import * as i0 from '@angular/core';
import { inject, ElementRef, Directive, input, Renderer2, effect, TemplateRef, booleanAttribute, untracked, NgModule, computed, Injectable, Component, linkedSignal, output, signal, afterNextRender, contentChildren, DestroyRef, RendererFactory2, numberAttribute, Pipe, HostBinding, Input, ViewChildren, model, PLATFORM_ID, Inject, forwardRef, ContentChildren, ContentChild, contentChild, ViewChild, ChangeDetectorRef, viewChild, ChangeDetectionStrategy, NgZone, EventEmitter, HostListener, Output, afterRender, ViewContainerRef, viewChildren, Injector, runInInjectionContext } from '@angular/core';
import { NgTemplateOutlet, DOCUMENT, NgClass, AsyncPipe, NgStyle, isPlatformServer, isPlatformBrowser, formatDate, I18nPluralPipe } from '@angular/common';
import { animation, animate, style, AnimationBuilder, useAnimation, trigger, state, transition, group, query, animateChild } from '@angular/animations';
import { takeUntilDestroyed, toObservable, toSignal } from '@angular/core/rxjs-interop';
import { fromEvent, Subject, BehaviorSubject, Observable, skip, merge, takeWhile, distinctUntilChanged as distinctUntilChanged$1, map as map$1, debounceTime as debounceTime$1 } from 'rxjs';
import * as i1 from '@angular/router';
import { RouterModule, Router, ActivatedRoute, NavigationEnd, RouterLink } from '@angular/router';
import { filter, tap, distinctUntilChanged, take, debounceTime, finalize, zipWith, withLatestFrom, map, delay, combineLatestWith } from 'rxjs/operators';
import * as i1$1 from '@angular/cdk/a11y';
import { FocusMonitor, A11yModule, FocusKeyManager } from '@angular/cdk/a11y';
import * as i1$2 from '@angular/forms';
import { FormGroup, FormControl, Validators, ReactiveFormsModule, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { BreakpointObserver } from '@angular/cdk/layout';
import { createPopper } from '@popperjs/core';
import { SelectionModel } from '@angular/cdk/collections';
import { IconDirective } from '@coreui/icons-angular';
const _c0 = ["*"];
const _c1 = () => ({
  display: "none"
});
const _c2 = ["*", "*"];
function AccordionItemComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function AccordionItemComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function AccordionItemComponent_ng_template_6_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function AccordionItemComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function AccordionItemComponent_ng_template_6_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleItem());
    });
    i0.ɵɵtemplate(1, AccordionItemComponent_ng_template_6_ng_container_1_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const defaultAccordionHeaderContentTemplate_r3 = i0.ɵɵreference(9);
    const tmpl_r4 = i0.ɵɵreadContextLet(0);
    i0.ɵɵproperty("collapsed", !ctx_r1.itemVisible());
    i0.ɵɵattribute("aria-controls", ctx_r1.contentId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", tmpl_r4["accordionHeader"] || defaultAccordionHeaderContentTemplate_r3)("ngTemplateOutletContext", ctx_r1.itemContext);
  }
}
function AccordionItemComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function AccordionItemComponent_ng_template_10_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function AccordionItemComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, AccordionItemComponent_ng_template_10_ng_container_1_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const defaultAccordionBodyContentTemplate_r5 = i0.ɵɵreference(13);
    const tmpl_r4 = i0.ɵɵreadContextLet(0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", tmpl_r4["accordionBody"] || defaultAccordionBodyContentTemplate_r5)("ngTemplateOutletContext", ctx_r1.itemContext);
  }
}
function AccordionItemComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
function AlertComponent_Conditional_0_Conditional_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function AlertComponent_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, AlertComponent_Conditional_0_Conditional_0_ng_container_0_Template, 1, 0, "ng-container", 1);
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r0 = i0.ɵɵnextContext(2);
    const defaultAlertButtonCloseTemplate_r2 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngTemplateOutlet", ((tmp_3_0 = ctx_r0.templates()) == null ? null : tmp_3_0["alertButtonCloseTemplate"]) || defaultAlertButtonCloseTemplate_r2);
  }
}
function AlertComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, AlertComponent_Conditional_0_Conditional_0_Template, 1, 1, "ng-container");
    i0.ɵɵprojection(1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.dismissible ? 0 : -1);
  }
}
function AlertComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2);
    i0.ɵɵlistener("click", function AlertComponent_ng_template_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.visible = false);
    });
    i0.ɵɵelementEnd();
  }
}
function AvatarComponent_ProjectionFallback_0_Conditional_0_Defer_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 1);
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("src", (tmp_3_0 = ctx_r0.src()) !== null && tmp_3_0 !== undefined ? tmp_3_0 : "", i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate("alt", ctx_r0.alt());
  }
}
function AvatarComponent_ProjectionFallback_0_Conditional_0_DeferPlaceholder_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 2);
    i0.ɵɵelement(1, "rect", 3);
    i0.ɵɵelementEnd();
  }
}
function AvatarComponent_ProjectionFallback_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, AvatarComponent_ProjectionFallback_0_Conditional_0_Defer_0_Template, 1, 2)(1, AvatarComponent_ProjectionFallback_0_Conditional_0_DeferPlaceholder_1_Template, 2, 0);
    i0.ɵɵdefer(2, 0, null, null, 1);
    i0.ɵɵdeferPrefetchOnIdle();
    i0.ɵɵdeferOnIdle();
  }
}
function AvatarComponent_ProjectionFallback_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, AvatarComponent_ProjectionFallback_0_Conditional_0_Template, 4, 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.src() ? 0 : -1);
  }
}
function AvatarComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.statusClass());
  }
}
const _c3 = () => ({});
function BreadcrumbItemComponent_Conditional_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function BreadcrumbItemComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 1);
    i0.ɵɵtemplate(1, BreadcrumbItemComponent_Conditional_0_ng_container_1_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_3_0;
    let tmp_4_0;
    let tmp_5_0;
    let tmp_6_0;
    let tmp_7_0;
    let tmp_8_0;
    let tmp_9_0;
    let tmp_10_0;
    let tmp_11_0;
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultBreadcrumbItemContentTemplate_r2 = i0.ɵɵreference(3);
    i0.ɵɵproperty("routerLink", ctx_r0.url())("cHtmlAttr", (tmp_3_0 = ctx_r0.attributes()) !== null && tmp_3_0 !== undefined ? tmp_3_0 : i0.ɵɵpureFunction0(11, _c3))("target", (tmp_4_0 = ctx_r0.attributes()) == null ? null : tmp_4_0["target"])("queryParams", (tmp_5_0 = (tmp_5_0 = ctx_r0.linkProps()) == null ? null : tmp_5_0.queryParams) !== null && tmp_5_0 !== undefined ? tmp_5_0 : null)("fragment", (tmp_6_0 = ctx_r0.linkProps()) == null ? null : tmp_6_0.fragment)("queryParamsHandling", (tmp_7_0 = (tmp_7_0 = ctx_r0.linkProps()) == null ? null : tmp_7_0.queryParamsHandling) !== null && tmp_7_0 !== undefined ? tmp_7_0 : null)("preserveFragment", (tmp_8_0 = (tmp_8_0 = ctx_r0.linkProps()) == null ? null : tmp_8_0.preserveFragment) !== null && tmp_8_0 !== undefined ? tmp_8_0 : false)("skipLocationChange", (tmp_9_0 = (tmp_9_0 = ctx_r0.linkProps()) == null ? null : tmp_9_0.skipLocationChange) !== null && tmp_9_0 !== undefined ? tmp_9_0 : false)("replaceUrl", (tmp_10_0 = (tmp_10_0 = ctx_r0.linkProps()) == null ? null : tmp_10_0.replaceUrl) !== null && tmp_10_0 !== undefined ? tmp_10_0 : false)("state", (tmp_11_0 = (tmp_11_0 = ctx_r0.linkProps()) == null ? null : tmp_11_0.state) !== null && tmp_11_0 !== undefined ? tmp_11_0 : i0.ɵɵpureFunction0(12, _c3));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", defaultBreadcrumbItemContentTemplate_r2);
  }
}
function BreadcrumbItemComponent_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function BreadcrumbItemComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵtemplate(1, BreadcrumbItemComponent_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultBreadcrumbItemContentTemplate_r2 = i0.ɵɵreference(3);
    i0.ɵɵproperty("cHtmlAttr", (tmp_2_0 = ctx_r0.attributes()) !== null && tmp_2_0 !== undefined ? tmp_2_0 : i0.ɵɵpureFunction0(2, _c3));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", defaultBreadcrumbItemContentTemplate_r2);
  }
}
function BreadcrumbItemComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function BreadcrumbRouterComponent_For_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "c-breadcrumb-item", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const breadcrumb_r2 = ctx_r0.$implicit;
    const ɵ$index_3_r3 = ctx_r0.$index;
    const ɵ$count_3_r4 = ctx_r0.$count;
    i0.ɵɵproperty("active", ɵ$index_3_r3 === ɵ$count_3_r4 - 1)("url", breadcrumb_r2 == null ? null : breadcrumb_r2.url)("attributes", breadcrumb_r2 == null ? null : breadcrumb_r2.attributes)("linkProps", breadcrumb_r2 == null ? null : breadcrumb_r2.linkProps);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", breadcrumb_r2 == null ? null : breadcrumb_r2.label, " ");
  }
}
function BreadcrumbRouterComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, BreadcrumbRouterComponent_For_2_Conditional_0_Template, 2, 5, "c-breadcrumb-item", 1);
  }
  if (rf & 2) {
    const breadcrumb_r2 = ctx.$implicit;
    const ɵ$index_3_r3 = ctx.$index;
    const ɵ$count_3_r4 = ctx.$count;
    i0.ɵɵconditional((breadcrumb_r2 == null ? null : breadcrumb_r2.label) && ((breadcrumb_r2 == null ? null : breadcrumb_r2.url == null ? null : breadcrumb_r2.url.slice(-1)) === "/" || ɵ$index_3_r3 === ɵ$count_3_r4 - 1) ? 0 : -1);
  }
}
const _c4 = () => ({
  display: "flex",
  justifyContent: "center"
});
const _c5 = () => ({
  order: "-1"
});
const _c6 = () => ({
  year: "numeric"
});
const _c7 = () => ({
  month: "long"
});
function CalendarNavigationComponent_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function CalendarNavigationComponent_Conditional_0_Conditional_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.handleNavigationClick("prev"));
    })("keyup", function CalendarNavigationComponent_Conditional_0_Conditional_3_Template_button_keyup_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.handleNavigationKeyUp($event, "prev"));
    });
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r1.disablePrevMonth());
    i0.ɵɵattribute("aria-label", ctx_r1.ariaPrevMonthLabel());
  }
}
function CalendarNavigationComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0)(1, "button", 5);
    i0.ɵɵlistener("click", function CalendarNavigationComponent_Conditional_0_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleNavigationClick("prev", true));
    })("keyup", function CalendarNavigationComponent_Conditional_0_Template_button_keyup_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleNavigationKeyUp($event, "prev", true));
    });
    i0.ɵɵelement(2, "span", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, CalendarNavigationComponent_Conditional_0_Conditional_3_Template, 2, 2, "button", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.disablePrevYear());
    i0.ɵɵattribute("aria-label", ctx_r1.ariaPrevYearLabel());
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.view() === "days" ? 3 : -1);
  }
}
function CalendarNavigationComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function CalendarNavigationComponent_Conditional_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setView("months"));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.date().toLocaleDateString(ctx_r1.locale(), i0.ɵɵpureFunction0(1, _c7)), " ");
  }
}
function CalendarNavigationComponent_Conditional_5_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function CalendarNavigationComponent_Conditional_5_Conditional_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.handleNavigationClick("next"));
    })("keyup", function CalendarNavigationComponent_Conditional_5_Conditional_1_Template_button_keyup_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.handleNavigationKeyUp($event, "next"));
    });
    i0.ɵɵelement(1, "span", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r1.disableNextMonth());
    i0.ɵɵattribute("aria-label", ctx_r1.ariaNextMonthLabel());
  }
}
function CalendarNavigationComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, CalendarNavigationComponent_Conditional_5_Conditional_1_Template, 2, 2, "button", 7);
    i0.ɵɵelementStart(2, "button", 5);
    i0.ɵɵlistener("click", function CalendarNavigationComponent_Conditional_5_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleNavigationClick("next", true));
    })("keyup", function CalendarNavigationComponent_Conditional_5_Template_button_keyup_2_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleNavigationKeyUp($event, "next", true));
    });
    i0.ɵɵelement(3, "span", 10);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.view() === "days" ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.disableNextYear());
    i0.ɵɵattribute("aria-label", ctx_r1.ariaNextYearLabel());
  }
}
const _c8 = (a0, a1, a2, a3) => ({
  minDate: a0,
  maxDate: a1,
  disabledDates: a2,
  dateFilter: a3
});
const _forTrack0 = ($index, $item) => $item.date;
const _forTrack1 = ($index, $item) => $item[0];
const _forTrack2 = ($index, $item) => $item.days[0];
function CalendarMonthComponent_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 5)(1, "div", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.weekNumbersLabel());
  }
}
function CalendarMonthComponent_Conditional_1_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdeclareLet(0);
    i0.ɵɵelementStart(1, "th", 6);
    i0.ɵɵpipe(2, "calendarWeekday");
    i0.ɵɵelementStart(3, "div", 7);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "calendarWeekday");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const weekDay_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    const date_r3 = weekDay_r2.date;
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("abbr", i0.ɵɵpipeBind3(2, 2, date_r3, "long", ctx_r0.locale()));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(5, 6, date_r3, ctx_r0.weekdayFormat(), ctx_r0.locale()), " ");
  }
}
function CalendarMonthComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "thead")(1, "tr");
    i0.ɵɵtemplate(2, CalendarMonthComponent_Conditional_1_Conditional_2_Template, 3, 1, "th", 5);
    i0.ɵɵrepeaterCreate(3, CalendarMonthComponent_Conditional_1_For_4_Template, 6, 10, "th", 6, _forTrack0);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.showWeekNumber() ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r0.weekDays());
  }
}
function CalendarMonthComponent_Case_3_For_1_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 9, 0);
    i0.ɵɵpipe(2, "calendarClassYear");
    i0.ɵɵlistener("click", function CalendarMonthComponent_Case_3_For_1_For_2_Template_td_click_0_listener() {
      const year_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const calendarYear_r6 = i0.ɵɵreference(1);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(!calendarYear_r6.disabled$() && ctx_r0.handleYearCellClick(year_r5));
    })("keydown", function CalendarMonthComponent_Case_3_For_1_For_2_Template_td_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const calendarYear_r6 = i0.ɵɵreference(1);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(calendarYear_r6.date() && ctx_r0.handleDayCellKeyDown($event, calendarYear_r6.date()));
    })("keyup", function CalendarMonthComponent_Case_3_For_1_For_2_Template_td_keyup_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const calendarYear_r6 = i0.ɵɵreference(1);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.handleYearCellKeyUp($event, calendarYear_r6.date()));
    })("mouseenter", function CalendarMonthComponent_Case_3_For_1_For_2_Template_td_mouseenter_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const calendarYear_r6 = i0.ɵɵreference(1);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(calendarYear_r6.date() && ctx_r0.handleCellMouseEnter(calendarYear_r6.date()));
    });
    i0.ɵɵelementStart(3, "div", 10);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_27_0;
    const year_r5 = ctx.$implicit;
    const calendarYear_r6 = i0.ɵɵreference(1);
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("date", ctx_r0.getYearStart(year_r5))("ngClass", i0.ɵɵpipeBind1(2, 5, year_r5))("tabindex", calendarYear_r6.disabled$() ? -1 : 0);
    i0.ɵɵattribute("aria-label", (tmp_27_0 = calendarYear_r6.date()) == null ? null : tmp_27_0.getFullYear());
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.yearNumber(year_r5), " ");
  }
}
function CalendarMonthComponent_Case_3_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵrepeaterCreate(1, CalendarMonthComponent_Case_3_For_1_For_2_Template, 5, 7, "td", 8, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const yearsRow_r7 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵrepeater(yearsRow_r7);
  }
}
function CalendarMonthComponent_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, CalendarMonthComponent_Case_3_For_1_Template, 3, 0, "tr", null, _forTrack1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r0.listOfYears());
  }
}
function CalendarMonthComponent_Case_4_For_1_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵdeclareLet(0);
    i0.ɵɵelementStart(1, "td", 9, 1);
    i0.ɵɵpipe(3, "calendarClassMonth");
    i0.ɵɵlistener("click", function CalendarMonthComponent_Case_4_For_1_For_2_Template_td_click_1_listener() {
      i0.ɵɵrestoreView(_r8);
      const calendarMonth_r9 = i0.ɵɵreference(2);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(!calendarMonth_r9.disabled$() && ctx_r0.handleMonthCellClick(calendarMonth_r9.date()));
    })("keydown", function CalendarMonthComponent_Case_4_For_1_For_2_Template_td_keydown_1_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const calendarMonth_r9 = i0.ɵɵreference(2);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(calendarMonth_r9.date() && ctx_r0.handleDayCellKeyDown($event, calendarMonth_r9.date()));
    })("keyup", function CalendarMonthComponent_Case_4_For_1_For_2_Template_td_keyup_1_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const calendarMonth_r9 = i0.ɵɵreference(2);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.handleMonthCellKeyUp($event, calendarMonth_r9.date()));
    })("mouseenter", function CalendarMonthComponent_Case_4_For_1_For_2_Template_td_mouseenter_1_listener() {
      i0.ɵɵrestoreView(_r8);
      const calendarMonth_r9 = i0.ɵɵreference(2);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(calendarMonth_r9.date() && ctx_r0.handleCellMouseEnter(calendarMonth_r9.date()));
    });
    i0.ɵɵelementStart(4, "div", 10);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_28_0;
    const month_r10 = ctx.$implicit;
    const ɵ$index_40_r11 = ctx.$index;
    const calendarMonth_r9 = i0.ɵɵreference(2);
    const ɵ$index_37_r12 = i0.ɵɵnextContext().$index;
    const monthStart_r13 = i0.ɵɵnextContext(2).getMonthStart(ɵ$index_37_r12 * 3 + ɵ$index_40_r11);
    i0.ɵɵadvance();
    i0.ɵɵproperty("date", monthStart_r13)("ngClass", i0.ɵɵpipeBind2(3, 5, monthStart_r13, ɵ$index_37_r12 * 3 + ɵ$index_40_r11))("tabindex", calendarMonth_r9.disabled$() ? -1 : 0);
    i0.ɵɵattribute("aria-label", ((tmp_28_0 = calendarMonth_r9.date()) == null ? null : tmp_28_0.getFullYear()) + " " + month_r10.month);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", month_r10.month, " ");
  }
}
function CalendarMonthComponent_Case_4_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵrepeaterCreate(1, CalendarMonthComponent_Case_4_For_1_For_2_Template, 6, 8, "td", 8, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const monthsRow_r14 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵrepeater(monthsRow_r14);
  }
}
function CalendarMonthComponent_Case_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, CalendarMonthComponent_Case_4_For_1_Template, 3, 0, "tr", null, _forTrack1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r0.listOfMonths());
  }
}
function CalendarMonthComponent_Case_5_For_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const week_r18 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", week_r18.weekNumber === 0 ? 53 : week_r18.weekNumber, " ");
  }
}
function CalendarMonthComponent_Case_5_For_3_For_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵdeclareLet(0);
    i0.ɵɵelementStart(1, "td", 15, 3);
    i0.ɵɵpipe(3, "calendarClassDay");
    i0.ɵɵpipe(4, "calendarDayTitle");
    i0.ɵɵlistener("click", function CalendarMonthComponent_Case_5_For_3_For_4_Conditional_1_Template_td_click_1_listener() {
      i0.ɵɵrestoreView(_r19);
      const selectable_r20 = i0.ɵɵreadContextLet(0);
      const dateObj_r21 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(selectable_r20 && ctx_r0.handleDayCellClick(dateObj_r21.date));
    })("keydown", function CalendarMonthComponent_Case_5_For_3_For_4_Conditional_1_Template_td_keydown_1_listener($event) {
      i0.ɵɵrestoreView(_r19);
      const selectable_r20 = i0.ɵɵreadContextLet(0);
      const dateObj_r21 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(selectable_r20 && ctx_r0.handleDayCellKeyDown($event, dateObj_r21.date));
    })("keyup", function CalendarMonthComponent_Case_5_For_3_For_4_Conditional_1_Template_td_keyup_1_listener($event) {
      i0.ɵɵrestoreView(_r19);
      const selectable_r20 = i0.ɵɵreadContextLet(0);
      const dateObj_r21 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(selectable_r20 && ctx_r0.handleDayCellKeyUp($event, dateObj_r21.date));
    })("mouseenter", function CalendarMonthComponent_Case_5_For_3_For_4_Conditional_1_Template_td_mouseenter_1_listener() {
      i0.ɵɵrestoreView(_r19);
      const selectable_r20 = i0.ɵɵreadContextLet(0);
      const dateObj_r21 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(selectable_r20 && ctx_r0.handleCellMouseEnter(dateObj_r21.date));
    });
    i0.ɵɵelementStart(5, "div", 10);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "calendarDay");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const dateObj_r21 = i0.ɵɵnextContext().$implicit;
    const currentMonth_r22 = i0.ɵɵreadContextLet(0);
    i0.ɵɵnextContext(2);
    const daySelection_r23 = i0.ɵɵreadContextLet(1);
    const ctx_r0 = i0.ɵɵnextContext();
    const selectable_r24 = i0.ɵɵstoreLet(daySelection_r23 && (currentMonth_r22 || ctx_r0.selectAdjacentDays()));
    i0.ɵɵadvance();
    i0.ɵɵproperty("date", dateObj_r21.date)("month", dateObj_r21.month)("ngClass", i0.ɵɵpipeBind2(3, 7, dateObj_r21, i0.ɵɵpureFunction4(17, _c8, ctx_r0.minDate(), ctx_r0.maxDate(), ctx_r0.disabledDates(), ctx_r0.dateFilter())))("tabindex", selectable_r24 && !ctx_r0.isDateDisabled(dateObj_r21.date) ? 0 : -1);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(4, 10, dateObj_r21.date, ctx_r0.locale()));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(7, 13, dateObj_r21.date, ctx_r0.dayFormat(), ctx_r0.locale()), " ");
  }
}
function CalendarMonthComponent_Case_5_For_3_For_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "td", 5);
  }
}
function CalendarMonthComponent_Case_5_For_3_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdeclareLet(0);
    i0.ɵɵtemplate(1, CalendarMonthComponent_Case_5_For_3_For_4_Conditional_1_Template, 8, 22, "td", 14)(2, CalendarMonthComponent_Case_5_For_3_For_4_Conditional_2_Template, 1, 0, "td", 5);
  }
  if (rf & 2) {
    const dateObj_r21 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    const currentMonth_r25 = i0.ɵɵstoreLet(dateObj_r21.month === "current");
    i0.ɵɵadvance();
    i0.ɵɵconditional(currentMonth_r25 || ctx_r0.showAdjacentDays() ? 1 : 2);
  }
}
function CalendarMonthComponent_Case_5_For_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 12, 2);
    i0.ɵɵlistener("click", function CalendarMonthComponent_Case_5_For_3_Template_tr_click_0_listener() {
      i0.ɵɵrestoreView(_r15);
      const calendarRow_r16 = i0.ɵɵreference(1);
      i0.ɵɵnextContext();
      const weekSelection_r17 = i0.ɵɵreadContextLet(0);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(weekSelection_r17 && calendarRow_r16.current && calendarRow_r16.date && ctx_r0.handleDayCellClick(calendarRow_r16.date));
    })("keydown", function CalendarMonthComponent_Case_5_For_3_Template_tr_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r15);
      const calendarRow_r16 = i0.ɵɵreference(1);
      i0.ɵɵnextContext();
      const weekSelection_r17 = i0.ɵɵreadContextLet(0);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(weekSelection_r17 && calendarRow_r16.current && calendarRow_r16.date && ctx_r0.handleDayCellKeyDown($event, calendarRow_r16.date));
    })("keyup", function CalendarMonthComponent_Case_5_For_3_Template_tr_keyup_0_listener($event) {
      i0.ɵɵrestoreView(_r15);
      const calendarRow_r16 = i0.ɵɵreference(1);
      i0.ɵɵnextContext();
      const weekSelection_r17 = i0.ɵɵreadContextLet(0);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(weekSelection_r17 && calendarRow_r16.current && calendarRow_r16.date && ctx_r0.handleDayCellKeyUp($event, calendarRow_r16.date));
    })("mouseenter", function CalendarMonthComponent_Case_5_For_3_Template_tr_mouseenter_0_listener() {
      i0.ɵɵrestoreView(_r15);
      const calendarRow_r16 = i0.ɵɵreference(1);
      i0.ɵɵnextContext();
      const weekSelection_r17 = i0.ɵɵreadContextLet(0);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(weekSelection_r17 && calendarRow_r16.date && ctx_r0.handleCellMouseEnter(calendarRow_r16.date));
    });
    i0.ɵɵtemplate(2, CalendarMonthComponent_Case_5_For_3_Conditional_2_Template, 2, 1, "th", 13);
    i0.ɵɵrepeaterCreate(3, CalendarMonthComponent_Case_5_For_3_For_4_Template, 3, 2, null, null, _forTrack0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const week_r18 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("cCalendarRow", week_r18);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.showWeekNumber() ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(week_r18.days);
  }
}
function CalendarMonthComponent_Case_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdeclareLet(0)(1);
    i0.ɵɵrepeaterCreate(2, CalendarMonthComponent_Case_5_For_3_Template, 5, 2, "tr", 11, _forTrack2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstoreLet(ctx_r0.selectionType() === "week");
    i0.ɵɵadvance();
    i0.ɵɵstoreLet(ctx_r0.selectionType() === "day");
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r0.monthDetails());
  }
}
function CalendarComponent_For_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵpipe(1, "calendarClassView");
    i0.ɵɵelementStart(2, "c-calendar-navigation", 1);
    i0.ɵɵlistener("navigationClick", function CalendarComponent_For_1_Template_c_calendar_navigation_navigationClick_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleNavigationClick($event.direction, $event.years));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "c-calendar-month", 2);
    i0.ɵɵlistener("cdkFocusChange", function CalendarComponent_For_1_Template_c_calendar_month_cdkFocusChange_3_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleFocusChange($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ɵ$index_1_r3 = ctx.$index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBind1(1, 8, ctx_r1.view()));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("pageIndex", ɵ$index_1_r3)("navigation", ctx_r1.navigation())("ariaNextMonthLabel", ctx_r1.ariaNextMonthLabel())("ariaNextYearLabel", ctx_r1.ariaNextYearLabel())("ariaPrevMonthLabel", ctx_r1.ariaPrevMonthLabel())("ariaPrevYearLabel", ctx_r1.ariaPrevYearLabel());
    i0.ɵɵadvance();
    i0.ɵɵproperty("pageIndex", ɵ$index_1_r3);
  }
}
function CarouselControlComponent_ProjectionFallback_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span");
    i0.ɵɵelementStart(1, "span", 0);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.carouselControlIconClass());
    i0.ɵɵattribute("aria-hidden", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.caption());
  }
}
const _c9 = (a0, a1) => ({
  $implicit: a0,
  active: a1
});
const _c10 = a0 => ({
  active: a0
});
function CarouselIndicatorsComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CarouselIndicatorsComponent_ng_template_2_For_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 3);
    i0.ɵɵlistener("click", function CarouselIndicatorsComponent_ng_template_2_For_1_Template_button_click_0_listener() {
      const ɵ$index_8_r2 = i0.ɵɵrestoreView(_r1).$index;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onClick(ɵ$index_8_r2));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ɵ$index_8_r2 = ctx.$index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(i0.ɵɵpureFunction1(4, _c10, ctx_r2.active === ɵ$index_8_r2));
    i0.ɵɵattribute("data-coreui-target", ɵ$index_8_r2)("aria-current", ctx_r2.active === ɵ$index_8_r2);
  }
}
function CarouselIndicatorsComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, CarouselIndicatorsComponent_ng_template_2_For_1_Template, 1, 6, "button", 2, i0.ɵɵrepeaterTrackByIdentity);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r2.items);
  }
}
function CarouselItemComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
const _c11 = () => ({
  "--cui-timepicker-roll-cell-width": "80px"
});
const _c12 = (a0, a1) => ({
  "time-picker-roll-cell": true,
  selected: a0,
  disabled: a1
});
const _forTrack3 = ($index, $item) => $item.value;
function TimePickerRollColComponent_For_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵdeclareLet(0);
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵlistener("click", function TimePickerRollColComponent_For_1_Template_div_click_1_listener($event) {
      const element_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleElementClick($event, element_r2));
    })("keydown", function TimePickerRollColComponent_For_1_Template_div_keydown_1_listener($event) {
      const element_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleElementKeyDown($event, element_r2));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const element_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    const cellWidth_r4 = element_r2.label.length > 2 ? i0.ɵɵpureFunction0(6, _c11) : i0.ɵɵpureFunction0(7, _c3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cTimeElement", element_r2)("ngClass", i0.ɵɵpureFunction2(8, _c12, element_r2.value === ctx_r2.selected(), element_r2.disabled))("tabindex", element_r2.disabled ? -1 : 0)("ngStyle", cellWidth_r4);
    i0.ɵɵattribute("disabled", element_r2.disabled || null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", element_r2.label, " ");
  }
}
function TimePickerRollAmPmComponent_For_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵlistener("click", function TimePickerRollAmPmComponent_For_1_Template_div_click_0_listener($event) {
      const element_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleElementClick($event, element_r2));
    })("keydown", function TimePickerRollAmPmComponent_For_1_Template_div_keydown_0_listener($event) {
      const element_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleElementKeyDown($event, element_r2));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const element_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("cDayPeriodElement", element_r2)("ngClass", i0.ɵɵpureFunction2(5, _c12, element_r2.value === ctx_r2.selected(), element_r2.disabled))("tabindex", element_r2.disabled ? -1 : 0);
    i0.ɵɵattribute("disabled", element_r2.disabled || null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", element_r2.label, " ");
  }
}
const _c13 = a0 => ({
  $implicit: a0
});
function TimePickerComponent_Conditional_0_For_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const hour_r3 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", hour_r3.value);
    i0.ɵɵattribute("disabled", hour_r3.disabled || null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", hour_r3.label, " ");
  }
}
function TimePickerComponent_Conditional_0_For_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const minute_r4 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", minute_r4.value);
    i0.ɵɵattribute("disabled", minute_r4.disabled || null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", minute_r4.label, " ");
  }
}
function TimePickerComponent_Conditional_0_Conditional_11_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const second_r6 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", second_r6.value);
    i0.ɵɵattribute("disabled", second_r6.disabled || null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", second_r6.label, " ");
  }
}
function TimePickerComponent_Conditional_0_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵtext(0);
    i0.ɵɵelementStart(1, "select", 11);
    i0.ɵɵlistener("blur", function TimePickerComponent_Conditional_0_Conditional_11_Template_select_blur_1_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onBlur());
    });
    i0.ɵɵrepeaterCreate(2, TimePickerComponent_Conditional_0_Conditional_11_For_3_Template, 2, 3, "option", 8, _forTrack3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", " :", "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("sizing", (tmp_3_0 = ctx_r1.size()) !== null && tmp_3_0 !== undefined ? tmp_3_0 : "");
    i0.ɵɵattribute("disabled", ctx_r1.disabled() || null);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.listOfSeconds);
  }
}
function TimePickerComponent_Conditional_0_Conditional_12_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dayPeriod_r8 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", dayPeriod_r8.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", dayPeriod_r8.label, " ");
  }
}
function TimePickerComponent_Conditional_0_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 12);
    i0.ɵɵlistener("blur", function TimePickerComponent_Conditional_0_Conditional_12_Template_select_blur_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onBlur());
    });
    i0.ɵɵrepeaterCreate(1, TimePickerComponent_Conditional_0_Conditional_12_For_2_Template, 2, 2, "option", 13, _forTrack3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("sizing", (tmp_2_0 = ctx_r1.size()) !== null && tmp_2_0 !== undefined ? tmp_2_0 : "");
    i0.ɵɵattribute("disabled", ctx_r1.disabled() || null);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.dayPeriods);
  }
}
function TimePickerComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 4)(2, "div", 5);
    i0.ɵɵelement(3, "span", 6);
    i0.ɵɵelementStart(4, "select", 7);
    i0.ɵɵlistener("blur", function TimePickerComponent_Conditional_0_Template_select_blur_4_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onBlur());
    });
    i0.ɵɵrepeaterCreate(5, TimePickerComponent_Conditional_0_For_6_Template, 2, 3, "option", 8, _forTrack3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(7);
    i0.ɵɵelementStart(8, "select", 9);
    i0.ɵɵlistener("blur", function TimePickerComponent_Conditional_0_Template_select_blur_8_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onBlur());
    });
    i0.ɵɵrepeaterCreate(9, TimePickerComponent_Conditional_0_For_10_Template, 2, 3, "option", 8, _forTrack3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, TimePickerComponent_Conditional_0_Conditional_11_Template, 4, 3)(12, TimePickerComponent_Conditional_0_Conditional_12_Template, 3, 2, "select", 10);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    let tmp_3_0;
    let tmp_7_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formGroup", ctx_r1.selectTime)("ngClass", ctx_r1.timePickerClasses());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("sizing", (tmp_3_0 = ctx_r1.size()) !== null && tmp_3_0 !== undefined ? tmp_3_0 : "");
    i0.ɵɵattribute("disabled", ctx_r1.disabled() || null);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.listOfHours12);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", " :", "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("sizing", (tmp_7_0 = ctx_r1.size()) !== null && tmp_7_0 !== undefined ? tmp_7_0 : "");
    i0.ɵɵattribute("disabled", ctx_r1.disabled() || null);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.listOfMinutes);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.seconds() ? 11 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.hour12 ? 12 : -1);
  }
}
function TimePickerComponent_Conditional_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 16);
  }
}
function TimePickerComponent_Conditional_1_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵlistener("click", function TimePickerComponent_Conditional_1_Conditional_5_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(!ctx_r1.disabled() && ctx_r1.handleClear($event));
    });
    i0.ɵɵelementEnd();
  }
}
function TimePickerComponent_Conditional_1_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "c-time-picker-roll-col", 20);
    i0.ɵɵlistener("selectedChange", function TimePickerComponent_Conditional_1_Conditional_11_Template_c_time_picker_roll_col_selectedChange_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.handleSelectTimeChange($event, "second"));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const dropdownMenu_r12 = i0.ɵɵreference(7);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r1.disabled())("elements", ctx_r1.listOfSeconds)("refresh", dropdownMenu_r12.visible())("selected", ctx_r1.second);
  }
}
function TimePickerComponent_Conditional_1_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "c-time-picker-roll-am-pm", 20);
    i0.ɵɵlistener("selectedChange", function TimePickerComponent_Conditional_1_Conditional_12_Template_c_time_picker_roll_am_pm_selectedChange_0_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.handleSelectDayPeriodChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const dropdownMenu_r12 = i0.ɵɵreference(7);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r1.disabled())("elements", ctx_r1.dayPeriods)("refresh", dropdownMenu_r12.visible())("selected", ctx_r1.dayPeriod);
  }
}
function TimePickerComponent_Conditional_1_Conditional_13_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TimePickerComponent_Conditional_1_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtemplate(1, TimePickerComponent_Conditional_1_Conditional_13_ng_container_1_Template, 1, 0, "ng-container", 24);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const dropdown_r14 = i0.ɵɵreference(1);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.templates == null ? null : ctx_r1.templates.timePickerFooter)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c13, dropdown_r14));
  }
}
function TimePickerComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "c-dropdown", 3, 0)(2, "div", 14)(3, "input", 15);
    i0.ɵɵlistener("blur", function TimePickerComponent_Conditional_1_Template_input_blur_3_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleBlur($event));
    })("change", function TimePickerComponent_Conditional_1_Template_input_change_3_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleTimeInputChange($event));
    })("focus", function TimePickerComponent_Conditional_1_Template_input_focus_3_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleFocus($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, TimePickerComponent_Conditional_1_Conditional_4_Template, 1, 0, "div", 16)(5, TimePickerComponent_Conditional_1_Conditional_5_Template, 1, 0, "div", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 18, 1)(8, "div", 19)(9, "c-time-picker-roll-col", 20);
    i0.ɵɵlistener("selectedChange", function TimePickerComponent_Conditional_1_Template_c_time_picker_roll_col_selectedChange_9_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleSelectTimeChange($event, "hour"));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "c-time-picker-roll-col", 20);
    i0.ɵɵlistener("selectedChange", function TimePickerComponent_Conditional_1_Template_c_time_picker_roll_col_selectedChange_10_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleSelectTimeChange($event, "minute"));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, TimePickerComponent_Conditional_1_Conditional_11_Template, 1, 4, "c-time-picker-roll-col", 21)(12, TimePickerComponent_Conditional_1_Conditional_12_Template, 1, 4, "c-time-picker-roll-am-pm", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, TimePickerComponent_Conditional_1_Conditional_13_Template, 2, 4, "div", 22);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_9_0;
    const dropdownMenu_r12 = i0.ɵɵreference(7);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("autoClose", "outside")("ngClass", ctx_r1.timePickerClasses())("visible", ctx_r1.visible());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("caret", false);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControl", ctx_r1.timeInputCtrl)("placeholder", ctx_r1.placeholder())("readonly", (tmp_9_0 = ctx_r1.inputReadOnly()) !== null && tmp_9_0 !== undefined ? tmp_9_0 : null);
    i0.ɵɵattribute("pattern", ctx_r1.hour12 ? "(((0[1-9])|(1[0-2])):([0-5])([0-9])\\s(A|P)M)" : "([01]?[0-9]|2[0-3]):[0-5][0-9]")("tabindex", ctx_r1.disabled() ? -1 : 0);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.indicator() ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.cleaner() && ctx_r1.time && !ctx_r1.disabled() ? 5 : -1);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", ctx_r1.disabled())("elements", ctx_r1.listOfHours12)("refresh", dropdownMenu_r12.visible())("selected", ctx_r1.hour);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.disabled())("elements", ctx_r1.listOfMinutes)("refresh", dropdownMenu_r12.visible())("selected", ctx_r1.minute);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.seconds() ? 11 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.hour12 ? 12 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r1.templates == null ? null : ctx_r1.templates.timePickerFooter) ? 13 : -1);
  }
}
const _c14 = ["startDateElementRef"];
const _c15 = ["endDateElementRef"];
const _c16 = a0 => ({
  hover: a0
});
function DateRangePickerComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 7);
  }
}
function DateRangePickerComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 16, 2);
    i0.ɵɵlistener("change", function DateRangePickerComponent_Conditional_7_Template_input_change_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleEndDateInputChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_7_0;
    let tmp_8_0;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c16, !!ctx_r2.inputEndHoverValue()))("placeholder", ctx_r2.endDatePlaceholder)("readonly", (tmp_7_0 = ctx_r2.inputReadOnly()) !== null && tmp_7_0 !== undefined ? tmp_7_0 : null)("valid", (tmp_8_0 = ctx_r2.valid()) !== null && tmp_8_0 !== undefined ? tmp_8_0 : undefined);
    i0.ɵɵattribute("tabindex", ctx_r2.disabled() ? -1 : 0);
  }
}
function DateRangePickerComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
  }
}
function DateRangePickerComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵlistener("click", function DateRangePickerComponent_Conditional_9_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(!ctx_r2.disabled() && ctx_r2.handleClear($event));
    });
    i0.ɵɵelementEnd();
  }
}
function DateRangePickerComponent_Conditional_12_Conditional_0_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 20);
    i0.ɵɵlistener("click", function DateRangePickerComponent_Conditional_12_Conditional_0_For_2_Template_button_click_0_listener() {
      const customRange_r6 = i0.ɵɵrestoreView(_r5).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.setCustomRange(customRange_r6));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "customRangeKey");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const customRange_r6 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("color", ctx_r2.rangesButtonsColor())("size", ctx_r2.rangesButtonsSize())("variant", ctx_r2.rangesButtonsVariant());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 4, customRange_r6), " ");
  }
}
function DateRangePickerComponent_Conditional_12_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵrepeaterCreate(1, DateRangePickerComponent_Conditional_12_Conditional_0_For_2_Template, 3, 6, "button", 19, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r2.customRanges);
  }
}
function DateRangePickerComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DateRangePickerComponent_Conditional_12_Conditional_0_Template, 3, 0, "div", 18);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r2.ranges() && ctx_r2.customRanges.length > 0 ? 0 : -1);
  }
}
function DateRangePickerComponent_Conditional_14_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "c-time-picker", 21);
    i0.ɵɵlistener("timeChange", function DateRangePickerComponent_Conditional_14_Conditional_2_Template_c_time_picker_timeChange_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.handleEndTimeChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_7_0;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("locale", ctx_r2.locale())("disabled", !ctx_r2.endDate())("time", (tmp_7_0 = ctx_r2.endDate()) !== null && tmp_7_0 !== undefined ? tmp_7_0 : undefined);
  }
}
function DateRangePickerComponent_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14)(1, "c-time-picker", 21);
    i0.ɵɵlistener("timeChange", function DateRangePickerComponent_Conditional_14_Template_c_time_picker_timeChange_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleStartTimeChange($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, DateRangePickerComponent_Conditional_14_Conditional_2_Template, 1, 3, "c-time-picker", 22);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_6_0;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("locale", ctx_r2.locale())("disabled", !ctx_r2.startDate())("time", (tmp_6_0 = ctx_r2.startDate()) !== null && tmp_6_0 !== undefined ? tmp_6_0 : undefined);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.range() ? 2 : -1);
  }
}
function DateRangePickerComponent_Conditional_16_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DateRangePickerComponent_Conditional_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, DateRangePickerComponent_Conditional_16_ng_container_1_Template, 1, 0, "ng-container", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const dropdown_r9 = i0.ɵɵreference(2);
    const footer_r10 = i0.ɵɵreadContextLet(15);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", footer_r10)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c13, dropdown_r9));
  }
}
function DatePickerComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 7);
  }
}
function DatePickerComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 16, 2);
    i0.ɵɵlistener("change", function DatePickerComponent_Conditional_7_Template_input_change_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleEndDateInputChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_7_0;
    let tmp_8_0;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c16, !!ctx_r2.inputEndHoverValue()))("placeholder", ctx_r2.endDatePlaceholder)("readonly", (tmp_7_0 = ctx_r2.inputReadOnly()) !== null && tmp_7_0 !== undefined ? tmp_7_0 : null)("valid", (tmp_8_0 = ctx_r2.valid()) !== null && tmp_8_0 !== undefined ? tmp_8_0 : undefined);
    i0.ɵɵattribute("tabindex", ctx_r2.disabled() ? -1 : 0);
  }
}
function DatePickerComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
  }
}
function DatePickerComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵlistener("click", function DatePickerComponent_Conditional_9_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(!ctx_r2.disabled() && ctx_r2.handleClear($event));
    });
    i0.ɵɵelementEnd();
  }
}
function DatePickerComponent_Conditional_12_Conditional_0_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 20);
    i0.ɵɵlistener("click", function DatePickerComponent_Conditional_12_Conditional_0_For_2_Template_button_click_0_listener() {
      const customRange_r6 = i0.ɵɵrestoreView(_r5).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.setCustomRange(customRange_r6));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "customRangeKey");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const customRange_r6 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("color", ctx_r2.rangesButtonsColor())("size", ctx_r2.rangesButtonsSize())("variant", ctx_r2.rangesButtonsVariant());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 4, customRange_r6), " ");
  }
}
function DatePickerComponent_Conditional_12_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵrepeaterCreate(1, DatePickerComponent_Conditional_12_Conditional_0_For_2_Template, 3, 6, "button", 19, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r2.customRanges);
  }
}
function DatePickerComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DatePickerComponent_Conditional_12_Conditional_0_Template, 3, 0, "div", 18);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r2.ranges() && ctx_r2.customRanges.length > 0 ? 0 : -1);
  }
}
function DatePickerComponent_Conditional_14_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "c-time-picker", 21);
    i0.ɵɵlistener("timeChange", function DatePickerComponent_Conditional_14_Conditional_2_Template_c_time_picker_timeChange_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.handleEndTimeChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_7_0;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("locale", ctx_r2.locale())("disabled", !ctx_r2.endDate())("time", (tmp_7_0 = ctx_r2.endDate()) !== null && tmp_7_0 !== undefined ? tmp_7_0 : undefined);
  }
}
function DatePickerComponent_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14)(1, "c-time-picker", 21);
    i0.ɵɵlistener("timeChange", function DatePickerComponent_Conditional_14_Template_c_time_picker_timeChange_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleStartTimeChange($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, DatePickerComponent_Conditional_14_Conditional_2_Template, 1, 3, "c-time-picker", 22);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_6_0;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("locale", ctx_r2.locale())("disabled", !ctx_r2.startDate())("time", (tmp_6_0 = ctx_r2.startDate()) !== null && tmp_6_0 !== undefined ? tmp_6_0 : undefined);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.range() ? 2 : -1);
  }
}
function DatePickerComponent_Conditional_16_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DatePickerComponent_Conditional_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, DatePickerComponent_Conditional_16_ng_container_1_Template, 1, 0, "ng-container", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const dropdown_r9 = i0.ɵɵreference(2);
    const footer_r10 = i0.ɵɵreadContextLet(15);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", footer_r10)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c13, dropdown_r9));
  }
}
const _c17 = ".form-control.date-picker-input[_ngcontent-%COMP%]:focus{box-shadow:0 0}";
function SpinnerComponent_ProjectionFallback_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 0);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label());
  }
}
const _c18 = () => ({
  position: "absolute",
  "top.%": "50",
  "left.%": "50",
  transform: "translateX(-50%) translateY(-50%)"
});
function ElementCoverComponent_ProjectionFallback_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "c-spinner", 1);
  }
}
function HeaderComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.headerClasses());
  }
}
function HeaderComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
const _c19 = ["cLoadingButton", ""];
function LoadingButtonComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "c-spinner", 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("variant", ctx_r0.spinnerType())("@loadingButton", undefined);
  }
}
const _c20 = ["contentDiv"];
function MultiSelectOptionComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", (tmp_2_0 = (tmp_2_0 = ctx_r0.text) !== null && tmp_2_0 !== undefined ? tmp_2_0 : ctx_r0.label) !== null && tmp_2_0 !== undefined ? tmp_2_0 : ctx_r0.value == null ? null : ctx_r0.value.toString(), " ");
  }
}
function MultiSelectOptgroupComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "c-multi-select-optgroup-label");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label);
  }
}
function MultiSelectNativeSelectComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "option", 1);
  }
  if (rf & 2) {
    const option_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r1.disabled)("label", option_r1.label)("value", option_r1.value);
    i0.ɵɵattribute("selected", option_r1.selected ? "" : null);
  }
}
function MultiSelectTagComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2);
    i0.ɵɵlistener("click", function MultiSelectTagComponent_Conditional_2_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleRemove($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_1_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ((tmp_1_0 = ctx_r1.multiselectVisible()) !== null && tmp_1_0 !== undefined ? tmp_1_0 : true) === false);
  }
}
const _c21 = ["options"];
const _c22 = ["inputElement"];
const _c23 = ["scrollViewport"];
const MultiSelectComponent_ng_template_13_Defer_1_DepsFn = () => [AsyncPipe, NgStyle, NgTemplateOutlet, import('@angular/cdk/scrolling').then(m => m.CdkFixedSizeVirtualScroll), import('@angular/cdk/scrolling').then(m => m.CdkVirtualScrollViewport), import('@angular/cdk/scrolling').then(m => m.CdkVirtualForOf)];
const _c24 = a0 => ({
  "form-multi-select-selection": true,
  "form-multi-select-selection-tags": a0
});
const _c25 = a0 => ({
  "form-multi-select-search": true,
  disabled: a0,
  "text-truncate": true
});
const _c26 = () => ({
  "border-radius": "6px",
  "z-index": 2
});
const _c27 = (a0, a1, a2) => ({
  "height.px": a0,
  "maxHeight.px": a1,
  "minWidth.px": a2,
  overflowX: "hidden"
});
const _c28 = a0 => ({
  "minWidth.px": a0,
  overflowX: "hidden"
});
const _c29 = (a0, a1, a2, a3, a4, a5, a6) => ({
  $implicit: a0,
  even: a1,
  odd: a2,
  index: a3,
  count: a4,
  first: a5,
  last: a6
});
const _c30 = a0 => ({
  "form-multi-select-options": a0
});
const _c31 = a0 => ({
  "maxHeight.px": a0,
  overflowY: "scroll"
});
function MultiSelectComponent_Conditional_5_Conditional_0_For_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "c-multi-select-tag", 20);
    i0.ɵɵlistener("remove", function MultiSelectComponent_Conditional_5_Conditional_0_For_1_Template_c_multi_select_tag_remove_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.handleTagRemove($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_20_0;
    let tmp_21_0;
    const option_r4 = ctx.$implicit;
    i0.ɵɵproperty("disabled", (tmp_20_0 = option_r4.disabled) !== null && tmp_20_0 !== undefined ? tmp_20_0 : false)("label", (tmp_21_0 = option_r4.label) !== null && tmp_21_0 !== undefined ? tmp_21_0 : option_r4.value == null ? null : option_r4.value.toString())("option", option_r4)("value", option_r4.value);
  }
}
function MultiSelectComponent_Conditional_5_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, MultiSelectComponent_Conditional_5_Conditional_0_For_1_Template, 1, 4, "c-multi-select-tag", 19, _forTrack3);
  }
  if (rf & 2) {
    i0.ɵɵrepeater(ctx);
  }
}
function MultiSelectComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MultiSelectComponent_Conditional_5_Conditional_0_Template, 2, 0);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    let tmp_7_0;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵconditional((tmp_7_0 = i0.ɵɵpipeBind1(1, 1, ctx_r2.optionsSelected$)) ? 0 : -1, tmp_7_0);
  }
}
function MultiSelectComponent_Conditional_6_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r5 = ctx.$implicit;
    const ɵ$index_14_r6 = ctx.$index;
    const ɵ$count_14_r7 = ctx.$count;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", option_r5.label, "", ɵ$index_14_r6 === ɵ$count_14_r7 - 1 ? "\xA0" : ",\xA0", "");
  }
}
function MultiSelectComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, MultiSelectComponent_Conditional_6_For_1_Template, 2, 2, "span", 21, _forTrack3);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r2.selectedOptions);
  }
}
function MultiSelectComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.optionsSelected.size === 0 ? ctx_r2.placeholder : ctx_r2.counterPlaceholderText, " ");
  }
}
function MultiSelectComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 22, 6);
    i0.ɵɵlistener("keydown", function MultiSelectComponent_Conditional_8_Template_input_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleSearchKeyDown($event));
    })("valueChange", function MultiSelectComponent_Conditional_8_Template_input_valueChange_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleSearchValueChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("tabindex", ctx_r2.disabled ? -1 : 0);
    i0.ɵɵproperty("disabled", ctx_r2.disabled || !ctx_r2.search)("ngClass", i0.ɵɵpureFunction1(6, _c25, ctx_r2.disabled || !ctx_r2.search))("ngModel", ctx_r2.searchValue)("value", ctx_r2.searchValue);
    i0.ɵɵattribute("placeholder", ctx_r2.selectedOptions.length === 0 ? ctx_r2.placeholder : ctx_r2.counterPlaceholderText);
  }
}
function MultiSelectComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 23);
    i0.ɵɵlistener("click", function MultiSelectComponent_Conditional_10_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.clearAllOptions($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r2.disabled || !ctx_r2.isDropdownVisible && ctx_r2.cleaner !== "active");
  }
}
function MultiSelectComponent_Conditional_12_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 27);
    i0.ɵɵlistener("click", function MultiSelectComponent_Conditional_12_Conditional_2_Conditional_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.selectAllOptions());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.selectAllLabel, " ");
  }
}
function MultiSelectComponent_Conditional_12_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MultiSelectComponent_Conditional_12_Conditional_2_Conditional_0_Template, 2, 1, "button", 26);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r2.selectAll && ctx_r2.multiple && !ctx_r2.virtualScroller ? 0 : -1);
  }
}
function MultiSelectComponent_Conditional_12_Conditional_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function MultiSelectComponent_Conditional_12_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MultiSelectComponent_Conditional_12_Conditional_3_ng_container_0_Template, 1, 0, "ng-container", 28);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    const multiselectVirtualScroller_r11 = i0.ɵɵreference(14);
    const multiselectOptionsDiv_r12 = i0.ɵɵreference(16);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.virtualScroller ? multiselectVirtualScroller_r11 : multiselectOptionsDiv_r12);
  }
}
function MultiSelectComponent_Conditional_12_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.searchNoResultsLabel);
  }
}
function MultiSelectComponent_Conditional_12_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "c-element-cover", 25);
  }
  if (rf & 2) {
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(1, _c26));
  }
}
function MultiSelectComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18, 7);
    i0.ɵɵtemplate(2, MultiSelectComponent_Conditional_12_Conditional_2_Template, 1, 1)(3, MultiSelectComponent_Conditional_12_Conditional_3_Template, 1, 1, "ng-container")(4, MultiSelectComponent_Conditional_12_Conditional_4_Template, 2, 1, "div", 24)(5, MultiSelectComponent_Conditional_12_Conditional_5_Template, 1, 2, "c-element-cover", 25);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const dropdown_r13 = i0.ɵɵreference(1);
    i0.ɵɵproperty("visible", dropdown_r13.visible());
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r2.visibleOptions() && ctx_r2.options.length > 0 ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.visibleOptions() && ctx_r2.options.length > 0 || ctx_r2.isLoading() ? 3 : 4);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r2.isLoading() ? 5 : -1);
  }
}
function MultiSelectComponent_ng_template_13_Defer_0_Conditional_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 32, 9);
  }
  if (rf & 2) {
    const option_r16 = ctx.$implicit;
    const even_r17 = ctx.even;
    const odd_r18 = ctx.odd;
    const index_r19 = ctx.index;
    const count_r20 = ctx.count;
    const first_r21 = ctx.first;
    const last_r22 = ctx.last;
    const ctx_r2 = i0.ɵɵnextContext(4);
    const defaultMultiSelectOptionTemplate_r23 = i0.ɵɵreference(18);
    i0.ɵɵproperty("ngTemplateOutletContext", i0.ɵɵpureFunction7(2, _c29, option_r16, even_r17, odd_r18, index_r19, count_r20, first_r21, last_r22))("ngTemplateOutlet", ctx_r2.templates["multiSelectOptionTemplate"] || defaultMultiSelectOptionTemplate_r23);
  }
}
function MultiSelectComponent_ng_template_13_Defer_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cdk-virtual-scroll-viewport", 30, 8);
    i0.ɵɵlistener("scrolledIndexChange", function MultiSelectComponent_ng_template_13_Defer_0_Conditional_0_Template_cdk_virtual_scroll_viewport_scrolledIndexChange_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const scrollViewport_r15 = i0.ɵɵreference(1);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.handleScrolledIndexChange($event, scrollViewport_r15));
    });
    i0.ɵɵtemplate(2, MultiSelectComponent_ng_template_13_Defer_0_Conditional_0_ng_container_2_Template, 2, 10, "ng-container", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("maxBufferPx", ctx_r2.itemSize * ctx_r2.visibleItems);
    i0.ɵɵpropertyInterpolate("minBufferPx", ctx_r2.itemSize * ctx_r2.visibleItems);
    i0.ɵɵproperty("itemSize", ctx_r2.itemSize)("ngStyle", ctx_r2.optionsMaxHeight !== "auto" ? i0.ɵɵpureFunction3(7, _c27, ctx_r2.optionsMaxHeight, ctx_r2.optionsMaxHeight, ctx_r2.minWidth()) : i0.ɵɵpureFunction1(11, _c28, ctx_r2.minWidth()));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cdkVirtualForOf", ctx)("cdkVirtualForTrackBy", ctx_r2.trackByFn)("cdkVirtualForTemplateCacheSize", 0);
  }
}
function MultiSelectComponent_ng_template_13_Defer_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MultiSelectComponent_ng_template_13_Defer_0_Conditional_0_Template, 3, 13, "cdk-virtual-scroll-viewport", 29);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    let tmp_8_0;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional((tmp_8_0 = i0.ɵɵpipeBind1(1, 1, ctx_r2.optionsArray$)) ? 0 : -1, tmp_8_0);
  }
}
function MultiSelectComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MultiSelectComponent_ng_template_13_Defer_0_Template, 2, 3);
    i0.ɵɵdefer(1, 0, MultiSelectComponent_ng_template_13_Defer_1_DepsFn);
    i0.ɵɵdeferOnImmediate();
  }
}
function MultiSelectComponent_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵprojection(1);
    i0.ɵɵelementContainer(2, 34);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const userOptionsTemplate_r24 = i0.ɵɵreference(20);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c30, ctx_r2.visibleOptions()))("ngStyle", ctx_r2.optionsMaxHeight !== "auto" ? i0.ɵɵpureFunction1(5, _c31, ctx_r2.optionsMaxHeight) : i0.ɵɵpureFunction0(7, _c3));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", userOptionsTemplate_r24);
  }
}
function MultiSelectComponent_ng_template_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "c-multi-select-option", 35);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r25 = ctx.$implicit;
    i0.ɵɵproperty("disabled", option_r25.disabled)("label", option_r25.label)("text", option_r25.text)("value", option_r25.value)("visible", option_r25.visible);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", option_r25.text, " ");
  }
}
function MultiSelectComponent_ng_template_19_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 36);
  }
  if (rf & 2) {
    const option_r26 = ctx.$implicit;
    const ɵ$index_78_r27 = ctx.$index;
    const ɵ$count_78_r28 = ctx.$count;
    const ctx_r2 = i0.ɵɵnextContext(2);
    const defaultMultiSelectOptionTemplate_r23 = i0.ɵɵreference(18);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.templates["multiSelectOptionTemplate"] || defaultMultiSelectOptionTemplate_r23)("ngTemplateOutletContext", i0.ɵɵpureFunction7(2, _c29, option_r26, ɵ$index_78_r27 % 2 === 0, ɵ$index_78_r27 % 2 !== 0, ɵ$index_78_r27, ɵ$count_78_r28, ɵ$index_78_r27 === 0, ɵ$index_78_r27 === ɵ$count_78_r28 - 1));
  }
}
function MultiSelectComponent_ng_template_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, MultiSelectComponent_ng_template_19_For_1_Template, 1, 10, "ng-container", 36, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵpipe(2, "async");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(i0.ɵɵpipeBind1(2, 0, ctx_r2.userOptionsArray$));
  }
}
function NavbarComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NavbarComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.containerClass());
  }
}
function NavbarComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
const _c32 = ["modalContentRef"];
const _c33 = "[_nghost-%COMP%]{display:list-item;text-align:-webkit-match-parent;text-align:match-parent}";
const _c34 = ["popoverTemplate"];
const _c35 = a0 => ({
  "popover-arrow": a0
});
function ProgressComponent_Conditional_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ProgressComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ProgressComponent_Conditional_0_ng_container_0_Template, 1, 0, "ng-container", 2);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const defaultContent_r1 = i0.ɵɵreference(3);
    i0.ɵɵproperty("ngTemplateOutlet", defaultContent_r1);
  }
}
function ProgressComponent_Conditional_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ProgressComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdeclareLet(0);
    i0.ɵɵelementStart(1, "c-progress-bar", 1);
    i0.ɵɵtemplate(2, ProgressComponent_Conditional_1_ng_container_2_Template, 1, 0, "ng-container", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const defaultContent_r1 = i0.ɵɵreference(3);
    const pbd_r3 = ctx_r1.progressBarDirective;
    i0.ɵɵadvance();
    i0.ɵɵproperty("animated", pbd_r3 == null ? null : pbd_r3.animated())("variant", pbd_r3 == null ? null : pbd_r3.variant())("color", pbd_r3 == null ? null : pbd_r3.color())("value", ctx_r1.value());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", defaultContent_r1);
  }
}
function ProgressComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
const _c36 = ["tooltipTemplate"];
const _c37 = () => ["hover", "focusin"];
const _c38 = (a0, a1) => ({
  $implicit: a0,
  itemIndex: a1
});
function RatingComponent_For_1_Conditional_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function RatingComponent_For_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵlistener("mouseenter", function RatingComponent_For_1_Conditional_0_Template_div_mouseenter_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ɵ$index_1_r2 = i0.ɵɵnextContext().$index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.hoveredItem.set(ɵ$index_1_r2));
    })("focusin", function RatingComponent_For_1_Conditional_0_Template_div_focusin_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ɵ$index_1_r2 = i0.ɵɵnextContext().$index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.hoveredItem.set(ɵ$index_1_r2));
    });
    i0.ɵɵtemplate(1, RatingComponent_For_1_Conditional_0_ng_container_1_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const item_r5 = ctx_r3.$implicit;
    const ɵ$index_1_r2 = ctx_r3.$index;
    const ctx_r2 = i0.ɵɵnextContext();
    const ratingItemLabel_r6 = i0.ɵɵreference(3);
    i0.ɵɵproperty("cTooltip", ctx_r2.getTooltipValue(ɵ$index_1_r2))("cTooltipTrigger", i0.ɵɵpureFunction0(4, _c37));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ratingItemLabel_r6)("ngTemplateOutletContext", i0.ɵɵpureFunction2(5, _c38, item_r5, ɵ$index_1_r2));
  }
}
function RatingComponent_For_1_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function RatingComponent_For_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, RatingComponent_For_1_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const item_r5 = ctx_r3.$implicit;
    const ɵ$index_1_r2 = ctx_r3.$index;
    i0.ɵɵnextContext();
    const ratingItemLabel_r6 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ratingItemLabel_r6)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c38, item_r5, ɵ$index_1_r2));
  }
}
function RatingComponent_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, RatingComponent_For_1_Conditional_0_Template, 2, 8, "div", 5)(1, RatingComponent_For_1_Conditional_1_Template, 2, 5, "div", 6);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r2.tooltips() ? 0 : 1);
  }
}
function RatingComponent_ng_template_2_For_1_Conditional_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function RatingComponent_ng_template_2_For_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, RatingComponent_ng_template_2_For_1_Conditional_1_ng_container_0_Template, 1, 0, "ng-container", 8);
  }
  if (rf & 2) {
    let tmp_22_0;
    const itemIndex_r9 = i0.ɵɵnextContext(2).itemIndex;
    const ctx_r2 = i0.ɵɵnextContext();
    const customIconTemplate_r10 = i0.ɵɵreference(9);
    i0.ɵɵproperty("ngTemplateOutlet", customIconTemplate_r10)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c13, (tmp_22_0 = (tmp_22_0 = ctx_r2.icon()) == null ? null : tmp_22_0[itemIndex_r9]) !== null && tmp_22_0 !== undefined ? tmp_22_0 : ctx_r2.icon()));
  }
}
function RatingComponent_ng_template_2_For_1_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function RatingComponent_ng_template_2_For_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, RatingComponent_ng_template_2_For_1_Conditional_2_ng_container_0_Template, 1, 0, "ng-container", 11);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(3);
    const defaultIconTemplate_r11 = i0.ɵɵreference(7);
    i0.ɵɵproperty("ngTemplateOutlet", defaultIconTemplate_r11);
  }
}
function RatingComponent_ng_template_2_For_1_Conditional_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function RatingComponent_ng_template_2_For_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, RatingComponent_ng_template_2_For_1_Conditional_3_ng_container_0_Template, 1, 0, "ng-container", 8);
  }
  if (rf & 2) {
    let tmp_22_0;
    const itemIndex_r9 = i0.ɵɵnextContext(2).itemIndex;
    const ctx_r2 = i0.ɵɵnextContext();
    const customIconActiveTemplate_r12 = i0.ɵɵreference(11);
    i0.ɵɵproperty("ngTemplateOutlet", customIconActiveTemplate_r12)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c13, (tmp_22_0 = (tmp_22_0 = ctx_r2.activeIcon()) == null ? null : tmp_22_0[itemIndex_r9]) !== null && tmp_22_0 !== undefined ? tmp_22_0 : ctx_r2.activeIcon()));
  }
}
function RatingComponent_ng_template_2_For_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "c-rating-item-label", 10);
    i0.ɵɵlistener("click", function RatingComponent_ng_template_2_For_1_Template_c_rating_item_label_click_0_listener() {
      const itemValue_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.handleClick(itemValue_r8));
    })("focus", function RatingComponent_ng_template_2_For_1_Template_c_rating_item_label_focus_0_listener($event) {
      const itemValue_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.handleFocusIn($event, itemValue_r8));
    })("mouseenter", function RatingComponent_ng_template_2_For_1_Template_c_rating_item_label_mouseenter_0_listener($event) {
      const itemValue_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.handleMouseEnter($event, itemValue_r8));
    });
    i0.ɵɵtemplate(1, RatingComponent_ng_template_2_For_1_Conditional_1_Template, 1, 4, "ng-container")(2, RatingComponent_ng_template_2_For_1_Conditional_2_Template, 1, 1, "ng-container")(3, RatingComponent_ng_template_2_For_1_Conditional_3_Template, 1, 4, "ng-container");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_25_0;
    let tmp_26_0;
    const itemValue_r8 = ctx.$implicit;
    const ɵ$index_18_r13 = ctx.$index;
    const itemIndex_r9 = i0.ɵɵnextContext().itemIndex;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c10, ctx_r2.isItemActive(itemValue_r8)))("ngStyle", ɵ$index_18_r13 + 1 < ctx_r2.numberOfSubItems() ? ctx_r2.notLastItemStyle(ɵ$index_18_r13) : i0.ɵɵpureFunction0(9, _c3))("value", itemValue_r8);
    i0.ɵɵattribute("aria-label", itemValue_r8)("aria-checked", itemValue_r8 === ctx_r2.value());
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.iconTemplates()[(tmp_25_0 = ctx_r2.icon()[itemIndex_r9]) !== null && tmp_25_0 !== undefined ? tmp_25_0 : ctx_r2.icon()] ? 1 : 2);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r2.iconTemplates()[(tmp_26_0 = ctx_r2.activeIcon()[itemIndex_r9]) !== null && tmp_26_0 !== undefined ? tmp_26_0 : ctx_r2.activeIcon()] ? 3 : -1);
  }
}
function RatingComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, RatingComponent_ng_template_2_For_1_Template, 4, 10, "c-rating-item-label", 9, i0.ɵɵrepeaterTrackByIndex);
  }
  if (rf & 2) {
    const item_r14 = ctx.$implicit;
    i0.ɵɵrepeater(item_r14);
  }
}
function RatingComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.hoverValue());
  }
}
function RatingComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 12);
  }
}
function RatingComponent_ng_template_8_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function RatingComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtemplate(1, RatingComponent_ng_template_8_ng_container_1_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_7_0;
    const icon_r15 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    const defaultIconTemplate_r11 = i0.ɵɵreference(7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ((tmp_7_0 = ctx_r2.iconTemplates()) == null ? null : tmp_7_0[icon_r15]) || defaultIconTemplate_r11);
  }
}
function RatingComponent_ng_template_10_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function RatingComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtemplate(1, RatingComponent_ng_template_10_ng_container_1_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_7_0;
    const icon_r16 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    const customIconTemplate_r10 = i0.ɵɵreference(9);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ((tmp_7_0 = ctx_r2.iconTemplates()) == null ? null : tmp_7_0[icon_r16]) || customIconTemplate_r10);
  }
}
const _c39 = ["inputRef"];
const _c40 = ["trackRef"];
const _c41 = (a0, a1, a2, a3, a4, a5) => [a0, a1, a2, a3, a4, a5];
const _c42 = (a0, a1, a2, a3, a4) => [a0, a1, a2, a3, a4];
const _c43 = (a0, a1, a2, a3, a4, a5, a6) => [a0, a1, a2, a3, a4, a5, a6];
function RangeSliderComponent_For_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵpipe(1, "rangeSliderTooltipPositionStyle");
    i0.ɵɵelementStart(2, "div", 10);
    i0.ɵɵdeclareLet(3);
    i0.ɵɵelementStart(4, "label", 11);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(6, "div", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_16_0;
    const ctx_r3 = i0.ɵɵnextContext();
    const value_r5 = ctx_r3.$implicit;
    const ɵ$index_3_r2 = ctx_r3.$index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpipeBindV(1, 3, i0.ɵɵpureFunction6(10, _c41, value_r5, ctx_r2.min(), ctx_r2.max(), ctx_r2.vertical(), ctx_r2.thumbSize(), ctx_r2.isRtl)));
    const tooltipsFn_r6 = ctx_r2.tooltipsFormat();
    i0.ɵɵadvance(4);
    i0.ɵɵpropertyInterpolate("for", ctx_r2.inputIds()[ɵ$index_3_r2]);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", (tmp_16_0 = tooltipsFn_r6 == null ? null : tooltipsFn_r6(value_r5)) !== null && tmp_16_0 !== undefined ? tmp_16_0 : value_r5, " ");
  }
}
function RangeSliderComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 8, 0);
    i0.ɵɵlistener("ngModelChange", function RangeSliderComponent_For_2_Template_input_ngModelChange_0_listener($event) {
      const ɵ$index_3_r2 = i0.ɵɵrestoreView(_r1).$index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleInputChange($event, ɵ$index_3_r2));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, RangeSliderComponent_For_2_Conditional_2_Template, 7, 17, "div", 9);
  }
  if (rf & 2) {
    const value_r5 = ctx.$implicit;
    const ɵ$index_3_r2 = ctx.$index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("min", ctx_r2.min())("max", ctx_r2.max())("step", ctx_r2.step())("value", value_r5)("disabled", ctx_r2.disabledState())("ngModel", value_r5);
    i0.ɵɵattribute("value", value_r5)("aria-valuemin", ctx_r2.min())("aria-valuemax", ctx_r2.max())("aria-valuenow", value_r5)("aria-orientation", ctx_r2.vertical() ? "vertical" : "horizontal")("id", ctx_r2.inputIds()[ɵ$index_3_r2]);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r2.tooltips() ? 2 : -1);
  }
}
function RangeSliderComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 5, 1);
    i0.ɵɵpipe(2, "rangeSliderTrack");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpipeBindV(2, 1, i0.ɵɵpureFunction5(7, _c42, ctx_r2.currentValue(), ctx_r2.min(), ctx_r2.max(), ctx_r2.vertical(), ctx_r2.isRtl)));
  }
}
function RangeSliderComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 6, 1);
  }
}
function RangeSliderComponent_Conditional_5_For_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵdeclareLet(0);
    i0.ɵɵelementStart(1, "div", 14, 3);
    i0.ɵɵpipe(3, "rangeSliderLabelClass");
    i0.ɵɵpipe(4, "rangeSliderLabelStyle");
    i0.ɵɵlistener("mousedown", function RangeSliderComponent_Conditional_5_For_3_Template_div_mousedown_1_listener($event) {
      const label_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.handleLabelClick($event, label_r8));
    });
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const label_r8 = ctx.$implicit;
    const ɵ$index_28_r9 = ctx.$index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    const labelValue_r10 = ctx_r2.getLabel(label_r8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBind2(3, 3, label_r8, ctx_r2.clickableLabels()))("ngStyle", i0.ɵɵpipeBindV(4, 6, i0.ɵɵpureFunction7(14, _c43, label_r8, ctx_r2.min(), ctx_r2.max(), ctx_r2.vertical(), ctx_r2.labels(), ɵ$index_28_r9, ctx_r2.isRtl)));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", labelValue_r10, " ");
  }
}
function RangeSliderComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7, 2);
    i0.ɵɵrepeaterCreate(2, RangeSliderComponent_Conditional_5_For_3_Template, 6, 22, "div", 13, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r2.labels());
  }
}
function SidebarBrandComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("cHtmlAttr", ctx_r0.brandFull())("ngClass", "sidebar-brand-full");
  }
}
function SidebarBrandComponent_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("cHtmlAttr", ctx_r0.brandNarrow())("ngClass", "sidebar-brand-narrow");
  }
}
function SidebarBrandComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 0);
    i0.ɵɵtemplate(1, SidebarBrandComponent_Conditional_0_Conditional_1_Template, 1, 2, "img", 1)(2, SidebarBrandComponent_Conditional_0_Conditional_2_Template, 1, 2, "img", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", ctx_r0.routerLink());
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.brandFull() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.brandNarrow() ? 2 : -1);
  }
}
function SidebarBrandComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function SidebarNavLinkContentComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_1_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate((tmp_1_0 = ctx_r0.item == null ? null : ctx_r0.item.name) !== null && tmp_1_0 !== undefined ? tmp_1_0 : "");
  }
}
const _c44 = () => ({
  exact: false
});
function SidebarNavLinkComponent_Case_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SidebarNavLinkComponent_Case_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵpipe(1, "cSidebarNavBadge");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBind1(1, 2, ctx_r0.item));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.item.badge == null ? null : ctx_r0.item.badge.text);
  }
}
function SidebarNavLinkComponent_Case_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 1);
    i0.ɵɵpipe(1, "cSidebarNavLink");
    i0.ɵɵtemplate(2, SidebarNavLinkComponent_Case_0_ng_container_2_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelement(3, "c-sidebar-nav-link-content", 5);
    i0.ɵɵtemplate(4, SidebarNavLinkComponent_Case_0_Conditional_4_Template, 3, 4, "span", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r0 = i0.ɵɵnextContext();
    const iconTemplate_r2 = i0.ɵɵreference(4);
    i0.ɵɵproperty("cHtmlAttr", (tmp_2_0 = ctx_r0.item.attributes) !== null && tmp_2_0 !== undefined ? tmp_2_0 : i0.ɵɵpureFunction0(8, _c3))("ngClass", i0.ɵɵpipeBind1(1, 6, ctx_r0.item));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", iconTemplate_r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(9, _c13, ctx_r0.item));
    i0.ɵɵadvance();
    i0.ɵɵproperty("item", ctx_r0.item);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.item.badge ? 4 : -1);
  }
}
function SidebarNavLinkComponent_Case_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SidebarNavLinkComponent_Case_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵpipe(1, "cSidebarNavBadge");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBind1(1, 2, ctx_r0.item));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.item.badge == null ? null : ctx_r0.item.badge.text);
  }
}
function SidebarNavLinkComponent_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 7);
    i0.ɵɵpipe(1, "cSidebarNavLink");
    i0.ɵɵlistener("click", function SidebarNavLinkComponent_Case_1_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.linkClicked());
    });
    i0.ɵɵtemplate(2, SidebarNavLinkComponent_Case_1_ng_container_2_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelement(3, "c-sidebar-nav-link-content", 5);
    i0.ɵɵtemplate(4, SidebarNavLinkComponent_Case_1_Conditional_4_Template, 3, 4, "span", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r0 = i0.ɵɵnextContext();
    const iconTemplate_r2 = i0.ɵɵreference(4);
    i0.ɵɵproperty("cHtmlAttr", (tmp_2_0 = ctx_r0.item.attributes) !== null && tmp_2_0 !== undefined ? tmp_2_0 : i0.ɵɵpureFunction0(9, _c3))("href", ctx_r0.href, i0.ɵɵsanitizeUrl)("ngClass", i0.ɵɵpipeBind1(1, 7, ctx_r0.item));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", iconTemplate_r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(10, _c13, ctx_r0.item));
    i0.ɵɵadvance();
    i0.ɵɵproperty("item", ctx_r0.item);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.item.badge ? 4 : -1);
  }
}
function SidebarNavLinkComponent_Case_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SidebarNavLinkComponent_Case_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵpipe(1, "cSidebarNavBadge");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBind1(1, 2, ctx_r0.item));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.item.badge == null ? null : ctx_r0.item.badge.text);
  }
}
function SidebarNavLinkComponent_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 8);
    i0.ɵɵpipe(1, "cSidebarNavLink");
    i0.ɵɵlistener("click", function SidebarNavLinkComponent_Case_2_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.linkClicked());
    });
    i0.ɵɵtemplate(2, SidebarNavLinkComponent_Case_2_ng_container_2_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelement(3, "c-sidebar-nav-link-content", 5);
    i0.ɵɵtemplate(4, SidebarNavLinkComponent_Case_2_Conditional_4_Template, 3, 4, "span", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    let tmp_5_0;
    let tmp_7_0;
    let tmp_8_0;
    let tmp_9_0;
    let tmp_11_0;
    let tmp_12_0;
    const ctx_r0 = i0.ɵɵnextContext();
    const iconTemplate_r2 = i0.ɵɵreference(4);
    i0.ɵɵproperty("cHtmlAttr", (tmp_2_0 = ctx_r0.item.attributes) !== null && tmp_2_0 !== undefined ? tmp_2_0 : i0.ɵɵpureFunction0(18, _c3))("fragment", ctx_r0.item.linkProps == null ? null : ctx_r0.item.linkProps.fragment)("ngClass", i0.ɵɵpipeBind1(1, 16, ctx_r0.item))("preserveFragment", (tmp_5_0 = ctx_r0.item.linkProps == null ? null : ctx_r0.item.linkProps.preserveFragment) !== null && tmp_5_0 !== undefined ? tmp_5_0 : false)("queryParamsHandling", ctx_r0.item.linkProps == null ? null : ctx_r0.item.linkProps.queryParamsHandling)("queryParams", (tmp_7_0 = ctx_r0.item.linkProps == null ? null : ctx_r0.item.linkProps.queryParams) !== null && tmp_7_0 !== undefined ? tmp_7_0 : null)("replaceUrl", (tmp_8_0 = ctx_r0.item.linkProps == null ? null : ctx_r0.item.linkProps.replaceUrl) !== null && tmp_8_0 !== undefined ? tmp_8_0 : false)("routerLinkActiveOptions", (tmp_9_0 = ctx_r0.item.linkProps == null ? null : ctx_r0.item.linkProps.routerLinkActiveOptions) !== null && tmp_9_0 !== undefined ? tmp_9_0 : i0.ɵɵpureFunction0(19, _c44))("routerLink", ctx_r0.item.url)("skipLocationChange", (tmp_11_0 = ctx_r0.item.linkProps == null ? null : ctx_r0.item.linkProps.skipLocationChange) !== null && tmp_11_0 !== undefined ? tmp_11_0 : false)("state", (tmp_12_0 = ctx_r0.item.linkProps == null ? null : ctx_r0.item.linkProps.state) !== null && tmp_12_0 !== undefined ? tmp_12_0 : i0.ɵɵpureFunction0(20, _c3))("target", ctx_r0.item.attributes == null ? null : ctx_r0.item.attributes["target"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", iconTemplate_r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(21, _c13, ctx_r0.item));
    i0.ɵɵadvance();
    i0.ɵɵproperty("item", ctx_r0.item);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.item.badge ? 4 : -1);
  }
}
function SidebarNavLinkComponent_ng_template_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵelement(1, "span", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_4_0;
    const item_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", (tmp_4_0 = item_r5.icon) !== null && tmp_4_0 !== undefined ? tmp_4_0 : "");
  }
}
function SidebarNavLinkComponent_ng_template_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 10);
    i0.ɵɵpipe(1, "cSidebarNavIcon");
  }
  if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("cIcon", item_r5.iconComponent == null ? null : item_r5.iconComponent.content)("customClasses", i0.ɵɵpipeBind1(1, 3, item_r5))("name", item_r5.iconComponent == null ? null : item_r5.iconComponent.name);
  }
}
function SidebarNavLinkComponent_ng_template_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 6);
    i0.ɵɵpipe(1, "cSidebarNavIcon");
  }
  if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBind1(1, 1, item_r5));
  }
}
function SidebarNavLinkComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SidebarNavLinkComponent_ng_template_3_Conditional_0_Template, 2, 1, "span", 9)(1, SidebarNavLinkComponent_ng_template_3_Conditional_1_Template, 2, 5, ":svg:svg", 10)(2, SidebarNavLinkComponent_ng_template_3_Conditional_2_Template, 2, 3, "span", 6);
  }
  if (rf & 2) {
    const item_r5 = ctx.$implicit;
    i0.ɵɵconditional((item_r5 == null ? null : item_r5.icon) ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((item_r5 == null ? null : item_r5.iconComponent) ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!(item_r5 == null ? null : item_r5.icon) && !(item_r5 == null ? null : item_r5.iconComponent) ? 2 : -1);
  }
}
function SidebarNavLabelComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.getLabelIconClass());
  }
}
function SidebarNavLabelComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 1);
    i0.ɵɵpipe(1, "cSidebarNavBadge");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBind1(1, 2, ctx_r0.item));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.item.badge.text);
  }
}
function SidebarNavGroupComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SidebarNavGroupComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵpipe(1, "cSidebarNavBadge");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBind1(1, 2, ctx_r1.item));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.item.badge.text);
  }
}
function SidebarNavGroupComponent_ng_template_6_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵelement(1, "span", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_4_0;
    const item_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", (tmp_4_0 = item_r3.icon) !== null && tmp_4_0 !== undefined ? tmp_4_0 : "");
  }
}
function SidebarNavGroupComponent_ng_template_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 6);
    i0.ɵɵpipe(1, "cSidebarNavIcon");
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("cIcon", item_r3.iconComponent == null ? null : item_r3.iconComponent.content)("customClasses", i0.ɵɵpipeBind1(1, 3, item_r3))("name", item_r3.iconComponent == null ? null : item_r3.iconComponent.name);
  }
}
function SidebarNavGroupComponent_ng_template_6_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 3);
    i0.ɵɵpipe(1, "cSidebarNavIcon");
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBind1(1, 1, item_r3));
  }
}
function SidebarNavGroupComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SidebarNavGroupComponent_ng_template_6_Conditional_0_Template, 2, 1, "span", 5)(1, SidebarNavGroupComponent_ng_template_6_Conditional_1_Template, 2, 5, ":svg:svg", 6)(2, SidebarNavGroupComponent_ng_template_6_Conditional_2_Template, 2, 3, "span", 3);
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    i0.ɵɵconditional((item_r3 == null ? null : item_r3.icon) ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((item_r3 == null ? null : item_r3.iconComponent) ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!(item_r3 == null ? null : item_r3.icon) && !(item_r3 == null ? null : item_r3.iconComponent) ? 2 : -1);
  }
}
const _c45 = () => ({
  exact: true
});
function SidebarNavComponent_For_1_Case_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "c-sidebar-nav-group", 1, 0);
    i0.ɵɵpipe(2, "cSidebarNavItemClass");
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("dropdownMode", ctx_r1.dropdownMode)("item", item_r1)("ngClass", i0.ɵɵpipeBind1(2, 5, item_r1))("routerLinkActiveOptions", i0.ɵɵpureFunction0(7, _c45))("compact", ctx_r1.compact);
  }
}
function SidebarNavComponent_For_1_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "c-sidebar-nav-divider", 2);
    i0.ɵɵpipe(1, "cSidebarNavItemClass");
  }
  if (rf & 2) {
    let tmp_11_0;
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("cHtmlAttr", (tmp_11_0 = item_r1.attributes) !== null && tmp_11_0 !== undefined ? tmp_11_0 : i0.ɵɵpureFunction0(5, _c3))("item", item_r1)("ngClass", i0.ɵɵpipeBind1(1, 3, item_r1));
  }
}
function SidebarNavComponent_For_1_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "c-sidebar-nav-title", 2);
    i0.ɵɵpipe(1, "cSidebarNavItemClass");
  }
  if (rf & 2) {
    let tmp_11_0;
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("cHtmlAttr", (tmp_11_0 = item_r1.attributes) !== null && tmp_11_0 !== undefined ? tmp_11_0 : i0.ɵɵpureFunction0(5, _c3))("item", item_r1)("ngClass", i0.ɵɵpipeBind1(1, 3, item_r1));
  }
}
function SidebarNavComponent_For_1_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "c-sidebar-nav-label", 3);
    i0.ɵɵpipe(1, "cSidebarNavItemClass");
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("item", item_r1)("ngClass", i0.ɵɵpipeBind1(1, 2, item_r1));
  }
}
function SidebarNavComponent_For_1_Case_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SidebarNavComponent_For_1_Case_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "c-sidebar-nav-link", 4);
    i0.ɵɵpipe(1, "cSidebarNavItemClass");
    i0.ɵɵlistener("linkClick", function SidebarNavComponent_For_1_Case_5_Template_c_sidebar_nav_link_linkClick_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.hideMobile());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("item", item_r1)("ngClass", i0.ɵɵpipeBind1(1, 2, item_r1));
  }
}
function SidebarNavComponent_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SidebarNavComponent_For_1_Case_0_Template, 3, 8, "c-sidebar-nav-group", 1)(1, SidebarNavComponent_For_1_Case_1_Template, 2, 6, "c-sidebar-nav-divider", 2)(2, SidebarNavComponent_For_1_Case_2_Template, 2, 6, "c-sidebar-nav-title", 2)(3, SidebarNavComponent_For_1_Case_3_Template, 2, 4, "c-sidebar-nav-label", 3)(4, SidebarNavComponent_For_1_Case_4_Template, 1, 0, "ng-container")(5, SidebarNavComponent_For_1_Case_5_Template, 2, 4, "c-sidebar-nav-link", 3);
  }
  if (rf & 2) {
    let tmp_10_0;
    const item_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional((tmp_10_0 = ctx_r1.helper.itemType(item_r1)) === "group" ? 0 : tmp_10_0 === "divider" ? 1 : tmp_10_0 === "title" ? 2 : tmp_10_0 === "label" ? 3 : tmp_10_0 === "empty" ? 4 : 5);
  }
}
const _c46 = a0 => ({
  disabled: a0
});
function SmartPaginationComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 1)(1, "button", 3);
    i0.ɵɵlistener("click", function SmartPaginationComponent_Conditional_1_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setPage(1));
    });
    i0.ɵɵelementStart(2, "span", 4);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.activePage === 1)("ngClass", i0.ɵɵpureFunction1(3, _c46, ctx_r1.activePage === 1));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.firstButton);
  }
}
function SmartPaginationComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 1)(1, "button", 5);
    i0.ɵɵlistener("click", function SmartPaginationComponent_Conditional_2_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setPage(ctx_r1.activePage - 1));
    });
    i0.ɵɵelementStart(2, "span", 4);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.activePage === 1)("ngClass", i0.ɵɵpureFunction1(3, _c46, ctx_r1.activePage === 1));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.previousButton);
  }
}
function SmartPaginationComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 1)(1, "a", 6);
    i0.ɵɵtext(2, " ... ");
    i0.ɵɵelementEnd()();
  }
}
function SmartPaginationComponent_For_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 2)(1, "button", 7);
    i0.ɵɵlistener("click", function SmartPaginationComponent_For_5_Template_button_click_1_listener() {
      const item_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setPage(item_r5));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("active", ctx_r1.activePage === item_r5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", (ctx_r1.activePage === item_r5 ? "Current page " : "Go to page ") + item_r5.toString());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r5, " ");
  }
}
function SmartPaginationComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 1)(1, "a", 6);
    i0.ɵɵtext(2, " ... ");
    i0.ɵɵelementEnd()();
  }
}
function SmartPaginationComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 1)(1, "button", 8);
    i0.ɵɵlistener("click", function SmartPaginationComponent_Conditional_7_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setPage(ctx_r1.activePage + 1));
    });
    i0.ɵɵelementStart(2, "span", 4);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.activePage === ctx_r1.pages)("ngClass", i0.ɵɵpureFunction1(3, _c46, ctx_r1.activePage === ctx_r1.pages));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.nextButton);
  }
}
function SmartPaginationComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 1)(1, "button", 9);
    i0.ɵɵlistener("click", function SmartPaginationComponent_Conditional_8_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setPage(ctx_r1.pages));
    });
    i0.ɵɵelementStart(2, "span", 4);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.activePage === ctx_r1.pages)("ngClass", i0.ɵɵpureFunction1(3, _c46, ctx_r1.activePage === ctx_r1.pages));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.lastButton);
  }
}
function SmartTableFilterComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 0);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.labelClasses);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.filterLabel, " ");
  }
}
const _c47 = (a0, a1) => ({
  $implicit: a0,
  header: a1
});
function SmartTableHeadComponent_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SmartTableHeadComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SmartTableHeadComponent_Conditional_2_ng_container_0_Template, 1, 0, "ng-container", 7);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.summaryRowTemplate);
  }
}
function SmartTableHeadComponent_Conditional_3_For_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th");
  }
}
function SmartTableHeadComponent_Conditional_3_For_1_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_33_0;
    const cell_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    const colSorter_r3 = i0.ɵɵreadContextLet(0);
    i0.ɵɵproperty("cHtmlAttr", ctx_r0.getTableHeaderCellProps(cell_r2))("cTableColor", ctx_r0.tableHeaderCellColor(cell_r2))("colSpan", (tmp_33_0 = cell_r2.colspan) !== null && tmp_33_0 !== undefined ? tmp_33_0 : 1)("ngStyle", ctx_r0.getTableHeaderCellStyles(cell_r2, colSorter_r3));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", cell_r2.label, " ");
  }
}
function SmartTableHeadComponent_Conditional_3_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, SmartTableHeadComponent_Conditional_3_For_1_Conditional_1_Template, 1, 0, "th");
    i0.ɵɵrepeaterCreate(2, SmartTableHeadComponent_Conditional_3_For_1_For_3_Template, 2, 5, "th", 8, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r4 = ctx.$implicit;
    i0.ɵɵnextContext(2);
    const selectableRows_r5 = i0.ɵɵreadContextLet(1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(selectableRows_r5 ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(row_r4);
  }
}
function SmartTableHeadComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, SmartTableHeadComponent_Conditional_3_For_1_Template, 4, 1, "tr", null, i0.ɵɵrepeaterTrackByIdentity);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r0.columnGroups());
  }
}
function SmartTableHeadComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th")(1, "input", 9);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵlistener("change", function SmartTableHeadComponent_Conditional_5_Template_input_change_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.handleSelectAllChecked($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r0.selectedAll === true)("disabled", !ctx_r0.selectAll())("indeterminate", i0.ɵɵpipeBind1(2, 3, ctx_r0.indeterminate$));
  }
}
function SmartTableHeadComponent_For_7_Conditional_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SmartTableHeadComponent_For_7_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SmartTableHeadComponent_For_7_Conditional_1_ng_container_0_Template, 1, 0, "ng-container", 11);
  }
  if (rf & 2) {
    const column_r9 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    const columnSorterIconTemplate_r12 = i0.ɵɵreference(14);
    i0.ɵɵproperty("ngTemplateOutlet", columnSorterIconTemplate_r12)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c13, ctx_r0.getColumnSorterState(column_r9)));
  }
}
function SmartTableHeadComponent_For_7_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SmartTableHeadComponent_For_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th", 10);
    i0.ɵɵlistener("click", function SmartTableHeadComponent_For_7_Template_th_click_0_listener() {
      const ctx_r7 = i0.ɵɵrestoreView(_r7);
      const column_r9 = ctx_r7.$implicit;
      const ɵ$index_27_r10 = ctx_r7.$index;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.handleSortClick(column_r9, ɵ$index_27_r10));
    })("keydown", function SmartTableHeadComponent_For_7_Template_th_keydown_0_listener($event) {
      const ctx_r10 = i0.ɵɵrestoreView(_r7);
      const column_r9 = ctx_r10.$implicit;
      const ɵ$index_27_r10 = ctx_r10.$index;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.handleSortKeyDown($event, column_r9, ɵ$index_27_r10));
    });
    i0.ɵɵtemplate(1, SmartTableHeadComponent_For_7_Conditional_1_Template, 1, 4, "ng-container")(2, SmartTableHeadComponent_For_7_ng_container_2_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_26_0;
    const column_r9 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultColumnLabel_r13 = i0.ɵɵreference(10);
    const colSorter_r3 = i0.ɵɵreadContextLet(0);
    i0.ɵɵproperty("cHtmlAttr", ctx_r0.getTableHeaderCellProps(column_r9))("cTableColor", ctx_r0.tableHeaderCellColor(column_r9))("ngClass", ctx_r0.getTableHeaderCellClass(column_r9))("ngStyle", ctx_r0.getTableHeaderCellStyles(column_r9, colSorter_r3))("tabindex", colSorter_r3 && ctx_r0.columnSorterEnabled(column_r9) ? 0 : -1);
    i0.ɵɵattribute("aria-sort", ctx_r0.getAriaSort(column_r9));
    i0.ɵɵadvance();
    i0.ɵɵconditional(colSorter_r3 && ctx_r0.columnSorterEnabled(column_r9) ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", (tmp_26_0 = ctx_r0.columnLabelTemplates[ctx_r0.getColumnLabel(column_r9)]) !== null && tmp_26_0 !== undefined ? tmp_26_0 : defaultColumnLabel_r13)("ngTemplateOutletContext", i0.ɵɵpureFunction2(9, _c47, column_r9, ctx_r0));
  }
}
function SmartTableHeadComponent_Conditional_8_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th");
  }
}
function SmartTableHeadComponent_Conditional_8_For_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SmartTableHeadComponent_Conditional_8_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 12);
    i0.ɵɵtemplate(1, SmartTableHeadComponent_Conditional_8_For_3_ng_container_1_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_23_0;
    const column_r14 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    const defaultColumnFilter_r15 = i0.ɵɵreference(12);
    const colSorter_r3 = i0.ɵɵreadContextLet(0);
    i0.ɵɵproperty("cHtmlAttr", ctx_r0.getTableHeaderCellProps(column_r14))("cTableColor", ctx_r0.tableHeaderCellColor(column_r14))("ngStyle", ctx_r0.getTableHeaderCellStyles(column_r14, colSorter_r3));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", (tmp_23_0 = ctx_r0.columnFilterTemplates[ctx_r0.getColumnFilter(column_r14)]) !== null && tmp_23_0 !== undefined ? tmp_23_0 : defaultColumnFilter_r15)("ngTemplateOutletContext", i0.ɵɵpureFunction2(5, _c47, column_r14, ctx_r0));
  }
}
function SmartTableHeadComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, SmartTableHeadComponent_Conditional_8_Conditional_1_Template, 1, 0, "th");
    i0.ɵɵrepeaterCreate(2, SmartTableHeadComponent_Conditional_8_For_3_Template, 2, 8, "th", 12, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const selectableRows_r5 = i0.ɵɵreadContextLet(1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(selectableRows_r5 ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r0.columns);
  }
}
function SmartTableHeadComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "columnLabel");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r16 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, column_r16));
  }
}
function SmartTableHeadComponent_ng_template_11_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "c-smart-table-column-filter", 15);
    i0.ɵɵlistener("valueChange", function SmartTableHeadComponent_ng_template_11_Conditional_0_Template_c_smart_table_column_filter_valueChange_0_listener($event) {
      i0.ɵɵrestoreView(_r17);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleColumnFilterValueChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_14_0;
    const column_r18 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("column", column_r18)("delay", 300)("onEvent", ctx_r0.columnFilterEvent)("value", (tmp_14_0 = ctx_r0.columnFilterState()[ctx_r0.columnKey(column_r18)]) !== null && tmp_14_0 !== undefined ? tmp_14_0 : "");
  }
}
function SmartTableHeadComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SmartTableHeadComponent_ng_template_11_Conditional_0_Template, 1, 4, "c-smart-table-column-filter", 14);
  }
  if (rf & 2) {
    const column_r18 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.columnFilterEnabled(column_r18) ? 0 : -1);
  }
}
function SmartTableHeadComponent_ng_template_13_Case_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SmartTableHeadComponent_ng_template_13_Case_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtemplate(1, SmartTableHeadComponent_ng_template_13_Case_0_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const sortingIconAscendingTemplate_r19 = i0.ɵɵreference(18);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", sortingIconAscendingTemplate_r19);
  }
}
function SmartTableHeadComponent_ng_template_13_Case_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SmartTableHeadComponent_ng_template_13_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtemplate(1, SmartTableHeadComponent_ng_template_13_Case_1_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const sortingIconDescendingTemplate_r20 = i0.ɵɵreference(20);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", sortingIconDescendingTemplate_r20);
  }
}
function SmartTableHeadComponent_ng_template_13_Case_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SmartTableHeadComponent_ng_template_13_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 17);
    i0.ɵɵtemplate(1, SmartTableHeadComponent_ng_template_13_Case_2_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const sortingIconTemplate_r21 = i0.ɵɵreference(16);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", sortingIconTemplate_r21);
  }
}
function SmartTableHeadComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SmartTableHeadComponent_ng_template_13_Case_0_Template, 2, 1, "span", 16)(1, SmartTableHeadComponent_ng_template_13_Case_1_Template, 2, 1, "span", 16)(2, SmartTableHeadComponent_ng_template_13_Case_2_Template, 2, 1, "span", 17);
  }
  if (rf & 2) {
    let tmp_10_0;
    const columnSorterState_r22 = ctx.$implicit;
    i0.ɵɵconditional((tmp_10_0 = columnSorterState_r22) === "asc" ? 0 : tmp_10_0 === "desc" ? 1 : 2);
  }
}
function SmartTableHeadComponent_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 18);
    i0.ɵɵelement(1, "polygon", 19)(2, "polygon", 20);
    i0.ɵɵelementEnd();
  }
}
function SmartTableHeadComponent_ng_template_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 18);
    i0.ɵɵelement(1, "polygon", 21);
    i0.ɵɵelementEnd();
  }
}
function SmartTableHeadComponent_ng_template_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 18);
    i0.ɵɵelement(1, "polygon", 22);
    i0.ɵɵelementEnd();
  }
}
function SmartTableItemsPerPageSelectorComponent_For_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r1 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", option_r1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(option_r1);
  }
}
const _c48 = [[["", "customHeader", ""]]];
const _c49 = ["[customHeader]"];
const _c50 = a0 => ({
  "ms-1": a0
});
const _c51 = () => ["top"];
const _c52 = a0 => ({
  sides: a0,
  query: "td"
});
const _c53 = () => ["bottom"];
const _c54 = a0 => ({
  sides: a0,
  query: "tbody"
});
const _c55 = (a0, a1) => [a0, a1];
const _c56 = a0 => ({
  cursor: a0
});
const _c57 = (a0, a1, a2, a3, a4) => ({
  column: a0,
  item: a1,
  columnName: a2,
  tdContent: a3,
  cellProps: a4
});
const _c58 = () => ({
  borderBottomWidth: 0
});
const _c59 = () => ({
  border: 0
});
const _c60 = (a0, a1) => ({
  item: a0,
  index: a1
});
function SmartTableComponent_Conditional_0_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SmartTableComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, SmartTableComponent_Conditional_0_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const tableFilterTemplate_r1 = i0.ɵɵreference(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", tableFilterTemplate_r1);
  }
}
function SmartTableComponent_Conditional_0_Conditional_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SmartTableComponent_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, SmartTableComponent_Conditional_0_Conditional_2_ng_container_1_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const tableCleanerTemplate_r2 = i0.ɵɵreference(7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", tableCleanerTemplate_r2);
  }
}
function SmartTableComponent_Conditional_0_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SmartTableComponent_Conditional_0_ng_template_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "c-smart-table-filter", 17);
    i0.ɵɵlistener("valueChange", function SmartTableComponent_Conditional_0_ng_template_4_Conditional_0_Template_c_smart_table_filter_valueChange_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.handleTableFilterChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("delay", 300)("filterLabel", ctx_r3.tableFilterLabel)("filterPlaceholder", ctx_r3.tableFilterPlaceholder)("onEvent", ctx_r3.tableFilterEvent)("value", ctx_r3.tableFilterState);
  }
}
function SmartTableComponent_Conditional_0_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SmartTableComponent_Conditional_0_ng_template_4_Conditional_0_Template, 1, 5, "c-smart-table-filter", 16);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r3.tableFilter ? 0 : -1);
  }
}
function SmartTableComponent_Conditional_0_ng_template_6_Conditional_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SmartTableComponent_Conditional_0_ng_template_6_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵlistener("click", function SmartTableComponent_Conditional_0_ng_template_6_Conditional_0_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.clean($event));
    });
    i0.ɵɵtemplate(1, SmartTableComponent_Conditional_0_ng_template_6_Conditional_0_ng_container_1_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    const filterIconTemplate_r6 = i0.ɵɵreference(16);
    i0.ɵɵproperty("disabled", !ctx_r3.isFiltered)("ngClass", i0.ɵɵpureFunction1(3, _c50, ctx_r3.tableFilter));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", filterIconTemplate_r6);
  }
}
function SmartTableComponent_Conditional_0_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SmartTableComponent_Conditional_0_ng_template_6_Conditional_0_Template, 2, 5, "button", 18);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r3.cleaner ? 0 : -1);
  }
}
function SmartTableComponent_Conditional_0_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
}
function SmartTableComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, SmartTableComponent_Conditional_0_Conditional_1_Template, 2, 1, "div", 15)(2, SmartTableComponent_Conditional_0_Conditional_2_Template, 2, 1, "div", 15)(3, SmartTableComponent_Conditional_0_ng_container_3_Template, 1, 0, "ng-container", 11)(4, SmartTableComponent_Conditional_0_ng_template_4_Template, 1, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(6, SmartTableComponent_Conditional_0_ng_template_6_Template, 1, 1, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor)(8, SmartTableComponent_Conditional_0_ng_template_8_Template, 2, 0, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tableCustomHeaderTemplate_r7 = i0.ɵɵreference(9);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.tableFilter ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.cleaner ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.templates["tableCustomHeader"] || tableCustomHeaderTemplate_r7);
  }
}
function SmartTableComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "c-smart-table-head", 21);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵlistener("columnFilterStateChange", function SmartTableComponent_Conditional_3_Template_c_smart_table_head_columnFilterStateChange_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.handleColumnFilterChange($event));
    })("selectAllChange", function SmartTableComponent_Conditional_3_Template_c_smart_table_head_selectAllChange_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.handleSelectAllChange($event));
    })("sorterStateChange", function SmartTableComponent_Conditional_3_Template_c_smart_table_head_sorterStateChange_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.handleSortChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_6_0;
    let tmp_17_0;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("cAlign", ctx_r3.tableHeadProps == null ? null : ctx_r3.tableHeadProps.align)("cHtmlAttr", (tmp_6_0 = ctx_r3.tableHeadProps == null ? null : ctx_r3.tableHeadProps.attributes) !== null && tmp_6_0 !== undefined ? tmp_6_0 : i0.ɵɵpureFunction0(17, _c3))("cTableColor", ctx_r3.tableHeadProps == null ? null : ctx_r3.tableHeadProps.color)("columnFilterState", ctx_r3.columnFilterState)("columnFilterTemplates", ctx_r3.columnFilterTemplates)("columnFilter", ctx_r3.columnFilter)("columnGroups", ctx_r3.columnGroups$())("columnLabelTemplates", ctx_r3.columnLabelTemplates)("columnSorter", ctx_r3.columnSorter())("columns", ctx_r3.columns$())("selectAll", ctx_r3.selectAll)("selectable", ctx_r3.selectable)("selectedAll", (tmp_17_0 = i0.ɵɵpipeBind1(1, 15, ctx_r3.selectedAllSubject)) !== null && tmp_17_0 !== undefined ? tmp_17_0 : false)("showGroups", ctx_r3.showGroups$())("sorterValue", ctx_r3.sorterValue);
  }
}
function SmartTableComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SmartTableComponent_Conditional_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SmartTableComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tfoot");
    i0.ɵɵtemplate(1, SmartTableComponent_Conditional_5_ng_container_1_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.summaryRowTemplate);
  }
}
function SmartTableComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "c-smart-table-head", 22);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵlistener("selectAllChange", function SmartTableComponent_Conditional_6_Template_c_smart_table_head_selectAllChange_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.handleSelectAllChange($event));
    })("sorterStateChange", function SmartTableComponent_Conditional_6_Template_c_smart_table_head_sorterStateChange_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.handleSortChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_6_0;
    let tmp_14_0;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("cAlign", ctx_r3.tableFootProps == null ? null : ctx_r3.tableFootProps.align)("cHtmlAttr", (tmp_6_0 = ctx_r3.tableFootProps == null ? null : ctx_r3.tableFootProps.attributes) !== null && tmp_6_0 !== undefined ? tmp_6_0 : i0.ɵɵpureFunction0(14, _c3))("cTableColor", ctx_r3.tableFootProps == null ? null : ctx_r3.tableFootProps.color)("columnFilterTemplates", ctx_r3.columnFilterTemplates)("columnLabelTemplates", ctx_r3.columnLabelTemplates)("columnSorter", ctx_r3.columnSorter())("columns", ctx_r3.columns$())("selectAll", ctx_r3.selectAll)("selectable", ctx_r3.selectable)("selectedAll", (tmp_14_0 = i0.ɵɵpipeBind1(1, 12, ctx_r3.selectedAllSubject)) !== null && tmp_14_0 !== undefined ? tmp_14_0 : false)("sorterValue", ctx_r3.sorterValue)("summaryRowTemplate", ctx_r3.summaryRowTemplate);
  }
}
function SmartTableComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "c-element-cover", 13);
  }
  if (rf & 2) {
    i0.ɵɵproperty("boundaries", i0.ɵɵpureFunction2(7, _c55, i0.ɵɵpureFunction1(2, _c52, i0.ɵɵpureFunction0(1, _c51)), i0.ɵɵpureFunction1(5, _c54, i0.ɵɵpureFunction0(4, _c53))));
  }
}
function SmartTableComponent_Conditional_8_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "c-smart-pagination", 27);
    i0.ɵɵlistener("activePageChange", function SmartTableComponent_Conditional_8_Conditional_2_Template_c_smart_pagination_activePageChange_0_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.setActivePage($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("activePage", ctx_r3.activePage)("pages", ctx_r3.numberOfPages);
  }
}
function SmartTableComponent_Conditional_8_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "c-smart-table-items-per-page-selector", 28);
    i0.ɵɵlistener("itemsPerPageChange", function SmartTableComponent_Conditional_8_Conditional_4_Template_c_smart_table_items_per_page_selector_itemsPerPageChange_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.handleItemsPerPageChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("itemsPerPageLabel", ctx_r3.itemsPerPageLabel)("itemsPerPageOptions", ctx_r3.itemsPerPageOptions)("itemsPerPage", ctx_r3.itemsPerPage);
  }
}
function SmartTableComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 23);
    i0.ɵɵtemplate(2, SmartTableComponent_Conditional_8_Conditional_2_Template, 1, 2, "c-smart-pagination", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 25);
    i0.ɵɵtemplate(4, SmartTableComponent_Conditional_8_Conditional_4_Template, 1, 3, "c-smart-table-items-per-page-selector", 26);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r3.pagination && ctx_r3.numberOfPages > 1 ? 2 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r3.itemsPerPageSelect ? 4 : -1);
  }
}
function SmartTableComponent_ng_template_9_For_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 31)(1, "input", 32);
    i0.ɵɵlistener("change", function SmartTableComponent_ng_template_9_For_2_Conditional_1_Template_input_change_1_listener($event) {
      i0.ɵɵrestoreView(_r16);
      const item_r14 = i0.ɵɵnextContext().$implicit;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.handleRowChecked($event, item_r14));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_21_0;
    let tmp_23_0;
    const item_r14 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("cAlign", item_r14 == null ? null : item_r14["_cellProps"] == null ? null : item_r14["_cellProps"]._all == null ? null : item_r14["_cellProps"]._all.align)("cTableActive", (tmp_21_0 = item_r14 == null ? null : item_r14["_cellProps"] == null ? null : item_r14["_cellProps"]._all == null ? null : item_r14["_cellProps"]._all.active) !== null && tmp_21_0 !== undefined ? tmp_21_0 : undefined)("cTableColor", item_r14 == null ? null : item_r14["_cellProps"] == null ? null : item_r14["_cellProps"]._all == null ? null : item_r14["_cellProps"]._all.color);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", (tmp_23_0 = item_r14._selected) !== null && tmp_23_0 !== undefined ? tmp_23_0 : false)("disabled", (item_r14 == null ? null : item_r14._selectable) === false);
  }
}
function SmartTableComponent_ng_template_9_For_2_For_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SmartTableComponent_ng_template_9_For_2_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdeclareLet(0);
    i0.ɵɵtemplate(1, SmartTableComponent_ng_template_9_For_2_For_3_ng_container_1_Template, 1, 0, "ng-container", 33);
  }
  if (rf & 2) {
    const column_r17 = ctx.$implicit;
    const item_r14 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    const columnDefaultTemplate_r18 = i0.ɵɵreference(12);
    const columnKey_r19 = ctx_r3.getColumnKey(column_r17);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.templates["tableData"] || columnDefaultTemplate_r18)("ngTemplateOutletContext", i0.ɵɵpureFunction5(2, _c57, column_r17, item_r14, ctx_r3.getColumnKey(column_r17), item_r14[columnKey_r19], ctx_r3.getTableDataCellProps(column_r17, item_r14)));
  }
}
function SmartTableComponent_ng_template_9_For_2_Conditional_4_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SmartTableComponent_ng_template_9_For_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelement(1, "td", 34);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "tr", 35)(3, "td", 36);
    i0.ɵɵtemplate(4, SmartTableComponent_ng_template_9_For_2_Conditional_4_ng_container_4_Template, 1, 0, "ng-container", 33);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext();
    const item_r14 = ctx_r19.$implicit;
    const ɵ$index_84_r15 = ctx_r19.$index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("colSpan", ctx_r3.colspan)("ngStyle", i0.ɵɵpureFunction0(6, _c58));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("colSpan", ctx_r3.colspan)("ngStyle", i0.ɵɵpureFunction0(7, _c59));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.templates["tableDetails"])("ngTemplateOutletContext", i0.ɵɵpureFunction2(8, _c60, item_r14, ɵ$index_84_r15));
  }
}
function SmartTableComponent_ng_template_9_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 30);
    i0.ɵɵlistener("click", function SmartTableComponent_ng_template_9_For_2_Template_tr_click_0_listener($event) {
      const ctx_r12 = i0.ɵɵrestoreView(_r12);
      const item_r14 = ctx_r12.$implicit;
      const ɵ$index_84_r15 = ctx_r12.$index;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.handleRowClick({
        $event: $event,
        item: item_r14,
        i: ɵ$index_84_r15
      }));
    });
    i0.ɵɵtemplate(1, SmartTableComponent_ng_template_9_For_2_Conditional_1_Template, 2, 5, "td", 31);
    i0.ɵɵrepeaterCreate(2, SmartTableComponent_ng_template_9_For_2_For_3_Template, 2, 8, "ng-container", null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, SmartTableComponent_ng_template_9_For_2_Conditional_4_Template, 5, 11);
  }
  if (rf & 2) {
    let tmp_20_0;
    const item_r14 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("cAlign", item_r14._props == null ? null : item_r14._props.align)("cTableActive", (tmp_20_0 = item_r14._props == null ? null : item_r14._props.active) !== null && tmp_20_0 !== undefined ? tmp_20_0 : undefined)("cTableColor", item_r14._props == null ? null : item_r14._props.color)("ngStyle", i0.ɵɵpureFunction1(7, _c56, ctx_r3.clickableRows ? "pointer" : "auto"))("tabindex", ctx_r3.clickableRows ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.selectable ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r3.columns$());
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r3.templates["tableDetails"] ? 4 : -1);
  }
}
function SmartTableComponent_ng_template_9_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SmartTableComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody", 29);
    i0.ɵɵrepeaterCreate(1, SmartTableComponent_ng_template_9_For_2_Template, 5, 9, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵtemplate(3, SmartTableComponent_ng_template_9_ng_container_3_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_6_0;
    const ctx_r3 = i0.ɵɵnextContext();
    const noItemsDefaultTemplate_r21 = i0.ɵɵreference(14);
    i0.ɵɵproperty("cAlign", ctx_r3.tableBodyProps == null ? null : ctx_r3.tableBodyProps.align)("cHtmlAttr", (tmp_6_0 = ctx_r3.tableBodyProps == null ? null : ctx_r3.tableBodyProps.attributes) !== null && tmp_6_0 !== undefined ? tmp_6_0 : i0.ɵɵpureFunction0(4, _c3))("cTableColor", ctx_r3.tableBodyProps == null ? null : ctx_r3.tableBodyProps.color);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r3.currentItems);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", noItemsDefaultTemplate_r21);
  }
}
function SmartTableComponent_ng_template_11_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 37);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_12_0;
    let tmp_14_0;
    const ctx_r21 = i0.ɵɵnextContext();
    const cellProps_r23 = ctx_r21.cellProps;
    const column_r24 = ctx_r21.column;
    const columnName_r25 = ctx_r21.columnName;
    const item_r26 = ctx_r21.item;
    const tdContent_r27 = ctx_r21.tdContent;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("cAlign", cellProps_r23 == null ? null : cellProps_r23.align)("cHtmlAttr", (tmp_12_0 = cellProps_r23 == null ? null : cellProps_r23["_attributes"]) !== null && tmp_12_0 !== undefined ? tmp_12_0 : undefined)("cTableActive", cellProps_r23 == null ? null : cellProps_r23["active"])("cTableColor", (tmp_14_0 = (tmp_14_0 = cellProps_r23 == null ? null : cellProps_r23.color) !== null && tmp_14_0 !== undefined ? tmp_14_0 : column_r24[columnName_r25] == null ? null : column_r24[columnName_r25]._colProps == null ? null : column_r24[columnName_r25]._colProps.color) !== null && tmp_14_0 !== undefined ? tmp_14_0 : undefined)("ngClass", ctx_r3.getTableDataCellClass(column_r24, item_r26))("ngStyle", ctx_r3.getTableDataCellStyles(column_r24, item_r26));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", tdContent_r27, " ");
  }
}
function SmartTableComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SmartTableComponent_ng_template_11_Conditional_0_Template, 2, 7, "td", 37);
  }
  if (rf & 2) {
    const tdContent_r27 = ctx.tdContent;
    i0.ɵɵconditional(tdContent_r27 !== undefined ? 0 : -1);
  }
}
function SmartTableComponent_ng_template_13_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td", 38);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("colSpan", ctx_r3.colspan);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r3.noItemsLabel);
  }
}
function SmartTableComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SmartTableComponent_ng_template_13_Conditional_0_Template, 3, 2, "tr");
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵconditional(!ctx_r3.currentItems.length ? 0 : -1);
  }
}
function SmartTableComponent_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 39);
    i0.ɵɵelement(1, "polygon", 40)(2, "polygon", 41);
    i0.ɵɵelementEnd();
  }
}
const _c61 = () => ({
  outline: 0
});
function ToastHeaderComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "button", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(3, _c61));
    i0.ɵɵproperty("cToastClose", ctx_r0.toast());
  }
}
function ToasterComponent_ng_template_0_Template(rf, ctx) {}
const _c62 = [[["", 8, "chart-wrapper"]], "*"];
const _c63 = [".chart-wrapper", "*"];
function WidgetStatAComponent_Conditional_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WidgetStatAComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, WidgetStatAComponent_Conditional_3_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultWidgetValueTemplate_r2 = i0.ɵɵreference(10);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", (ctx_r0.templates == null ? null : ctx_r0.templates["widgetValueTemplate"]) || defaultWidgetValueTemplate_r2);
  }
}
function WidgetStatAComponent_Conditional_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WidgetStatAComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, WidgetStatAComponent_Conditional_4_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultWidgetTitleTemplate_r3 = i0.ɵɵreference(8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", (ctx_r0.templates == null ? null : ctx_r0.templates["widgetTitleTemplate"]) || defaultWidgetTitleTemplate_r3);
  }
}
function WidgetStatAComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WidgetStatAComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WidgetStatAComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.title(), "\n");
  }
}
function WidgetStatAComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.value(), "\n");
  }
}
function WidgetStatAComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function WidgetStatAComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
function WidgetStatBComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.value());
  }
}
function WidgetStatBComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.title());
  }
}
function WidgetStatBComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.inverse() ? "text-white text-opacity-75" : "text-body-secondary");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.text(), " ");
  }
}
function WidgetStatCComponent_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WidgetStatCComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, WidgetStatCComponent_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultWidgetIconTemplate_r2 = i0.ɵɵreference(6);
    i0.ɵɵproperty("ngClass", ctx_r0.iconClasses());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", (ctx_r0.templates == null ? null : ctx_r0.templates["widgetIconTemplate"]) || defaultWidgetIconTemplate_r2);
  }
}
function WidgetStatCComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.valueClasses());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.value(), " ");
  }
}
function WidgetStatCComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.titleClasses());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.title(), " ");
  }
}
function WidgetStatCComponent_Conditional_4_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WidgetStatCComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, WidgetStatCComponent_Conditional_4_ng_container_0_Template, 1, 0, "ng-container", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultWidgetProgressTemplate_r3 = i0.ɵɵreference(8);
    i0.ɵɵproperty("ngTemplateOutlet", (ctx_r0.templates == null ? null : ctx_r0.templates["widgetProgressTemplate"]) || defaultWidgetProgressTemplate_r3);
  }
}
function WidgetStatCComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.icon(), "\n");
  }
}
function WidgetStatCComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function WidgetStatDComponent_For_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 2);
  }
}
function WidgetStatDComponent_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, WidgetStatDComponent_For_4_Conditional_0_Template, 1, 0, "div", 2);
    i0.ɵɵelementStart(1, "c-col")(2, "div", 3);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 4);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ɵ$index_6_r2 = ctx.$index;
    i0.ɵɵconditional(ɵ$index_6_r2 % 2 !== 0 ? 0 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(item_r1.value);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r1.title);
  }
}
function WidgetStatEComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.titleClasses());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.title());
  }
}
function WidgetStatEComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.value());
  }
}
function WidgetStatFComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WidgetStatFComponent_Conditional_9_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WidgetStatFComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "c-card-footer");
    i0.ɵɵtemplate(1, WidgetStatFComponent_Conditional_9_ng_container_1_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultFooterIconTemplate_r2 = i0.ɵɵreference(13);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", (ctx_r0.templates == null ? null : ctx_r0.templates["widgetFooterTemplate"]) || defaultFooterIconTemplate_r2);
  }
}
function WidgetStatFComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.icon());
  }
}
function WidgetStatFComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.footer());
  }
}
var BreakpointInfix;
(function (BreakpointInfix) {
  BreakpointInfix["xs"] = "xs";
  BreakpointInfix["sm"] = "sm";
  BreakpointInfix["md"] = "md";
  BreakpointInfix["lg"] = "lg";
  BreakpointInfix["xl"] = "xl";
  BreakpointInfix["xxl"] = "xxl";
})(BreakpointInfix || (BreakpointInfix = {}));
class ElementRefDirective {
  constructor() {
    this.elementRef = inject(ElementRef);
  }
  static {
    this.ɵfac = function ElementRefDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ElementRefDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ElementRefDirective,
      selectors: [["", "cElementRef", ""]],
      exportAs: ["cElementRef"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ElementRefDirective, [{
    type: Directive,
    args: [{
      selector: '[cElementRef]',
      exportAs: 'cElementRef'
    }]
  }], null, null);
})();
class HtmlAttributesDirective {
  constructor() {
    this.cHtmlAttr = input();
    this.#renderer = inject(Renderer2);
    this.#elementRef = inject(ElementRef);
    this.#attrEffect = effect(() => {
      const attribs = this.cHtmlAttr();
      for (const attr in attribs) {
        if (attr === 'style' && typeof attribs[attr] === 'object') {
          this.setStyle(attribs[attr]);
        } else if (attr === 'class') {
          this.addClass(attribs[attr]);
        } else {
          this.setAttrib(attr, attribs[attr]);
        }
      }
    });
  }
  #renderer;
  #elementRef;
  #attrEffect;
  setStyle(styles) {
    for (const style in styles) {
      if (style) {
        this.#renderer.setStyle(this.#elementRef.nativeElement, style, styles[style]);
      }
    }
  }
  addClass(classes) {
    const classArray = Array.isArray(classes) ? classes : classes.split(' ');
    classArray.filter(element => element.length > 0).forEach(element => {
      this.#renderer.addClass(this.#elementRef.nativeElement, element);
    });
  }
  setAttrib(key, value) {
    value !== null ? this.#renderer.setAttribute(this.#elementRef.nativeElement, key, value) : this.#renderer.removeAttribute(this.#elementRef.nativeElement, key);
  }
  static {
    this.ɵfac = function HtmlAttributesDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HtmlAttributesDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: HtmlAttributesDirective,
      selectors: [["", "cHtmlAttr", ""]],
      inputs: {
        cHtmlAttr: [1, "cHtmlAttr"]
      },
      exportAs: ["cHtmlAttr"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HtmlAttributesDirective, [{
    type: Directive,
    args: [{
      selector: '[cHtmlAttr]',
      exportAs: 'cHtmlAttr'
    }]
  }], null, null);
})();
class TemplateIdDirective {
  constructor() {
    this.templateRef = inject(TemplateRef);
    this.cTemplateId = input.required();
  }
  get id() {
    return this.cTemplateId();
  }
  static {
    this.ɵfac = function TemplateIdDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TemplateIdDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: TemplateIdDirective,
      selectors: [["", "cTemplateId", ""]],
      inputs: {
        cTemplateId: [1, "cTemplateId"]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TemplateIdDirective, [{
    type: Directive,
    args: [{
      selector: '[cTemplateId]'
    }]
  }], null, null);
})();
class ThemeDirective {
  constructor() {
    this.#hostElement = inject(ElementRef);
    this.#renderer = inject(Renderer2);
    /**
     * Add dark theme attribute.
     * @return 'dark' | 'light' | undefined
     */
    this.colorScheme = input();
    this.#colorSchemeChange = effect(() => {
      const colorScheme = this.colorScheme();
      colorScheme ? this.setTheme(colorScheme) : this.unsetTheme();
    });
    this.dark = input(false, {
      transform: booleanAttribute
    });
    this.#darkChange = effect(() => {
      const darkTheme = this.dark() || untracked(this.colorScheme) === 'dark';
      darkTheme ? this.setTheme('dark') : this.unsetTheme();
    });
  }
  #hostElement;
  #renderer;
  #colorSchemeChange;
  #darkChange;
  setTheme(theme) {
    if (theme) {
      this.#renderer.setAttribute(this.#hostElement.nativeElement, 'data-coreui-theme', theme);
    }
  }
  unsetTheme() {
    this.#renderer.removeAttribute(this.#hostElement.nativeElement, 'data-coreui-theme');
  }
  static {
    this.ɵfac = function ThemeDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ThemeDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ThemeDirective,
      selectors: [["", "cTheme", ""]],
      inputs: {
        colorScheme: [1, "colorScheme"],
        dark: [1, "dark"]
      },
      exportAs: ["cTheme"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ThemeDirective, [{
    type: Directive,
    args: [{
      selector: '[cTheme]',
      exportAs: 'cTheme'
    }]
  }], null, null);
})();
class SharedModule {
  static forRoot() {
    return {
      ngModule: SharedModule
    };
  }
  static {
    this.ɵfac = function SharedModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SharedModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SharedModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SharedModule, [{
    type: NgModule,
    args: [{
      imports: [ElementRefDirective, HtmlAttributesDirective, TemplateIdDirective, ThemeDirective],
      exports: [ElementRefDirective, HtmlAttributesDirective, TemplateIdDirective, ThemeDirective]
    }]
  }], null, null);
})();
class AccordionButtonDirective {
  constructor() {
    /**
     * Toggles an accordion button collapsed state. Use in accordionHeaderTemplate. [docs]
     * @type boolean
     */
    this.collapsed = input(undefined);
    /**
     * Default type for cAccordionButton. [docs]
     * @type string
     * @default 'button'
     */
    this.type = input('button');
    this.hostClasses = computed(() => {
      return {
        'accordion-button': true,
        collapsed: this.collapsed()
      };
    });
    this.ariaExpanded = computed(() => !this.collapsed());
  }
  static {
    this.ɵfac = function AccordionButtonDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AccordionButtonDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: AccordionButtonDirective,
      selectors: [["", "cAccordionButton", ""]],
      hostVars: 4,
      hostBindings: function AccordionButtonDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("type", ctx.type())("aria-expanded", ctx.ariaExpanded());
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        collapsed: [1, "collapsed"],
        type: [1, "type"]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccordionButtonDirective, [{
    type: Directive,
    args: [{
      selector: '[cAccordionButton]',
      host: {
        '[class]': 'hostClasses()',
        '[attr.type]': 'type()',
        '[attr.aria-expanded]': 'ariaExpanded()'
      }
    }]
  }], null, null);
})();
class AccordionService {
  constructor() {
    this.items = [];
    this.alwaysOpen = false;
  }
  addItem(item) {
    this.items.push(item);
  }
  removeItem(item) {
    const index = this.items.indexOf(item);
    if (index !== -1) {
      this.items.splice(index, 1);
    }
  }
  toggleItem(item) {
    item.itemVisible.update(value => !value);
    this.closeOtherItems(item);
  }
  closeOtherItems(openItem) {
    if (!this.alwaysOpen) {
      this.items.forEach(item => {
        if (item !== openItem) {
          item.itemVisible.set(false);
        }
      });
    }
  }
  static {
    this.ɵfac = function AccordionService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AccordionService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AccordionService,
      factory: AccordionService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccordionService, [{
    type: Injectable
  }], null, null);
})();
class AccordionComponent {
  constructor() {
    this.#accordionService = inject(AccordionService);
    /**
     * Removes the default background-color, some borders, and some rounded corners to render accordions edge-to-edge with their parent container.
     * @type boolean
     */
    this.flush = input(false, {
      transform: booleanAttribute
    });
    /**
     * Make accordion items stay open when another item is opened
     * @type boolean
     */
    this.alwaysOpen = input(false, {
      transform: booleanAttribute
    });
    this.#alwaysOpenEffect = effect(() => {
      this.#accordionService.alwaysOpen = this.alwaysOpen();
    });
    this.hostClasses = computed(() => ({
      accordion: true,
      'accordion-flush': this.flush()
    }));
  }
  #accordionService;
  #alwaysOpenEffect;
  static {
    this.ɵfac = function AccordionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AccordionComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AccordionComponent,
      selectors: [["c-accordion"]],
      hostVars: 2,
      hostBindings: function AccordionComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        flush: [1, "flush"],
        alwaysOpen: [1, "alwaysOpen"]
      },
      exportAs: ["cAccordionItem"],
      features: [i0.ɵɵProvidersFeature([AccordionService])],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function AccordionComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccordionComponent, [{
    type: Component,
    args: [{
      selector: 'c-accordion',
      template: '<ng-content />',
      exportAs: 'cAccordionItem',
      providers: [AccordionService],
      host: {
        '[class]': 'hostClasses()'
      },
      styles: [":host{display:block}\n"]
    }]
  }], null, null);
})();
const expandAnimation = animation([animate('{{ time }} {{ easing }}')]);
const collapseAnimation = animation([style({
  height: '*',
  minHeight: '*'
}), animate('{{ time }} {{ easing }}', style({
  height: 0,
  minHeight: 0
}))]);
const expandHorizontalAnimation = animation([animate('{{ time }} {{ easing }}')]);
const collapseHorizontalAnimation = animation([animate('{{ time }} {{ easing }}')]);
class CollapseDirective {
  #hostElement;
  #renderer;
  #animationBuilder;
  #player;
  constructor() {
    this.#hostElement = inject(ElementRef);
    this.#renderer = inject(Renderer2);
    this.#animationBuilder = inject(AnimationBuilder);
    this.#player = undefined;
    /**
     * @ignore
     */
    this.animateInput = input(true, {
      transform: booleanAttribute,
      alias: 'animate'
    });
    this.animate = linkedSignal({
      source: this.animateInput,
      computation: value => value
    });
    /**
     * Set horizontal collapsing to transition the width instead of height.
     * @type boolean
     * @default false
     */
    this.horizontal = input(false, {
      transform: booleanAttribute
    });
    /**
     * Toggle the visibility of collapsible element.
     * @type boolean
     * @default false
     */
    this.visibleInput = input(false, {
      transform: booleanAttribute,
      alias: 'visible'
    });
    this.visibleChange = output();
    this.visible = linkedSignal({
      source: this.visibleInput,
      computation: value => value
    });
    this.#initialized = signal(false);
    this.#visibleEffect = effect(() => {
      const visible = this.visible();
      if (this.#initialized()) {
        this.createPlayer(visible);
      }
    });
    /**
     * Add `navbar` prop for grouping and hiding navbar contents by a parent breakpoint.
     * @type boolean
     * @default false
     */
    this.navbar = input(false, {
      transform: booleanAttribute
    });
    /**
     * @ignore
     */
    this.duration = input('350ms');
    /**
     * @ignore
     */
    this.transition = input('ease');
    /**
     * Event emitted on visibility change. [docs]
     * @type string
     */
    this.collapseChange = output();
    this.hostClasses = computed(() => {
      return {
        'navbar-collapse': this.navbar(),
        'collapse-horizontal': this.horizontal()
      };
    });
    afterNextRender({
      read: () => {
        this.#initialized.set(true);
      }
    });
  }
  #initialized;
  #visibleEffect;
  ngOnDestroy() {
    this.destroyPlayer();
  }
  toggle(visible = !this.visible()) {
    this.visible.set(visible);
  }
  destroyPlayer() {
    this.#player?.destroy();
    this.#player = undefined;
  }
  createPlayer(visible = this.visible()) {
    if (this.#player?.hasStarted()) {
      this.destroyPlayer();
    }
    const host = this.#hostElement.nativeElement;
    if (visible) {
      this.#renderer.removeStyle(host, 'display');
    }
    const duration = this.animate() ? this.duration() : '0ms';
    const expand = this.horizontal() ? expandHorizontalAnimation : expandAnimation;
    const collapse = this.horizontal() ? collapseHorizontalAnimation : collapseAnimation;
    const dimension = this.horizontal() ? 'width' : 'height';
    const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
    const scrollSize = `scroll${capitalizedDimension}`;
    const animationFactory = this.#animationBuilder?.build(useAnimation(visible ? expand : collapse, {
      params: {
        time: duration,
        easing: this.transition()
      }
    }));
    this.#player = animationFactory.create(host);
    !visible && host.offsetHeight && host.style[dimension] && host.scrollHeight;
    this.#renderer.setStyle(host, dimension, visible ? 0 : `${host.getBoundingClientRect()[dimension]}px`);
    this.#player.onStart(() => {
      this.setMaxSize();
      this.#renderer.removeClass(host, 'collapse');
      this.#renderer.addClass(host, 'collapsing');
      this.#renderer.removeClass(host, 'show');
      this.#renderer.setStyle(host, dimension, visible ? `${host[scrollSize]}px` : '');
      this.collapseChange?.emit(visible ? 'opening' : 'collapsing');
    });
    this.#player.onDone(() => {
      this.#renderer.removeClass(host, 'collapsing');
      this.#renderer.addClass(host, 'collapse');
      if (visible) {
        this.#renderer.addClass(host, 'show');
        this.#renderer.setStyle(host, dimension, '');
      } else {
        this.#renderer.removeClass(host, 'show');
      }
      this.collapseChange?.emit(visible ? 'open' : 'collapsed');
      this.destroyPlayer();
      this.visibleChange.emit(visible);
    });
    this.#player?.play();
  }
  setMaxSize() {
    const host = this.#hostElement.nativeElement;
    if (this.horizontal()) {
      host.scrollWidth > 0 && this.#renderer.setStyle(host, 'maxWidth', `${host.scrollWidth}px`);
      // } else {
      //   host.scrollHeight > 0 && this.#renderer.setStyle(host, 'maxHeight', `${host.scrollHeight}px`);
    }
  }
  static {
    this.ɵfac = function CollapseDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CollapseDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: CollapseDirective,
      selectors: [["", "cCollapse", ""]],
      hostVars: 5,
      hostBindings: function CollapseDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵstyleMap(i0.ɵɵpureFunction0(4, _c1));
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        animateInput: [1, "animate", "animateInput"],
        horizontal: [1, "horizontal"],
        visibleInput: [1, "visible", "visibleInput"],
        navbar: [1, "navbar"],
        duration: [1, "duration"],
        transition: [1, "transition"]
      },
      outputs: {
        visibleChange: "visibleChange",
        collapseChange: "collapseChange"
      },
      exportAs: ["cCollapse"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CollapseDirective, [{
    type: Directive,
    args: [{
      selector: '[cCollapse]',
      exportAs: 'cCollapse',
      host: {
        '[class]': 'hostClasses()',
        '[style]': '{ display: "none" }'
      }
    }]
  }], () => [], null);
})();
class CollapseModule {
  static forRoot() {
    return {
      ngModule: CollapseModule,
      providers: []
    };
  }
  static {
    this.ɵfac = function CollapseModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CollapseModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CollapseModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CollapseModule, [{
    type: NgModule,
    args: [{
      exports: [CollapseDirective],
      imports: [CollapseDirective]
    }]
  }], null, null);
})();
let nextId$2 = 0;
class AccordionItemComponent {
  constructor() {
    this.#accordionService = inject(AccordionService);
    /**
     * Toggle an accordion item programmatically
     * @return boolean
     * @default false
     */
    // eslint-disable-next-line @angular-eslint/no-input-rename
    this.visibleInput = input(false, {
      transform: booleanAttribute,
      alias: 'visible'
    });
    this.itemVisible = signal(false);
    this.#visibleInputChange = effect(() => {
      this.visible = this.visibleInput();
    });
    this.contentId = `accordion-item-${nextId$2++}`;
    this.contentTemplates = contentChildren(TemplateIdDirective, {
      descendants: true
    });
    this.templates = computed(() => {
      return this.contentTemplates().reduce((acc, child) => {
        acc[child.id] = child.templateRef;
        return acc;
      }, {});
    });
  }
  #accordionService;
  #visibleInputChange;
  set visible(value) {
    this.itemVisible.set(value);
  }
  get visible() {
    return this.itemVisible();
  }
  get itemContext() {
    return {
      $implicit: this.itemVisible()
    };
  }
  ngOnInit() {
    this.#accordionService.addItem(this);
  }
  ngOnDestroy() {
    this.#accordionService.removeItem(this);
  }
  toggleItem() {
    this.#accordionService.toggleItem(this);
  }
  static {
    this.ɵfac = function AccordionItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AccordionItemComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AccordionItemComponent,
      selectors: [["c-accordion-item"]],
      contentQueries: function AccordionItemComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.contentTemplates, TemplateIdDirective, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      hostAttrs: [1, "accordion-item"],
      inputs: {
        visibleInput: [1, "visible", "visibleInput"]
      },
      exportAs: ["cAccordionItem"],
      ngContentSelectors: _c2,
      decls: 14,
      vars: 8,
      consts: [["defaultAccordionHeaderTemplate", ""], ["defaultAccordionHeaderContentTemplate", ""], ["defaultAccordionBodyTemplate", ""], ["defaultAccordionBodyContentTemplate", ""], [1, "accordion-header"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["cCollapse", "", 1, "accordion-collapse", 3, "visible", "id"], ["cAccordionButton", "", 3, "click", "collapsed"], [1, "accordion-body"]],
      template: function AccordionItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c2);
          i0.ɵɵdeclareLet(0);
          i0.ɵɵelementContainerStart(1);
          i0.ɵɵelementStart(2, "div", 4);
          i0.ɵɵtemplate(3, AccordionItemComponent_ng_container_3_Template, 1, 0, "ng-container", 5);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "div", 6);
          i0.ɵɵtemplate(5, AccordionItemComponent_ng_container_5_Template, 1, 0, "ng-container", 5);
          i0.ɵɵelementEnd();
          i0.ɵɵelementContainerEnd();
          i0.ɵɵtemplate(6, AccordionItemComponent_ng_template_6_Template, 2, 4, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(8, AccordionItemComponent_ng_template_8_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(10, AccordionItemComponent_ng_template_10_Template, 2, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(12, AccordionItemComponent_ng_template_12_Template, 1, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const defaultAccordionHeaderTemplate_r6 = i0.ɵɵreference(7);
          const defaultAccordionBodyTemplate_r7 = i0.ɵɵreference(11);
          const tmpl_r8 = i0.ɵɵstoreLet(ctx.templates());
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngTemplateOutlet", tmpl_r8["accordionHeaderTemplate"] || defaultAccordionHeaderTemplate_r6)("ngTemplateOutletContext", ctx.itemContext);
          i0.ɵɵadvance();
          i0.ɵɵproperty("visible", ctx.itemVisible())("id", ctx.contentId);
          i0.ɵɵattribute("aria-expanded", ctx.itemVisible());
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngTemplateOutlet", tmpl_r8["accordionBodyTemplate"] || defaultAccordionBodyTemplate_r7)("ngTemplateOutletContext", ctx.itemContext);
        }
      },
      dependencies: [AccordionButtonDirective, NgTemplateOutlet, CollapseDirective],
      styles: ["[_nghost-%COMP%]{display:block;overflow:hidden}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccordionItemComponent, [{
    type: Component,
    args: [{
      selector: 'c-accordion-item',
      exportAs: 'cAccordionItem',
      imports: [AccordionButtonDirective, NgTemplateOutlet, CollapseDirective],
      host: {
        class: 'accordion-item'
      },
      template: "@let tmpl = templates();\n<ng-container>\n  <div class=\"accordion-header\">\n    <ng-container *ngTemplateOutlet=\"tmpl['accordionHeaderTemplate'] || defaultAccordionHeaderTemplate; context: itemContext\" />\n  </div>\n  <div class=\"accordion-collapse\" cCollapse [visible]=\"itemVisible()\" [attr.aria-expanded]=\"itemVisible()\" [id]=\"contentId\">\n    <ng-container *ngTemplateOutlet=\"tmpl['accordionBodyTemplate'] || defaultAccordionBodyTemplate; context: itemContext\" />\n  </div>\n</ng-container>\n\n<ng-template #defaultAccordionHeaderTemplate>\n  <button cAccordionButton [collapsed]=\"!itemVisible()\" [attr.aria-controls]=\"contentId\" (click)=\"toggleItem()\">\n    <ng-container\n      *ngTemplateOutlet=\"tmpl['accordionHeader'] || defaultAccordionHeaderContentTemplate; context: itemContext\">\n    </ng-container>\n  </button>\n</ng-template>\n\n<ng-template #defaultAccordionHeaderContentTemplate>\n  <ng-content />\n</ng-template>\n\n<ng-template #defaultAccordionBodyTemplate>\n  <div class=\"accordion-body\">\n    <ng-container\n      *ngTemplateOutlet=\"tmpl['accordionBody'] || defaultAccordionBodyContentTemplate; context: itemContext\">\n    </ng-container>\n  </div>\n</ng-template>\n\n<ng-template #defaultAccordionBodyContentTemplate>\n  <ng-content />\n</ng-template>\n",
      styles: [":host{display:block;overflow:hidden}\n"]
    }]
  }], null, null);
})();
class AccordionModule {
  static {
    this.ɵfac = function AccordionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AccordionModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: AccordionModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [AccordionService]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccordionModule, [{
    type: NgModule,
    args: [{
      imports: [AccordionButtonDirective, AccordionComponent, AccordionItemComponent],
      exports: [AccordionComponent, AccordionButtonDirective, AccordionItemComponent],
      providers: [AccordionService]
    }]
  }], null, null);
})();
class AlertHeadingDirective {
  static {
    this.ɵfac = function AlertHeadingDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AlertHeadingDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: AlertHeadingDirective,
      selectors: [["", "cAlertHeading", ""]],
      hostAttrs: [1, "alert-heading"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AlertHeadingDirective, [{
    type: Directive,
    args: [{
      selector: '[cAlertHeading]',
      host: {
        class: 'alert-heading'
      }
    }]
  }], null, null);
})();
class AlertLinkDirective {
  static {
    this.ɵfac = function AlertLinkDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AlertLinkDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: AlertLinkDirective,
      selectors: [["", "cAlertLink", ""]],
      hostAttrs: [1, "alert-link"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AlertLinkDirective, [{
    type: Directive,
    args: [{
      selector: '[cAlertLink]',
      host: {
        class: 'alert-link'
      }
    }]
  }], null, null);
})();
class ButtonDirective {
  constructor() {
    /**
     * Toggle the active state for the component. [docs]
     * @type InputSignalWithTransform<boolean, unknown>
     */
    this.active = input(false, {
      transform: booleanAttribute
    });
    /**
     * Sets the color context of the component to one of CoreUI’s themed colors. [docs]
     * @type InputSignal<Colors>
     */
    this.color = input('primary');
    /**
     * Toggle the disabled state for the component.
     * @type InputSignalWithTransform<boolean, unknown>
     */
    this.disabled = input(false, {
      transform: booleanAttribute
    });
    /**
     * Select the shape of the component.
     * @type InputSignal<Shapes>
     */
    this.shape = input();
    /**
     * Size the component small or large.
     * @type InputSignal<'sm' | 'lg' | ''>
     */
    this.size = input('');
    /**
     * Specifies the type of button. Always specify the type attribute for the `<button>` element.
     * Different browsers may use different default types for the `<button>` element.
     * @type InputSignal<ButtonType>
     * @default 'button'
     */
    this.type = input('button');
    /**
     * Set the button variant to an outlined button or a ghost button.
     * @type InputSignal<'ghost' | 'outline' | undefined>
     */
    this.variant = input();
    this.hostClasses = computed(() => {
      return {
        btn: true,
        [`btn-${this.color()}`]: !!this.color() && !this.variant(),
        [`btn-${this.variant()}`]: !!this.variant() && !this.color(),
        [`btn-${this.variant()}-${this.color()}`]: !!this.variant() && !!this.color(),
        [`btn-${this.size()}`]: !!this.size(),
        [`${this.shape()}`]: !!this.shape(),
        active: this.active(),
        disabled: this._disabled()
      };
    });
    this._disabled = computed(() => this.disabled());
    this.ariaDisabled = computed(() => {
      return this._disabled() ? true : null;
    });
    this.attrDisabled = computed(() => {
      return this._disabled() ? '' : null;
    });
    this.tabIndex = computed(() => {
      return this._disabled() ? '-1' : null;
    });
    this.isActive = computed(() => {
      return this.active() || null;
    });
  }
  static {
    this.ɵfac = function ButtonDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ButtonDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ButtonDirective,
      selectors: [["", "cButton", ""]],
      hostAttrs: [1, "btn"],
      hostVars: 7,
      hostBindings: function ButtonDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("aria-disabled", ctx.ariaDisabled())("aria-pressed", ctx.isActive())("disabled", ctx.attrDisabled())("tabindex", ctx.tabIndex())("type", ctx.type());
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        active: [1, "active"],
        color: [1, "color"],
        disabled: [1, "disabled"],
        shape: [1, "shape"],
        size: [1, "size"],
        type: [1, "type"],
        variant: [1, "variant"]
      },
      exportAs: ["cButton"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonDirective, [{
    type: Directive,
    args: [{
      selector: '[cButton]',
      exportAs: 'cButton',
      host: {
        class: 'btn',
        '[class]': 'hostClasses()',
        '[attr.aria-disabled]': 'ariaDisabled()',
        '[attr.aria-pressed]': 'isActive()',
        '[attr.disabled]': 'attrDisabled()',
        '[attr.tabindex]': 'tabIndex()',
        '[attr.type]': 'type()'
      }
    }]
  }], null, null);
})();
class ButtonCloseDirective extends ButtonDirective {
  constructor() {
    super(...arguments);
    /**
     * Change the default color to white.
     * @type boolean
     * @deprecated 5.0.0. Use `cButtonClose.dark` instead.
     */
    this.white = input(false, {
      transform: booleanAttribute
    });
    this.hostClasses = computed(() => {
      return {
        btn: true,
        'btn-close': true,
        'btn-close-white': this.white(),
        [`btn-${this.size()}`]: !!this.size(),
        active: this.active(),
        disabled: this._disabled()
      };
    });
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵButtonCloseDirective_BaseFactory;
      return function ButtonCloseDirective_Factory(__ngFactoryType__) {
        return (ɵButtonCloseDirective_BaseFactory || (ɵButtonCloseDirective_BaseFactory = i0.ɵɵgetInheritedFactory(ButtonCloseDirective)))(__ngFactoryType__ || ButtonCloseDirective);
      };
    })();
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ButtonCloseDirective,
      selectors: [["", "cButtonClose", ""]],
      hostAttrs: [1, "btn", "btn-close"],
      hostVars: 7,
      hostBindings: function ButtonCloseDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("aria-disabled", ctx.ariaDisabled())("aria-pressed", ctx.isActive())("disabled", ctx.attrDisabled())("tabindex", ctx.tabIndex())("type", ctx.type());
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        white: [1, "white"]
      },
      features: [i0.ɵɵHostDirectivesFeature([{
        directive: ThemeDirective,
        inputs: ["dark", "dark"]
      }]), i0.ɵɵInheritDefinitionFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonCloseDirective, [{
    type: Directive,
    args: [{
      selector: '[cButtonClose]',
      hostDirectives: [{
        directive: ThemeDirective,
        inputs: ['dark']
      }],
      host: {
        class: 'btn btn-close',
        '[class]': 'hostClasses()',
        '[attr.aria-disabled]': 'ariaDisabled()',
        '[attr.aria-pressed]': 'isActive()',
        '[attr.disabled]': 'attrDisabled()',
        '[attr.tabindex]': 'tabIndex()',
        '[attr.type]': 'type()'
      }
    }]
  }], null, null);
})();
class ButtonModule {
  static {
    this.ɵfac = function ButtonModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ButtonModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ButtonModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonModule, [{
    type: NgModule,
    args: [{
      imports: [ButtonDirective, ButtonCloseDirective],
      exports: [ButtonDirective, ButtonCloseDirective]
    }]
  }], null, null);
})();
class AlertComponent {
  constructor() {
    /**
     * Sets the color context of the component to one of CoreUI’s themed colors.
     * @return Colors
     * @default 'primary'
     */
    this.color = input('primary');
    /**
     * Default role for alert. [docs]
     * @return string
     * @default 'alert'
     */
    this.role = input('alert');
    /**
     * Set the alert variant to a solid.
     * @return string
     */
    this.variant = input();
    /**
     * Optionally adds a close button to alert and allow it to self dismiss.
     * @return boolean
     * @default false
     */
    this.dismissibleInput = input(false, {
      transform: booleanAttribute,
      alias: 'dismissible'
    });
    this.#dismissible = linkedSignal({
      source: this.dismissibleInput,
      computation: value => {
        return value;
      }
    });
    /**
     * Adds animation for dismissible alert.
     * @return boolean
     */
    this.fade = input(false, {
      transform: booleanAttribute
    });
    /**
     * Toggle the visibility of alert component.
     * @return boolean
     */
    this.visibleInput = input(true, {
      transform: booleanAttribute,
      alias: 'visible'
    });
    this.#visible = linkedSignal({
      source: this.visibleInput,
      computation: value => {
        return value;
      }
    });
    this.hide = signal(false);
    /**
     * Event triggered on the alert dismiss.
     */
    this.visibleChange = output();
    this.contentTemplates = contentChildren(TemplateIdDirective, {
      descendants: true
    });
    this.templates = computed(() => {
      return this.contentTemplates().reduce((acc, child) => {
        acc[child.id] = child.templateRef;
        return acc;
      }, {});
    });
    this.hostClasses = computed(() => {
      const color = this.color();
      const variant = this.variant();
      return {
        alert: true,
        'alert-dismissible': this.dismissible,
        fade: this.fade(),
        show: !this.hide(),
        [`alert-${color}`]: !!color && variant !== 'solid',
        [`bg-${color}`]: !!color && variant === 'solid',
        'text-white': !!color && variant === 'solid'
      };
    });
  }
  #dismissible;
  set dismissible(value) {
    this.#dismissible.set(value);
  }
  get dismissible() {
    return this.#dismissible();
  }
  #visible;
  set visible(value) {
    if (this.#visible() !== value) {
      this.#visible.set(value);
      this.visibleChange.emit(value);
    }
  }
  get visible() {
    return this.#visible();
  }
  get animateType() {
    return this.visible ? 'show' : 'hide';
  }
  onAnimationStart($event) {
    this.onAnimationEvent($event);
  }
  onAnimationDone($event) {
    this.onAnimationEvent($event);
  }
  onAnimationEvent(event) {
    this.hide.set(event.phaseName === 'start' && event.toState === 'show');
    if (event.phaseName === 'done') {
      this.hide.set(event.toState === 'hide' || event.toState === 'void');
      if (event.toState === 'show') {
        this.hide.set(false);
      }
    }
  }
  static {
    this.ɵfac = function AlertComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AlertComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AlertComponent,
      selectors: [["c-alert"]],
      contentQueries: function AlertComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.contentTemplates, TemplateIdDirective, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      hostVars: 5,
      hostBindings: function AlertComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵsyntheticHostListener("@fadeInOut.start", function AlertComponent_animation_fadeInOut_start_HostBindingHandler($event) {
            return ctx.onAnimationStart($event);
          })("@fadeInOut.done", function AlertComponent_animation_fadeInOut_done_HostBindingHandler($event) {
            return ctx.onAnimationDone($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵsyntheticHostProperty("@.disabled", !ctx.fade())("@fadeInOut", ctx.animateType);
          i0.ɵɵattribute("role", ctx.role());
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        color: [1, "color"],
        role: [1, "role"],
        variant: [1, "variant"],
        dismissibleInput: [1, "dismissible", "dismissibleInput"],
        fade: [1, "fade"],
        visibleInput: [1, "visible", "visibleInput"]
      },
      outputs: {
        visibleChange: "visibleChange"
      },
      exportAs: ["cAlert"],
      ngContentSelectors: _c0,
      decls: 3,
      vars: 1,
      consts: [["defaultAlertButtonCloseTemplate", ""], [4, "ngTemplateOutlet"], ["aria-label", "Close", "cButtonClose", "", 3, "click"]],
      template: function AlertComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, AlertComponent_Conditional_0_Template, 2, 1)(1, AlertComponent_ng_template_1_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.visible || !ctx.hide() ? 0 : -1);
        }
      },
      dependencies: [NgTemplateOutlet, ButtonCloseDirective],
      styles: ["[_nghost-%COMP%]{display:block;overflow:hidden}"],
      data: {
        animation: [trigger('fadeInOut', [state('show', style({
          opacity: 1,
          height: '*',
          padding: '*',
          border: '*',
          margin: '*'
        })), state('hide', style({
          opacity: 0,
          height: 0,
          padding: 0,
          border: 0,
          margin: 0
        })), state('void', style({
          opacity: 0,
          height: 0,
          padding: 0,
          border: 0,
          margin: 0
        })), transition('show => hide', [animate('.3s ease-out')]), transition('hide => show', [animate('.3s ease-in')]), transition('show => void', [animate('.3s ease-out')]), transition('void => show', [animate('.3s ease-in')])])]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AlertComponent, [{
    type: Component,
    args: [{
      selector: 'c-alert',
      exportAs: 'cAlert',
      imports: [NgTemplateOutlet, ButtonCloseDirective],
      animations: [trigger('fadeInOut', [state('show', style({
        opacity: 1,
        height: '*',
        padding: '*',
        border: '*',
        margin: '*'
      })), state('hide', style({
        opacity: 0,
        height: 0,
        padding: 0,
        border: 0,
        margin: 0
      })), state('void', style({
        opacity: 0,
        height: 0,
        padding: 0,
        border: 0,
        margin: 0
      })), transition('show => hide', [animate('.3s ease-out')]), transition('hide => show', [animate('.3s ease-in')]), transition('show => void', [animate('.3s ease-out')]), transition('void => show', [animate('.3s ease-in')])])],
      host: {
        '[@.disabled]': '!fade()',
        '[@fadeInOut]': 'animateType',
        '[attr.role]': 'role()',
        '[class]': 'hostClasses()',
        '(@fadeInOut.start)': 'onAnimationStart($event)',
        '(@fadeInOut.done)': 'onAnimationDone($event)'
      },
      template: "@if (visible || !hide()) {\n  @if (dismissible) {\n    <ng-container *ngTemplateOutlet=\"templates()?.['alertButtonCloseTemplate'] || defaultAlertButtonCloseTemplate\" />\n  }\n  <ng-content />\n}\n<ng-template #defaultAlertButtonCloseTemplate>\n  <button (click)=\"visible=false\" aria-label=\"Close\" cButtonClose></button>\n</ng-template>\n",
      styles: [":host{display:block;overflow:hidden}\n"]
    }]
  }], null, null);
})();
class AlertModule {
  static {
    this.ɵfac = function AlertModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AlertModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: AlertModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AlertModule, [{
    type: NgModule,
    args: [{
      imports: [AlertComponent, AlertHeadingDirective, AlertLinkDirective],
      exports: [AlertComponent, AlertHeadingDirective, AlertLinkDirective]
    }]
  }], null, null);
})();
class AlignDirective {
  constructor() {
    /**
     * Set vertical alignment of inline, inline-block, inline-table, and table cell elements
     * @return Alignment
     */
    this.align = input(undefined, {
      alias: 'cAlign'
    });
    this.hostClasses = computed(() => {
      const align = this.align();
      return {
        [`align-${align}`]: !!align
      };
    });
  }
  static {
    this.ɵfac = function AlignDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AlignDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: AlignDirective,
      selectors: [["", "cAlign", ""]],
      hostVars: 2,
      hostBindings: function AlignDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        align: [1, "cAlign", "align"]
      },
      exportAs: ["cAlign"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AlignDirective, [{
    type: Directive,
    args: [{
      selector: '[cAlign]',
      exportAs: 'cAlign',
      host: {
        '[class]': 'hostClasses()'
      }
    }]
  }], null, null);
})();
class BgColorDirective {
  constructor() {
    /**
     * Set the background of an element to any contextual class
     */
    this.cBgColor = input('');
    /**
     * Add linear gradient as background image to the backgrounds.
     * @return boolean
     */
    this.gradient = input();
    this.hostClasses = computed(() => {
      const color = this.cBgColor();
      return {
        [`bg-${color}`]: !!color,
        'bg-gradient': this.gradient()
      };
    });
  }
  static {
    this.ɵfac = function BgColorDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BgColorDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: BgColorDirective,
      selectors: [["", "cBgColor", ""]],
      hostVars: 2,
      hostBindings: function BgColorDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        cBgColor: [1, "cBgColor"],
        gradient: [1, "gradient"]
      },
      exportAs: ["cBgColor"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BgColorDirective, [{
    type: Directive,
    args: [{
      selector: '[cBgColor]',
      exportAs: 'cBgColor',
      host: {
        '[class]': 'hostClasses()'
      }
    }]
  }], null, null);
})();
class BorderDirective {
  constructor() {
    /**
     * Add or remove an element’s borders
     * @return Border
     */
    this.cBorder = input(true);
    this.hostClasses = computed(() => {
      const border = this.cBorder();
      if (typeof border === 'boolean') {
        return {
          border: border
        };
      }
      if (typeof border === 'number' || typeof border === 'string') {
        return {
          border: true,
          [`border-${border}`]: true
        };
      }
      if (typeof border === 'object') {
        const borderObj = {
          top: undefined,
          end: undefined,
          bottom: undefined,
          start: undefined,
          color: undefined,
          ...border
        };
        // @ts-ignore
        const keys = Object.keys(borderObj).filter(key => borderObj[key] !== undefined);
        const classes = {};
        keys.forEach(key => {
          // @ts-ignore
          const val = borderObj[key];
          if (typeof val === 'boolean') {
            // @ts-ignore
            classes[`border-${key}`] = true;
          } else if (typeof val === 'number' || typeof val === 'string') {
            // @ts-ignore
            classes[`border-${key}-${val}`] = true;
          } else if (typeof val === 'object') {
            if ('color' in val) {
              // @ts-ignore
              classes[`border-${key}-${val.color}`] = true;
            }
            if ('width' in val) {
              // @ts-ignore
              classes[`border-${key}-${val.width}`] = true;
            }
          }
        });
        return Object.entries(classes).length === 0 ? {
          border: false
        } : classes;
      }
      return {
        border: false
      };
    });
  }
  static {
    this.ɵfac = function BorderDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BorderDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: BorderDirective,
      selectors: [["", "cBorder", ""]],
      hostVars: 2,
      hostBindings: function BorderDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        cBorder: [1, "cBorder"]
      },
      exportAs: ["cBorder"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BorderDirective, [{
    type: Directive,
    args: [{
      selector: '[cBorder]',
      exportAs: 'cBorder',
      host: {
        '[class]': 'hostClasses()'
      }
    }]
  }], null, null);
})();
class RoundedDirective {
  constructor() {
    /**
     * Set border radius variant and radius size
     * @type Rounded
     */
    this.cRounded = input(true);
    this.hostClasses = computed(() => {
      const rounded = this.cRounded();
      if (typeof rounded === 'boolean') {
        return {
          rounded: rounded
        };
      }
      if (typeof rounded === 'number' || typeof rounded === 'string') {
        return {
          [`rounded-${rounded}`]: true
        };
      }
      if (typeof rounded === 'object') {
        const roundedObj = {
          top: undefined,
          end: undefined,
          bottom: undefined,
          start: undefined,
          circle: undefined,
          pill: undefined,
          size: undefined,
          ...rounded
        };
        // @ts-ignore
        const keys = Object.keys(roundedObj).filter(key => roundedObj[key] !== undefined);
        const classes = {};
        keys.forEach(key => {
          // @ts-ignore
          const val = roundedObj[key];
          if (typeof val === 'boolean') {
            // @ts-ignore
            classes[`rounded-${key}`] = val;
          } else {
            // @ts-ignore
            classes[`rounded-${val}`] = true;
          }
        });
        // console.log('rounded keys', keys, classes);
        return Object.entries(classes).length === 0 ? {
          rounded: false
        } : classes;
      }
      return {
        rounded: false
      };
    });
  }
  static {
    this.ɵfac = function RoundedDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RoundedDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: RoundedDirective,
      selectors: [["", "cRounded", ""]],
      hostVars: 2,
      hostBindings: function RoundedDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        cRounded: [1, "cRounded"]
      },
      exportAs: ["cRounded"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RoundedDirective, [{
    type: Directive,
    args: [{
      selector: '[cRounded]',
      exportAs: 'cRounded',
      host: {
        '[class]': 'hostClasses()'
      }
    }]
  }], null, null);
})();
class ShadowOnScrollDirective {
  #destroyRef;
  #document;
  #elementRef;
  #scrolled;
  #scrollEffect;
  #observable;
  #shadowClass;
  constructor() {
    this.#destroyRef = inject(DestroyRef);
    this.#document = inject(DOCUMENT);
    this.#elementRef = inject(ElementRef);
    this.#scrolled = signal(false);
    this.#scrollEffect = effect(() => {
      this.#elementRef.nativeElement.classList.toggle(this.#shadowClass, this.#scrolled());
    });
    this.#shadowClass = 'shadow-sm';
    this.cShadowOnScroll = input(true);
    this.#shadowOnScrollEffect = effect(() => {
      const value = this.cShadowOnScroll();
      untracked(() => {
        this.#scrolled.set(false);
        if (value) {
          this.#shadowClass = value === true ? 'shadow' : `shadow-${value}`;
          this.#observable = fromEvent(this.#document, 'scroll').pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(scrolled => {
            this.#scrolled.set(this.#document.documentElement.scrollTop > 0);
          });
        } else {
          this.#observable?.unsubscribe();
        }
      });
    });
    this.#destroyRef.onDestroy(() => {
      this.#scrollEffect?.destroy();
    });
  }
  #shadowOnScrollEffect;
  static {
    this.ɵfac = function ShadowOnScrollDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ShadowOnScrollDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ShadowOnScrollDirective,
      selectors: [["", "cShadowOnScroll", ""]],
      inputs: {
        cShadowOnScroll: [1, "cShadowOnScroll"]
      },
      exportAs: ["cShadowOnScroll"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ShadowOnScrollDirective, [{
    type: Directive,
    args: [{
      selector: '[cShadowOnScroll]',
      exportAs: 'cShadowOnScroll'
    }]
  }], () => [], null);
})();
class TextColorDirective {
  constructor() {
    /**
     * Set text-color of element
     * @type TextColors
     */
    this.color = input('', {
      alias: 'cTextColor'
    });
    this.hostClasses = computed(() => {
      const color = this.color();
      return {
        [`text-${color}`]: !!color
      };
    });
  }
  static {
    this.ɵfac = function TextColorDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TextColorDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: TextColorDirective,
      selectors: [["", "cTextColor", ""]],
      hostVars: 2,
      hostBindings: function TextColorDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        color: [1, "cTextColor", "color"]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TextColorDirective, [{
    type: Directive,
    args: [{
      selector: '[cTextColor]',
      host: {
        '[class]': 'hostClasses()'
      }
    }]
  }], null, null);
})();
class TextBgColorDirective {
  constructor() {
    /**
     * Set text-bg-color of element
     * @type Colors
     */
    this.textBgColor = input('', {
      alias: 'cTextBgColor'
    });
    this.hostClasses = computed(() => {
      const color = this.textBgColor();
      return {
        [`text-bg-${color}`]: !!color
      };
    });
  }
  static {
    this.ɵfac = function TextBgColorDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TextBgColorDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: TextBgColorDirective,
      selectors: [["", "cTextBgColor", ""]],
      hostVars: 2,
      hostBindings: function TextBgColorDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        textBgColor: [1, "cTextBgColor", "textBgColor"]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TextBgColorDirective, [{
    type: Directive,
    args: [{
      selector: '[cTextBgColor]',
      host: {
        '[class]': 'hostClasses()'
      }
    }]
  }], null, null);
})();
const UTILITY_DIRECTIVES = [AlignDirective, BgColorDirective, BorderDirective, RoundedDirective, ShadowOnScrollDirective, TextColorDirective, TextBgColorDirective];
class UtilitiesModule {
  static {
    this.ɵfac = function UtilitiesModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UtilitiesModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: UtilitiesModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UtilitiesModule, [{
    type: NgModule,
    args: [{
      imports: [...UTILITY_DIRECTIVES],
      exports: [...UTILITY_DIRECTIVES]
    }]
  }], null, null);
})();
class AvatarComponent {
  constructor() {
    /**
     * Sets the background color context of the component to one of CoreUI’s themed colors.
     * @type Colors
     */
    this.color = input();
    /**
     * Select the shape of the component.
     * @type Shapes
     */
    this.shape = input();
    /**
     * Size the component small, large, or extra large.
     * @default 'md'
     */
    this.size = input('md');
    /**
     * The alt attribute for the img element alternate text.
     * @type string
     */
    this.alt = input('');
    /**
     * The src attribute for the img element.
     * @type string
     */
    this.src = input();
    /**
     * Sets the color context of the status indicator to one of CoreUI’s themed colors.
     * @type Colors
     */
    this.status = input();
    /**
     * Sets the text color of the component to one of CoreUI’s themed colors.
     * via TextColorDirective
     * @type TextColors
     */
    this.textColor = input();
    this.statusClass = computed(() => {
      return {
        'avatar-status': true,
        [`bg-${this.status()}`]: !!this.status()
      };
    });
    this.hostClasses = computed(() => {
      return {
        avatar: true,
        [`avatar-${this.size()}`]: !!this.size(),
        [`bg-${this.color()}`]: !!this.color(),
        [`${this.shape()}`]: !!this.shape()
      };
    });
  }
  static {
    this.ɵfac = function AvatarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AvatarComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AvatarComponent,
      selectors: [["c-avatar"]],
      hostAttrs: [1, "avatar"],
      hostVars: 2,
      hostBindings: function AvatarComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        color: [1, "color"],
        shape: [1, "shape"],
        size: [1, "size"],
        alt: [1, "alt"],
        src: [1, "src"],
        status: [1, "status"],
        textColor: [1, "textColor"]
      },
      features: [i0.ɵɵHostDirectivesFeature([{
        directive: TextColorDirective,
        inputs: ["cTextColor", "textColor"]
      }])],
      ngContentSelectors: _c0,
      decls: 3,
      vars: 1,
      consts: [[3, "ngClass"], [1, "avatar-img", 3, "src", "alt"], ["aria-label", "Avatar placeholder", "focusable", "false", "preserveAspectRatio", "xMidYMid slice", "role", "img", "xmlns", "http://www.w3.org/2000/svg", 1, "avatar-img", 2, "position", "absolute", "width", "100%", "height", "100%", "inset", "0"], ["fill", "#868e96", "height", "100%", "width", "100%"]],
      template: function AvatarComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0, 0, null, AvatarComponent_ProjectionFallback_0_Template, 1, 1);
          i0.ɵɵtemplate(2, AvatarComponent_Conditional_2_Template, 1, 1, "span", 0);
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(!!ctx.status() ? 2 : -1);
        }
      },
      dependencies: [NgClass],
      styles: ["[_nghost-%COMP%]   .avatar-img[_ngcontent-%COMP%]{object-fit:cover}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AvatarComponent, [{
    type: Component,
    args: [{
      selector: 'c-avatar',
      imports: [NgClass],
      hostDirectives: [{
        directive: TextColorDirective,
        inputs: ['cTextColor: textColor']
      }],
      host: {
        class: 'avatar',
        '[class]': 'hostClasses()'
      },
      template: "<ng-content>\n  @if (src()) {\n    @defer (prefetch on idle) {\n      <img src=\"{{src() ?? ''}}\" class=\"avatar-img\" alt=\"{{alt()}}\" />\n    } @placeholder () {\n      <svg aria-label=\"Avatar placeholder\"\n           focusable=\"false\"\n           preserveAspectRatio=\"xMidYMid slice\"\n           role=\"img\"\n           xmlns=\"http://www.w3.org/2000/svg\"\n           class=\"avatar-img\"\n           style=\"position: absolute; width: 100%; height: 100%; inset: 0;\">\n        <rect fill=\"#868e96\" height=\"100%\" width=\"100%\"></rect>\n      </svg>\n    }\n  }\n</ng-content>\n@if (!!status()) {\n  <span [ngClass]=\"statusClass()\"></span>\n}\n\n",
      styles: [":host .avatar-img{object-fit:cover}\n"]
    }]
  }], null, null);
})();
class AvatarModule {
  static {
    this.ɵfac = function AvatarModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AvatarModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: AvatarModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AvatarModule, [{
    type: NgModule,
    args: [{
      imports: [AvatarComponent],
      exports: [AvatarComponent]
    }]
  }], null, null);
})();
class BadgeComponent {
  constructor() {
    /**
     * Sets the color context of the component to one of CoreUI’s themed colors.
     * @type Colors
     */
    this.color = input();
    /**
     * Position badge in one of the corners of a link or button.
     * @type BadgePositions
     */
    this.position = input();
    /**
     * Select the shape of the component.
     * @type Shapes
     */
    this.shape = input();
    /**
     * Size the component small.
     */
    this.size = input();
    /**
     * Sets the text color of the component to one of CoreUI’s themed colors.
     * via TextColorDirective
     * @type TextColors
     */
    this.textColor = input();
    /**
     * Sets the component's color scheme to one of CoreUI's themed colors, ensuring the text color contrast adheres to the WCAG 4.5:1 contrast ratio standard for accessibility.
     * via TextBgColorDirective
     * @type Colors
     * @since 5.0.0
     */
    this.textBgColor = input();
    this.hostClasses = computed(() => {
      const position = this.position();
      const positionClasses = {
        'position-absolute': !!position,
        'translate-middle': !!position,
        'top-0': position?.includes('top'),
        'top-100': position?.includes('bottom'),
        'start-100': position?.includes('end'),
        'start-0': position?.includes('start')
      };
      return Object.assign({
        badge: true,
        [`bg-${this.color()}`]: !!this.color(),
        [`badge-${this.size()}`]: !!this.size(),
        [`${this.shape()}`]: !!this.shape()
      }, !!position ? positionClasses : {});
    });
  }
  static {
    this.ɵfac = function BadgeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BadgeComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BadgeComponent,
      selectors: [["c-badge"]],
      hostAttrs: [1, "badge"],
      hostVars: 2,
      hostBindings: function BadgeComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        color: [1, "color"],
        position: [1, "position"],
        shape: [1, "shape"],
        size: [1, "size"],
        textColor: [1, "textColor"],
        textBgColor: [1, "textBgColor"]
      },
      features: [i0.ɵɵHostDirectivesFeature([{
        directive: TextColorDirective,
        inputs: ["cTextColor", "textColor"]
      }, {
        directive: TextBgColorDirective,
        inputs: ["cTextBgColor", "textBgColor"]
      }])],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BadgeComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BadgeComponent, [{
    type: Component,
    args: [{
      selector: 'c-badge',
      template: '<ng-content />',
      hostDirectives: [{
        directive: TextColorDirective,
        inputs: ['cTextColor: textColor']
      }, {
        directive: TextBgColorDirective,
        inputs: ['cTextBgColor: textBgColor']
      }],
      host: {
        class: 'badge',
        '[class]': 'hostClasses()'
      }
    }]
  }], null, null);
})();
class BadgeModule {
  static {
    this.ɵfac = function BadgeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BadgeModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: BadgeModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BadgeModule, [{
    type: NgModule,
    args: [{
      imports: [BadgeComponent],
      exports: [BadgeComponent]
    }]
  }], null, null);
})();
class BackdropService {
  constructor() {
    this.#backdropClick = new Subject();
    this.backdropClick$ = this.#backdropClick.asObservable();
    this.#document = inject(DOCUMENT);
    this.#rendererFactory = inject(RendererFactory2);
    this.#renderer = this.#rendererFactory.createRenderer(null, null);
    this.scrollbarWidth = this.#scrollbarWidth;
    this.#scrollBarVisible = true;
  }
  #backdropClick;
  #document;
  #rendererFactory;
  #renderer;
  #unListen;
  get #scrollbarWidth() {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = this.#document.documentElement.clientWidth;
    const scrollbarWidth = Math.abs((this.#document.defaultView?.innerWidth ?? documentWidth) - documentWidth);
    return `${scrollbarWidth}px`;
  }
  setBackdrop(type = 'modal') {
    const backdropElement = this.#renderer.createElement('div');
    this.#renderer.addClass(backdropElement, `${type}-backdrop`);
    this.#renderer.addClass(backdropElement, 'fade');
    this.#renderer.appendChild(this.#document.body, backdropElement);
    this.#unListen = this.#renderer.listen(backdropElement, 'click', e => {
      this.onClickHandler();
    });
    this.scrollbarWidth = this.#scrollbarWidth;
    setTimeout(() => {
      this.#renderer.addClass(backdropElement, 'show');
      // this.hideScrollbar();
    });
    this.activeBackdrop = backdropElement;
    return backdropElement;
  }
  clearBackdrop(backdropElement) {
    if (backdropElement) {
      this.#unListen();
      this.#renderer.removeClass(backdropElement, 'show');
      setTimeout(() => {
        if (this.activeBackdrop === backdropElement) {
          this.resetScrollbar();
        }
        this.#renderer.removeChild(this.#document.body, backdropElement);
        backdropElement = undefined;
      }, 300);
    }
    return undefined;
  }
  get #isRTL() {
    return [this.#document.documentElement.dir, this.#document.body.dir].includes('rtl');
  }
  #scrollBarVisible;
  hideScrollbar() {
    if (this.#scrollBarVisible) {
      this.#renderer.setStyle(this.#document.body, 'overflow', 'hidden');
      this.#renderer.setStyle(this.#document.body, `padding-${this.#isRTL ? 'left' : 'right'}`, this.scrollbarWidth);
      this.#scrollBarVisible = false;
    }
  }
  resetScrollbar() {
    this.#renderer.removeStyle(this.#document.body, 'overflow');
    this.#renderer.removeStyle(this.#document.body, `padding-${this.#isRTL ? 'left' : 'right'}`);
    this.#scrollBarVisible = true;
  }
  onClickHandler() {
    this.#backdropClick.next(true);
  }
  static {
    this.ɵfac = function BackdropService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BackdropService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: BackdropService,
      factory: BackdropService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BackdropService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class BreadcrumbItemComponent {
  constructor() {
    /**
     * Toggle the active state for the component. [docs]
     * @return boolean
     */
    this.active = input(undefined, {
      transform: booleanAttribute
    });
    /**
     * The `url` prop for the inner `[routerLink]` directive. [docs]
     * @type string
     */
    this.url = input();
    /**
     * Additional html attributes for link. [docs]
     * @type INavAttributes
     */
    this.attributes = input();
    /**
     * Some `NavigationExtras` props for the inner `[routerLink]` directive and `routerLinkActiveOptions`. [docs]
     * @type INavLinkProps
     */
    this.linkProps = input();
    this.ariaCurrent = computed(() => {
      return this.active() ? 'page' : null;
    });
    this.hostClasses = computed(() => {
      return {
        'breadcrumb-item': true,
        active: this.active()
      };
    });
  }
  static {
    this.ɵfac = function BreadcrumbItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BreadcrumbItemComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BreadcrumbItemComponent,
      selectors: [["c-breadcrumb-item"]],
      hostVars: 3,
      hostBindings: function BreadcrumbItemComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("aria-current", ctx.ariaCurrent());
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        active: [1, "active"],
        url: [1, "url"],
        attributes: [1, "attributes"],
        linkProps: [1, "linkProps"]
      },
      exportAs: ["breadcrumbItem"],
      ngContentSelectors: _c0,
      decls: 4,
      vars: 1,
      consts: [["defaultBreadcrumbItemContentTemplate", ""], [3, "routerLink", "cHtmlAttr", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state"], [3, "cHtmlAttr"], [4, "ngTemplateOutlet"]],
      template: function BreadcrumbItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, BreadcrumbItemComponent_Conditional_0_Template, 2, 13, "a", 1)(1, BreadcrumbItemComponent_Conditional_1_Template, 2, 3, "span", 2)(2, BreadcrumbItemComponent_ng_template_2_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵconditional(!ctx.active() ? 0 : 1);
        }
      },
      dependencies: [RouterModule, i1.RouterLink, NgTemplateOutlet, HtmlAttributesDirective],
      styles: ["[_nghost-%COMP%]{display:list-item;text-align:-webkit-match-parent;text-align:match-parent}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BreadcrumbItemComponent, [{
    type: Component,
    args: [{
      selector: 'c-breadcrumb-item',
      imports: [RouterModule, NgTemplateOutlet, HtmlAttributesDirective],
      exportAs: 'breadcrumbItem',
      host: {
        '[attr.aria-current]': 'ariaCurrent()',
        '[class]': 'hostClasses()'
      },
      template: "@if (!active()) {\n  <a [routerLink]=\"url()\"\n     [cHtmlAttr]=\"attributes() ?? {}\"\n     [target]=\"attributes()?.['target']\"\n     [queryParams]=\"linkProps()?.queryParams ?? null\"\n     [fragment]=\"linkProps()?.fragment\"\n     [queryParamsHandling]=\"linkProps()?.queryParamsHandling ?? null\"\n     [preserveFragment]=\"linkProps()?.preserveFragment ?? false\"\n     [skipLocationChange]=\"linkProps()?.skipLocationChange ?? false\"\n     [replaceUrl]=\"linkProps()?.replaceUrl ?? false\"\n     [state]=\"linkProps()?.state ?? {}\"\n  >\n    <ng-container *ngTemplateOutlet=\"defaultBreadcrumbItemContentTemplate\" />\n  </a>\n} @else {\n  <span [cHtmlAttr]=\"attributes() ?? {}\">\n      <ng-container *ngTemplateOutlet=\"defaultBreadcrumbItemContentTemplate\" />\n  </span>\n}\n\n<ng-template #defaultBreadcrumbItemContentTemplate>\n  <ng-content />\n</ng-template>\n",
      styles: [":host{display:list-item;text-align:-webkit-match-parent;text-align:match-parent}\n"]
    }]
  }], null, null);
})();
class BreadcrumbComponent {
  constructor() {
    /**
     * Default aria-label for breadcrumb. [docs]
     * @return string
     * @default 'breadcrumb'
     */
    this.ariaLabel = input('breadcrumb');
    /**
     * Default role for breadcrumb. [docs]
     * @return string
     * @default 'navigation'
     */
    this.role = input('navigation');
  }
  static {
    this.ɵfac = function BreadcrumbComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BreadcrumbComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BreadcrumbComponent,
      selectors: [["c-breadcrumb"]],
      hostAttrs: [1, "breadcrumb"],
      hostVars: 2,
      hostBindings: function BreadcrumbComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("aria-label", ctx.ariaLabel())("role", ctx.role());
        }
      },
      inputs: {
        ariaLabel: [1, "ariaLabel"],
        role: [1, "role"]
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BreadcrumbComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BreadcrumbComponent, [{
    type: Component,
    args: [{
      selector: 'c-breadcrumb',
      template: '<ng-content />',
      host: {
        class: 'breadcrumb',
        '[attr.aria-label]': 'ariaLabel()',
        '[attr.role]': 'role()'
      }
    }]
  }], null, null);
})();
class BreadcrumbRouterService {
  #router;
  #activatedRoute;
  #breadcrumbsBehaviorSubject;
  constructor() {
    this.#router = inject(Router);
    this.#activatedRoute = inject(ActivatedRoute);
    this.outlet = 'primary';
    this.#breadcrumbsBehaviorSubject = new BehaviorSubject(new Array());
    this.breadcrumbs$ = this.#breadcrumbsBehaviorSubject.asObservable();
    this.#router.events.pipe(takeUntilDestroyed(), filter(event => event instanceof NavigationEnd)).subscribe(event => {
      const breadcrumbs = [];
      let currentRoute = this.#activatedRoute.root;
      let url = '';
      do {
        const childrenRoutes = currentRoute.children;
        currentRoute = null;
        childrenRoutes.forEach(childRoute => {
          // console.log('breadcrumb event', event, 'route', route);
          if (childRoute.outlet === this.outlet) {
            const routeSnapshot = childRoute.snapshot;
            url += '/' + routeSnapshot.url.map(segment => segment.path).join('/');
            breadcrumbs.push({
              label: routeSnapshot.data['title'] ?? routeSnapshot.title ?? '',
              url,
              queryParams: routeSnapshot.queryParams
            });
            currentRoute = childRoute;
          }
        });
      } while (currentRoute);
      this.#breadcrumbsBehaviorSubject.next(Object.assign([], breadcrumbs));
      return breadcrumbs;
    });
  }
  static {
    this.ɵfac = function BreadcrumbRouterService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BreadcrumbRouterService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: BreadcrumbRouterService,
      factory: BreadcrumbRouterService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BreadcrumbRouterService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
class BreadcrumbRouterComponent {
  constructor() {
    this.service = inject(BreadcrumbRouterService);
    /**
     * Optional array of IBreadcrumbItem to override default BreadcrumbRouter behavior. [docs]
     * @return IBreadcrumbItem[]
     */
    this.items = input();
    this.setup = effect(() => {
      const items = this.items();
      if (items && items.length > 0) {
        this.breadcrumbs = new Observable(observer => {
          const itemsValue = this.items();
          if (itemsValue) {
            observer.next(itemsValue);
          }
        });
      }
    });
  }
  ngOnInit() {
    this.breadcrumbs = this.service.breadcrumbs$;
  }
  ngOnDestroy() {
    this.breadcrumbs = undefined;
  }
  static {
    this.ɵfac = function BreadcrumbRouterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BreadcrumbRouterComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BreadcrumbRouterComponent,
      selectors: [["c-breadcrumb-router"], ["", "cBreadcrumbRouter", ""]],
      inputs: {
        items: [1, "items"]
      },
      decls: 4,
      vars: 2,
      consts: [[1, "m-0"], [3, "active", "url", "attributes", "linkProps"]],
      template: function BreadcrumbRouterComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "c-breadcrumb", 0);
          i0.ɵɵrepeaterCreate(1, BreadcrumbRouterComponent_For_2_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
          i0.ɵɵpipe(3, "async");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵrepeater(i0.ɵɵpipeBind1(3, 0, ctx.breadcrumbs));
        }
      },
      dependencies: [BreadcrumbComponent, BreadcrumbItemComponent, AsyncPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BreadcrumbRouterComponent, [{
    type: Component,
    args: [{
      selector: 'c-breadcrumb-router, [cBreadcrumbRouter]',
      imports: [BreadcrumbComponent, BreadcrumbItemComponent, AsyncPipe],
      template: "<c-breadcrumb class=\"m-0\">\n  @for (breadcrumb of breadcrumbs | async; track breadcrumb; let last = $last) {\n    @if (breadcrumb?.label && (breadcrumb?.url?.slice(-1) === '/' || last)) {\n      <c-breadcrumb-item\n        [active]=\"last\"\n        [url]=\"breadcrumb?.url\"\n        [attributes]=\"breadcrumb?.attributes\"\n        [linkProps]=\"breadcrumb?.linkProps\"\n      >\n        {{ breadcrumb?.label }}\n      </c-breadcrumb-item>\n    }\n  }\n</c-breadcrumb>\n"
    }]
  }], null, null);
})();
class BreadcrumbModule {
  static {
    this.ɵfac = function BreadcrumbModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BreadcrumbModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: BreadcrumbModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [BreadcrumbRouterService],
      imports: [BreadcrumbItemComponent, BreadcrumbRouterComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BreadcrumbModule, [{
    type: NgModule,
    args: [{
      imports: [BreadcrumbComponent, BreadcrumbItemComponent, BreadcrumbRouterComponent],
      exports: [BreadcrumbComponent, BreadcrumbItemComponent, BreadcrumbRouterComponent],
      providers: [BreadcrumbRouterService]
    }]
  }], null, null);
})();
class ButtonGroupComponent {
  constructor() {
    /**
     * Size the component small or large.
     * @type { 'sm' | 'lg' }
     */
    this.size = input();
    /**
     * Create a set of buttons that appear vertically stacked rather than horizontally. Split button dropdowns are not supported here.
     * @type boolean
     */
    this.vertical = input(false, {
      transform: booleanAttribute
    });
    /**
     * Default role attr for ButtonGroup. [docs]
     * @type InputSignal<string>
     * @default 'group'
     */
    this.role = input('group');
    this.hostClasses = computed(() => {
      return {
        'btn-group': !this.vertical(),
        'btn-group-vertical': this.vertical(),
        [`btn-group-${this.size()}`]: !!this.size()
      };
    });
  }
  static {
    this.ɵfac = function ButtonGroupComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ButtonGroupComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ButtonGroupComponent,
      selectors: [["c-button-group"]],
      hostVars: 3,
      hostBindings: function ButtonGroupComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role());
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        size: [1, "size"],
        vertical: [1, "vertical"],
        role: [1, "role"]
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function ButtonGroupComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonGroupComponent, [{
    type: Component,
    args: [{
      selector: 'c-button-group',
      template: '<ng-content />',
      host: {
        '[attr.role]': 'role()',
        '[class]': 'hostClasses()'
      }
    }]
  }], null, null);
})();
class ButtonToolbarComponent {
  constructor() {
    /**
     * Default role attr for ButtonToolbar. [docs]
     * @type InputSignal<string>
     * @default 'toolbar'
     */
    this.role = input('toolbar');
  }
  static {
    this.ɵfac = function ButtonToolbarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ButtonToolbarComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ButtonToolbarComponent,
      selectors: [["c-button-toolbar"]],
      hostAttrs: [1, "btn-toolbar"],
      hostVars: 1,
      hostBindings: function ButtonToolbarComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role());
        }
      },
      inputs: {
        role: [1, "role"]
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function ButtonToolbarComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonToolbarComponent, [{
    type: Component,
    args: [{
      selector: 'c-button-toolbar',
      template: '<ng-content />',
      host: {
        class: 'btn-toolbar',
        '[attr.role]': 'role()'
      }
    }]
  }], null, null);
})();
class ButtonGroupModule {
  static {
    this.ɵfac = function ButtonGroupModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ButtonGroupModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ButtonGroupModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonGroupModule, [{
    type: NgModule,
    args: [{
      imports: [ButtonGroupComponent, ButtonToolbarComponent],
      exports: [ButtonGroupComponent, ButtonToolbarComponent]
    }]
  }], null, null);
})();
function dateTransform(value) {
  return tryDate(value, 'dateTransform');
}
const convertIsoWeekToDate = isoWeek => {
  const [year, week] = isoWeek.split(/w/i);
  // Get date for 4th of January for year
  const date = new Date(parseInt(year), 0, 4);
  // Get previous Monday, add 7 days for each week after first
  date.setDate(date.getDate() - (date.getDay() || 7) + 1 + (parseInt(week ?? 1) - 1) * 7);
  return date;
};
const convertToDateObject = (date, selectionType, propName) => {
  if (date instanceof Date) {
    return new Date(date);
  }
  if (isValidDate(date)) {
    return new Date(date);
  }
  if (selectionType === 'week') {
    return convertIsoWeekToDate(date);
  }
  return tryDate(date, propName ?? 'convertToDateObject');
  // return new Date(Date.parse(date));
};
const convertToLocalDate = (d, locale, options = {}) => d.toLocaleDateString(locale, options);
const convertToLocalTime = (d, locale, options = {}) => d.toLocaleTimeString(locale, options);
const createGroupsInArray = (arr, numberOfGroups) => {
  const perGroup = Math.ceil(arr.length / numberOfGroups);
  return Array.from({
    length: numberOfGroups
  }).fill('').map((_, i) => arr.slice(i * perGroup, (i + 1) * perGroup));
};
const getCalendarDate = (calendarDate, order, view) => {
  if (order !== 0 && view === 'days') {
    return new Date(calendarDate.getFullYear(), calendarDate.getMonth() + order, 1);
  }
  if (order !== 0 && view === 'months') {
    return new Date(calendarDate.getFullYear() + order, calendarDate.getMonth(), 1);
  }
  if (order !== 0 && view === 'years') {
    return new Date(calendarDate.getFullYear() + 12 * order, calendarDate.getMonth(), 1);
  }
  return calendarDate;
};
const getCurrentYear = () => new Date().getFullYear();
const getCurrentMonth = () => new Date().getMonth();
const getDateBySelectionType = (date, selectionType) => {
  if (date === null) {
    return null;
  }
  if (selectionType === 'week') {
    return `${date.getFullYear()}W${getWeekNumber(date)}`;
  }
  if (selectionType === 'month') {
    const monthNumber = `0${date.getMonth() + 1}`.slice(-2);
    return `${date.getFullYear()}-${monthNumber}`;
  }
  if (selectionType === 'year') {
    return `${date.getFullYear()}`;
  }
  return date;
};
//
const getLocalDateFromString = (string, locale, time) => {
  const date = new Date(2013, 11, 31, 17, 19, 22);
  let regex = time ? date.toLocaleString(locale) : date.toLocaleDateString(locale);
  regex = regex.replace('2013', '(?<year>[0-9]{2,4})').replace('12', '(?<month>[0-9]{1,2})').replace('31', '(?<day>[0-9]{1,2})');
  if (time) {
    regex = regex.replace('5', '(?<hour>[0-9]{1,2})').replace('17', '(?<hour>[0-9]{1,2})').replace('19', '(?<minute>[0-9]{1,2})').replace('22', '(?<second>[0-9]{1,2})').replace('PM', '(?<ampm>[A-Z]{2})');
  }
  const rgx = RegExp(`${regex}`);
  const partials = string.match(rgx);
  if (partials === null) {
    return;
  }
  const newDate = partials.groups && (time ? new Date(Number(partials.groups['year']), Number(partials.groups['month']) - 1, Number(partials.groups['day']), partials.groups['ampm'] ? partials.groups['ampm'] === 'PM' ? Number(partials.groups['hour']) + 12 : Number(partials.groups['hour']) : Number(partials.groups['hour']), Number(partials.groups['minute']), Number(partials.groups['second'])) : new Date(Number(partials.groups['year']), Number(partials.groups['month']) - 1, Number(partials.groups['day'])));
  return newDate;
};
const getMonthName = (month, locale) => {
  const d = new Date();
  d.setDate(1);
  d.setMonth(month);
  return d.toLocaleString(locale, {
    month: 'long'
  });
};
const getMonthsNames = (locale, year) => {
  const months = [];
  const d = new Date(year);
  d.setDate(1);
  for (let i = 0; i < 12; i++) {
    d.setMonth(i);
    months.push({
      year,
      month: d.toLocaleDateString(locale, {
        month: 'short'
      })
    });
  }
  return months;
};
const getYears = year => {
  const years = [];
  for (let _year = year - 6; _year < year + 6; _year++) {
    years.push(_year);
  }
  return years;
};
const getLeadingDays = (year, month, firstDayOfWeek) => {
  // 0: sunday
  // 1: monday
  const dates = [];
  const d = new Date(year, month);
  const y = d.getFullYear();
  const m = d.getMonth();
  const firstWeekday = new Date(y, m, 1).getDay();
  let leadingDays = 6 - (6 - firstWeekday) - firstDayOfWeek;
  if (firstDayOfWeek) {
    leadingDays = leadingDays < 0 ? 7 + leadingDays : leadingDays;
  }
  for (let i = leadingDays * -1; i < 0; i++) {
    dates.push({
      date: new Date(y, m, i + 1),
      month: 'previous'
    });
  }
  return dates;
};
const getMonthDays = (year, month) => {
  const dates = [];
  const lastDay = new Date(year, month + 1, 0).getDate();
  for (let i = 1; i <= lastDay; i++) {
    dates.push({
      date: new Date(year, month, i),
      month: 'current'
    });
  }
  return dates;
};
const getTrailingDays = (year, month, leadingDays, monthDays) => {
  const dates = [];
  const days = 42 - (leadingDays.length + monthDays.length);
  for (let i = 1; i <= days; i++) {
    dates.push({
      date: new Date(year, month + 1, i),
      month: 'next'
    });
  }
  return dates;
};
const getDayNumber = date => Math.ceil((Number(date) - Number(new Date(date.getFullYear(), 0, 0))) / 1000 / 60 / 60 / 24);
const getWeekNumber = date => {
  const week1 = new Date(date.getFullYear(), 0, 4);
  return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
};
const getMonthDetails = (year, month, firstDayOfWeek) => {
  const daysPrevMonth = getLeadingDays(year, month, firstDayOfWeek);
  const daysThisMonth = getMonthDays(year, month);
  const daysNextMonth = getTrailingDays(year, month, daysPrevMonth, daysThisMonth);
  const days = [...daysPrevMonth, ...daysThisMonth, ...daysNextMonth];
  const weeks = [];
  days.forEach((day, index) => {
    if (index % 7 === 0 || weeks.length === 0) {
      weeks.push({
        weekNumber: -1,
        days: []
      });
    }
    if ((index + 1) % 7 === 0) {
      weeks[weeks.length - 1].weekNumber = getWeekNumber(day.date);
    }
    weeks[weeks.length - 1].days.push(day);
  });
  return [...weeks];
};
const isDateDisabled = (date, min, max, dates) => {
  if (!date) {
    return false;
  }
  if (!min && !max && (!dates || !dates.length)) {
    return false;
  }
  if (min && date < min) {
    return true;
  }
  if (max && date > max) {
    return true;
  }
  let disabled = false;
  if (dates) {
    for (const _date of dates) {
      if (Array.isArray(_date)) {
        if (isDateInRange(date, _date[0], _date[1])) {
          disabled = true;
          break;
        }
      }
      if (_date instanceof Date) {
        if (isSameDateAs(date, _date)) {
          disabled = true;
          break;
        }
      }
    }
  }
  return disabled;
};
const isDateInRange = (date, start, end) => {
  return date && start && end && start <= date && date <= end;
};
const isYearInRange = (date, start, end) => {
  return date && start && end && start.getFullYear() <= date.getFullYear() && date.getFullYear() <= end.getFullYear();
};
const isDateBetweenMinMax = (date, min, max) => {
  if (date && min && max) {
    return min <= date && date <= max;
  }
  if (date && min) {
    return min <= date;
  }
  if (date && max) {
    return date <= max;
  }
  return true;
};
const isDateSelected = (date, start, end) => {
  return date && (start && isSameDateAs(start, date) || end && isSameDateAs(end, date));
};
const isMonthSelected = (date, start, end) => {
  return date && (start && isSameMonthAs(start, date) || end && isSameMonthAs(end, date));
};
const isYearSelected = (date, start, end) => {
  return date && (start && isSameYearAs(start, date) || end && isSameYearAs(end, date));
};
const isEndDate = (date, start, end) => {
  return date && start && end && isSameDateAs(end, date) && start < end;
};
const isLastDayOfMonth = date => {
  const test = new Date(date.getTime());
  const month = test.getMonth();
  test.setDate(test.getDate() + 1);
  return test.getMonth() !== month;
};
const equalDates = (a, b) => {
  return a && b && a.getTime() === b.getTime() || a === null && b === null;
};
const isSameDateAs = (date, date2) => {
  return date.getDate() == date2.getDate() && date.getMonth() == date2.getMonth() && date.getFullYear() == date2.getFullYear();
};
const isSameMonthAs = (date, date2) => {
  return date.getMonth() == date2.getMonth() && date.getFullYear() == date2.getFullYear();
};
const isSameYearAs = (date, date2) => {
  return date.getFullYear() == date2.getFullYear();
};
const isStartDate = (date, start, end) => {
  return date && start && end && isSameDateAs(start, date) && start < end;
};
const isToday = date => {
  const today = new Date();
  return date.getDate() == today.getDate() && date.getMonth() == today.getMonth() && date.getFullYear() == today.getFullYear();
};
const isThisMonth = (date, index) => {
  const today = new Date();
  return index == today.getMonth() && date.getFullYear() == today.getFullYear();
};
const isThisYear = year => {
  const today = new Date();
  return year == today.getFullYear();
};
const isValidDate = date => {
  if (date instanceof Date || typeof date === 'number' || typeof date === 'string') {
    // Try to create a Date object from Date or timestamp or string
    const dateObj = new Date(date);
    return !isNaN(dateObj.getTime());
  }
  // If none of the above conditions are met, it's not a valid date
  return false;
};
const tryDate = (value, propName = 'date') => {
  let _value;
  try {
    if (!isValidDate(value)) {
      throw value;
    }
    _value = new Date(value);
  } catch (err) {
    console.warn(`Invalid ${propName}`, err);
    _value = new Date();
    _value.setHours(0, 0, 0, 0);
  }
  return _value;
};
const isDateInRangeDisabled = (startDate, endDate, dates, dateFilter) => {
  if ((!dates || !dates.length) && !dateFilter) {
    return false;
  }
  if (startDate && endDate) {
    const date = new Date(startDate);
    let disabled = false;
    while (date <= endDate) {
      disabled = isDateDisabled(date, null, null, dates) || (dateFilter ? !dateFilter(date) : false);
      if (disabled) {
        break;
      }
      date.setDate(date.getDate() + 1);
    }
    return disabled;
  }
  return false;
};
const getUtcTime = value => {
  const hours = value?.getUTCHours() ?? 0;
  const minutes = value?.getUTCMinutes() ?? 0;
  const seconds = value?.getUTCSeconds() ?? 0;
  const ms = value?.getUTCMilliseconds() ?? 0;
  const offset = value?.getTimezoneOffset() ?? 0;
  const utcTimeObj = {
    hours,
    minutes,
    seconds,
    ms,
    offset
  };
  Object.entries(utcTimeObj).forEach(([key, value]) => {
    if (value && Number.isNaN(value)) {
      utcTimeObj[key] = 0;
    }
  });
  Object.freeze(utcTimeObj);
  return utcTimeObj;
};
const setUtcTime = (value, time, withTime) => {
  if (!value || Number.isNaN(value?.getTime() ?? NaN) || !withTime) {
    return value;
  }
  const date = new Date(value);
  date.setUTCHours(time['hours'], time['minutes'], time['seconds'], time['ms']);
  return new Date(date);
};
// type DateParts = {
//   [key in DateTimeFormatPartTypes]?: string;
// };
// type DateParts = {
//   year: number, month: number, day: number, literal: string
// };
//
// export const cvtDate = (dateAsString: string, locale = 'pl-PL') => {
//   const dateString = dateAsString ?? new Date().toLocaleDateString(locale);
//   const dateSplit = dateString.split(/[.\-\/\s\D]/gi).filter(item => !!item.length);
//   const formatter = new Intl.DateTimeFormat(locale);
//   const parts = formatter.formatToParts().filter(part => ['year', 'month', 'day'].includes(part.type));
//   const dateShim = {
//     day: undefined, month: undefined, year: undefined
//   };
//   parts.forEach((part, index) => {
//     const { type, value } = { ...part };
//     // @ts-ignore
//     dateShim[type] = dateSplit[index];
//   });
//
//   return dateShim;
//
//   // const dateParts: DateParts = {
//   //   year: 0,
//   //   month: 0,
//   //   day: 0,
//   //   literal: '/'
//   // };
//   //
//   // const literal = parts.find(part => part.type === 'literal')?.value ?? '/';
//   // // const year = parseInt(parts.find(part => part.type === 'year')?.value ?? '0');
//   // // const month = parseInt(parts.find(part => part.type === 'year')?.value ?? '0');
//   // // const day = parseInt(parts.find(part => part.type === 'year')?.value ?? '0');
//   //
//   // const dateArray = dateString.split(literal);
//   //
//   // parts.forEach(part => {
//   //   const {type, value} = {...part};
//   //   if (type === 'day') {
//   //
//   //   }
//   // })
//   //
//   // parts.filter(part => part.type in dateParts).map(part => {
//   //   const {type, value} = {...part};
//   //   // @ts-ignore
//   //   dateParts[type] = parseInt(part.value);
//   //   //
//   //   // switch (type) {
//   //   //   case 'day':
//   //   //     day = parseInt(value);
//   //   //     break;
//   //   //   case 'month':
//   //   //     month = parseInt(value);
//   //   //     break;
//   //   //   case 'year':
//   //   //     year = parseInt(value);
//   //   //     break;
//   //   // }
//   // })
//   // // const { year, month, day } = {...dateParts}
//   // return new Date(year, month - 1, day);
// };
//
// // function getDateX(dateAsString) {
// //   const [day, month, year] = dateAsString.split('/');
// //   return new Date(year, month - 1, day);
// // }
//
// // getDate('12/07/1997');

class CalendarService {
  #differ;
  constructor(keyValueDiffers) {
    this.keyValueDiffers = keyValueDiffers;
    this.calendarStateObject = {
      calendarDate: new Date(),
      hoverDate: null,
      startDate: null,
      endDate: null,
      maxDate: null,
      minDate: null,
      disabledDates: [],
      range: false,
      view: 'days',
      locale: 'default',
      dateFilter: undefined,
      weekdayFormat: 'short',
      dayFormat: 'numeric',
      navYearFirst: false,
      showAdjacentDays: true,
      selectAdjacentDays: false,
      selectionType: 'day',
      showWeekNumber: false,
      weekNumbersLabel: undefined,
      firstDayOfWeek: 1
    };
    this.#calendarState = new BehaviorSubject(this.calendarStateObject);
    this.calendarState$ = this.#calendarState.asObservable();
    this.#differ = this.keyValueDiffers.find(this.calendarStateObject).create();
  }
  #calendarState;
  update(state) {
    const keys = Object.keys(state);
    for (const key of keys) {
      const entry = this.calendarStateObject[key];
      if (entry === state[key]) {
        continue;
      }
      if (isValidDate(state[key]) && entry ? entry.getTime() === state[key]?.getTime() : false) {
        continue;
      }
      this.calendarStateObject[key] = state[key];
    }
    if (this.#differ) {
      const changes = this.#differ.diff(this.calendarStateObject);
      if (changes) {
        const newState = {
          ...this.calendarStateObject
        };
        changes.forEachChangedItem(item => {
          // console.log('changes', item.key, item);
          newState[item.key] = item.currentValue;
        });
        this.#calendarState.next(newState);
      }
    }
  }
  static {
    this.ɵfac = function CalendarService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalendarService)(i0.ɵɵinject(i0.KeyValueDiffers));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CalendarService,
      factory: CalendarService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CalendarService, [{
    type: Injectable
  }], () => [{
    type: i0.KeyValueDiffers
  }], null);
})();
class CalendarNavigationComponent {
  #destroyRef;
  #calendarService;
  constructor() {
    this.#destroyRef = inject(DestroyRef);
    this.#calendarService = inject(CalendarService);
    this.pageIndex = input(0, {
      transform: numberAttribute
    });
    this.addMonths = computed(() => {
      const view = this.view();
      const pageIndex = this.pageIndex();
      return pageIndex * (view === 'years' ? 144 : view === 'months' ? 12 : 1);
    });
    this.navigation = input(true);
    this.maxDate = signal(null);
    this.minDate = signal(null);
    this.calendarDate = signal(new Date());
    this.navYearFirst = signal(false);
    this.locale = signal('default');
    this.view = signal('days');
    this.selectionType = signal('day');
    this.ariaNextMonthLabel = input('Next month');
    this.ariaNextYearLabel = input('Next year');
    this.ariaPrevMonthLabel = input('Previous month');
    this.ariaPrevYearLabel = input('Previous year');
    this.navigationClick = output();
    this.date = computed(() => {
      return new Date(this.calendarDate().getFullYear(), this.calendarDate().getMonth() + this.addMonths());
    });
    this.disableNextMonth = computed(() => {
      const maxDate = this.maxDate();
      return maxDate ? this.date() >= maxDate : false;
    });
    this.disablePrevMonth = computed(() => {
      const minDate = this.minDate();
      return minDate ? this.date() <= minDate : false;
    });
    this.disableNextYear = computed(() => {
      const maxDate = this.maxDate();
      return maxDate ? this.date().getFullYear() + 1 >= maxDate.getFullYear() : false;
    });
    this.disablePrevYear = computed(() => {
      const minDate = this.minDate();
      return minDate ? this.date().getFullYear() - 1 <= minDate.getFullYear() : false;
    });
    this.calendarStateSubscribe();
  }
  calendarStateSubscribe() {
    this.#calendarService.calendarState$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(state => {
      const keys = Object.keys(state);
      for (const key of keys) {
        if (key in this) {
          // @ts-ignore
          typeof this[key] === 'function' ? this[key].set(state[key]) : this[key] = state[key];
          // this[key] = state[key];
        }
      }
    });
  }
  setView(view) {
    this.view.set(view);
    this.#calendarService.update({
      view: view
    });
  }
  handleNavigationClick(direction, years = false) {
    this.navigationClick.emit({
      direction,
      years: years
    });
  }
  handleNavigationKeyUp($event, direction, years) {
    if (['Space'].includes($event.code)) {
      $event.preventDefault();
      this.handleNavigationClick(direction, years);
    }
  }
  static {
    this.ɵfac = function CalendarNavigationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalendarNavigationComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CalendarNavigationComponent,
      selectors: [["c-calendar-navigation"]],
      hostAttrs: [1, "calendar-nav"],
      inputs: {
        pageIndex: [1, "pageIndex"],
        navigation: [1, "navigation"],
        ariaNextMonthLabel: [1, "ariaNextMonthLabel"],
        ariaNextYearLabel: [1, "ariaNextYearLabel"],
        ariaPrevMonthLabel: [1, "ariaPrevMonthLabel"],
        ariaPrevYearLabel: [1, "ariaPrevYearLabel"]
      },
      outputs: {
        navigationClick: "navigationClick"
      },
      decls: 6,
      vars: 11,
      consts: [[1, "calendar-nav-prev"], ["aria-live", "polite", 1, "calendar-nav-date", 3, "ngStyle"], ["cButton", "", "color", "transparent", "size", "sm", "tabindex", "0"], ["cButton", "", "color", "transparent", "size", "sm", "tabindex", "0", 3, "click", "ngStyle"], [1, "calendar-nav-next"], ["cButton", "", "color", "transparent", "size", "sm", "tabindex", "0", 3, "click", "keyup", "disabled"], [1, "calendar-nav-icon", "calendar-nav-icon-double-prev"], ["cButton", "", "color", "transparent", "size", "sm", "tabindex", "0", 3, "disabled"], [1, "calendar-nav-icon", "calendar-nav-icon-prev"], ["cButton", "", "color", "transparent", "size", "sm", "tabindex", "0", 3, "click"], [1, "calendar-nav-icon", "calendar-nav-icon-double-next"], [1, "calendar-nav-icon", "calendar-nav-icon-next"]],
      template: function CalendarNavigationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, CalendarNavigationComponent_Conditional_0_Template, 4, 3, "div", 0);
          i0.ɵɵelementStart(1, "div", 1);
          i0.ɵɵtemplate(2, CalendarNavigationComponent_Conditional_2_Template, 2, 2, "button", 2);
          i0.ɵɵelementStart(3, "button", 3);
          i0.ɵɵlistener("click", function CalendarNavigationComponent_Template_button_click_3_listener() {
            return ctx.setView("years");
          });
          i0.ɵɵtext(4);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(5, CalendarNavigationComponent_Conditional_5_Template, 4, 3, "div", 4);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.navigation() ? 0 : -1);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngStyle", ctx.navYearFirst() ? i0.ɵɵpureFunction0(6, _c4) : i0.ɵɵpureFunction0(7, _c3));
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.view() === "days" ? 2 : -1);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngStyle", ctx.navYearFirst() ? i0.ɵɵpureFunction0(8, _c5) : i0.ɵɵpureFunction0(9, _c3));
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", ctx.date().toLocaleDateString(ctx.locale(), i0.ɵɵpureFunction0(10, _c6)), " ");
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.navigation() ? 5 : -1);
        }
      },
      dependencies: [ButtonDirective, NgStyle],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CalendarNavigationComponent, [{
    type: Component,
    args: [{
      selector: 'c-calendar-navigation',
      imports: [ButtonDirective, NgStyle],
      host: {
        class: 'calendar-nav'
      },
      template: "@if (navigation()) {\n  <div class=\"calendar-nav-prev\">\n    <button\n      (click)=\"handleNavigationClick('prev', true)\"\n      (keyup)=\"handleNavigationKeyUp($event, 'prev', true)\"\n      cButton\n      [disabled]=\"disablePrevYear()\"\n      color=\"transparent\"\n      size=\"sm\"\n      tabindex=\"0\"\n      [attr.aria-label]=\"ariaPrevYearLabel()\"\n    >\n      <span class=\"calendar-nav-icon calendar-nav-icon-double-prev\"></span>\n    </button>\n    @if (view() === 'days') {\n      <button\n        (click)=\"handleNavigationClick('prev')\"\n        (keyup)=\"handleNavigationKeyUp($event, 'prev')\"\n        cButton\n        [disabled]=\"disablePrevMonth()\"\n        color=\"transparent\"\n        size=\"sm\"\n        tabindex=\"0\"\n        [attr.aria-label]=\"ariaPrevMonthLabel()\"\n      >\n        <span class=\"calendar-nav-icon calendar-nav-icon-prev\"></span>\n      </button>\n    }\n  </div>\n}\n<div [ngStyle]=\"navYearFirst() ? { display: 'flex', justifyContent: 'center' } : {}\" aria-live=\"polite\" class=\"calendar-nav-date\">\n  @if (view() === 'days') {\n    <button\n      (click)=\"setView('months')\"\n      cButton\n      color=\"transparent\"\n      size=\"sm\"\n      tabindex=\"0\"\n    >\n      {{ date().toLocaleDateString(locale(), { month: 'long' }) }}\n    </button>\n  }\n  <button\n    (click)=\"setView('years')\"\n    [ngStyle]=\"navYearFirst() ? { order: '-1' } : {}\"\n    cButton\n    color=\"transparent\"\n    size=\"sm\"\n    tabindex=\"0\"\n  >\n    {{ date().toLocaleDateString(locale(), { year: 'numeric' }) }}\n  </button>\n</div>\n@if (navigation()) {\n  <div class=\"calendar-nav-next\">\n    @if (view() === 'days') {\n      <button\n        (click)=\"handleNavigationClick('next')\"\n        (keyup)=\"handleNavigationKeyUp($event, 'next')\"\n        [disabled]=\"disableNextMonth()\"\n        cButton\n        color=\"transparent\"\n        size=\"sm\"\n        tabindex=\"0\"\n        [attr.aria-label]=\"ariaNextMonthLabel()\"\n      >\n        <span class=\"calendar-nav-icon calendar-nav-icon-next\"></span>\n      </button>\n    }\n    <button\n      (click)=\"handleNavigationClick('next', true)\"\n      (keyup)=\"handleNavigationKeyUp($event, 'next', true)\"\n      cButton\n      [disabled]=\"disableNextYear()\"\n      color=\"transparent\"\n      size=\"sm\"\n      tabindex=\"0\"\n      [attr.aria-label]=\"ariaNextYearLabel()\"\n    >\n      <span class=\"calendar-nav-icon calendar-nav-icon-double-next\"></span>\n    </button>\n  </div>\n}\n"
    }]
  }], () => [], null);
})();
class CalendarWeekdayPipe {
  transform(date, weekdayFormat = 'short', locale = 'default') {
    return typeof weekdayFormat === 'function' ? weekdayFormat(date) : typeof weekdayFormat === 'string' ? date.toLocaleDateString(locale, {
      weekday: weekdayFormat
    }) : date.toLocaleDateString(locale, {
      weekday: 'long'
    }).slice(0, weekdayFormat);
  }
  static {
    this.ɵfac = function CalendarWeekdayPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalendarWeekdayPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "calendarWeekday",
      type: CalendarWeekdayPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CalendarWeekdayPipe, [{
    type: Pipe,
    args: [{
      name: 'calendarWeekday',
      standalone: true
    }]
  }], null, null);
})();
class CalendarClassYearPipe {
  transform(year, args) {
    return {
      'calendar-cell': true,
      year: true,
      today: isThisYear(year)
    };
  }
  static {
    this.ɵfac = function CalendarClassYearPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalendarClassYearPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "calendarClassYear",
      type: CalendarClassYearPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CalendarClassYearPipe, [{
    type: Pipe,
    args: [{
      name: 'calendarClassYear',
      standalone: true
    }]
  }], null, null);
})();
class CalendarClassMonthPipe {
  transform(calendarDate, monthIndex) {
    const year = new Date(calendarDate).getFullYear();
    const date = new Date(year, monthIndex, 1);
    return {
      'calendar-cell': true,
      month: true,
      today: isThisMonth(date, monthIndex)
    };
  }
  static {
    this.ɵfac = function CalendarClassMonthPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalendarClassMonthPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "calendarClassMonth",
      type: CalendarClassMonthPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CalendarClassMonthPipe, [{
    type: Pipe,
    args: [{
      name: 'calendarClassMonth',
      standalone: true
    }]
  }], null, null);
})();
class CalendarDayPipe {
  transform(date, dayFormat = 'numeric', locale = 'default') {
    return typeof dayFormat === 'function' ? dayFormat(date) : date.toLocaleDateString(locale, {
      day: dayFormat
    });
  }
  static {
    this.ɵfac = function CalendarDayPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalendarDayPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "calendarDay",
      type: CalendarDayPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CalendarDayPipe, [{
    type: Pipe,
    args: [{
      name: 'calendarDay',
      standalone: true
    }]
  }], null, null);
})();
class CalendarDayDirective {
  #destroyRef;
  #calendarService;
  #calendarState;
  constructor() {
    this.#destroyRef = inject(DestroyRef);
    this.#calendarService = inject(CalendarService);
    this.elementRef = inject(ElementRef);
    this.focusMonitor = inject(FocusMonitor);
    this.#calendarState = signal({
      ...this.#calendarService.calendarStateObject
    });
    this.date = input();
    this.month = input('current');
    this.disabled = false;
    // @Input() calendarDate = new Date();
    this.#selectEndDate = computed(() => {
      const state = this.#calendarState();
      return state.range && !!state.startDate && !state.endDate;
    });
    this.disabled$ = computed(() => {
      const state = {
        ...this.#calendarState()
      };
      const date = this.date();
      if (!date) {
        return true;
      }
      const dateYear = date.getFullYear();
      switch (state.view) {
        case 'months':
          {
            const dateMonth = dateYear * 100 + date.getMonth();
            const minDate = state.minDate ? state.minDate.getFullYear() * 100 + state.minDate?.getMonth() : undefined;
            const maxDate = state.maxDate ? state.maxDate.getFullYear() * 100 + state.maxDate?.getMonth() : undefined;
            this.disabled = (minDate ? dateMonth < minDate : false) || (maxDate ? dateMonth > maxDate : false);
            break;
          }
        case 'years':
          {
            const minYear = state.minDate?.getFullYear();
            const maxYear = state.maxDate?.getFullYear();
            this.disabled = (minYear ? dateYear < minYear : false) || (maxYear ? dateYear > maxYear : false);
            break;
          }
      }
      return this.disabled;
    });
    this.hostClasses = computed(() => {
      const date = this.date();
      if (!date) {
        return;
      }
      const selectEndDate = this.#selectEndDate();
      const month = this.month();
      const state = this.#calendarState();
      state.startDate = state.startDate ?? null;
      state.hoverDate = state.hoverDate ?? null;
      state.endDate = state.endDate ?? null;
      const start = isStartDate(date, state.startDate, state.endDate);
      const end = isEndDate(date, state.startDate, state.endDate);
      let selected = false;
      let clickable = false;
      let rangeHover = false;
      let inRange = false;
      let disabledRange = false;
      let disabledDate = false;
      let disabledByFilter = false;
      switch (state.view) {
        case 'months':
          if (state.selectionType === 'month') {
            selected = !!isMonthSelected(date, state.startDate, state.endDate);
            inRange = !!isDateInRange(date, state.startDate, state.endDate);
            rangeHover = selectEndDate && !!isDateInRange(date, state.startDate, state.hoverDate);
          }
          break;
        case 'years':
          if (state.selectionType === 'year') {
            selected = !!isYearSelected(date, state.startDate, state.endDate);
            inRange = !!isDateInRange(date, state.startDate, state.endDate);
            rangeHover = selectEndDate && !!isYearInRange(date, state.startDate, state.hoverDate);
          }
          break;
        default:
          selected = state.selectionType === 'day' && !!isDateSelected(date, state.startDate, state.endDate);
          clickable = month !== 'current' && !!state.selectAdjacentDays;
          rangeHover = state.selectionType === 'day' && month === 'current' && selectEndDate && !!isDateInRange(date, state.startDate, state.hoverDate);
          inRange = month === 'current' && (isDateInRange(date, state.startDate, state.endDate) || !!start || !!end);
          disabledRange = isDateInRangeDisabled(state.startDate, date, state.disabledDates, state.dateFilter);
          disabledDate = isDateDisabled(date, state.minDate, state.maxDate, state.disabledDates);
          disabledByFilter = typeof state.dateFilter === 'function' && date ? !state.dateFilter(date) : false;
          this.disabled = disabledDate || disabledByFilter;
      }
      return {
        'range-hover': rangeHover && (!disabledRange || !disabledByFilter),
        selected: selected,
        range: inRange,
        start: !!start,
        end: !!end,
        disabled: this.disabled,
        clickable: clickable
      };
    });
    this.ariaSelected = computed(() => {
      return this.hostClasses()?.['selected'] ? true : null;
    });
    this.#calendarService.calendarState$.pipe(tap(state => {
      this.#calendarState.set(state);
    }), takeUntilDestroyed(this.#destroyRef)).subscribe();
  }
  // @Input() calendarDate = new Date();
  #selectEndDate;
  focus(origin) {
    this.focusMonitor.focusVia(this.elementRef.nativeElement, origin ?? 'keyboard');
  }
  getLabel() {
    return this.date()?.toLocaleDateString(this.#calendarState().locale) ?? '';
  }
  static {
    this.ɵfac = function CalendarDayDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalendarDayDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: CalendarDayDirective,
      selectors: [["", "cCalendarDay", ""]],
      hostVars: 3,
      hostBindings: function CalendarDayDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("aria-selected", ctx.ariaSelected());
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        date: [1, "date"],
        month: [1, "month"]
      },
      exportAs: ["cCalendarDay"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CalendarDayDirective, [{
    type: Directive,
    args: [{
      selector: '[cCalendarDay]',
      standalone: true,
      exportAs: 'cCalendarDay',
      host: {
        '[class]': 'hostClasses()',
        '[attr.aria-selected]': 'ariaSelected()'
      }
    }]
  }], () => [], null);
})();
class CalendarDayTitlePipe {
  transform(date, locale = 'default') {
    return date.toLocaleDateString(locale);
  }
  static {
    this.ɵfac = function CalendarDayTitlePipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalendarDayTitlePipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "calendarDayTitle",
      type: CalendarDayTitlePipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CalendarDayTitlePipe, [{
    type: Pipe,
    args: [{
      name: 'calendarDayTitle',
      standalone: true
    }]
  }], null, null);
})();
class CalendarClassDayPipe {
  transform(dateObj, datesConfig) {
    const {
      date,
      month
    } = {
      ...dateObj
    };
    const {
      minDate,
      maxDate,
      disabledDates,
      dateFilter
    } = {
      ...datesConfig
    };
    // @ts-ignore
    const disabled = isDateDisabled(date, minDate, maxDate, disabledDates) || (dateFilter ? !dateFilter(date) : false);
    return {
      'calendar-cell': true,
      today: isToday(date),
      disabled: disabled,
      next: month === 'next',
      previous: month === 'previous',
      current: month === 'current',
      last: isLastDayOfMonth(date)
    };
  }
  static {
    this.ɵfac = function CalendarClassDayPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalendarClassDayPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "calendarClassDay",
      type: CalendarClassDayPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CalendarClassDayPipe, [{
    type: Pipe,
    args: [{
      name: 'calendarClassDay',
      standalone: true
    }]
  }], null, null);
})();
class CalendarRowDirective {
  #destroyRef;
  #calendarService;
  constructor() {
    this.#destroyRef = inject(DestroyRef);
    this.#calendarService = inject(CalendarService);
    this.elementRef = inject(ElementRef);
    this.focusMonitor = inject(FocusMonitor);
    this.date = null;
    this.startDate = null;
    this.endDate = null;
    this.hoverDate = null;
    this.maxDate = null;
    this.minDate = null;
    this.range = false;
    this.selectionType = 'week';
    this.calendarDate = new Date();
    this.locale = 'default';
    this.tabindex = signal(-1);
    this.#calendarService.calendarState$.pipe(distinctUntilChanged(), takeUntilDestroyed(this.#destroyRef)).subscribe(state => {
      const {
        startDate = this.startDate,
        endDate = this.endDate,
        hoverDate = this.hoverDate,
        maxDate = this.maxDate,
        minDate = this.minDate,
        range = this.range,
        disabledDates = this.disabledDates,
        dateFilter = this.dateFilter,
        selectionType = this.selectionType,
        calendarDate = this.calendarDate,
        locale = this.locale
      } = {
        ...state
      };
      this.startDate = startDate;
      this.endDate = endDate;
      this.hoverDate = hoverDate;
      this.maxDate = maxDate;
      this.minDate = minDate;
      this.range = range;
      this.disabledDates = disabledDates;
      this.dateFilter = dateFilter;
      this.selectionType = selectionType;
      this.calendarDate = calendarDate ?? new Date();
      this.locale = locale ?? 'default';
      // this.#tabindex.set(this.selectionType === 'week' && this.current && !this.disabled ? 0 : -1);
    });
  }
  set week(value) {
    this.current = value.days.some(day => day.month === 'current');
    this.tabindex.set(this.selectionType === 'week' && this.current && !this.disabled ? 0 : -1);
    this.#week = value;
  }
  get week() {
    return this.#week;
  }
  #week;
  get selectEndDate() {
    return this.range && !!this.startDate && !this.endDate;
  }
  get hostClasses() {
    if (!this.week) {
      return {
        'calendar-row': true
      };
    }
    const week = this.week;
    const calendarDate = this.calendarDate;
    const selectionType = this.selectionType;
    this.current = week.days.some(day => day.month === 'current');
    if (this.selectionType === 'week') {
      this.date = convertToDateObject(week.weekNumber === 0 ? `${calendarDate.getFullYear()}W53` : `${calendarDate.getFullYear()}W${week.weekNumber}`, 'week');
      const inRange = isDateInRange(this.date, this.startDate, this.endDate);
      const rangeHover = this.hoverDate && (this.selectEndDate ? isDateInRange(this.date, this.startDate, this.hoverDate) : isDateInRange(this.date, this.hoverDate, this.endDate));
      const selected = isDateSelected(this.date, this.startDate, this.endDate);
      const disabledDate = isDateDisabled(this.date, this.minDate, this.maxDate, this.disabledDates);
      const disabledByFilter = Object.prototype.toString.call(this.dateFilter) === '[object Function]' && this.date ? !this.dateFilter(this.date) : false;
      this.disabled = disabledDate || disabledByFilter;
      return {
        'calendar-row': true,
        disabled: this.disabled,
        range: inRange,
        'range-hover': rangeHover,
        selected: selected,
        current: this.current
      };
    } else {
      return {
        'calendar-row': true,
        current: this.current
      };
    }
  }
  get ariaSelected() {
    return this.hostClasses?.['selected'] ? true : null;
  }
  focus(origin) {
    this.focusMonitor.focusVia(this.elementRef.nativeElement, origin ?? 'keyboard');
  }
  getLabel() {
    return this.date?.toLocaleDateString(this.locale) ?? '';
  }
  static {
    this.ɵfac = function CalendarRowDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalendarRowDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: CalendarRowDirective,
      selectors: [["", "cCalendarRow", ""]],
      hostVars: 4,
      hostBindings: function CalendarRowDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("aria-selected", ctx.ariaSelected)("tabindex", ctx.tabindex());
          i0.ɵɵclassMap(ctx.hostClasses);
        }
      },
      inputs: {
        week: [0, "cCalendarRow", "week"]
      },
      exportAs: ["cCalendarRow"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CalendarRowDirective, [{
    type: Directive,
    args: [{
      selector: '[cCalendarRow]',
      standalone: true,
      exportAs: 'cCalendarRow',
      host: {
        '[attr.aria-selected]': 'ariaSelected',
        '[attr.tabindex]': 'tabindex()'
      }
    }]
  }], () => [], {
    week: [{
      type: Input,
      args: [{
        alias: 'cCalendarRow',
        required: true
      }]
    }],
    hostClasses: [{
      type: HostBinding,
      args: ['class']
    }]
  });
})();
class CalendarMonthComponent {
  #destroyRef;
  #calendarService;
  constructor() {
    this.#destroyRef = inject(DestroyRef);
    this.#calendarService = inject(CalendarService);
    this.pageIndex = input(0, {
      transform: numberAttribute
    });
    this.addMonths = computed(() => {
      const view = this.view();
      const pageIndex = this.pageIndex();
      return pageIndex * (view === 'years' ? 144 : view === 'months' ? 12 : 1);
    });
    /**
     * Initial selected date.
     * @type  (Date | null)
     */
    this.startDate = signal(null, {
      equal: equalDates
    });
    /**
     * Initial selected to date (range).
     * @type  Date | null
     */
    this.endDate = signal(null, {
      equal: equalDates
    });
    this.datesEffect = effect(() => {
      const startDate = this.startDate();
      const endDate = startDate && this.range() ? this.endDate() : null;
      this.#calendarService.update({
        startDate: startDate,
        endDate: endDate
      });
    });
    /**
     * Specify the list of dates that cannot be selected.
     * @type  Date[] | Date[][]
     */
    this.disabledDates = signal([]);
    /**
     * Sets the day of start week.
     * - 0 - Sunday,
     * - 1 - Monday,
     * - 2 - Tuesday,
     * - 3 - Wednesday,
     * - 4 - Thursday,
     * - 5 - Friday,
     * - 6 - Saturday,
     */
    this.firstDayOfWeek = signal(1);
    /**
     * Sets the default locale for components. If not set, it is inherited from the browser.
     * @default 'default'
     */
    this.locale = signal('default');
    /**
     * Allow range selection.
     * @type boolean
     * @default false
     */
    this.range = signal(false);
    /**
     * Set length or format of day name.
     * @type number | 'long' | 'narrow' | 'short'
     * @default 'short'
     */
    this.weekdayFormat = signal('short');
    /**
     * Set calendar view.
     * @type 'days' | 'months' | 'years'
     * @default 'days'
     */
    this.view = signal('days');
    /**
     * Max selectable date.
     */
    this.maxDate = signal(null, {
      equal: equalDates
    });
    /**
     * Min selectable date.
     */
    this.minDate = signal(null, {
      equal: equalDates
    });
    this.listOfMonths = computed(() => {
      return createGroupsInArray(getMonthsNames(this.locale(), this.date().getFullYear()), 4);
    });
    this.listOfYears = computed(() => createGroupsInArray(getYears(this.date().getFullYear()), 4));
    /**
     * Default date of the component
     * @type Date
     */
    this.calendarDate = signal(new Date(), {
      equal: equalDates
    });
    this.date = computed(() => {
      const date = this.calendarDate();
      return new Date(date.getFullYear(), date.getMonth() + this.addMonths(), 1, 0, 0, 0, 0);
    }, {
      equal: (a, b) => a.getTime() === b.getTime()
    });
    this.calendarDateEffect = effect(() => {
      this.#calendarService.update({
        calendarDate: this.calendarDate()
      });
    });
    this.dateFilter = signal(undefined);
    this.dayFormat = signal('numeric');
    this.selectAdjacentDays = signal(false);
    this.showAdjacentDays = signal(true);
    this.selectionType = signal('day');
    this.showWeekNumber = signal(false);
    this.weekNumbersLabel = signal('');
    this.monthDetails = computed(() => {
      const date = this.date();
      return getMonthDetails(date.getFullYear(), date.getMonth(), this.firstDayOfWeek());
    });
    this.weekDays = computed(() => {
      const monthDetails = this.monthDetails();
      return monthDetails[0].days;
    });
    this.calendarStateSubscribe();
  }
  yearNumber(year) {
    return new Date(year, 0).toLocaleDateString(this.locale(), {
      year: 'numeric'
    });
  }
  isDateDisabled(date) {
    const selectionType = this.selectionType();
    const disabledDates = this.disabledDates();
    const dateFilterFn = this.dateFilter();
    const maxDate = this.maxDate();
    const minDate = this.minDate();
    if (selectionType === 'year') {
      const min = minDate ? new Date(minDate.getFullYear(), 0, 1, 0, 0, 0, 0) : null;
      const max = maxDate ? new Date(maxDate.getFullYear(), 11, 31, 0, 0, 0, 0) : null;
      return isDateDisabled(date, min, max, disabledDates) || (dateFilterFn ? !dateFilterFn(date) : false);
    }
    if (selectionType === 'month') {
      const min = minDate ? new Date(minDate.getFullYear(), minDate.getMonth(), 1, 0, 0, 0, 0) : null;
      const max = maxDate ? new Date(maxDate.getFullYear(), maxDate.getMonth() + 1, 1, 0, 0, -1, 0) : null;
      return isDateDisabled(date, min, max, disabledDates) || (dateFilterFn ? !dateFilterFn(date) : false);
    }
    return isDateDisabled(date, minDate, maxDate, disabledDates) || (dateFilterFn ? !dateFilterFn(date) : false);
  }
  calendarCellTitle(date) {
    return date.toLocaleDateString(this.locale());
  }
  handleCellMouseEnter(hoverDate) {
    if (!hoverDate) {
      return;
    }
    const selectionType = this.selectionType();
    const updateHoverValue = ['day', 'week'].includes(selectionType) && this.view() === 'days' || ['month'].includes(selectionType) && this.view() === 'months' || ['year'].includes(selectionType) && this.view() === 'years';
    // if (updateHoverValue) {
    const hoverValue = this.isDateDisabled(hoverDate) || !updateHoverValue ? null : hoverDate;
    this.#calendarService.update({
      hoverDate: hoverValue
    });
    // }
  }
  handleYearCellClick(year) {
    if (this.selectionType() === 'year') {
      let date = new Date(year, 0, 1, 0, 0, 0, 0);
      if (this.range() && this.startDate() && !this.endDate()) {
        date = new Date(date.getFullYear(), 12, 1, 0, 0, -1, 0);
      }
      this.handleDayCellClick(date);
      return;
    }
    const calendarDate = new Date(year, 0, 1, 0, 0, 0, 0);
    this.view.set('months');
    this.#calendarService.update({
      view: this.view(),
      calendarDate: calendarDate
    });
  }
  handleYearCellKeyUp($event, date) {
    if (!date) {
      return;
    }
    if (['Space', 'Enter'].includes($event.code)) {
      this.handleYearCellClick(date.getFullYear());
      return;
    }
    if (['Tab', 'ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown'].includes($event.code)) {
      this.handleCellMouseEnter(new Date(date));
      return;
    }
  }
  handleMonthCellKeyUp($event, date) {
    if (!date) {
      return;
    }
    if (['Space', 'Enter'].includes($event.code)) {
      this.handleMonthCellClick(date);
      return;
    }
    if (['Tab', 'ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown'].includes($event.code)) {
      this.handleCellMouseEnter(date);
      return;
    }
  }
  handleMonthCellClick(value) {
    if (!value) {
      return;
    }
    if (this.selectionType() === 'month') {
      let date = new Date(value.getFullYear(), value.getMonth(), 1, 0, 0, 0, 0);
      if (this.range() && this.startDate() && !this.endDate()) {
        date = new Date(date.getFullYear(), date.getMonth() + 1, 1, 0, 0, -1, 0);
      }
      this.handleDayCellClick(date);
      return;
    }
    this.view.set('days');
    this.#calendarService.update({
      view: this.view()
    });
    // this.setCalendarPage(0, 0, value.getMonth() - this.addMonths());
    const calendarDate = new Date(value.getFullYear(), value.getMonth() - this.addMonths(), 1, 0, 0, 0, 0);
    this.#calendarService.update({
      calendarDate: calendarDate
    });
  }
  setCalendarPage(years, months = 0, setMonth) {
    const year = this.date().getFullYear();
    const month = this.date().getMonth();
    const d = new Date(year, month, 1, 0, 0, 0, 0);
    years && d.setFullYear(d.getFullYear() + years);
    months && d.setMonth(d.getMonth() + months);
    typeof setMonth === 'number' && d.setMonth(setMonth);
    this.#calendarService.update({
      calendarDate: d
    });
  }
  handleDayCellKeyDown($event, date) {
    if (!date) {
      return;
    }
    if (!['Tab', 'ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown'].includes($event.code)) {
      return;
    }
    $event.preventDefault();
    this.handleCellMouseEnter(date);
    const eventKey = $event.key === 'Tab' ? $event.shiftKey ? 'ArrowLeft' : 'ArrowRight' : $event.key;
    const selectionType = this.selectionType();
    const view = this.view();
    const maxDate = this.maxDate();
    if (maxDate && date >= convertToDateObject(maxDate, selectionType) && ['ArrowRight', 'ArrowDown'].includes(eventKey)) {
      return;
    }
    const minDate = this.minDate();
    if (minDate && date <= convertToDateObject(minDate, selectionType) && ['ArrowLeft', 'ArrowUp'].includes(eventKey)) {
      return;
    }
    let element = $event.target;
    if (selectionType === 'week' && view === 'days' && element.tabIndex === -1) {
      element = element.closest('tr[tabindex="0"]');
    }
    const elements = ['week'].includes(selectionType) && view === 'days' ? this.calendarRows : this.calendarDays;
    const list = elements.toArray().map(calendarCell => calendarCell.elementRef.nativeElement)
    // .filter((element) => this.selectionType === 'week' ? element?.tabIndex === 0 : element?.classList.contains('current'))
    .filter(element => element?.tabIndex === 0);
    const index = list.indexOf(element);
    const first = index === 0;
    const last = index === list.length - 1;
    const toBoundary = {
      start: index,
      end: list.length - (index + 1)
    };
    const gap = {
      ArrowRight: 1,
      ArrowLeft: -1,
      ArrowUp: selectionType === 'week' && view === 'days' ? -1 : view === 'days' ? -7 : -3,
      ArrowDown: selectionType === 'week' && view === 'days' ? 1 : view === 'days' ? 7 : 3
    };
    if (eventKey === 'ArrowRight' && last || eventKey === 'ArrowDown' && toBoundary.end < gap.ArrowDown || eventKey === 'ArrowLeft' && first || eventKey === 'ArrowUp' && toBoundary.start < Math.abs(gap.ArrowUp)) {
      elements.changes.pipe(take(1), takeUntilDestroyed(this.#destroyRef)).subscribe(change => {
        const _list = change.toArray()
        // .filter(element => this.selectionType === 'week' ? element?.elementRef.nativeElement.tabIndex === 0 : element?.elementRef.nativeElement.classList.contains('current'));
        .filter(directive => directive?.elementRef.nativeElement.tabIndex === 0);
        if (_list.length) {
          let dayToFocus;
          switch (eventKey) {
            case 'ArrowRight':
              {
                dayToFocus = _list[0];
                break;
              }
            case 'ArrowLeft':
              {
                dayToFocus = _list[_list.length - 1];
                break;
              }
            case 'ArrowDown':
              {
                dayToFocus = _list[gap.ArrowDown - (list.length - index)];
                break;
              }
            case 'ArrowUp':
              {
                dayToFocus = _list[_list.length - (Math.abs(gap.ArrowUp) + 1 - (index + 1))];
                break;
              }
          }
          if (!dayToFocus?.disabled) {
            // console.log('dayToFocus', dayToFocus?.date);
            dayToFocus?.focus('keyboard');
          }
        }
      });
      switch (view) {
        case 'days':
          this.setCalendarPage(0, ['ArrowRight', 'ArrowDown'].includes(eventKey) ? 1 : -1);
          break;
        case 'months':
          this.setCalendarPage(['ArrowRight', 'ArrowDown'].includes(eventKey) ? 1 : -1);
          break;
        case 'years':
          this.setCalendarPage(['ArrowRight', 'ArrowDown'].includes(eventKey) ? 12 : -12);
          break;
      }
      return;
    }
    // @ts-ignore
    const nextElement = list[index + gap[eventKey]];
    if (nextElement?.tabIndex === 0) {
      nextElement.focus();
      return;
    }
    for (let i = index; i < list.length; list.length && ['ArrowRight', 'ArrowDown'].includes(eventKey) ? i++ : i--) {
      // @ts-ignore
      const nextElement = list[i + gap[eventKey]];
      if (nextElement?.tabIndex === 0) {
        // @ts-ignore
        nextElement?.focus();
        break;
      }
      // @ts-ignore
      if (!nextElement) {
        break;
      }
    }
  }
  handleCellMouseLeave() {
    this.#calendarService.update({
      hoverDate: null
    });
  }
  handleDayCellKeyUp($event, date) {
    if (['Space', 'Enter'].includes($event.code)) {
      this.handleDayCellClick(date);
      return;
    }
    if (['Tab', 'ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown'].includes($event.code)) {
      this.handleCellMouseEnter(date);
      return;
    }
  }
  handleDayCellClick(date) {
    if (this.selectionType() === 'day' && this.isDateDisabled(date)) {
      return;
    }
    if (!this.range()) {
      this.endDate.set(null);
      this.startDate.set(date);
      return;
    }
    const startDate = this.startDate();
    const endDate = this.endDate();
    if (startDate && endDate) {
      this.startDate.set(null);
      this.endDate.set(null);
      return;
    }
    if (!!startDate && !endDate) {
      if (startDate && date < startDate) {
        this.endDate.set(null);
        this.startDate.set(date);
      } else {
        const addDays = this.selectionType() !== 'week' ? 1 : 7;
        this.endDate.set(new Date(date.getFullYear(), date.getMonth(), date.getDate() + addDays, 0, 0, -1, 0));
      }
    } else {
      this.endDate.set(null);
      this.startDate.set(date);
    }
    {
      const startDate = this.startDate();
      const endDate = this.endDate();
      if (startDate && endDate) {
        const dateFilterFn = this.dateFilter();
        if (isDateInRangeDisabled(startDate, endDate, this.disabledDates(), dateFilterFn)) {
          this.startDate.set(null);
          this.endDate.set(null);
          return;
        }
      }
    }
  }
  calendarStateSubscribe() {
    this.#calendarService.calendarState$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(state => {
      const keys = Object.keys(state);
      for (const key of keys) {
        if (key in this) {
          // @ts-ignore
          const isWritableSignal = typeof this[key] === 'function' && typeof this[key].set === 'function';
          // @ts-ignore
          isWritableSignal ? this[key].set(state[key]) : this[key] = state[key];
        }
      }
    });
  }
  getMonthStart(index) {
    return new Date(this.calendarDate().getFullYear(), index + this.addMonths(), 1, 0, 0, 0, 0);
  }
  getMonthEnd(index) {
    return new Date(this.calendarDate().getFullYear(), index + 1 + this.addMonths(), 1, 0, 0, -1, 0);
  }
  getYearStart(year) {
    return new Date(year, 0, 1);
  }
  getYearEnd(year) {
    return new Date(year, 11, 1, 0, 0, -1, 0);
  }
  static {
    this.ɵfac = function CalendarMonthComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalendarMonthComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CalendarMonthComponent,
      selectors: [["c-calendar-month"]],
      viewQuery: function CalendarMonthComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(CalendarDayDirective, 5);
          i0.ɵɵviewQuery(CalendarRowDirective, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.calendarDays = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.calendarRows = _t);
        }
      },
      inputs: {
        pageIndex: [1, "pageIndex"]
      },
      exportAs: ["cCalendarMonth"],
      decls: 6,
      vars: 2,
      consts: [["calendarYear", "cCalendarDay"], ["calendarMonth", "cCalendarDay"], ["calendarRow", "cCalendarRow"], ["calendarCell", "cCalendarDay"], [3, "mouseleave"], [1, "calendar-cell"], [1, "calendar-cell", 3, "abbr"], [1, "calendar-header-cell-inner"], ["cCalendarDay", "", 3, "date", "ngClass", "tabindex"], ["cCalendarDay", "", 3, "click", "keydown", "keyup", "mouseenter", "date", "ngClass", "tabindex"], [1, "calendar-cell-inner"], [3, "cCalendarRow"], [3, "click", "keydown", "keyup", "mouseenter", "cCalendarRow"], [1, "calendar-cell-week-number"], ["cCalendarDay", "", 3, "date", "month", "ngClass", "tabindex"], ["cCalendarDay", "", 3, "click", "keydown", "keyup", "mouseenter", "date", "month", "ngClass", "tabindex"]],
      template: function CalendarMonthComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "table");
          i0.ɵɵtemplate(1, CalendarMonthComponent_Conditional_1_Template, 5, 1, "thead");
          i0.ɵɵelementStart(2, "tbody", 4);
          i0.ɵɵlistener("mouseleave", function CalendarMonthComponent_Template_tbody_mouseleave_2_listener() {
            return ctx.handleCellMouseLeave();
          });
          i0.ɵɵtemplate(3, CalendarMonthComponent_Case_3_Template, 2, 0)(4, CalendarMonthComponent_Case_4_Template, 2, 0)(5, CalendarMonthComponent_Case_5_Template, 4, 2);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          let tmp_1_0;
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.view() === "days" ? 1 : -1);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional((tmp_1_0 = ctx.view()) === "years" ? 3 : tmp_1_0 === "months" ? 4 : 5);
        }
      },
      dependencies: [CalendarDayDirective, CalendarDayPipe, CalendarDayTitlePipe, CalendarRowDirective, CalendarClassDayPipe, CalendarClassMonthPipe, CalendarClassYearPipe, CalendarWeekdayPipe, NgClass],
      styles: [".btn-transparent[_ngcontent-%COMP%]:focus-visible{outline:-webkit-focus-ring-color auto 1px}.calendar-row[_ngcontent-%COMP%]:focus-visible{box-shadow:var(--cui-calendar-cell-focus-box-shadow);border-radius:.375rem}.calendar-row[_ngcontent-%COMP%]:focus-within:not([tabindex=\"-1\"]){outline:0;box-shadow:var(--cui-calendar-cell-focus-box-shadow);border-radius:.375rem;outline-style:auto!important}.calendar-row[_ngcontent-%COMP%]:focus:not([tabindex=\"-1\"]){outline:0;box-shadow:var(--cui-calendar-cell-focus-box-shadow);border-radius:.375rem;outline-style:auto!important}.calendar-cell[_ngcontent-%COMP%]:focus:not(:focus-visible):not([tabindex=\"-1\"]){box-shadow:var(--cui-calendar-cell-focus-box-shadow);border-radius:.375rem}.calendar-cell-inner[_ngcontent-%COMP%]{-webkit-user-select:none;user-select:none}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CalendarMonthComponent, [{
    type: Component,
    args: [{
      selector: 'c-calendar-month',
      exportAs: 'cCalendarMonth',
      imports: [CalendarDayDirective, CalendarDayPipe, CalendarDayTitlePipe, CalendarRowDirective, CalendarClassDayPipe, CalendarClassMonthPipe, CalendarClassYearPipe, CalendarWeekdayPipe, NgClass],
      template: "<table>\n  @if (view() === 'days') {\n    <thead>\n    <tr>\n      @if (showWeekNumber()) {\n        <th class=\"calendar-cell\">\n          <div class=\"calendar-header-cell-inner\">{{ weekNumbersLabel() }}</div>\n        </th>\n      }\n      @for (weekDay of weekDays(); track weekDay.date; let i = $index) {\n        @let date = weekDay.date ;\n        <th class=\"calendar-cell\" abbr=\"{{date | calendarWeekday:'long':locale()}}\">\n          <div class=\"calendar-header-cell-inner\">\n            {{ date | calendarWeekday:weekdayFormat():locale() }}\n          </div>\n        </th>\n      }\n    </tr>\n    </thead>\n  }\n  <tbody (mouseleave)=\"handleCellMouseLeave()\">\n    @switch (view()) {\n      @case ('years') {\n        @for (yearsRow of listOfYears(); track yearsRow[0]; let rowIdx = $index) {\n          <tr>\n            @for (year of yearsRow; track year; let idx = $index) {\n              <td\n                #calendarYear=\"cCalendarDay\"\n                (click)=\"!calendarYear.disabled$() && handleYearCellClick(year)\"\n                (keydown)=\"calendarYear.date() && handleDayCellKeyDown($event, calendarYear.date())\"\n                (keyup)=\"handleYearCellKeyUp($event, calendarYear.date())\"\n                (mouseenter)=\"calendarYear.date() && handleCellMouseEnter(calendarYear.date())\"\n                [attr.aria-label]=\"calendarYear.date()?.getFullYear()\"\n                [date]=\"getYearStart(year)\"\n                [ngClass]=\"year | calendarClassYear\"\n                [tabindex]=\"calendarYear.disabled$() ? -1 : 0\"\n                cCalendarDay\n              >\n                <div class=\"calendar-cell-inner\">\n                  {{ yearNumber(year) }}\n                </div>\n              </td>\n            }\n          </tr>\n        }\n      }\n      @case ('months') {\n        @for (monthsRow of listOfMonths(); track monthsRow[0]; let rowIdx = $index) {\n          <tr>\n            @for (month of monthsRow; track month; let idx = $index) {\n              @let monthStart = getMonthStart(rowIdx*3+idx);\n              <td\n                #calendarMonth=\"cCalendarDay\"\n                (click)=\"!calendarMonth.disabled$() && handleMonthCellClick(calendarMonth.date())\"\n                (keydown)=\"calendarMonth.date() && handleDayCellKeyDown($event, calendarMonth.date())\"\n                (keyup)=\"handleMonthCellKeyUp($event, calendarMonth.date())\"\n                (mouseenter)=\"calendarMonth.date() && handleCellMouseEnter(calendarMonth.date())\"\n                [attr.aria-label]=\"calendarMonth.date()?.getFullYear()+' '+month.month\"\n                [date]=\"monthStart\"\n                [ngClass]=\"monthStart | calendarClassMonth:(rowIdx*3+idx)\"\n                [tabindex]=\"calendarMonth.disabled$() ? -1 : 0\"\n                cCalendarDay\n              >\n                <div class=\"calendar-cell-inner\">\n                  {{ month.month }}\n                </div>\n              </td>\n            }\n          </tr>\n        }\n\n      }\n      @default {\n        @let weekSelection = selectionType() === 'week';\n        @let daySelection = selectionType() === 'day';\n        @for (week of monthDetails(); track week.days[0]; let i = $index) {\n          <tr #calendarRow=\"cCalendarRow\"\n              (click)=\"weekSelection && (calendarRow.current) && calendarRow.date && handleDayCellClick(calendarRow.date)\"\n              (keydown)=\"weekSelection && (calendarRow.current) && calendarRow.date && handleDayCellKeyDown($event, calendarRow.date)\"\n              (keyup)=\"weekSelection && (calendarRow.current) && calendarRow.date && handleDayCellKeyUp($event, calendarRow.date)\"\n              (mouseenter)=\"weekSelection && calendarRow.date && handleCellMouseEnter(calendarRow.date)\"\n              [cCalendarRow]=\"week\"\n          >\n            @if (showWeekNumber()) {\n              <th class=\"calendar-cell-week-number\">\n                {{ week.weekNumber === 0 ? 53 : week.weekNumber }}\n              </th>\n            }\n            @for (dateObj of week.days; track dateObj.date; let idx = $index) {\n              @let currentMonth = dateObj.month === 'current';\n              @if (currentMonth || showAdjacentDays()) {\n                @let selectable = daySelection && (currentMonth || selectAdjacentDays());\n                <td #calendarCell=\"cCalendarDay\"\n                    (click)=\"selectable && handleDayCellClick(dateObj.date)\"\n                    (keydown)=\"selectable && handleDayCellKeyDown($event, dateObj.date)\"\n                    (keyup)=\"selectable && handleDayCellKeyUp($event, dateObj.date)\"\n                    (mouseenter)=\"selectable && handleCellMouseEnter(dateObj.date)\"\n                    [attr.aria-label]=\"dateObj.date | calendarDayTitle:locale()\"\n                    [date]=\"dateObj.date\"\n                    [month]=\"dateObj.month\"\n                    [ngClass]=\"dateObj | calendarClassDay:{minDate: minDate(), maxDate: maxDate(), disabledDates: disabledDates(), dateFilter: dateFilter()}\"\n                    [tabindex]=\"selectable && !isDateDisabled(dateObj.date) ? 0 : -1\"\n                    cCalendarDay\n                >\n                  <div class=\"calendar-cell-inner\">\n                    {{ dateObj.date | calendarDay:dayFormat():locale() }}\n                  </div>\n                </td>\n              } @else {\n                <td class=\"calendar-cell\"></td>\n              }\n            }\n          </tr>\n        }\n      }\n    }\n  </tbody>\n</table>\n\n",
      styles: [".btn-transparent:focus-visible{outline:-webkit-focus-ring-color auto 1px}.calendar-row:focus-visible{box-shadow:var(--cui-calendar-cell-focus-box-shadow);border-radius:.375rem}.calendar-row:focus-within:not([tabindex=\"-1\"]){outline:0;box-shadow:var(--cui-calendar-cell-focus-box-shadow);border-radius:.375rem;outline-style:auto!important}.calendar-row:focus:not([tabindex=\"-1\"]){outline:0;box-shadow:var(--cui-calendar-cell-focus-box-shadow);border-radius:.375rem;outline-style:auto!important}.calendar-cell:focus:not(:focus-visible):not([tabindex=\"-1\"]){box-shadow:var(--cui-calendar-cell-focus-box-shadow);border-radius:.375rem}.calendar-cell-inner{-webkit-user-select:none;user-select:none}\n"]
    }]
  }], () => [], {
    calendarDays: [{
      type: ViewChildren,
      args: [CalendarDayDirective]
    }],
    calendarRows: [{
      type: ViewChildren,
      args: [CalendarRowDirective]
    }]
  });
})();
class CalendarClassViewPipe {
  transform(view) {
    return {
      calendar: true,
      [`${view}`]: !!view
    };
  }
  static {
    this.ɵfac = function CalendarClassViewPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalendarClassViewPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "calendarClassView",
      type: CalendarClassViewPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CalendarClassViewPipe, [{
    type: Pipe,
    args: [{
      name: 'calendarClassView',
      standalone: true
    }]
  }], null, null);
})();
class CalendarComponent {
  constructor() {
    this.#destroyRef = inject(DestroyRef);
    this.#calendarService = inject(CalendarService);
    this.calendarDateChange = output();
    /**
     * Default date of the component
     * @type  Date | string
     */
    this.calendarDateModel = model(new Date(new Date().setDate(1)).setHours(0, 0, 0, 0), {
      alias: 'calendarDate'
    });
    this.calendarDate = computed(() => {
      const date = convertToDateObject(this.calendarDateModel() ?? this.startDate() ?? new Date(), this.selectionType(), 'calendarDate') ?? new Date();
      const calendarDate = new Date(new Date(date.setDate(1)).setHours(0, 0, 0, 0));
      return convertToDateObject(calendarDate, this.selectionType(), 'calendarDate');
    }, {
      equal: equalDates
    });
    this.calendarDateEffect = effect(() => {
      this.#calendarService.update({
        calendarDate: this.calendarDate()
      });
      this.calendarDateChange.emit(this.calendarDate());
    });
    /**
     * The number of calendars that render on desktop devices.
     * @type number
     * default 1
     */
    this.calendars = input(1, {
      transform: numberAttribute
    });
    this.calendarsArray = computed(() => {
      const calendars = ['month', 'year'].includes(this.selectionType()) ? 1 : this.calendars();
      return Array.from({
        length: calendars
      }, (v, i) => i);
    });
    /**
     * Set the format of day name.
     * @default 'numeric'
     * @type DayFormatType
     */
    this.dayFormat = input('numeric');
    this.dayFormatEffect = effect(() => {
      this.#calendarService.update({
        dayFormat: this.dayFormat()
      });
    });
    /**
     * Specify the list of dates that cannot be selected.
     * @type (Date | Date[])[]
     */
    this.disabledDates = input([]);
    this.disabledDatesEffect = effect(() => {
      this.#calendarService.update({
        disabledDates: this.disabledDates()
      });
    });
    this.endDateChange = output();
    this.startDateChange = output();
    /**
     * Initial selected date.
     * @type  (Date | null)
     */
    this.startDateModel = model(null, {
      alias: 'startDate'
    });
    this.startDate = computed(() => {
      const date = this.startDateModel() ?? null;
      return !!date ? convertToDateObject(date, this.selectionType(), 'startDate') : null;
    }, {
      equal: equalDates
    });
    /**
     * Initial selected to date (range).
     * @type Date | null
     */
    this.endDateModel = model(null, {
      alias: 'endDate'
    });
    this.endDate = computed(() => {
      const date = this.endDateModel() ?? null;
      return !!date && this.range() ? convertToDateObject(date, this.selectionType(), 'endDate') : null;
    }, {
      equal: equalDates
    });
    this.#datesEffect = effect(() => {
      const startDate = this.startDate();
      const endDate = this.endDate();
      this.#calendarService.update({
        startDate: startDate,
        endDate: endDate
      });
      this.startDateChange.emit(startDate);
      this.endDateChange.emit(endDate);
    });
    /**
     * Sets the day of start week.
     * - 0 - Sunday,
     * - 1 - Monday,
     * - 2 - Tuesday,
     * - 3 - Wednesday,
     * - 4 - Thursday,
     * - 5 - Friday,
     * - 6 - Saturday,
     *
     * @type number
     * @default 1
     */
    this.firstDayOfWeek = input(1);
    this.firstDayOfWeekEffect = effect(() => {
      this.#calendarService.update({
        firstDayOfWeek: this.firstDayOfWeek()
      });
    });
    /**
     * Sets the default locale for components. If not set, it is inherited from the browser.
     * @default 'default'
     */
    this.locale = input('default');
    this.localeEffect = effect(() => {
      this.#calendarService.update({
        locale: this.locale()
      });
    });
    /**
     * Max selectable date.
     */
    this.maxDateInput = input(null, {
      alias: 'maxDate'
    });
    this.maxDateEffect = effect(() => {
      const date = this.maxDateInput();
      const maxDate = !!date ? convertToDateObject(date, undefined, 'maxDate') : null;
      this.#calendarService.update({
        maxDate: maxDate
      });
    });
    /**
     * Min selectable date.
     */
    this.minDateInput = input(null, {
      alias: 'minDate'
    });
    this.minDateEffect = effect(() => {
      const date = this.minDateInput();
      const minDate = !!date ? convertToDateObject(date, undefined, 'minDate') : null;
      this.#calendarService.update({
        minDate: minDate
      });
    });
    /**
     * Show navigation.
     * @type boolean
     */
    this.navigation = input(true, {
      transform: booleanAttribute
    });
    /**
     * Reorder year-month navigation, and render year first.
     * @type boolean
     * @default false
     */
    this.navYearFirst = input(false, {
      transform: booleanAttribute
    });
    this.navYearFirstEffect = effect(() => {
      this.#calendarService.update({
        navYearFirst: this.navYearFirst()
      });
    });
    /**
     * Allow range selection.
     * @type boolean
     * @default false
     */
    this.range = input(false, {
      transform: booleanAttribute
    });
    this.rangeEffect = effect(() => {
      this.#calendarService.update({
        range: this.range()
      });
    });
    /**
     * Set calendar view.
     * @type 'days' | 'months' | 'years'
     * @default 'days'
     */
    this.view = model('days');
    this.viewEffect = effect(() => {
      this.#calendarService.update({
        view: this.view()
      });
    });
    /**
     * Set length or format of day name.
     * @type number | 'long' | 'narrow' | 'short'
     * @default 'short'
     */
    this.weekdayFormat = input('short');
    this.weekdayFormatEffect = effect(() => {
      this.#calendarService.update({
        weekdayFormat: this.weekdayFormat()
      });
    });
    this.dateFilter = input();
    this.dateFilterEffect = effect(() => {
      this.#calendarService.update({
        dateFilter: this.dateFilter()
      });
    });
    /**
     * Set whether days in adjacent months shown before or after the current month are selectable. This only applies if the `showAdjacentDays` option is set to true.
     * @type boolean
     * @default false
     * @since 4.4.10
     */
    this.selectAdjacentDays = input(false, {
      transform: booleanAttribute
    });
    this.selectAdjacentDaysEffect = effect(() => {
      this.#calendarService.update({
        selectAdjacentDays: this.selectAdjacentDays()
      });
    });
    /**
     * Set whether to display dates in adjacent months (non-selectable) at the start and end of the current month.
     * @type boolean
     * @default true
     * @since 4.4.10
     */
    this.showAdjacentDays = input(true, {
      transform: booleanAttribute
    });
    this.showAdjacentDaysEffect = effect(() => {
      this.#calendarService.update({
        showAdjacentDays: this.showAdjacentDays()
      });
    });
    /**
     * Specify the type of date selection as day, week, month, or year.
     * @type 'day' | 'week' | 'month' | 'year'
     * @default 'day'
     * @since 5.0.0
     */
    this.selectionType = input('day');
    this.selectionTypeEffect = effect(() => {
      const selectionType = this.selectionType();
      const view = ['day', 'week'].includes(selectionType) ? 'days' : selectionType === 'month' ? 'months' : 'years';
      this.#calendarService.update({
        selectionType: selectionType,
        view: view
      });
    });
    /**
     * Set whether to display week numbers in the calendar.
     * @type boolean
     * @default false
     * @since 5.0.0
     */
    this.showWeekNumber = input(false, {
      transform: booleanAttribute
    });
    this.showWeekNumberEffect = effect(() => {
      this.#calendarService.update({
        showWeekNumber: this.showWeekNumber()
      });
    });
    /**
     * Label displayed over week numbers in the calendar.
     * @type string
     * @default undefined
     * @since 5.0.0
     */
    this.weekNumbersLabel = input();
    this.weekNumbersLabelEffect = effect(() => {
      this.#calendarService.update({
        weekNumbersLabel: this.weekNumbersLabel()
      });
    });
    this.ariaNextMonthLabel = input('Next month');
    this.ariaNextYearLabel = input('Next year');
    this.ariaPrevMonthLabel = input('Previous month');
    this.ariaPrevYearLabel = input('Previous year');
    this.calendarCellHover = output();
    // used with calendarService
    this.hoverDate = signal(null);
    this.hoverDateEffect = effect(() => {
      this.calendarCellHover.emit(this.hoverDate());
    });
    this.hostClasses = computed(() => {
      const selectionType = this.selectionType();
      const view = this.view();
      return {
        calendars: true,
        [`select-${selectionType}`]: selectionType && view === 'days',
        'show-week-numbers': this.showWeekNumber()
      };
    });
  }
  #destroyRef;
  #calendarService;
  #datesEffect;
  // @ViewChildren(CalendarMonthComponent) calendarMonths!: QueryList<CalendarMonthComponent>;
  ngOnInit() {
    this.#calendarService.update({
      locale: this.locale() ?? 'default',
      view: this.view(),
      range: this.range(),
      selectionType: this.selectionType()
      // showAdjacentDays: this.showAdjacentDays,
      // selectAdjacentDays: this.selectAdjacentDays
    });
  }
  ngAfterViewInit() {
    // setTimeout(() => {
    this.calendarStateSubscribe();
    // });
  }
  calendarStateSubscribe() {
    const inputs = ['dateFilter', 'dayFormat', 'disabledDates', 'firstDayOfWeek', 'locale', 'maxDate', 'minDate', 'navYearFirst', 'range', 'selectAdjacentDays', 'selectionType', 'showAdjacentDays', 'showWeekNumber', 'weekdayFormat', 'weekNumbersLabel'];
    // const models = ['startDate', 'endDate', 'calendarDate'];
    this.#calendarService?.calendarState$.pipe(debounceTime(1), takeUntilDestroyed(this.#destroyRef)).subscribe(state => {
      const keys = Object.keys(state);
      for (const key of keys) {
        if (key in this) {
          if (inputs.includes(key)) {
            continue;
          }
          // if (models.includes(key) && state[key] !== undefined) {
          //   const model = `${key}Model`;
          //   // @ts-ignore
          //   this[model].set(state[key]);
          // }
          if (key === 'startDate') {
            this.startDateModel.set(state[key]);
            continue;
          }
          if (key === 'endDate') {
            this.endDateModel.set(state[key]);
            continue;
          }
          if (key === 'calendarDate') {
            this.calendarDateModel.set(state[key]);
            continue;
          }
          if (key === 'view') {
            this.view.set(state[key]);
            continue;
          }
          // @ts-ignore
          const isWritableSignal = typeof this[key] === 'function' && typeof this[key].set === 'function';
          // @ts-ignore
          const isReadonlySignal = typeof this[key] === 'function' && typeof this[key].set === 'undefined';
          // @ts-ignore
          if (isWritableSignal && !isReadonlySignal ? this[key]() !== state[key] : this[key] !== state[key]) {
            // @ts-ignore
            isWritableSignal ? this[key].set(state[key]) : this[key] = state[key];
            // this[key] = state[key];
          }
        }
      }
    });
  }
  setCalendarPage(years, months = 0, setMonth) {
    const calendarDate = this.calendarDate();
    const year = calendarDate.getFullYear();
    const month = calendarDate.getMonth();
    const d = new Date(year, month, 1);
    years && d.setFullYear(d.getFullYear() + years);
    months && d.setMonth(d.getMonth() + months);
    typeof setMonth === 'number' && d.setMonth(setMonth);
    this.calendarDateModel.set(d);
  }
  handleNavigationClick(direction, years = false) {
    const view = this.view();
    if (direction === 'prev') {
      if (years) {
        this.setCalendarPage(view === 'years' ? -10 : -1);
        return;
      }
      if (view !== 'days') {
        this.setCalendarPage(-1);
        return;
      }
      this.setCalendarPage(0, -1);
      return;
    }
    if (direction === 'next') {
      if (years) {
        this.setCalendarPage(view === 'years' ? 10 : 1);
        return;
      }
      if (view !== 'days') {
        this.setCalendarPage(1);
        return;
      }
      this.setCalendarPage(0, 1);
      return;
    }
  }
  /**
   * Clear startDate and endDate
   * @type void
   */
  clearDates() {
    this.#calendarService.update({
      startDate: null,
      endDate: null
    });
  }
  handleFocusChange($event) {
    if ($event === null) {
      this.#calendarService.update({
        hoverDate: null
      });
    }
  }
  static {
    this.ɵfac = function CalendarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalendarComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CalendarComponent,
      selectors: [["c-calendar"]],
      hostAttrs: [1, "calendar"],
      hostVars: 2,
      hostBindings: function CalendarComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        calendarDateModel: [1, "calendarDate", "calendarDateModel"],
        calendars: [1, "calendars"],
        dayFormat: [1, "dayFormat"],
        disabledDates: [1, "disabledDates"],
        startDateModel: [1, "startDate", "startDateModel"],
        endDateModel: [1, "endDate", "endDateModel"],
        firstDayOfWeek: [1, "firstDayOfWeek"],
        locale: [1, "locale"],
        maxDateInput: [1, "maxDate", "maxDateInput"],
        minDateInput: [1, "minDate", "minDateInput"],
        navigation: [1, "navigation"],
        navYearFirst: [1, "navYearFirst"],
        range: [1, "range"],
        view: [1, "view"],
        weekdayFormat: [1, "weekdayFormat"],
        dateFilter: [1, "dateFilter"],
        selectAdjacentDays: [1, "selectAdjacentDays"],
        showAdjacentDays: [1, "showAdjacentDays"],
        selectionType: [1, "selectionType"],
        showWeekNumber: [1, "showWeekNumber"],
        weekNumbersLabel: [1, "weekNumbersLabel"],
        ariaNextMonthLabel: [1, "ariaNextMonthLabel"],
        ariaNextYearLabel: [1, "ariaNextYearLabel"],
        ariaPrevMonthLabel: [1, "ariaPrevMonthLabel"],
        ariaPrevYearLabel: [1, "ariaPrevYearLabel"]
      },
      outputs: {
        calendarDateChange: "calendarDateChange",
        calendarDateModel: "calendarDateChange",
        endDateChange: "endDateChange",
        startDateChange: "startDateChange",
        startDateModel: "startDateChange",
        endDateModel: "endDateChange",
        view: "viewChange",
        calendarCellHover: "calendarCellHover"
      },
      exportAs: ["cCalendar"],
      features: [i0.ɵɵProvidersFeature([CalendarService])],
      decls: 2,
      vars: 0,
      consts: [[3, "ngClass"], [3, "navigationClick", "pageIndex", "navigation", "ariaNextMonthLabel", "ariaNextYearLabel", "ariaPrevMonthLabel", "ariaPrevYearLabel"], ["cdkMonitorSubtreeFocus", "", 3, "cdkFocusChange", "pageIndex"]],
      template: function CalendarComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵrepeaterCreate(0, CalendarComponent_For_1_Template, 4, 10, "div", 0, i0.ɵɵrepeaterTrackByIdentity);
        }
        if (rf & 2) {
          i0.ɵɵrepeater(ctx.calendarsArray());
        }
      },
      dependencies: [CalendarNavigationComponent, CalendarClassViewPipe, CalendarMonthComponent, NgClass, A11yModule, i1$1.CdkMonitorFocus],
      styles: [".btn-transparent[_ngcontent-%COMP%]:focus-visible{outline:-webkit-focus-ring-color auto 1px}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CalendarComponent, [{
    type: Component,
    args: [{
      selector: 'c-calendar',
      exportAs: 'cCalendar',
      providers: [CalendarService],
      imports: [CalendarNavigationComponent, CalendarClassViewPipe, CalendarMonthComponent, NgClass, A11yModule],
      host: {
        class: 'calendar',
        '[class]': 'hostClasses()'
      },
      template: "@for (calendar of calendarsArray(); track calendar; let i = $index) {\n  <div [ngClass]=\"view() | calendarClassView\">\n    <c-calendar-navigation\n      (navigationClick)=\"handleNavigationClick($event.direction, $event.years)\"\n      [pageIndex]=\"i\"\n      [navigation]=\"navigation()\"\n      [ariaNextMonthLabel]=\"ariaNextMonthLabel()\"\n      [ariaNextYearLabel]=\"ariaNextYearLabel()\"\n      [ariaPrevMonthLabel]=\"ariaPrevMonthLabel()\"\n      [ariaPrevYearLabel]=\"ariaPrevYearLabel()\"\n    />\n\n    <c-calendar-month\n      [pageIndex]=\"i\"\n      cdkMonitorSubtreeFocus\n      (cdkFocusChange)=\"handleFocusChange($event)\"\n    />\n  </div>\n}\n",
      styles: [".btn-transparent:focus-visible{outline:-webkit-focus-ring-color auto 1px}\n"]
    }]
  }], null, null);
})();
class CalendarClassRowPipe {
  transform(week, datesConfig) {
    const {
      minDate,
      maxDate,
      disabledDates,
      dateFilter,
      calendarDate,
      selectionType
    } = {
      ...datesConfig
    };
    const date = convertToDateObject(week.weekNumber === 0 ? `${calendarDate.getFullYear()}W53` : `${calendarDate.getFullYear()}W${week.weekNumber}`, selectionType);
    const isDisabled = isDateDisabled(date, minDate, maxDate, disabledDates) || (dateFilter ? !dateFilter(date) : false);
    return {
      'calendar-row': true,
      disabled: isDisabled
    };
  }
  static {
    this.ɵfac = function CalendarClassRowPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalendarClassRowPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "calendarClassRow",
      type: CalendarClassRowPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CalendarClassRowPipe, [{
    type: Pipe,
    args: [{
      name: 'calendarClassRow',
      standalone: true
    }]
  }], null, null);
})();
class CalendarModule {
  static {
    this.ɵfac = function CalendarModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalendarModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CalendarModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CalendarComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CalendarModule, [{
    type: NgModule,
    args: [{
      imports: [CalendarComponent, CalendarClassYearPipe, CalendarClassDayPipe, CalendarClassMonthPipe, CalendarDayDirective, CalendarClassViewPipe, CalendarNavigationComponent, CalendarMonthComponent, CalendarDayPipe, CalendarWeekdayPipe, CalendarDayTitlePipe, CalendarClassRowPipe],
      exports: [CalendarComponent, CalendarMonthComponent, CalendarNavigationComponent]
    }]
  }], null, null);
})();
class CalloutComponent {
  constructor() {
    /**
     * Sets the color context of the component to one of CoreUI’s themed colors.
     * @type Colors
     */
    this.color = input();
    this.hostClasses = computed(() => {
      const color = this.color();
      return {
        callout: true,
        [`callout-${color}`]: !!color
      };
    });
  }
  static {
    this.ɵfac = function CalloutComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalloutComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CalloutComponent,
      selectors: [["c-callout"], ["", "cCallout", ""]],
      hostAttrs: [1, "callout"],
      hostVars: 2,
      hostBindings: function CalloutComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        color: [1, "color"]
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function CalloutComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CalloutComponent, [{
    type: Component,
    args: [{
      selector: 'c-callout, [cCallout]',
      template: '<ng-content />',
      host: {
        class: 'callout',
        '[class]': 'hostClasses()'
      },
      styles: [":host{display:block}\n"]
    }]
  }], null, null);
})();
class CalloutModule {
  static {
    this.ɵfac = function CalloutModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalloutModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CalloutModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CalloutModule, [{
    type: NgModule,
    args: [{
      exports: [CalloutComponent],
      imports: [CalloutComponent]
    }]
  }], null, null);
})();
class CardComponent {
  constructor() {
    /**
     * Sets the color context of the component to one of CoreUI’s themed colors.
     * @type Colors
     */
    this.color = input();
    /**
     * Sets the text color context of the component to one of CoreUI’s themed colors.
     * via TextColorDirective
     * @type TextColors
     */
    this.textColor = input();
    /**
     * Sets the component's color scheme to one of CoreUI themed colors, ensuring the text color contrast adheres to the WCAG 4.5:1 contrast ratio standard for accessibility.
     * via TextBgColorDirective
     * @type Colors
     * @since 5.0.0
     */
    this.textBgColor = input();
    this.hostClasses = computed(() => {
      const color = this.color();
      return {
        card: true,
        [`bg-${color}`]: !!color
      };
    });
  }
  static {
    this.ɵfac = function CardComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CardComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CardComponent,
      selectors: [["c-card"], ["", "c-card", ""]],
      hostAttrs: [1, "card"],
      hostVars: 2,
      hostBindings: function CardComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        color: [1, "color"],
        textColor: [1, "textColor"],
        textBgColor: [1, "textBgColor"]
      },
      features: [i0.ɵɵHostDirectivesFeature([{
        directive: TextColorDirective,
        inputs: ["cTextColor", "textColor"]
      }, {
        directive: TextBgColorDirective,
        inputs: ["cTextBgColor", "textBgColor"]
      }])],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function CardComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardComponent, [{
    type: Component,
    args: [{
      selector: 'c-card, [c-card]',
      template: '<ng-content />',
      hostDirectives: [{
        directive: TextColorDirective,
        inputs: ['cTextColor: textColor']
      }, {
        directive: TextBgColorDirective,
        inputs: ['cTextBgColor: textBgColor']
      }],
      host: {
        class: 'card',
        '[class]': 'hostClasses()'
      }
    }]
  }], null, null);
})();
class CardBodyComponent {
  static {
    this.ɵfac = function CardBodyComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CardBodyComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CardBodyComponent,
      selectors: [["c-card-body"], ["", "c-card-body", ""]],
      hostAttrs: [1, "card-body"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function CardBodyComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardBodyComponent, [{
    type: Component,
    args: [{
      selector: 'c-card-body, [c-card-body]',
      template: '<ng-content />',
      host: {
        class: 'card-body'
      }
    }]
  }], null, null);
})();
class CardFooterComponent {
  static {
    this.ɵfac = function CardFooterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CardFooterComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CardFooterComponent,
      selectors: [["c-card-footer"], ["", "c-card-footer", ""]],
      hostAttrs: [1, "card-footer"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function CardFooterComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardFooterComponent, [{
    type: Component,
    args: [{
      selector: 'c-card-footer, [c-card-footer]',
      template: '<ng-content />',
      host: {
        class: 'card-footer'
      }
    }]
  }], null, null);
})();
class CardGroupComponent {
  static {
    this.ɵfac = function CardGroupComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CardGroupComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CardGroupComponent,
      selectors: [["c-card-group"], ["", "c-card-group", ""]],
      hostAttrs: [1, "card-group"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function CardGroupComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardGroupComponent, [{
    type: Component,
    args: [{
      selector: 'c-card-group, [c-card-group]',
      template: '<ng-content />',
      host: {
        class: 'card-group'
      }
    }]
  }], null, null);
})();
class CardHeaderComponent {
  static {
    this.ɵfac = function CardHeaderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CardHeaderComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CardHeaderComponent,
      selectors: [["c-card-header"], ["", "c-card-header", ""]],
      hostAttrs: [1, "card-header"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function CardHeaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardHeaderComponent, [{
    type: Component,
    args: [{
      selector: 'c-card-header, [c-card-header]',
      template: '<ng-content />',
      host: {
        class: 'card-header'
      }
    }]
  }], null, null);
})();
class CardHeaderActionsComponent {
  static {
    this.ɵfac = function CardHeaderActionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CardHeaderActionsComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CardHeaderActionsComponent,
      selectors: [["c-card-header-actions"], ["", "c-card-header-actions", ""]],
      hostAttrs: [1, "card-header-actions"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function CardHeaderActionsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardHeaderActionsComponent, [{
    type: Component,
    args: [{
      selector: 'c-card-header-actions, [c-card-header-actions]',
      template: '<ng-content />',
      host: {
        class: 'card-header-actions'
      }
    }]
  }], null, null);
})();
class CardImgDirective {
  constructor() {
    /**
     * Optionally orientate the image to the top, bottom, or make it overlaid across the card.
     * @type {'top | 'bottom'}
     */
    this.orientation = input(undefined, {
      alias: 'cCardImg'
    });
    this.hostClasses = computed(() => {
      const orientation = this.orientation();
      const suffix = !!orientation ? `-${orientation}` : '';
      const horizontal = ['start', 'end'].includes(orientation ?? '-') ? orientation : undefined;
      return {
        [`card-img${suffix}`]: !horizontal,
        'img-fluid': !!horizontal,
        [`rounded-${horizontal}`]: !!horizontal
      };
    });
  }
  static {
    this.ɵfac = function CardImgDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CardImgDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: CardImgDirective,
      selectors: [["", "cCardImg", ""]],
      hostVars: 2,
      hostBindings: function CardImgDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        orientation: [1, "cCardImg", "orientation"]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardImgDirective, [{
    type: Directive,
    args: [{
      selector: '[cCardImg]',
      host: {
        '[class]': 'hostClasses()'
      }
    }]
  }], null, null);
})();
class CardImgOverlayComponent {
  static {
    this.ɵfac = function CardImgOverlayComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CardImgOverlayComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CardImgOverlayComponent,
      selectors: [["c-card-img-overlay"]],
      hostAttrs: [1, "card-img-overlay"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function CardImgOverlayComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardImgOverlayComponent, [{
    type: Component,
    args: [{
      selector: 'c-card-img-overlay',
      template: '<ng-content />',
      host: {
        class: 'card-img-overlay'
      },
      styles: [":host{display:block}\n"]
    }]
  }], null, null);
})();
class CardLinkDirective {
  static {
    this.ɵfac = function CardLinkDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CardLinkDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: CardLinkDirective,
      selectors: [["", "cCardLink", ""]],
      hostAttrs: [1, "card-link"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardLinkDirective, [{
    type: Directive,
    args: [{
      selector: '[cCardLink]',
      host: {
        class: 'card-link'
      }
    }]
  }], null, null);
})();
class CardSubtitleDirective {
  static {
    this.ɵfac = function CardSubtitleDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CardSubtitleDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: CardSubtitleDirective,
      selectors: [["", "cCardSubtitle", ""]],
      hostAttrs: [1, "card-subtitle"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardSubtitleDirective, [{
    type: Directive,
    args: [{
      selector: '[cCardSubtitle]',
      host: {
        class: 'card-subtitle'
      }
    }]
  }], null, null);
})();
class CardTextDirective {
  static {
    this.ɵfac = function CardTextDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CardTextDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: CardTextDirective,
      selectors: [["", "cCardText", ""]],
      hostAttrs: [1, "card-text"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardTextDirective, [{
    type: Directive,
    args: [{
      selector: '[cCardText]',
      host: {
        class: 'card-text'
      }
    }]
  }], null, null);
})();
class CardTitleDirective {
  static {
    this.ɵfac = function CardTitleDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CardTitleDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: CardTitleDirective,
      selectors: [["", "cCardTitle", ""]],
      hostAttrs: [1, "card-title"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardTitleDirective, [{
    type: Directive,
    args: [{
      selector: '[cCardTitle]',
      host: {
        class: 'card-title'
      }
    }]
  }], null, null);
})();
class CardModule {
  static {
    this.ɵfac = function CardModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CardModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CardModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardModule, [{
    type: NgModule,
    args: [{
      imports: [CardComponent, CardBodyComponent, CardFooterComponent, CardGroupComponent, CardHeaderComponent, CardHeaderActionsComponent, CardImgDirective, CardImgOverlayComponent, CardLinkDirective, CardSubtitleDirective, CardTextDirective, CardTitleDirective],
      exports: [CardComponent, CardBodyComponent, CardFooterComponent, CardGroupComponent, CardHeaderComponent, CardHeaderActionsComponent, CardImgDirective, CardImgOverlayComponent, CardLinkDirective, CardSubtitleDirective, CardTextDirective, CardTitleDirective]
    }]
  }], null, null);
})();
class IntersectionService {
  constructor() {
    this.platformId = inject(PLATFORM_ID);
    this.#intersecting = new BehaviorSubject({
      isIntersecting: false
    });
    this.intersecting$ = this.#intersecting.asObservable();
    this.defaultObserverOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.2
    };
    this.hostElementRefs = new Map();
  }
  #intersecting;
  createIntersectionObserver(hostElement, observerOptions = this.defaultObserverOptions) {
    if (isPlatformServer(this.platformId)) {
      this.#intersecting.next({
        isIntersecting: true,
        hostElement
      });
      return;
    }
    const options = {
      ...this.defaultObserverOptions,
      ...observerOptions
    };
    const handleIntersect = (entries, observer) => {
      entries.forEach(entry => {
        this.#intersecting.next({
          isIntersecting: entry.isIntersecting,
          hostElement
        });
      });
    };
    this.hostElementRefs.set(hostElement, new IntersectionObserver(handleIntersect, options));
    this.hostElementRefs.get(hostElement)?.observe(hostElement.nativeElement);
  }
  unobserve(elementRef) {
    this.hostElementRefs.get(elementRef)?.unobserve(elementRef.nativeElement);
    this.hostElementRefs.set(elementRef, null);
    this.hostElementRefs.delete(elementRef);
  }
  ngOnDestroy() {
    this.hostElementRefs.forEach((observer, elementRef) => {
      observer?.unobserve(elementRef.nativeElement);
    });
  }
  static {
    this.ɵfac = function IntersectionService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IntersectionService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: IntersectionService,
      factory: IntersectionService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IntersectionService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class ListenersService {
  constructor() {
    this.renderer = inject(Renderer2);
    this.listeners = new Map();
  }
  setListeners({
    hostElement,
    trigger,
    callbackOn,
    callbackOff,
    callbackToggle
  }) {
    const host = hostElement.nativeElement;
    const triggers = Array.isArray(trigger) ? trigger : trigger?.split(' ') ?? [];
    if (triggers?.includes('click')) {
      typeof callbackToggle === 'function' && this.listeners.set('click', this.renderer.listen(host, 'click', callbackToggle));
    }
    if (triggers?.includes('focus')) {
      typeof callbackOn === 'function' && this.listeners.set('focus', this.renderer.listen(host, 'focus', callbackOn));
    }
    if (triggers?.includes('focusin')) {
      typeof callbackOff === 'function' && this.listeners.set('focusout', this.renderer.listen(host, 'focusout', callbackOff));
      typeof callbackOn === 'function' && this.listeners.set('focusin', this.renderer.listen(host, 'focusin', callbackOn));
    }
    if (triggers?.includes('click') || triggers?.includes('focus')) {
      typeof callbackOff === 'function' && this.listeners.set('blur', this.renderer.listen(host, 'blur', callbackOff));
    }
    if (triggers?.includes('hover')) {
      typeof callbackOn === 'function' && this.listeners.set('mouseenter', this.renderer.listen(host, 'mouseenter', callbackOn));
      typeof callbackOff === 'function' && this.listeners.set('mouseleave', this.renderer.listen(host, 'mouseleave', callbackOff));
    }
  }
  clearListeners() {
    this.listeners.forEach((unListen, key) => {
      unListen();
    });
    this.listeners.forEach((unListen, key) => {
      // @ts-ignore
      this.listeners.set(key, null);
    });
    this.listeners.clear();
  }
  static {
    this.ɵfac = function ListenersService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ListenersService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ListenersService,
      factory: ListenersService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListenersService, [{
    type: Injectable
  }], null, null);
})();
class ClassToggleService {
  #document = inject(DOCUMENT);
  #rendererFactory = inject(RendererFactory2);
  #renderer;
  constructor() {
    this.#renderer = this.#rendererFactory.createRenderer(null, null);
  }
  toggle(selector, className) {
    const element = this.#document.querySelector(selector);
    if (element) {
      element.classList.contains(className) ? this.#renderer.removeClass(element, className) : this.#renderer.addClass(element, className);
    }
  }
  static {
    this.ɵfac = function ClassToggleService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ClassToggleService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ClassToggleService,
      factory: ClassToggleService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClassToggleService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
class InMemoryStorageService {
  #storage = new Map();
  setItem(key, data) {
    this.#storage.set(key, JSON.stringify(data));
  }
  getItem(key) {
    return this.#storage.has(key) ? JSON.parse(this.#storage.get(key) ?? 'null') : undefined;
  }
  removeItem(key) {
    this.#storage.delete(key);
  }
  clear() {
    this.#storage.clear();
  }
  get length() {
    return this.#storage.size;
  }
  key(index) {
    return Array.from(this.#storage.keys())[index];
  }
  static {
    this.ɵfac = function InMemoryStorageService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || InMemoryStorageService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: InMemoryStorageService,
      factory: InMemoryStorageService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InMemoryStorageService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class LocalStorageService {
  constructor() {
    this.platformId = inject(PLATFORM_ID);
    this.document = inject(DOCUMENT);
    this.#data$ = new BehaviorSubject(null);
    this.data$ = this.#data$.asObservable();
    this.#localStorage = isPlatformBrowser(this.platformId) && this.document.defaultView ? this.document.defaultView?.localStorage : new InMemoryStorageService();
  }
  #localStorage;
  #data$;
  setItem(key, data) {
    this.#localStorage.setItem(key, JSON.stringify(data));
    this.#data$.next({
      key,
      data
    });
  }
  getItem(key) {
    const data = JSON.parse(this.#localStorage.getItem(key) || 'null');
    this.#data$.next({
      key,
      data
    });
    return data;
  }
  removeItem(key) {
    this.#localStorage.removeItem(key);
    this.#data$.next({
      key,
      data: null
    });
  }
  clear() {
    this.#localStorage.clear();
    this.#data$.next(null);
  }
  static {
    this.ɵfac = function LocalStorageService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LocalStorageService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LocalStorageService,
      factory: LocalStorageService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LocalStorageService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
class ColorModeService {
  #destroyRef;
  #document;
  #localStorage;
  #colorModeEffect;
  constructor() {
    this.#destroyRef = inject(DestroyRef);
    this.#document = inject(DOCUMENT);
    this.#localStorage = inject(LocalStorageService);
    this.eventName = signal('ColorSchemeChange');
    this.localStorageItemName = signal(undefined);
    this.localStorageItemName$ = toObservable(this.localStorageItemName);
    this.colorMode = signal(undefined);
    this.#colorModeEffect = effect(() => {
      const colorMode = this.colorMode();
      if (colorMode) {
        const localStorageItemName = this.localStorageItemName();
        localStorageItemName && this.setStoredTheme(localStorageItemName, colorMode);
        this.#setTheme(colorMode);
      }
    });
    afterNextRender({
      read: () => {
        this.localStorageItemName$.pipe(tap(params => {
          this.colorMode.set(this.getDefaultScheme(params));
        }), takeUntilDestroyed(this.#destroyRef)).subscribe();
      }
    });
  }
  getStoredTheme(localStorageItemName) {
    return this.#localStorage.getItem(localStorageItemName);
  }
  setStoredTheme(localStorageItemName, colorMode) {
    return this.#localStorage.setItem(localStorageItemName, colorMode);
  }
  removeStoredTheme(localStorageItemName) {
    this.#localStorage.removeItem(localStorageItemName);
  }
  getDefaultScheme(localStorageItemName) {
    if (this.#document.defaultView === undefined) {
      return this.getDatasetTheme();
    }
    const storedTheme = localStorageItemName && this.getStoredTheme(localStorageItemName);
    return storedTheme ?? this.getDatasetTheme();
  }
  getPrefersColorScheme() {
    return this.#document.defaultView?.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : this.#document.defaultView?.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : undefined;
  }
  getDatasetTheme() {
    return this.#document.documentElement.dataset['coreuiTheme'];
  }
  #setTheme(colorMode) {
    this.#document.documentElement.dataset['coreuiTheme'] = colorMode === 'auto' ? this.getPrefersColorScheme() : colorMode;
    const event = new Event(this.eventName());
    this.#document.documentElement.dispatchEvent(event);
  }
  static {
    this.ɵfac = function ColorModeService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ColorModeService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ColorModeService,
      factory: ColorModeService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ColorModeService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
class UIDService {
  #document = inject(DOCUMENT);
  getUID(prefix = 'random-id') {
    let uid = prefix;
    do {
      uid = `${prefix}-${Math.floor(Math.random() * 1000000).toString(10)}`;
    } while (this.#document.getElementById(uid));
    return uid;
  }
  static {
    this.ɵfac = function UIDService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UIDService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: UIDService,
      factory: UIDService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UIDService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class RtlService {
  #document = inject(DOCUMENT);
  isRTL(element) {
    if (element) {
      return element.closest('[dir="rtl"]') !== null;
    }
    return this.#document?.documentElement?.dir === 'rtl' || this.#document?.body?.dir === 'rtl';
  }
  static {
    this.ɵfac = function RtlService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RtlService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RtlService,
      factory: RtlService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RtlService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class CarouselService {
  constructor() {
    this.#carouselIndex = new BehaviorSubject({});
    this.carouselIndex$ = this.#carouselIndex.asObservable();
  }
  #carouselIndex;
  setIndex(index) {
    this.#carouselIndex.next(index);
  }
  static {
    this.ɵfac = function CarouselService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CarouselService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CarouselService,
      factory: CarouselService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CarouselService, [{
    type: Injectable
  }], null, null);
})();
class CarouselState {
  #carouselService = inject(CarouselService);
  #state = {
    activeItemIndex: -1,
    animate: true,
    items: [],
    direction: 'next',
    transition: 'slide',
    interval: 0
  };
  get state() {
    return this.#state;
  }
  set state(state) {
    const prevState = {
      ...this.#state
    };
    const nextState = {
      ...this.#state,
      ...state
    };
    this.#state = nextState;
    if (prevState.activeItemIndex !== nextState.activeItemIndex) {
      const activeItemIndex = this.state.activeItemIndex || 0;
      const itemInterval = this.state.items && this.state.items[activeItemIndex]?.interval() || -1;
      this.#carouselService.setIndex({
        active: nextState.activeItemIndex,
        interval: itemInterval,
        lastItemIndex: (nextState.items?.length ?? 0) - 1
      });
    }
  }
  setItems(newItems) {
    if (newItems.length) {
      const itemsArray = newItems;
      itemsArray.forEach((item, i) => {
        item.index = i;
      });
      this.state = {
        items: [...itemsArray]
      };
    } else {
      this.reset();
    }
  }
  setNextIndex(nextIndex) {
    this.#carouselService.setIndex(nextIndex);
  }
  direction(direction = 'next') {
    this.state = {
      direction
    };
    const {
      activeItemIndex = -1,
      items
    } = this.state;
    const itemsCount = items?.length ?? 0;
    if (itemsCount > 0) {
      return direction === 'next' ? activeItemIndex === itemsCount - 1 ? 0 : activeItemIndex + 1 : activeItemIndex === 0 ? itemsCount - 1 : activeItemIndex - 1;
    } else {
      return 0;
    }
  }
  reset() {
    this.state = {
      activeItemIndex: -1,
      animate: true,
      items: [],
      direction: 'next',
      transition: 'slide',
      interval: 0
    };
  }
  static {
    this.ɵfac = function CarouselState_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CarouselState)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CarouselState,
      factory: CarouselState.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CarouselState, [{
    type: Injectable
  }], null, null);
})();
class CarouselConfig {
  constructor() {
    /* Animate transition of slides */
    this.activeIndex = 0;
    /* Animate transition of slides */
    this.animate = true;
    /* Default direction of auto changing of slides */
    this.direction = 'next';
    /* Default interval of auto changing of slides */
    this.interval = 0;
  }
  static {
    this.ɵfac = function CarouselConfig_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CarouselConfig)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CarouselConfig,
      factory: CarouselConfig.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CarouselConfig, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class CarouselComponent {
  #hostElement;
  #carouselService;
  #carouselState;
  #intersectionService;
  #listenersService;
  constructor(config) {
    this.config = config;
    this.#hostElement = inject(ElementRef);
    this.#carouselService = inject(CarouselService);
    this.#carouselState = inject(CarouselState);
    this.#intersectionService = inject(IntersectionService);
    this.#listenersService = inject(ListenersService);
    /**
     * Index of the active item.
     * @return number
     */
    this.activeIndexInput = input(0, {
      alias: 'activeIndex'
    });
    this.activeIndex = linkedSignal({
      source: this.activeIndexInput,
      computation: value => value
    });
    /**
     * Carousel automatically starts cycle items.
     * @return boolean
     */
    this.animateInput = input(true, {
      alias: 'animate'
    });
    this.animate = linkedSignal({
      source: this.animateInput,
      computation: value => value
    });
    /**
     * Carousel direction. [docs]
     * @return {'next' | 'prev'}
     */
    this.directionInput = input('next', {
      alias: 'direction'
    });
    this.direction = linkedSignal({
      source: this.directionInput,
      computation: value => value
    });
    /**
     * The amount of time to delay between automatically cycling an item. If false, carousel will not automatically cycle.
     * @return number
     * @default 0
     */
    this.intervalInput = input(0, {
      alias: 'interval'
    });
    this.interval = linkedSignal({
      source: this.intervalInput,
      computation: value => value
    });
    this.#intervalEffect = effect(() => {
      const interval = this.interval();
      this.#carouselState.state = {
        interval: interval
      };
      interval ? this.setTimer() : this.resetTimer();
    });
    /**
     * Sets which event handlers you’d like provided to your pause prop. You can specify one trigger or an array of them.
     * @return {'hover' | 'focus' | 'click'}
     */
    this.pause = input('hover');
    /**
     * Support left/right swipe interactions on touchscreen devices.
     * @return boolean
     * @default true
     */
    this.touch = input(true);
    /**
     * Set type of the transition.
     * @return {'slide' | 'crossfade'}
     * @default 'slide'
     */
    this.transition = input('slide');
    /**
     * Set whether the carousel should cycle continuously or have hard stops.
     * @return boolean
     * @default true
     */
    this.wrap = input(true);
    /**
     * Event emitted on carousel item change. [docs]
     * @return number
     */
    this.itemChange = output();
    this.activeItemInterval = 0;
    this.#destroyRef = inject(DestroyRef);
    this.#visible = true;
    this.loadConfig();
  }
  loadConfig() {
    this.activeIndex.set(this.config?.activeIndex ?? this.activeIndex());
    this.animate.set(this.config?.animate ?? this.animate());
    this.direction.set(this.config?.direction ?? this.direction());
    this.interval.set(this.config?.interval ?? this.interval());
  }
  #intervalEffect;
  #destroyRef;
  ngOnInit() {
    this.carouselStateSubscribe();
  }
  ngOnDestroy() {
    this.resetTimer();
    this.clearListeners();
    this.swipeSubscribe(false);
  }
  ngAfterContentInit() {
    this.intersectionServiceSubscribe();
    this.#carouselState.state = {
      activeItemIndex: this.activeIndex(),
      animate: this.animate(),
      interval: this.interval(),
      transition: this.transition()
    };
    this.setListeners();
    this.swipeSubscribe();
  }
  setListeners() {
    const config = {
      hostElement: this.#hostElement,
      trigger: this.pause() || [],
      callbackOff: () => {
        this.setTimer();
      },
      callbackOn: () => {
        this.resetTimer();
      }
    };
    this.#listenersService.setListeners(config);
  }
  clearListeners() {
    this.#listenersService.clearListeners();
  }
  set visible(value) {
    this.#visible = value;
  }
  get visible() {
    return this.#visible;
  }
  #visible;
  setTimer() {
    const interval = this.activeItemInterval || this.interval();
    const direction = this.direction();
    this.resetTimer();
    if (interval > 0) {
      this.timerId = setTimeout(() => {
        const nextIndex = this.#carouselState.direction(direction);
        this.#carouselState.state = {
          activeItemIndex: nextIndex
        };
      }, interval);
    }
  }
  resetTimer() {
    clearTimeout(this.timerId);
    this.timerId = undefined;
  }
  carouselStateSubscribe() {
    this.#carouselService.carouselIndex$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(nextItem => {
      if ('active' in nextItem && typeof nextItem.active === 'number') {
        this.itemChange.emit(nextItem.active);
      }
      this.activeItemInterval = typeof nextItem.interval === 'number' && nextItem.interval > -1 ? nextItem.interval : this.interval();
      const direction = this.direction();
      const isLastItem = nextItem.active === nextItem.lastItemIndex && direction === 'next' || nextItem.active === 0 && direction === 'prev';
      !this.wrap() && isLastItem ? this.resetTimer() : this.setTimer();
    });
  }
  intersectionServiceSubscribe() {
    this.#intersectionService.createIntersectionObserver(this.#hostElement);
    this.#intersectionService.intersecting$.pipe(filter(next => next.hostElement === this.#hostElement), finalize(() => {
      this.#intersectionService.unobserve(this.#hostElement);
    }), takeUntilDestroyed(this.#destroyRef)).subscribe(next => {
      this.visible = next.isIntersecting;
      next.isIntersecting ? this.setTimer() : this.resetTimer();
    });
  }
  swipeSubscribe(subscribe = true) {
    if (this.touch() && subscribe) {
      const carouselElement = this.#hostElement.nativeElement;
      const touchStart$ = fromEvent(carouselElement, 'touchstart');
      const touchEnd$ = fromEvent(carouselElement, 'touchend');
      const touchMove$ = fromEvent(carouselElement, 'touchmove');
      this.swipeSubscription = touchStart$.pipe(zipWith(touchEnd$.pipe(withLatestFrom(touchMove$))), takeUntilDestroyed(this.#destroyRef)).subscribe(([touchstart, [touchend, touchmove]]) => {
        touchstart.stopPropagation();
        touchmove.stopPropagation();
        const distanceX = touchstart.touches[0]?.clientX - touchmove.touches[0]?.clientX || 0;
        if (Math.abs(distanceX) > 0.3 * carouselElement.clientWidth && touchstart.timeStamp <= touchmove.timeStamp) {
          const nextIndex = this.#carouselState.direction(distanceX > 0 ? 'next' : 'prev');
          this.#carouselState.state = {
            activeItemIndex: nextIndex
          };
        }
      });
    } else {
      this.swipeSubscription?.unsubscribe();
    }
  }
  static {
    this.ɵfac = function CarouselComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CarouselComponent)(i0.ɵɵdirectiveInject(CarouselConfig));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CarouselComponent,
      selectors: [["c-carousel"]],
      hostAttrs: [1, "carousel", "slide"],
      hostVars: 2,
      hostBindings: function CarouselComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("carousel-fade", ctx.transition() === "crossfade" && ctx.animate());
        }
      },
      inputs: {
        activeIndexInput: [1, "activeIndex", "activeIndexInput"],
        animateInput: [1, "animate", "animateInput"],
        directionInput: [1, "direction", "directionInput"],
        intervalInput: [1, "interval", "intervalInput"],
        pause: [1, "pause"],
        touch: [1, "touch"],
        transition: [1, "transition"],
        wrap: [1, "wrap"]
      },
      outputs: {
        itemChange: "itemChange"
      },
      exportAs: ["cCarousel"],
      features: [i0.ɵɵProvidersFeature([CarouselService, CarouselState, ListenersService]), i0.ɵɵHostDirectivesFeature([{
        directive: ThemeDirective,
        inputs: ["dark", "dark"]
      }])],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function CarouselComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CarouselComponent, [{
    type: Component,
    args: [{
      selector: 'c-carousel',
      template: '<ng-content />',
      providers: [CarouselService, CarouselState, ListenersService],
      hostDirectives: [{
        directive: ThemeDirective,
        inputs: ['dark']
      }],
      exportAs: 'cCarousel',
      host: {
        class: 'carousel slide',
        '[class.carousel-fade]': 'transition() === "crossfade" && animate()'
      },
      styles: [":host{display:block}\n"]
    }]
  }], () => [{
    type: CarouselConfig,
    decorators: [{
      type: Inject,
      args: [CarouselConfig]
    }]
  }], null);
})();
class CarouselCaptionComponent {
  static {
    this.ɵfac = function CarouselCaptionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CarouselCaptionComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CarouselCaptionComponent,
      selectors: [["c-carousel-caption"]],
      hostVars: 2,
      hostBindings: function CarouselCaptionComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("carousel-caption", true);
        }
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function CarouselCaptionComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CarouselCaptionComponent, [{
    type: Component,
    args: [{
      selector: 'c-carousel-caption',
      template: '<ng-content />',
      host: {
        '[class.carousel-caption]': 'true'
      },
      styles: [":host{display:block}\n"]
    }]
  }], null, null);
})();
class CarouselControlComponent {
  constructor() {
    this.#carouselState = inject(CarouselState);
    /**
     * Carousel control caption. [docs]
     * @return string
     */
    this.captionInput = input(undefined, {
      alias: 'caption'
    });
    this.caption = linkedSignal({
      source: this.captionInput,
      computation: value => {
        return !!value ? value : this.direction() === 'prev' ? 'Previous' : 'Next';
      }
    });
    /**
     * Carousel control direction.
     * @return {'next' | 'prev'}
     */
    this.direction = input('next');
    /**
     * Carousel control role.
     * @return string
     */
    this.role = input('button');
    this.hostClasses = computed(() => {
      return `carousel-control-${this.direction()}`;
    });
    this.carouselControlIconClass = computed(() => {
      return `carousel-control-${this.direction()}-icon`;
    });
  }
  #carouselState;
  onKeyUp($event) {
    if ($event.key === 'Enter') {
      this.#play();
    }
    if ($event.key === 'ArrowLeft') {
      this.#play('prev');
    }
    if ($event.key === 'ArrowRight') {
      this.#play('next');
    }
  }
  onClick($event) {
    this.#play();
  }
  #play(direction = this.direction()) {
    const nextIndex = this.#carouselState.direction(direction);
    this.#carouselState.state = {
      activeItemIndex: nextIndex
    };
  }
  static {
    this.ɵfac = function CarouselControlComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CarouselControlComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CarouselControlComponent,
      selectors: [["c-carousel-control"]],
      hostVars: 3,
      hostBindings: function CarouselControlComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keyup", function CarouselControlComponent_keyup_HostBindingHandler($event) {
            return ctx.onKeyUp($event);
          })("click", function CarouselControlComponent_click_HostBindingHandler($event) {
            return ctx.onClick($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role());
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        captionInput: [1, "caption", "captionInput"],
        direction: [1, "direction"],
        role: [1, "role"]
      },
      exportAs: ["cCarouselControl"],
      ngContentSelectors: _c0,
      decls: 2,
      vars: 0,
      consts: [[1, "visually-hidden"]],
      template: function CarouselControlComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0, 0, null, CarouselControlComponent_ProjectionFallback_0_Template, 3, 4);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CarouselControlComponent, [{
    type: Component,
    args: [{
      selector: 'c-carousel-control',
      exportAs: 'cCarouselControl',
      host: {
        '[attr.role]': 'role()',
        '[class]': 'hostClasses()',
        '(keyup)': 'onKeyUp($event)',
        '(click)': 'onClick($event)'
      },
      template: "<ng-content>\n  <span [attr.aria-hidden]=\"true\" [class]=\"carouselControlIconClass()\"></span>\n  <span class=\"visually-hidden\">{{ caption() }}</span>\n</ng-content>\n"
    }]
  }], null, null);
})();
class CarouselIndicatorsComponent {
  constructor() {
    this.#destroyRef = inject(DestroyRef);
    this.#carouselService = inject(CarouselService);
    this.#carouselState = inject(CarouselState);
    this.items = [];
    this.active = 0;
    this.contentTemplates = contentChildren(TemplateIdDirective, {
      descendants: true
    });
    this.templates = computed(() => {
      return this.contentTemplates().reduce((acc, child) => {
        acc[child.id] = child.templateRef;
        return acc;
      }, {});
    });
  }
  #destroyRef;
  #carouselService;
  #carouselState;
  ngOnInit() {
    this.#carouselService.carouselIndex$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(nextIndex => {
      this.items = this.#carouselState?.state?.items?.map(item => item.index) ?? [];
      if ('active' in nextIndex) {
        this.active = nextIndex.active ?? 0;
      }
    });
  }
  onClick(index) {
    if (index !== this.active) {
      const direction = index < this.active ? 'prev' : 'next';
      this.#carouselState.state = {
        direction,
        activeItemIndex: index
      };
    }
  }
  static {
    this.ɵfac = function CarouselIndicatorsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CarouselIndicatorsComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CarouselIndicatorsComponent,
      selectors: [["c-carousel-indicators"]],
      contentQueries: function CarouselIndicatorsComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.contentTemplates, TemplateIdDirective, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      hostAttrs: [1, "carousel-indicators"],
      exportAs: ["cCarouselIndicators"],
      decls: 4,
      vars: 5,
      consts: [["defaultCarouselIndicatorsTemplate", ""], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["type", "button", 3, "class"], ["type", "button", 3, "click"]],
      template: function CarouselIndicatorsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵdeclareLet(0);
          i0.ɵɵtemplate(1, CarouselIndicatorsComponent_ng_container_1_Template, 1, 0, "ng-container", 1)(2, CarouselIndicatorsComponent_ng_template_2_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const defaultCarouselIndicatorsTemplate_r4 = i0.ɵɵreference(3);
          const tmpl_r5 = ctx.templates();
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngTemplateOutlet", tmpl_r5["carouselIndicatorsTemplate"] || defaultCarouselIndicatorsTemplate_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c9, ctx.items, ctx.active));
        }
      },
      dependencies: [NgTemplateOutlet],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CarouselIndicatorsComponent, [{
    type: Component,
    args: [{
      selector: 'c-carousel-indicators',
      exportAs: 'cCarouselIndicators',
      imports: [NgTemplateOutlet],
      host: {
        class: 'carousel-indicators'
      },
      template: "@let tmpl = templates();\n<ng-container *ngTemplateOutlet=\"tmpl['carouselIndicatorsTemplate'] || defaultCarouselIndicatorsTemplate; context: {$implicit: items, active: active}\" />\n\n<ng-template #defaultCarouselIndicatorsTemplate>\n  @for (item of items; track item; let i = $index) {\n    <button\n      [attr.data-coreui-target]=\"i\"\n      type=\"button\"\n      (click)=\"onClick(i)\"\n      [class]=\"{ active: active === i }\"\n      [attr.aria-current]=\"active === i\">\n    </button>\n  }\n</ng-template>\n"
    }]
  }], null, null);
})();
class CarouselItemComponent {
  #destroyRef;
  #carouselService;
  constructor() {
    this.#destroyRef = inject(DestroyRef);
    this.#carouselService = inject(CarouselService);
    /**
     * @ignore
     */
    this.activeInput = input(false, {
      transform: booleanAttribute,
      alias: 'active'
    });
    this.active = linkedSignal({
      source: this.activeInput,
      computation: value => {
        return value;
      }
    });
    /**
     * Time delay before cycling to next item. If -1, uses carousel interval value.
     * @return number
     * @default -1
     */
    this.interval = input(-1);
    /**
     * Carousel item role.
     * @return string
     * @default 'group'
     */
    this.role = input('group');
    this.#carouselService.carouselIndex$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(nextIndex => {
      if ('active' in nextIndex) {
        this.active.set(nextIndex.active === this.index);
      }
    });
  }
  static {
    this.ɵfac = function CarouselItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CarouselItemComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CarouselItemComponent,
      selectors: [["c-carousel-item"]],
      hostAttrs: [1, "carousel-item"],
      hostVars: 3,
      hostBindings: function CarouselItemComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role());
          i0.ɵɵclassProp("active", ctx.active());
        }
      },
      inputs: {
        activeInput: [1, "active", "activeInput"],
        interval: [1, "interval"],
        role: [1, "role"]
      },
      exportAs: ["cCarouselItem"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 1,
      template: function CarouselItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, CarouselItemComponent_Conditional_0_Template, 1, 0);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.active() ? 0 : -1);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CarouselItemComponent, [{
    type: Component,
    args: [{
      selector: 'c-carousel-item',
      exportAs: 'cCarouselItem',
      host: {
        class: 'carousel-item',
        '[class.active]': 'active()',
        '[attr.role]': 'role()'
      },
      template: "@if (active()) {\n  <ng-content />\n}\n",
      styles: [":host{display:block}\n"]
    }]
  }], () => [], null);
})();
function toSlideLeft(fromState, toState) {
  return toState.left === true && toState.type === 'slide';
}
function toSlideRight(fromState, toState) {
  return toState.left === false && toState.type === 'slide';
}
function toFadeLeft(fromState, toState) {
  return toState.left === true && toState.type !== 'slide';
}
function toFadeRight(fromState, toState) {
  return toState.left === false && toState.type !== 'slide';
}
const slideAnimationLeft = animation(group([query(':leave', [animate('0.6s ease-in-out', style({
  transform: 'translateX(-100%)'
}))], {
  optional: true
}), query(':enter', [style({
  transform: 'translateX(100%)'
}), animate('0.6s ease-in-out', style('*'))], {
  optional: true
})]));
const slideAnimationRight = animation(group([query(':enter', [style({
  transform: 'translateX(-100%)'
}), animate('0.6s ease-in-out', style('*'))], {
  optional: true
}), query(':leave', [animate('0.6s ease-in-out', style({
  transform: 'translateX(100%)'
}))], {
  optional: true
})]));
const fadeAnimationLeft = animation(group([query(':leave', [animate('0.9s ease-in-out', style({
  zIndex: 0,
  opacity: 0
}))], {
  optional: true
}), query(':enter', [style({
  zIndex: 1,
  opacity: 1
}), animate('0.6s ease-in-out', style('*'))], {
  optional: true
})]));
const fadeAnimationRight = animation(group([query(':enter', [style({
  zIndex: 1,
  opacity: 1
}), animate('0.6s ease-in-out', style('*'))], {
  optional: true
}), query(':leave', [animate('0.9s ease-in-out', style({
  zIndex: 0,
  opacity: 0
}))], {
  optional: true
})]));
const carouselPlay = trigger('carouselPlay', [state('*', style({
  transform: 'translateX(0)',
  display: 'block',
  opacity: 1
})), transition(toFadeLeft, useAnimation(fadeAnimationLeft)), transition(toFadeRight, useAnimation(fadeAnimationRight)), transition(toSlideLeft, useAnimation(slideAnimationLeft)), transition(toSlideRight, useAnimation(slideAnimationRight))]);
class CarouselInnerComponent {
  constructor() {
    this.#carouselState = inject(CarouselState);
    this.activeIndex = signal(undefined);
    this.animate = signal(true);
    this.interval = signal(0);
    this.slide = signal({
      left: true
    });
    this.transition = signal('crossfade');
    this.slideType = computed(() => {
      return {
        left: this.slide().left,
        type: this.transition()
      };
    });
    this.ariaLive = computed(() => {
      return this.interval() ? 'off' : 'polite';
    });
    this.contentItems = contentChildren(CarouselItemComponent);
    this.#prevContentItems = signal([]);
  }
  #carouselState;
  #prevContentItems;
  ngAfterContentInit() {
    this.setItems();
  }
  ngAfterContentChecked() {
    this.setItems();
    const state = this.#carouselState?.state;
    const nextIndex = state?.activeItemIndex;
    const nextDirection = state?.direction;
    if (this.activeIndex() !== nextIndex) {
      this.animate.set(state?.animate ?? false);
      this.activeIndex.set(state?.activeItemIndex);
      this.interval.set(state?.interval ?? 0);
      this.slide.set({
        left: nextDirection === 'next'
      });
      this.transition.set(state?.transition ?? 'slide');
    }
  }
  setItems() {
    const contentItems = this.contentItems();
    if (this.#prevContentItems() !== contentItems) {
      this.#prevContentItems.set([...contentItems]);
      this.#carouselState.setItems(contentItems);
    }
  }
  static {
    this.ɵfac = function CarouselInnerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CarouselInnerComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CarouselInnerComponent,
      selectors: [["c-carousel-inner"]],
      contentQueries: function CarouselInnerComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.contentItems, CarouselItemComponent, 4);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      hostAttrs: [1, "carousel-inner"],
      hostVars: 3,
      hostBindings: function CarouselInnerComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵsyntheticHostProperty("@carouselPlay", ctx.slideType())("@.disabled", !ctx.animate());
          i0.ɵɵattribute("aria-live", ctx.ariaLive());
        }
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function CarouselInnerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"],
      data: {
        animation: [carouselPlay]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CarouselInnerComponent, [{
    type: Component,
    args: [{
      selector: 'c-carousel-inner',
      animations: [carouselPlay],
      template: '<ng-content />',
      host: {
        class: 'carousel-inner',
        '[@carouselPlay]': 'slideType()',
        '[@.disabled]': '!animate()',
        '[attr.aria-live]': 'ariaLive()'
      },
      styles: [":host{display:block}\n"]
    }]
  }], null, null);
})();
class CarouselModule {
  static forRoot() {
    return {
      ngModule: CarouselModule,
      providers: []
    };
  }
  static {
    this.ɵfac = function CarouselModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CarouselModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CarouselModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [CarouselService, CarouselState, CarouselConfig]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CarouselModule, [{
    type: NgModule,
    args: [{
      imports: [CarouselComponent, CarouselCaptionComponent, CarouselControlComponent, CarouselIndicatorsComponent, CarouselInnerComponent, CarouselItemComponent],
      providers: [CarouselService, CarouselState, CarouselConfig],
      exports: [CarouselComponent, CarouselCaptionComponent, CarouselControlComponent, CarouselIndicatorsComponent, CarouselInnerComponent, CarouselItemComponent]
    }]
  }], null, null);
})();
class DropdownDividerDirective {
  static {
    this.ɵfac = function DropdownDividerDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DropdownDividerDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: DropdownDividerDirective,
      selectors: [["", "cDropdownDivider", ""]],
      hostAttrs: [1, "dropdown-divider"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownDividerDirective, [{
    type: Directive,
    args: [{
      selector: '[cDropdownDivider]',
      host: {
        class: 'dropdown-divider'
      }
    }]
  }], null, null);
})();
class DropdownHeaderDirective {
  static {
    this.ɵfac = function DropdownHeaderDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DropdownHeaderDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: DropdownHeaderDirective,
      selectors: [["", "cDropdownHeader", ""]],
      hostAttrs: [1, "dropdown-header"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownHeaderDirective, [{
    type: Directive,
    args: [{
      selector: '[cDropdownHeader]',
      host: {
        class: 'dropdown-header'
      }
    }]
  }], null, null);
})();
class DropdownService {
  constructor() {
    this.dropdownState = new BehaviorSubject({});
    this.dropdownState$ = this.dropdownState.asObservable();
  }
  toggle(state) {
    this.dropdownState.next(state);
  }
  static {
    this.ɵfac = function DropdownService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DropdownService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: DropdownService,
      factory: DropdownService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownService, [{
    type: Injectable
  }], null, null);
})();
class DropdownMenuDirective {
  constructor() {
    this.#destroyRef = inject(DestroyRef);
    this.elementRef = inject(ElementRef);
    this.#dropdownService = inject(DropdownService);
    /**
     * Set alignment of dropdown menu.
     * @return 'start' | 'end'
     */
    this.alignment = input();
    /**
     * Toggle the visibility of dropdown menu component.
     * @return boolean
     */
    this.visibleInput = input(false, {
      transform: booleanAttribute,
      alias: 'visible'
    });
    this.visible = linkedSignal({
      source: this.visibleInput,
      computation: value => value
    });
    this.hostClasses = computed(() => {
      const alignment = this.alignment();
      const visible = this.visible();
      return {
        'dropdown-menu': true,
        [`dropdown-menu-${alignment}`]: !!alignment,
        show: visible
      };
    });
    this.hostStyles = computed(() => {
      // workaround for popper position calculate (see also: dropdown.component)
      const visible = this.visible();
      return {
        visibility: visible ? null : '',
        display: visible ? null : ''
      };
    });
  }
  #destroyRef;
  #dropdownService;
  #focusKeyManager;
  onKeyDown($event) {
    if (!this.visible()) {
      return;
    }
    if (['Space', 'ArrowDown'].includes($event.code)) {
      $event.preventDefault();
    }
    this.#focusKeyManager.onKeydown($event);
  }
  onKeyUp($event) {
    if (!this.visible()) {
      return;
    }
    if (['Tab'].includes($event.key)) {
      if (this.#focusKeyManager.activeItem) {
        $event.shiftKey ? this.#focusKeyManager.setPreviousItemActive() : this.#focusKeyManager.setNextItemActive();
      } else {
        this.#focusKeyManager.setFirstItemActive();
      }
    }
  }
  ngAfterContentInit() {
    this.focusKeyManagerInit();
    this.dropdownItemsContent.changes.pipe(tap(change => {
      this.focusKeyManagerInit();
    }), takeUntilDestroyed(this.#destroyRef)).subscribe();
  }
  ngOnInit() {
    this.#dropdownService.dropdownState$.pipe(tap(state => {
      if ('visible' in state) {
        this.visible.update(visible => state.visible === 'toggle' ? !visible : state.visible);
        if (!this.visible()) {
          this.#focusKeyManager?.setActiveItem(-1);
        }
      }
    }), takeUntilDestroyed(this.#destroyRef)).subscribe();
  }
  focusKeyManagerInit() {
    this.#focusKeyManager = new FocusKeyManager(this.dropdownItemsContent).withHomeAndEnd().withPageUpDown().withWrap().skipPredicate(dropdownItem => dropdownItem.disabled === true);
  }
  static {
    this.ɵfac = function DropdownMenuDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DropdownMenuDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: DropdownMenuDirective,
      selectors: [["", "cDropdownMenu", ""]],
      contentQueries: function DropdownMenuDirective_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, DropdownItemDirective, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdownItemsContent = _t);
        }
      },
      hostAttrs: [1, "dropdown-menu"],
      hostVars: 4,
      hostBindings: function DropdownMenuDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown", function DropdownMenuDirective_keydown_HostBindingHandler($event) {
            return ctx.onKeyDown($event);
          })("keyup", function DropdownMenuDirective_keyup_HostBindingHandler($event) {
            return ctx.onKeyUp($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵstyleMap(ctx.hostStyles());
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        alignment: [1, "alignment"],
        visibleInput: [1, "visible", "visibleInput"]
      },
      exportAs: ["cDropdownMenu"],
      features: [i0.ɵɵHostDirectivesFeature([{
        directive: ThemeDirective,
        inputs: ["dark", "dark"]
      }])]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownMenuDirective, [{
    type: Directive,
    args: [{
      selector: '[cDropdownMenu]',
      exportAs: 'cDropdownMenu',
      hostDirectives: [{
        directive: ThemeDirective,
        inputs: ['dark']
      }],
      host: {
        class: 'dropdown-menu',
        '[class]': 'hostClasses()',
        '[style]': 'hostStyles()',
        '(keydown)': 'onKeyDown($event)',
        '(keyup)': 'onKeyUp($event)'
      }
    }]
  }], null, {
    dropdownItemsContent: [{
      type: ContentChildren,
      args: [forwardRef(() => DropdownItemDirective), {
        descendants: true
      }]
    }]
  });
})();

// lightweight injection token
class DropdownToken {}
class DropdownToggleDirective {
  constructor() {
    // injections
    this.#destroyRef = inject(DestroyRef);
    this.elementRef = inject(ElementRef);
    this.#dropdownService = inject(DropdownService);
    this.dropdown = inject(DropdownToken, {
      optional: true
    });
    /**
     * Reference to dropdown component.
     * @return DropdownComponent | undefined
     * @default undefined
     */
    this.dropdownComponent = input();
    /**
     * Disables the toggler.
     * @return boolean
     * @default false
     */
    this.disabled = input(false, {
      transform: booleanAttribute
    });
    /**
     * Enables pseudo element caret on toggler.
     * @return boolean
     */
    this.caret = input(true);
    /**
     * Create split button dropdowns with virtually the same markup as single button dropdowns,
     * but with the addition of `.dropdown-toggle-split` class for proper spacing around the dropdown caret.
     * @return boolean
     * @default false
     */
    this.split = input(false, {
      transform: booleanAttribute
    });
    this.hostClasses = computed(() => {
      return {
        'dropdown-toggle': this.caret(),
        'dropdown-toggle-split': this.split(),
        disabled: this.disabled()
      };
    });
    this.#ariaExpanded = signal(false);
  }
  // injections
  #destroyRef;
  #dropdownService;
  #ariaExpanded;
  get ariaExpanded() {
    return this.#ariaExpanded();
  }
  onClick($event) {
    $event.preventDefault();
    !this.disabled() && this.#dropdownService.toggle({
      visible: 'toggle',
      dropdown: this.dropdown
    });
  }
  ngAfterViewInit() {
    const dropdownComponent = this.dropdownComponent();
    if (dropdownComponent) {
      this.dropdown = dropdownComponent;
      this.#dropdownService = dropdownComponent?.dropdownService;
    }
    if (this.dropdown) {
      const dropdown = this.dropdown;
      dropdown?.visibleChange?.subscribe(visible => {
        this.#ariaExpanded.set(visible);
      });
    }
  }
  static {
    this.ɵfac = function DropdownToggleDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DropdownToggleDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: DropdownToggleDirective,
      selectors: [["", "cDropdownToggle", ""]],
      hostVars: 3,
      hostBindings: function DropdownToggleDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function DropdownToggleDirective_click_HostBindingHandler($event) {
            return ctx.onClick($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("aria-expanded", ctx.ariaExpanded);
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        dropdownComponent: [1, "dropdownComponent"],
        disabled: [1, "disabled"],
        caret: [1, "caret"],
        split: [1, "split"]
      },
      exportAs: ["cDropdownToggle"],
      features: [i0.ɵɵProvidersFeature([{
        provide: DropdownToken,
        useExisting: forwardRef(() => DropdownComponent)
      }])]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownToggleDirective, [{
    type: Directive,
    args: [{
      selector: '[cDropdownToggle]',
      providers: [{
        provide: DropdownToken,
        useExisting: forwardRef(() => DropdownComponent)
      }],
      exportAs: 'cDropdownToggle',
      host: {
        '[class]': 'hostClasses()',
        '[attr.aria-expanded]': 'ariaExpanded',
        '(click)': 'onClick($event)'
      }
    }]
  }], null, null);
})();
class DropdownComponent {
  constructor(document, elementRef, renderer, ngZone, changeDetectorRef, dropdownService) {
    this.document = document;
    this.elementRef = elementRef;
    this.renderer = renderer;
    this.ngZone = ngZone;
    this.changeDetectorRef = changeDetectorRef;
    this.dropdownService = dropdownService;
    /**
     * Set alignment of dropdown menu.
     * @return {'start' | 'end' | { xs: 'start' | 'end' } | { sm: 'start' | 'end' } | { md: 'start' | 'end' } | { lg: 'start' | 'end' } | { xl: 'start' | 'end'} | { xxl: 'start' | 'end'}}
     */
    this.alignment = input();
    /**
     * Automatically close dropdown when clicking outside the dropdown menu.
     */
    this.autoClose = input(true);
    /**
     * Sets a specified  direction and location of the dropdown menu.
     * @return 'dropup' | 'dropend' | 'dropstart'
     */
    this.direction = input();
    /**
     * Describes the placement of your component after Popper.js has applied all the modifiers
     * that may have flipped or altered the originally provided placement property.
     * @return Placement
     */
    this.placement = input('bottom-start');
    /**
     * If you want to disable dynamic positioning set this property to `false`.
     * @return boolean
     * @default true
     */
    this.popper = input(true, {
      transform: booleanAttribute
    });
    /**
     * Optional popper Options object, placement prop takes precedence over
     * @return Partial<Options>
     */
    this.popperOptionsInput = input({}, {
      alias: 'popperOptions'
    });
    this.popperOptionsEffect = effect(() => {
      this.popperOptions = {
        ...untracked(this.#popperOptions),
        ...this.popperOptionsInput()
      };
    });
    this.#popperOptions = signal({
      placement: this.placement(),
      modifiers: [],
      strategy: 'absolute'
    });
    /**
     * Set the dropdown variant to a btn-group, dropdown, input-group, and nav-item.
     */
    this.variant = input('dropdown');
    /**
     * Toggle the visibility of dropdown menu component.
     * @return boolean
     * @default false
     */
    this.visibleInput = input(false, {
      transform: booleanAttribute,
      alias: 'visible'
    });
    this.visible = linkedSignal({
      source: this.visibleInput,
      computation: value => value
    });
    this.visibleEffect = effect(() => {
      const visible = this.visible();
      this.activeTrap = visible;
      visible ? this.createPopperInstance() : this.destroyPopperInstance();
      this.setVisibleState(visible);
      this.visibleChange.emit(visible);
    });
    this.visibleChange = output();
    this.dropdownContext = {
      $implicit: this.visible()
    };
    this.activeTrap = false;
    this.listeners = [];
    this.hostClasses = computed(() => {
      const direction = this.direction();
      const variant = this.variant();
      return {
        dropdown: (variant === 'dropdown' || variant === 'nav-item') && !direction,
        [`${direction}`]: !!direction,
        [`${variant}`]: !!variant,
        dropup: direction === 'dropup' || direction === 'dropup-center',
        show: this.visible()
      };
    });
    // todo: find better solution
    this.hostStyle = computed(() => {
      return this.variant() === 'input-group' ? {
        display: 'contents'
      } : {};
    });
    this.dropdownStateSubscribe();
  }
  set popperOptions(value) {
    this.#popperOptions.update(popperOptions => ({
      ...popperOptions,
      ...value
    }));
  }
  get popperOptions() {
    let placement = this.placement();
    switch (this.direction()) {
      case 'dropup':
        {
          placement = 'top-start';
          break;
        }
      case 'dropend':
        {
          placement = 'right-start';
          break;
        }
      case 'dropstart':
        {
          placement = 'left-start';
          break;
        }
      case 'center':
        {
          placement = 'bottom';
          break;
        }
      case 'dropup-center':
        {
          placement = 'top';
          break;
        }
    }
    if (this.alignment() === 'end') {
      placement = 'bottom-end';
    }
    this.#popperOptions.update(value => ({
      ...value,
      placement: placement
    }));
    return this.#popperOptions();
  }
  #popperOptions;
  onHostClick($event) {
    this.clickedTarget = $event.target;
  }
  dropdownStateSubscribe(subscribe = true) {
    if (subscribe) {
      this.dropdownStateSubscription = this.dropdownService.dropdownState$.pipe(filter(state => {
        return this === state.dropdown;
      })).subscribe(state => {
        if ('visible' in state) {
          state?.visible === 'toggle' ? this.toggleDropdown() : this.visible.set(state.visible);
        }
      });
    } else {
      this.dropdownStateSubscription?.unsubscribe();
    }
  }
  toggleDropdown() {
    this.visible.update(visible => !visible);
  }
  onClick(event) {
    if (!this._toggler?.elementRef.nativeElement.contains(event.target?.closest('[cDropdownToggle]'))) {
      this.toggleDropdown();
    }
  }
  ngAfterContentInit() {
    if (this.variant() === 'nav-item') {
      this.renderer.addClass(this._toggler.elementRef.nativeElement, 'nav-link');
    }
  }
  ngOnInit() {
    this.setVisibleState(this.visible());
  }
  ngOnDestroy() {
    this.clearListeners();
    this.dropdownStateSubscribe(false);
    this.destroyPopperInstance();
  }
  setVisibleState(value) {
    this.dropdownService.toggle({
      visible: value,
      dropdown: this
    });
  }
  // todo: turn off popper in navbar-nav
  createPopperInstance() {
    if (this._toggler && this._menu) {
      this.ngZone.runOutsideAngular(() => {
        // workaround for popper position calculate (see also: dropdown-menu.component)
        this._menu.elementRef.nativeElement.style.visibility = 'hidden';
        this._menu.elementRef.nativeElement.style.display = 'block';
        if (this.popper()) {
          this.popperInstance = createPopper(this._toggler.elementRef.nativeElement, this._menu.elementRef.nativeElement, {
            ...this.popperOptions
          });
        }
        this.ngZone.run(() => {
          this.setListeners();
          this.changeDetectorRef.markForCheck();
          this.changeDetectorRef.detectChanges();
        });
      });
    }
  }
  destroyPopperInstance() {
    this.clearListeners();
    this.popperInstance?.destroy();
    this.popperInstance = undefined;
    this.changeDetectorRef.markForCheck();
  }
  setListeners() {
    this.listeners.push(this.renderer.listen(this.document, 'click', event => {
      const target = event.target;
      if (this._menuElementRef?.nativeElement.contains(event.target)) {
        this.clickedTarget = target;
      }
      if (this._toggler?.elementRef.nativeElement.contains(event.target)) {
        return;
      }
      const autoClose = this.autoClose();
      if (autoClose === true) {
        this.setVisibleState(false);
        return;
      }
      if (this.clickedTarget === target && autoClose === 'inside') {
        this.setVisibleState(false);
        return;
      }
      if (this.clickedTarget !== target && autoClose === 'outside') {
        this.setVisibleState(false);
        return;
      }
    }));
    this.listeners.push(this.renderer.listen(this.elementRef.nativeElement, 'keyup', event => {
      if (event.key === 'Escape' && this.autoClose() !== false) {
        event.stopPropagation();
        this.setVisibleState(false);
        return;
      }
    }));
    this.listeners.push(this.renderer.listen(this.document, 'keyup', event => {
      if (event.key === 'Tab' && this.autoClose() !== false && !this.elementRef.nativeElement.contains(event.target)) {
        this.setVisibleState(false);
        return;
      }
    }));
  }
  clearListeners() {
    this.listeners.forEach(unListen => {
      unListen();
    });
    // @ts-ignore
    this.listeners.fill(undefined);
    this.listeners = [];
  }
  static {
    this.ɵfac = function DropdownComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DropdownComponent)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(DropdownService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DropdownComponent,
      selectors: [["c-dropdown"]],
      contentQueries: function DropdownComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, DropdownToggleDirective, 5);
          i0.ɵɵcontentQuery(dirIndex, DropdownMenuDirective, 5);
          i0.ɵɵcontentQuery(dirIndex, DropdownMenuDirective, 5, ElementRef);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._toggler = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._menu = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._menuElementRef = _t.first);
        }
      },
      hostVars: 4,
      hostBindings: function DropdownComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function DropdownComponent_click_HostBindingHandler($event) {
            return ctx.onHostClick($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵstyleMap(ctx.hostStyle());
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        alignment: [1, "alignment"],
        autoClose: [1, "autoClose"],
        direction: [1, "direction"],
        placement: [1, "placement"],
        popper: [1, "popper"],
        popperOptionsInput: [1, "popperOptions", "popperOptionsInput"],
        variant: [1, "variant"],
        visibleInput: [1, "visible", "visibleInput"]
      },
      outputs: {
        visibleChange: "visibleChange"
      },
      exportAs: ["cDropdown"],
      features: [i0.ɵɵProvidersFeature([DropdownService]), i0.ɵɵHostDirectivesFeature([{
        directive: ThemeDirective,
        inputs: ["dark", "dark"]
      }])],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DropdownComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: [".dropdown[_nghost-%COMP%]:not(.btn-group), .dropdown   [_nghost-%COMP%]:not(.btn-group), .dropup[_nghost-%COMP%]:not(.btn-group), .dropup   [_nghost-%COMP%]:not(.btn-group){display:block}.dropstart[_nghost-%COMP%]:not(.btn-group), .dropstart   [_nghost-%COMP%]:not(.btn-group), .dropend[_nghost-%COMP%]:not(.btn-group), .dropend   [_nghost-%COMP%]:not(.btn-group){display:inline-flex}html:not([dir=rtl]).input-group   [_nghost-%COMP%]:first-child  :first-child, html:not([dir=rtl])   .input-group   [_nghost-%COMP%]:first-child  :first-child, .input-group   html:not([dir=rtl])   [_nghost-%COMP%]:first-child  :first-child{border-top-right-radius:0;border-bottom-right-radius:0}html:not([dir=rtl]).input-group   [_nghost-%COMP%]:first-child  :not(:first-child):not(.dropdown-menu), html:not([dir=rtl])   .input-group   [_nghost-%COMP%]:first-child  :not(:first-child):not(.dropdown-menu), .input-group   html:not([dir=rtl])   [_nghost-%COMP%]:first-child  :not(:first-child):not(.dropdown-menu){margin-left:-1px;border-top-left-radius:0;border-bottom-left-radius:0}html:not([dir=rtl]).input-group   [_nghost-%COMP%]:first-child  :not(:first-child):not(.dropdown-menu):not(:only-of-type), html:not([dir=rtl])   .input-group   [_nghost-%COMP%]:first-child  :not(:first-child):not(.dropdown-menu):not(:only-of-type), .input-group   html:not([dir=rtl])   [_nghost-%COMP%]:first-child  :not(:first-child):not(.dropdown-menu):not(:only-of-type){border-top-right-radius:0;border-bottom-right-radius:0}html:not([dir=rtl]).input-group   [_nghost-%COMP%]:last-child  :first-child, html:not([dir=rtl])   .input-group   [_nghost-%COMP%]:last-child  :first-child, .input-group   html:not([dir=rtl])   [_nghost-%COMP%]:last-child  :first-child{border-top-left-radius:0;border-bottom-left-radius:0}html:not([dir=rtl]).input-group   [_nghost-%COMP%]:last-child  :first-child:not(:only-of-type), html:not([dir=rtl])   .input-group   [_nghost-%COMP%]:last-child  :first-child:not(:only-of-type), .input-group   html:not([dir=rtl])   [_nghost-%COMP%]:last-child  :first-child:not(:only-of-type){border-top-right-radius:0;border-bottom-right-radius:0}html:not([dir=rtl]).input-group   [_nghost-%COMP%]:last-child  :not(:first-child):not(.dropdown-menu), html:not([dir=rtl])   .input-group   [_nghost-%COMP%]:last-child  :not(:first-child):not(.dropdown-menu), .input-group   html:not([dir=rtl])   [_nghost-%COMP%]:last-child  :not(:first-child):not(.dropdown-menu){margin-left:-1px;border-top-left-radius:0;border-bottom-left-radius:0}[dir=rtl]   .input-group   [_nghost-%COMP%]{direction:rtl}[dir=rtl]   .input-group   [_nghost-%COMP%]:first-child  :first-child{border-top-left-radius:0;border-bottom-left-radius:0}[dir=rtl]   .input-group   [_nghost-%COMP%]:first-child  :not(:first-child):not(.dropdown-menu){margin-right:-1px;border-top-right-radius:0;border-bottom-right-radius:0}[dir=rtl]   .input-group   [_nghost-%COMP%]:first-child  :not(:first-child):not(.dropdown-menu):not(:only-of-type){border-top-left-radius:0;border-bottom-left-radius:0}[dir=rtl]   .input-group   [_nghost-%COMP%]:last-child  :first-child{border-top-right-radius:0;border-bottom-right-radius:0}[dir=rtl]   .input-group   [_nghost-%COMP%]:last-child  :first-child:not(:only-of-type){border-top-left-radius:0;border-bottom-left-radius:0}[dir=rtl]   .input-group   [_nghost-%COMP%]:last-child  :not(:first-child):not(.dropdown-menu){margin-right:-1px;border-top-right-radius:0;border-bottom-right-radius:0}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownComponent, [{
    type: Component,
    args: [{
      selector: 'c-dropdown',
      template: '<ng-content />',
      exportAs: 'cDropdown',
      providers: [DropdownService],
      hostDirectives: [{
        directive: ThemeDirective,
        inputs: ['dark']
      }],
      host: {
        '[class]': 'hostClasses()',
        '[style]': 'hostStyle()',
        '(click)': 'onHostClick($event)'
      },
      styles: [":host-context(.dropdown,.dropup):not(.btn-group){display:block}:host-context(.dropstart,.dropend):not(.btn-group){display:inline-flex}:host-context(html:not([dir=rtl])) :host-context(.input-group) :host:first-child::ng-deep :first-child{border-top-right-radius:0;border-bottom-right-radius:0}:host-context(html:not([dir=rtl])) :host-context(.input-group) :host:first-child::ng-deep :not(:first-child):not(.dropdown-menu){margin-left:-1px;border-top-left-radius:0;border-bottom-left-radius:0}:host-context(html:not([dir=rtl])) :host-context(.input-group) :host:first-child::ng-deep :not(:first-child):not(.dropdown-menu):not(:only-of-type){border-top-right-radius:0;border-bottom-right-radius:0}:host-context(html:not([dir=rtl])) :host-context(.input-group) :host:last-child::ng-deep :first-child{border-top-left-radius:0;border-bottom-left-radius:0}:host-context(html:not([dir=rtl])) :host-context(.input-group) :host:last-child::ng-deep :first-child:not(:only-of-type){border-top-right-radius:0;border-bottom-right-radius:0}:host-context(html:not([dir=rtl])) :host-context(.input-group) :host:last-child::ng-deep :not(:first-child):not(.dropdown-menu){margin-left:-1px;border-top-left-radius:0;border-bottom-left-radius:0}:host-context([dir=rtl] .input-group) :host{direction:rtl}:host-context([dir=rtl] .input-group) :host:first-child::ng-deep :first-child{border-top-left-radius:0;border-bottom-left-radius:0}:host-context([dir=rtl] .input-group) :host:first-child::ng-deep :not(:first-child):not(.dropdown-menu){margin-right:-1px;border-top-right-radius:0;border-bottom-right-radius:0}:host-context([dir=rtl] .input-group) :host:first-child::ng-deep :not(:first-child):not(.dropdown-menu):not(:only-of-type){border-top-left-radius:0;border-bottom-left-radius:0}:host-context([dir=rtl] .input-group) :host:last-child::ng-deep :first-child{border-top-right-radius:0;border-bottom-right-radius:0}:host-context([dir=rtl] .input-group) :host:last-child::ng-deep :first-child:not(:only-of-type){border-top-left-radius:0;border-bottom-left-radius:0}:host-context([dir=rtl] .input-group) :host:last-child::ng-deep :not(:first-child):not(.dropdown-menu){margin-right:-1px;border-top-right-radius:0;border-bottom-right-radius:0}\n"]
    }]
  }], () => [{
    type: Document,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }, {
    type: i0.NgZone
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: DropdownService
  }], {
    _toggler: [{
      type: ContentChild,
      args: [DropdownToggleDirective]
    }],
    _menu: [{
      type: ContentChild,
      args: [DropdownMenuDirective]
    }],
    _menuElementRef: [{
      type: ContentChild,
      args: [DropdownMenuDirective, {
        read: ElementRef
      }]
    }]
  });
})();
class DropdownItemDirective {
  constructor() {
    this.#elementRef = inject(ElementRef);
    this.#dropdownService = inject(DropdownService);
    this.dropdown = inject(DropdownComponent, {
      optional: true
    });
    /**
     * Set active state to a dropdown-item.
     * @return boolean
     * @default undefined
     */
    this.active = input();
    /**
     * Configure dropdown-item close dropdown behavior.
     * @return boolean
     * @default true
     */
    this.autoClose = input(true);
    /**
     * Disables a dropdown-item.
     * @return boolean
     * @default undefined
     */
    this.disabledInput = input(false, {
      transform: booleanAttribute,
      alias: 'disabled'
    });
    this.disabledEffect = linkedSignal({
      source: this.disabledInput,
      computation: value => value
    });
    this.ariaCurrent = computed(() => {
      return this.active() ? 'true' : null;
    });
    this.hostClasses = computed(() => {
      return {
        'dropdown-item': true,
        active: this.active(),
        disabled: this.disabled
      };
    });
    this.tabIndexInput = input(null, {
      alias: 'tabIndex'
    });
    this.tabIndex = linkedSignal({
      source: this.tabIndexInput,
      computation: value => this.disabled ? '-1' : value
    });
  }
  #elementRef;
  #dropdownService;
  set disabled(value) {
    this.disabledEffect.set(value);
  }
  get disabled() {
    return this.disabledEffect();
  }
  focus(origin) {
    this.#elementRef?.nativeElement?.focus();
  }
  getLabel() {
    return this.#elementRef?.nativeElement?.textContent.trim();
  }
  onClick($event) {
    this.handleInteraction();
  }
  onKeyUp($event) {
    if ($event.key === 'Enter') {
      this.handleInteraction();
    }
  }
  handleInteraction() {
    if (this.autoClose()) {
      this.#dropdownService.toggle({
        visible: 'toggle',
        dropdown: this.dropdown
      });
    }
  }
  static {
    this.ɵfac = function DropdownItemDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DropdownItemDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: DropdownItemDirective,
      selectors: [["", "cDropdownItem", ""]],
      hostAttrs: [1, "dropdown-item"],
      hostVars: 5,
      hostBindings: function DropdownItemDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function DropdownItemDirective_click_HostBindingHandler($event) {
            return ctx.onClick($event);
          })("keyup", function DropdownItemDirective_keyup_HostBindingHandler($event) {
            return ctx.onKeyUp($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("tabindex", ctx.tabIndex())("aria-current", ctx.ariaCurrent())("aria-disabled", ctx.disabled || null);
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        active: [1, "active"],
        autoClose: [1, "autoClose"],
        disabledInput: [1, "disabled", "disabledInput"],
        tabIndexInput: [1, "tabIndex", "tabIndexInput"]
      },
      exportAs: ["cDropdownItem"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownItemDirective, [{
    type: Directive,
    args: [{
      selector: '[cDropdownItem]',
      exportAs: 'cDropdownItem',
      host: {
        class: 'dropdown-item',
        '[class]': 'hostClasses()',
        '[attr.tabindex]': 'tabIndex()',
        '[attr.aria-current]': 'ariaCurrent()',
        '[attr.aria-disabled]': 'disabled || null',
        '(click)': 'onClick($event)',
        '(keyup)': 'onKeyUp($event)'
      }
    }]
  }], null, null);
})();
class DropdownItemPlainDirective {
  static {
    this.ɵfac = function DropdownItemPlainDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DropdownItemPlainDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: DropdownItemPlainDirective,
      selectors: [["", "cDropdownItemPlain", ""]],
      hostAttrs: [1, "dropdown-item-text"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownItemPlainDirective, [{
    type: Directive,
    args: [{
      selector: '[cDropdownItemPlain]',
      host: {
        class: 'dropdown-item-text'
      }
    }]
  }], null, null);
})();
class DropdownCloseDirective {
  constructor() {
    this.#dropdownService = inject(DropdownService);
    this.dropdown = inject(DropdownComponent, {
      optional: true
    });
    /**
     * Disables a dropdown-close directive.
     * @return boolean
     * @default false
     */
    this.disabledInput = input(false, {
      transform: booleanAttribute,
      alias: 'disabled'
    });
    this.disabled = linkedSignal({
      source: this.disabledInput,
      computation: value => value || null
    });
    this.dropdownComponent = input();
    this.tabIndexInput = input(null, {
      alias: 'tabIndex'
    });
    this.tabIndex = linkedSignal({
      source: this.tabIndexInput,
      computation: value => this.disabled() ? '-1' : value
    });
  }
  #dropdownService;
  ngAfterViewInit() {
    const dropdownComponent = this.dropdownComponent();
    if (dropdownComponent) {
      this.dropdown = dropdownComponent;
      this.#dropdownService = dropdownComponent?.dropdownService;
    }
  }
  onClick($event) {
    this.handleToggle();
  }
  onKeyUp($event) {
    if ($event.key === 'Enter') {
      this.handleToggle();
    }
  }
  handleToggle() {
    if (!this.disabled()) {
      this.#dropdownService.toggle({
        visible: false,
        dropdown: this.dropdown
      });
    }
  }
  static {
    this.ɵfac = function DropdownCloseDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DropdownCloseDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: DropdownCloseDirective,
      selectors: [["", "cDropdownClose", ""]],
      hostVars: 4,
      hostBindings: function DropdownCloseDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function DropdownCloseDirective_click_HostBindingHandler($event) {
            return ctx.onClick($event);
          })("keyup", function DropdownCloseDirective_keyup_HostBindingHandler($event) {
            return ctx.onKeyUp($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("aria-disabled", ctx.disabled() || null)("tabindex", ctx.tabIndex());
          i0.ɵɵclassProp("disabled", ctx.disabled());
        }
      },
      inputs: {
        disabledInput: [1, "disabled", "disabledInput"],
        dropdownComponent: [1, "dropdownComponent"],
        tabIndexInput: [1, "tabIndex", "tabIndexInput"]
      },
      exportAs: ["cDropdownClose"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownCloseDirective, [{
    type: Directive,
    args: [{
      selector: '[cDropdownClose]',
      exportAs: 'cDropdownClose',
      host: {
        '[class.disabled]': 'disabled()',
        '[attr.aria-disabled]': 'disabled() || null',
        '[attr.tabindex]': 'tabIndex()',
        '(click)': 'onClick($event)',
        '(keyup)': 'onKeyUp($event)'
      }
    }]
  }], null, null);
})();
class DropdownModule {
  static {
    this.ɵfac = function DropdownModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DropdownModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DropdownModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [DropdownService]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownModule, [{
    type: NgModule,
    args: [{
      imports: [DropdownComponent, DropdownCloseDirective, DropdownDividerDirective, DropdownHeaderDirective, DropdownItemDirective, DropdownItemPlainDirective, DropdownMenuDirective, DropdownToggleDirective],
      exports: [DropdownComponent, DropdownCloseDirective, DropdownDividerDirective, DropdownHeaderDirective, DropdownItemDirective, DropdownItemPlainDirective, DropdownMenuDirective, DropdownToggleDirective],
      providers: [DropdownService]
    }]
  }], null, null);
})();
class FormDirective {
  constructor() {
    /**
     * Mark a form as validated. If you set it `true`, all validation styles will be applied to the form. [docs]
     * @return boolean
     * @default false
     */
    this.validated = input(false, {
      transform: booleanAttribute
    });
  }
  static {
    this.ɵfac = function FormDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FormDirective,
      selectors: [["form", "cForm", ""]],
      hostVars: 2,
      hostBindings: function FormDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("was-validated", ctx.validated());
        }
      },
      inputs: {
        validated: [1, "validated"]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormDirective, [{
    type: Directive,
    args: [{
      selector: 'form[cForm]',
      host: {
        '[class.was-validated]': 'validated()'
      }
    }]
  }], null, null);
})();
class FormFeedbackComponent {
  constructor() {
    /**
     * If your form layout allows it, you can display validation feedback in a styled tooltip.
     * @default false
     */
    this.tooltip = input(false, {
      transform: booleanAttribute
    });
    /**
     * Set component validation state to valid.
     * @default undefined
     */
    this.valid = input();
    this.hostClasses = computed(() => {
      const status = this.valid() === true ? 'valid' : 'invalid';
      const type = this.tooltip() ? 'tooltip' : 'feedback';
      return {
        [`${status}-${type}`]: true
        // 'valid-feedback': valid === true && !tooltip,
        // 'valid-tooltip': valid === true && tooltip,
        // 'invalid-feedback': valid !== true && !tooltip,
        // 'invalid-tooltip': valid !== true && tooltip
      };
    });
  }
  static {
    this.ɵfac = function FormFeedbackComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormFeedbackComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FormFeedbackComponent,
      selectors: [["c-form-feedback"]],
      hostVars: 2,
      hostBindings: function FormFeedbackComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        tooltip: [1, "tooltip"],
        valid: [1, "valid"]
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function FormFeedbackComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormFeedbackComponent, [{
    type: Component,
    args: [{
      selector: 'c-form-feedback',
      template: '<ng-content />',
      host: {
        '[class]': 'hostClasses()'
      }
    }]
  }], null, null);
})();
class InputGroupComponent {
  constructor() {
    /**
     * Size the component small or large.
     */
    this.sizing = input();
    this.hostClasses = computed(() => {
      const sizing = this.sizing();
      return {
        'input-group': true,
        [`input-group-${sizing}`]: !!sizing
      };
    });
  }
  static {
    this.ɵfac = function InputGroupComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || InputGroupComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: InputGroupComponent,
      selectors: [["c-input-group"]],
      hostAttrs: [1, "input-group"],
      hostVars: 2,
      hostBindings: function InputGroupComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        sizing: [1, "sizing"]
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function InputGroupComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InputGroupComponent, [{
    type: Component,
    args: [{
      selector: 'c-input-group',
      template: '<ng-content />',
      host: {
        class: 'input-group',
        '[class]': 'hostClasses()'
      }
    }]
  }], null, null);
})();
class FormSelectDirective {
  constructor() {
    /**
     * Size the component small or large.
     * @default undefined
     */
    this.sizing = input();
    /**
     * Set component validation state to valid.
     * @default undefined
     */
    this.valid = input();
    this.hostClasses = computed(() => {
      const sizing = this.sizing();
      const valid = this.valid();
      return {
        'form-select': true,
        [`form-select-${sizing}`]: !!sizing,
        'is-valid': valid === true,
        'is-invalid': valid === false
      };
    });
  }
  static {
    this.ɵfac = function FormSelectDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormSelectDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FormSelectDirective,
      selectors: [["select", "cSelect", ""]],
      hostAttrs: [1, "form-select"],
      hostVars: 2,
      hostBindings: function FormSelectDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        sizing: [1, "sizing"],
        valid: [1, "valid"]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormSelectDirective, [{
    type: Directive,
    args: [{
      selector: 'select[cSelect]',
      host: {
        class: 'form-select',
        '[class]': 'hostClasses()'
      }
    }]
  }], null, null);
})();
class FormLabelDirective {
  constructor() {
    /**
     * For horizontal forms set labels to 'col' and make them vertically centered with their associated form controls.
     * @default ''
     */
    this.col = input('', {
      alias: 'cLabel'
    });
    /**
     * Size the label small or large.
     * @default ''
     */
    this.sizing = input();
    this.hostClasses = computed(() => {
      const col = this.col();
      const sizing = this.sizing();
      return {
        'form-label': true,
        'col-form-label': col === 'col',
        [`col-form-label-${sizing}`]: !!sizing && col === 'col'
      };
    });
  }
  static {
    this.ɵfac = function FormLabelDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormLabelDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FormLabelDirective,
      selectors: [["", "cLabel", ""]],
      hostAttrs: [1, "form-label"],
      hostVars: 2,
      hostBindings: function FormLabelDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        col: [1, "cLabel", "col"],
        sizing: [1, "sizing"]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormLabelDirective, [{
    type: Directive,
    args: [{
      selector: '[cLabel]',
      host: {
        class: 'form-label',
        '[class]': 'hostClasses()'
      }
    }]
  }], null, null);
})();
class FormCheckLabelDirective {
  static {
    this.ɵfac = function FormCheckLabelDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormCheckLabelDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FormCheckLabelDirective,
      selectors: [["label", "cFormCheckLabel", ""]],
      hostAttrs: [1, "form-check-label"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormCheckLabelDirective, [{
    type: Directive,
    args: [{
      selector: 'label[cFormCheckLabel]',
      host: {
        class: 'form-check-label'
      }
    }]
  }], null, null);
})();
class FormCheckComponent {
  constructor() {
    /**
     * Group checkboxes or radios on the same horizontal row.
     * @default false
     */
    this.inline = input(false, {
      transform: booleanAttribute
    });
    /**
     * Put checkboxes or radios on the opposite side.
     * @default false
     * @since 4.4.7
     */
    this.reverse = input(false, {
      transform: booleanAttribute
    });
    /**
     * Size the component large or extra large. Works only with `[switch]="true"` [docs]
     * @default undefined
     */
    this.sizing = input();
    /**
     * Render a toggle switch on for checkbox.
     * @type boolean
     * @default false
     */
    this.switch = input(false, {
      transform: booleanAttribute
    });
    this.formCheckLabel = contentChild(FormCheckLabelDirective);
    this.formCheckClass = computed(() => !!this.formCheckLabel());
    this.hostClasses = computed(() => {
      const sizing = this.sizing();
      const isSwitch = this.switch();
      return {
        'form-check': !!this.formCheckLabel(),
        'form-switch': isSwitch,
        [`form-switch-${sizing}`]: isSwitch && !!sizing,
        'form-check-inline': this.inline(),
        'form-check-reverse': this.reverse()
      };
    });
  }
  static {
    this.ɵfac = function FormCheckComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormCheckComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FormCheckComponent,
      selectors: [["c-form-check"]],
      contentQueries: function FormCheckComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.formCheckLabel, FormCheckLabelDirective, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      hostVars: 2,
      hostBindings: function FormCheckComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        inline: [1, "inline"],
        reverse: [1, "reverse"],
        sizing: [1, "sizing"],
        switch: [1, "switch"]
      },
      exportAs: ["cFormCheck"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function FormCheckComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormCheckComponent, [{
    type: Component,
    args: [{
      selector: 'c-form-check',
      template: '<ng-content />',
      exportAs: 'cFormCheck',
      host: {
        '[class]': 'hostClasses()'
      }
    }]
  }], null, null);
})();
class FormCheckInputDirective {
  constructor() {
    this.#renderer = inject(Renderer2);
    this.#hostElement = inject(ElementRef);
    /**
     * Specifies the type of component.
     * @default 'checkbox'
     */
    this.type = input('checkbox');
    /**
     * Set component indeterminate state.
     * @default false
     */
    this.indeterminateInput = input(false, {
      transform: booleanAttribute,
      alias: 'indeterminate'
    });
    this.#indeterminateEffect = effect(() => {
      const indeterminate = this.indeterminateInput();
      if (untracked(this.#indeterminate) !== indeterminate) {
        const htmlInputElement = this.#hostElement.nativeElement;
        if (indeterminate) {
          this.#renderer.setProperty(htmlInputElement, 'checked', false);
        }
        this.#renderer.setProperty(htmlInputElement, 'indeterminate', indeterminate);
        this.#indeterminate.set(indeterminate);
      }
    });
    this.#indeterminate = signal(false);
    /**
     * Set component validation state to valid.
     * @default undefined
     */
    this.valid = input();
    this.hostClasses = computed(() => {
      const valid = this.valid();
      return {
        'form-check-input': true,
        'is-valid': valid === true,
        'is-invalid': valid === false
      };
    });
    /**
     * Set component checked state.
     * @default false
     */
    this.checkedInput = input(false, {
      transform: booleanAttribute,
      alias: 'checked'
    });
    this.#checkedEffect = effect(() => {
      const checked = this.checkedInput();
      const htmlInputElement = this.#hostElement?.nativeElement;
      if (htmlInputElement) {
        this.#renderer.setProperty(htmlInputElement, 'checked', checked);
      }
    });
  }
  #renderer;
  #hostElement;
  #indeterminateEffect;
  get indeterminate() {
    return this.#indeterminate();
  }
  #indeterminate;
  #checkedEffect;
  get checked() {
    return this.#hostElement?.nativeElement?.checked;
  }
  static {
    this.ɵfac = function FormCheckInputDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormCheckInputDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FormCheckInputDirective,
      selectors: [["input", "cFormCheckInput", ""]],
      hostAttrs: [1, "form-check-input"],
      hostVars: 3,
      hostBindings: function FormCheckInputDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("type", ctx.type());
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        type: [1, "type"],
        indeterminateInput: [1, "indeterminate", "indeterminateInput"],
        valid: [1, "valid"],
        checkedInput: [1, "checked", "checkedInput"]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormCheckInputDirective, [{
    type: Directive,
    args: [{
      selector: 'input[cFormCheckInput]',
      host: {
        class: 'form-check-input',
        '[class]': 'hostClasses()',
        '[attr.type]': 'type()'
      }
    }]
  }], null, null);
})();
class FormControlDirective {
  constructor() {
    this.#hostElement = inject(ElementRef);
    /**
     * Size the component small or large.
     * @default undefined
     */
    this.sizing = input();
    /**
     * Set component validation state to valid.
     * @default undefined
     */
    this.valid = input();
    /**
     * Specifies the type of input element.
     */
    this.type = input('text');
    /**
     * Render the component styled as plain text. Removes the default form field styling and preserve the correct margin and padding. Recommend to use alongside `readonly`
     * @default false
     */
    this.plaintext = input(false, {
      transform: booleanAttribute
    });
    this.hostClasses = computed(() => {
      const type = this.type();
      const isRange = type === 'range';
      const plaintext = this.plaintext();
      const sizing = this.sizing();
      const valid = this.valid();
      return {
        'form-control': !isRange && !plaintext,
        'form-control-plaintext': !isRange && plaintext,
        'form-control-color': type === 'color',
        'form-range': isRange,
        [`form-control-${sizing}`]: !!sizing && !isRange,
        'is-valid': valid === true,
        'is-invalid': valid === false
      };
    });
  }
  #hostElement;
  get hostTag() {
    return this.#hostElement.nativeElement.tagName;
  }
  ngOnInit() {
    const hostTag = this.hostTag.toLowerCase();
    if (hostTag !== 'input' && hostTag !== 'textarea') {
      console.warn(`CoreUI [cFormControl] works with '<input>' and '<textarea>' - not with '<${hostTag}>'`);
    }
  }
  static {
    this.ɵfac = function FormControlDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormControlDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FormControlDirective,
      selectors: [["input", "cFormControl", ""], ["textarea", "cFormControl", ""]],
      hostVars: 3,
      hostBindings: function FormControlDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("type", ctx.type());
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        sizing: [1, "sizing"],
        valid: [1, "valid"],
        type: [1, "type"],
        plaintext: [1, "plaintext"]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormControlDirective, [{
    type: Directive,
    args: [{
      selector: 'input[cFormControl], textarea[cFormControl]',
      host: {
        '[class]': 'hostClasses()',
        '[attr.type]': 'type()'
      }
    }]
  }], null, null);
})();
class FormTextDirective {
  static {
    this.ɵfac = function FormTextDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormTextDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FormTextDirective,
      selectors: [["", "cFormText", ""]],
      hostAttrs: [1, "form-text"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormTextDirective, [{
    type: Directive,
    args: [{
      selector: '[cFormText]',
      host: {
        class: 'form-text'
      }
    }]
  }], null, null);
})();
class FormFloatingDirective {
  constructor() {
    /**
     * Enable floating labels
     * @type boolean
     */
    this.floating = input(true, {
      transform: booleanAttribute,
      alias: 'cFormFloating'
    });
  }
  static {
    this.ɵfac = function FormFloatingDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormFloatingDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FormFloatingDirective,
      selectors: [["", "cFormFloating", ""]],
      hostVars: 2,
      hostBindings: function FormFloatingDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("form-floating", ctx.floating());
        }
      },
      inputs: {
        floating: [1, "cFormFloating", "floating"]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormFloatingDirective, [{
    type: Directive,
    args: [{
      selector: '[cFormFloating]',
      host: {
        '[class.form-floating]': 'floating()'
      }
    }]
  }], null, null);
})();
class InputGroupTextDirective {
  static {
    this.ɵfac = function InputGroupTextDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || InputGroupTextDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: InputGroupTextDirective,
      selectors: [["", "cInputGroupText", ""]],
      hostAttrs: [1, "input-group-text"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InputGroupTextDirective, [{
    type: Directive,
    args: [{
      selector: '[cInputGroupText]',
      host: {
        class: 'input-group-text'
      }
    }]
  }], null, null);
})();
class FormModule {
  static {
    this.ɵfac = function FormModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: FormModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormModule, [{
    type: NgModule,
    args: [{
      imports: [FormDirective, FormCheckComponent, FormCheckLabelDirective, FormCheckInputDirective, FormControlDirective, FormFeedbackComponent, FormFloatingDirective, FormLabelDirective, FormSelectDirective, FormTextDirective, InputGroupComponent, InputGroupTextDirective],
      exports: [FormDirective, FormCheckComponent, FormCheckLabelDirective, FormCheckInputDirective, FormControlDirective, FormFeedbackComponent, FormFloatingDirective, FormLabelDirective, FormSelectDirective, FormTextDirective, InputGroupComponent, InputGroupTextDirective]
    }]
  }], null, null);
})();
const getSupportedLocale = (locale = 'default') => {
  let supportedLocale;
  try {
    supportedLocale = Intl.DateTimeFormat.supportedLocalesOf(locale).length ? locale : 'default';
  } catch (e) {
    supportedLocale = 'default';
  }
  return supportedLocale;
};
const isHour12 = (locale = 'default') => {
  const supportedLocale = getSupportedLocale(locale);
  const hour12 = Intl.DateTimeFormat(supportedLocale, {
    timeStyle: 'short'
  }).resolvedOptions().hour12;
  return hour12 ?? false;
};
const convert12hTo24h = (abbr, hour) => {
  if (abbr === 'am' && hour === 12) {
    return 0;
  }
  if (abbr === 'am') {
    return hour;
  }
  if (abbr === 'pm' && hour === 12) {
    return 12;
  }
  return hour + 12;
};
const convert24hTo12h = hour => hour % 12 || 12;
const convertTimeToDate = time => time ? time instanceof Date ? new Date(time) : new Date(`1970-01-01 ${time}`) : null;
// export const getAmPm = (date: Date, locale: string) => {
//   if (date.toLocaleTimeString(locale).includes('AM')) {
//     return 'am'
//   }
//   if (date.toLocaleTimeString(locale).includes('PM')) {
//     return 'pm'
//   }
//   return date.getHours() >= 12 ? 'pm' : 'am'
// }
const getAmPm = (date, locale, options = {}) => {
  const dayPeriods = getDayPeriods('en-US', options);
  const time = new Intl.DateTimeFormat('en-US', {
    timeStyle: 'short',
    hour12: true
  }).format(date);
  const dayPeriod = dayPeriods.find(element => time.includes(element.label));
  return dayPeriod?.value ?? (date.getHours() >= 12 ? 'pm' : 'am');
};
const isAm = date => {
  return date.getHours() < 12;
};
const isPm = date => {
  return date.getHours() > 11;
};
const isValidTimeZone = timeZone => {
  try {
    if (timeZone === undefined) {
      return false;
    }
    if (!Intl || !Intl.DateTimeFormat().resolvedOptions().timeZone) {
      throw new Error('Time zones not supported.');
    }
    if (typeof timeZone !== 'string') {
      throw new Error(`Invalid timeZone type specified: ${timeZone}`);
    }
    try {
      // throws an error if timezone is not valid
      Intl.DateTimeFormat(undefined, {
        timeZone: timeZone
      });
    } catch (error) {
      throw new Error(`Invalid timeZone string specified: ${timeZone}`);
    }
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};
const getListOfHours = (locale, options = {}) => {
  const hour12 = isHour12(locale);
  const time = new Date(0);
  return Array.from({
    length: 24
  }, (_, i) => {
    time.setHours(i);
    const dayPeriod = getAmPm(time, locale);
    return {
      value: i,
      dayPeriod: dayPeriod,
      label: time.toLocaleTimeString(locale, {
        hour: '2-digit',
        hour12: hour12,
        minute: '2-digit',
        second: '2-digit'
      }).split(':')[0]
    };
  });
};
const getListOfMinutes = (locale, options = {}, valueAsString = false) => {
  const d = new Date(0);
  return Array.from({
    length: 60
  }, (_, i) => {
    d.setMinutes(i);
    return {
      value: i,
      // value: valueAsString ? i.toString() : i,
      label: d.toLocaleTimeString(locale, {
        // ...options,
        hour: '2-digit',
        hour12: false,
        minute: '2-digit',
        second: '2-digit'
      }).split(':')[1]
    };
  });
};
const getListOfSeconds = (locale, options = {}, valueAsString = false) => Array.from({
  length: 60
}, (_, i) => {
  const d = new Date(0);
  d.setSeconds(i);
  return {
    value: i,
    // value: valueAsString ? i.toString() : i,
    label: d.toLocaleTimeString(locale, {
      // ...options,
      hour: '2-digit',
      hour12: false,
      minute: '2-digit',
      second: '2-digit'
    }).split(':')[2]
  };
});
const getSelectedHour = (date, locale) => date instanceof Date ? isHour12(locale) ? convert24hTo12h(date.getHours()) : date.getHours() : '';
const getSelectedMinutes = date => date ? date.getMinutes() : '';
const getSelectedSeconds = date => date ? date.getSeconds() : '';
// export const isAmPm = (locale: string) =>
//   ['am', 'AM', 'pm', 'PM'].some((el) => new Date().toLocaleString(locale).includes(el))
const isAmPm = (locale = 'default') => {
  const supportedLocale = getSupportedLocale(locale);
  const date = new Date();
  const time = new Intl.DateTimeFormat(supportedLocale, {
    timeStyle: 'short'
  }).format(date);
  const isAmPm = time.match(/(?:\p{L}\p{M}\p{P}*)+|(?:\p{L}\p{P}*)+/gu) ?? [];
  return isAmPm.length > 0;
};
const isValidTime = time => {
  if (typeof time === 'string') {
    return isValidDate(time) || isValidDate(new Date(`1970-01-01 ${time}`));
  }
  return isValidDate(time);
  // const d = new Date(`1970-01-01 ${time}`)
  // return d instanceof Date && d.getTime()
};
// export const _getDayPeriods = (locale: string = 'default', options: DateTimeFormatOptions = {}) => {
//   const supportedLocale = getSupportedLocale(locale);
//
//   const dayPeriods = { am: 'am', pm: 'pm' };
//
//   const hour12 = isHour12(supportedLocale);
//   if (!hour12) {
//     return dayPeriods;
//   }
//
//   const am = new Date(Date.UTC(1970, 0, 1, 0, 0, 0));
//   const pm = new Date(Date.UTC(1970, 0, 1, 13, 0, 0));
//
//   const formatter = new Intl.DateTimeFormat(supportedLocale, { hour12: hour12, hour: 'numeric', timeZone: 'UTC' });
//   dayPeriods.am = formatter.formatToParts(am).find(part => part.type === 'dayPeriod')?.value ?? 'am';
//   dayPeriods.pm = formatter.formatToParts(pm).find(part => part.type === 'dayPeriod')?.value ?? 'pm'
//   return dayPeriods;
// };
const getDayPeriods = (locale = 'default', options = {}) => {
  const supportedLocale = getSupportedLocale(locale);
  const dayPeriods = [{
    value: 'am',
    label: 'am'
  }, {
    value: 'pm',
    label: 'pm'
  }];
  const hour12 = isHour12(supportedLocale);
  if (!hour12) {
    return dayPeriods;
  }
  const am = new Date(Date.UTC(1970, 0, 1, 0, 0, 0));
  const pm = new Date(Date.UTC(1970, 0, 1, 13, 0, 0));
  const formatter = new Intl.DateTimeFormat(supportedLocale, {
    hour12: hour12,
    hour: 'numeric',
    timeZone: 'UTC'
  });
  const formattedAm = formatter.formatToParts(am).find(part => part.type === 'dayPeriod')?.value ?? 'am';
  const formattedPm = formatter.formatToParts(pm).find(part => part.type === 'dayPeriod')?.value ?? 'pm';
  dayPeriods.forEach((element, index, dayPeriods) => {
    dayPeriods[index].label = element.value === 'am' ? formattedAm ?? 'am' : formattedPm ?? 'pm';
  });
  return dayPeriods;
};
// testing
// const langs = [
//   ['Abkhazian', 'ab'],
//   ['Afar', 'aa'],
//   ['Afrikaans', 'af'],
//   ['Akan', 'ak'],
//   ['Albanian', 'sq'],
//   ['Amharic', 'am'],
//   ['Arabic', 'ar'],
//   ['Aragonese', 'an'],
//   ['Argentina', 'es-ar'],
//   ['Armenian', 'hy'],
//   ['Assamese', 'as'],
//   ['Avaric', 'av'],
//   ['Avestan', 'ae'],
//   ['Aymara', 'ay'],
//   ['Azerbaijani', 'az'],
//   ['Bambara', 'bm'],
//   ['Bashkir', 'ba'],
//   ['Basque', 'eu'],
//   ['Belarusian', 'be'],
//   ['Bengali (Bangla)', 'bn'],
//   ['Bihari', 'bh'],
//   ['Bislama', 'bi'],
//   ['Bosnian', 'bs'],
//   ['Breton', 'br'],
//   ['Bulgarian', 'bg'],
//   ['Burmese', 'my'],
//   ['Catalan', 'ca'],
//   ['Chamorro', 'ch'],
//   ['Chechen', 'ce'],
//   ['Chichewa, Chewa, Nyanja', 'ny'],
//   ['Chinese', 'zh'],
//   ['Chinese (Simplified)', 'zh-Hans'],
//   ['Chinese (Traditional)', 'zh-Hant'],
//   ['Chuvash', 'cv'],
//   ['Cornish', 'kw'],
//   ['Corsican', 'co'],
//   ['Cree', 'cr'],
//   ['Croatian', 'hr'],
//   ['Czech', 'cs'],
//   ['Danish', 'da'],
//   ['Divehi, Dhivehi, Maldivian', 'dv'],
//   ['Dutch', 'nl'],
//   ['Dzongkha', 'dz'],
//   ['English', 'en'],
//   ['Esperanto', 'eo'],
//   ['Estonian', 'et'],
//   ['Ewe', 'ee'],
//   ['Faroese', 'fo'],
//   ['Fijian', 'fj'],
//   ['Finnish', 'fi'],
//   ['French', 'fr'],
//   ['Fula, Fulah, Pulaar, Pular', 'ff'],
//   ['Galician', 'gl'],
//   ['Gaelic (Scottish)', 'gd'],
//   ['Gaelic (Manx)', 'gv'],
//   ['Georgian', 'ka'],
//   ['German', 'de'],
//   ['Greek', 'el'],
//   ['Greenlandic', 'kl'],
//   ['Guarani', 'gn'],
//   ['Gujarati', 'gu'],
//   ['Haitian Creole', 'ht'],
//   ['Hausa', 'ha'],
//   ['Hebrew', 'he'],
//   ['Herero', 'hz'],
//   ['Hindi', 'hi'],
//   ['Hiri Motu', 'ho'],
//   ['Hungarian', 'hu'],
//   ['Icelandic', 'is'],
//   ['Ido', 'io'],
//   ['Igbo', 'ig'],
//   ['Indonesian', 'id', 'in'],
//   ['Interlingua', 'ia'],
//   ['Interlingue', 'ie'],
//   ['Inuktitut', 'iu'],
//   ['Inupiak', 'ik'],
//   ['Irish', 'ga'],
//   ['Italian', 'it'],
//   ['Japanese', 'ja'],
//   ['Javanese', 'jv'],
//   ['Kalaallisut, Greenlandic', 'kl'],
//   ['Kannada', 'kn'],
//   ['Kanuri', 'kr'],
//   ['Kashmiri', 'ks'],
//   ['Kazakh', 'kk'],
//   ['Khmer', 'km'],
//   ['Kikuyu', 'ki'],
//   ['Kinyarwanda (Rwanda)', 'rw'],
//   ['Kirundi', 'rn'],
//   ['Kyrgyz', 'ky'],
//   ['Komi', 'kv'],
//   ['Kongo', 'kg'],
//   ['Korean', 'ko'],
//   ['Kurdish', 'ku'],
//   ['Kwanyama', 'kj'],
//   ['Lao', 'lo'],
//   ['Latin', 'la'],
//   ['Latvian (Lettish)', 'lv'],
//   ['Limburgish (Limburger)', 'li'],
//   ['Lingala', 'ln'],
//   ['Lithuanian', 'lt'],
//   ['Luga-Katanga', 'lu'],
//   ['Luganda, Ganda', 'lg'],
//   ['Luxembourgish', 'lb'],
//   ['Manx', 'gv'],
//   ['Macedonian', 'mk'],
//   ['Malagasy', 'mg'],
//   ['Malay', 'ms'],
//   ['Malayalam', 'ml'],
//   ['Maltese', 'mt'],
//   ['Maori', 'mi'],
//   ['Marathi', 'mr'],
//   ['Marshallese', 'mh'],
//   ['Moldavian', 'mo'],
//   ['Mongolian', 'mn'],
//   ['Nauru', 'na'],
//   ['Navajo', 'nv'],
//   ['Ndonga', 'ng'],
//   ['Northern Ndebele', 'nd'],
//   ['Nepali', 'ne'],
//   ['Norwegian', 'no'],
//   ['Norwegian bokmål', 'nb'],
//   ['Norwegian nynorsk', 'nn'],
//   ['Nuosu', 'ii'],
//   ['Occitan', 'oc'],
//   ['Ojibwe', 'oj'],
//   ['Old Church Slavonic, Old Bulgarian', 'cu'],
//   ['Oriya', 'or'],
//   ['Oromo (Afaan Oromo)', 'om'],
//   ['Ossetian', 'os'],
//   ['Pāli', 'pi'],
//   ['Pashto, Pushto', 'ps'],
//   ['Persian (Farsi)', 'fa'],
//   ['Polish', 'pl'],
//   ['Portuguese', 'pt'],
//   ['Punjabi (Eastern)', 'pa'],
//   ['Quechua', 'qu'],
//   ['Romansh', 'rm'],
//   ['Romanian', 'ro'],
//   ['Russian', 'ru'],
//   ['Sami', 'se'],
//   ['Samoan', 'sm'],
//   ['Sango', 'sg'],
//   ['Sanskrit', 'sa'],
//   ['Serbian', 'sr'],
//   ['Serbo-Croatian', 'sh'],
//   ['Sesotho', 'st'],
//   ['Setswana', 'tn'],
//   ['Shona', 'sn'],
//   ['Sichuan Yi', 'ii'],
//   ['Sindhi', 'sd'],
//   ['Sinhalese', 'si'],
//   ['Siswati', 'ss'],
//   ['Slovak', 'sk'],
//   ['Slovenian', 'sl'],
//   ['Somali', 'so'],
//   ['Southern Ndebele', 'nr'],
//   ['Spanish', 'es'],
//   ['Sundanese', 'su'],
//   ['Swahili (Kiswahili)', 'sw'],
//   ['Swati', 'ss'],
//   ['Swedish', 'sv'],
//   ['Tagalog', 'tl'],
//   ['Tahitian', 'ty'],
//   ['Tajik', 'tg'],
//   ['Tamil', 'ta'],
//   ['Tatar', 'tt'],
//   ['Telugu', 'te'],
//   ['Thai', 'th'],
//   ['Tibetan', 'bo'],
//   ['Tigrinya', 'ti'],
//   ['Tonga', 'to'],
//   ['Tsonga', 'ts'],
//   ['Turkish', 'tr'],
//   ['Turkmen', 'tk'],
//   ['Twi', 'tw'],
//   ['Uyghur', 'ug'],
//   ['Ukrainian', 'uk'],
//   ['Urdu', 'ur'],
//   ['Uzbek', 'uz'],
//   ['Venda', 've'],
//   ['Vietnamese', 'vi'],
//   ['Volapük', 'vo'],
//   ['Wallon', 'wa'],
//   ['Welsh', 'cy'],
//   ['Wolof', 'wo'],
//   ['Western Frisian', 'fy'],
//   ['Xhosa', 'xh'],
//   ['Yiddish', 'yi', 'ji'],
//   ['Yoruba', 'yo'],
//   ['Zhuang, Chuang', 'za'],
//   ['Zulu', 'zu'],
// ]
//
// langs.forEach(lang => {const period = getDayPeriods(lang[1]); if (period.am === 'AM') return; console.log(lang[1], period )})
// Chrome / Opera
// Amharic am {am: 'ጥዋት', pm: 'ከሰዓት'}
// Arabic ar {am: 'ص', pm: 'م'}
// Bulgarian bg {am: 'пр.об.', pm: 'сл.об.'}
// Chinese (Traditional) zh-Hant {am: '上午', pm: '下午'}
// Greek el {am: 'π.μ.', pm: 'μ.μ.'}
// Hindi hi {am: 'am', pm: 'pm'}
// Kannada kn {am: 'ಪೂರ್ವಾಹ್ನ', pm: 'ಅಪರಾಹ್ನ'}
// Korean ko {am: '오전', pm: '오후'}
// Malay ms {am: 'PG', pm: 'PTG'}
// Tamil ta {am: 'முற்பகல்', pm: 'பிற்பகல்'}
// Edge Chromium
// Albanian sq {am: 'e paradites', pm: 'e pasdites'}
// Amharic am {am: 'ጥዋት', pm: 'ከሰዓት'}
// Arabic ar {am: 'ص', pm: 'م'}
// Bulgarian bg {am: 'пр.об.', pm: 'сл.об.'}
// Chinese (Traditional) zh-Hant {am: '上午', pm: '下午'}
// Greek el {am: 'π.μ.', pm: 'μ.μ.'}
// Hindi hi {am: 'am', pm: 'pm'}
// Kannada kn {am: 'ಪೂರ್ವಾಹ್ನ', pm: 'ಅಪರಾಹ್ನ'}
// Korean ko {am: '오전', pm: '오후'}
// Malay ms {am: 'PG', pm: 'PTG'}
// Punjabi (Eastern) pa {am: 'ਪੂ.ਦੁ.', pm: 'ਬਾ.ਦੁ.'}
// Sindhi sd {am: 'صبح، منجهند', pm: 'منجهند، شام'}
// Tamil ta {am: 'முற்பகல்', pm: 'பிற்பகல்'}
// Firefox
// Akan ak { am: "AN", pm: "EW" }
// Albanian sq { am: "e paradites", pm: "e pasdites" }
// Amharic am { am: "ጥዋት", pm: "ከሰዓት" }
// Arabic ar { am: "ص", pm: "م" }
// Assamese as { am: "পূৰ্বাহ্ন", pm: "অপৰাহ্ন" }
// Bulgarian bg { am: "пр.об.", pm: "сл.об." }
// Chinese (Traditional) zh-Hant { am: "上午", pm: "下午" }
// Dzongkha dz { am: "སྔ་ཆ་", pm: "ཕྱི་ཆ་" }
// Ewe ee { am: "ŋdi", pm: "ɣetrɔ" }
// Greek el { am: "π.μ.", pm: "μ.μ." }
// Hindi hi { am: "am", pm: "pm" }
// Kannada kn { am: "ಪೂರ್ವಾಹ್ನ", pm: "ಅಪರಾಹ್ನ" }
// Korean ko { am: "오전", pm: "오후" }
// Malay ms { am: "PG", pm: "PTG" }
// Oromo (Afaan Oromo) om { am: "WD", pm: "WB" }
// Punjabi (Eastern) pa { am: "ਪੂ.ਦੁ.", pm: "ਬਾ.ਦੁ." }
// Sanskrit sa { am: "पूर्वाह्न", pm: "अपराह्न" }
// Sindhi sd { am: "صبح، منجهند", pm: "منجهند، شام" }
// Somali so { am: "GH", pm: "GD" }
// Tamil ta { am: "முற்பகல்", pm: "பிற்பகல்" }
// Tigrinya ti { am: "ቅ.ቀ.", pm: "ድ.ቀ." }
// Tonga to { am: "hengihengi", pm: "efiafi" }
// Twi tw { am: "AN", pm: "EW" }
// const formats = {
//   "ar-SA" : "dd/MM/yy",
//   "bg-BG" : "dd.M.yyyy",
//   "ca-ES" : "dd/MM/yyyy",
//   "zh-TW" : "yyyy/M/d",
//   "cs-CZ" : "d.M.yyyy",
//   "da-DK" : "dd-MM-yyyy",
//   "de-DE" : "dd.MM.yyyy",
//   "el-GR" : "d/M/yyyy",
//   "en-US" : "M/d/yyyy",
//   "fi-FI" : "d.M.yyyy",
//   "fr-FR" : "dd/MM/yyyy",
//   "he-IL" : "dd/MM/yyyy",
//   "hu-HU" : "yyyy. MM. dd.",
//   "is-IS" : "d.M.yyyy",
//   "it-IT" : "dd/MM/yyyy",
//   "ja-JP" : "yyyy/MM/dd",
//   "ko-KR" : "yyyy-MM-dd",
//   "nl-NL" : "d-M-yyyy",
//   "nb-NO" : "dd.MM.yyyy",
//   "pl-PL" : "yyyy-MM-dd",
//   "pt-BR" : "d/M/yyyy",
//   "ro-RO" : "dd.MM.yyyy",
//   "ru-RU" : "dd.MM.yyyy",
//   "hr-HR" : "d.M.yyyy",
//   "sk-SK" : "d. M. yyyy",
//   "sq-AL" : "yyyy-MM-dd",
//   "sv-SE" : "yyyy-MM-dd",
//   "th-TH" : "d/M/yyyy",
//   "tr-TR" : "dd.MM.yyyy",
//   "ur-PK" : "dd/MM/yyyy",
//   "id-ID" : "dd/MM/yyyy",
//   "uk-UA" : "dd.MM.yyyy",
//   "be-BY" : "dd.MM.yyyy",
//   "sl-SI" : "d.M.yyyy",
//   "et-EE" : "d.MM.yyyy",
//   "lv-LV" : "yyyy.MM.dd.",
//   "lt-LT" : "yyyy.MM.dd",
//   "fa-IR" : "MM/dd/yyyy",
//   "vi-VN" : "dd/MM/yyyy",
//   "hy-AM" : "dd.MM.yyyy",
//   "az-Latn-AZ" : "dd.MM.yyyy",
//   "eu-ES" : "yyyy/MM/dd",
//   "mk-MK" : "dd.MM.yyyy",
//   "af-ZA" : "yyyy/MM/dd",
//   "ka-GE" : "dd.MM.yyyy",
//   "fo-FO" : "dd-MM-yyyy",
//   "hi-IN" : "dd-MM-yyyy",
//   "ms-MY" : "dd/MM/yyyy",
//   "kk-KZ" : "dd.MM.yyyy",
//   "ky-KG" : "dd.MM.yy",
//   "sw-KE" : "M/d/yyyy",
//   "uz-Latn-UZ" : "dd/MM yyyy",
//   "tt-RU" : "dd.MM.yyyy",
//   "pa-IN" : "dd-MM-yy",
//   "gu-IN" : "dd-MM-yy",
//   "ta-IN" : "dd-MM-yyyy",
//   "te-IN" : "dd-MM-yy",
//   "kn-IN" : "dd-MM-yy",
//   "mr-IN" : "dd-MM-yyyy",
//   "sa-IN" : "dd-MM-yyyy",
//   "mn-MN" : "yy.MM.dd",
//   "gl-ES" : "dd/MM/yy",
//   "kok-IN" : "dd-MM-yyyy",
//   "syr-SY" : "dd/MM/yyyy",
//   "dv-MV" : "dd/MM/yy",
//   "ar-IQ" : "dd/MM/yyyy",
//   "zh-CN" : "yyyy/M/d",
//   "de-CH" : "dd.MM.yyyy",
//   "en-GB" : "dd/MM/yyyy",
//   "es-MX" : "dd/MM/yyyy",
//   "fr-BE" : "d/MM/yyyy",
//   "it-CH" : "dd.MM.yyyy",
//   "nl-BE" : "d/MM/yyyy",
//   "nn-NO" : "dd.MM.yyyy",
//   "pt-PT" : "dd-MM-yyyy",
//   "sr-Latn-CS" : "d.M.yyyy",
//   "sv-FI" : "d.M.yyyy",
//   "az-Cyrl-AZ" : "dd.MM.yyyy",
//   "ms-BN" : "dd/MM/yyyy",
//   "uz-Cyrl-UZ" : "dd.MM.yyyy",
//   "ar-EG" : "dd/MM/yyyy",
//   "zh-HK" : "d/M/yyyy",
//   "de-AT" : "dd.MM.yyyy",
//   "en-AU" : "d/MM/yyyy",
//   "es-ES" : "dd/MM/yyyy",
//   "fr-CA" : "yyyy-MM-dd",
//   "sr-Cyrl-CS" : "d.M.yyyy",
//   "ar-LY" : "dd/MM/yyyy",
//   "zh-SG" : "d/M/yyyy",
//   "de-LU" : "dd.MM.yyyy",
//   "en-CA" : "dd/MM/yyyy",
//   "es-GT" : "dd/MM/yyyy",
//   "fr-CH" : "dd.MM.yyyy",
//   "ar-DZ" : "dd-MM-yyyy",
//   "zh-MO" : "d/M/yyyy",
//   "de-LI" : "dd.MM.yyyy",
//   "en-NZ" : "d/MM/yyyy",
//   "es-CR" : "dd/MM/yyyy",
//   "fr-LU" : "dd/MM/yyyy",
//   "ar-MA" : "dd-MM-yyyy",
//   "en-IE" : "dd/MM/yyyy",
//   "es-PA" : "MM/dd/yyyy",
//   "fr-MC" : "dd/MM/yyyy",
//   "ar-TN" : "dd-MM-yyyy",
//   "en-ZA" : "yyyy/MM/dd",
//   "es-DO" : "dd/MM/yyyy",
//   "ar-OM" : "dd/MM/yyyy",
//   "en-JM" : "dd/MM/yyyy",
//   "es-VE" : "dd/MM/yyyy",
//   "ar-YE" : "dd/MM/yyyy",
//   "en-029" : "MM/dd/yyyy",
//   "es-CO" : "dd/MM/yyyy",
//   "ar-SY" : "dd/MM/yyyy",
//   "en-BZ" : "dd/MM/yyyy",
//   "es-PE" : "dd/MM/yyyy",
//   "ar-JO" : "dd/MM/yyyy",
//   "en-TT" : "dd/MM/yyyy",
//   "es-AR" : "dd/MM/yyyy",
//   "ar-LB" : "dd/MM/yyyy",
//   "en-ZW" : "M/d/yyyy",
//   "es-EC" : "dd/MM/yyyy",
//   "ar-KW" : "dd/MM/yyyy",
//   "en-PH" : "M/d/yyyy",
//   "es-CL" : "dd-MM-yyyy",
//   "ar-AE" : "dd/MM/yyyy",
//   "es-UY" : "dd/MM/yyyy",
//   "ar-BH" : "dd/MM/yyyy",
//   "es-PY" : "dd/MM/yyyy",
//   "ar-QA" : "dd/MM/yyyy",
//   "es-BO" : "dd/MM/yyyy",
//   "es-SV" : "dd/MM/yyyy",
//   "es-HN" : "dd/MM/yyyy",
//   "es-NI" : "dd/MM/yyyy",
//   "es-PR" : "dd/MM/yyyy",
//   "am-ET" : "d/M/yyyy",
//   "tzm-Latn-DZ" : "dd-MM-yyyy",
//   "iu-Latn-CA" : "d/MM/yyyy",
//   "sma-NO" : "dd.MM.yyyy",
//   "mn-Mong-CN" : "yyyy/M/d",
//   "gd-GB" : "dd/MM/yyyy",
//   "en-MY" : "d/M/yyyy",
//   "prs-AF" : "dd/MM/yy",
//   "bn-BD" : "dd-MM-yy",
//   "wo-SN" : "dd/MM/yyyy",
//   "rw-RW" : "M/d/yyyy",
//   "qut-GT" : "dd/MM/yyyy",
//   "sah-RU" : "MM.dd.yyyy",
//   "gsw-FR" : "dd/MM/yyyy",
//   "co-FR" : "dd/MM/yyyy",
//   "oc-FR" : "dd/MM/yyyy",
//   "mi-NZ" : "dd/MM/yyyy",
//   "ga-IE" : "dd/MM/yyyy",
//   "se-SE" : "yyyy-MM-dd",
//   "br-FR" : "dd/MM/yyyy",
//   "smn-FI" : "d.M.yyyy",
//   "moh-CA" : "M/d/yyyy",
//   "arn-CL" : "dd-MM-yyyy",
//   "ii-CN" : "yyyy/M/d",
//   "dsb-DE" : "d. M. yyyy",
//   "ig-NG" : "d/M/yyyy",
//   "kl-GL" : "dd-MM-yyyy",
//   "lb-LU" : "dd/MM/yyyy",
//   "ba-RU" : "dd.MM.yy",
//   "nso-ZA" : "yyyy/MM/dd",
//   "quz-BO" : "dd/MM/yyyy",
//   "yo-NG" : "d/M/yyyy",
//   "ha-Latn-NG" : "d/M/yyyy",
//   "fil-PH" : "M/d/yyyy",
//   "ps-AF" : "dd/MM/yy",
//   "fy-NL" : "d-M-yyyy",
//   "ne-NP" : "M/d/yyyy",
//   "se-NO" : "dd.MM.yyyy",
//   "iu-Cans-CA" : "d/M/yyyy",
//   "sr-Latn-RS" : "d.M.yyyy",
//   "si-LK" : "yyyy-MM-dd",
//   "sr-Cyrl-RS" : "d.M.yyyy",
//   "lo-LA" : "dd/MM/yyyy",
//   "km-KH" : "yyyy-MM-dd",
//   "cy-GB" : "dd/MM/yyyy",
//   "bo-CN" : "yyyy/M/d",
//   "sms-FI" : "d.M.yyyy",
//   "as-IN" : "dd-MM-yyyy",
//   "ml-IN" : "dd-MM-yy",
//   "en-IN" : "dd-MM-yyyy",
//   "or-IN" : "dd-MM-yy",
//   "bn-IN" : "dd-MM-yy",
//   "tk-TM" : "dd.MM.yy",
//   "bs-Latn-BA" : "d.M.yyyy",
//   "mt-MT" : "dd/MM/yyyy",
//   "sr-Cyrl-ME" : "d.M.yyyy",
//   "se-FI" : "d.M.yyyy",
//   "zu-ZA" : "yyyy/MM/dd",
//   "xh-ZA" : "yyyy/MM/dd",
//   "tn-ZA" : "yyyy/MM/dd",
//   "hsb-DE" : "d. M. yyyy",
//   "bs-Cyrl-BA" : "d.M.yyyy",
//   "tg-Cyrl-TJ" : "dd.MM.yy",
//   "sr-Latn-BA" : "d.M.yyyy",
//   "smj-NO" : "dd.MM.yyyy",
//   "rm-CH" : "dd/MM/yyyy",
//   "smj-SE" : "yyyy-MM-dd",
//   "quz-EC" : "dd/MM/yyyy",
//   "quz-PE" : "dd/MM/yyyy",
//   "hr-BA" : "d.M.yyyy.",
//   "sr-Latn-ME" : "d.M.yyyy",
//   "sma-SE" : "yyyy-MM-dd",
//   "en-SG" : "d/M/yyyy",
//   "ug-CN" : "yyyy-M-d",
//   "sr-Cyrl-BA" : "d.M.yyyy",
//   "es-US" : "M/d/yyyy"
// };
//
// Object.keys(formats).forEach(lang => {const period = getDayPeriods(lang); if (period.am === 'AM') return; console.log(lang, period )})

class TimeElementDirective {
  constructor(elementRef) {
    this.elementRef = elementRef;
    this.cTimeElement = input.required();
  }
  static {
    this.ɵfac = function TimeElementDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TimeElementDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: TimeElementDirective,
      selectors: [["", "cTimeElement", ""]],
      inputs: {
        cTimeElement: [1, "cTimeElement"]
      },
      exportAs: ["cTimeElement"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TimeElementDirective, [{
    type: Directive,
    args: [{
      selector: '[cTimeElement]',
      exportAs: 'cTimeElement',
      standalone: true
    }]
  }], () => [{
    type: i0.ElementRef
  }], null);
})();
class TimePickerRollColComponent {
  constructor(elementRef) {
    this.elementRef = elementRef;
    this.#init = true;
    this.disabled = input(false, {
      transform: booleanAttribute
    });
    this.elements = input([]);
    this.onClick = input();
    this.refresh = input(undefined, {
      transform: booleanAttribute
    });
    this.selectedInput = input(null, {
      alias: 'selected'
    });
    this.selected = linkedSignal(this.selectedInput);
    this.selectedChange = output();
  }
  #init;
  ngAfterViewInit() {
    this.timeElements?.changes.subscribe(state => {
      const selectedElement = this.timeElements?.find(element => {
        return element.cTimeElement()?.value === this.selected();
      });
      this.scrollToElement(selectedElement?.elementRef.nativeElement);
    });
    setTimeout(() => {
      const selectedElement = this.elementRef.nativeElement.querySelector('.selected');
      this.scrollToElement(selectedElement);
    }, 1000);
  }
  ngOnChanges(changes) {
    if (changes['refresh'] && changes['refresh'].currentValue || changes['selectedInput'] && !changes['selectedInput'].firstChange) {
      const selectedElement = this.timeElements?.find(element => {
        return element.cTimeElement()?.value === this.selected();
      });
      this.#init = !selectedElement;
      this.scrollToElement(selectedElement?.elementRef.nativeElement);
    }
  }
  scrollToElement(element) {
    setTimeout(() => {
      const elementSelected = element ?? this.elementRef.nativeElement.querySelector('.selected') ?? this.elementRef.nativeElement.firstElementChild;
      if (elementSelected) {
        this.elementRef.nativeElement.scrollTo({
          top: elementSelected?.offsetTop,
          behavior: this.#init ? 'auto' : 'smooth'
        });
        this.#init = false;
      }
    });
  }
  handleElementClick($event, element) {
    if (element.disabled) {
      return;
    }
    this.selected.set(element.value);
    this.scrollToElement($event.target);
    const onClick = this.onClick();
    onClick && onClick(element.value);
    this.selectedChange.emit(element.value);
  }
  handleElementKeyDown($event, element) {
    if ($event.code === 'Space' || $event.code === 'Enter') {
      $event.preventDefault();
      this.handleElementClick($event, element);
    }
  }
  static {
    this.ɵfac = function TimePickerRollColComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TimePickerRollColComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TimePickerRollColComponent,
      selectors: [["c-time-picker-roll-col"]],
      viewQuery: function TimePickerRollColComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(TimeElementDirective, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.timeElements = _t);
        }
      },
      hostAttrs: [1, "time-picker-roll-col"],
      hostVars: 2,
      hostBindings: function TimePickerRollColComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("disabled", ctx.disabled());
        }
      },
      inputs: {
        disabled: [1, "disabled"],
        elements: [1, "elements"],
        onClick: [1, "onClick"],
        refresh: [1, "refresh"],
        selectedInput: [1, "selected", "selectedInput"]
      },
      outputs: {
        selectedChange: "selectedChange"
      },
      exportAs: ["cTimePickerRollCol"],
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 2,
      vars: 0,
      consts: [["role", "button", 3, "cTimeElement", "ngClass", "tabindex", "ngStyle"], ["role", "button", 3, "click", "keydown", "cTimeElement", "ngClass", "tabindex", "ngStyle"]],
      template: function TimePickerRollColComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵrepeaterCreate(0, TimePickerRollColComponent_For_1_Template, 3, 11, "div", 0, _forTrack3);
        }
        if (rf & 2) {
          i0.ɵɵrepeater(ctx.elements());
        }
      },
      dependencies: [TimeElementDirective, NgClass, NgStyle],
      styles: ["[_nghost-%COMP%]{display:block}[_nghost-%COMP%]   .disabled[_ngcontent-%COMP%]{pointer-events:none}[_nghost-%COMP%]   .time-picker-roll-cell[_ngcontent-%COMP%]{--cui-timepicker-roll-cell-width: 50px;width:var(--cui-timepicker-roll-cell-width)}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TimePickerRollColComponent, [{
    type: Component,
    args: [{
      selector: 'c-time-picker-roll-col',
      exportAs: 'cTimePickerRollCol',
      imports: [TimeElementDirective, NgClass, NgStyle],
      host: {
        class: 'time-picker-roll-col',
        '[class.disabled]': 'disabled()'
      },
      template: "@for (element of elements(); track element.value; let i = $index) {\n  @let cellWidth = element.label.length > 2 ? {   '--cui-timepicker-roll-cell-width' : '80px' } : {};\n  <div (click)=\"handleElementClick($event, element)\"\n       (keydown)=\"handleElementKeyDown($event, element)\"\n       [attr.disabled]=\"element.disabled || null\"\n       [cTimeElement]=\"element\"\n       [ngClass]=\"{'time-picker-roll-cell': true, selected: element.value === selected(), disabled: element.disabled}\"\n       [tabindex]=\"element.disabled ? -1 : 0\"\n       role=\"button\"\n       [ngStyle]=\"cellWidth\"\n  >\n    {{ element.label }}\n  </div>\n}\n\n",
      styles: [":host{display:block}:host .disabled{pointer-events:none}:host .time-picker-roll-cell{--cui-timepicker-roll-cell-width: 50px;width:var(--cui-timepicker-roll-cell-width)}\n"]
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    timeElements: [{
      type: ViewChildren,
      args: [TimeElementDirective]
    }]
  });
})();
class DayPeriodElementDirective {
  constructor(elementRef) {
    this.elementRef = elementRef;
    this.cDayPeriodElement = input.required();
  }
  static {
    this.ɵfac = function DayPeriodElementDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DayPeriodElementDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: DayPeriodElementDirective,
      selectors: [["", "cDayPeriodElement", ""]],
      inputs: {
        cDayPeriodElement: [1, "cDayPeriodElement"]
      },
      exportAs: ["cDayPeriodElement"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DayPeriodElementDirective, [{
    type: Directive,
    args: [{
      selector: '[cDayPeriodElement]',
      exportAs: 'cDayPeriodElement',
      standalone: true
    }]
  }], () => [{
    type: i0.ElementRef
  }], null);
})();
class TimePickerRollAmPmComponent {
  constructor(elementRef) {
    this.elementRef = elementRef;
    this.#init = true;
    this.disabled = input(false, {
      transform: booleanAttribute
    });
    this.elements = input([]);
    this.onClick = input();
    this.refresh = input(undefined, {
      transform: booleanAttribute
    });
    this.selectedInput = input(null, {
      alias: 'selected'
    });
    this.selected = linkedSignal(this.selectedInput);
    this.selectedChange = output();
  }
  #init;
  ngAfterViewInit() {
    this.dayPeriodElements?.changes.subscribe(state => {
      const selectedElement = this.dayPeriodElements?.find(element => {
        return element.cDayPeriodElement()?.value === this.selected();
      });
      this.scrollToElement(selectedElement?.elementRef.nativeElement);
    });
    const selectedElement = this.elementRef.nativeElement.querySelector('.selected');
    this.scrollToElement(selectedElement);
  }
  ngOnChanges(changes) {
    if (changes['refresh'] && changes['refresh'].currentValue || changes['selectedInput'] && !changes['selectedInput'].firstChange) {
      const selectedElement = this.dayPeriodElements?.find(element => {
        return element.cDayPeriodElement()?.value === this.selected();
      });
      this.#init = !selectedElement;
      this.scrollToElement(selectedElement?.elementRef.nativeElement);
    }
  }
  scrollToElement(element) {
    setTimeout(() => {
      const elementSelected = element || this.elementRef.nativeElement.querySelector('.selected');
      if (elementSelected) {
        this.elementRef.nativeElement.scrollTo({
          top: elementSelected?.offsetTop,
          behavior: this.#init ? 'auto' : 'smooth'
        });
        this.#init = false;
      }
    });
  }
  handleElementClick($event, element) {
    if (element.disabled) {
      return;
    }
    this.selected.set(element.value);
    this.scrollToElement($event.target);
    const onClick = this.onClick();
    onClick && onClick(element.value);
    this.selectedChange.emit(element.value);
  }
  handleElementKeyDown($event, element) {
    if ($event.code === 'Space' || $event.code === 'Enter') {
      $event.preventDefault();
      this.handleElementClick($event, element);
    }
  }
  static {
    this.ɵfac = function TimePickerRollAmPmComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TimePickerRollAmPmComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TimePickerRollAmPmComponent,
      selectors: [["c-time-picker-roll-am-pm"]],
      viewQuery: function TimePickerRollAmPmComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(DayPeriodElementDirective, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dayPeriodElements = _t);
        }
      },
      hostAttrs: [1, "time-picker-roll-col"],
      hostVars: 2,
      hostBindings: function TimePickerRollAmPmComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("disabled", ctx.disabled());
        }
      },
      inputs: {
        disabled: [1, "disabled"],
        elements: [1, "elements"],
        onClick: [1, "onClick"],
        refresh: [1, "refresh"],
        selectedInput: [1, "selected", "selectedInput"]
      },
      outputs: {
        selectedChange: "selectedChange"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 2,
      vars: 0,
      consts: [["role", "button", 3, "cDayPeriodElement", "ngClass", "tabindex"], ["role", "button", 3, "click", "keydown", "cDayPeriodElement", "ngClass", "tabindex"]],
      template: function TimePickerRollAmPmComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵrepeaterCreate(0, TimePickerRollAmPmComponent_For_1_Template, 2, 8, "div", 0, _forTrack3);
        }
        if (rf & 2) {
          i0.ɵɵrepeater(ctx.elements());
        }
      },
      dependencies: [DayPeriodElementDirective, NgClass],
      styles: ["[_nghost-%COMP%]{display:block}[_nghost-%COMP%]   .disabled[_ngcontent-%COMP%]{pointer-events:none}.time-picker-roll-cell[_ngcontent-%COMP%]{--cui-timepicker-roll-cell-width: 53px;width:var(--cui-timepicker-roll-cell-width)}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TimePickerRollAmPmComponent, [{
    type: Component,
    args: [{
      selector: 'c-time-picker-roll-am-pm',
      imports: [DayPeriodElementDirective, NgClass],
      host: {
        class: 'time-picker-roll-col',
        '[class.disabled]': 'disabled()'
      },
      template: "@for (element of elements(); track element.value; let i = $index) {\n  <div (click)=\"handleElementClick($event, element)\"\n       (keydown)=\"handleElementKeyDown($event, element)\"\n       [attr.disabled]=\"element.disabled || null\"\n       [cDayPeriodElement]=\"element\"\n       [ngClass]=\"{'time-picker-roll-cell': true, selected: element.value === selected(), disabled: element.disabled}\"\n       [tabindex]=\"element.disabled ? -1 : 0\"\n       role=\"button\"\n  >\n    {{ element.label }}\n  </div>\n}\n",
      styles: [":host{display:block}:host .disabled{pointer-events:none}.time-picker-roll-cell{--cui-timepicker-roll-cell-width: 53px;width:var(--cui-timepicker-roll-cell-width)}\n"]
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    dayPeriodElements: [{
      type: ViewChildren,
      args: [DayPeriodElementDirective]
    }]
  });
})();

// todo: Focus management
class TimePickerComponent {
  constructor() {
    this.#destroyRef = inject(DestroyRef);
    /**
     * Toggle visibility or set the content of the cleaner button.
     * @return boolean
     * @default true
     */
    this.cleaner = input(true, {
      transform: booleanAttribute
    });
    /**
     * Sets DateTime format options including timeZone
     * @return DateTimeFormatOptions
     * @default {}
     * @note The date object doesn't store timeZone, it keeps the local timezone of the browser, regardless if you parsed UTC dates.
     */
    this.dateTimeFormatOptions = input({});
    /**
     * Toggle the disabled state for the component.
     * @return boolean
     * @default false
     */
    this.disabledInput = input(false, {
      transform: booleanAttribute,
      alias: 'disabled'
    });
    this.disabled = linkedSignal(this.disabledInput);
    this.disabledEffect = effect(() => {
      if (this.disabled()) {
        this.timeInputCtrl.disable({
          emitEvent: false
        });
      } else {
        this.timeInputCtrl.enable({
          emitEvent: false
        });
      }
    });
    /**
     * Filter available hours to pick.
     * @return (value: number) => boolean;
     * @default undefined
     */
    this.filterHours = input();
    /**
     * Filter available minutes to pick.
     * @return (value: number) => boolean;
     * @default undefined
     */
    this.filterMinutes = input();
    /**
     * Filter available seconds to pick.
     * @return (value: number) => boolean;
     * @default undefined
     */
    this.filterSeconds = input();
    /**
     * Toggle visibility or set the content of the input indicator.
     * @return boolean
     * @default true
     */
    this.indicator = input(true, {
      transform: booleanAttribute
    });
    /**
     * Toggle the readonly state for the component.
     * @return boolean
     * @default false
     */
    this.inputReadOnly = input(false, {
      transform: booleanAttribute
    });
    /**
     * Sets the default locale for components. If not set, it is inherited from the browser.
     * @return string
     * @default default
     */
    this.locale = input('default');
    /**
     * Specifies short hint visible in time input.
     * @return string
     * @default 'Select time'
     */
    this.placeholder = input('Select time');
    /**
     * Toggle seconds visibility.
     * @return boolean
     * @default false
     */
    this.seconds = input(false, {
      transform: booleanAttribute
    });
    /**
     * Size the component small or large.
     * @return 'sm' | 'lg' | undefined
     * @default undefined
     */
    this.size = input();
    /**
     * Set the time picker variant to a roll or select.
     * @return 'roll' | 'select'
     * @default 'roll'
     */
    this.variant = input('roll');
    /**
     * Toggle visual validation feedback.
     * @return boolean | undefined
     * @default undefined
     */
    this.valid = input();
    /**
     * Toggle the visibility of dropdown timepicker menu component.
     * @return boolean
     * @default false
     */
    this.visible = input(false, {
      transform: booleanAttribute
    });
    this.timeChange = output();
    this.templates = {};
    this.hour12 = isHour12(this.locale());
    this.dayPeriods = [{
      value: 'am',
      label: 'am'
    }, {
      value: 'pm',
      label: 'pm'
    }];
    this._timeInputValue = this.time?.toLocaleTimeString(this.locale(), {
      timeStyle: this.seconds() ? 'medium' : 'short'
    }) ?? '';
    this.timePickerClasses = computed(() => {
      const disabled = this.disabled();
      const size = this.size();
      const valid = this.valid();
      const variant = this.variant();
      return {
        'time-picker': true,
        [`time-picker-${size}`]: !!size,
        'form-control': variant === 'select' && valid !== undefined,
        'is-valid': valid === true,
        'is-invalid': valid === false,
        disabled: disabled
      };
    });
    this.selectTime = new FormGroup({
      selectHours: new FormControl({
        value: this.hour,
        disabled: this.disabled()
      }, {
        validators: [Validators.min(0), Validators.max(this.hour12 ? 11 : 23)]
      }),
      selectMinutes: new FormControl({
        value: this.minute,
        disabled: this.disabled()
      }, {
        validators: [Validators.min(0), Validators.max(59)]
      }),
      selectSeconds: new FormControl({
        value: this.second,
        disabled: this.disabled()
      }, {
        validators: [Validators.min(0), Validators.max(59)]
      }),
      selectDayPeriod: new FormControl({
        value: this.dayPeriod,
        disabled: this.disabled()
      }, Validators.required)
    }, {
      validators: [Validators.required]
    });
    this.timeInputCtrl = new FormControl({
      value: this.timeInputValue,
      disabled: this.disabled()
    }, {
      validators: [Validators.required]
    });
    this._hour = -1;
    this._minute = -1;
    this._second = -1;
    this._dayPeriod = 'am';
    this.onChange = value => {
      /* empty */
    };
    this.onTouched = () => {
      /* empty */
    };
  }
  #destroyRef;
  /**
   * Initial selected time.
   * @return Date | string | null | number
   * @default undefined
   */
  set time(value) {
    if (value && isValidTime(value)) {
      const time = convertTimeToDate(value);
      if (!time) {
        this.clearTime();
        return;
      }
      this.dayPeriod = getAmPm(time, this.locale());
      if (this._time?.getTime() !== time.getTime()) {
        this._time = new Date(time.getTime());
      }
    } else {
      this.clearTime();
    }
  }
  get time() {
    return this._time;
  }
  onBlur() {
    this.onTouched();
  }
  getListOfHours12() {
    const listOfHours12 = this.hour12 ? this.listOfHours?.filter(item => item.dayPeriod && item.dayPeriod === this.dayPeriod || !item.dayPeriod) : this.listOfHours;
    if (this.hour12 && [0, 12].includes(listOfHours12[0].value)) {
      listOfHours12.push(listOfHours12.shift());
    }
    return listOfHours12;
  }
  set timeInputValue(value) {
    this.timeInputCtrl.setValue(value);
    this._timeInputValue = value;
  }
  get timeInputValue() {
    return this._timeInputValue;
  }
  set hour(value) {
    if (this._hour !== value) {
      if (value < 0) {
        this.clearTime();
        return;
      }
      this._hour = value;
    }
  }
  get hour() {
    return this._hour;
  }
  set minute(value) {
    if (this._minute !== value) {
      if (value < 0) {
        this.clearTime();
        return;
      }
      this._minute = value;
    }
  }
  get minute() {
    return this._minute;
  }
  set second(value) {
    if (this._second !== value) {
      if (value < 0) {
        this.clearTime();
        return;
      }
      this._second = value;
    }
  }
  get second() {
    return this._second;
  }
  set dayPeriod(value) {
    if (this._dayPeriod !== value) {
      this._dayPeriod = value;
      if (this.listOfHours) {
        this.listOfHours12 = this.getListOfHours12();
      }
      this.patchSelectTimeValues();
    }
    // this.listOfHours12 = this.hour12
    //                      ? this.listOfHours?.filter(
    //     (item) => (item.dayPeriod && item.dayPeriod === value) || !item.dayPeriod
    //   )
    //                      : this.listOfHours;
    // this.patchSelectTimeValues();
  }
  get dayPeriod() {
    return this._dayPeriod;
  }
  setTime() {
    this._hour = this._hour < 0 ? 0 : this._hour;
    this._minute = this._minute < 0 ? 0 : this._minute;
    this._second = this._second < 0 ? 0 : this._second;
    const time = new Date(this._time?.getTime() || new Date());
    time.setHours(this.hour, this.minute, this.second, 0);
    this.time = time;
    this.emitTime(time);
  }
  clearTime() {
    if (this.time) {
      this._time = undefined;
      this.emitTime(undefined);
    }
    this._hour = -1;
    this._minute = -1;
    this._second = -1;
    this.dayPeriod = 'am';
    this.patchSelectTimeValues();
    this.timeInputValue = '';
  }
  emitTime(time) {
    const timeValue = !!time && isValidTime(time) ? new Date(time.getTime()) : undefined;
    if (this._timeInternal?.getTime() !== timeValue?.getTime()) {
      this.timeChange.emit(timeValue);
      this.onChange(timeValue);
      this.onTouched();
      this._timeInternal = timeValue;
    }
    this.timeInputValue = this.time?.toLocaleTimeString(this.locale(), {
      timeStyle: this.seconds() ? 'medium' : 'short'
    }) ?? '';
  }
  ngOnInit() {
    this.setTimeLists();
    this.updateSelectTime();
    this.setChangeHandlers();
  }
  ngOnChanges(changes) {
    if (changes['time']) {
      if (!changes['time'].firstChange) {
        if (this._timeInternal?.getTime() !== changes['time'].currentValue?.getTime()) {
          this.updateSelectTime();
        }
      }
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.contentTemplates.forEach(child => {
        this.templates[child.id] = child.templateRef;
      });
    });
  }
  setTimeLists() {
    this.dayPeriods = getDayPeriods(this.locale(), this.dateTimeFormatOptions());
    this.hour12 = isHour12(this.locale());
    this.listOfHours = this.listOfTimeSegments(getListOfHours, this.filterHours());
    this.listOfMinutes = this.listOfTimeSegments(getListOfMinutes, this.filterMinutes());
    this.listOfSeconds = this.listOfTimeSegments(getListOfSeconds, this.filterSeconds());
    if (this.variant() === 'select') {
      const undefSegment = {
        value: -1,
        label: ' --',
        disabled: true
      };
      this.listOfHours.unshift({
        ...undefSegment
      });
      this.listOfMinutes.unshift({
        ...undefSegment
      });
      this.listOfSeconds.unshift({
        ...undefSegment
      });
    }
    this.listOfHours12 = this.getListOfHours12();
  }
  updateSelectTime(time = this.time) {
    if (!!time && isValidTime(time)) {
      const hour = time.getHours() ?? 0;
      const minute = time.getMinutes() ?? 0;
      const second = this.seconds() ? time.getSeconds() ?? 0 : 0;
      const closestSecond = this.closestTime(this.listOfSeconds, second);
      const closestMinute = this.closestTime(this.listOfMinutes, minute);
      const closestHour = this.closestTime(this.listOfHours, hour);
      this.second = this.seconds() ? closestSecond.value : 0;
      this.minute = closestMinute.value;
      this.hour = closestHour.value;
      this.setTime();
      this.patchSelectTimeValues();
    }
  }
  closestTime(timeArray, timeSegment) {
    let array = timeArray ?? [{
      value: 0,
      label: '00'
    }];
    if (this.time) {
      array = timeArray.filter(el => el.value >= 0);
      array = array.length ? array : timeArray;
    }
    return array.reduce((a, b) => {
      return Math.abs(b.value - timeSegment) < Math.abs(a.value - timeSegment) ? b : a;
    });
  }
  listOfTimeSegments(getListOfTimeSegments, filterTimeSegments) {
    const list = getListOfTimeSegments(this.locale(), this.dateTimeFormatOptions()).filter(segment => {
      return typeof filterTimeSegments === 'function' ? filterTimeSegments(segment.value) : true;
    });
    return list.length ? list : getListOfTimeSegments(this.locale(), this.dateTimeFormatOptions()).slice(0, 1);
  }
  handleSelectDayPeriodChange(dayPeriod) {
    if (dayPeriod !== this.dayPeriod) {
      const hrs = this.time?.getHours() ?? (this.hour < 0 ? 0 : this.hour);
      const hour = hrs > 12 ? convert24hTo12h(hrs) : convert12hTo24h(dayPeriod, hrs);
      this.hour = this.closestTime(this.listOfHours, hour).value;
      if (hour >= 0) {
        this.setTime();
      }
      this.updateSelectTime();
    }
  }
  handleSelectTimeChange(value, segment) {
    this[segment] = value;
    if (value >= 0) {
      this.setTime();
    }
    this.updateSelectTime();
  }
  patchSelectTimeValues() {
    const dayPeriod = this.selectTime.get('selectDayPeriod')?.value;
    if (this.dayPeriod !== dayPeriod) {
      this.selectTime.patchValue({
        selectDayPeriod: this.dayPeriod ?? 'am'
      });
    }
    const hours = this.selectTime.get('selectHours')?.value;
    const minutes = this.selectTime.get('selectMinutes')?.value;
    const seconds = this.selectTime.get('selectSeconds')?.value;
    const goUpdate = this.second < 0 && this.minute < 0 || this.hour >= 0 && this.minute >= 0 && this.second >= 0;
    const timeChanged = this.hour !== hours || this.minute !== minutes || this.second !== seconds;
    if (goUpdate && timeChanged) {
      if (this.hour !== hours) {
        this.selectTime.patchValue({
          selectHours: this.hour ?? 0
        });
      }
      if (this.minute !== minutes) {
        this.selectTime.patchValue({
          selectMinutes: this.minute ?? 0
        });
      }
      if (this.second !== seconds) {
        this.selectTime.patchValue({
          selectSeconds: this.second ?? 0
        });
      }
    }
  }
  trackByHour(index, hour) {
    return hour;
  }
  writeValue(value) {
    this.time = value;
    this.updateSelectTime();
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled) {
    this.disabled.set(isDisabled);
  }
  handleTimeInputChange($event) {
    const value = $event.target?.value;
    if (!value || !isValidTime(value)) {
      this.clearTime();
      return;
    }
    const time = convertTimeToDate(value);
    this.updateSelectTime(time ?? new Date(Date.now()));
  }
  handleClear($event) {
    this.clearTime();
  }
  handleBlur($event) {
    if (this.disabled()) {
      return;
    }
    this.dropdownRef?.nativeElement?.classList.remove('show');
    setTimeout(() => {
      this.onBlur();
    }, 100);
  }
  handleFocus($event) {
    if (this.disabled()) {
      return;
    }
    this.dropdownRef?.nativeElement?.classList.add('show');
  }
  setChangeHandlers() {
    if (this.variant() !== 'select') {
      return;
    }
    this.selectTime.get('selectHours')?.valueChanges.pipe(tap(value => {
      this.handleSelectTimeChange(value, 'hour');
    }), takeUntilDestroyed(this.#destroyRef)).subscribe();
    this.selectTime.get('selectMinutes')?.valueChanges.pipe(tap(value => {
      this.handleSelectTimeChange(value, 'minute');
    }), takeUntilDestroyed(this.#destroyRef)).subscribe();
    this.selectTime.get('selectSeconds')?.valueChanges.pipe(filter(() => this.seconds()), tap(value => {
      this.handleSelectTimeChange(value, 'second');
    }), takeUntilDestroyed(this.#destroyRef)).subscribe();
    this.selectTime.get('selectDayPeriod')?.valueChanges.pipe(filter(() => this.hour12), tap(value => {
      this.handleSelectDayPeriodChange(value);
    }), takeUntilDestroyed(this.#destroyRef)).subscribe();
  }
  static {
    this.ɵfac = function TimePickerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TimePickerComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TimePickerComponent,
      selectors: [["c-time-picker"]],
      contentQueries: function TimePickerComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, TemplateIdDirective, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentTemplates = _t);
        }
      },
      viewQuery: function TimePickerComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(DropdownComponent, 5, ElementRef);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdownRef = _t.first);
        }
      },
      hostBindings: function TimePickerComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("focusout", function TimePickerComponent_focusout_HostBindingHandler() {
            return ctx.onBlur();
          });
        }
      },
      inputs: {
        cleaner: [1, "cleaner"],
        dateTimeFormatOptions: [1, "dateTimeFormatOptions"],
        disabledInput: [1, "disabled", "disabledInput"],
        filterHours: [1, "filterHours"],
        filterMinutes: [1, "filterMinutes"],
        filterSeconds: [1, "filterSeconds"],
        indicator: [1, "indicator"],
        inputReadOnly: [1, "inputReadOnly"],
        locale: [1, "locale"],
        placeholder: [1, "placeholder"],
        seconds: [1, "seconds"],
        size: [1, "size"],
        time: "time",
        variant: [1, "variant"],
        valid: [1, "valid"],
        visible: [1, "visible"]
      },
      outputs: {
        timeChange: "timeChange"
      },
      exportAs: ["cTimePicker"],
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => TimePickerComponent),
        multi: true
      }]), i0.ɵɵNgOnChangesFeature],
      decls: 2,
      vars: 2,
      consts: [["dropdown", "cDropdown"], ["dropdownMenu", "cDropdownMenu"], [1, "date-picker-timepickers"], [3, "autoClose", "ngClass", "visible"], [1, "picker", "time-picker"], [1, "time-picker-body", 3, "formGroup", "ngClass"], [1, "time-picker-inline-icon"], ["cSelect", "", "formControlName", "selectHours", 1, "time-picker-inline-select", "ms-0", 3, "blur", "sizing"], [3, "ngValue"], ["cSelect", "", "formControlName", "selectMinutes", 1, "time-picker-inline-select", "ms-0", 3, "blur", "sizing"], ["cSelect", "", "formControlName", "selectDayPeriod", 1, "time-picker-inline-select", "ms-0", 3, "sizing"], ["cSelect", "", "formControlName", "selectSeconds", 1, "time-picker-inline-select", "ms-0", 3, "blur", "sizing"], ["cSelect", "", "formControlName", "selectDayPeriod", 1, "time-picker-inline-select", "ms-0", 3, "blur", "sizing"], [1, "time-picker-roll-cell", 3, "ngValue"], ["cDropdownToggle", "", 1, "time-picker-input-group", 3, "caret"], [1, "time-picker-input", 3, "blur", "change", "focus", "formControl", "placeholder", "readonly"], [1, "time-picker-indicator"], ["role", "button", 1, "time-picker-cleaner"], ["cDropdownMenu", "", 1, "time-picker-dropdown", "py-0"], [1, "time-picker-body", "time-picker-roll", 2, "position", "relative"], ["role", "listbox", 3, "selectedChange", "disabled", "elements", "refresh", "selected"], ["role", "listbox", 3, "disabled", "elements", "refresh", "selected"], [1, "time-picker-footer"], ["role", "button", 1, "time-picker-cleaner", 3, "click"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]],
      template: function TimePickerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, TimePickerComponent_Conditional_0_Template, 13, 9, "div", 2)(1, TimePickerComponent_Conditional_1_Template, 14, 22, "c-dropdown", 3);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.variant() === "select" ? 0 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.variant() === "roll" ? 1 : -1);
        }
      },
      dependencies: [NgClass, NgTemplateOutlet, ReactiveFormsModule, i1$2.NgSelectOption, i1$2.ɵNgSelectMultipleOption, i1$2.DefaultValueAccessor, i1$2.SelectControlValueAccessor, i1$2.NgControlStatus, i1$2.NgControlStatusGroup, i1$2.FormControlDirective, i1$2.FormGroupDirective, i1$2.FormControlName, DropdownComponent, DropdownToggleDirective, DropdownMenuDirective, FormSelectDirective, TimePickerRollColComponent, TimePickerRollAmPmComponent],
      styles: [".disabled[_ngcontent-%COMP%]{pointer-events:none}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TimePickerComponent, [{
    type: Component,
    args: [{
      selector: 'c-time-picker',
      exportAs: 'cTimePicker',
      imports: [NgClass, NgTemplateOutlet, ReactiveFormsModule, DropdownComponent, DropdownToggleDirective, DropdownMenuDirective, FormSelectDirective, TimePickerRollColComponent, TimePickerRollAmPmComponent],
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => TimePickerComponent),
        multi: true
      }],
      host: {
        '(focusout)': 'onBlur()'
      },
      template: "@if (variant() === 'select') {\n  <div class=\"date-picker-timepickers\">\n    <div class=\"picker time-picker\">\n      <div [formGroup]=\"selectTime\" [ngClass]=\"timePickerClasses()\" class=\"time-picker-body\">\n        <span class=\"time-picker-inline-icon\"></span>\n        <select (blur)=\"onBlur()\" [attr.disabled]=\"disabled() || null\" [sizing]=\"size() ?? ''\"\n                cSelect class=\"time-picker-inline-select ms-0\" formControlName=\"selectHours\">\n          @for (hour of listOfHours12; track hour.value; let i = $index) {\n            <option [attr.disabled]=\"hour.disabled || null\" [ngValue]=\"hour.value\">\n              {{ hour.label }}\n            </option>\n          }\n        </select>\n        {{ ' :' }}<select (blur)=\"onBlur()\" [attr.disabled]=\"disabled() || null\" [sizing]=\"size() ?? ''\"\n                          cSelect class=\"time-picker-inline-select ms-0\" formControlName=\"selectMinutes\">\n        @for (minute of listOfMinutes; track minute.value; let i = $index) {\n          <option [attr.disabled]=\"minute.disabled || null\" [ngValue]=\"minute.value\">\n            {{ minute.label }}\n          </option>\n        }\n      </select>\n        @if (seconds()) {\n          {{ ' :' }}<select (blur)=\"onBlur()\" [attr.disabled]=\"disabled() || null\" [sizing]=\"size() ?? ''\"\n                            cSelect class=\"time-picker-inline-select ms-0\" formControlName=\"selectSeconds\">\n            @for (second of listOfSeconds; track second.value; let i = $index) {\n              <option [attr.disabled]=\"second.disabled || null\" [ngValue]=\"second.value\">\n                {{ second.label }}\n              </option>\n            }\n          </select>\n        }\n        @if (hour12) {\n          <select (blur)=\"onBlur()\" [attr.disabled]=\"disabled() || null\" [sizing]=\"size() ?? ''\"\n                  cSelect class=\"time-picker-inline-select ms-0\" formControlName=\"selectDayPeriod\">\n            @for (dayPeriod of dayPeriods; track dayPeriod.value) {\n              <option [ngValue]=\"dayPeriod.value\" class=\"time-picker-roll-cell\">\n                {{ dayPeriod.label }}\n              </option>\n            }\n          </select>\n        }\n      </div>\n    </div>\n  </div>\n}\n@if (variant() === 'roll') {\n  <c-dropdown #dropdown=\"cDropdown\" [autoClose]=\"'outside'\" [ngClass]=\"timePickerClasses()\" [visible]=\"visible()\">\n    <div [caret]=\"false\" cDropdownToggle class=\"time-picker-input-group\">\n      <input (blur)=\"handleBlur($event);\"\n             (change)=\"handleTimeInputChange($event)\"\n             (focus)=\"handleFocus($event)\"\n             [attr.pattern]=\"hour12 ? '(((0[1-9])|(1[0-2])):([0-5])([0-9])\\\\s(A|P)M)' : '([01]?[0-9]|2[0-3]):[0-5][0-9]'\"\n             [attr.tabindex]=\"disabled() ? -1 : 0\"\n             [formControl]=\"timeInputCtrl\"\n             [placeholder]=\"placeholder()\"\n             [readonly]=\"inputReadOnly() ?? null\"\n             class=\"time-picker-input\"\n      >\n      @if (indicator()) {\n        <div class=\"time-picker-indicator\"></div>\n      }\n      @if (cleaner() && time && !disabled()) {\n        <div (click)=\"!disabled() && handleClear($event)\" class=\"time-picker-cleaner\" role=\"button\"></div>\n      }\n    </div>\n    <div #dropdownMenu=\"cDropdownMenu\" cDropdownMenu class=\"time-picker-dropdown py-0\">\n      <div class=\"time-picker-body time-picker-roll\" style=\"position: relative;\">\n        <c-time-picker-roll-col\n          (selectedChange)=\"handleSelectTimeChange($event, 'hour')\"\n          [disabled]=\"disabled()\"\n          [elements]=\"listOfHours12\"\n          [refresh]=\"dropdownMenu.visible()\"\n          [selected]=\"hour\"\n          role=\"listbox\"\n        />\n        <c-time-picker-roll-col\n          (selectedChange)=\"handleSelectTimeChange($event, 'minute')\"\n          [disabled]=\"disabled()\"\n          [elements]=\"listOfMinutes\"\n          [refresh]=\"dropdownMenu.visible()\"\n          [selected]=\"minute\"\n          role=\"listbox\"\n        />\n        @if (seconds()) {\n          <c-time-picker-roll-col\n            (selectedChange)=\"handleSelectTimeChange($event, 'second')\"\n            [disabled]=\"disabled()\"\n            [elements]=\"listOfSeconds\"\n            [refresh]=\"dropdownMenu.visible()\"\n            [selected]=\"second\"\n            role=\"listbox\"\n          />\n        }\n        @if (hour12) {\n          <c-time-picker-roll-am-pm\n            (selectedChange)=\"handleSelectDayPeriodChange($event)\"\n            [disabled]=\"disabled()\"\n            [elements]=\"dayPeriods\"\n            [refresh]=\"dropdownMenu.visible()\"\n            [selected]=\"dayPeriod\"\n            role=\"listbox\"\n          />\n        }\n      </div>\n      @if (templates?.timePickerFooter) {\n        <div class=\"time-picker-footer\">\n          <ng-container *ngTemplateOutlet=\"templates?.timePickerFooter; context: {$implicit: dropdown}\" />\n        </div>\n      }\n    </div>\n  </c-dropdown>\n}\n",
      styles: [".disabled{pointer-events:none}\n"]
    }]
  }], null, {
    time: [{
      type: Input
    }],
    dropdownRef: [{
      type: ViewChild,
      args: [DropdownComponent, {
        read: ElementRef
      }]
    }],
    contentTemplates: [{
      type: ContentChildren,
      args: [TemplateIdDirective, {
        descendants: true
      }]
    }]
  });
})();
class TimePickerModule {
  static {
    this.ɵfac = function TimePickerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TimePickerModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: TimePickerModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [TimePickerComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TimePickerModule, [{
    type: NgModule,
    args: [{
      imports: [TimePickerComponent],
      exports: [TimePickerComponent]
    }]
  }], null, null);
})();
class CustomRangeKeyPipe {
  transform(customRange, ...args) {
    return customRange[0];
  }
  static {
    this.ɵfac = function CustomRangeKeyPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CustomRangeKeyPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "customRangeKey",
      type: CustomRangeKeyPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomRangeKeyPipe, [{
    type: Pipe,
    args: [{
      name: 'customRangeKey',
      standalone: true
    }]
  }], null, null);
})();

/** Must be a valid date string */
// todo: validation
// export function invalidDateStringValidator(locale: string): ValidatorFn {
//   return (control: AbstractControl): ValidationErrors | null => {
//     // const validDate = !isNaN(Date.parse(control.value));
//     stringToDateConvert(control.value, locale);
//     const dateShim = cvtDate(control.value, locale);
//     // @ts-ignore
//     // control.setValue(new Date(dateShim.year, dateShim.month, dateShim.day))
//     console.log('dateShim', dateShim, locale);
//     const validDate = isValidDate(control.value);
//     console.log('invalidDateStringValidator', control, control.value, validDate);
//     return validDate ? { invalidDateStringValidator: { value: control.value } } : null;
//   };
// }
class DateRangePickerComponent {
  constructor() {
    this.#cdr = inject(ChangeDetectorRef);
    this.#breakpointObserver = inject(BreakpointObserver);
    this.#destroyRef = inject(DestroyRef);
    /**
     * Set the format of day name.
     * @default 'numeric'
     * @return DayFormatType
     */
    this.dayFormat = input('numeric');
    /**
     * The number of calendars that render on desktop devices.
     * @return number
     * @default 2
     */
    this.calendars = input(2, {
      transform: numberAttribute
    });
    /**
     * Toggle visibility or set the content of the cleaner button.
     * @return boolean
     * @default true
     */
    this.cleaner = input(true, {
      transform: booleanAttribute
    });
    /**
     * Determine if the dropdown should be closed after value setting.
     * @return boolean
     * @default false
     */
    this.closeOnSelect = input(false, {
      transform: booleanAttribute
    });
    /**
     * Set date format.
     * We use Angular formatDate() function, see:
     * - https://angular.io/api/common/formatDate
     * - https://angular.io/api/common/DatePipe#pre-defined-format-options
     */
    this.format = input();
    /**
     * Toggle visibility or set the content of the input indicator.
     * @return boolean
     * @default true
     */
    this.indicator = input(true);
    /**
     * Custom function to format the selected date into a string according to a custom format.
     * @since v5.0.0
     */
    this.inputDateFormat = input();
    /**
     * Custom function to parse the input value into a valid Date object.
     * @since v5.0.0
     */
    this.inputDateParse = input();
    /**
     * Toggle the readonly state for the component.
     * @return boolean
     * @default false
     */
    this.inputReadOnlyInput = input(false, {
      transform: booleanAttribute,
      alias: 'inputReadOnly'
    });
    this.inputReadOnly = computed(() => {
      return this.inputReadOnlyInput() || typeof this.format() === 'string';
    });
    /**
     * Reorder year-month navigation, and render year first.
     * @return boolean
     * @default false
     */
    this.navYearFirst = input(false, {
      transform: booleanAttribute
    });
    /**
     * Specifies short hints that are visible in start date and end date inputs.
     * type string
     */
    this.placeholder = input(['Start date', 'End date']);
    /**
     * Predefined date ranges the user can select from.
     * @return ICalendarRanges
     */
    this.ranges = input();
    /**
     * Sets the color context of the cancel button to one of CoreUI’s themed colors.
     * @return 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'dark' | 'light' | string
     * @default 'secondary'
     */
    this.rangesButtonsColor = input('secondary');
    /**
     * Size the ranges button small or large.
     * @return 'sm' | 'lg' | ''
     */
    this.rangesButtonsSize = input('');
    /**
     * Set the ranges button variant to an outlined button or a ghost button.
     * @return 'outline' | 'ghost' | undefined
     */
    this.rangesButtonsVariant = input('ghost');
    /**
     * Default icon or character that separates two dates.
     * @return boolean
     * @default true
     */
    this.separator = input(true, {
      transform: booleanAttribute
    });
    /**
     * Size the component small or large.
     * @return 'sm' | 'lg' | undefined
     * @default undefined
     */
    this.size = input();
    /**
     * Keep track of the time with the date value.
     * @return boolean
     * @default false
     */
    this.withTime = input(false, {
      transform: booleanAttribute
    });
    /**
     * Provide an additional time selection by adding select boxes to choose time.
     * @return boolean
     * @default false
     */
    this.timepickerInput = input(false, {
      transform: booleanAttribute,
      alias: 'timepicker'
    });
    /**
     * Toggle visual validation feedback.
     * @return boolean | undefined
     * @default undefined
     */
    this.valid = input();
    /**
     * Toggle the visibility of the dropdown date-picker component.
     * @return boolean
     * @default false
     */
    this.visibleInput = input(false, {
      transform: booleanAttribute,
      alias: 'visible'
    });
    this.#visibleInputEffect = effect(() => {
      this.visible.set(this.visibleInput());
    });
    this.visible = signal(false);
    this.startDateModel = model(null, {
      alias: 'startDate'
    });
    this.#dateModelEffect = effect(() => {
      this.dateRangeGroup.patchValue({
        startDateInput: this.startDateValue(),
        endDateInput: this.endDateValue()
      });
      const startDate = this.startDate();
      const endDate = this.endDate();
      this.valueModel.set({
        startDate: startDate,
        endDate: endDate
      });
      this.startDateModel.set(startDate);
      this.endDateModel.set(endDate);
    });
    this.startDate = computed(() => {
      const startDate = this.startDateModel();
      return startDate ? new Date(startDate) : null;
    }, {
      equal: equalDates
    });
    this.startTime = computed(() => {
      return getUtcTime(this.startDate());
    });
    this.endTime = computed(() => {
      return getUtcTime(this.endDate());
    });
    this.startDateChange = toObservable(this.startDate);
    this.endDateModel = model(null, {
      alias: 'endDate'
    });
    this.endDate = computed(() => {
      const endDate = this.endDateModel();
      return endDate ? new Date(endDate) : null;
    }, {
      equal: equalDates
    });
    this.endDateChange = toObservable(this.endDate);
    this.calendarDateInput = input(new Date(), {
      transform: dateTransform,
      alias: 'calendarDate'
    });
    this.calendarDate = linkedSignal(this.calendarDateInput);
    this.disabledDates = input([]);
    /**
     * Set first day of week.
     * @return DaysOfWeek
     * @default 1 (Monday)
     */
    this.firstDayOfWeek = input(1);
    this.locale = input('default');
    this.maxDate = input(null);
    this.minDate = input(null);
    /**
     * Show calendar navigation.
     * @return boolean
     * @default true
     */
    this.navigation = input(true, {
      transform: booleanAttribute
    });
    /**
     * Allow range selection.
     * @return boolean
     * @default true
     */
    this.rangeInput = input(true, {
      transform: booleanAttribute,
      alias: 'range'
    });
    this.range = computed(() => {
      return this.rangeInput();
    });
    this.dateFilter = input();
    this.disabledInput = input(false, {
      transform: booleanAttribute,
      alias: 'disabled'
    });
    this.#disabledEffect = effect(() => {
      this.disabled() ? this.dateRangeGroup.disable() : this.dateRangeGroup.enable();
    });
    this.disabled = computed(() => {
      return this.#disabled() || this.disabledInput();
    });
    this.#disabled = signal(false);
    this.valueModel = model(null, {
      alias: 'value'
    });
    this.#valueInputEffect = effect(() => {
      const value = this.valueModel() ?? {
        startDate: null,
        endDate: null
      };
      const range = this.range();
      untracked(() => {
        this.value = value instanceof Date ? {
          startDate: value,
          endDate: null
        } : {
          ...value
        };
      });
    });
    this.#value = signal({
      startDate: null,
      endDate: null
    });
    /**
     * Set length or format of day name.
     * @return WeekdayFormatType
     * @default 'short'
     */
    this.weekdayFormat = input('short');
    /**
     * Optional popper Options object
     * @return Partial<Options>
     */
    this.popperjsOptions = input({
      strategy: 'absolute'
    }, {
      alias: 'popperOptions'
    });
    /**
     * Set whether days in adjacent months shown before or after the current month are selectable. This only applies if the `showAdjacentDays` option is set to true.
     * @return boolean
     * @default false
     * @since 4.4.10
     */
    this.selectAdjacentDays = input(false, {
      transform: booleanAttribute
    });
    /**
     * Set whether to display dates in adjacent months (non-selectable) at the start and end of the current month.
     * @return boolean
     * @default true
     * @since 4.4.10
     */
    this.showAdjacentDays = input(true, {
      transform: booleanAttribute
    });
    /**
     * Specify the type of date selection as day, week, month, or year.
     * @return 'day' | 'week' | 'month' | 'year'
     * @default 'day'
     * @since 5.0.0
     */
    this.selectionType = input('day');
    /**
     * Set whether to display week numbers in the calendar.
     * @return boolean
     * @default false
     * @since 5.0.0
     */
    this.showWeekNumber = input(false, {
      transform: booleanAttribute
    });
    /**
     * Label displayed over week numbers in the calendar.
     * @return string
     * @default undefined
     * @since 5.0.0
     */
    this.weekNumbersLabel = input();
    this.valueChange = output();
    this.calendarCellHover = output();
    this.calendarDateChange = output();
    this.startDateElementRef = viewChild('startDateElementRef');
    this.endDateElementRef = viewChild('endDateElementRef');
    this.contentTemplates = contentChildren(TemplateIdDirective, {
      descendants: true
    });
    this.templates = computed(() => {
      return this.contentTemplates().reduce((acc, child) => {
        acc[child.id] = child.templateRef;
        return acc;
      }, {});
    });
    this.dateChangeSubscriptions = [];
    this.isMobile = true;
    this.showRanges = false;
    this.startDateValue = computed(() => {
      const locale = this.locale() ?? 'default';
      return this.formatDate(this.startDate());
    });
    this.endDateValue = computed(() => {
      const locale = this.locale() ?? 'default';
      return this.formatDate(this.endDate());
    });
    // todo: validation
    // startDateInput = new FormControl({ value: this.startDateValue, disabled: this.disabled }, [
    //   Validators.required
    //   // Validators.minLength(8),
    //   // Validators.maxLength(10),
    //   // invalidDateStringValidator(this.locale)
    // ]);
    // endDateInput = new FormControl({ value: this.endDateValue, disabled: this.disabled }, [
    //   Validators.required
    //   // Validators.minLength(8),
    //   // Validators.maxLength(10),
    //   // invalidDateStringValidator(this.locale)
    // ]);
    this.dateRangeGroup = new FormGroup({
      startDateInput: new FormControl({
        value: '',
        disabled: this.disabled()
      }, [Validators.required]),
      endDateInput: new FormControl({
        value: '',
        disabled: this.disabled()
      }, [Validators.required])
    });
    this.inputStartHoverValue = signal(null);
    this.inputEndHoverValue = signal(null);
    this.datePickerClasses = computed(() => {
      const size = this.size();
      const valid = this.valid();
      const disabled = this.disabled();
      return {
        'date-picker': true,
        [`date-picker-${size}`]: size,
        disabled: disabled,
        'is-valid': valid === true,
        'is-invalid': valid === false
      };
    });
    this.#breakpoints = {
      OneCalendarRanges: '(min-width: 480px)',
      TwoCalendars: '(max-width: 650px)',
      TwoCalendarsRanges: '(max-width: 810px)'
    };
    this.setInputValue = (elementRef, date) => {
      if (!elementRef) {
        return;
      }
      elementRef.nativeElement.value = this.formatDate(date);
      // elementRef.nativeElement.valueAsDate = date;
      return;
    };
    this.onChange = value => {
      /* empty */
    };
    this.onTouched = () => {
      /* empty */
    };
  }
  #cdr;
  #breakpointObserver;
  #destroyRef;
  get timepicker() {
    return false;
    // return this.timepickerInput();
  }
  #visibleInputEffect;
  #dateModelEffect;
  #disabledEffect;
  #disabled;
  #valueInputEffect;
  set value(value) {
    const newValue = value;
    if (JSON.stringify(this.#value()) !== JSON.stringify(newValue)) {
      this.#value.set(newValue);
      this.valueChange.emit(this.value);
      this.onChange(this.value);
      this.#cdr.markForCheck();
      if (this.closeOnSelect() && this.visible()) {
        const hasValue = this.range() ? !!(newValue.startDate && newValue.endDate) : !!newValue;
        this.visible.set(!hasValue);
      }
    }
  }
  get value() {
    return this.range() ? this.#value() : this.#value().startDate;
  }
  #value;
  subscribeDateChange(subscribe = true) {
    if (subscribe) {
      // todo
      // this.dateChangeSubscriptions.push(
      //   this.startDateChange.subscribe((next) => {
      //     // console.log('startDateChange', next);
      //     // this.startDate = next;
      //     // this.onChange(next);
      //   })
      // );
      // this.dateChangeSubscriptions.push(
      //   this.endDateChange.subscribe((next) => {
      //     // console.log('endDateChange', next);
      //     // this.endDate = next;
      //     // this.onChange(next);
      //   })
      // );
      return;
    }
    this.dateChangeSubscriptions.forEach(subscription => {
      subscription?.unsubscribe();
    });
  }
  onBlur() {
    this.onTouched();
  }
  get startDatePlaceholder() {
    const placeholder = this.placeholder();
    return Array.isArray(placeholder) ? placeholder[0] : placeholder;
  }
  get endDatePlaceholder() {
    const placeholder = this.placeholder();
    return Array.isArray(placeholder) ? placeholder[1] : placeholder;
  }
  formatDate(date) {
    const format = this.format();
    const inputDateFormat = this.inputDateFormat();
    const locale = this.locale();
    return !date || !isValidDate(date) ? '' : typeof inputDateFormat === 'function' ? inputDateFormat(date) : !!format && !!locale && locale !== 'default' ? formatDate(date, format, locale) : this.timepicker ? date.toLocaleString(locale) : date.toLocaleDateString(locale);
  }
  #breakpoints;
  ngOnInit() {
    const ranges = this.ranges();
    this.customRanges = ranges ? Object.entries(ranges) : [];
    const breakpoints = this.#breakpoints;
    this.#breakpointObserver.observe([breakpoints.OneCalendarRanges, breakpoints.TwoCalendars, breakpoints.TwoCalendarsRanges]).pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(result => {
      if (result.matches) {
        this.isMobile = this.customRanges?.length > 0 && result.breakpoints[breakpoints.TwoCalendarsRanges] || result.breakpoints[breakpoints.TwoCalendars];
        if (this.customRanges?.length > 0) {
          this.showRanges = !result.breakpoints[breakpoints.OneCalendarRanges];
        }
      }
    });
    this.subscribeDateChange();
  }
  ngOnDestroy() {
    this.subscribeDateChange(false);
  }
  convertValueToDate(value) {
    if (!value) {
      return null;
    }
    if (typeof value === 'string') {
      return this.inputParse(value) ?? null;
    }
    return new Date(value);
  }
  inputParse(date) {
    const inputDateParse = this.inputDateParse();
    if (typeof inputDateParse === 'function') {
      const parsedDate = inputDateParse(date);
      if (isValidDate(parsedDate)) {
        return parsedDate;
      }
    }
    return getLocalDateFromString(date, this.locale(), this.timepicker);
  }
  getCustomRangeKey(customRange) {
    return customRange[0];
  }
  setCustomRange(customRange) {
    const key = this.getCustomRangeKey(customRange);
    this.handleStartDateChange(customRange[1][0]);
    this.handleEndDateChange(customRange[1][1]);
  }
  handleCalendarCellHover($event) {
    this.calendarCellHover.emit($event);
    if (!this.startDate()) {
      this.setInputValue(this.startDateElementRef(), $event);
      this.inputStartHoverValue.set($event);
      this.setInputValue(this.endDateElementRef(), null);
      this.inputEndHoverValue.set(null);
      return;
    }
    if (!this.endDate()) {
      this.setInputValue(this.endDateElementRef(), $event);
      this.inputEndHoverValue.set($event);
      return;
    }
  }
  handleCalendarDateChange($event) {
    if (this.calendarDate().getTime() !== $event.getTime()) {
      this.calendarDateChange.emit($event);
    }
  }
  handleStartDateChange(date) {
    const newDate = setUtcTime(date, this.startTime(), this.withTime());
    this.startDateModel.set(newDate ?? null);
    this.inputStartHoverValue.set(null);
  }
  handleEndDateChange(date) {
    if (!this.range()) {
      return;
    }
    const newDate = setUtcTime(date, this.endTime(), this.withTime());
    this.endDateModel.set(newDate ?? null);
    this.inputEndHoverValue.set(null);
  }
  handleClear($event) {
    this.handleStartDateChange(null);
    this.handleEndDateChange(null);
  }
  handleStartDateInputChange($event) {
    const inputValue = $event.target.value;
    const date = this.inputParse(inputValue);
    if (!date) {
      this.handleStartDateChange(null);
      this.handleEndDateChange(null);
      return;
    }
    if (date instanceof Date && date.getTime()) {
      const endDate = this.endDate();
      if (!(this.forbiddenDate(date) || endDate && endDate < date)) {
        this.calendarDate.set(date);
        this.handleStartDateChange(date);
        return;
      }
    }
    this.handleStartDateChange(this.startDate() ?? null);
  }
  handleEndDateInputChange($event) {
    const inputValue = $event.target.value;
    const date = this.inputParse(inputValue);
    if (!date) {
      this.handleEndDateChange(null);
      return;
    }
    if (date instanceof Date && date.getTime()) {
      const startDate = this.startDate();
      if (!(this.forbiddenDate(date) || startDate && startDate > date)) {
        this.calendarDate.set(date);
        this.handleEndDateChange(date);
      } else {
        this.handleEndDateChange(null);
      }
    }
    this.handleEndDateChange(this.endDate() ?? null);
  }
  forbiddenDate(date) {
    const dateFilter = this.dateFilter();
    return isDateDisabled(date, this.minDate(), this.maxDate(), this.disabledDates()) || (dateFilter ? !dateFilter(date) : false);
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled) {
    this.#disabled.set(isDisabled);
  }
  writeValue(value) {
    if (!!value) {
      this.handleStartDateChange(this.range() ? value.startDate : value);
      this.handleEndDateChange(this.range() ? value.endDate : null);
    }
  }
  handleStartTimeChange(time) {
    this.startDateModel.set(time ?? this.startDate());
  }
  handleEndTimeChange(time) {
    if (!this.range()) {
      return;
    }
    this.endDateModel.set(time ?? this.endDate());
  }
  static {
    this.ɵfac = function DateRangePickerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DateRangePickerComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DateRangePickerComponent,
      selectors: [["c-date-range-picker"]],
      contentQueries: function DateRangePickerComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.contentTemplates, TemplateIdDirective, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      viewQuery: function DateRangePickerComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuerySignal(ctx.startDateElementRef, _c14, 5);
          i0.ɵɵviewQuerySignal(ctx.endDateElementRef, _c15, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance(2);
        }
      },
      hostVars: 2,
      hostBindings: function DateRangePickerComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("focusout", function DateRangePickerComponent_focusout_HostBindingHandler() {
            return ctx.onBlur();
          });
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.datePickerClasses());
        }
      },
      inputs: {
        dayFormat: [1, "dayFormat"],
        calendars: [1, "calendars"],
        cleaner: [1, "cleaner"],
        closeOnSelect: [1, "closeOnSelect"],
        format: [1, "format"],
        indicator: [1, "indicator"],
        inputDateFormat: [1, "inputDateFormat"],
        inputDateParse: [1, "inputDateParse"],
        inputReadOnlyInput: [1, "inputReadOnly", "inputReadOnlyInput"],
        navYearFirst: [1, "navYearFirst"],
        placeholder: [1, "placeholder"],
        ranges: [1, "ranges"],
        rangesButtonsColor: [1, "rangesButtonsColor"],
        rangesButtonsSize: [1, "rangesButtonsSize"],
        rangesButtonsVariant: [1, "rangesButtonsVariant"],
        separator: [1, "separator"],
        size: [1, "size"],
        withTime: [1, "withTime"],
        timepickerInput: [1, "timepicker", "timepickerInput"],
        valid: [1, "valid"],
        visibleInput: [1, "visible", "visibleInput"],
        startDateModel: [1, "startDate", "startDateModel"],
        endDateModel: [1, "endDate", "endDateModel"],
        calendarDateInput: [1, "calendarDate", "calendarDateInput"],
        disabledDates: [1, "disabledDates"],
        firstDayOfWeek: [1, "firstDayOfWeek"],
        locale: [1, "locale"],
        maxDate: [1, "maxDate"],
        minDate: [1, "minDate"],
        navigation: [1, "navigation"],
        rangeInput: [1, "range", "rangeInput"],
        dateFilter: [1, "dateFilter"],
        disabledInput: [1, "disabled", "disabledInput"],
        valueModel: [1, "value", "valueModel"],
        weekdayFormat: [1, "weekdayFormat"],
        popperjsOptions: [1, "popperOptions", "popperjsOptions"],
        selectAdjacentDays: [1, "selectAdjacentDays"],
        showAdjacentDays: [1, "showAdjacentDays"],
        selectionType: [1, "selectionType"],
        showWeekNumber: [1, "showWeekNumber"],
        weekNumbersLabel: [1, "weekNumbersLabel"]
      },
      outputs: {
        startDateModel: "startDateChange",
        endDateModel: "endDateChange",
        valueModel: "valueChange",
        valueChange: "valueChange",
        calendarCellHover: "calendarCellHover",
        calendarDateChange: "calendarDateChange"
      },
      exportAs: ["cDateRangePicker"],
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DateRangePickerComponent),
        multi: true
      }])],
      ngContentSelectors: _c0,
      decls: 18,
      vars: 42,
      consts: [["dropdown", "cDropdown"], ["startDateElementRef", ""], ["endDateElementRef", ""], [3, "formGroup"], [1, "date-picker", "picker", 3, "visibleChange", "visible", "autoClose", "ngClass", "popperOptions"], ["cDropdownToggle", "", 1, "date-picker-input-group", 3, "caret", "disabled"], ["cFormControl", "", "formControlName", "startDateInput", "pattern", "[1-9]*", 1, "date-picker-input", 3, "change", "ngClass", "placeholder", "readonly", "valid"], [1, "date-picker-separator"], ["cFormControl", "", "formControlName", "endDateInput", "pattern", "[1-9]*", 1, "date-picker-input", 3, "ngClass", "placeholder", "readonly", "valid"], [1, "date-picker-indicator"], ["role", "button", 1, "date-picker-cleaner"], ["cDropdownMenu", "", 1, "date-picker-dropdown", "py-0"], [1, "date-picker-body"], [1, "date-picker-calendars", 3, "calendarCellHover", "calendarDateChange", "endDateChange", "startDateChange", "calendarDate", "calendars", "dateFilter", "dayFormat", "disabledDates", "endDate", "firstDayOfWeek", "locale", "maxDate", "minDate", "navYearFirst", "navigation", "range", "selectAdjacentDays", "selectionType", "showAdjacentDays", "showWeekNumber", "startDate", "weekNumbersLabel", "weekdayFormat"], [1, "date-picker-timepickers"], [1, "date-picker-footer"], ["cFormControl", "", "formControlName", "endDateInput", "pattern", "[1-9]*", 1, "date-picker-input", 3, "change", "ngClass", "placeholder", "readonly", "valid"], ["role", "button", 1, "date-picker-cleaner", 3, "click"], [1, "date-picker-ranges"], ["cButton", "", 3, "color", "size", "variant"], ["cButton", "", 3, "click", "color", "size", "variant"], ["variant", "select", 3, "timeChange", "locale", "disabled", "time"], ["variant", "select", 3, "locale", "disabled", "time"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]],
      template: function DateRangePickerComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "fieldset", 3)(1, "c-dropdown", 4, 0);
          i0.ɵɵtwoWayListener("visibleChange", function DateRangePickerComponent_Template_c_dropdown_visibleChange_1_listener($event) {
            i0.ɵɵrestoreView(_r1);
            i0.ɵɵtwoWayBindingSet(ctx.visible, $event) || (ctx.visible = $event);
            return i0.ɵɵresetView($event);
          });
          i0.ɵɵelementStart(3, "div", 5)(4, "input", 6, 1);
          i0.ɵɵlistener("change", function DateRangePickerComponent_Template_input_change_4_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.handleStartDateInputChange($event));
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(6, DateRangePickerComponent_Conditional_6_Template, 1, 0, "div", 7)(7, DateRangePickerComponent_Conditional_7_Template, 2, 7, "input", 8)(8, DateRangePickerComponent_Conditional_8_Template, 1, 0, "div", 9)(9, DateRangePickerComponent_Conditional_9_Template, 1, 0, "div", 10);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(10, "div", 11)(11, "div", 12);
          i0.ɵɵtemplate(12, DateRangePickerComponent_Conditional_12_Template, 1, 1);
          i0.ɵɵelementStart(13, "c-calendar", 13);
          i0.ɵɵlistener("calendarCellHover", function DateRangePickerComponent_Template_c_calendar_calendarCellHover_13_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.handleCalendarCellHover($event));
          })("calendarDateChange", function DateRangePickerComponent_Template_c_calendar_calendarDateChange_13_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.handleCalendarDateChange($event));
          })("endDateChange", function DateRangePickerComponent_Template_c_calendar_endDateChange_13_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.handleEndDateChange($event));
          })("startDateChange", function DateRangePickerComponent_Template_c_calendar_startDateChange_13_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.handleStartDateChange($event));
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(14, DateRangePickerComponent_Conditional_14_Template, 3, 4, "div", 14);
          i0.ɵɵelementEnd();
          i0.ɵɵdeclareLet(15);
          i0.ɵɵtemplate(16, DateRangePickerComponent_Conditional_16_Template, 2, 4, "div", 15);
          i0.ɵɵelementEnd();
          i0.ɵɵprojection(17);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          let tmp_8_0;
          let tmp_11_0;
          let tmp_40_0;
          const dropdown_r9 = i0.ɵɵreference(2);
          const startDateElementRef_r11 = i0.ɵɵreference(5);
          i0.ɵɵproperty("formGroup", ctx.dateRangeGroup);
          i0.ɵɵadvance();
          i0.ɵɵtwoWayProperty("visible", ctx.visible);
          i0.ɵɵproperty("autoClose", "outside")("ngClass", ctx.datePickerClasses())("popperOptions", ctx.popperjsOptions());
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("caret", false)("disabled", (tmp_8_0 = ctx.disabled()) !== null && tmp_8_0 !== undefined ? tmp_8_0 : dropdown_r9.visible);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(40, _c16, !!ctx.inputStartHoverValue()))("placeholder", ctx.startDatePlaceholder)("readonly", (tmp_11_0 = ctx.inputReadOnly()) !== null && tmp_11_0 !== undefined ? tmp_11_0 : null)("valid", ctx.range() ? undefined : ctx.valid());
          i0.ɵɵattribute("tabindex", ctx.disabled() ? -1 : 0);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.range() && ctx.separator() ? 6 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.range() ? 7 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.indicator() ? 8 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.cleaner() && startDateElementRef_r11.value && !ctx.disabled() ? 9 : -1);
          i0.ɵɵadvance(3);
          i0.ɵɵconditional(!ctx.showRanges ? 12 : -1);
          i0.ɵɵadvance();
          i0.ɵɵproperty("calendarDate", ctx.calendarDate())("calendars", ctx.isMobile ? 1 : ctx.calendars())("dateFilter", ctx.dateFilter())("dayFormat", ctx.dayFormat())("disabledDates", ctx.disabledDates())("endDate", ctx.endDate())("firstDayOfWeek", ctx.firstDayOfWeek())("locale", ctx.locale())("maxDate", ctx.maxDate())("minDate", ctx.minDate())("navYearFirst", ctx.navYearFirst())("navigation", ctx.navigation())("range", ctx.range())("selectAdjacentDays", ctx.selectAdjacentDays())("selectionType", ctx.selectionType())("showAdjacentDays", ctx.showAdjacentDays())("showWeekNumber", ctx.showWeekNumber())("startDate", ctx.startDate())("weekNumbersLabel", ctx.weekNumbersLabel())("weekdayFormat", ctx.weekdayFormat());
          i0.ɵɵadvance();
          i0.ɵɵconditional(false && ctx.timepicker ? 14 : -1);
          i0.ɵɵadvance();
          const footer_r12 = i0.ɵɵstoreLet((tmp_40_0 = ctx.templates()) == null ? null : tmp_40_0["datePickerFooter"]);
          i0.ɵɵadvance();
          i0.ɵɵconditional(footer_r12 ? 16 : -1);
        }
      },
      dependencies: [NgClass, NgTemplateOutlet, ReactiveFormsModule, i1$2.DefaultValueAccessor, i1$2.NgControlStatus, i1$2.NgControlStatusGroup, i1$2.PatternValidator, i1$2.FormGroupDirective, i1$2.FormControlName, CalendarComponent, TimePickerComponent, ButtonDirective, DropdownComponent, DropdownToggleDirective, DropdownMenuDirective, FormControlDirective, CustomRangeKeyPipe],
      styles: [".form-control.date-picker-input[_ngcontent-%COMP%]:focus{box-shadow:0 0}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DateRangePickerComponent, [{
    type: Component,
    args: [{
      selector: 'c-date-range-picker',
      exportAs: 'cDateRangePicker',
      imports: [NgClass, NgTemplateOutlet, ReactiveFormsModule, CalendarComponent, TimePickerComponent, ButtonDirective, DropdownComponent, DropdownToggleDirective, DropdownMenuDirective, FormControlDirective, CustomRangeKeyPipe],
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DateRangePickerComponent),
        multi: true
      }],
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        '[class]': 'datePickerClasses()',
        '(focusout)': 'onBlur()'
      },
      template: "<fieldset [formGroup]=\"dateRangeGroup\">\n  <c-dropdown #dropdown=\"cDropdown\" [(visible)]=\"visible\" [autoClose]=\"'outside'\" [ngClass]=\"datePickerClasses()\"\n              [popperOptions]=\"popperjsOptions()\" class=\"date-picker picker\">\n    <div [caret]=\"false\"\n         [disabled]=\"disabled() ?? dropdown.visible\"\n         cDropdownToggle\n         class=\"date-picker-input-group\"\n    >\n      <input #startDateElementRef\n             (change)=\"handleStartDateInputChange($event)\"\n             [attr.tabindex]=\"disabled() ? -1 : 0\"\n             [ngClass]=\"{hover: !!inputStartHoverValue()}\"\n             [placeholder]=\"startDatePlaceholder\"\n             [readonly]=\"inputReadOnly() ?? null\"\n             [valid]=\"range() ? undefined : valid()\"\n             cFormControl\n             class=\"date-picker-input\"\n             formControlName=\"startDateInput\"\n             pattern=\"[1-9]*\"\n      >\n      @if (range() && separator()) {\n        <div class=\"date-picker-separator\"></div>\n      }\n      @if (range()) {\n        <input #endDateElementRef\n               (change)=\"handleEndDateInputChange($event)\"\n               [attr.tabindex]=\"disabled() ? -1 : 0\"\n               [ngClass]=\"{hover: !!inputEndHoverValue()}\"\n               [placeholder]=\"endDatePlaceholder\"\n               [readonly]=\"inputReadOnly() ?? null\"\n               [valid]=\"valid() ?? undefined\"\n               cFormControl\n               class=\"date-picker-input\"\n               formControlName=\"endDateInput\"\n               pattern=\"[1-9]*\"\n        >\n      }\n      @if (indicator()) {\n        <div class=\"date-picker-indicator\"></div>\n      }\n      @if (cleaner() && startDateElementRef.value && !disabled()) {\n        <div (click)=\"!disabled() && handleClear($event)\" class=\"date-picker-cleaner\" role=\"button\"></div>\n      }\n    </div>\n    <div cDropdownMenu class=\"date-picker-dropdown py-0\">\n      <div class=\"date-picker-body\">\n        @if (!showRanges) {\n          @if (ranges() && customRanges.length > 0) {\n            <div class=\"date-picker-ranges\">\n              @for (customRange of customRanges; track customRange) {\n                <button (click)=\"setCustomRange(customRange)\"\n                        [color]=\"rangesButtonsColor()\"\n                        [size]=\"rangesButtonsSize()\"\n                        [variant]=\"rangesButtonsVariant()\"\n                        cButton>\n                  {{ customRange | customRangeKey }}\n                </button>\n              }\n            </div>\n          }\n        }\n        <c-calendar\n          (calendarCellHover)=\"handleCalendarCellHover($event)\"\n          (calendarDateChange)=\"handleCalendarDateChange($event)\"\n          (endDateChange)=\"handleEndDateChange($event)\"\n          (startDateChange)=\"handleStartDateChange($event)\"\n          [calendarDate]=\"calendarDate()\"\n          [calendars]=\"isMobile ? 1 : calendars()\"\n          [dateFilter]=\"dateFilter()\"\n          [dayFormat]=\"dayFormat()\"\n          [disabledDates]=\"disabledDates()\"\n          [endDate]=\"endDate()\"\n          [firstDayOfWeek]=\"firstDayOfWeek()\"\n          [locale]=\"locale()\"\n          [maxDate]=\"maxDate()\"\n          [minDate]=\"minDate()\"\n          [navYearFirst]=\"navYearFirst()\"\n          [navigation]=\"navigation()\"\n          [range]=\"range()\"\n          [selectAdjacentDays]=\"selectAdjacentDays()\"\n          [selectionType]=\"selectionType()\"\n          [showAdjacentDays]=\"showAdjacentDays()\"\n          [showWeekNumber]=\"showWeekNumber()\"\n          [startDate]=\"startDate()\"\n          [weekNumbersLabel]=\"weekNumbersLabel()\"\n          [weekdayFormat]=\"weekdayFormat()\"\n          class=\"date-picker-calendars\"\n        />\n        @if (false && timepicker) {\n          <div class=\"date-picker-timepickers\">\n            <!-- todo-->\n            <c-time-picker\n              variant=\"select\"\n              [locale]=\"locale()\"\n              [disabled]=\"!startDate()\"\n              [time]=\"startDate() ?? undefined\"\n              (timeChange)=\"handleStartTimeChange($event)\"\n            />\n            @if (range()) {\n              <c-time-picker\n                variant=\"select\"\n                [locale]=\"locale()\"\n                [disabled]=\"!endDate()\"\n                [time]=\"endDate() ?? undefined\"\n                (timeChange)=\"handleEndTimeChange($event)\"\n              />\n            }\n          </div>\n        }\n      </div>\n      @let footer = templates()?.['datePickerFooter'];\n      @if (footer) {\n        <div class=\"date-picker-footer\">\n          <ng-container *ngTemplateOutlet=\"footer; context: {$implicit: dropdown}\" />\n        </div>\n      }\n    </div>\n    <ng-content />\n  </c-dropdown>\n</fieldset>\n",
      styles: [".form-control.date-picker-input:focus{box-shadow:0 0}\n"]
    }]
  }], null, null);
})();
class DateRangePickerModule {
  static {
    this.ɵfac = function DateRangePickerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DateRangePickerModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DateRangePickerModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DateRangePickerComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DateRangePickerModule, [{
    type: NgModule,
    args: [{
      imports: [DateRangePickerComponent],
      exports: [DateRangePickerComponent]
    }]
  }], null, null);
})();
class DatePickerComponent extends DateRangePickerComponent {
  constructor() {
    super(...arguments);
    this.dateChange = output();
    this.calendars = input(1, {
      transform: numberAttribute
    });
    this.placeholder = input('Select date');
    this.range = signal(false);
    this.endDate = signal(null);
    this.startDateModel = model(null, {
      alias: 'date'
    });
  }
  get date() {
    return this.startDate();
  }
  writeValue(value) {
    this.startDateModel.set(value);
    super.writeValue(value);
  }
  subscribeDateChange(subscribe = true) {
    if (subscribe) {
      this.dateChangeSubscriptions.push(this.startDateChange.subscribe(next => {
        if (this.startDateModel()?.getTime() !== next?.getTime()) {
          this.startDateModel.set(next);
          this.onChange(next);
          this.dateChange.emit(next);
        }
      }));
      return;
    }
    this.dateChangeSubscriptions.forEach(subscription => {
      subscription?.unsubscribe();
    });
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵDatePickerComponent_BaseFactory;
      return function DatePickerComponent_Factory(__ngFactoryType__) {
        return (ɵDatePickerComponent_BaseFactory || (ɵDatePickerComponent_BaseFactory = i0.ɵɵgetInheritedFactory(DatePickerComponent)))(__ngFactoryType__ || DatePickerComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DatePickerComponent,
      selectors: [["c-date-picker"]],
      inputs: {
        calendars: [1, "calendars"],
        placeholder: [1, "placeholder"],
        startDateModel: [1, "date", "startDateModel"]
      },
      outputs: {
        dateChange: "dateChange",
        startDateModel: "dateChange"
      },
      exportAs: ["cDatePicker"],
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DatePickerComponent),
        multi: true
      }]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 18,
      vars: 42,
      consts: [["dropdown", "cDropdown"], ["startDateElementRef", ""], ["endDateElementRef", ""], [3, "formGroup"], [1, "date-picker", "picker", 3, "visibleChange", "visible", "autoClose", "ngClass", "popperOptions"], ["cDropdownToggle", "", 1, "date-picker-input-group", 3, "caret", "disabled"], ["cFormControl", "", "formControlName", "startDateInput", "pattern", "[1-9]*", 1, "date-picker-input", 3, "change", "ngClass", "placeholder", "readonly", "valid"], [1, "date-picker-separator"], ["cFormControl", "", "formControlName", "endDateInput", "pattern", "[1-9]*", 1, "date-picker-input", 3, "ngClass", "placeholder", "readonly", "valid"], [1, "date-picker-indicator"], ["role", "button", 1, "date-picker-cleaner"], ["cDropdownMenu", "", 1, "date-picker-dropdown", "py-0"], [1, "date-picker-body"], [1, "date-picker-calendars", 3, "calendarCellHover", "calendarDateChange", "endDateChange", "startDateChange", "calendarDate", "calendars", "dateFilter", "dayFormat", "disabledDates", "endDate", "firstDayOfWeek", "locale", "maxDate", "minDate", "navYearFirst", "navigation", "range", "selectAdjacentDays", "selectionType", "showAdjacentDays", "showWeekNumber", "startDate", "weekNumbersLabel", "weekdayFormat"], [1, "date-picker-timepickers"], [1, "date-picker-footer"], ["cFormControl", "", "formControlName", "endDateInput", "pattern", "[1-9]*", 1, "date-picker-input", 3, "change", "ngClass", "placeholder", "readonly", "valid"], ["role", "button", 1, "date-picker-cleaner", 3, "click"], [1, "date-picker-ranges"], ["cButton", "", 3, "color", "size", "variant"], ["cButton", "", 3, "click", "color", "size", "variant"], ["variant", "select", 3, "timeChange", "locale", "disabled", "time"], ["variant", "select", 3, "locale", "disabled", "time"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]],
      template: function DatePickerComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "fieldset", 3)(1, "c-dropdown", 4, 0);
          i0.ɵɵtwoWayListener("visibleChange", function DatePickerComponent_Template_c_dropdown_visibleChange_1_listener($event) {
            i0.ɵɵrestoreView(_r1);
            i0.ɵɵtwoWayBindingSet(ctx.visible, $event) || (ctx.visible = $event);
            return i0.ɵɵresetView($event);
          });
          i0.ɵɵelementStart(3, "div", 5)(4, "input", 6, 1);
          i0.ɵɵlistener("change", function DatePickerComponent_Template_input_change_4_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.handleStartDateInputChange($event));
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(6, DatePickerComponent_Conditional_6_Template, 1, 0, "div", 7)(7, DatePickerComponent_Conditional_7_Template, 2, 7, "input", 8)(8, DatePickerComponent_Conditional_8_Template, 1, 0, "div", 9)(9, DatePickerComponent_Conditional_9_Template, 1, 0, "div", 10);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(10, "div", 11)(11, "div", 12);
          i0.ɵɵtemplate(12, DatePickerComponent_Conditional_12_Template, 1, 1);
          i0.ɵɵelementStart(13, "c-calendar", 13);
          i0.ɵɵlistener("calendarCellHover", function DatePickerComponent_Template_c_calendar_calendarCellHover_13_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.handleCalendarCellHover($event));
          })("calendarDateChange", function DatePickerComponent_Template_c_calendar_calendarDateChange_13_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.handleCalendarDateChange($event));
          })("endDateChange", function DatePickerComponent_Template_c_calendar_endDateChange_13_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.handleEndDateChange($event));
          })("startDateChange", function DatePickerComponent_Template_c_calendar_startDateChange_13_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.handleStartDateChange($event));
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(14, DatePickerComponent_Conditional_14_Template, 3, 4, "div", 14);
          i0.ɵɵelementEnd();
          i0.ɵɵdeclareLet(15);
          i0.ɵɵtemplate(16, DatePickerComponent_Conditional_16_Template, 2, 4, "div", 15);
          i0.ɵɵelementEnd();
          i0.ɵɵprojection(17);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          let tmp_8_0;
          let tmp_11_0;
          let tmp_40_0;
          const dropdown_r9 = i0.ɵɵreference(2);
          const startDateElementRef_r11 = i0.ɵɵreference(5);
          i0.ɵɵproperty("formGroup", ctx.dateRangeGroup);
          i0.ɵɵadvance();
          i0.ɵɵtwoWayProperty("visible", ctx.visible);
          i0.ɵɵproperty("autoClose", "outside")("ngClass", ctx.datePickerClasses())("popperOptions", ctx.popperjsOptions());
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("caret", false)("disabled", (tmp_8_0 = ctx.disabled()) !== null && tmp_8_0 !== undefined ? tmp_8_0 : dropdown_r9.visible);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(40, _c16, !!ctx.inputStartHoverValue()))("placeholder", ctx.startDatePlaceholder)("readonly", (tmp_11_0 = ctx.inputReadOnly()) !== null && tmp_11_0 !== undefined ? tmp_11_0 : null)("valid", ctx.range() ? undefined : ctx.valid());
          i0.ɵɵattribute("tabindex", ctx.disabled() ? -1 : 0);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.range() && ctx.separator() ? 6 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.range() ? 7 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.indicator() ? 8 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.cleaner() && startDateElementRef_r11.value && !ctx.disabled() ? 9 : -1);
          i0.ɵɵadvance(3);
          i0.ɵɵconditional(!ctx.showRanges ? 12 : -1);
          i0.ɵɵadvance();
          i0.ɵɵproperty("calendarDate", ctx.calendarDate())("calendars", ctx.isMobile ? 1 : ctx.calendars())("dateFilter", ctx.dateFilter())("dayFormat", ctx.dayFormat())("disabledDates", ctx.disabledDates())("endDate", ctx.endDate())("firstDayOfWeek", ctx.firstDayOfWeek())("locale", ctx.locale())("maxDate", ctx.maxDate())("minDate", ctx.minDate())("navYearFirst", ctx.navYearFirst())("navigation", ctx.navigation())("range", ctx.range())("selectAdjacentDays", ctx.selectAdjacentDays())("selectionType", ctx.selectionType())("showAdjacentDays", ctx.showAdjacentDays())("showWeekNumber", ctx.showWeekNumber())("startDate", ctx.startDate())("weekNumbersLabel", ctx.weekNumbersLabel())("weekdayFormat", ctx.weekdayFormat());
          i0.ɵɵadvance();
          i0.ɵɵconditional(false && ctx.timepicker ? 14 : -1);
          i0.ɵɵadvance();
          const footer_r12 = i0.ɵɵstoreLet((tmp_40_0 = ctx.templates()) == null ? null : tmp_40_0["datePickerFooter"]);
          i0.ɵɵadvance();
          i0.ɵɵconditional(footer_r12 ? 16 : -1);
        }
      },
      dependencies: [NgClass, NgTemplateOutlet, ReactiveFormsModule, i1$2.DefaultValueAccessor, i1$2.NgControlStatus, i1$2.NgControlStatusGroup, i1$2.PatternValidator, i1$2.FormGroupDirective, i1$2.FormControlName, CalendarComponent, TimePickerComponent, ButtonDirective, DropdownComponent, DropdownToggleDirective, DropdownMenuDirective, FormControlDirective, CustomRangeKeyPipe],
      styles: [_c17],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatePickerComponent, [{
    type: Component,
    args: [{
      selector: 'c-date-picker',
      exportAs: 'cDatePicker',
      imports: [NgClass, NgTemplateOutlet, ReactiveFormsModule, CalendarComponent, TimePickerComponent, ButtonDirective, DropdownComponent, DropdownToggleDirective, DropdownMenuDirective, FormControlDirective, CustomRangeKeyPipe],
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DatePickerComponent),
        multi: true
      }],
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<fieldset [formGroup]=\"dateRangeGroup\">\n  <c-dropdown #dropdown=\"cDropdown\" [(visible)]=\"visible\" [autoClose]=\"'outside'\" [ngClass]=\"datePickerClasses()\"\n              [popperOptions]=\"popperjsOptions()\" class=\"date-picker picker\">\n    <div [caret]=\"false\"\n         [disabled]=\"disabled() ?? dropdown.visible\"\n         cDropdownToggle\n         class=\"date-picker-input-group\"\n    >\n      <input #startDateElementRef\n             (change)=\"handleStartDateInputChange($event)\"\n             [attr.tabindex]=\"disabled() ? -1 : 0\"\n             [ngClass]=\"{hover: !!inputStartHoverValue()}\"\n             [placeholder]=\"startDatePlaceholder\"\n             [readonly]=\"inputReadOnly() ?? null\"\n             [valid]=\"range() ? undefined : valid()\"\n             cFormControl\n             class=\"date-picker-input\"\n             formControlName=\"startDateInput\"\n             pattern=\"[1-9]*\"\n      >\n      @if (range() && separator()) {\n        <div class=\"date-picker-separator\"></div>\n      }\n      @if (range()) {\n        <input #endDateElementRef\n               (change)=\"handleEndDateInputChange($event)\"\n               [attr.tabindex]=\"disabled() ? -1 : 0\"\n               [ngClass]=\"{hover: !!inputEndHoverValue()}\"\n               [placeholder]=\"endDatePlaceholder\"\n               [readonly]=\"inputReadOnly() ?? null\"\n               [valid]=\"valid() ?? undefined\"\n               cFormControl\n               class=\"date-picker-input\"\n               formControlName=\"endDateInput\"\n               pattern=\"[1-9]*\"\n        >\n      }\n      @if (indicator()) {\n        <div class=\"date-picker-indicator\"></div>\n      }\n      @if (cleaner() && startDateElementRef.value && !disabled()) {\n        <div (click)=\"!disabled() && handleClear($event)\" class=\"date-picker-cleaner\" role=\"button\"></div>\n      }\n    </div>\n    <div cDropdownMenu class=\"date-picker-dropdown py-0\">\n      <div class=\"date-picker-body\">\n        @if (!showRanges) {\n          @if (ranges() && customRanges.length > 0) {\n            <div class=\"date-picker-ranges\">\n              @for (customRange of customRanges; track customRange) {\n                <button (click)=\"setCustomRange(customRange)\"\n                        [color]=\"rangesButtonsColor()\"\n                        [size]=\"rangesButtonsSize()\"\n                        [variant]=\"rangesButtonsVariant()\"\n                        cButton>\n                  {{ customRange | customRangeKey }}\n                </button>\n              }\n            </div>\n          }\n        }\n        <c-calendar\n          (calendarCellHover)=\"handleCalendarCellHover($event)\"\n          (calendarDateChange)=\"handleCalendarDateChange($event)\"\n          (endDateChange)=\"handleEndDateChange($event)\"\n          (startDateChange)=\"handleStartDateChange($event)\"\n          [calendarDate]=\"calendarDate()\"\n          [calendars]=\"isMobile ? 1 : calendars()\"\n          [dateFilter]=\"dateFilter()\"\n          [dayFormat]=\"dayFormat()\"\n          [disabledDates]=\"disabledDates()\"\n          [endDate]=\"endDate()\"\n          [firstDayOfWeek]=\"firstDayOfWeek()\"\n          [locale]=\"locale()\"\n          [maxDate]=\"maxDate()\"\n          [minDate]=\"minDate()\"\n          [navYearFirst]=\"navYearFirst()\"\n          [navigation]=\"navigation()\"\n          [range]=\"range()\"\n          [selectAdjacentDays]=\"selectAdjacentDays()\"\n          [selectionType]=\"selectionType()\"\n          [showAdjacentDays]=\"showAdjacentDays()\"\n          [showWeekNumber]=\"showWeekNumber()\"\n          [startDate]=\"startDate()\"\n          [weekNumbersLabel]=\"weekNumbersLabel()\"\n          [weekdayFormat]=\"weekdayFormat()\"\n          class=\"date-picker-calendars\"\n        />\n        @if (false && timepicker) {\n          <div class=\"date-picker-timepickers\">\n            <!-- todo-->\n            <c-time-picker\n              variant=\"select\"\n              [locale]=\"locale()\"\n              [disabled]=\"!startDate()\"\n              [time]=\"startDate() ?? undefined\"\n              (timeChange)=\"handleStartTimeChange($event)\"\n            />\n            @if (range()) {\n              <c-time-picker\n                variant=\"select\"\n                [locale]=\"locale()\"\n                [disabled]=\"!endDate()\"\n                [time]=\"endDate() ?? undefined\"\n                (timeChange)=\"handleEndTimeChange($event)\"\n              />\n            }\n          </div>\n        }\n      </div>\n      @let footer = templates()?.['datePickerFooter'];\n      @if (footer) {\n        <div class=\"date-picker-footer\">\n          <ng-container *ngTemplateOutlet=\"footer; context: {$implicit: dropdown}\" />\n        </div>\n      }\n    </div>\n    <ng-content />\n  </c-dropdown>\n</fieldset>\n",
      styles: [".form-control.date-picker-input:focus{box-shadow:0 0}\n"]
    }]
  }], null, null);
})();
class DatePickerModule {
  static {
    this.ɵfac = function DatePickerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DatePickerModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DatePickerModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DatePickerComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatePickerModule, [{
    type: NgModule,
    args: [{
      imports: [DatePickerComponent],
      exports: [DatePickerComponent]
    }]
  }], null, null);
})();
class SpinnerComponent {
  constructor() {
    /**
     * Sets the color context of the component to one of CoreUI’s themed colors.
     * @type Colors
     */
    this.color = input();
    /**
     * Label for accessibility.
     * @type string
     * @default 'Loading...'
     */
    this.label = input('Loading...');
    /**
     * Size the component small.
     * @type string
     * @values 'sm'
     */
    this.size = input();
    /**
     * Set the button variant to an outlined button or a ghost button.
     * @values 'border' | 'grow'
     * @default 'border'
     */
    this.variant = input('border');
    /**
     * Default role attr for Spinner. [docs]
     * @type string
     * @default 'status'
     */
    this.role = input('status');
    this.hostClasses = computed(() => {
      return {
        [`spinner-${this.variant()}`]: true,
        [`text-${this.color()}`]: !!this.color(),
        [`spinner-${this.variant()}-${this.size()}`]: !!this.size()
      };
    });
  }
  static {
    this.ɵfac = function SpinnerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SpinnerComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SpinnerComponent,
      selectors: [["c-spinner"]],
      hostVars: 3,
      hostBindings: function SpinnerComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role());
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        color: [1, "color"],
        label: [1, "label"],
        size: [1, "size"],
        variant: [1, "variant"],
        role: [1, "role"]
      },
      ngContentSelectors: _c0,
      decls: 2,
      vars: 0,
      consts: [[1, "visually-hidden"]],
      template: function SpinnerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0, 0, null, SpinnerComponent_ProjectionFallback_0_Template, 2, 1);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpinnerComponent, [{
    type: Component,
    args: [{
      selector: 'c-spinner',
      host: {
        '[attr.role]': 'role()',
        '[class]': 'hostClasses()'
      },
      template: "<ng-content>\n  <span class=\"visually-hidden\">{{ label() }}</span>\n</ng-content>\n"
    }]
  }], null, null);
})();
class SpinnerModule {
  static {
    this.ɵfac = function SpinnerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SpinnerModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SpinnerModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpinnerModule, [{
    type: NgModule,
    args: [{
      exports: [SpinnerComponent],
      imports: [SpinnerComponent]
    }]
  }], null, null);
})();
class ElementCoverComponent {
  #parent;
  constructor() {
    this.elementRef = inject(ElementRef);
    this.changeDetectorRef = inject(ChangeDetectorRef);
    this.#parent = signal(undefined);
    /**
     * Array of custom boundaries. Use to create custom cover area (instead of parent element area). Area is defined by four sides: 'top', 'bottom', 'right', 'left'. If side is not defined by any custom boundary it is equal to parent element boundary. Each custom boundary is object with keys:
     * - sides (array) - select boundaries of element to define boundaries. Side names: 'top', 'bottom', 'right', 'left'.
     * - query (string) - query used to get element which define boundaries. Search will be done only inside parent element, by parent.querySelector(query) function. [docs]
     * @type {sides: string[], query: string}[]
     */
    this.boundaries = input();
    /**
     * Opacity of cover. [docs]
     * @type <number>
     */
    this.opacity = input(0.4);
    this.#customBoundaries = computed(() => {
      if (!this.boundaries() || this.elementRef === null) {
        return {};
      }
      if (!this.#parent()) {
        return {};
      }
      const parentCoords = this.#parent()?.getBoundingClientRect();
      const _customBoundaries = {};
      this.boundaries()?.forEach(value => {
        const element = this.#parent()?.querySelector(value.query);
        if (!element || !value.sides) {
          return;
        }
        const coords = element.getBoundingClientRect();
        value.sides.forEach(side => {
          const sideMargin = Math.abs(coords[side] - parentCoords[side]);
          _customBoundaries[side] = `${sideMargin}px`;
        });
      });
      return _customBoundaries;
    });
    this.#containerCoords = computed(() => {
      return {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        ...this.#customBoundaries()
      };
    });
    this.hostStyles = computed(() => {
      return {
        ...this.#containerCoords(),
        position: 'absolute',
        backgroundColor: `rgb(255,255,255,${this.opacity()})`
      };
    });
    afterNextRender({
      read: () => {
        this.#parent.set(this.elementRef.nativeElement.parentElement);
        this.changeDetectorRef.detectChanges();
      }
    });
  }
  #customBoundaries;
  #containerCoords;
  static {
    this.ɵfac = function ElementCoverComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ElementCoverComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ElementCoverComponent,
      selectors: [["c-element-cover"], ["", "cElementCover", ""]],
      hostVars: 2,
      hostBindings: function ElementCoverComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵstyleMap(ctx.hostStyles());
        }
      },
      inputs: {
        boundaries: [1, "boundaries"],
        opacity: [1, "opacity"]
      },
      ngContentSelectors: _c0,
      decls: 3,
      vars: 2,
      consts: [[3, "ngStyle"], ["color", "primary", "variant", "grow"]],
      template: function ElementCoverComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵprojection(1, 0, null, ElementCoverComponent_ProjectionFallback_1_Template, 1, 0);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(1, _c18));
        }
      },
      dependencies: [SpinnerComponent, NgStyle],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ElementCoverComponent, [{
    type: Component,
    args: [{
      selector: 'c-element-cover, [cElementCover]',
      imports: [SpinnerComponent, NgStyle],
      host: {
        '[style]': 'hostStyles()'
      },
      template: "<div [ngStyle]=\"{position: 'absolute', 'top.%': '50', 'left.%': '50', transform: 'translateX(-50%) translateY(-50%)'}\">\n  <ng-content>\n    <c-spinner color=\"primary\" variant=\"grow\" />\n  </ng-content>\n</div>\n",
      styles: [":host{display:block}\n"]
    }]
  }], () => [], null);
})();
class ElementCoverModule {
  static {
    this.ɵfac = function ElementCoverModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ElementCoverModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ElementCoverModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ElementCoverModule, [{
    type: NgModule,
    args: [{
      imports: [ElementCoverComponent],
      exports: [ElementCoverComponent]
    }]
  }], null, null);
})();
class FooterComponent {
  constructor() {
    /**
     * Place footer in non-static positions. [docs]
     * @type Positions
     */
    this.position = input();
    /**
     * Default role for footer. [docs]
     * @type string
     * @default 'contentinfo'
     */
    this.role = input('contentinfo');
    this.hostClasses = computed(() => {
      return {
        footer: true,
        [`footer-${this.position()}`]: !!this.position()
      };
    });
  }
  static {
    this.ɵfac = function FooterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FooterComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FooterComponent,
      selectors: [["c-footer"], ["", "cFooter", ""]],
      hostAttrs: [1, "footer"],
      hostVars: 3,
      hostBindings: function FooterComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role());
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        position: [1, "position"],
        role: [1, "role"]
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function FooterComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FooterComponent, [{
    type: Component,
    args: [{
      selector: 'c-footer, [cFooter]',
      template: '<ng-content />',
      host: {
        class: 'footer',
        '[class]': 'hostClasses()',
        '[attr.role]': 'role()'
      }
    }]
  }], null, null);
})();
class FooterModule {
  static {
    this.ɵfac = function FooterModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FooterModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: FooterModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FooterModule, [{
    type: NgModule,
    args: [{
      imports: [FooterComponent],
      exports: [FooterComponent]
    }]
  }], null, null);
})();
class ContainerComponent {
  constructor() {
    /**
     * Set container 100% wide until a breakpoint.
     */
    this.breakpoint = input('');
    /**
     * Set container 100% wide, spanning the entire width of the viewport.
     * @return boolean
     */
    this.fluid = input(false, {
      transform: booleanAttribute
    });
    this.hostClasses = computed(() => {
      const breakpoint = this.breakpoint();
      const fluid = this.fluid();
      return {
        container: !fluid && !breakpoint,
        'container-fluid': !!fluid,
        [`container-${breakpoint}`]: !!breakpoint
      };
    });
  }
  static {
    this.ɵfac = function ContainerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ContainerComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ContainerComponent,
      selectors: [["c-container"], ["", "cContainer", ""]],
      hostVars: 2,
      hostBindings: function ContainerComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        breakpoint: [1, "breakpoint"],
        fluid: [1, "fluid"]
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function ContainerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContainerComponent, [{
    type: Component,
    args: [{
      selector: 'c-container, [cContainer]',
      template: '<ng-content />',
      host: {
        '[class]': 'hostClasses()'
      },
      styles: [":host{display:block}\n"]
    }]
  }], null, null);
})();
class ColDirective {
  constructor() {
    /**
     * The number of columns/offset/order on extra small devices (<576px).
     * @return { 'auto' | number |  boolean }
     */
    this.cCol = input(false, {
      transform: this.coerceInput
    });
    this.xs = input(false, {
      transform: this.coerceInput
    });
    /**
     * The number of columns/offset/order on small devices (<768px).
     * @return { 'auto' | number |  boolean }
     */
    this.sm = input(false, {
      transform: this.coerceInput
    });
    /**
     * The number of columns/offset/order on medium devices (<992px).
     * @return { 'auto' | number |  boolean }
     */
    this.md = input(false, {
      transform: this.coerceInput
    });
    /**
     * The number of columns/offset/order on large devices (<1200px).
     * @return { 'auto' | number |  boolean }
     */
    this.lg = input(false, {
      transform: this.coerceInput
    });
    /**
     * The number of columns/offset/order on X-Large devices (<1400px).
     * @return { 'auto' | number |  boolean }
     */
    this.xl = input(false, {
      transform: this.coerceInput
    });
    /**
     * The number of columns/offset/order on XX-Large devices (≥1400px).
     * @return { 'auto' | number |  boolean }
     */
    this.xxl = input(false, {
      transform: this.coerceInput
    });
    this.breakpoints = computed(() => {
      return {
        xs: this.xs() || this.cCol(),
        sm: this.sm(),
        md: this.md(),
        lg: this.lg(),
        xl: this.xl(),
        xxl: this.xxl()
      };
    });
    this.offset = input();
    this.order = input();
    this.hostClasses = computed(() => {
      const classes = {
        col: true
      };
      const breakpoints = this.breakpoints();
      const offsetInput = this.offset();
      const orderInput = this.order();
      Object.keys(BreakpointInfix).forEach(breakpoint => {
        const value = breakpoints[breakpoint];
        const infix = breakpoint === 'xs' ? '' : `-${breakpoint}`;
        classes[`col${infix}`] = value === true;
        classes[`col${infix}-${value}`] = typeof value === 'number' || typeof value === 'string';
      });
      if (typeof offsetInput === 'object') {
        const offset = {
          ...offsetInput
        };
        Object.entries(offset).forEach(entry => {
          const [breakpoint, value] = [...entry];
          const infix = breakpoint === 'xs' ? '' : `-${breakpoint}`;
          classes[`offset${infix}-${value}`] = value >= 0 && value <= 11;
        });
      } else {
        const offset = numberAttribute(offsetInput);
        classes[`offset-${offset}`] = typeof offset === 'number' && offset > 0 && offset <= 11;
      }
      if (typeof orderInput === 'object') {
        const order = {
          ...orderInput
        };
        Object.entries(order).forEach(entry => {
          const [breakpoint, value] = [...entry];
          const infix = breakpoint === 'xs' ? '' : `-${breakpoint}`;
          classes[`order${infix}-${value}`] = !!value;
        });
      } else {
        const order = orderInput;
        classes[`order-${order}`] = !!order;
      }
      // if there is no 'col' class, add one
      classes['col'] = !Object.entries(classes).filter(i => i[0].startsWith('col-') && i[1]).length || breakpoints['xs'] === true;
      return classes;
    });
  }
  coerceInput(value) {
    if (value === 'auto') {
      return value;
    }
    if (value === '' || value === undefined || value === null) {
      return booleanAttribute(value);
    }
    if (typeof value === 'boolean') {
      return value;
    }
    return numberAttribute(value);
  }
  static {
    this.ɵfac = function ColDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ColDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ColDirective,
      selectors: [["", "cCol", ""]],
      hostVars: 2,
      hostBindings: function ColDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        cCol: [1, "cCol"],
        xs: [1, "xs"],
        sm: [1, "sm"],
        md: [1, "md"],
        lg: [1, "lg"],
        xl: [1, "xl"],
        xxl: [1, "xxl"],
        offset: [1, "offset"],
        order: [1, "order"]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ColDirective, [{
    type: Directive,
    args: [{
      selector: '[cCol]',
      host: {
        '[class]': 'hostClasses()'
      }
    }]
  }], null, null);
})();
class ColComponent extends ColDirective {
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵColComponent_BaseFactory;
      return function ColComponent_Factory(__ngFactoryType__) {
        return (ɵColComponent_BaseFactory || (ɵColComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ColComponent)))(__ngFactoryType__ || ColComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ColComponent,
      selectors: [["c-col"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function ColComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ColComponent, [{
    type: Component,
    args: [{
      selector: 'c-col',
      template: '<ng-content />',
      styles: [":host{display:block}\n"]
    }]
  }], null, null);
})();
class RowDirective {
  constructor() {
    /**
     * The number of columns/offset/order on extra small devices (<576px).
     * @return { cols: 'auto' | number }
     */
    this.xs = input();
    /**
     * The number of columns/offset/order on small devices (<768px).
     * @return { cols: 'auto' | number }
     */
    this.sm = input();
    /**
     * The number of columns/offset/order on medium devices (<992px).
     * @return { cols: 'auto' | number }
     */
    this.md = input();
    /**
     * The number of columns/offset/order on large devices (<1200px).
     * @return { cols: 'auto' | number }
     */
    this.lg = input();
    /**
     * The number of columns/offset/order on X-Large devices (<1400px).
     * @return { cols: 'auto' | number }
     */
    this.xl = input();
    /**
     * The number of columns/offset/order on XX-Large devices (≥1400px).
     * @return { cols: 'auto' | number }
     */
    this.xxl = input();
    this.hostClasses = computed(() => {
      const cols = this.xs();
      const classes = {
        row: true,
        [`row-cols-${cols}`]: !!cols
      };
      Object.keys(BreakpointInfix).forEach(breakpoint => {
        // @ts-ignore
        const value = this[breakpoint]();
        if (typeof value === 'number' || typeof value === 'string') {
          const infix = breakpoint === 'xs' ? '' : `-${breakpoint}`;
          classes[`row-cols${infix}-${value}`] = !!value;
        }
      });
      return classes;
    });
  }
  static {
    this.ɵfac = function RowDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RowDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: RowDirective,
      selectors: [["", "cRow", ""]],
      hostAttrs: [1, "row"],
      hostVars: 2,
      hostBindings: function RowDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        xs: [1, "xs"],
        sm: [1, "sm"],
        md: [1, "md"],
        lg: [1, "lg"],
        xl: [1, "xl"],
        xxl: [1, "xxl"]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RowDirective, [{
    type: Directive,
    args: [{
      selector: '[cRow]',
      host: {
        class: 'row',
        '[class]': 'hostClasses()'
      }
    }]
  }], null, null);
})();
class RowComponent extends RowDirective {
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵRowComponent_BaseFactory;
      return function RowComponent_Factory(__ngFactoryType__) {
        return (ɵRowComponent_BaseFactory || (ɵRowComponent_BaseFactory = i0.ɵɵgetInheritedFactory(RowComponent)))(__ngFactoryType__ || RowComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: RowComponent,
      selectors: [["c-row"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function RowComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RowComponent, [{
    type: Component,
    args: [{
      selector: 'c-row',
      template: '<ng-content />'
    }]
  }], null, null);
})();
class GutterDirective {
  constructor() {
    /**
     * Define padding between columns to space and align content responsively in the Bootstrap grid system.
     */
    this.gutter = input({});
    this.hostClasses = computed(() => {
      let gutterClass;
      const gutterInput = this.gutter();
      if (typeof gutterInput === 'number') {
        gutterClass = GutterDirective.getGutterClasses({
          g: gutterInput
        });
        return gutterClass;
      }
      {
        const {
          g,
          gx,
          gy
        } = {
          ...gutterInput
        };
        gutterClass = GutterDirective.getGutterClasses({
          g,
          gx,
          gy
        });
      }
      Object.keys(BreakpointInfix).forEach(key => {
        // @ts-ignore
        const gutter = gutterInput[key] ? {
          ...gutterInput[key]
        } : undefined;
        if (gutter) {
          const classes = GutterDirective.getGutterClasses(gutter, key);
          gutterClass = {
            ...gutterClass,
            ...classes
          };
        }
      });
      return gutterClass;
    });
  }
  static getGutterClasses(gutter, breakpoint) {
    const {
      g,
      gx,
      gy
    } = {
      ...gutter
    };
    const infix = breakpoint ? `-${breakpoint}` : '';
    return {
      [`g${infix}-${g}`]: typeof g === 'number',
      [`gx${infix}-${gx}`]: typeof gx === 'number',
      [`gy${infix}-${gy}`]: typeof gy === 'number'
    };
  }
  static {
    this.ɵfac = function GutterDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GutterDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: GutterDirective,
      selectors: [["", "gutter", ""]],
      hostVars: 2,
      hostBindings: function GutterDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        gutter: [1, "gutter"]
      },
      exportAs: ["gutter"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GutterDirective, [{
    type: Directive,
    args: [{
      // eslint-disable-next-line @angular-eslint/directive-selector
      selector: '[gutter]',
      exportAs: 'gutter',
      host: {
        '[class]': 'hostClasses()'
      }
    }]
  }], null, null);
})();
class GridModule {
  static {
    this.ɵfac = function GridModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GridModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: GridModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GridModule, [{
    type: NgModule,
    args: [{
      imports: [ColComponent, ColDirective, ContainerComponent, GutterDirective, RowComponent, RowDirective],
      exports: [ColComponent, ColDirective, ContainerComponent, GutterDirective, RowComponent, RowDirective]
    }]
  }], null, null);
})();
class HeaderComponent {
  constructor() {
    /**
     * Defines optional container wrapping children elements.
     */
    this.container = input();
    /**
     * Place header in non-static positions.
     */
    this.position = input();
    /**
     * Default role for header. [docs]
     * @type string
     * @default 'banner'
     */
    this.role = input('banner');
    this.hostClasses = computed(() => {
      return !!this.container() ? this.containerClasses() : this.headerClasses();
    });
    this.headerClasses = computed(() => {
      const position = this.position();
      return {
        header: true,
        [`header-${position}`]: !!position
      };
    });
    this.containerClasses = computed(() => {
      const container = this.container();
      return {
        container: container === true,
        [`container-${container}`]: typeof container === 'string'
      };
    });
  }
  static {
    this.ɵfac = function HeaderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HeaderComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: HeaderComponent,
      selectors: [["c-header"], ["", "c-header", ""]],
      hostVars: 3,
      hostBindings: function HeaderComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role());
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        container: [1, "container"],
        position: [1, "position"],
        role: [1, "role"]
      },
      exportAs: ["cHeader"],
      ngContentSelectors: _c2,
      decls: 2,
      vars: 1,
      consts: [[3, "ngClass"]],
      template: function HeaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c2);
          i0.ɵɵtemplate(0, HeaderComponent_Conditional_0_Template, 2, 1, "div", 0)(1, HeaderComponent_Conditional_1_Template, 1, 0);
        }
        if (rf & 2) {
          i0.ɵɵconditional(!!ctx.container() ? 0 : 1);
        }
      },
      dependencies: [NgClass],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderComponent, [{
    type: Component,
    args: [{
      selector: 'c-header, [c-header]',
      imports: [NgClass],
      exportAs: 'cHeader',
      host: {
        '[attr.role]': 'role()',
        '[class]': 'hostClasses()'
      },
      template: "@if (!!container()) {\n  <div [ngClass]=\"headerClasses()\">\n    <ng-content />\n  </div>\n} @else {\n  <ng-content />\n}\n"
    }]
  }], null, null);
})();
class HeaderBrandComponent {
  constructor() {
    /**
     * Default role for header-brand. [docs]
     * @return string
     * @default 'button'
     */
    this.role = input('button');
  }
  static {
    this.ɵfac = function HeaderBrandComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HeaderBrandComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: HeaderBrandComponent,
      selectors: [["c-header-brand"]],
      hostAttrs: [1, "header-brand"],
      hostVars: 1,
      hostBindings: function HeaderBrandComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role());
        }
      },
      inputs: {
        role: [1, "role"]
      },
      exportAs: ["cHeaderBrand"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function HeaderBrandComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderBrandComponent, [{
    type: Component,
    args: [{
      selector: 'c-header-brand',
      template: '<ng-content />',
      exportAs: 'cHeaderBrand',
      host: {
        '[attr.role]': 'role()',
        class: 'header-brand'
      }
    }]
  }], null, null);
})();
class HeaderDividerComponent {
  static {
    this.ɵfac = function HeaderDividerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HeaderDividerComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: HeaderDividerComponent,
      selectors: [["c-header-divider"], ["", "cHeaderDivider", ""]],
      hostAttrs: [1, "header-divider"],
      decls: 0,
      vars: 0,
      template: function HeaderDividerComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderDividerComponent, [{
    type: Component,
    args: [{
      selector: 'c-header-divider, [cHeaderDivider]',
      template: ``,
      host: {
        class: 'header-divider'
      }
    }]
  }], null, null);
})();
class HeaderNavComponent {
  constructor() {
    /**
     * Default role for header-nav. [docs]
     * @return string
     * @default 'navigation'
     */
    this.role = input('navigation');
  }
  static {
    this.ɵfac = function HeaderNavComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HeaderNavComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: HeaderNavComponent,
      selectors: [["c-header-nav"]],
      hostAttrs: [1, "header-nav"],
      hostVars: 1,
      hostBindings: function HeaderNavComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role());
        }
      },
      inputs: {
        role: [1, "role"]
      },
      exportAs: ["cHeaderNav"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function HeaderNavComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderNavComponent, [{
    type: Component,
    args: [{
      selector: 'c-header-nav',
      template: '<ng-content />',
      exportAs: 'cHeaderNav',
      host: {
        '[attr.role]': 'role()',
        class: 'header-nav'
      }
    }]
  }], null, null);
})();
class HeaderTextComponent {
  static {
    this.ɵfac = function HeaderTextComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HeaderTextComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: HeaderTextComponent,
      selectors: [["c-header-text"], ["", "cHeaderText", ""]],
      hostAttrs: [1, "header-text"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function HeaderTextComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderTextComponent, [{
    type: Component,
    args: [{
      selector: 'c-header-text, [cHeaderText]',
      template: '<ng-content />',
      host: {
        class: 'header-text'
      }
    }]
  }], null, null);
})();
class HeaderTogglerDirective {
  constructor() {
    this.#renderer = inject(Renderer2);
    this.#hostElement = inject(ElementRef);
    /**
     * Default type for header-toggler button. [docs]
     * @return string
     * @default 'button'
     */
    this.type = input('button');
    /**
     * Default aria-label attr for header-toggler. [docs]
     * @type string
     * @default 'Toggle navigation'
     */
    this.ariaLabel = input('Toggle navigation');
  }
  #renderer;
  #hostElement;
  addDefaultIcon() {
    const span = this.#renderer.createElement('span');
    this.#renderer.addClass(span, 'header-toggler-icon');
    this.#renderer.appendChild(this.#hostElement.nativeElement, span);
  }
  ngAfterContentInit() {
    const hasContent = this.#hostElement.nativeElement.childNodes.length > 0;
    if (!hasContent) {
      this.addDefaultIcon();
    }
  }
  static {
    this.ɵfac = function HeaderTogglerDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HeaderTogglerDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: HeaderTogglerDirective,
      selectors: [["", "cHeaderToggler", ""]],
      hostAttrs: [1, "header-toggler"],
      hostVars: 2,
      hostBindings: function HeaderTogglerDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("type", ctx.type())("aria-label", ctx.ariaLabel());
        }
      },
      inputs: {
        type: [1, "type"],
        ariaLabel: [1, "ariaLabel"]
      },
      exportAs: ["cHeaderToggler"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderTogglerDirective, [{
    type: Directive,
    args: [{
      selector: '[cHeaderToggler]',
      exportAs: 'cHeaderToggler',
      host: {
        '[attr.type]': 'type()',
        '[attr.aria-label]': 'ariaLabel()',
        class: 'header-toggler'
      }
    }]
  }], null, null);
})();
class HeaderModule {
  static {
    this.ɵfac = function HeaderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HeaderModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: HeaderModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderModule, [{
    type: NgModule,
    args: [{
      imports: [HeaderComponent, HeaderBrandComponent, HeaderDividerComponent, HeaderNavComponent, HeaderTextComponent, HeaderTogglerDirective],
      exports: [HeaderComponent, HeaderBrandComponent, HeaderDividerComponent, HeaderNavComponent, HeaderTextComponent, HeaderTogglerDirective]
    }]
  }], null, null);
})();
class ImgDirective {
  constructor() {
    /**
     * Set the horizontal aligment.
     * @type {'' | 'start' | 'end' | 'center'}
     */
    this.align = input('');
    /**
     * Make image responsive.
     * @type boolean
     */
    this.fluid = input(false, {
      transform: booleanAttribute
    });
    /**
     * Make image rounded.
     * @type boolean
     */
    this.rounded = input(false, {
      transform: booleanAttribute
    });
    /**
     * Give an image a rounded 1px border appearance.
     * @type boolean
     */
    this.thumbnail = input(false, {
      transform: booleanAttribute
    });
    /**
     * Color for image placeholder.
     */
    this.placeholderColor = input('transparent');
    this.hostStyles = computed(() => {
      return {
        backgroundColor: this.placeholderColor()
      };
    });
    this.hostClasses = computed(() => {
      const align = this.align();
      return {
        [`float-${align}`]: align === 'start' || align === 'end',
        'd-block': align === 'center',
        'mx-auto': align === 'center',
        'img-fluid': this.fluid(),
        rounded: this.rounded(),
        'img-thumbnail': this.thumbnail()
      };
    });
  }
  static {
    this.ɵfac = function ImgDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ImgDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ImgDirective,
      selectors: [["", "cImg", ""]],
      hostVars: 4,
      hostBindings: function ImgDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵstyleMap(ctx.hostStyles());
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        align: [1, "align"],
        fluid: [1, "fluid"],
        rounded: [1, "rounded"],
        thumbnail: [1, "thumbnail"],
        placeholderColor: [1, "placeholderColor"]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImgDirective, [{
    type: Directive,
    args: [{
      selector: '[cImg]',
      host: {
        '[class]': 'hostClasses()',
        '[style]': 'hostStyles()'
      }
    }]
  }], null, null);
})();
class ImgModule {
  static {
    this.ɵfac = function ImgModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ImgModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ImgModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImgModule, [{
    type: NgModule,
    args: [{
      imports: [ImgDirective],
      exports: [ImgDirective]
    }]
  }], null, null);
})();
class ListGroupDirective {
  constructor() {
    /**
     * Remove some borders and rounded corners to render list group items edge-to-edge in a parent component (e.g., `<CCard>`).
     * @type boolean
     */
    this.flush = input(false, {
      transform: booleanAttribute
    });
    /**
     * Specify horizontal layout type.
     */
    this.horizontal = input();
    this.hostClasses = computed(() => {
      const horizontal = this.horizontal();
      return {
        'list-group': true,
        'list-group-horizontal': horizontal === true || horizontal === '',
        [`list-group-horizontal-${horizontal}`]: !!horizontal && typeof horizontal !== 'boolean',
        'list-group-flush': this.flush()
      };
    });
  }
  static {
    this.ɵfac = function ListGroupDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ListGroupDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ListGroupDirective,
      selectors: [["", "cListGroup", ""]],
      hostAttrs: [1, "list-group"],
      hostVars: 2,
      hostBindings: function ListGroupDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        flush: [1, "flush"],
        horizontal: [1, "horizontal"]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListGroupDirective, [{
    type: Directive,
    args: [{
      selector: '[cListGroup]',
      host: {
        class: 'list-group',
        '[class]': 'hostClasses()'
      }
    }]
  }], null, null);
})();
class ListGroupItemDirective {
  constructor() {
    this.hostElement = inject(ElementRef);
    /**
     * Toggle the active state for the component.
     * @type InputSignal<boolean | undefined>
     */
    this.active = input();
    /**
     * Sets the color context of the component to one of CoreUI’s themed colors.
     * @type InputSignal<boolean | undefined>
     */
    this.color = input();
    /**
     * Set disabled attr for the host element. [docs]
     * @type boolean
     */
    this.disabled = input(false, {
      transform: booleanAttribute
    });
    this.hostClasses = computed(() => {
      const host = this.hostElement.nativeElement;
      return {
        'list-group-item': true,
        'list-group-item-action': host.nodeName === 'A' || host.nodeName === 'BUTTON',
        active: !!this.active(),
        disabled: this._disabled(),
        [`list-group-item-${this.color()}`]: !!this.color()
      };
    });
    this._disabled = computed(() => this.disabled());
    this.ariaDisabled = computed(() => {
      return this._disabled() ? true : null;
    });
    this.attrDisabled = computed(() => {
      return this._disabled() ? '' : null;
    });
    this.tabIndex = computed(() => {
      return this._disabled() ? '-1' : null;
    });
    this.ariaCurrent = computed(() => {
      return this.active() || null;
    });
  }
  static {
    this.ɵfac = function ListGroupItemDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ListGroupItemDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ListGroupItemDirective,
      selectors: [["", "cListGroupItem", ""], ["c-list-group-item"]],
      hostVars: 6,
      hostBindings: function ListGroupItemDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("aria-disabled", ctx.ariaDisabled())("aria-current", ctx.ariaCurrent())("disabled", ctx.attrDisabled())("tabindex", ctx.tabIndex());
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        active: [1, "active"],
        color: [1, "color"],
        disabled: [1, "disabled"]
      },
      exportAs: ["cListGroupItem"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListGroupItemDirective, [{
    type: Directive,
    args: [{
      selector: '[cListGroupItem], c-list-group-item',
      exportAs: 'cListGroupItem',
      host: {
        '[class]': 'hostClasses()',
        '[attr.aria-disabled]': 'ariaDisabled()',
        '[attr.aria-current]': 'ariaCurrent()',
        '[attr.disabled]': 'attrDisabled()',
        '[attr.tabindex]': 'tabIndex()'
      }
    }]
  }], null, null);
})();
class ListGroupModule {
  static {
    this.ɵfac = function ListGroupModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ListGroupModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ListGroupModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListGroupModule, [{
    type: NgModule,
    args: [{
      exports: [ListGroupDirective, ListGroupItemDirective],
      imports: [ListGroupDirective, ListGroupItemDirective]
    }]
  }], null, null);
})();
const loadingButtonAnimation = trigger('loadingButton', [transition(':enter', [style({
  opacity: 0,
  marginRight: '1rem',
  marginLeft: '-2rem'
}), animate('.15s ease-in-out', style({
  opacity: 1,
  marginRight: '1rem',
  marginLeft: '0rem'
}))]), transition(':leave', [style({
  opacity: 1
}), animate('.15s ease-in-out', style({
  opacity: 0,
  marginRight: '1rem',
  marginLeft: '-2rem'
}))])]);
class LoadingButtonComponent extends ButtonDirective {
  constructor() {
    super();
    /**
     * Makes button disabled when loading.
     * @type boolean
     * @default false
     */
    this.disabledOnLoading = input(false, {
      transform: booleanAttribute
    });
    /**
     * Loading state (set to true to start animation).
     * @type boolean
     */
    this.loading = input(false, {
      transform: booleanAttribute
    });
    /**
     * Event emitted on loading change
     * @type boolean
     */
    this.loadingChange = output();
    this.loadingEffect = effect(() => {
      this.loadingChange.emit(this.loading());
    });
    /**
     * Sets type of spinner.
     * @type {'border' | 'grow'}
     */
    this.spinnerType = input('border');
    this.hostClasses = computed(() => {
      return {
        btn: true,
        'btn-loading': true,
        'is-loading': this.loading(),
        [`btn-${this.color()}`]: !!this.color() && !this.variant(),
        [`btn-${this.variant()}`]: !!this.variant() && !this.color(),
        [`btn-${this.variant()}-${this.color()}`]: !!this.variant() && !!this.color(),
        [`btn-${this.size()}`]: !!this.size(),
        active: this.active(),
        disabled: this._disabled()
      };
    });
    this._disabled = computed(() => {
      return this.disabled() || this.disabledOnLoading() && this.loading();
    });
  }
  static {
    this.ɵfac = function LoadingButtonComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LoadingButtonComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: LoadingButtonComponent,
      selectors: [["button", "cLoadingButton", ""], ["a", "cLoadingButton", ""]],
      hostAttrs: [1, "btn-loading"],
      hostVars: 7,
      hostBindings: function LoadingButtonComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("aria-disabled", ctx.ariaDisabled())("aria-pressed", ctx.isActive())("disabled", ctx.attrDisabled())("tabindex", ctx.tabIndex())("type", ctx.type());
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        disabledOnLoading: [1, "disabledOnLoading"],
        loading: [1, "loading"],
        spinnerType: [1, "spinnerType"]
      },
      outputs: {
        loadingChange: "loadingChange"
      },
      exportAs: ["cLoadingButton"],
      features: [i0.ɵɵInheritDefinitionFeature],
      attrs: _c19,
      ngContentSelectors: _c0,
      decls: 2,
      vars: 1,
      consts: [["size", "sm", 1, "btn-loading-spinner", 3, "variant"]],
      template: function LoadingButtonComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, LoadingButtonComponent_Conditional_0_Template, 1, 2, "c-spinner", 0);
          i0.ɵɵprojection(1);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.loading() ? 0 : -1);
        }
      },
      dependencies: [SpinnerComponent],
      encapsulation: 2,
      data: {
        animation: [loadingButtonAnimation]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoadingButtonComponent, [{
    type: Component,
    args: [{
      selector: 'button[cLoadingButton], a[cLoadingButton]',
      exportAs: 'cLoadingButton',
      imports: [SpinnerComponent],
      animations: [loadingButtonAnimation],
      host: {
        class: 'btn-loading',
        '[class]': 'hostClasses()',
        '[attr.aria-disabled]': 'ariaDisabled()',
        '[attr.aria-pressed]': 'isActive()',
        '[attr.disabled]': 'attrDisabled()',
        '[attr.tabindex]': 'tabIndex()',
        '[attr.type]': 'type()'
      },
      template: "@if (loading()) {\n  <c-spinner [variant]=\"spinnerType()\" size=\"sm\" class=\"btn-loading-spinner\" @loadingButton />\n}\n<ng-content />\n"
    }]
  }], () => [], null);
})();
class LoadingButtonModule {
  static {
    this.ɵfac = function LoadingButtonModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LoadingButtonModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: LoadingButtonModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoadingButtonModule, [{
    type: NgModule,
    args: [{
      exports: [LoadingButtonComponent],
      imports: [LoadingButtonComponent]
    }]
  }], null, null);
})();
class MultiSelectOptgroupLabelComponent {
  static {
    this.ɵfac = function MultiSelectOptgroupLabelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MultiSelectOptgroupLabelComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MultiSelectOptgroupLabelComponent,
      selectors: [["c-multi-select-optgroup-label"]],
      hostAttrs: [1, "form-multi-select-optgroup-label"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function MultiSelectOptgroupLabelComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiSelectOptgroupLabelComponent, [{
    type: Component,
    args: [{
      selector: 'c-multi-select-optgroup-label',
      template: '<ng-content />',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: true,
      host: {
        class: 'form-multi-select-optgroup-label'
      },
      styles: [":host{display:block}\n"]
    }]
  }], null, null);
})();
class MultiSelectService {
  constructor() {
    this.optionsStyle = 'checkbox';
    this.multiSelectVisible = new BehaviorSubject(false);
    this.multiSelectVisible$ = this.multiSelectVisible.asObservable();
    this.multiSelectFocus = new Subject();
    this.multiSelectFocus$ = this.multiSelectFocus.asObservable();
    this.userOptionsSignal = signal([]);
    this.optionsArray = new BehaviorSubject([]);
    this.optionsArray$ = this.optionsArray.asObservable();
  }
  setSelectionModel(multiple = true, initiallySelectedValues = []) {
    this.selectionModel = new SelectionModel(multiple);
  }
  toggleVisible(visible) {
    this.multiSelectVisible.next(visible);
  }
  focusChange(option) {
    this.multiSelectFocus.next(option);
  }
  getUserOptions() {
    return computed(this.userOptionsSignal);
  }
  addUserOption(option) {
    this.userOptionsSignal.update(options => [...options, option]);
  }
  removeUserOption(value) {
    const updatedOptions = this.userOptionsSignal().filter(option => option.value !== value);
    this.userOptionsSignal.set(updatedOptions);
  }
  removeAllUserOptions() {
    this.userOptionsSignal.set([]);
  }
  getOptionsArray() {
    return this.optionsArray$;
  }
  updateOptionsArray(options) {
    this.optionsArray.next(options);
  }
  static {
    this.ɵfac = function MultiSelectService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MultiSelectService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MultiSelectService,
      factory: MultiSelectService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiSelectService, [{
    type: Injectable
  }], null, null);
})();
class MultiSelectOptionComponent {
  #destroyRef;
  #ngZone;
  constructor(elementRef, changeDetectorRef, focusMonitor, multiSelectService) {
    this.elementRef = elementRef;
    this.changeDetectorRef = changeDetectorRef;
    this.focusMonitor = focusMonitor;
    this.multiSelectService = multiSelectService;
    this.#destroyRef = inject(DestroyRef);
    this.#ngZone = inject(NgZone);
    /**
     * Option style
     * @type ('checkbox' | 'text')
     * @default 'checkbox'
     */
    this.optionsStyle = this.multiSelectService?.optionsStyle ?? 'checkbox';
    this.#visible = signal(true);
    /**
     * Option disabled.
     * @type boolean
     * @default false
     */
    this.disabled = false;
    this.#selected = signal(undefined);
    /**
     * Emits option selected change
     * @type boolean
     */
    this.selectedChange = new EventEmitter();
    this.#value = signal(undefined);
    this.hasContent = signal(true);
    this.#dropdownVisible = signal(false);
    this.#active = signal(false);
    this.#focused = false;
    this.focusChange = new EventEmitter();
    this.#tabIndex = computed(() => {
      return this.#active() && this.#visible() ? 0 : -1;
    });
    this.#ariaSelected = computed(() => {
      const value = this.#value();
      const selected = this.#selected();
      if (value !== undefined && selected !== undefined) {
        selected ? this.multiSelectService.selectionModel?.select(value) : this.multiSelectService.selectionModel?.deselect(value);
        this.selectedChange.emit(selected);
        this.changeDetectorRef.markForCheck();
      }
      return selected;
    });
  }
  /**
   * Option visible.
   * @type boolean
   * @default true
   */
  set visible(value) {
    this.#visible.set(value);
  }
  get visible() {
    return this.#visible();
  }
  #visible;
  /**
   * Option selected.
   * @type boolean
   * @default false
   */
  set selected(value) {
    if (value !== undefined) {
      const selected = booleanAttribute(value);
      if (this.#selected() !== selected) {
        this.#selected.set(selected);
        if (this.value !== undefined) {
          selected ? this.multiSelectService.selectionModel?.select(this.value) : this.multiSelectService.selectionModel?.deselect(this.value);
        }
      }
    }
  }
  get selected() {
    return this.#selected();
  }
  #selected;
  /**
   * Option value.
   * @type string | number
   * @default undefined
   */
  set value(value) {
    if (this.#value() !== value) {
      this.#value.set(value);
    }
  }
  get value() {
    return this.#value();
  }
  #value;
  #dropdownVisible;
  set active(value) {
    const active = value && this.#visible() && !this.disabled;
    if (this.#active() !== active) {
      this.#active.set(active);
    }
  }
  get active() {
    return this.#active() && this.#visible();
  }
  #active;
  #focused;
  get role() {
    return 'option';
  }
  get hostClasses() {
    return {
      'form-multi-select-option': true,
      'form-multi-selected': this.#selected(),
      [`form-multi-select-option-with-${this.optionsStyle}`]: !!this.optionsStyle,
      disabled: this.disabled,
      'd-none': !this.#visible(),
      active: this.#active(),
      focused: this.#focused
    };
  }
  get tabIndex() {
    return this.disabled || !this.#visible() ? -1 : this.#tabIndex();
  }
  #tabIndex;
  get ariaDisabled() {
    return this.disabled || null;
  }
  get ariaSelected() {
    return this.#ariaSelected() ?? false;
  }
  #ariaSelected;
  onKeyDown($event) {
    if (['Space'].includes($event.code)) {
      $event.preventDefault();
    }
    if (['Tab'].includes($event.code)) {
      $event.preventDefault();
    }
  }
  onBlur() {
    this.#focused = false;
  }
  onFocus() {
    this.#focused = true;
  }
  onKeyUp($event) {
    if (this.#dropdownVisible()) {
      if (['Enter', 'Space'].includes($event.code)) {
        $event.stopImmediatePropagation();
        $event.preventDefault();
        this.selected = this.disabled ? this.#selected() : !this.#selected();
        this.focus('keyboard');
      }
    }
  }
  onClick($event) {
    $event.stopPropagation();
    this.selected = this.disabled ? this.#selected() : !this.#selected();
    this.focus('mouse');
  }
  ngAfterViewInit() {
    this.setSubscriptions();
    const hasContent = !!this.contentDiv?.nativeElement.childNodes.length;
    if (!hasContent) {
      this.#ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          this.hasContent.set(hasContent);
          // this.#ngZone.run(() => {
          //   this.changeDetectorRef.markForCheck();
          // });
        });
      });
    }
    if (this.text === undefined) {
      const innerText = this.elementRef.nativeElement.textContent.trim() || this.elementRef.nativeElement.innerText.trim();
      this.text = innerText || this.value?.toString().trim();
    }
    if (this.label === undefined) {
      this.label = this.text?.trim();
    }
    if (this.value === undefined) {
      this.value = this.label?.trim() || '...';
    }
    if (!this.changeDetectorRef.destroyed) {
      // setTimeout(() => {
      this.selected = this.isSelected(this.value);
      this.changeDetectorRef.markForCheck();
      // });
    }
  }
  /** Get the label for this element which is required by the FocusableOption interface. */
  getLabel() {
    return this.label ?? this.value;
  }
  focus(origin = 'program') {
    if (this.#dropdownVisible() && !this.disabled) {
      this.focusMonitor.focusVia(this.elementRef.nativeElement, origin, {
        preventScroll: false
      });
      this.multiSelectService.focusChange(this);
      this.changeDetectorRef.markForCheck();
      this.focusChange.emit(this);
    }
  }
  setSubscriptions() {
    this.multiSelectService.multiSelectVisible$.pipe(tap(visible => {
      this.#dropdownVisible.set(visible);
    }), takeUntilDestroyed(this.#destroyRef)).subscribe();
    this.multiSelectService.multiSelectFocus$.pipe(distinctUntilChanged(), filter(option => this.active !== (this.value === option.value)), tap(option => {
      this.active = this.value === option.value;
      this.changeDetectorRef.markForCheck();
    }), takeUntilDestroyed(this.#destroyRef)).subscribe();
    if (!this.changeDetectorRef.destroyed) {
      this.multiSelectService.selectionModel.changed.pipe(filter(change => change.added.includes(this.value) || change.removed.includes(this.value)), tap(change => {
        this.selected = change.added.includes(this.value);
        this.changeDetectorRef.markForCheck();
      }), takeUntilDestroyed(this.#destroyRef)).subscribe();
    }
  }
  isSelected(value = this.value) {
    return (this.#selected() || this.multiSelectService.selectionModel?.isSelected(value)) ?? false;
  }
  static {
    this.ɵfac = function MultiSelectOptionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MultiSelectOptionComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$1.FocusMonitor), i0.ɵɵdirectiveInject(MultiSelectService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MultiSelectOptionComponent,
      selectors: [["c-multi-select-option"]],
      viewQuery: function MultiSelectOptionComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c20, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentDiv = _t.first);
        }
      },
      hostVars: 7,
      hostBindings: function MultiSelectOptionComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown", function MultiSelectOptionComponent_keydown_HostBindingHandler($event) {
            return ctx.onKeyDown($event);
          })("blur", function MultiSelectOptionComponent_blur_HostBindingHandler() {
            return ctx.onBlur();
          })("focus", function MultiSelectOptionComponent_focus_HostBindingHandler() {
            return ctx.onFocus();
          })("keyup", function MultiSelectOptionComponent_keyup_HostBindingHandler($event) {
            return ctx.onKeyUp($event);
          })("click", function MultiSelectOptionComponent_click_HostBindingHandler($event) {
            return ctx.onClick($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵhostProperty("role", ctx.role);
          i0.ɵɵattribute("tabindex", ctx.tabIndex)("disabled", ctx.ariaDisabled)("aria-disabled", ctx.ariaDisabled)("aria-selected", ctx.ariaSelected);
          i0.ɵɵclassMap(ctx.hostClasses);
        }
      },
      inputs: {
        optionsStyle: "optionsStyle",
        label: "label",
        text: "text",
        visible: [2, "visible", "visible", booleanAttribute],
        disabled: [2, "disabled", "disabled", booleanAttribute],
        selected: "selected",
        value: "value",
        active: [2, "active", "active", booleanAttribute],
        role: "role"
      },
      outputs: {
        selectedChange: "selectedChange",
        focusChange: "focusChange"
      },
      exportAs: ["cMultiSelectOption"],
      ngContentSelectors: _c0,
      decls: 4,
      vars: 1,
      consts: [["contentDiv", ""]],
      template: function MultiSelectOptionComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", null, 0);
          i0.ɵɵprojection(2);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(3, MultiSelectOptionComponent_Conditional_3_Template, 2, 1, "div");
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵconditional(!ctx.hasContent() ? 3 : -1);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block;-webkit-user-select:none;user-select:none;white-space:nowrap;overflow:hidden}.active[_nghost-%COMP%]{border-radius:var(--cui-form-multi-select-option-indicator-border-radius, .375rem);box-shadow:0 0 .125rem 0 var(--cui-gray-400)}.focused[_nghost-%COMP%], [_nghost-%COMP%]   [_ngcontent-%COMP%]:focus-visible{box-shadow:0 0 0 .125rem #321fdb40;outline:none}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiSelectOptionComponent, [{
    type: Component,
    args: [{
      selector: 'c-multi-select-option',
      exportAs: 'cMultiSelectOption',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: true,
      template: "<div #contentDiv>\n  <ng-content />\n</div>\n@if (!hasContent()) {\n  <div>\n    {{ text ?? label ?? value?.toString() }}\n  </div>\n}\n",
      styles: [":host{display:block;-webkit-user-select:none;user-select:none;white-space:nowrap;overflow:hidden}:host.active{border-radius:var(--cui-form-multi-select-option-indicator-border-radius, .375rem);box-shadow:0 0 .125rem 0 var(--cui-gray-400)}:host.focused,:host :focus-visible{box-shadow:0 0 0 .125rem #321fdb40;outline:none}\n"]
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i1$1.FocusMonitor
  }, {
    type: MultiSelectService
  }], {
    optionsStyle: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    text: [{
      type: Input
    }],
    visible: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    disabled: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    selected: [{
      type: Input
    }],
    selectedChange: [{
      type: Output
    }],
    value: [{
      type: Input
    }],
    contentDiv: [{
      type: ViewChild,
      args: ['contentDiv']
    }],
    active: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    focusChange: [{
      type: Output
    }],
    role: [{
      type: Input
    }, {
      type: HostBinding,
      args: ['role']
    }],
    hostClasses: [{
      type: HostBinding,
      args: ['class']
    }],
    tabIndex: [{
      type: HostBinding,
      args: ['attr.tabindex']
    }],
    ariaDisabled: [{
      type: HostBinding,
      args: ['attr.disabled']
    }, {
      type: HostBinding,
      args: ['attr.aria-disabled']
    }],
    ariaSelected: [{
      type: HostBinding,
      args: ['attr.aria-selected']
    }],
    onKeyDown: [{
      type: HostListener,
      args: ['keydown', ['$event']]
    }],
    onBlur: [{
      type: HostListener,
      args: ['blur']
    }],
    onFocus: [{
      type: HostListener,
      args: ['focus']
    }],
    onKeyUp: [{
      type: HostListener,
      args: ['keyup', ['$event']]
    }],
    onClick: [{
      type: HostListener,
      args: ['click', ['$event']]
    }]
  });
})();
class MultiSelectOptgroupComponent {
  constructor(multiSelectService) {
    this.multiSelectService = multiSelectService;
    this.#destroyRef = inject(DestroyRef);
    this.visible = signal(true);
    this.disabled = false;
  }
  #destroyRef;
  get hostClasses() {
    return {
      'form-multi-select-options': true,
      'd-none': !this.visible()
    };
  }
  ngAfterContentInit() {
    this.updateMultiSelectOptions();
    this.watchOptGroupContent();
  }
  ngOnChanges(changes) {
    if (changes['disabled']) {
      this.updateMultiSelectOptions();
    }
  }
  updateMultiSelectOptions() {
    this.multiSelectOptions?.forEach(option => {
      option.disabled = this.disabled || option.disabled;
    });
  }
  watchOptGroupContent() {
    this.multiSelectService.optionsArray$.pipe(tap(x => {
      this.visible.set(this.multiSelectOptions?.some(option => option.visible));
    }), takeUntilDestroyed(this.#destroyRef)).subscribe();
  }
  static {
    this.ɵfac = function MultiSelectOptgroupComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MultiSelectOptgroupComponent)(i0.ɵɵdirectiveInject(MultiSelectService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MultiSelectOptgroupComponent,
      selectors: [["c-multi-select-optgroup"]],
      contentQueries: function MultiSelectOptgroupComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, MultiSelectOptionComponent, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.multiSelectOptions = _t);
        }
      },
      hostVars: 2,
      hostBindings: function MultiSelectOptgroupComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses);
        }
      },
      inputs: {
        label: "label",
        disabled: [2, "disabled", "disabled", booleanAttribute]
      },
      features: [i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c0,
      decls: 2,
      vars: 1,
      template: function MultiSelectOptgroupComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, MultiSelectOptgroupComponent_Conditional_0_Template, 2, 1, "c-multi-select-optgroup-label");
          i0.ɵɵprojection(1);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.label && ctx.visible() ? 0 : -1);
        }
      },
      dependencies: [MultiSelectOptgroupLabelComponent],
      styles: ["[_nghost-%COMP%]{display:block}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiSelectOptgroupComponent, [{
    type: Component,
    args: [{
      selector: 'c-multi-select-optgroup',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [MultiSelectOptgroupLabelComponent],
      template: "@if (label && visible()) {\n  <c-multi-select-optgroup-label>{{ label }}</c-multi-select-optgroup-label>\n}\n<ng-content />\n",
      styles: [":host{display:block}\n"]
    }]
  }], () => [{
    type: MultiSelectService
  }], {
    label: [{
      type: Input
    }],
    disabled: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    multiSelectOptions: [{
      type: ContentChildren,
      args: [MultiSelectOptionComponent, {
        descendants: true
      }]
    }],
    hostClasses: [{
      type: HostBinding,
      args: ['class']
    }]
  });
})();
class MultiSelectNativeSelectComponent {
  constructor(changeDetectorRef) {
    this.changeDetectorRef = changeDetectorRef;
    this.form = '';
    this.id = '';
  }
  static {
    this.ɵfac = function MultiSelectNativeSelectComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MultiSelectNativeSelectComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MultiSelectNativeSelectComponent,
      selectors: [["c-multi-select-native-select"]],
      inputs: {
        form: "form",
        id: "id",
        multiple: [2, "multiple", "multiple", booleanAttribute],
        name: "name",
        options: "options",
        disabled: [2, "disabled", "disabled", booleanAttribute]
      },
      decls: 3,
      vars: 4,
      consts: [["tabindex", "-1", 2, "display", "none", 3, "disabled", "id", "multiple", "name"], ["tabindex", "-1", 3, "disabled", "label", "value"]],
      template: function MultiSelectNativeSelectComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "select", 0);
          i0.ɵɵrepeaterCreate(1, MultiSelectNativeSelectComponent_For_2_Template, 1, 4, "option", 1, i0.ɵɵrepeaterTrackByIdentity);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("disabled", ctx.disabled)("id", ctx.id)("multiple", ctx.multiple)("name", ctx.name);
          i0.ɵɵadvance();
          i0.ɵɵrepeater(ctx.options);
        }
      },
      styles: ["[_nghost-%COMP%]{display:none}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiSelectNativeSelectComponent, [{
    type: Component,
    args: [{
      selector: 'c-multi-select-native-select',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: true,
      template: "<select [disabled]=\"disabled\" [id]=\"id\" [multiple]=\"multiple\" [name]=\"name\" style=\"display: none\" tabindex=\"-1\">\n  @for (option of options; track option) {\n    <option\n      [attr.selected]=\"option.selected ? '' : null\"\n      [disabled]=\"disabled\"\n      [label]=\"option.label\"\n      [value]=\"option.value\"\n      tabindex=\"-1\"\n    ></option>\n  }\n</select>\n\n",
      styles: [":host{display:none}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }], {
    form: [{
      type: Input
    }],
    id: [{
      type: Input
    }],
    multiple: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    name: [{
      type: Input
    }],
    options: [{
      type: Input
    }],
    disabled: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }]
  });
})();
class MultiSelectTagComponent {
  constructor() {
    this.#multiSelectService = inject(MultiSelectService);
    this.multiselectVisible = toSignal(this.#multiSelectService.multiSelectVisible$);
    this.disabled = true;
    this.remove = new EventEmitter();
  }
  #multiSelectService;
  get hostClasses() {
    return {
      'form-multi-select-tag': true
    };
  }
  handleRemove($event) {
    $event.stopPropagation();
    if (this.value) {
      this.remove.emit(this.value);
    }
  }
  static {
    this.ɵfac = function MultiSelectTagComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MultiSelectTagComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MultiSelectTagComponent,
      selectors: [["c-multi-select-tag"]],
      hostVars: 2,
      hostBindings: function MultiSelectTagComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses);
        }
      },
      inputs: {
        option: "option",
        disabled: "disabled",
        label: "label",
        value: "value"
      },
      outputs: {
        remove: "remove"
      },
      decls: 3,
      vars: 2,
      consts: [[1, "text-truncate"], ["aria-label", "Clear", "type", "button", 1, "form-multi-select-tag-delete", 3, "disabled"], ["aria-label", "Clear", "type", "button", 1, "form-multi-select-tag-delete", 3, "click", "disabled"]],
      template: function MultiSelectTagComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "span", 0);
          i0.ɵɵtext(1);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(2, MultiSelectTagComponent_Conditional_2_Template, 1, 1, "button", 1);
        }
        if (rf & 2) {
          let tmp_0_0;
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate((tmp_0_0 = (tmp_0_0 = ctx.label) !== null && tmp_0_0 !== undefined ? tmp_0_0 : ctx.value == null ? null : ctx.value.toString()) !== null && tmp_0_0 !== undefined ? tmp_0_0 : "???");
          i0.ɵɵadvance();
          i0.ɵɵconditional(!ctx.disabled ? 2 : -1);
        }
      },
      styles: ["[_nghost-%COMP%]   .btn-xs[_ngcontent-%COMP%]{padding-left:.125rem;padding-right:.125rem;font-size:.575rem;border-radius:.2rem}.form-multi-select-tag[_nghost-%COMP%]{-webkit-user-select:none;user-select:none;pointer-events:all;align-items:center;display:flex}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiSelectTagComponent, [{
    type: Component,
    args: [{
      selector: 'c-multi-select-tag',
      standalone: true,
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<span class=\"text-truncate\">{{ label ?? value?.toString() ?? '???' }}</span>\n@if (!disabled) {\n  <button (click)=\"handleRemove($event)\"\n          [disabled]=\"((multiselectVisible()) ?? true) === false\"\n          aria-label=\"Clear\"\n          class=\"form-multi-select-tag-delete\"\n          type=\"button\">\n  </button>\n}\n",
      styles: [":host .btn-xs{padding-left:.125rem;padding-right:.125rem;font-size:.575rem;border-radius:.2rem}:host.form-multi-select-tag{-webkit-user-select:none;user-select:none;pointer-events:all;align-items:center;display:flex}\n"]
    }]
  }], null, {
    option: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    value: [{
      type: Input
    }],
    remove: [{
      type: Output
    }],
    hostClasses: [{
      type: HostBinding,
      args: ['class']
    }]
  });
})();
class MultiSelectSearchDirective {
  constructor(elementRef, destroyRef) {
    this.elementRef = elementRef;
    this.destroyRef = destroyRef;
    this.#value$ = new BehaviorSubject('');
    this.#value = '';
    this.delay = 300;
    this.valueChange = new EventEmitter();
  }
  #value$;
  #input$;
  #value;
  set value(value) {
    this.#value$.next(value);
  }
  ngAfterViewInit() {
    this.setSubscription();
  }
  setSubscription() {
    this.#value$.pipe(distinctUntilChanged(), takeUntilDestroyed(this.destroyRef)
    // debounceTime(this.delay),
    // switchMap(value => this.#input$)
    ).subscribe(value => {
      if (this.#value !== value) {
        this.#value = value;
        this.valueChange.emit(value);
      }
    });
    this.#input$ = fromEvent(this.elementRef.nativeElement, 'input').pipe(debounceTime(this.delay), map(event => {
      return event.target.value;
    }), takeUntilDestroyed(this.destroyRef));
    this.#input$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(value => {
      if (value !== this.#value) {
        this.#value$.next(value);
      }
    });
  }
  static {
    this.ɵfac = function MultiSelectSearchDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MultiSelectSearchDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.DestroyRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MultiSelectSearchDirective,
      selectors: [["", "cMultiSelectSearch", ""]],
      inputs: {
        delay: "delay",
        value: "value"
      },
      outputs: {
        valueChange: "valueChange"
      },
      exportAs: ["cMultiSelectSearch"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiSelectSearchDirective, [{
    type: Directive,
    args: [{
      selector: '[cMultiSelectSearch]',
      exportAs: 'cMultiSelectSearch',
      standalone: true
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.DestroyRef
  }], {
    delay: [{
      type: Input
    }],
    value: [{
      type: Input
    }],
    valueChange: [{
      type: Output
    }]
  });
})();
const observeReferenceResizeModifier = {
  name: 'observeReferenceResizeModifier',
  enabled: true,
  phase: 'main',
  fn({
    state
  }) {
    /* empty */
  },
  effect: ({
    state,
    instance
  }) => {
    const RO_PROP = '__popperjsRO__';
    const {
      reference
    } = state.elements;
    let resizeObserver = new ResizeObserver(entries => {
      if (entries.find(entry => entry.target === reference)) {
        instance.update();
      }
    });
    resizeObserver.observe(reference);
    return () => {
      resizeObserver?.disconnect();
      resizeObserver = null;
    };
  }
};
const sameAsReferenceWidthModifier = {
  name: 'sameAsReferenceWidthModifier',
  enabled: true,
  fn: ({
    state
  }) => {
    state.styles['popper'].minWidth = `${state.rects.reference.width}px`;
  },
  phase: 'beforeWrite',
  requires: ['computeStyles']
};
const defaultPopperOptions = {
  strategy: 'fixed',
  modifiers: [observeReferenceResizeModifier, sameAsReferenceWidthModifier, {
    name: 'offset',
    options: {
      offset: () => [0, 4]
    }
  }]
};
class MultiSelectComponent {
  #destroyRef;
  #document;
  #i18nPlural;
  constructor(elementRef, renderer, ngZone, changeDetectorRef, viewContainerRef, focusMonitor, multiSelectService, iterableDiffers) {
    this.elementRef = elementRef;
    this.renderer = renderer;
    this.ngZone = ngZone;
    this.changeDetectorRef = changeDetectorRef;
    this.viewContainerRef = viewContainerRef;
    this.focusMonitor = focusMonitor;
    this.multiSelectService = multiSelectService;
    this.iterableDiffers = iterableDiffers;
    this.#destroyRef = inject(DestroyRef);
    this.#document = inject(DOCUMENT);
    this.#i18nPlural = inject(I18nPluralPipe);
    this.#destroy$ = new Subject();
    this.#optionsReady$ = new Subject();
    this.userOptionsArray$ = new BehaviorSubject([]);
    this.#options = new Map();
    this.optionsSelected$ = new BehaviorSubject([]);
    this.optionsSelected = new Map();
    this.value$ = new BehaviorSubject([]);
    this.#optionsContent = [];
    this.onChange = value => {
      /* empty */
    };
    this.onTouched = () => {
      /* empty */
    };
    /**
     * Allow users to create options if they are not in the list of options.
     * @type boolean
     * @default false
     * @since 4.5.11
     */
    this.allowCreateOptions = false;
    /**
     * Enables selection cleaner element
     * @type boolean
     * @default true | 'active'
     */
    this.cleaner = true;
    /**
     * Clear current search on selecting an item
     * @type boolean
     * @default false
     * @since 4.5.11
     */
    this.clearSearchOnSelect = false;
    this._disabled = false;
    this.isLoading = signal(false);
    this._multiple = false;
    /**
     * Hidden native select form
     * @type string
     * @default ''
     */
    this.nativeFormId = '';
    /**
     * Hidden native select id
     * @type string
     * @default ''
     */
    this.nativeId = '';
    /**
     * Hidden native select name
     * @type string
     * @default ''
     */
    this.nativeName = '';
    /**
     * Sets maxHeight of options list in px
     * @type string | number
     * @default 'auto'
     */
    this.optionsMaxHeight = 'auto';
    /**
     * Specifies a short hint that is visible in the search input
     * @type string
     * @default 'Select...'
     */
    this.placeholder = 'Select...';
    /**
     * Enables search input element
     * @type boolean | SearchFn | 'external'
     * @default true
     */
    this.search = true;
    /**
     * Sets the label for no results when filtering
     * @type string
     * @default 'no items'
     */
    this.searchNoResultsLabel = 'no items';
    this._searchValue = '';
    /**
     * Emits searchValue string for external filtering
     * @type string
     */
    this.searchValueChange = new EventEmitter();
    /**
     * Enables select all button
     * @type boolean
     * @default true
     */
    this.selectAll = true;
    /**
     * Sets the select all button label
     * @type string
     * @default 'Select all options'
     */
    this.selectAllLabel = 'Select all options';
    /**
     * Selection type
     * @type 'counter' | 'tags' | 'text'
     * @default 'tags'
     */
    this.selectionType = 'tags';
    /**
     * Counter selection label value
     * @type string
     * @default 'item(s) selected'
     */
    this.selectionTypeCounterText = 'item(s) selected';
    /**
     * Counter selection label plural map for I18nPluralPipe
     * @type IPluralMap
     * @default { '=1': 'item selected', 'other': 'items selected' }
     */
    this.selectionTypeCounterTextPluralMap = {
      '=1': 'item selected',
      other: 'items selected'
    };
    this.#value = signal([]);
    /**
     * Emits valueChange
     * @type TValue | TValue[]
     */
    this.valueChange = new EventEmitter();
    this._virtualScroller = false;
    this._visibleItems = 8;
    /**
     * The size of the option item in the list (in pixels).
     * @type number
     * @default 40
     */
    this.itemSize = 40;
    /**
     * Min width of the options list (in pixels).
     * @type number
     * @default 196
     */
    this.itemMinWidth = 196;
    this.minWidth = signal(this.itemMinWidth);
    this._visible = false;
    /**
     * Emits visibleChange
     * @type boolean
     */
    this.visibleChange = new EventEmitter();
    this.#popperOptions = signal(defaultPopperOptions);
    this.isDropdownVisible = false;
    this.templates = {};
    this._tabIndex = -1;
    this.visibleOptions = signal(false);
    this._subtreeFocused = this.focusOrigin(null);
    this.userOptions = this.multiSelectService.getUserOptions();
    this.activeOption = null;
    this.differ = this.iterableDiffers.find(this.#value()).create();
    this.multiSelectService.setSelectionModel(this.multiple);
    this.optionsArray$ = this.multiSelectService.getOptionsArray();
  }
  #destroy$;
  #optionsReady$;
  #options;
  #optionsContent;
  writeValue(value) {
    if (value !== undefined && value !== null) {
      this.value = Array.isArray(value) ? [...value] : [value];
    } else {
      this.value = Array(0);
    }
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
  }
  /**
   * Disables multi-select component
   * @type boolean
   * @default false
   */
  set disabled(value) {
    if (this._disabled !== value) {
      this._disabled = value;
      this.setFocusMonitor(!value);
    }
  }
  get disabled() {
    return this._disabled;
  }
  /**
   * Add loading spinner and reduced opacity.
   * @type boolean
   * @default false
   * @since 4.5.2
   */
  set loading(value) {
    this.isLoading.set(value);
  }
  /**
   * Specifies that multiple options can be selected at once
   * @type boolean
   * @default false
   */
  set multiple(value) {
    this._multiple = value;
    this.multiSelectService.setSelectionModel(this._multiple);
  }
  get multiple() {
    return this._multiple;
  }
  /**
   * List of option elements
   * @type IOption[]
   * @default []
   */
  set options(options) {
    if (Array.isArray(options)) {
      this.#options.clear();
      this.makeOptions(options);
    }
  }
  get options() {
    return [...this.#options.values()];
  }
  /**
   * Sets option style
   * @type 'checkbox' | 'text'
   * @default 'checkbox'
   */
  set optionsStyle(value) {
    this.multiSelectService.optionsStyle = value ?? 'checkbox';
  }
  /**
   * Sets initial search string
   * @type string
   * @default ''
   */
  set searchValue(value) {
    if (this._searchValue !== value.trimStart()) {
      this._searchValue = value.trimStart();
      this.visible = this.searchValue.length > 0 && this.subtreeFocused ? true : this.visible;
      this.filterOptions(this.searchValue);
      this.inputElementSize();
      this.searchValueChange.emit(this._searchValue);
    }
  }
  get searchValue() {
    return this._searchValue;
  }
  /**
   * Initial value of multi-select
   * @type (TValue | TValue[])
   */
  set value(value) {
    const newValue = Array.isArray(value) ? [...value] : [value];
    // if (this.differ) {
    const changes = this.differ?.diff(newValue);
    if (changes) {
      if (newValue.length === 0) {
        this.multiSelectService.selectionModel.clear();
      }
      this.#value.set([...newValue]);
      this.value$.next([...newValue]);
      this.onChange(this.value);
      // this.valueChange.emit(this.value);
    }
    // }
  }
  get value() {
    const value = this.multiSelectService.selectionModel?.selected ?? [...this.#value()];
    return this.multiple ? [...value] : value[0];
  }
  #value;
  /**
   * Enable virtual scroller for options list.
   * @type boolean
   * @default false
   */
  set virtualScroller(value) {
    this._virtualScroller = value;
  }
  get virtualScroller() {
    return this._virtualScroller;
  }
  /**
   * Amount of visible options, if set - overwrites optionsMaxHeight
   * @type number
   * @default 8
   */
  set visibleItems(value) {
    this._visibleItems = value > 0 ? value : 8;
    this.optionsMaxHeight = (this.itemSize * this._visibleItems + 16).toString();
  }
  get visibleItems() {
    return this._visibleItems;
  }
  /**
   * Toggle the visibility of the dropdown select component.
   * @type boolean
   * @default false
   */
  set visible(value) {
    if (value !== this._visible) {
      this._visible = value;
      setTimeout(() => {
        this.multiSelectService.toggleVisible(value);
      });
      if (!value) {
        // this.searchValue = '';
      }
    }
  }
  get visible() {
    return this._visible;
  }
  /**
   * Optional popper Options object
   * @type Partial<Options>
   */
  set popperOptions(options) {
    const prevOptions = this.#popperOptions();
    const {
      modifiers: prevModifiers = []
    } = prevOptions;
    const {
      modifiers: currModifiers = []
    } = options;
    const currOptions = {
      ...options,
      modifiers: [...prevModifiers.filter(prevModifier => !currModifiers.find(currModifier => currModifier.name === prevModifier.name)), ...currModifiers]
    };
    this.#popperOptions.set({
      ...prevOptions,
      ...currOptions
    });
  }
  get popperOptions() {
    return this.#popperOptions();
  }
  #popperOptions;
  get selectedOptions() {
    return [...this.optionsSelected.values()];
  }
  get selectedOptionsText() {
    return this.selectedOptions.map(option => option.label).join(', ');
  }
  get counterText() {
    return `${this.selectedOptions.length} ${this.selectionTypeCounterText}`;
  }
  get counterTextType() {
    return typeof (this.selectionTypeCounterTextPluralMap ?? this.selectionTypeCounterText);
  }
  get counterPlaceholderText() {
    if (this.selectedOptions.length === 0 || this.selectionType !== 'counter') {
      return null;
    }
    if (this.counterTextType === 'string') {
      return this.counterText;
    } else {
      return `${this.selectedOptions.length} ${this.#i18nPlural.transform(this.selectedOptions.length, this.selectionTypeCounterTextPluralMap ?? {
        other: this.selectionTypeCounterText ?? '+'
      })}`;
    }
  }
  get hostClasses() {
    return {
      disabled: this.disabled
    };
  }
  get multiselectClasses() {
    return {
      'form-multi-select': true,
      [`form-multi-select-${this.size}`]: !!this.size,
      show: this.visible,
      disabled: this.disabled,
      'is-valid': this.valid === true,
      'is-invalid': this.valid === false
    };
  }
  get ariaMultiSelectable() {
    return this.multiple;
  }
  get ariaExpanded() {
    return this.visible;
  }
  get tabIndex() {
    return this._tabIndex;
  }
  set tabIndex(value) {
    setTimeout(() => {
      this._tabIndex = this.disabled || this.search ? -1 : value === null ? null : 0;
    });
  }
  onKeyUp($event) {
    if (this.disabled) {
      return;
    }
    this.onTouched();
    const targetTagName = $event.target.tagName;
    if ($event.key === 'Escape') {
      this.visible = false;
      this.searchValue = '';
      this.setFocus('keyboard', 'onKeyUp');
      return;
    }
    if (['Enter', 'Space', 'ArrowDown'].includes($event.code) && [this.inputElement?.nativeElement, this.elementRef.nativeElement].includes($event.target)) {
      $event.stopPropagation();
      this.visible = true;
      if (!this.search) {
        this.setFocus('keyboard', 'onKeyUp');
      }
      return;
    }
    if (['Tab'].includes($event.key)) {
      // todo focus on input when tab in
      // if ($event.target === this.inputElement?.nativeElement) {
      //   console.log($event.key, $event.target)
      // }
      if ($event.target === this.elementRef.nativeElement) {
        this.visible = true;
        if (!this.search) {
          this.setFocus('keyboard', 'onKeyUp');
        }
        this.tabTarget = targetTagName;
        return;
      }
      if (this.visible && this.subtreeFocused) {
        if (targetTagName === 'C-MULTI-SELECT-OPTION') {
          if (this.tabTarget === 'C-MULTI-SELECT-OPTION') {
            if ($event.shiftKey && this.focusKeyManager.activeItem?.value === this.options.filter(option => option.visible && !option.disabled).slice(0)[0].value) {
              this.setFocus('keyboard', 'onKeyUp');
              this.tabTarget = targetTagName;
              return;
            }
            if (!$event.shiftKey && this.focusKeyManager.activeItem?.value === this.options.filter(option => option.visible && !option.disabled).slice(-1)[0].value) {
              this.setFocus('keyboard', 'onKeyUp');
              this.tabTarget = targetTagName;
              this.updateActiveItem(0);
              return;
            }
          }
          if (!this.focusKeyManager.activeItem || this.tabTarget !== targetTagName) {
            if (this.activeOption) {
              this.focusKeyManager.setActiveItem(this.activeOption);
            } else {
              this.setFirstItemActive();
            }
          } else {
            $event.shiftKey ? this.focusKeyManager.setPreviousItemActive() : this.focusKeyManager.setNextItemActive();
          }
        }
        this.tabTarget = targetTagName;
        return;
      }
    }
  }
  onKeyDown($event) {
    const targetTagName = $event.target.tagName;
    if ($event.key === 'Enter' && targetTagName === 'INPUT') {
      $event.preventDefault();
    }
    if ($event.key === 'Tab') {
      this.tabTarget = targetTagName;
      return;
    }
    if ($event.key === 'ArrowDown' && targetTagName !== 'C-MULTI-SELECT-OPTION') {
      $event.preventDefault();
      return;
    }
    if ($event.key === 'Escape') {
      this.visible = false;
      this.searchValue = '';
      this.setFocus('keyboard', 'onKeyDown');
      return;
    }
    if (this.disabled) {
      return;
    }
    // avoid setting focus to option while on input element
    if ($event.target === this.inputElement?.nativeElement) {
      return;
    }
    if ($event.key !== 'Tab') {
      this.focusKeyManager?.onKeydown($event);
    }
  }
  onClick($event) {
    if (this.disabled) {
      return;
    }
    if ([this.dropdown.nativeElement].includes($event.target)) {
      this.visible = !this.visible;
    } else {
      this.visible = true;
    }
    this.onTouched();
    this.setFocus('mouse', 'onClick');
  }
  get subtreeFocused() {
    return this._subtreeFocused;
  }
  set subtreeFocused(focused) {
    this._subtreeFocused = this.disabled ? false : focused;
    if (!focused) {
      this.searchValue = '';
    }
    if (!this.virtualScroller) {
      this.visible = focused === false ? false : this.visible;
    }
  }
  focusOrigin(origin) {
    if (this.disabled) {
      return false;
    }
    return !!origin;
  }
  ngOnInit() {
    this.multiSelectService.selectionModel.changed.pipe(filter(() => !this.multiple), delay(0), tap(change => {
      if (change.added.length > 0) {
        // close dropdown for single select (!multiple)
        this.visible = false;
        this.searchValue = '';
      }
    }), skip(1), tap(change => {
      this.setFocus('program', 'selectionModel.changed (single)');
    }), takeUntilDestroyed(this.#destroyRef)).subscribe();
    this.#optionsReady$.pipe(filter(() => !this.virtualScroller), delay(0), tap(() => {
      this.setFocusKeyManager([...this.multiSelectOptionsContent, ...this.multiSelectOptionsView]);
    }), takeUntilDestroyed(this.#destroyRef)).subscribe();
    this.multiSelectService.selectionModel.changed.pipe(tap(change => {
      const {
        added
      } = {
        ...change
      };
      if (added.length > 0 && this.clearSearchOnSelect) {
        this.searchValue = '';
      }
    }), takeUntilDestroyed(this.#destroyRef)).subscribe();
    this.multiSelectService.selectionModel.changed.pipe(
    // delay(0),
    combineLatestWith(this.#optionsReady$), tap(([change, ready]) => {
      const {
        removed
      } = {
        ...change
      };
      removed.forEach(value => {
        this.optionsSelected.delete(value);
      });
      this.multiSelectService.selectionModel.selected.forEach(key => {
        const value = this.#options.get(key);
        if (value) {
          this.optionsSelected.set(key, value);
        }
      });
      this.optionsSelected$.next(Array.from(this.optionsSelected.values()));
      this.value = [...this.multiSelectService.selectionModel.selected];
      this.inputElementSize();
      this.updateNativeSelect();
    }), takeUntilDestroyed(this.#destroyRef)).subscribe();
    // set initial values
    this.multiSelectService.selectionModel.select(...this.#value());
    this.value$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(value => {
      if (!value.length) {
        this.clearAllOptions();
        return;
      }
      value.forEach(value => {
        this.multiSelectService.selectionModel.select(value);
      });
    });
    this.value$.pipe(debounceTime(100), distinctUntilChanged(), tap(value => {
      this.valueChange.emit(this.value);
    }), takeUntilDestroyed(this.#destroyRef)).subscribe();
    this.multiSelectService.optionsArray$.pipe(combineLatestWith(this.userOptionsArray$), tap(([options, userOptions]) => {
      this.visibleOptions.set(options.some(item => item.visible) || userOptions.some(item => item.visible));
      this.activeOption = null;
      if (this.virtualScroller) {
        this.multiSelectOptionsContent?.forEach(option => {
          option.active = false;
        });
        this.scrollViewport?.setRenderedRange({
          start: 0,
          end: this.visibleItems
        });
        this.scrollViewport?.scrollToIndex(0);
      } else {
        this.multiSelectOptionsContent?.forEach(option => {
          const found = options.find(item => item.value === option.value);
          option.visible = found?.visible ?? false;
          option.active = false;
        });
        const firstFocusable = this.firstFocusableItem;
        if (firstFocusable) {
          this.updateActiveItem(firstFocusable);
        }
      }
      if (!this.activeOption) {
        setTimeout(() => {
          this.updateActiveItem(0);
        });
      }
      this.multiSelectOptionsContent?.notifyOnChanges();
    }), takeUntilDestroyed(this.#destroyRef)).subscribe();
    this.tabIndex = 0;
  }
  ngOnDestroy() {
    this.#destroy$.next();
    this.#destroy$.complete();
    this.setFocusMonitor(false);
  }
  ngOnChanges(changes) {
    if (changes['value']) {
      const valueChanges = changes['value'];
      if (valueChanges.currentValue.length === 0) {
        this.clearAllOptions();
      }
      this.inputElementSize();
    }
  }
  makeOptions(options) {
    if (this.search === 'external' && this.searchValue.length) {
      this.#options.forEach((option, key) => {
        option.visible = false;
      });
    }
    options.forEach(option => {
      const key = option.value;
      const value = {
        value: option.value ?? option.label,
        label: option.label ?? option.value?.toString(),
        disabled: option.disabled === true,
        visible: this.search === 'external' ? true : option.custom && option.selected ? option.visible : option.visible !== false,
        text: option.text ?? option.label ?? option.value?.toString(),
        selected: option.selected,
        custom: option.custom
        // selected: this.multiSelectService.selectionModel.isSelected(option.value),
        // id: option.id
      };
      this.#options.set(key, {
        ...value
      });
    });
    this.filterOptions(this.searchValue);
    this.multiSelectOptionsContent?.notifyOnChanges();
    this.multiSelectOptionsView?.notifyOnChanges();
    this.#optionsReady$.next();
  }
  // #effectUserOptions = effect(() => {
  //   if (this.allowCreateOptions) {
  //     this.userOptionsArray$.next(Array.from(this.userOptions().filter(option => option.visible)));
  //   }
  // });
  addUserOption() {
    if (this.allowCreateOptions) {
      if (this.userOptions().some(option => option.value === this.searchValue)) {
        return;
      }
      if (this.#options.get(this.searchValue)) {
        return;
      }
      const userOption = {
        value: this.searchValue,
        label: this.searchValue,
        text: this.searchValue,
        visible: true,
        custom: true,
        selected: true
      };
      this.searchValue = this.clearSearchOnSelect || this.allowCreateOptions ? '' : this.searchValue;
      this.multiSelectService.addUserOption(userOption);
      this.multiSelectService.selectionModel.select(userOption.value);
      this.optionsSelected.set(userOption.value, userOption);
      this.makeOptions([...this.options, ...this.userOptions()]);
    }
  }
  removeAllUserOptions() {
    this.multiSelectService.removeAllUserOptions();
  }
  ngAfterViewInit() {
    this.setVirtualScroller();
    this.multiSelectOptionsContent?.changes.pipe(delay(0), distinctUntilChanged((previous, current) => {
      const prev = previous.toArray().map(option => option.value);
      const curr = current.toArray().map(option => option.value);
      if (this.virtualScroller) {
        return JSON.stringify(prev) === JSON.stringify(curr);
      }
      return JSON.stringify(this.#optionsContent) === JSON.stringify(curr);
    }), tap(changes => {
      this.#optionsContent = changes.toArray().map(option => option.value);
    }), takeUntilDestroyed(this.#destroyRef)).subscribe(next => {
      this.visibleOptions.set(this.multiSelectOptionsContent?.some(option => option.visible));
      if (this.visibleOptions()) {
        if (!this.virtualScroller) {
          this.#options.clear();
        }
        this.makeOptions(this.multiSelectOptionsContent.toArray());
      }
    });
    this.visibleOptions.set(this.multiSelectOptionsContent?.length > 0 || this.multiSelectOptionsView?.length > 0);
    if (this.visibleOptions()) {
      this.multiSelectOptionsContent.notifyOnChanges();
    }
    this.multiselectSubscribe();
    this.setFocusMonitor(!this.disabled);
    this.setListKeyManager();
    this.inputElementSize();
    this.multiSelectOptionsContent.notifyOnChanges();
    setTimeout(() => {
      this.createNativeSelect();
    });
    this.multiSelectService.multiSelectFocus$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(option => {
      if (this.activeOption && this.activeOption.value !== option.value) {
        this.focusKeyManager.setActiveItem(option);
      }
    });
  }
  multiselectSubscribe(subscribe = true) {
    this.multiSelectService.multiSelectVisible$.pipe(debounceTime(100), distinctUntilChanged(), takeUntilDestroyed(this.#destroyRef)).subscribe(visible => {
      if (this.isDropdownVisible !== visible) {
        this.isDropdownVisible = visible;
        this.visibleChange.emit(visible);
        if (!visible) {
          /* empty */
        } else {
          if (this.virtualScroller) {
            {
              const dropdownMinWidth = parseInt(this.dropdownMenu.nativeElement.style.minWidth, 10);
              this.minWidth.set(this.itemMinWidth > dropdownMinWidth ? this.itemMinWidth : dropdownMinWidth);
            }
            this.scrollViewport?.setRenderedRange({
              start: 0,
              end: this.visibleItems
            });
            this.scrollViewport?.scrollToIndex(0);
          }
        }
        this.multiSelectOptionsContent.notifyOnChanges();
      }
      this.updateActiveItem(0);
    });
  }
  clearAllOptions($event) {
    setTimeout(() => {
      const enabledOptions = Array.from(this.optionsSelected.values()).filter(option => !option.disabled).map(option => option.value);
      this.multiSelectService.selectionModel.deselect(...enabledOptions);
      this.removeAllUserOptions();
      this.searchValue = '';
      if ($event) {
        this.setFocus('program', 'clearAllOptions');
      }
    });
  }
  selectAllOptions() {
    const enabledOptions = Array.from(this.#options.values()).filter(option => option.visible && !option.disabled).map(option => option.value);
    this.multiSelectService.selectionModel.select(...enabledOptions);
    this.inputElementSize();
  }
  handleTagRemove(value) {
    this.multiSelectService.selectionModel.deselect(value);
    this.setFocus('program', 'handleTagRemove');
  }
  setFocus(origin = 'program', methodName) {
    if (this.disabled) {
      return;
    }
    const element = this.inputElement?.nativeElement ?? this.elementRef.nativeElement;
    const preventScroll = origin === 'program';
    this.focusMonitor?.focusVia(element, origin, {
      preventScroll: preventScroll
    });
    // console.log('setFocus', origin, methodName, 'preventScroll:', preventScroll, element.tagName, this.value);
  }
  filterOptions(value) {
    const searchString = value.toLowerCase() ?? '';
    this.#options.forEach((item, index) => {
      if (searchString === '') {
        item.visible = true;
        return;
      }
      if (typeof this.search === 'function') {
        item.visible = this.search(item, searchString);
        return;
      }
      if (this.search === 'external' && !item.custom || !searchString) {
        // item.visible = true;
        return;
      }
      item.visible = item.label?.toLowerCase().includes(searchString) ?? true;
    });
    this.multiSelectService.updateOptionsArray(Array.from(this.#options.values()).filter(item => item.visible));
    this.userOptionsArray$.next(Array.from(this.#options.values()).filter(item => item.custom));
  }
  createNativeSelect() {
    if (!this.nativeId) {
      return;
    }
    this.viewContainerRef.clear();
    this.nativeSelectRef = this.viewContainerRef.createComponent(MultiSelectNativeSelectComponent);
    this.updateNativeSelect();
  }
  updateNativeSelect() {
    if (!this.nativeSelectRef || !this.nativeId) {
      return;
    }
    const options = Array.from(this.optionsSelected).map(item => {
      const {
        selected,
        value,
        label
      } = item[1];
      return {
        selected,
        value,
        label
      };
    });
    this.nativeSelectRef.setInput('multiple', this.multiple);
    this.nativeSelectRef.setInput('form', this.nativeFormId);
    this.nativeSelectRef.setInput('id', this.nativeId);
    this.nativeSelectRef.setInput('name', this.nativeName);
    this.nativeSelectRef.setInput('options', [...options]);
    this.nativeSelectRef.setInput('disabled', this.disabled);
    this.nativeSelectRef.instance.changeDetectorRef.markForCheck();
  }
  inputElementSize() {
    if (this.inputElement) {
      if (!this.inputElement?.nativeElement?.disabled) {
        this.renderer.setAttribute(this.inputElement?.nativeElement, 'size', (this.searchValue.length + 2).toString());
      } else {
        // this.renderer.removeAttribute(this.inputElement?.nativeElement, 'size');
        this.renderer.setAttribute(this.inputElement?.nativeElement, 'size', '2');
      }
    }
  }
  handleSearchKeyDown($event) {
    if (['Enter'].includes($event.key) && this.searchValue.length && this.allowCreateOptions) {
      $event.preventDefault();
      $event.stopPropagation();
      $event.stopImmediatePropagation();
      this.addUserOption();
      this.changeDetectorRef.markForCheck();
      return;
    }
    if (this.searchValue.length || this.optionsSelected.size === 0) {
      return;
    }
    if (['Backspace', 'Delete'].includes($event.key)) {
      $event.stopPropagation();
      const last = this.selectedOptions.filter(option => !option.disabled).pop();
      if (last) {
        this.multiSelectService.selectionModel.deselect(last.value);
      }
    }
  }
  setFocusMonitor(monitor) {
    if (monitor && !this.disabled) {
      // todo focus on input when tab in
      // this.focusMonitor?.monitor(this.elementRef, false)
      //   .pipe(
      //     tap(origin => {
      //       if (origin === 'keyboard' && this.search && this.selectedOptions.length) {
      //         this.inputElement.nativeElement.focus();
      //       }
      //     }),
      //     takeUntilDestroyed(this.#destroyRef)
      //   )
      //   .subscribe();
      this.focusMonitorSubscription = this.focusMonitor?.monitor(this.elementRef, true).pipe(
      // to avoid focus lost on speed scrolling with virtualScroll
      debounceTime(100), takeUntilDestroyed(this.#destroyRef)).subscribe(origin => {
        this.ngZone.run(() => {
          this.subtreeFocused = this.focusOrigin(origin);
          this.changeDetectorRef?.markForCheck();
        });
      });
    } else {
      this.focusMonitor?.stopMonitoring(this.elementRef);
      this.focusMonitorSubscription?.unsubscribe();
    }
  }
  handleScrolledIndexChange(scrolledIndex, scrollViewport) {
    if (!this.scrollViewport) {
      this.scrollViewport = scrollViewport;
    }
    const availableOptions = this.options.filter(option => option.visible);
    const firstVisibleOption = availableOptions[scrolledIndex];
    const activeOptionIndex = availableOptions.findIndex(option => option.value === this.activeOption?.value);
    const optionsArray = this.multiSelectOptionsContent.toArray();
    if (scrolledIndex > activeOptionIndex) {
      const firstVisibleItem = optionsArray.find(option => option.value === firstVisibleOption?.value);
      if (firstVisibleItem && scrolledIndex) {
        this.focusKeyManager.setActiveItem(firstVisibleItem);
      }
      return;
    }
    if (scrolledIndex + this.visibleItems - 2 <= activeOptionIndex) {
      const lastVisibleItem = optionsArray.findIndex(option => option.value === firstVisibleOption.value);
      if (lastVisibleItem > -1) {
        this.focusKeyManager.setActiveItem(lastVisibleItem + this.visibleItems - 2);
      }
      return;
    }
  }
  trackByFn(index, option) {
    return option.value;
  }
  handleSearchValueChange(searchValue) {
    this.searchValue = searchValue;
    if (!searchValue) {
      this.scrollViewport?.scrollToIndex(0);
      this.multiSelectOptionsContent.notifyOnChanges();
      if (this.subtreeFocused) {
        this.setFocus('program', 'handleSearchValueChange');
      }
    }
  }
  setVirtualScroller() {
    if (!this.virtualScroller) {
      return;
    }
    // multiSelectOptionTemplate for virtualScroller
    this.contentTemplates.forEach(child => {
      this.templates[child.id] = child.templateRef;
    });
    // if no template found, get defaultMultiSelectOptionTemplate from view
    if (!this.templates['multiSelectOptionTemplate']) {
      this.multiSelectOptionsContent = this.multiSelectOptionsView;
      this.multiSelectOptionsContent.notifyOnChanges();
    }
    // multiSelectOptionsContent gets out of order on changes
    // do sort() and reset()
    const indexOfOption = option => {
      return [...option.elementRef.nativeElement.parentElement.children]?.indexOf(option.elementRef.nativeElement);
    };
    const optionsChange$ = this.multiSelectOptionsContent.changes;
    const sortedOptions$ = optionsChange$.pipe(map(options => options.toArray()), filter(options => options.length > 0), map(options => options.sort((a, b) => indexOfOption(a) - indexOfOption(b))), takeUntilDestroyed(this.#destroyRef));
    sortedOptions$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(sortedOptions => {
      return this.multiSelectOptionsContent.reset(sortedOptions);
    });
    this.scrollViewportView.changes.pipe(take(1), map(changes => changes.toArray()[0]), tap(scrollViewport => {
      if (!this.scrollViewport) {
        this.scrollViewport = scrollViewport;
        const cdkVirtualScrollContentWrapper = this.scrollViewport.getElementRef().nativeElement?.firstElementChild;
        if (cdkVirtualScrollContentWrapper) {
          const style = this.#document.defaultView?.getComputedStyle(cdkVirtualScrollContentWrapper, null) ?? undefined;
          const padding = parseInt(style?.getPropertyValue('padding-left') ?? '12px') * 3;
          const observer = new MutationObserver(mutationRecords => {
            mutationRecords.forEach(child => {
              child.addedNodes.forEach(node => {
                if (node.nodeName === 'C-MULTI-SELECT-OPTION') {
                  const width = node.offsetWidth;
                  if (width > this.itemMinWidth) {
                    this.itemMinWidth = width + padding;
                  }
                }
              });
            });
          });
          observer?.observe(cdkVirtualScrollContentWrapper, {
            childList: true
          });
          this.#destroy$.subscribe(() => {
            observer?.disconnect();
          });
        }
      }
    }), takeUntilDestroyed(this.#destroyRef)).subscribe();
  }
  setListKeyManager() {
    // run once on multiSelectOptionsContent first set
    this.multiSelectOptionsContent.changes.pipe(filter(changes => this.virtualScroller), take(1), tap(() => {
      this.setFocusKeyManager(this.multiSelectOptionsContent);
    }), takeUntilDestroyed(this.#destroyRef)).subscribe();
  }
  setFocusKeyManager(focusableOptions) {
    // this.focusKeyManager?.destroy();
    this.focusKeyManager = new FocusKeyManager(focusableOptions).withHomeAndEnd().withPageUpDown().skipPredicate(option => option.disabled || !option.visible);
    if (!this._virtualScroller) {
      this.focusKeyManager.withTypeAhead(300);
    }
    this.focusKeyManager.tabOut.pipe(takeUntilDestroyed(this.#destroyRef), tap(() => {
      /* empty */
    })).subscribe();
    this.focusKeyManager.change.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(change => {
      if (change < 0) {
        this.activeOption ? this.focusKeyManager.setActiveItem(this.activeOption) : this.setFirstItemActive();
      }
      if (this.focusKeyManager.activeItem) {
        this.focusKeyManager.activeItem.active = true;
      }
      this.activeOption = this.focusKeyManager.activeItem;
      const option = this.activeOption;
      this.multiSelectService.focusChange(option);
      this.multiSelectOptionsContent.notifyOnChanges();
      this.multiSelectOptionsView.notifyOnChanges();
    });
    // if (!this.focusKeyManager.activeItem) {
    //   this.setFirstItemActive();
    // }
  }
  get firstFocusableItem() {
    return this.multiSelectOptionsContent?.find(option => option.visible && !option.disabled) ?? this.multiSelectOptionsView?.find(option => option.visible && !option.disabled);
  }
  setFirstItemActive() {
    const firstFocusableItem = this.firstFocusableItem;
    firstFocusableItem ? this.focusKeyManager?.setActiveItem(firstFocusableItem) : this.focusKeyManager?.setFirstItemActive();
    this.activeOption = this.focusKeyManager?.activeItem ?? null;
  }
  updateActiveItem(item) {
    const firstFocusableItem = this.firstFocusableItem ?? item;
    firstFocusableItem ? this.focusKeyManager?.updateActiveItem(firstFocusableItem) : this.focusKeyManager?.updateActiveItem(0);
    if (this.focusKeyManager?.activeItem) {
      this.multiSelectOptionsContent?.forEach(option => {
        option.active = false;
      });
      this.multiSelectOptionsView?.forEach(option => {
        option.active = false;
      });
      this.focusKeyManager.activeItem.active = true;
    }
    this.activeOption = this.focusKeyManager?.activeItem ?? null;
  }
  handleIndicatorClick($event) {
    $event.preventDefault();
    $event.stopPropagation();
    this.visible = !this.visible;
  }
  static {
    this.ɵfac = function MultiSelectComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MultiSelectComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i1$1.FocusMonitor), i0.ɵɵdirectiveInject(MultiSelectService), i0.ɵɵdirectiveInject(i0.IterableDiffers));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MultiSelectComponent,
      selectors: [["c-multi-select"]],
      contentQueries: function MultiSelectComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, MultiSelectOptionComponent, 5);
          i0.ɵɵcontentQuery(dirIndex, TemplateIdDirective, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.multiSelectOptionsContent = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentTemplates = _t);
        }
      },
      viewQuery: function MultiSelectComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c21, 5);
          i0.ɵɵviewQuery(_c22, 5);
          i0.ɵɵviewQuery(DropdownMenuDirective, 5, ElementRef);
          i0.ɵɵviewQuery(DropdownComponent, 5, ElementRef);
          i0.ɵɵviewQuery(DropdownToggleDirective, 5, ElementRef);
          i0.ɵɵviewQuery(MultiSelectOptionComponent, 5);
          i0.ɵɵviewQuery(_c23, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.optionsElementRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdownMenu = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdown = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdownToggle = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.multiSelectOptionsView = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.scrollViewportView = _t);
        }
      },
      hostVars: 5,
      hostBindings: function MultiSelectComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keyup", function MultiSelectComponent_keyup_HostBindingHandler($event) {
            return ctx.onKeyUp($event);
          })("keydown", function MultiSelectComponent_keydown_HostBindingHandler($event) {
            return ctx.onKeyDown($event);
          })("click", function MultiSelectComponent_click_HostBindingHandler($event) {
            return ctx.onClick($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("aria-multiselectable", ctx.ariaMultiSelectable)("aria-expanded", ctx.ariaExpanded)("tabindex", ctx.tabIndex);
          i0.ɵɵclassMap(ctx.hostClasses);
        }
      },
      inputs: {
        allowCreateOptions: [2, "allowCreateOptions", "allowCreateOptions", booleanAttribute],
        cleaner: "cleaner",
        clearSearchOnSelect: [2, "clearSearchOnSelect", "clearSearchOnSelect", booleanAttribute],
        disabled: [2, "disabled", "disabled", booleanAttribute],
        loading: [2, "loading", "loading", booleanAttribute],
        multiple: [2, "multiple", "multiple", booleanAttribute],
        nativeFormId: "nativeFormId",
        nativeId: "nativeId",
        nativeName: "nativeName",
        options: "options",
        optionsMaxHeight: "optionsMaxHeight",
        optionsStyle: "optionsStyle",
        placeholder: "placeholder",
        search: "search",
        searchNoResultsLabel: "searchNoResultsLabel",
        searchValue: "searchValue",
        selectAll: "selectAll",
        selectAllLabel: "selectAllLabel",
        selectionType: "selectionType",
        selectionTypeCounterText: "selectionTypeCounterText",
        selectionTypeCounterTextPluralMap: "selectionTypeCounterTextPluralMap",
        size: "size",
        value: "value",
        valid: "valid",
        virtualScroller: [2, "virtualScroller", "virtualScroller", booleanAttribute],
        visibleItems: [2, "visibleItems", "visibleItems", numberAttribute],
        itemSize: "itemSize",
        itemMinWidth: "itemMinWidth",
        visible: [2, "visible", "visible", booleanAttribute],
        popperOptions: "popperOptions"
      },
      outputs: {
        searchValueChange: "searchValueChange",
        valueChange: "valueChange",
        visibleChange: "visibleChange"
      },
      exportAs: ["cMultiSelect"],
      features: [i0.ɵɵProvidersFeature([I18nPluralPipe, MultiSelectService, {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => MultiSelectComponent),
        multi: true
      }]), i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c0,
      decls: 21,
      vars: 15,
      consts: [["dropdown", "cDropdown"], ["dropdownToggle", "cDropdownToggle"], ["multiselectVirtualScroller", ""], ["multiselectOptionsDiv", ""], ["defaultMultiSelectOptionTemplate", ""], ["userOptionsTemplate", ""], ["inputElement", ""], ["dropdownMenu", "cDropdownMenu"], ["scrollViewport", ""], ["cdkVirtualFor", ""], [3, "visibleChange", "visible", "autoClose", "ngClass", "popperOptions"], ["cDropdownToggle", "", "role", "button", 1, "form-multi-select-input-group", 3, "caret", "disabled"], [3, "ngClass"], [1, "text-placeholder", "text-truncate"], ["autocomplete", "off", "cMultiSelectSearch", "", "size", "2", "type", "text", 3, "disabled", "ngClass", "ngModel", "value", "tabindex"], [1, "form-multi-select-buttons"], ["aria-label", "Clear all", "type", "button", 1, "form-multi-select-cleaner", 3, "disabled"], ["type", "button", 1, "form-multi-select-indicator", 3, "click", "disabled"], ["cDropdownMenu", "", "role", "menu", 1, "form-multi-select-dropdown", 3, "visible"], ["tabindex", "-1", 1, "form-multi-select-tag", "text-truncate", 3, "disabled", "label", "option", "value"], ["tabindex", "-1", 1, "form-multi-select-tag", "text-truncate", 3, "remove", "disabled", "label", "option", "value"], [1, "form-multi-select-text", "text-truncate"], ["autocomplete", "off", "cMultiSelectSearch", "", "size", "2", "type", "text", 3, "keydown", "valueChange", "disabled", "ngClass", "ngModel", "value", "tabindex"], ["aria-label", "Clear all", "type", "button", 1, "form-multi-select-cleaner", 3, "click", "disabled"], [1, "form-multi-select-options-empty"], [3, "ngStyle"], ["type", "button", "tabindex", "0", 1, "form-multi-select-all"], ["type", "button", "tabindex", "0", 1, "form-multi-select-all", 3, "click"], [4, "ngTemplateOutlet"], ["tabindex", "-1", 1, "form-multi-select-options", 3, "itemSize", "ngStyle", "maxBufferPx", "minBufferPx"], ["tabindex", "-1", 1, "form-multi-select-options", 3, "scrolledIndexChange", "itemSize", "ngStyle", "maxBufferPx", "minBufferPx"], [3, "ngTemplateOutletContext", "ngTemplateOutlet", 4, "cdkVirtualFor", "cdkVirtualForOf", "cdkVirtualForTrackBy", "cdkVirtualForTemplateCacheSize"], [3, "ngTemplateOutletContext", "ngTemplateOutlet"], [3, "ngClass", "ngStyle"], [3, "ngTemplateOutlet"], [3, "disabled", "label", "text", "value", "visible"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"]],
      template: function MultiSelectComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "c-dropdown", 10, 0);
          i0.ɵɵtwoWayListener("visibleChange", function MultiSelectComponent_Template_c_dropdown_visibleChange_0_listener($event) {
            i0.ɵɵrestoreView(_r1);
            i0.ɵɵtwoWayBindingSet(ctx.visible, $event) || (ctx.visible = $event);
            return i0.ɵɵresetView($event);
          });
          i0.ɵɵelementStart(2, "div", 11, 1)(4, "span", 12);
          i0.ɵɵtemplate(5, MultiSelectComponent_Conditional_5_Template, 2, 3)(6, MultiSelectComponent_Conditional_6_Template, 2, 0)(7, MultiSelectComponent_Conditional_7_Template, 2, 1, "span", 13)(8, MultiSelectComponent_Conditional_8_Template, 2, 8, "input", 14);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(9, "div", 15);
          i0.ɵɵtemplate(10, MultiSelectComponent_Conditional_10_Template, 1, 1, "button", 16);
          i0.ɵɵelementStart(11, "button", 17);
          i0.ɵɵlistener("click", function MultiSelectComponent_Template_button_click_11_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.handleIndicatorClick($event));
          });
          i0.ɵɵelementEnd()()();
          i0.ɵɵtemplate(12, MultiSelectComponent_Conditional_12_Template, 6, 4, "div", 18);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(13, MultiSelectComponent_ng_template_13_Template, 3, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(15, MultiSelectComponent_ng_template_15_Template, 3, 8, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(17, MultiSelectComponent_ng_template_17_Template, 2, 6, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(19, MultiSelectComponent_ng_template_19_Template, 3, 2, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵtwoWayProperty("visible", ctx.visible);
          i0.ɵɵproperty("autoClose", "outside")("ngClass", ctx.multiselectClasses)("popperOptions", ctx.popperOptions);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("caret", false)("disabled", ctx.disabled);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c24, ctx.selectionType === "tags" && ctx.selectedOptions.length));
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.selectionType === "tags" ? 5 : ctx.selectionType === "text" && !!ctx.selectedOptions.length ? 6 : -1);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(!ctx.search ? 7 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.search ? 8 : -1);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(!!ctx.cleaner && ctx.optionsSelected.size > 0 && !ctx.disabled ? 10 : -1);
          i0.ɵɵadvance();
          i0.ɵɵproperty("disabled", ctx.disabled);
          i0.ɵɵadvance();
          i0.ɵɵconditional(!ctx.disabled ? 12 : -1);
        }
      },
      dependencies: [AsyncPipe, NgClass, NgStyle, NgTemplateOutlet, FormsModule, i1$2.DefaultValueAccessor, i1$2.NgControlStatus, i1$2.NgModel, MultiSelectTagComponent, MultiSelectOptionComponent, MultiSelectSearchDirective, DropdownComponent, DropdownMenuDirective, DropdownToggleDirective, ElementCoverComponent],
      styles: ["[_nghost-%COMP%]{display:block}[_nghost-%COMP%]:focus-visible{outline:none}.cdk-focused[_nghost-%COMP%]:not(.disabled)   .form-multi-select[_ngcontent-%COMP%]{outline:none;box-shadow:0 0 0 var(--cui-focus-ring-width) var(--cui-focus-ring-color);border-radius:var(--cui-border-radius, .375rem)}[_nghost-%COMP%]:not(.cdk-focused)   .form-multi-select[_ngcontent-%COMP%]:not(.show)   input.form-multi-select-search[_ngcontent-%COMP%]:not([placeholder]){display:none}[_nghost-%COMP%]   .form-multi-select[_ngcontent-%COMP%]   .form-multi-select-selection[_ngcontent-%COMP%]{display:flex;flex:1 1 auto;flex-wrap:wrap}[_nghost-%COMP%]   .form-multi-select[_ngcontent-%COMP%]   .form-multi-select-selection[_ngcontent-%COMP%]   .text-placeholder[_ngcontent-%COMP%], [_nghost-%COMP%]   .form-multi-select[_ngcontent-%COMP%]   .form-multi-select-selection[_ngcontent-%COMP%]   .form-multi-select-search[_ngcontent-%COMP%]::placeholder{color:var(--cui-form-multi-select-color);opacity:.8}[_nghost-%COMP%]   .form-multi-select[_ngcontent-%COMP%]   .form-multi-select-search[size][_ngcontent-%COMP%]{display:flex}[_nghost-%COMP%]     .cdk-virtual-scroll-content-wrapper{padding:var(--cui-form-multi-select-options-padding-y) var(--cui-form-multi-select-options-padding-x);font-size:1rem;color:var(--cui-form-multi-select-options-color)}[_nghost-%COMP%]   .cdk-virtual-scroll-viewport[_ngcontent-%COMP%]{width:var(--cui-dropdown-min-width)}[_nghost-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]{--cui-dropdown-padding-y: 0}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadataAsync(MultiSelectComponent, () => [import('@angular/cdk/scrolling').then(m => m.CdkFixedSizeVirtualScroll), import('@angular/cdk/scrolling').then(m => m.CdkVirtualScrollViewport), import('@angular/cdk/scrolling').then(m => m.CdkVirtualForOf)], (CdkFixedSizeVirtualScroll, CdkVirtualScrollViewport, CdkVirtualForOf) => {
    i0.ɵsetClassMetadata(MultiSelectComponent, [{
      type: Component,
      args: [{
        selector: 'c-multi-select',
        exportAs: 'cMultiSelect',
        providers: [I18nPluralPipe, MultiSelectService, {
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => MultiSelectComponent),
          multi: true
        }],
        imports: [AsyncPipe, NgClass, NgStyle, NgTemplateOutlet, CdkFixedSizeVirtualScroll, CdkVirtualScrollViewport, CdkVirtualForOf, FormsModule, MultiSelectTagComponent, MultiSelectOptionComponent, MultiSelectSearchDirective, DropdownComponent, DropdownMenuDirective, DropdownToggleDirective, ElementCoverComponent],
        template: "<c-dropdown #dropdown=\"cDropdown\"\n            [(visible)]=\"visible\"\n            [autoClose]=\"'outside'\"\n            [ngClass]=\"multiselectClasses\"\n            [popperOptions]=\"popperOptions\">\n  <div #dropdownToggle=\"cDropdownToggle\" [caret]=\"false\" [disabled]=\"disabled\" cDropdownToggle role=\"button\"\n       class=\"form-multi-select-input-group\">\n    <span\n      [ngClass]=\"{'form-multi-select-selection': true, 'form-multi-select-selection-tags': (selectionType === 'tags' && selectedOptions.length)}\">\n      @if (selectionType === 'tags') {\n        @if (optionsSelected$ | async; as optionTags) {\n          @for (option of optionTags; track option.value; let i = $index) {\n            <c-multi-select-tag\n              (remove)=\"handleTagRemove($event)\"\n              [disabled]=\"option.disabled ?? false\"\n              [label]=\"option.label ?? option.value?.toString()\"\n              [option]=\"option\"\n              [value]=\"option.value\"\n              class=\"form-multi-select-tag text-truncate\"\n              tabindex=\"-1\"\n            />\n          }\n        }\n      } @else if (selectionType === 'text' && !!selectedOptions.length) {\n        @for (option of selectedOptions; track option.value; let i = $index, last = $last) {\n          <span class=\"form-multi-select-text text-truncate\">{{ option.label }}{{ last ? '&nbsp;' : ',&nbsp;' }}</span>\n        }\n      }\n      @if (!search) {\n        <span class=\"text-placeholder text-truncate\">\n          {{ optionsSelected.size === 0 ? placeholder : counterPlaceholderText }}\n        </span>\n      }\n      @if (search) {\n        <input\n          #inputElement\n          (keydown)=\"handleSearchKeyDown($event)\"\n          (valueChange)=\"handleSearchValueChange($event)\"\n          [attr.placeholder]=\"selectedOptions.length === 0 ? placeholder : counterPlaceholderText\"\n          [disabled]=\"disabled || !search\"\n          [ngClass]=\"{ 'form-multi-select-search': true, disabled: (disabled || !search), 'text-truncate': true }\"\n          [ngModel]=\"searchValue\"\n          [value]=\"searchValue\"\n          autocomplete=\"off\"\n          cMultiSelectSearch\n          size=\"2\"\n          tabindex=\"{{ disabled ? -1 : 0 }}\"\n          type=\"text\"\n        >\n      }\n    </span>\n    <div class=\"form-multi-select-buttons\">\n      @if (!!cleaner && optionsSelected.size > 0 && !disabled) {\n        <button\n          (click)=\"clearAllOptions($event)\"\n          [disabled]=\"disabled || (!isDropdownVisible && cleaner !== 'active')\"\n          aria-label=\"Clear all\"\n          class=\"form-multi-select-cleaner\"\n          type=\"button\"\n        ></button>\n      }\n      <button (click)=\"handleIndicatorClick($event)\"\n              [disabled]=\"disabled\"\n              class=\"form-multi-select-indicator\"\n              type=\"button\">\n      </button>\n    </div>\n  </div>\n  @if (!disabled) {\n    <div #dropdownMenu=\"cDropdownMenu\" [visible]=\"dropdown.visible()\" cDropdownMenu\n         class=\"form-multi-select-dropdown\" role=\"menu\">\n      @if (visibleOptions() && options.length > 0) {\n        @if (selectAll && multiple && !virtualScroller) {\n          <button\n            (click)=\"selectAllOptions()\"\n            class=\"form-multi-select-all\"\n            type=\"button\"\n            tabindex=\"0\"\n          >\n            {{ selectAllLabel }}\n          </button>\n        }\n      }\n      @if ((visibleOptions() && options.length > 0) || isLoading()) {\n        <ng-container *ngTemplateOutlet=\"virtualScroller ? multiselectVirtualScroller : multiselectOptionsDiv\" />\n      } @else {\n        <div class=\"form-multi-select-options-empty\">{{ searchNoResultsLabel }}</div>\n      }\n      @if (isLoading()) {\n        <c-element-cover [ngStyle]=\"{'border-radius': '6px', 'z-index': 2}\" />\n      }\n    </div>\n  }\n</c-dropdown>\n\n<ng-template #multiselectVirtualScroller>\n  @defer (on immediate) {\n    @if ((optionsArray$ | async); as optionsArray) {\n      <cdk-virtual-scroll-viewport\n        #scrollViewport\n        (scrolledIndexChange)=\"handleScrolledIndexChange($event, scrollViewport)\"\n        [itemSize]=\"itemSize\"\n        [ngStyle]=\"optionsMaxHeight !== 'auto' ? { 'height.px': optionsMaxHeight, 'maxHeight.px': optionsMaxHeight, 'minWidth.px': minWidth(), overflowX: 'hidden' } : { 'minWidth.px': minWidth(), overflowX: 'hidden'}\"\n        maxBufferPx=\"{{itemSize * visibleItems}}\"\n        minBufferPx=\"{{itemSize * visibleItems}}\"\n        class=\"form-multi-select-options\"\n        tabindex=\"-1\"\n      >\n        <ng-container\n          #cdkVirtualFor\n          *cdkVirtualFor=\"let option of optionsArray; trackBy: trackByFn; templateCacheSize: 0; even as even; odd as odd; index as index; count as count; first as first; last as last;\"\n          [ngTemplateOutletContext]=\"{$implicit: option, even, odd, index, count, first, last}\"\n          [ngTemplateOutlet]=\"templates['multiSelectOptionTemplate'] || defaultMultiSelectOptionTemplate\"\n        />\n      </cdk-virtual-scroll-viewport>\n    }\n  }\n</ng-template>\n\n<ng-template #multiselectOptionsDiv>\n  <div\n    [ngClass]=\"{'form-multi-select-options': visibleOptions()}\"\n    [ngStyle]=\"optionsMaxHeight !== 'auto' ? { 'maxHeight.px': optionsMaxHeight, overflowY: 'scroll' } : {}\"\n  >\n    <ng-content />\n    <ng-container [ngTemplateOutlet]=\"userOptionsTemplate\" />\n  </div>\n</ng-template>\n\n<ng-template #defaultMultiSelectOptionTemplate let-option>\n  <c-multi-select-option\n    [disabled]=\"option.disabled\"\n    [label]=\"option.label\"\n    [text]=\"option.text\"\n    [value]=\"option.value\"\n    [visible]=\"option.visible\"\n  >\n    {{ option.text }}\n  </c-multi-select-option>\n</ng-template>\n\n<ng-template #userOptionsTemplate>\n  @for (option of userOptionsArray$ | async; track option; let even = $even, odd = $odd, index = $index, count = $count, first = $first, last = $last) {\n    <ng-container\n      [ngTemplateOutlet]=\"templates['multiSelectOptionTemplate'] || defaultMultiSelectOptionTemplate\"\n      [ngTemplateOutletContext]=\"{$implicit: option, even, odd, index, count, first, last}\"\n    />\n  }\n</ng-template>\n",
        styles: [":host{display:block}:host:focus-visible{outline:none}:host.cdk-focused:not(.disabled) .form-multi-select{outline:none;box-shadow:0 0 0 var(--cui-focus-ring-width) var(--cui-focus-ring-color);border-radius:var(--cui-border-radius, .375rem)}:host:not(.cdk-focused) .form-multi-select:not(.show) input.form-multi-select-search:not([placeholder]){display:none}:host .form-multi-select .form-multi-select-selection{display:flex;flex:1 1 auto;flex-wrap:wrap}:host .form-multi-select .form-multi-select-selection .text-placeholder,:host .form-multi-select .form-multi-select-selection .form-multi-select-search::placeholder{color:var(--cui-form-multi-select-color);opacity:.8}:host .form-multi-select .form-multi-select-search[size]{display:flex}:host ::ng-deep .cdk-virtual-scroll-content-wrapper{padding:var(--cui-form-multi-select-options-padding-y) var(--cui-form-multi-select-options-padding-x);font-size:1rem;color:var(--cui-form-multi-select-options-color)}:host .cdk-virtual-scroll-viewport{width:var(--cui-dropdown-min-width)}:host .dropdown-menu{--cui-dropdown-padding-y: 0}\n"]
      }]
    }], () => [{
      type: i0.ElementRef
    }, {
      type: i0.Renderer2
    }, {
      type: i0.NgZone
    }, {
      type: i0.ChangeDetectorRef
    }, {
      type: i0.ViewContainerRef
    }, {
      type: i1$1.FocusMonitor
    }, {
      type: MultiSelectService
    }, {
      type: i0.IterableDiffers
    }], {
      allowCreateOptions: [{
        type: Input,
        args: [{
          transform: booleanAttribute
        }]
      }],
      cleaner: [{
        type: Input
      }],
      clearSearchOnSelect: [{
        type: Input,
        args: [{
          transform: booleanAttribute
        }]
      }],
      disabled: [{
        type: Input,
        args: [{
          transform: booleanAttribute
        }]
      }],
      loading: [{
        type: Input,
        args: [{
          transform: booleanAttribute
        }]
      }],
      multiple: [{
        type: Input,
        args: [{
          transform: booleanAttribute
        }]
      }],
      nativeFormId: [{
        type: Input
      }],
      nativeId: [{
        type: Input
      }],
      nativeName: [{
        type: Input
      }],
      options: [{
        type: Input
      }],
      optionsMaxHeight: [{
        type: Input
      }],
      optionsStyle: [{
        type: Input
      }],
      placeholder: [{
        type: Input
      }],
      search: [{
        type: Input
      }],
      searchNoResultsLabel: [{
        type: Input
      }],
      searchValue: [{
        type: Input
      }],
      searchValueChange: [{
        type: Output
      }],
      selectAll: [{
        type: Input
      }],
      selectAllLabel: [{
        type: Input
      }],
      selectionType: [{
        type: Input
      }],
      selectionTypeCounterText: [{
        type: Input
      }],
      selectionTypeCounterTextPluralMap: [{
        type: Input
      }],
      size: [{
        type: Input
      }],
      value: [{
        type: Input
      }],
      valueChange: [{
        type: Output
      }],
      valid: [{
        type: Input
      }],
      virtualScroller: [{
        type: Input,
        args: [{
          transform: booleanAttribute
        }]
      }],
      visibleItems: [{
        type: Input,
        args: [{
          transform: numberAttribute
        }]
      }],
      itemSize: [{
        type: Input
      }],
      itemMinWidth: [{
        type: Input
      }],
      visible: [{
        type: Input,
        args: [{
          transform: booleanAttribute
        }]
      }],
      visibleChange: [{
        type: Output
      }],
      popperOptions: [{
        type: Input
      }],
      multiSelectOptionsContent: [{
        type: ContentChildren,
        args: [MultiSelectOptionComponent, {
          descendants: true
        }]
      }],
      multiSelectOptionsView: [{
        type: ViewChildren,
        args: [MultiSelectOptionComponent]
      }],
      scrollViewportView: [{
        type: ViewChildren,
        args: ['scrollViewport']
      }],
      optionsElementRef: [{
        type: ViewChild,
        args: ['options']
      }],
      contentTemplates: [{
        type: ContentChildren,
        args: [TemplateIdDirective, {
          descendants: true
        }]
      }],
      inputElement: [{
        type: ViewChild,
        args: ['inputElement']
      }],
      dropdownMenu: [{
        type: ViewChild,
        args: [DropdownMenuDirective, {
          read: ElementRef
        }]
      }],
      dropdown: [{
        type: ViewChild,
        args: [DropdownComponent, {
          read: ElementRef
        }]
      }],
      dropdownToggle: [{
        type: ViewChild,
        args: [DropdownToggleDirective, {
          read: ElementRef
        }]
      }],
      hostClasses: [{
        type: HostBinding,
        args: ['class']
      }],
      ariaMultiSelectable: [{
        type: HostBinding,
        args: ['attr.aria-multiselectable']
      }],
      ariaExpanded: [{
        type: HostBinding,
        args: ['attr.aria-expanded']
      }],
      tabIndex: [{
        type: HostBinding,
        args: ['attr.tabindex']
      }],
      onKeyUp: [{
        type: HostListener,
        args: ['keyup', ['$event']]
      }],
      onKeyDown: [{
        type: HostListener,
        args: ['keydown', ['$event']]
      }],
      onClick: [{
        type: HostListener,
        args: ['click', ['$event']]
      }]
    });
  });
})();
class MultiSelectModule {
  static {
    this.ɵfac = function MultiSelectModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MultiSelectModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MultiSelectModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [MultiSelectService],
      imports: [MultiSelectComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiSelectModule, [{
    type: NgModule,
    args: [{
      imports: [MultiSelectComponent, MultiSelectOptionComponent, MultiSelectOptgroupComponent, MultiSelectOptgroupLabelComponent],
      exports: [MultiSelectComponent, MultiSelectOptionComponent, MultiSelectOptgroupComponent, MultiSelectOptgroupLabelComponent],
      providers: [MultiSelectService]
    }]
  }], null, null);
})();
class NavLinkDirective {
  constructor() {
    /**
     * Sets .nav-link class to the host. [docs]
     * @default true
     */
    this.cNavLink = input(true, {
      transform: booleanAttribute
    });
    /**
     * Toggle the active state for the component. [docs]
     * @default undefined
     */
    this.active = input();
    /**
     * Set disabled attr for the host element. [docs]
     * @default false
     */
    this.disabled = input(false, {
      transform: booleanAttribute
    });
    this.ariaCurrent = computed(() => {
      return this.active() ? 'page' : null;
    });
    this.ariaDisabled = null;
    this.attrDisabled = null;
    this.attrTabindex = null;
    this.styleCursor = null;
    this.#disabledEffect = effect(() => {
      const disabled = this.disabled();
      this.ariaDisabled = disabled || null;
      this.attrDisabled = disabled ? '' : null;
      this.attrTabindex = disabled ? '-1' : null;
      this.styleCursor = disabled ? null : 'pointer';
    });
    this.hostClasses = computed(() => {
      return {
        'nav-link': this.cNavLink(),
        disabled: this.disabled(),
        active: this.active()
      };
    });
  }
  #disabledEffect;
  static {
    this.ɵfac = function NavLinkDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NavLinkDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NavLinkDirective,
      selectors: [["", "cNavLink", ""]],
      hostVars: 8,
      hostBindings: function NavLinkDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("aria-current", ctx.ariaCurrent())("aria-disabled", ctx.ariaDisabled)("disabled", ctx.attrDisabled)("tabindex", ctx.attrTabindex);
          i0.ɵɵclassMap(ctx.hostClasses());
          i0.ɵɵstyleProp("cursor", ctx.styleCursor);
        }
      },
      inputs: {
        cNavLink: [1, "cNavLink"],
        active: [1, "active"],
        disabled: [1, "disabled"]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavLinkDirective, [{
    type: Directive,
    args: [{
      selector: '[cNavLink]',
      host: {
        '[class]': 'hostClasses()',
        '[attr.aria-current]': 'ariaCurrent()',
        '[attr.aria-disabled]': 'ariaDisabled',
        '[attr.disabled]': 'attrDisabled',
        '[attr.tabindex]': 'attrTabindex',
        '[style.cursor]': 'styleCursor'
      }
    }]
  }], null, null);
})();
class NavItemComponent {
  static {
    this.ɵfac = function NavItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NavItemComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NavItemComponent,
      selectors: [["c-nav-item"]],
      hostAttrs: [1, "nav-item"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function NavItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:list-item;text-align:match-parent;text-align:-webkit-match-parent}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavItemComponent, [{
    type: Component,
    args: [{
      selector: 'c-nav-item',
      template: '<ng-content />',
      host: {
        class: 'nav-item'
      },
      styles: [":host{display:list-item;text-align:match-parent;text-align:-webkit-match-parent}\n"]
    }]
  }], null, null);
})();
class NavComponent {
  constructor() {
    /**
     * Specify a layout type for component.
     * @default undefined
     */
    this.layout = input();
    /**
     * Set the nav variant to tabs or pills.
     * @default undefined
     */
    this.variant = input();
    this.hostClasses = computed(() => {
      const layout = this.layout();
      const variant = this.variant();
      return {
        nav: true,
        [`nav-${layout}`]: !!layout,
        [`nav-${variant}`]: !!variant
      };
    });
  }
  static {
    this.ɵfac = function NavComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NavComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NavComponent,
      selectors: [["c-nav"]],
      hostAttrs: [1, "nav"],
      hostVars: 2,
      hostBindings: function NavComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        layout: [1, "layout"],
        variant: [1, "variant"]
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function NavComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]   .nav-link[_ngcontent-%COMP%]:focus{outline:0}.nav-underline-border[_nghost-%COMP%]{column-gap:0}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavComponent, [{
    type: Component,
    args: [{
      selector: 'c-nav',
      template: '<ng-content />',
      host: {
        class: 'nav',
        '[class]': 'hostClasses()'
      },
      styles: [":host .nav-link:focus{outline:0}:host.nav-underline-border{column-gap:0}\n"]
    }]
  }], null, null);
})();
class NavModule {
  static {
    this.ɵfac = function NavModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NavModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NavModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavModule, [{
    type: NgModule,
    args: [{
      imports: [NavComponent, NavItemComponent, NavLinkDirective],
      exports: [NavComponent, NavItemComponent, NavLinkDirective]
    }]
  }], null, null);
})();

// todo: fix container prop issue not rendering children
// todo: workaround -  use <c-container> component directly in template
class NavbarComponent {
  constructor() {
    this.#breakpointObserver = inject(BreakpointObserver);
    this.#document = inject(DOCUMENT);
    this.#hostElement = inject(ElementRef);
    /**
     * Sets the color context of the component to one of CoreUI’s themed colors.
     * @type Colors
     */
    this.color = input();
    /**
     * Defines optional container wrapping children elements.
     */
    this.container = input();
    /**
     * Defines the responsive breakpoint to determine when content collapses.
     */
    this.expand = input();
    /**
     * Place component in non-static positions.
     */
    this.placement = input();
    this.role = input('navigation');
    this.collapse = contentChild(CollapseDirective);
    this.hostClasses = computed(() => {
      const color = this.color();
      const expand = this.expand();
      const expandClassSuffix = expand === true ? '' : `-${expand}`;
      const placement = this.placement();
      return {
        navbar: true,
        [`navbar-expand${expandClassSuffix}`]: !!expand,
        [`bg-${color}`]: !!color,
        [`${placement}`]: !!placement
      };
    });
    this.containerClass = computed(() => {
      const container = this.container();
      return `container${container !== true ? '-' + container : ''}`;
    });
    this.computedStyle = signal('');
    this.afterNextRenderFn = afterRender({
      read: () => {
        const expand = this.expand();
        if (typeof expand === 'string') {
          const computedStyle = this.#document.defaultView?.getComputedStyle(this.#hostElement.nativeElement)?.getPropertyValue(`--cui-breakpoint-${expand}`) ?? false;
          computedStyle && this.computedStyle.set(computedStyle);
        }
      }
    });
    this.breakpoint = computed(() => {
      const expand = this.expand();
      if (typeof expand === 'string') {
        return this.computedStyle();
      }
      return false;
    });
  }
  #breakpointObserver;
  #document;
  #hostElement;
  #observer;
  ngAfterContentInit() {
    const breakpoint = this.breakpoint();
    if (breakpoint) {
      const onBreakpoint = `(min-width: ${breakpoint})`;
      this.#observer = this.#breakpointObserver.observe([onBreakpoint]).pipe().subscribe(result => {
        const collapse = this.collapse();
        if (collapse) {
          const animate = collapse.animate();
          collapse.animate.set(false);
          collapse.toggle(false);
          setTimeout(() => {
            collapse.toggle(result.matches);
            setTimeout(() => {
              collapse.animate.set(animate);
            });
          });
        }
      });
    }
  }
  ngOnDestroy() {
    this.#observer?.unsubscribe();
  }
  static {
    this.ɵfac = function NavbarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NavbarComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NavbarComponent,
      selectors: [["c-navbar"]],
      contentQueries: function NavbarComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.collapse, CollapseDirective, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      hostVars: 3,
      hostBindings: function NavbarComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role());
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        color: [1, "color"],
        container: [1, "container"],
        expand: [1, "expand"],
        placement: [1, "placement"],
        role: [1, "role"]
      },
      features: [i0.ɵɵHostDirectivesFeature([{
        directive: ThemeDirective,
        inputs: ["colorScheme", "colorScheme"]
      }])],
      ngContentSelectors: _c2,
      decls: 5,
      vars: 1,
      consts: [["withContainerTemplate", ""], ["noContainerTemplate", ""], [4, "ngTemplateOutlet"], [3, "ngClass"]],
      template: function NavbarComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c2);
          i0.ɵɵtemplate(0, NavbarComponent_ng_container_0_Template, 1, 0, "ng-container", 2)(1, NavbarComponent_ng_template_1_Template, 2, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(3, NavbarComponent_ng_template_3_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const withContainerTemplate_r2 = i0.ɵɵreference(2);
          const noContainerTemplate_r3 = i0.ɵɵreference(4);
          i0.ɵɵproperty("ngTemplateOutlet", ctx.container() ? withContainerTemplate_r2 : noContainerTemplate_r3);
        }
      },
      dependencies: [NgClass, NgTemplateOutlet],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavbarComponent, [{
    type: Component,
    args: [{
      selector: 'c-navbar',
      imports: [NgClass, NgTemplateOutlet],
      hostDirectives: [{
        directive: ThemeDirective,
        inputs: ['colorScheme']
      }],
      host: {
        '[class]': 'hostClasses()',
        '[attr.role]': 'role()'
      },
      template: "<ng-container *ngTemplateOutlet=\"container() ? withContainerTemplate : noContainerTemplate\" />\n\n<ng-template #withContainerTemplate>\n  <div [ngClass]=\"containerClass()\">\n    <ng-content />\n  </div>\n</ng-template>\n\n<ng-template #noContainerTemplate>\n  <ng-content />\n</ng-template>\n"
    }]
  }], null, null);
})();
class NavbarBrandDirective {
  constructor() {
    this.role = input('button');
  }
  static {
    this.ɵfac = function NavbarBrandDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NavbarBrandDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NavbarBrandDirective,
      selectors: [["", "cNavbarBrand", ""]],
      hostAttrs: [1, "navbar-brand"],
      hostVars: 1,
      hostBindings: function NavbarBrandDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role());
        }
      },
      inputs: {
        role: [1, "role"]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavbarBrandDirective, [{
    type: Directive,
    args: [{
      selector: '[cNavbarBrand]',
      host: {
        class: 'navbar-brand',
        '[attr.role]': 'role()'
      }
    }]
  }], null, null);
})();
class NavbarNavComponent {
  constructor() {
    /**
     * Enable vertical scrolling of a collapsed navbar toggleable contents.
     * @type boolean
     */
    this.scroll = input(false, {
      transform: booleanAttribute
    });
    this.hostClasses = computed(() => {
      return {
        'navbar-nav': true,
        'navbar-nav-scroll': this.scroll()
      };
    });
  }
  static {
    this.ɵfac = function NavbarNavComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NavbarNavComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NavbarNavComponent,
      selectors: [["c-navbar-nav"]],
      hostVars: 2,
      hostBindings: function NavbarNavComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        scroll: [1, "scroll"]
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function NavbarNavComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavbarNavComponent, [{
    type: Component,
    args: [{
      selector: 'c-navbar-nav',
      template: '<ng-content />',
      host: {
        '[class]': 'hostClasses()'
      }
    }]
  }], null, null);
})();
class NavbarTextComponent {
  static {
    this.ɵfac = function NavbarTextComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NavbarTextComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NavbarTextComponent,
      selectors: [["c-navbar-text"]],
      hostAttrs: [1, "navbar-text"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function NavbarTextComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavbarTextComponent, [{
    type: Component,
    args: [{
      selector: 'c-navbar-text',
      template: '<ng-content />',
      host: {
        class: 'navbar-text'
      }
    }]
  }], null, null);
})();
class NavbarTogglerDirective {
  #renderer;
  #hostElement;
  constructor() {
    this.#renderer = inject(Renderer2);
    this.#hostElement = inject(ElementRef);
    /**
     * Reference to navbar collapse element (via # template variable) . [docs]
     * @type string
     * @default 'button'
     */
    this.collapseRef = input(undefined, {
      alias: 'cNavbarToggler'
    });
    /**
     * Default type for navbar-toggler. [docs]
     * @type string
     * @default 'button'
     */
    this.type = input('button');
    /**
     * Default aria-label attr for navbar-toggler. [docs]
     * @type string
     * @default 'Toggle navigation'
     */
    this.ariaLabel = input('Toggle navigation');
    afterNextRender({
      read: () => {
        const hasContent = this.#hostElement.nativeElement.childNodes.length;
        if (!hasContent) {
          this.addDefaultIcon();
        }
      }
    });
  }
  handleClick($event) {
    const collapseRef = this.collapseRef();
    collapseRef?.toggle(!collapseRef?.visible());
  }
  addDefaultIcon() {
    const span = this.#renderer.createElement('span');
    this.#renderer.addClass(span, 'navbar-toggler-icon');
    this.#renderer.appendChild(this.#hostElement.nativeElement, span);
  }
  static {
    this.ɵfac = function NavbarTogglerDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NavbarTogglerDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NavbarTogglerDirective,
      selectors: [["", "cNavbarToggler", ""]],
      hostAttrs: [1, "navbar-toggler"],
      hostVars: 2,
      hostBindings: function NavbarTogglerDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function NavbarTogglerDirective_click_HostBindingHandler($event) {
            return ctx.handleClick($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("aria-label", ctx.ariaLabel())("type", ctx.type());
        }
      },
      inputs: {
        collapseRef: [1, "cNavbarToggler", "collapseRef"],
        type: [1, "type"],
        ariaLabel: [1, "ariaLabel"]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavbarTogglerDirective, [{
    type: Directive,
    args: [{
      selector: '[cNavbarToggler]',
      host: {
        '[attr.aria-label]': 'ariaLabel()',
        '[attr.type]': 'type()',
        class: 'navbar-toggler',
        '(click)': 'handleClick($event)'
      }
    }]
  }], () => [], null);
})();
class NavbarModule {
  static {
    this.ɵfac = function NavbarModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NavbarModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NavbarModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavbarModule, [{
    type: NgModule,
    args: [{
      exports: [NavbarBrandDirective, NavbarComponent, NavbarNavComponent, NavbarTextComponent, NavbarTogglerDirective],
      imports: [NavbarBrandDirective, NavbarComponent, NavbarNavComponent, NavbarTextComponent, NavbarTogglerDirective]
    }]
  }], null, null);
})();
class ModalBodyComponent {
  static {
    this.ɵfac = function ModalBodyComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ModalBodyComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ModalBodyComponent,
      selectors: [["c-modal-body"]],
      hostAttrs: [1, "modal-body"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function ModalBodyComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalBodyComponent, [{
    type: Component,
    args: [{
      selector: 'c-modal-body',
      template: '<ng-content />',
      host: {
        class: 'modal-body'
      },
      styles: [":host{display:block}\n"]
    }]
  }], null, null);
})();
class ModalContentComponent {
  static {
    this.ɵfac = function ModalContentComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ModalContentComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ModalContentComponent,
      selectors: [["c-modal-content"]],
      hostAttrs: [1, "modal-content"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function ModalContentComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalContentComponent, [{
    type: Component,
    args: [{
      selector: 'c-modal-content',
      template: '<ng-content />',
      host: {
        class: 'modal-content'
      }
    }]
  }], null, null);
})();
class ModalDialogComponent {
  constructor() {
    /**
     * Align the modal in the center or top of the screen.
     * @default undefined
     */
    this.alignment = input();
    /**
     * Set modal to covers the entire user viewport.
     * @return {boolean | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'}
     */
    this.fullscreen = input();
    /**
     * Does the modal dialog itself scroll, or does the whole dialog scroll within the window.
     * @default false
     * @return {boolean}
     */
    this.scrollable = input(false, {
      transform: booleanAttribute
    });
    /**
     * Size the component small, large, or extra large.
     * @default undefined
     * @return {'sm' | 'lg' | 'xl'}
     */
    this.size = input();
    this.hostClasses = computed(() => {
      const fullscreen = this.fullscreen();
      const size = this.size();
      return {
        'modal-dialog': true,
        'modal-dialog-centered': this.alignment() === 'center',
        'modal-fullscreen': fullscreen === true,
        [`modal-fullscreen-${fullscreen}-down`]: typeof fullscreen === 'string',
        'modal-dialog-scrollable': this.scrollable(),
        [`modal-${size}`]: !!size
      };
    });
  }
  static {
    this.ɵfac = function ModalDialogComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ModalDialogComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ModalDialogComponent,
      selectors: [["c-modal-dialog"]],
      hostAttrs: [1, "modal-dialog"],
      hostVars: 2,
      hostBindings: function ModalDialogComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        alignment: [1, "alignment"],
        fullscreen: [1, "fullscreen"],
        scrollable: [1, "scrollable"],
        size: [1, "size"]
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function ModalDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}.modal-dialog-centered[_nghost-%COMP%]{display:flex}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalDialogComponent, [{
    type: Component,
    args: [{
      selector: 'c-modal-dialog',
      template: '<ng-content />',
      host: {
        class: 'modal-dialog',
        '[class]': 'hostClasses()'
      },
      styles: [":host{display:block}:host.modal-dialog-centered{display:flex}\n"]
    }]
  }], null, null);
})();
class ModalService {
  constructor() {
    this.#modalState = new Subject();
    this.modalState$ = this.#modalState.asObservable();
  }
  #modalState;
  toggle(action) {
    this.#modalState.next(action);
  }
  static {
    this.ɵfac = function ModalService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ModalService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ModalService,
      factory: ModalService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class ModalToggleDirective {
  constructor() {
    this.#modalService = inject(ModalService);
    /**
     * Html id attr of modal to dismiss.
     * @default undefined
     */
    this.toggle = input(undefined, {
      alias: 'cModalToggle'
    });
  }
  #modalService;
  dismiss($event) {
    $event.preventDefault();
    this.#modalService.toggle({
      show: 'toggle',
      id: this.toggle()
    });
  }
  static {
    this.ɵfac = function ModalToggleDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ModalToggleDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ModalToggleDirective,
      selectors: [["", "cModalToggle", ""]],
      hostBindings: function ModalToggleDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function ModalToggleDirective_click_HostBindingHandler($event) {
            return ctx.dismiss($event);
          });
        }
      },
      inputs: {
        toggle: [1, "cModalToggle", "toggle"]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalToggleDirective, [{
    type: Directive,
    args: [{
      selector: '[cModalToggle]',
      host: {
        '(click)': 'dismiss($event)'
      }
    }]
  }], null, null);
})();
class ModalFooterComponent {
  static {
    this.ɵfac = function ModalFooterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ModalFooterComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ModalFooterComponent,
      selectors: [["c-modal-footer"]],
      hostAttrs: [1, "modal-footer"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function ModalFooterComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalFooterComponent, [{
    type: Component,
    args: [{
      selector: 'c-modal-footer',
      template: '<ng-content />',
      host: {
        class: 'modal-footer'
      }
    }]
  }], null, null);
})();
class ModalHeaderComponent {
  static {
    this.ɵfac = function ModalHeaderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ModalHeaderComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ModalHeaderComponent,
      selectors: [["c-modal-header"]],
      hostAttrs: [1, "modal-header"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function ModalHeaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalHeaderComponent, [{
    type: Component,
    args: [{
      selector: 'c-modal-header',
      template: '<ng-content />',
      host: {
        class: 'modal-header'
      }
    }]
  }], null, null);
})();
class ModalTitleDirective {
  static {
    this.ɵfac = function ModalTitleDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ModalTitleDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ModalTitleDirective,
      selectors: [["", "cModalTitle", ""]],
      hostAttrs: [1, "modal-title"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalTitleDirective, [{
    type: Directive,
    args: [{
      selector: '[cModalTitle]',
      host: {
        class: 'modal-title'
      }
    }]
  }], null, null);
})();
class ModalComponent {
  constructor() {
    this.#document = inject(DOCUMENT);
    this.#renderer = inject(Renderer2);
    this.#hostElement = inject(ElementRef);
    this.#modalService = inject(ModalService);
    this.#backdropService = inject(BackdropService);
    this.#destroyRef = inject(DestroyRef);
    this.#focusMonitor = inject(FocusMonitor);
    /**
     * Align the modal in the center or top of the screen.
     * @return {'top' | 'center'}
     * @default 'top'
     */
    this.alignment = input('top');
    /**
     * Apply a backdrop on body while modal is open.
     * @return boolean | 'static'
     * @default true
     */
    this.backdrop = input(true);
    /**
     * Set modal to cover the entire user viewport.
     * @return {boolean | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'}
     * @default undefined
     */
    this.fullscreen = input();
    /**
     * Closes the modal when escape key is pressed.
     * @return boolean
     * @default true
     */
    this.keyboard = input(true, {
      transform: booleanAttribute
    });
    this.attrId = input(undefined, {
      alias: 'id'
    });
    /**
     * Size the component small, large, or extra large.
     * @return {'sm' | 'lg' | 'xl'}
     * @default undefined
     */
    this.size = input();
    /**
     * Remove animation to create modal that simply appear rather than fade in to view.
     */
    this.transition = input(true, {
      transform: booleanAttribute
    });
    /**
     * Default role for modal
     * @return string
     * @default 'dialog'
     */
    this.role = input('dialog');
    /**
     * Set aria-modal html attr for modal
     * @type boolean
     * @default null
     */
    this.ariaModalInput = input(false, {
      transform: booleanAttribute,
      alias: 'ariaModal'
    });
    this.ariaModal = computed(() => {
      return this.visible || this.ariaModalInput() ? true : null;
    });
    /**
     * Create a scrollable modal that allows scrolling the modal body.
     * @return boolean
     * @default false
     */
    this.scrollable = input(false, {
      transform: booleanAttribute
    });
    /**
     * Toggle the visibility of modal component.
     * @return boolean
     * @default false
     */
    this.visibleInput = input(false, {
      transform: booleanAttribute,
      alias: 'visible'
    });
    this.#visibleInputEffect = effect(() => {
      const visible = this.visibleInput();
      untracked(() => {
        this.visible = visible;
      });
    });
    this.#visible = signal(false);
    this.#activeElement = signal(null);
    this.#visibleEffect = effect(() => {
      const visible = this.#visible();
      const afterViewInit = this.#afterViewInit();
      untracked(() => {
        if (visible && afterViewInit) {
          this.#activeElement.set(this.#document.activeElement);
          // this.#activeElement()?.blur();
          setTimeout(() => {
            const focusable = this.modalContentRef()?.nativeElement.querySelectorAll('[tabindex]:not([tabindex="-1"]), button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled])');
            if (focusable?.length) {
              this.#focusMonitor.focusVia(focusable[0], 'keyboard');
            }
          });
        } else {
          const activeElement = this.#activeElement();
          if (activeElement && this.#document.contains(activeElement)) {
            this.#focusMonitor.focusVia(activeElement, 'keyboard');
            setTimeout(() => {
              // this.#activeElement()?.focus();
              this.#activeElement.set(null);
            });
          }
        }
      });
    });
    /**
     * Event triggered on modal dismiss.
     * @return boolean
     */
    this.visibleChange = output();
    // @ViewChild(ModalContentComponent, { read: ElementRef }) modalContent!: ElementRef;
    // @ViewChild('modalContentRef', { read: ElementRef }) modalContentRef!: ElementRef;
    // readonly modalContentRef = viewChild(ModalContentComponent, { read: ElementRef });
    this.modalContentRef = viewChild('modalContentRef', {
      read: ElementRef
    });
    // private inBoundingClientRect!: boolean;
    this.hostClasses = computed(() => {
      return {
        modal: true,
        fade: this.transition(),
        show: this.show
      };
    });
    this.animateTrigger = computed(() => {
      return this.visible ? 'visible' : 'hidden';
    });
    this.#show = signal(true);
    this.mouseDownTarget = null;
    this.#afterViewInit = signal(false);
  }
  #document;
  #renderer;
  #hostElement;
  #modalService;
  #backdropService;
  #destroyRef;
  #focusMonitor;
  get id() {
    return this.attrId();
  }
  #visibleInputEffect;
  set visible(value) {
    if (this.#visible() !== value) {
      this.#visible.set(value);
      this.setBodyStyles(value);
      this.setBackdrop(this.backdrop() !== false && value);
      this.visibleChange.emit(value);
    }
  }
  get visible() {
    return this.#visible();
  }
  #visible;
  #activeElement;
  #visibleEffect;
  #activeBackdrop;
  get ariaHidden() {
    return this.visible ? null : true;
  }
  get show() {
    return this.visible && this.#show();
  }
  set show(value) {
    this.#show.set(value);
  }
  #show;
  animateStart(event) {
    if (event.toState === 'visible') {
      this.#backdropService.hideScrollbar();
      this.#renderer.setStyle(this.#hostElement.nativeElement, 'display', 'block');
    } else {
      if (!this.transition()) {
        this.#renderer.setStyle(this.#hostElement.nativeElement, 'display', 'none');
      }
    }
  }
  animateDone(event) {
    setTimeout(() => {
      if (event.toState === 'hidden') {
        this.#renderer.setStyle(this.#hostElement.nativeElement, 'display', 'none');
      }
    });
    this.show = this.visible;
  }
  onKeyUpHandler(event) {
    if (event.key === 'Escape' && this.keyboard() && this.visible) {
      if (this.backdrop() === 'static') {
        this.setStaticBackdrop();
      } else {
        this.#modalService.toggle({
          show: false,
          modal: this
        });
      }
    }
  }
  onMouseDownHandler($event) {
    this.mouseDownTarget = $event.target;
  }
  onClickHandler($event) {
    if (this.mouseDownTarget !== $event.target) {
      this.mouseDownTarget = null;
      return;
    }
    const targetElement = $event.target;
    if (targetElement === this.#hostElement.nativeElement) {
      if (this.backdrop() === 'static') {
        this.setStaticBackdrop();
        return;
      }
      this.#modalService.toggle({
        show: false,
        modal: this
      });
    }
  }
  ngOnInit() {
    this.stateToggleSubscribe();
  }
  #afterViewInit;
  ngAfterViewInit() {
    this.#afterViewInit.set(true);
  }
  ngOnDestroy() {
    this.#modalService.toggle({
      show: false,
      modal: this
    });
    this.#afterViewInit.set(false);
  }
  stateToggleSubscribe() {
    this.#modalService.modalState$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(action => {
      if (this === action.modal || this.id === action.id) {
        if ('show' in action) {
          this.visible = action?.show === 'toggle' ? !this.visible : action.show;
        }
      } else {
        if (this.visible) {
          this.visible = false;
        }
      }
    });
  }
  setBackdrop(setBackdrop) {
    this.#activeBackdrop = setBackdrop ? this.#backdropService.setBackdrop('modal') : this.#backdropService.clearBackdrop(this.#activeBackdrop);
  }
  setBodyStyles(open) {
    if (open) {
      if (this.backdrop() === true) {
        this.#renderer.addClass(this.#document.body, 'modal-open');
      }
    } else {
      this.#renderer.removeClass(this.#document.body, 'modal-open');
    }
  }
  setStaticBackdrop() {
    if (this.transition()) {
      this.#renderer.addClass(this.#hostElement.nativeElement, 'modal-static');
      this.#renderer.setStyle(this.#hostElement.nativeElement, 'overflow-y', 'hidden');
      setTimeout(() => {
        this.#renderer.removeClass(this.#hostElement.nativeElement, 'modal-static');
        this.#renderer.removeStyle(this.#hostElement.nativeElement, 'overflow-y');
      }, 300);
    }
  }
  static {
    this.ɵfac = function ModalComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ModalComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ModalComponent,
      selectors: [["c-modal"]],
      viewQuery: function ModalComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuerySignal(ctx.modalContentRef, _c32, 5, ElementRef);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      hostAttrs: [1, "modal"],
      hostVars: 8,
      hostBindings: function ModalComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵsyntheticHostListener("@showHide.start", function ModalComponent_animation_showHide_start_HostBindingHandler($event) {
            return ctx.animateStart($event);
          })("@showHide.done", function ModalComponent_animation_showHide_done_HostBindingHandler($event) {
            return ctx.animateDone($event);
          });
          i0.ɵɵlistener("mousedown", function ModalComponent_mousedown_HostBindingHandler($event) {
            return ctx.onMouseDownHandler($event);
          })("click", function ModalComponent_click_HostBindingHandler($event) {
            return ctx.onClickHandler($event);
          })("keyup", function ModalComponent_keyup_HostBindingHandler($event) {
            return ctx.onKeyUpHandler($event);
          }, false, i0.ɵɵresolveDocument);
        }
        if (rf & 2) {
          i0.ɵɵsyntheticHostProperty("@showHide", ctx.animateTrigger());
          i0.ɵɵattribute("role", ctx.role())("inert", ctx.ariaHidden)("id", ctx.id)("aria-modal", ctx.ariaModal())("tabindex", -1);
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        alignment: [1, "alignment"],
        backdrop: [1, "backdrop"],
        fullscreen: [1, "fullscreen"],
        keyboard: [1, "keyboard"],
        attrId: [1, "id", "attrId"],
        size: [1, "size"],
        transition: [1, "transition"],
        role: [1, "role"],
        ariaModalInput: [1, "ariaModal", "ariaModalInput"],
        scrollable: [1, "scrollable"],
        visibleInput: [1, "visible", "visibleInput"]
      },
      outputs: {
        visibleChange: "visibleChange"
      },
      exportAs: ["cModal"],
      ngContentSelectors: _c0,
      decls: 5,
      vars: 6,
      consts: [["modalContentRef", ""], [3, "alignment", "fullscreen", "scrollable", "size"], [2, "display", "contents", 3, "cdkTrapFocus", "cdkTrapFocusAutoCapture"]],
      template: function ModalComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "c-modal-dialog", 1)(1, "c-modal-content")(2, "div", 2, 0);
          i0.ɵɵprojection(4);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("alignment", ctx.alignment())("fullscreen", ctx.fullscreen())("scrollable", ctx.scrollable())("size", ctx.size());
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("cdkTrapFocus", ctx.visible)("cdkTrapFocusAutoCapture", ctx.visible);
        }
      },
      dependencies: [ModalDialogComponent, ModalContentComponent, A11yModule, i1$1.CdkTrapFocus],
      encapsulation: 2,
      data: {
        animation: [trigger('showHide', [state('visible', style({
          // display: 'block'
        })), state('hidden', style({
          // display: 'none'
        })), transition('visible <=> *', [animate('150ms')])])]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalComponent, [{
    type: Component,
    args: [{
      selector: 'c-modal',
      animations: [trigger('showHide', [state('visible', style({
        // display: 'block'
      })), state('hidden', style({
        // display: 'none'
      })), transition('visible <=> *', [animate('150ms')])])],
      exportAs: 'cModal',
      imports: [ModalDialogComponent, ModalContentComponent, A11yModule],
      host: {
        class: 'modal',
        '[class]': 'hostClasses()',
        '[attr.role]': 'role()',
        '[attr.inert]': 'ariaHidden',
        '[attr.id]': 'id',
        '[attr.aria-modal]': 'ariaModal()',
        '[attr.tabindex]': '-1',
        '[@showHide]': 'animateTrigger()',
        '(@showHide.start)': 'animateStart($event)',
        '(@showHide.done)': 'animateDone($event)',
        '(mousedown)': 'onMouseDownHandler($event)',
        '(click)': 'onClickHandler($event)',
        '(document:keyup)': 'onKeyUpHandler($event)'
      },
      template: "<c-modal-dialog\n  [alignment]=\"alignment()\"\n  [fullscreen]=\"fullscreen()\"\n  [scrollable]=\"scrollable()\"\n  [size]=\"size()\">\n  <c-modal-content>\n    <div [cdkTrapFocus]=\"visible\" [cdkTrapFocusAutoCapture]=\"visible\" style=\"display: contents;\" #modalContentRef>\n      <ng-content />\n    </div>\n  </c-modal-content>\n</c-modal-dialog>\n"
    }]
  }], null, null);
})();
class ModalModule {
  static {
    this.ɵfac = function ModalModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ModalModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ModalModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [ModalService],
      imports: [ModalComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalModule, [{
    type: NgModule,
    args: [{
      exports: [ModalBodyComponent, ModalComponent, ModalContentComponent, ModalDialogComponent, ModalFooterComponent, ModalHeaderComponent, ModalTitleDirective, ModalToggleDirective],
      imports: [ModalBodyComponent, ModalComponent, ModalContentComponent, ModalDialogComponent, ModalFooterComponent, ModalHeaderComponent, ModalTitleDirective, ModalToggleDirective],
      providers: [ModalService]
    }]
  }], null, null);
})();
class OffcanvasService {
  constructor() {
    this.offcanvasState = new Subject();
    this.offcanvasState$ = this.offcanvasState.asObservable();
  }
  toggle(action) {
    this.offcanvasState.next(action);
  }
  static {
    this.ɵfac = function OffcanvasService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OffcanvasService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OffcanvasService,
      factory: OffcanvasService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OffcanvasService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
let nextId$1 = 0;
class OffcanvasComponent {
  constructor() {
    this.#document = inject(DOCUMENT);
    this.#platformId = inject(PLATFORM_ID);
    this.#renderer = inject(Renderer2);
    this.#hostElement = inject(ElementRef);
    this.#offcanvasService = inject(OffcanvasService);
    this.#backdropService = inject(BackdropService);
    this.#breakpointObserver = inject(BreakpointObserver);
    this.#destroyRef = inject(DestroyRef);
    /**
     * Apply a backdrop on body while offcanvas is open.
     * @return boolean | 'static'
     * @default true
     */
    this.backdrop = input(true);
    /**
     * Closes the offcanvas when escape key is pressed [docs]
     * @return boolean
     * @default true
     */
    this.keyboard = input(true, {
      transform: booleanAttribute
    });
    /**
     * Components placement, there’s no default placement.
     * @return {'start' | 'end' | 'top' | 'bottom'}
     * @default 'start'
     */
    this.placement = input('start');
    /**
     * Responsive offcanvas property hides content outside the viewport from a specified breakpoint and down.
     * @return boolean | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
     * @default true
     * @since 4.3.10
     */
    this.responsive = input(true);
    this.id = input(`offcanvas-${this.placement()}-${nextId$1++}`);
    /**
     * Default role for offcanvas. [docs]
     * @return string
     * @default 'dialog'
     */
    this.role = input('dialog');
    /**
     * Set aria-modal html attr for offcanvas. [docs]
     * @return boolean
     * @default true
     */
    this.ariaModal = input(true, {
      transform: booleanAttribute
    });
    /**
     * Allow body scrolling while offcanvas is visible.
     * @return boolean
     * @default false
     */
    this.scroll = input(false, {
      transform: booleanAttribute
    });
    /**
     * Toggle the visibility of offcanvas component.
     * @return boolean
     * @default false
     */
    this.visibleInput = input(false, {
      transform: booleanAttribute,
      alias: 'visible'
    });
    this.visible = linkedSignal({
      source: this.visibleInput,
      computation: value => value
    });
    this.visibleEffect = effect(() => {
      const visible = this.visible();
      if (visible) {
        this.setBackdrop(this.backdrop());
        this.setFocus();
      } else {
        this.setBackdrop(false);
      }
      this.layoutChangeSubscribe(visible);
      this.visibleChange.emit(visible);
    });
    /**
     * Event triggered on visible change.
     * @return <boolean>
     */
    this.visibleChange = output();
    this.hostClasses = computed(() => {
      const responsive = this.responsive();
      const placement = this.placement();
      const visible = this.visible();
      return {
        offcanvas: typeof responsive === 'boolean',
        [`offcanvas-${responsive}`]: typeof responsive !== 'boolean',
        [`offcanvas-${placement}`]: !!placement,
        show: visible
      };
    });
    this.ariaHidden = computed(() => {
      return this.visible() ? null : true;
    });
  }
  #document;
  #platformId;
  #renderer;
  #hostElement;
  #offcanvasService;
  #backdropService;
  #breakpointObserver;
  #destroyRef;
  #activeBackdrop;
  #backdropClickSubscription;
  #layoutChangeSubscription;
  get tabIndex() {
    return '-1';
  }
  get show() {
    return this.visible();
  }
  set show(value) {
    this.visible.set(value);
  }
  get responsiveBreakpoint() {
    const responsive = this.responsive();
    if (typeof responsive !== 'string') {
      return false;
    }
    const element = this.#document.documentElement;
    const breakpointValue = this.#document.defaultView?.getComputedStyle(element)?.getPropertyValue(`--cui-breakpoint-${responsive.trim()}`) ?? false;
    return breakpointValue ? `${parseFloat(breakpointValue.trim()) - 0.02}px` : false;
  }
  animateStart(event) {
    if (event.toState === 'visible') {
      if (!this.scroll()) {
        this.#backdropService.hideScrollbar();
      }
      this.#renderer.addClass(this.#hostElement.nativeElement, 'showing');
    } else {
      this.#renderer.addClass(this.#hostElement.nativeElement, 'hiding');
    }
  }
  animateDone(event) {
    setTimeout(() => {
      if (event.toState === 'visible') {
        this.#renderer.removeClass(this.#hostElement.nativeElement, 'showing');
      }
      if (event.toState === 'hidden') {
        this.#renderer.removeClass(this.#hostElement.nativeElement, 'hiding');
        this.#renderer.removeStyle(this.#document.body, 'overflow');
        this.#renderer.removeStyle(this.#document.body, 'paddingRight');
      }
    });
    this.show = this.visible();
  }
  onKeyDownHandler(event) {
    if (event.key === 'Escape' && this.keyboard() && this.visible() && this.backdrop() !== 'static') {
      this.#offcanvasService.toggle({
        show: false,
        id: this.id()
      });
    }
  }
  ngOnInit() {
    this.stateToggleSubscribe();
    setTimeout(() => {
      // hotfix to avoid offcanvas flicker on the first render
      this.#renderer.setStyle(this.#hostElement.nativeElement, 'display', 'flex');
    });
  }
  ngOnDestroy() {
    this.#offcanvasService.toggle({
      show: false,
      id: this.id()
    });
  }
  setFocus() {
    if (isPlatformBrowser(this.#platformId)) {
      setTimeout(() => this.#hostElement.nativeElement.focus());
    }
  }
  stateToggleSubscribe() {
    this.#offcanvasService.offcanvasState$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(action => {
      if (this === action.offcanvas || this.id() === action.id) {
        if ('show' in action) {
          this.visible.update(value => action?.show === 'toggle' ? !value : action.show);
        }
      }
    });
  }
  backdropClickSubscribe(subscribe = true) {
    if (subscribe) {
      this.#backdropClickSubscription = this.#backdropService.backdropClick$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(clicked => {
        this.#offcanvasService.toggle({
          show: !clicked,
          id: this.id()
        });
      });
    } else {
      this.#backdropClickSubscription?.unsubscribe();
    }
  }
  setBackdrop(setBackdrop) {
    this.#activeBackdrop = !!setBackdrop ? this.#backdropService.setBackdrop('offcanvas') : this.#backdropService.clearBackdrop(this.#activeBackdrop);
    setBackdrop === true ? this.backdropClickSubscribe() : this.backdropClickSubscribe(false);
  }
  layoutChangeSubscribe(subscribe = true) {
    if (subscribe) {
      if (!this.responsiveBreakpoint) {
        return;
      }
      const responsiveBreakpoint = `(max-width: ${this.responsiveBreakpoint})`;
      const layoutChanges = this.#breakpointObserver.observe([responsiveBreakpoint]);
      this.#layoutChangeSubscription = layoutChanges.pipe(filter(breakpointState => !breakpointState.matches), takeUntilDestroyed(this.#destroyRef)).subscribe(breakpointState => {
        this.visible.set(breakpointState.matches);
      });
    } else {
      this.#layoutChangeSubscription?.unsubscribe();
    }
  }
  static {
    this.ɵfac = function OffcanvasComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OffcanvasComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OffcanvasComponent,
      selectors: [["c-offcanvas"]],
      hostAttrs: ["ngSkipHydration", "true"],
      hostVars: 8,
      hostBindings: function OffcanvasComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵsyntheticHostListener("@showHide.start", function OffcanvasComponent_animation_showHide_start_HostBindingHandler($event) {
            return ctx.animateStart($event);
          })("@showHide.done", function OffcanvasComponent_animation_showHide_done_HostBindingHandler($event) {
            return ctx.animateDone($event);
          });
          i0.ɵɵlistener("keydown", function OffcanvasComponent_keydown_HostBindingHandler($event) {
            return ctx.onKeyDownHandler($event);
          }, false, i0.ɵɵresolveDocument);
        }
        if (rf & 2) {
          i0.ɵɵsyntheticHostProperty("@showHide", ctx.visible() ? "visible" : "hidden");
          i0.ɵɵattribute("id", ctx.id())("inert", ctx.ariaHidden() || null)("role", ctx.role())("aria-modal", ctx.ariaModal())("tabindex", ctx.tabIndex);
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        backdrop: [1, "backdrop"],
        keyboard: [1, "keyboard"],
        placement: [1, "placement"],
        responsive: [1, "responsive"],
        id: [1, "id"],
        role: [1, "role"],
        ariaModal: [1, "ariaModal"],
        scroll: [1, "scroll"],
        visibleInput: [1, "visible", "visibleInput"]
      },
      outputs: {
        visibleChange: "visibleChange"
      },
      exportAs: ["cOffcanvas"],
      features: [i0.ɵɵHostDirectivesFeature([{
        directive: ThemeDirective,
        inputs: ["dark", "dark"]
      }])],
      ngContentSelectors: _c0,
      decls: 2,
      vars: 0,
      consts: [["cdkTrapFocus", "", "cdkTrapFocusAutoCapture", ""]],
      template: function OffcanvasComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
        }
      },
      dependencies: [A11yModule, i1$1.CdkTrapFocus],
      styles: ["[_nghost-%COMP%]{display:none}"],
      data: {
        animation: [trigger('showHide', [state('visible', style({
          // visibility: 'visible'
        })), state('hidden', style({
          // visibility: 'hidden'
        })), transition('visible <=> *', [animate('300ms')])])]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OffcanvasComponent, [{
    type: Component,
    args: [{
      selector: 'c-offcanvas',
      animations: [trigger('showHide', [state('visible', style({
        // visibility: 'visible'
      })), state('hidden', style({
        // visibility: 'hidden'
      })), transition('visible <=> *', [animate('300ms')])])],
      exportAs: 'cOffcanvas',
      imports: [A11yModule],
      hostDirectives: [{
        directive: ThemeDirective,
        inputs: ['dark']
      }],
      host: {
        ngSkipHydration: 'true',
        '[@showHide]': 'this.visible() ? "visible" : "hidden"',
        '[attr.id]': 'id()',
        '[attr.inert]': 'ariaHidden() || null',
        '[attr.role]': 'role()',
        '[attr.aria-modal]': 'ariaModal()',
        '[attr.tabindex]': 'tabIndex',
        '[class]': 'hostClasses()',
        '(@showHide.start)': 'animateStart($event)',
        '(@showHide.done)': 'animateDone($event)',
        '(document:keydown)': 'onKeyDownHandler($event)'
      },
      template: "<div cdkTrapFocus cdkTrapFocusAutoCapture>\n  <ng-content />\n</div>\n\n",
      styles: [":host{display:none}\n"]
    }]
  }], null, null);
})();
class OffcanvasBodyComponent {
  static {
    this.ɵfac = function OffcanvasBodyComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OffcanvasBodyComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OffcanvasBodyComponent,
      selectors: [["c-offcanvas-body"]],
      hostAttrs: [1, "offcanvas-body"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function OffcanvasBodyComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OffcanvasBodyComponent, [{
    type: Component,
    args: [{
      selector: 'c-offcanvas-body',
      template: '<ng-content />',
      host: {
        class: 'offcanvas-body'
      },
      styles: [":host{display:block}\n"]
    }]
  }], null, null);
})();
class OffcanvasHeaderComponent {
  static {
    this.ɵfac = function OffcanvasHeaderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OffcanvasHeaderComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OffcanvasHeaderComponent,
      selectors: [["c-offcanvas-header"]],
      hostAttrs: [1, "offcanvas-header"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function OffcanvasHeaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OffcanvasHeaderComponent, [{
    type: Component,
    args: [{
      selector: 'c-offcanvas-header',
      template: '<ng-content />',
      host: {
        class: 'offcanvas-header'
      }
    }]
  }], null, null);
})();
class OffcanvasTitleDirective {
  static {
    this.ɵfac = function OffcanvasTitleDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OffcanvasTitleDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: OffcanvasTitleDirective,
      selectors: [["", "cOffcanvasTitle", ""]],
      hostAttrs: [1, "offcanvas-title"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OffcanvasTitleDirective, [{
    type: Directive,
    args: [{
      selector: '[cOffcanvasTitle]',
      host: {
        class: 'offcanvas-title'
      }
    }]
  }], null, null);
})();
class OffcanvasToggleDirective {
  constructor() {
    this.#offcanvasService = inject(OffcanvasService);
    /**
     * Html id attr of offcanvas to toggle.
     * @return string
     */
    this.id = input(undefined, {
      alias: 'cOffcanvasToggle'
    });
  }
  #offcanvasService;
  toggleOpen($event) {
    $event.preventDefault();
    this.#offcanvasService.toggle({
      show: 'toggle',
      id: this.id()
    });
  }
  static {
    this.ɵfac = function OffcanvasToggleDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OffcanvasToggleDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: OffcanvasToggleDirective,
      selectors: [["", "cOffcanvasToggle", ""]],
      hostBindings: function OffcanvasToggleDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function OffcanvasToggleDirective_click_HostBindingHandler($event) {
            return ctx.toggleOpen($event);
          });
        }
      },
      inputs: {
        id: [1, "cOffcanvasToggle", "id"]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OffcanvasToggleDirective, [{
    type: Directive,
    args: [{
      selector: '[cOffcanvasToggle]',
      host: {
        '(click)': 'toggleOpen($event)'
      }
    }]
  }], null, null);
})();
class OffcanvasModule {
  static {
    this.ɵfac = function OffcanvasModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OffcanvasModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: OffcanvasModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [OffcanvasService, BackdropService],
      imports: [OffcanvasComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OffcanvasModule, [{
    type: NgModule,
    args: [{
      exports: [OffcanvasBodyComponent, OffcanvasComponent, OffcanvasHeaderComponent, OffcanvasTitleDirective, OffcanvasToggleDirective],
      imports: [OffcanvasBodyComponent, OffcanvasComponent, OffcanvasHeaderComponent, OffcanvasTitleDirective, OffcanvasToggleDirective],
      providers: [OffcanvasService, BackdropService]
    }]
  }], null, null);
})();
class PageLinkDirective {
  static {
    this.ɵfac = function PageLinkDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PageLinkDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: PageLinkDirective,
      selectors: [["", "cPageLink", ""]],
      hostAttrs: [1, "page-link"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageLinkDirective, [{
    type: Directive,
    args: [{
      selector: '[cPageLink]',
      host: {
        class: 'page-link'
      }
    }]
  }], null, null);
})();
class PageItemDirective {
  constructor() {
    this.#renderer = inject(Renderer2);
    /**
     * Toggle the active state for the component.
     * @return boolean
     */
    this.active = input();
    /**
     * Toggle the disabled state for the component.
     * @return boolean
     */
    this.disabled = input();
    this.ariaCurrent = computed(() => {
      return this.active() ? 'page' : null;
    });
    this.hostClasses = computed(() => {
      return {
        'page-item': true,
        disabled: this.disabled(),
        active: this.active()
      };
    });
    this.pageLinkElementRef = contentChild(PageLinkDirective, {
      read: ElementRef
    });
    this.pageLinkElementRefEffect = effect(() => {
      const pageLinkElementRef = this.pageLinkElementRef();
      const disabled = this.disabled();
      if (!pageLinkElementRef) {
        return;
      }
      const pageLinkElement = pageLinkElementRef.nativeElement;
      if (disabled) {
        this.#renderer.setAttribute(pageLinkElement, 'aria-disabled', 'true');
        this.#renderer.setAttribute(pageLinkElement, 'tabindex', '-1');
      } else {
        this.#renderer.removeAttribute(pageLinkElement, 'aria-disabled');
        this.#renderer.removeAttribute(pageLinkElement, 'tabindex');
      }
    });
  }
  #renderer;
  static {
    this.ɵfac = function PageItemDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PageItemDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: PageItemDirective,
      selectors: [["", "cPageItem", ""]],
      contentQueries: function PageItemDirective_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.pageLinkElementRef, PageLinkDirective, 5, ElementRef);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      hostAttrs: [1, "page-item"],
      hostVars: 3,
      hostBindings: function PageItemDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("aria-current", ctx.ariaCurrent());
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        active: [1, "active"],
        disabled: [1, "disabled"]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageItemDirective, [{
    type: Directive,
    args: [{
      selector: '[cPageItem]',
      host: {
        class: 'page-item',
        '[class]': 'hostClasses()',
        '[attr.aria-current]': 'ariaCurrent()'
      }
    }]
  }], null, null);
})();
class PageItemComponent extends PageItemDirective {
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵPageItemComponent_BaseFactory;
      return function PageItemComponent_Factory(__ngFactoryType__) {
        return (ɵPageItemComponent_BaseFactory || (ɵPageItemComponent_BaseFactory = i0.ɵɵgetInheritedFactory(PageItemComponent)))(__ngFactoryType__ || PageItemComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: PageItemComponent,
      selectors: [["c-page-item"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function PageItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: [_c33]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageItemComponent, [{
    type: Component,
    args: [{
      selector: 'c-page-item',
      template: '<ng-content />',
      styles: [":host{display:list-item;text-align:-webkit-match-parent;text-align:match-parent}\n"]
    }]
  }], null, null);
})();
class PaginationComponent {
  constructor() {
    /**
     * Set the alignment of pagination components.
     * @values 'start', 'center', 'end'
     */
    this.align = input('');
    /**
     * Size the component small or large.
     * @values 'sm', 'lg'
     */
    this.size = input();
    /**
     * Default role for pagination. [docs]
     * @return string
     * @default 'navigation'
     */
    this.role = input('navigation');
    this.paginationClass = computed(() => {
      const size = this.size();
      const align = this.align();
      return {
        pagination: true,
        [`pagination-${size}`]: !!size,
        [`justify-content-${align}`]: !!align
      };
    });
  }
  static {
    this.ɵfac = function PaginationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PaginationComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: PaginationComponent,
      selectors: [["c-pagination"]],
      hostVars: 1,
      hostBindings: function PaginationComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role());
        }
      },
      inputs: {
        align: [1, "align"],
        size: [1, "size"],
        role: [1, "role"]
      },
      ngContentSelectors: _c0,
      decls: 2,
      vars: 1,
      consts: [[3, "ngClass"]],
      template: function PaginationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "ul", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", ctx.paginationClass());
        }
      },
      dependencies: [NgClass],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaginationComponent, [{
    type: Component,
    args: [{
      selector: 'c-pagination',
      imports: [NgClass],
      host: {
        '[attr.role]': 'role()'
      },
      template: "<ul [ngClass]=\"paginationClass()\">\n  <ng-content />\n</ul>\n"
    }]
  }], null, null);
})();
class PaginationModule {
  static {
    this.ɵfac = function PaginationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PaginationModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: PaginationModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaginationModule, [{
    type: NgModule,
    args: [{
      exports: [PageItemComponent, PageItemDirective, PageLinkDirective, PaginationComponent],
      imports: [PageItemComponent, PageItemDirective, PageLinkDirective, PaginationComponent]
    }]
  }], null, null);
})();
class PlaceholderDirective {
  constructor() {
    /**
     * placeholder toggler
     * @type boolean
     * @default false
     */
    this.visible = input(false, {
      transform: booleanAttribute,
      alias: 'cPlaceholder'
    });
    /**
     * Size the placeholder xs, small, large.
     */
    this.size = input(undefined, {
      alias: 'cPlaceholderSize'
    });
    this.ariaHidden = computed(() => {
      return this.visible() ? null : true;
    });
    this.hostClasses = computed(() => {
      return {
        placeholder: this.visible(),
        [`placeholder-${this.size()}`]: !!this.size()
      };
    });
  }
  static {
    this.ɵfac = function PlaceholderDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PlaceholderDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: PlaceholderDirective,
      selectors: [["", "cPlaceholder", ""]],
      hostVars: 3,
      hostBindings: function PlaceholderDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("aria-hidden", ctx.ariaHidden());
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        visible: [1, "cPlaceholder", "visible"],
        size: [1, "cPlaceholderSize", "size"]
      },
      exportAs: ["cPlaceholder"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlaceholderDirective, [{
    type: Directive,
    args: [{
      selector: '[cPlaceholder]',
      exportAs: 'cPlaceholder',
      host: {
        '[class]': 'hostClasses()',
        '[attr.aria-hidden]': 'ariaHidden()'
      }
    }]
  }], null, null);
})();
class PlaceholderAnimationDirective {
  constructor() {
    /**
     * Animation type for placeholder
     * @type 'glow' | 'wave'
     * @default undefined
     */
    this.animation = input(undefined, {
      alias: 'cPlaceholderAnimation'
    });
    this.placeholder = contentChild(PlaceholderDirective);
    this.hostClasses = computed(() => {
      return {
        [`placeholder-${this.animation()}`]: this.placeholder()?.visible() && !!this.animation()
      };
    });
  }
  static {
    this.ɵfac = function PlaceholderAnimationDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PlaceholderAnimationDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: PlaceholderAnimationDirective,
      selectors: [["", "cPlaceholderAnimation", ""]],
      contentQueries: function PlaceholderAnimationDirective_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.placeholder, PlaceholderDirective, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      hostVars: 2,
      hostBindings: function PlaceholderAnimationDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        animation: [1, "cPlaceholderAnimation", "animation"]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlaceholderAnimationDirective, [{
    type: Directive,
    args: [{
      selector: '[cPlaceholderAnimation]',
      host: {
        '[class]': 'hostClasses()'
      }
    }]
  }], null, null);
})();
class PlaceholderModule {
  static {
    this.ɵfac = function PlaceholderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PlaceholderModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: PlaceholderModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlaceholderModule, [{
    type: NgModule,
    args: [{
      imports: [PlaceholderDirective, PlaceholderAnimationDirective],
      exports: [PlaceholderDirective, PlaceholderAnimationDirective]
    }]
  }], null, null);
})();
class PopoverComponent {
  constructor() {
    this.renderer = inject(Renderer2);
    /**
     * Content of popover
     * @return {string | TemplateRef}
     */
    this.content = input('');
    this.#contentEffect = effect(() => {
      this.updateView(this.content());
    });
    /**
     * Toggle the visibility of popover component.
     * @return boolean
     */
    this.visible = input(false, {
      transform: booleanAttribute
    });
    this.id = input();
    this.role = input('tooltip');
    this.viewContainerRef = viewChild('popoverTemplate', {
      read: ViewContainerRef
    });
    this.hostClasses = computed(() => {
      return {
        popover: true,
        fade: true,
        show: this.visible(),
        'bs-popover-auto': true
      };
    });
  }
  #contentEffect;
  ngOnDestroy() {
    this.clear();
  }
  clear() {
    this.viewContainerRef()?.clear();
    if (!!this.textNode) {
      this.renderer.removeChild(this.textNode.parentNode, this.textNode);
    }
  }
  updateView(content) {
    this.clear();
    if (!content) {
      return;
    }
    if (content instanceof TemplateRef) {
      this.viewContainerRef()?.createEmbeddedView(content);
    } else {
      const textNodeContent = this.renderer.createText(content);
      this.textNode = this.renderer.createElement('div');
      this.renderer.addClass(this.textNode, 'popover-body');
      this.renderer.appendChild(this.textNode, textNodeContent);
      const element = this.viewContainerRef()?.element.nativeElement;
      this.renderer.appendChild(element.parentNode, this.textNode);
    }
  }
  static {
    this.ɵfac = function PopoverComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PopoverComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: PopoverComponent,
      selectors: [["c-popover"]],
      viewQuery: function PopoverComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuerySignal(ctx.viewContainerRef, _c34, 5, ViewContainerRef);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      hostAttrs: [1, "popover", "fade", "bs-popover-auto"],
      hostVars: 4,
      hostBindings: function PopoverComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role())("id", ctx.id());
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        content: [1, "content"],
        visible: [1, "visible"],
        id: [1, "id"],
        role: [1, "role"]
      },
      decls: 4,
      vars: 3,
      consts: [["popoverTemplate", ""], ["data-popper-arrow", "", 3, "ngClass"]],
      template: function PopoverComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementContainerStart(0);
          i0.ɵɵelement(1, "div", 1);
          i0.ɵɵelementContainer(2, null, 0);
          i0.ɵɵelementContainerEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c35, !!ctx.content()));
        }
      },
      dependencies: [NgClass],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PopoverComponent, [{
    type: Component,
    args: [{
      selector: 'c-popover',
      imports: [NgClass],
      host: {
        class: 'popover fade bs-popover-auto',
        '[class]': 'hostClasses()',
        '[attr.role]': 'role()',
        '[attr.id]': 'id()'
      },
      template: "<ng-container>\n  <div [ngClass]=\"{'popover-arrow': !!content()}\" data-popper-arrow></div>\n  <ng-container #popoverTemplate />\n</ng-container>\n"
    }]
  }], null, null);
})();
class PopoverDirective {
  constructor() {
    this.#renderer = inject(Renderer2);
    this.#hostElement = inject(ElementRef);
    this.#viewContainerRef = inject(ViewContainerRef);
    this.#listenersService = inject(ListenersService);
    this.#changeDetectorRef = inject(ChangeDetectorRef);
    this.#intersectionService = inject(IntersectionService);
    this.#destroyRef = inject(DestroyRef);
    this.#document = inject(DOCUMENT);
    /**
     * Content of popover
     * @return {string | TemplateRef}
     */
    this.content = input(undefined, {
      alias: 'cPopover'
    });
    this.#contentEffect = effect(() => {
      if (this.content()) {
        this.destroyTooltipElement();
      }
    });
    /**
     * Optional popper Options object, takes precedence over cPopoverPlacement prop
     * @return Partial<Options>
     */
    this.popperOptions = input({}, {
      alias: 'cPopoverOptions'
    });
    this.#popperOptionsEffect = effect(() => {
      this._popperOptions = {
        ...this._popperOptions,
        placement: this.placement(),
        ...this.popperOptions()
      };
    });
    this.popperOptionsComputed = computed(() => {
      return {
        placement: this.placement(),
        ...this._popperOptions
      };
    });
    /**
     * Describes the placement of your component after Popper.js has applied all the modifiers that may have flipped or altered the originally provided placement property.
     * @return: 'top' | 'bottom' | 'left' | 'right'
     * @default: 'top'
     */
    this.placement = input('top', {
      alias: 'cPopoverPlacement'
    });
    /**
     * ElementRefDirective for positioning the tooltip on reference element
     * @return: ElementRefDirective
     * @default: undefined
     */
    this.reference = input(undefined, {
      alias: 'cTooltipRef'
    });
    this.referenceRef = computed(() => this.reference()?.elementRef ?? this.#hostElement);
    /**
     * Sets which event handlers you’d like provided to your toggle prop. You can specify one trigger or an array of them.
     * @return: Triggers | Triggers[]
     */
    this.trigger = input('hover', {
      alias: 'cPopoverTrigger'
    });
    /**
     * Toggle the visibility of popover component.
     * @return boolean
     */
    this.visible = model(false, {
      alias: 'cPopoverVisible'
    });
    this.#visibleEffect = effect(() => {
      this.visible() ? this.addTooltipElement() : this.removeTooltipElement();
    });
    this._popperOptions = {
      modifiers: [{
        name: 'offset',
        options: {
          offset: [0, 9]
        }
      }]
    };
  }
  #renderer;
  #hostElement;
  #viewContainerRef;
  #listenersService;
  #changeDetectorRef;
  #intersectionService;
  #destroyRef;
  #document;
  #contentEffect;
  #popperOptionsEffect;
  #visibleEffect;
  get ariaDescribedBy() {
    return this.tooltipId ? this.tooltipId : null;
  }
  ngAfterViewInit() {
    this.intersectionServiceSubscribe();
  }
  ngOnDestroy() {
    this.clearListeners();
    this.destroyTooltipElement();
  }
  ngOnInit() {
    this.setListeners();
  }
  setListeners() {
    const config = {
      hostElement: this.#hostElement,
      trigger: this.trigger(),
      callbackToggle: () => {
        this.visible.update(visible => !visible);
      },
      callbackOff: () => {
        this.visible.set(false);
      },
      callbackOn: () => {
        this.visible.set(true);
      }
    };
    this.#listenersService.setListeners(config);
  }
  clearListeners() {
    this.#listenersService.clearListeners();
  }
  intersectionServiceSubscribe() {
    this.#intersectionService.createIntersectionObserver(this.referenceRef());
    this.#intersectionService.intersecting$.pipe(filter(next => next.hostElement === this.referenceRef()), debounceTime(100), finalize(() => {
      this.#intersectionService.unobserve(this.referenceRef());
    }), takeUntilDestroyed(this.#destroyRef)).subscribe(next => {
      this.visible.set(next.isIntersecting ? this.visible() : false);
    });
  }
  getUID(prefix) {
    let uid = prefix ?? 'random-id';
    do {
      uid = `${prefix}-${Math.floor(Math.random() * 1000000).toString(10)}`;
    } while (this.#document.getElementById(uid));
    return uid;
  }
  createTooltipElement() {
    if (!this.tooltipRef) {
      this.tooltipRef = this.#viewContainerRef.createComponent(PopoverComponent);
      // this.viewContainerRef.detach();
    }
  }
  destroyTooltipElement() {
    this.tooltip?.remove();
    this.tooltipRef?.destroy();
    // @ts-ignore
    this.tooltipRef = undefined;
    this.popperInstance?.destroy();
    this.#viewContainerRef?.detach();
    this.#viewContainerRef?.clear();
  }
  addTooltipElement() {
    if (!this.content()) {
      this.destroyTooltipElement();
      return;
    }
    if (!this.tooltipRef) {
      this.createTooltipElement();
    }
    this.tooltipRef?.setInput('content', this.content() ?? '');
    this.tooltip = this.tooltipRef?.location.nativeElement;
    this.#renderer.addClass(this.tooltip, 'd-none');
    this.#renderer.addClass(this.tooltip, 'fade');
    this.popperInstance?.destroy();
    this.#viewContainerRef.insert(this.tooltipRef.hostView);
    this.#renderer.appendChild(this.#document.body, this.tooltip);
    this.popperInstance = createPopper(this.referenceRef().nativeElement, this.tooltip, {
      ...this.popperOptionsComputed()
    });
    if (!this.visible()) {
      this.removeTooltipElement();
      return;
    }
    setTimeout(() => {
      this.tooltipId = this.getUID('popover');
      this.tooltipRef?.setInput('id', this.tooltipId);
      this.#renderer.removeClass(this.tooltip, 'd-none');
      this.tooltipRef?.setInput('visible', this.visible());
      this.popperInstance?.forceUpdate();
      this.#changeDetectorRef?.markForCheck();
    }, 100);
  }
  removeTooltipElement() {
    this.tooltipId = '';
    if (!this.tooltipRef) {
      return;
    }
    this.tooltipRef.setInput('visible', false);
    this.tooltipRef.setInput('id', undefined);
    this.#changeDetectorRef.markForCheck();
    setTimeout(() => {
      this.#viewContainerRef?.detach();
    }, 300);
  }
  static {
    this.ɵfac = function PopoverDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PopoverDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: PopoverDirective,
      selectors: [["", "cPopover", ""]],
      hostVars: 1,
      hostBindings: function PopoverDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("aria-describedby", ctx.ariaDescribedBy);
        }
      },
      inputs: {
        content: [1, "cPopover", "content"],
        popperOptions: [1, "cPopoverOptions", "popperOptions"],
        placement: [1, "cPopoverPlacement", "placement"],
        reference: [1, "cTooltipRef", "reference"],
        trigger: [1, "cPopoverTrigger", "trigger"],
        visible: [1, "cPopoverVisible", "visible"]
      },
      outputs: {
        visible: "cPopoverVisibleChange"
      },
      exportAs: ["cPopover"],
      features: [i0.ɵɵProvidersFeature([ListenersService, IntersectionService])]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PopoverDirective, [{
    type: Directive,
    args: [{
      selector: '[cPopover]',
      exportAs: 'cPopover',
      providers: [ListenersService, IntersectionService],
      host: {
        '[attr.aria-describedby]': 'ariaDescribedBy'
      }
    }]
  }], null, null);
})();
class PopoverModule {
  static {
    this.ɵfac = function PopoverModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PopoverModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: PopoverModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PopoverModule, [{
    type: NgModule,
    args: [{
      exports: [PopoverDirective, PopoverComponent],
      imports: [PopoverDirective, PopoverComponent]
    }]
  }], null, null);
})();
class ProgressService {
  constructor() {
    this.stacked = signal(false);
    this.value = signal(undefined);
    this.precision = signal(0);
    this.min = signal(0);
    this.max = signal(100);
    this.percent = computed(() => {
      return +(((this.value() ?? 0) - this.min()) / (this.max() - this.min()) * 100).toFixed(this.precision());
    });
  }
  static {
    this.ɵfac = function ProgressService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProgressService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ProgressService,
      factory: ProgressService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProgressService, [{
    type: Injectable
  }], null, null);
})();
class ProgressBarDirective {
  constructor() {
    this.#renderer = inject(Renderer2);
    this.#hostElement = inject(ElementRef);
    this.#progressService = inject(ProgressService);
    this.#valuesEffect = effect(() => {
      const host = this.#hostElement.nativeElement;
      const value = this.#progressService.value();
      const percent = this.#progressService.percent();
      const stacked = this.#progressService.stacked();
      if (value === undefined) {
        for (const name of ['aria-valuenow', 'aria-valuemax', 'aria-valuemin', 'role']) {
          this.#renderer.removeAttribute(host, name);
        }
      } else {
        const {
          min,
          max
        } = this.#progressService;
        this.#renderer.setAttribute(host, 'aria-valuenow', String(value));
        this.#renderer.setAttribute(host, 'aria-valuemin', String(min()));
        this.#renderer.setAttribute(host, 'aria-valuemax', String(max()));
        this.#renderer.setAttribute(host, 'role', this.role());
      }
      const tagName = host.tagName;
      if (percent >= 0 && (stacked && tagName === 'C-PROGRESS' || !stacked && tagName !== 'C-PROGRESS')) {
        this.#renderer.setStyle(host, 'width', `${percent}%`);
      } else {
        this.#renderer.removeStyle(host, 'width');
      }
    });
    /**
     * Use to animate the stripes right to left via CSS3 animations.
     * @return boolean
     */
    this.animated = input(undefined, {
      transform: booleanAttribute
    });
    /**
     * Sets the color context of the component to one of CoreUI’s themed colors.
     * @values 'primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark', 'light'
     */
    this.color = input();
    this.precision = input(0, {
      transform: numberAttribute
    });
    /**
     * The percent value the ProgressBar.
     * @return number
     * @default 0
     */
    this.value = input(0, {
      transform: numberAttribute
    });
    /**
     * Set the progress bar variant to optional striped.
     * @values 'striped'
     * @default undefined
     */
    this.variant = input();
    /**
     * The max value of the ProgressBar.
     * @return number
     * @default 100
     */
    this.max = input(100, {
      transform: numberAttribute
    });
    /**
     * Set default html role attribute.
     * @return string
     */
    this.role = input('progressbar');
    this.#serviceEffect = effect(() => {
      this.#progressService.precision.set(this.precision());
      const max = this.max();
      this.#progressService.max.set(isNaN(max) || max <= 0 ? 100 : max);
      const value = this.value();
      this.#progressService.value.set(value && !isNaN(value) ? value : undefined);
    });
  }
  #renderer;
  #hostElement;
  #progressService;
  #valuesEffect;
  #serviceEffect;
  static {
    this.ɵfac = function ProgressBarDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProgressBarDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ProgressBarDirective,
      selectors: [["", "cProgressBar", ""]],
      inputs: {
        animated: [1, "animated"],
        color: [1, "color"],
        precision: [1, "precision"],
        value: [1, "value"],
        variant: [1, "variant"],
        max: [1, "max"],
        role: [1, "role"]
      },
      exportAs: ["cProgressBar"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProgressBarDirective, [{
    type: Directive,
    args: [{
      selector: '[cProgressBar]',
      exportAs: 'cProgressBar'
    }]
  }], null, null);
})();
class ProgressBarComponent {
  constructor() {
    this.#progressBarDirective = inject(ProgressBarDirective, {
      optional: true
    });
    this.hostClasses = computed(() => {
      const animated = this.#progressBarDirective?.animated();
      const color = this.#progressBarDirective?.color();
      const variant = this.#progressBarDirective?.variant();
      return {
        'progress-bar': true,
        'progress-bar-animated': !!animated,
        [`progress-bar-${variant}`]: !!variant,
        [`bg-${color}`]: !!color
      };
    });
  }
  #progressBarDirective;
  static {
    this.ɵfac = function ProgressBarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProgressBarComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ProgressBarComponent,
      selectors: [["c-progress-bar"]],
      hostAttrs: [1, "progress-bar"],
      hostVars: 2,
      hostBindings: function ProgressBarComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      features: [i0.ɵɵHostDirectivesFeature([{
        directive: ProgressBarDirective,
        inputs: ["animated", "animated", "color", "color", "max", "max", "role", "role", "value", "value", "variant", "variant"]
      }])],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function ProgressBarComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProgressBarComponent, [{
    type: Component,
    args: [{
      selector: 'c-progress-bar',
      template: '<ng-content />',
      hostDirectives: [{
        directive: ProgressBarDirective,
        inputs: ['animated', 'color', 'max', 'role', 'value', 'variant']
      }],
      host: {
        class: 'progress-bar',
        '[class]': 'hostClasses()'
      }
    }]
  }], null, null);
})();
class ProgressStackedComponent {
  constructor() {
    this.stacked = input(true);
  }
  static {
    this.ɵfac = function ProgressStackedComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProgressStackedComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ProgressStackedComponent,
      selectors: [["c-progress-stacked"]],
      hostVars: 2,
      hostBindings: function ProgressStackedComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("progress-stacked", ctx.stacked());
        }
      },
      inputs: {
        stacked: [1, "stacked"]
      },
      exportAs: ["cProgressStacked"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function ProgressStackedComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:flex}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProgressStackedComponent, [{
    type: Component,
    args: [{
      selector: 'c-progress-stacked',
      exportAs: 'cProgressStacked',
      template: '<ng-content />',
      host: {
        '[class.progress-stacked]': 'stacked()'
      },
      styles: [":host{display:flex}\n"]
    }]
  }], null, null);
})();
class ProgressComponent {
  #hostElement;
  #stacked;
  #progressService;
  constructor() {
    this.#hostElement = inject(ElementRef);
    this.progressBarDirective = inject(ProgressBarDirective, {
      optional: true
    });
    this.#stacked = inject(ProgressStackedComponent, {
      optional: true
    })?.stacked() ?? false;
    this.#progressService = inject(ProgressService);
    this.stacked = this.#progressService.stacked;
    this.percent = this.#progressService.percent;
    this.value = this.#progressService.value;
    this.contentProgressBars = contentChildren(ProgressBarComponent);
    /**
     * Sets the height of the component. If you set that value the inner `<CProgressBar>` will automatically resize accordingly.
     * @return number
     */
    this.height = input(0, {
      transform: numberAttribute
    });
    /**
     * Displays thin progress.
     * @return boolean
     */
    this.thin = input(false, {
      transform: booleanAttribute
    });
    /**
     * Change the default color to white.
     * @return boolean
     */
    this.white = input(false, {
      transform: booleanAttribute
    });
    this.hostClasses = computed(() => {
      return {
        progress: true,
        'progress-thin': this.thin(),
        'progress-white': this.white()
      };
    });
    this.hostStyle = computed(() => {
      const height = this.height();
      return !!height ? `${height}px` : this.#hostElement?.nativeElement?.style?.height ?? undefined;
    });
    this.#progressService.stacked.set(this.#stacked);
  }
  static {
    this.ɵfac = function ProgressComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProgressComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ProgressComponent,
      selectors: [["c-progress"]],
      contentQueries: function ProgressComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.contentProgressBars, ProgressBarComponent, 4);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      hostAttrs: [1, "progress"],
      hostVars: 4,
      hostBindings: function ProgressComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
          i0.ɵɵstyleProp("height", ctx.hostStyle());
        }
      },
      inputs: {
        height: [1, "height"],
        thin: [1, "thin"],
        white: [1, "white"]
      },
      exportAs: ["cProgress"],
      features: [i0.ɵɵProvidersFeature([ProgressService]), i0.ɵɵHostDirectivesFeature([{
        directive: ProgressBarDirective,
        inputs: ["animated", "animated", "color", "color", "max", "max", "role", "role", "value", "value", "variant", "variant"]
      }])],
      ngContentSelectors: _c0,
      decls: 4,
      vars: 1,
      consts: [["defaultContent", ""], [3, "animated", "variant", "color", "value"], [4, "ngTemplateOutlet"]],
      template: function ProgressComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, ProgressComponent_Conditional_0_Template, 1, 1, "ng-container")(1, ProgressComponent_Conditional_1_Template, 3, 5, "c-progress-bar", 1)(2, ProgressComponent_ng_template_2_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          let tmp_1_0;
          i0.ɵɵconditional(((tmp_1_0 = ctx.contentProgressBars()) == null ? null : tmp_1_0.length) ? 0 : 1);
        }
      },
      dependencies: [ProgressBarComponent, NgTemplateOutlet],
      styles: [".progress-stacked.progress[_nghost-%COMP%], .progress-stacked   .progress[_nghost-%COMP%]{transition:var(--cui-progress-bar-transition)}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProgressComponent, [{
    type: Component,
    args: [{
      selector: 'c-progress',
      exportAs: 'cProgress',
      imports: [ProgressBarComponent, NgTemplateOutlet],
      hostDirectives: [{
        directive: ProgressBarDirective,
        inputs: ['animated', 'color', 'max', 'role', 'value', 'variant']
      }],
      host: {
        class: 'progress',
        '[class]': 'hostClasses()',
        '[style.height]': 'hostStyle()'
      },
      providers: [ProgressService],
      template: "@if (contentProgressBars()?.length) {\n  <ng-container *ngTemplateOutlet=\"defaultContent\" />\n} @else {\n  @let pbd = progressBarDirective;\n  <c-progress-bar [animated]=\"pbd?.animated()\" [variant]=\"pbd?.variant()\" [color]=\"pbd?.color()\" [value]=\"value()\">\n    <ng-container *ngTemplateOutlet=\"defaultContent\" />\n  </c-progress-bar>\n}\n\n<ng-template #defaultContent>\n  <ng-content />\n</ng-template>\n\n",
      styles: [":host-context(.progress-stacked).progress{transition:var(--cui-progress-bar-transition)}\n"]
    }]
  }], () => [], null);
})();
class ProgressModule {
  static {
    this.ɵfac = function ProgressModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProgressModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ProgressModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProgressModule, [{
    type: NgModule,
    args: [{
      exports: [ProgressComponent, ProgressBarComponent, ProgressBarDirective, ProgressStackedComponent],
      imports: [ProgressComponent, ProgressBarComponent, ProgressBarDirective, ProgressStackedComponent]
    }]
  }], null, null);
})();
class TooltipComponent {
  constructor() {
    this.renderer = inject(Renderer2);
    /**
     * Content of tooltip
     * @type {string | TemplateRef}
     */
    this.content = input('');
    this.#contentEffect = effect(() => {
      this.updateView(this.content());
    });
    /**
     * Toggle the visibility of popover component.
     * @type boolean
     */
    this.visible = input(false, {
      transform: booleanAttribute
    });
    this.id = input();
    this.role = input('tooltip');
    this.viewContainerRef = viewChild('tooltipTemplate', {
      read: ViewContainerRef
    });
    this.hostClasses = computed(() => {
      return {
        tooltip: true,
        fade: true,
        show: this.visible(),
        'bs-tooltip-auto': true
      };
    });
  }
  #contentEffect;
  ngOnDestroy() {
    this.clear();
  }
  clear() {
    this.viewContainerRef()?.clear();
    if (!!this.textNode) {
      this.renderer.removeChild(this.textNode.parentNode, this.textNode);
    }
  }
  updateView(content) {
    this.clear();
    if (!content) {
      return;
    }
    if (content instanceof TemplateRef) {
      this.viewContainerRef()?.createEmbeddedView(content);
    } else {
      this.textNode = this.renderer.createText(content);
      const element = this.viewContainerRef()?.element.nativeElement;
      this.renderer.appendChild(element.parentNode, this.textNode);
    }
  }
  static {
    this.ɵfac = function TooltipComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TooltipComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TooltipComponent,
      selectors: [["c-tooltip"]],
      viewQuery: function TooltipComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuerySignal(ctx.viewContainerRef, _c36, 5, ViewContainerRef);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      hostAttrs: [1, "tooltip", "fade", "bs-tooltip-auto"],
      hostVars: 4,
      hostBindings: function TooltipComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role())("id", ctx.id());
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        content: [1, "content"],
        visible: [1, "visible"],
        id: [1, "id"],
        role: [1, "role"]
      },
      decls: 5,
      vars: 0,
      consts: [["tooltipTemplate", ""], ["data-popper-arrow", "", 1, "tooltip-arrow"], [1, "tooltip-inner"]],
      template: function TooltipComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementContainerStart(0);
          i0.ɵɵelement(1, "div", 1);
          i0.ɵɵelementStart(2, "div", 2);
          i0.ɵɵelementContainer(3, null, 0);
          i0.ɵɵelementEnd();
          i0.ɵɵelementContainerEnd();
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TooltipComponent, [{
    type: Component,
    args: [{
      selector: 'c-tooltip',
      host: {
        class: 'tooltip fade bs-tooltip-auto',
        '[class]': 'hostClasses()',
        '[attr.role]': 'role()',
        '[attr.id]': 'id()'
      },
      template: "<ng-container>\n  <div class=\"tooltip-arrow\" data-popper-arrow></div>\n  <div class=\"tooltip-inner\">\n    <ng-container #tooltipTemplate />\n  </div>\n</ng-container>\n"
    }]
  }], null, null);
})();
class TooltipDirective {
  constructor() {
    this.#renderer = inject(Renderer2);
    this.#hostElement = inject(ElementRef);
    this.#viewContainerRef = inject(ViewContainerRef);
    this.#listenersService = inject(ListenersService);
    this.#changeDetectorRef = inject(ChangeDetectorRef);
    this.#intersectionService = inject(IntersectionService);
    this.#destroyRef = inject(DestroyRef);
    this.#document = inject(DOCUMENT);
    /**
     * Content of tooltip
     * @return {string | TemplateRef}
     */
    this.content = input(undefined, {
      alias: 'cTooltip'
    });
    this.#contentEffect = effect(() => {
      if (this.content()) {
        this.destroyTooltipElement();
      }
    });
    /**
     * Optional popper Options object, takes precedence over cPopoverPlacement prop
     * @return Partial<Options>
     */
    this.popperOptions = input({}, {
      alias: 'cTooltipOptions'
    });
    this.#popperOptionsEffect = effect(() => {
      this._popperOptions = {
        ...this._popperOptions,
        placement: this.placement(),
        ...this.popperOptions()
      };
    });
    this.popperOptionsComputed = computed(() => {
      return {
        placement: this.placement(),
        ...this._popperOptions
      };
    });
    /**
     * Describes the placement of your component after Popper.js has applied all the modifiers that may have flipped or altered the originally provided placement property.
     * @return: 'top' | 'bottom' | 'left' | 'right'
     * @default: 'top'
     */
    this.placement = input('top', {
      alias: 'cTooltipPlacement'
    });
    /**
     * ElementRefDirective for positioning the tooltip on reference element
     * @return: ElementRefDirective
     * @default: undefined
     */
    this.reference = input(undefined, {
      alias: 'cTooltipRef'
    });
    this.referenceRef = computed(() => this.reference()?.elementRef ?? this.#hostElement);
    /**
     * Sets which event handlers you’d like provided to your toggle prop. You can specify one trigger or an array of them.
     * @return: 'Triggers | Triggers[]
     */
    this.trigger = input('hover', {
      alias: 'cTooltipTrigger'
    });
    /**
     * Toggle the visibility of tooltip component.
     * @return boolean
     */
    this.visible = model(false, {
      alias: 'cTooltipVisible'
    });
    this.#visibleEffect = effect(() => {
      this.visible() ? this.addTooltipElement() : this.removeTooltipElement();
    });
    this._popperOptions = {
      modifiers: [{
        name: 'offset',
        options: {
          offset: [0, 5]
        }
      }]
    };
  }
  #renderer;
  #hostElement;
  #viewContainerRef;
  #listenersService;
  #changeDetectorRef;
  #intersectionService;
  #destroyRef;
  #document;
  #contentEffect;
  #popperOptionsEffect;
  #visibleEffect;
  get ariaDescribedBy() {
    return this.tooltipId ? this.tooltipId : null;
  }
  ngAfterViewInit() {
    this.intersectionServiceSubscribe();
  }
  ngOnDestroy() {
    this.clearListeners();
    this.destroyTooltipElement();
  }
  ngOnInit() {
    this.setListeners();
  }
  setListeners() {
    const config = {
      hostElement: this.#hostElement,
      trigger: this.trigger(),
      callbackToggle: () => {
        this.visible.update(value => !value);
      },
      callbackOff: () => {
        this.visible.set(false);
      },
      callbackOn: () => {
        this.visible.set(true);
      }
    };
    this.#listenersService.setListeners(config);
  }
  clearListeners() {
    this.#listenersService.clearListeners();
  }
  intersectionServiceSubscribe() {
    this.#intersectionService.createIntersectionObserver(this.referenceRef());
    this.#intersectionService.intersecting$.pipe(filter(next => next.hostElement === this.referenceRef()), debounceTime(100), finalize(() => {
      this.#intersectionService.unobserve(this.referenceRef());
    }), takeUntilDestroyed(this.#destroyRef)).subscribe(next => {
      this.visible.set(next.isIntersecting ? this.visible() : false);
    });
  }
  getUID(prefix) {
    let uid = prefix ?? 'random-id';
    do {
      uid = `${prefix}-${Math.floor(Math.random() * 1000000).toString(10)}`;
    } while (this.#document.getElementById(uid));
    return uid;
  }
  createTooltipElement() {
    if (!this.tooltipRef) {
      this.tooltipRef = this.#viewContainerRef.createComponent(TooltipComponent);
      // this.viewContainerRef.detach();
    }
  }
  destroyTooltipElement() {
    this.tooltip?.remove();
    this.tooltipRef?.destroy();
    // @ts-ignore
    this.tooltipRef = undefined;
    this.popperInstance?.destroy();
    this.#viewContainerRef?.detach();
    this.#viewContainerRef?.clear();
  }
  addTooltipElement() {
    if (!this.content()) {
      this.destroyTooltipElement();
      return;
    }
    if (!this.tooltipRef) {
      this.createTooltipElement();
    }
    this.tooltipRef?.setInput('content', this.content() ?? '');
    this.tooltip = this.tooltipRef?.location.nativeElement;
    this.#renderer.addClass(this.tooltip, 'd-none');
    this.#renderer.addClass(this.tooltip, 'fade');
    this.popperInstance?.destroy();
    this.#viewContainerRef.insert(this.tooltipRef.hostView);
    this.#renderer.appendChild(this.#document.body, this.tooltip);
    this.popperInstance = createPopper(this.referenceRef().nativeElement, this.tooltip, {
      ...this.popperOptionsComputed()
    });
    if (!this.visible()) {
      this.removeTooltipElement();
      return;
    }
    setTimeout(() => {
      this.tooltipId = this.getUID('tooltip');
      this.tooltipRef?.setInput('id', this.tooltipId);
      this.#renderer.removeClass(this.tooltip, 'd-none');
      this.tooltipRef?.setInput('visible', this.visible());
      this.popperInstance?.forceUpdate();
      this.#changeDetectorRef?.markForCheck();
    }, 100);
  }
  removeTooltipElement() {
    this.tooltipId = '';
    if (!this.tooltipRef) {
      return;
    }
    this.tooltipRef.setInput('visible', false);
    this.tooltipRef.setInput('id', undefined);
    this.#changeDetectorRef.markForCheck();
    setTimeout(() => {
      this.#viewContainerRef?.detach();
    }, 300);
  }
  static {
    this.ɵfac = function TooltipDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TooltipDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: TooltipDirective,
      selectors: [["", "cTooltip", ""]],
      hostVars: 1,
      hostBindings: function TooltipDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("aria-describedby", ctx.ariaDescribedBy);
        }
      },
      inputs: {
        content: [1, "cTooltip", "content"],
        popperOptions: [1, "cTooltipOptions", "popperOptions"],
        placement: [1, "cTooltipPlacement", "placement"],
        reference: [1, "cTooltipRef", "reference"],
        trigger: [1, "cTooltipTrigger", "trigger"],
        visible: [1, "cTooltipVisible", "visible"]
      },
      outputs: {
        visible: "cTooltipVisibleChange"
      },
      exportAs: ["cTooltip"],
      features: [i0.ɵɵProvidersFeature([ListenersService, IntersectionService])]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TooltipDirective, [{
    type: Directive,
    args: [{
      selector: '[cTooltip]',
      exportAs: 'cTooltip',
      providers: [ListenersService, IntersectionService],
      host: {
        '[attr.aria-describedby]': 'ariaDescribedBy'
      }
    }]
  }], null, null);
})();
class TooltipModule {
  static {
    this.ɵfac = function TooltipModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TooltipModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: TooltipModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TooltipModule, [{
    type: NgModule,
    args: [{
      exports: [TooltipComponent, TooltipDirective],
      imports: [TooltipComponent, TooltipDirective]
    }]
  }], null, null);
})();
class RatingItemLabelComponent {
  constructor() {
    this.#elementRef = inject(ElementRef);
    this.#renderer = inject(Renderer2);
    this.label = input('');
    this.value = input.required();
    this.focusable = signal(false);
    this.focusableEffect = effect(() => {
      this.#renderer.setAttribute(this.#elementRef.nativeElement, 'tabindex', this.focusable() ? '0' : '-1');
    });
  }
  #elementRef;
  #renderer;
  // @HostBinding('attr.tabindex')
  // get tabIndex() {
  //   // console.log('active', this.active(), this.active() ? '0' : '-1')
  //   console.log('focusable', this.value(), this.focusable(), this.focusable() ? '0' : '-1');
  //   return this.focusable() ? '0' : '-1';
  // }
  focus(origin) {
    this.#elementRef.nativeElement.focus();
  }
  getLabel() {
    return this.label() || this.value().toString();
  }
  static {
    this.ɵfac = function RatingItemLabelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RatingItemLabelComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: RatingItemLabelComponent,
      selectors: [["c-rating-item-label"]],
      inputs: {
        label: [1, "label"],
        value: [1, "value"]
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function RatingItemLabelComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RatingItemLabelComponent, [{
    type: Component,
    args: [{
      selector: 'c-rating-item-label',
      standalone: true,
      template: '<ng-content />'
    }]
  }], null, null);
})();
const coerceStringArray = value => Array.isArray(value) ? [...value] : [value];
const coerceRatingPrecision = value => [1, 0.5, 0.25].includes(numberAttribute(value)) ? numberAttribute(value) : 1;
const coerceNumber = value => Number(value ?? 0);
class RatingComponent {
  constructor() {
    this.#destroyRef = inject(DestroyRef);
    this.#elementRef = inject(ElementRef);
    /**
     * The default icon to display when the item is selected.
     * @type: string | string[]
     */
    this.activeIcon = input([], {
      transform: coerceStringArray
    });
    /**
     * Enables the clearing upon clicking the selected item again.
     * @type: boolean
     * @default: false
     */
    this.allowClear = input(false, {
      transform: booleanAttribute
    });
    /**
     * Toggle the disabled state for the component.
     * @type: boolean
     * @default: false
     */
    this.disabled = input(false, {
      transform: booleanAttribute
    });
    this.#disabledState = signal(this.disabled());
    /**
     * If enabled, only the currently selected icon will be visibly highlighted.
     * @type: boolean
     * @default: false
     */
    this.highlightOnlySelected = input(false, {
      transform: booleanAttribute
    });
    /**
     * The default icon to display when the item is not selected.
     * @type: string | string[]
     */
    this.icon = input([], {
      transform: coerceStringArray
    });
    /**
     * Specifies the total number of stars to be displayed in the star rating component. This property determines the scale of the rating,
     * such as out of 5 stars, 10 stars, etc.
     * @type: number
     * @default: 5
     */
    this.itemCount = input(5, {
      transform: numberAttribute
    });
    /**
     * Minimum increment value change allowed.
     * @type: number
     * @default: 1
     */
    this.precision = input(1, {
      transform: numberAttribute
    });
    /**
     * Allows to click fractions
     * @type: boolean
     * @default: false
     */
    // readonly precisionClick = input(false, { transform: booleanAttribute });
    /**
     * Toggle the readonly state for the component.
     * @type: boolean
     * @default: false
     */
    this.readOnly = input(false, {
      transform: booleanAttribute
    });
    /**
     * Size the component small, large, or custom if you define custom icons with custom height.
     * @type: 'sm' | 'lg' | 'custom' | undefined
     * @default: undefined
     */
    this.size = input(undefined);
    /**
     * Enable tooltips with default values or set specific labels for each icon.
     * @type: boolean | string[] | undefined
     * @default: undefined
     */
    this.tooltips = input(undefined);
    /**
     * The `value` attribute of component.
     * @type: number | null
     * @default: null
     * Emits `valueChange` on value change
     */
    this.value = model(null);
    /**
     * Event emitted on hoverValue change.
     * @type: number | null
     */
    this.hoverValue = signal(null);
    this.hoverValueChange = output();
    this.hoverValueEffect = effect(() => {
      this.hoverValueChange.emit(this.hoverValue());
      if (!this.hoverValue()) {
        this.hoveredItem.set(undefined);
      }
    });
    this.#cleared = signal(false);
    this.hoveredItem = signal(undefined);
    this.tooltipValue = signal(null);
    this.ratingDisabled = computed(() => this.disabled() || this.readOnly() || this.#disabledState());
    this.ratingDisabledEffect = effect(() => {
      if (!this.ratingDisabled()) {
        const focusIn$ = fromEvent(this.#elementRef.nativeElement, 'focusin');
        const focusOut$ = fromEvent(this.#elementRef.nativeElement, 'focusout');
        const mouseLeave$ = fromEvent(this.#elementRef.nativeElement, 'mouseleave');
        merge(focusIn$, focusOut$, mouseLeave$).pipe(filter(event => !this.ratingDisabled()), tap($event => {
          switch ($event.type) {
            case 'focusin':
              this.onTouched();
              break;
            case 'focusout':
            case 'mouseleave':
              this.hoverValue.set(null);
              break;
          }
        }), takeWhile(() => !this.ratingDisabled()), takeUntilDestroyed(this.#destroyRef)).subscribe();
      }
    });
    this.contentTemplates = contentChildren(TemplateIdDirective);
    this.iconTemplates = computed(() => {
      const templateArray = this.contentTemplates().map(child => {
        return [[child.id], child.templateRef];
      });
      return Object.fromEntries(templateArray);
    });
    this.numberOfSubItems = computed(() => {
      return parseInt((1 / this.precision()).toFixed());
    });
    this.ratingItems = computed(() => {
      return Array.from({
        length: this.itemCount()
      }, (_, itemIndex) => {
        if (this.numberOfSubItems() === 1) {
          return [itemIndex + 1];
        }
        return Array.from({
          length: this.numberOfSubItems()
        }, (_, subIndex) => itemIndex + (subIndex + 1) * this.precision());
      });
    });
    this.ratingItemLabels = viewChildren(RatingItemLabelComponent);
    this.ratingItemLabelsEffect = effect(() => {
      if (untracked(this.ratingDisabled)) {
        return;
      }
      this.#focusKeyManager = new FocusKeyManager(this.ratingItemLabels()).withHorizontalOrientation('ltr').withWrap();
      const activeItemIndex = this.ratingItems().flat().findIndex(value => value === coerceNumber(this.value() ?? 0));
      this.#focusKeyManager?.updateActiveItem(activeItemIndex < 0 ? 0 : activeItemIndex);
      this.#focusKeyManager.tabOut.pipe(tap(x => {
        const activeItemIndex = untracked(this.ratingItems).flat().findIndex(value => value === coerceNumber(untracked(this.value) ?? 0));
        this.#focusKeyManager.updateActiveItem(activeItemIndex === -1 ? 0 : activeItemIndex);
        this.updateFocusableItems();
      }), takeUntilDestroyed(this.#destroyRef)).subscribe();
      this.#focusKeyManager.change.pipe(tap(value => {
        this.ratingItemLabels().forEach((label, index) => {
          label.focusable.set(index === this.#focusKeyManager.activeItemIndex);
          if (index === this.#focusKeyManager.activeItemIndex) {
            const value = untracked(label.value);
            this.handleClick(value);
          }
        });
      }), takeUntilDestroyed(this.#destroyRef)).subscribe();
    });
    this.onChange = value => {
      /* empty */
    };
    this.onTouched = () => {
      /* empty */
    };
    // keep it at the bottom of the code
    this.valueEffect = effect(() => {
      const ratingValue = this.value();
      this.onChange(ratingValue);
      if (untracked(this.ratingDisabled)) {
        return;
      }
      if (untracked(this.#cleared)) {
        this.#cleared.set(false);
        return;
      }
      const activeItemIndex = this.ratingItems().flat().findIndex(value => value === coerceNumber(ratingValue ?? 0));
      this.#focusKeyManager?.updateActiveItem(activeItemIndex < 0 ? 0 : activeItemIndex);
      this.updateFocusableItems();
    });
  }
  #destroyRef;
  #elementRef;
  #disabledState;
  #cleared;
  #focusKeyManager;
  get hostClasses() {
    return {
      rating: true,
      [`rating-${this.size()}`]: this.size(),
      disabled: this.disabled() || this.#disabledState(),
      readonly: this.readOnly()
    };
  }
  get ariaValueNow() {
    return this.value();
  }
  get ariaValueMax() {
    return this.itemCount();
  }
  get role() {
    return 'radiogroup';
  }
  onKeydown($event) {
    if (this.ratingDisabled()) {
      return false;
    }
    if (['Space', 'Enter'].includes($event.code)) {
      $event.preventDefault();
      const item = this.ratingItemLabels().find((label, index) => index === this.#focusKeyManager?.activeItemIndex);
      this.handleClick(item?.value() ?? -1);
      return;
    }
    if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes($event.key)) {
      this.#focusKeyManager.onKeydown($event);
      return;
    }
    if (['Tab'].includes($event.key)) {
      this.#focusKeyManager?.tabOut.next();
    }
    return;
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled) {
    this.#disabledState.set(isDisabled);
  }
  writeValue(value) {
    this.value.set(value);
  }
  isItemActive(value) {
    const localValue = this.hoverValue() ?? this.value() ?? -1;
    return this.highlightOnlySelected() ? localValue === value : localValue >= value;
  }
  notLastItemStyle(value) {
    return {
      zIndex: this.numberOfSubItems() - value,
      position: 'absolute',
      width: `${this.precision() * (value + 1) * 100}%`,
      overflow: 'hidden',
      opacity: 0.1
    };
  }
  handleFocusIn($event, itemValue) {
    this.handleMouseEnter($event, itemValue);
  }
  handleClick(value) {
    if (this.ratingDisabled()) {
      return;
    }
    if (this.allowClear() && value === this.value()) {
      this.#cleared.set(true);
      this.value.set(null);
      this.hoverValue.set(null);
    } else {
      this.value.set(value);
    }
  }
  handleMouseEnter($event, value) {
    if (this.ratingDisabled()) {
      return;
    }
    this.hoverValue.set(null);
    this.hoverValue.set(value);
    this.tooltipValue.set(value);
  }
  getTooltipValue(index) {
    if (!this.hoverValue() || this.hoveredItem() !== index) {
      return undefined;
    }
    if (Array.isArray(this.tooltips())) {
      const tooltips = this.tooltips();
      return tooltips[index];
    }
    return this.precision() ? this.tooltipValue()?.toString() ?? '' : this.ratingItems() ? (this.ratingItems()[index].at(-1) ?? '').toString() : '';
  }
  updateFocusableItems() {
    this.ratingItemLabels().forEach((label, index) => {
      label.focusable.set(index === this.#focusKeyManager?.activeItemIndex);
    });
  }
  static {
    this.ɵfac = function RatingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RatingComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: RatingComponent,
      selectors: [["c-rating"]],
      contentQueries: function RatingComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.contentTemplates, TemplateIdDirective, 4);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      viewQuery: function RatingComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuerySignal(ctx.ratingItemLabels, RatingItemLabelComponent, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      hostVars: 5,
      hostBindings: function RatingComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown", function RatingComponent_keydown_HostBindingHandler($event) {
            return ctx.onKeydown($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("aria-valuenow", ctx.ariaValueNow)("aria-valuemax", ctx.ariaValueMax)("role", ctx.role);
          i0.ɵɵclassMap(ctx.hostClasses);
        }
      },
      inputs: {
        activeIcon: [1, "activeIcon"],
        allowClear: [1, "allowClear"],
        disabled: [1, "disabled"],
        highlightOnlySelected: [1, "highlightOnlySelected"],
        icon: [1, "icon"],
        itemCount: [1, "itemCount"],
        precision: [1, "precision"],
        readOnly: [1, "readOnly"],
        size: [1, "size"],
        tooltips: [1, "tooltips"],
        value: [1, "value"]
      },
      outputs: {
        value: "valueChange",
        hoverValueChange: "hoverValueChange"
      },
      exportAs: ["cRating"],
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => RatingComponent),
        multi: true
      }])],
      decls: 12,
      vars: 0,
      consts: [["ratingItemLabel", ""], ["tooltipContent", ""], ["defaultIconTemplate", ""], ["customIconTemplate", ""], ["customIconActiveTemplate", ""], [1, "rating-item", 3, "cTooltip", "cTooltipTrigger"], [1, "rating-item"], [1, "rating-item", 3, "mouseenter", "focusin", "cTooltip", "cTooltipTrigger"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["role", "radio", 1, "rating-item-label", "d-inline-block", 3, "ngClass", "ngStyle", "value"], ["role", "radio", 1, "rating-item-label", "d-inline-block", 3, "click", "focus", "mouseenter", "ngClass", "ngStyle", "value"], [4, "ngTemplateOutlet"], [1, "rating-item-icon"], [1, "rating-item-custom-icon"], [1, "rating-item-custom-icon-active"]],
      template: function RatingComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵrepeaterCreate(0, RatingComponent_For_1_Template, 2, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
          i0.ɵɵtemplate(2, RatingComponent_ng_template_2_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(4, RatingComponent_ng_template_4_Template, 2, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(6, RatingComponent_ng_template_6_Template, 1, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(8, RatingComponent_ng_template_8_Template, 2, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(10, RatingComponent_ng_template_10_Template, 2, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵrepeater(ctx.ratingItems());
        }
      },
      dependencies: () => [NgClass, NgStyle, NgTemplateOutlet, TooltipDirective, RatingItemLabelComponent],
      styles: ["[_nghost-%COMP%]{display:inline-flex}:is(.disabled[_nghost-%COMP%], .readonly[_nghost-%COMP%])   .rating-item-label[_ngcontent-%COMP%]{cursor:default}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RatingComponent, [{
    type: Component,
    args: [{
      selector: 'c-rating',
      exportAs: 'cRating',
      imports: [NgClass, NgStyle, NgTemplateOutlet, forwardRef(() => TooltipDirective), RatingItemLabelComponent],
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => RatingComponent),
        multi: true
      }],
      template: "@for (item of ratingItems(); track item; let itemIndex = $index, last = $last) {\n  @if (tooltips()) {\n    <div\n      class=\"rating-item\"\n      [cTooltip]=\"getTooltipValue(itemIndex)\"\n      [cTooltipTrigger]=\"['hover', 'focusin']\"\n      (mouseenter)=\"hoveredItem.set(itemIndex)\"\n      (focusin)=\"hoveredItem.set(itemIndex)\"\n    >\n      <ng-container *ngTemplateOutlet=\"ratingItemLabel; context: { $implicit: item, itemIndex }\" />\n    </div>\n  } @else {\n    <div class=\"rating-item\">\n      <ng-container *ngTemplateOutlet=\"ratingItemLabel; context: { $implicit: item, itemIndex }\" />\n    </div>\n  }\n}\n\n<ng-template let-item let-itemIndex=\"itemIndex\" #ratingItemLabel>\n  @for (itemValue of item; track radioIndex; let radioIndex = $index, last = $last) {\n    <c-rating-item-label\n      class=\"rating-item-label d-inline-block\"\n      role=\"radio\"\n      (click)=\"handleClick(itemValue)\"\n      (focus)=\"handleFocusIn($event, itemValue)\"\n      [ngClass]=\"{ active: isItemActive(itemValue) }\"\n      (mouseenter)=\"handleMouseEnter($event, itemValue)\"\n      [ngStyle]=\"radioIndex + 1 < numberOfSubItems() ? notLastItemStyle(radioIndex) : {}\"\n      [value]=\"itemValue\"\n      [attr.aria-label]=\"itemValue\"\n      [attr.aria-checked]=\"itemValue === value()\"\n    >\n      @if (iconTemplates()[icon()[itemIndex] ?? icon()]) {\n        <ng-container *ngTemplateOutlet=\"customIconTemplate; context: { $implicit: icon()?.[itemIndex] ?? icon() }\" />\n      } @else {\n        <ng-container *ngTemplateOutlet=\"defaultIconTemplate\" />\n      }\n      @if (iconTemplates()[activeIcon()[itemIndex] ?? activeIcon()]) {\n        <ng-container *ngTemplateOutlet=\"customIconActiveTemplate; context: { $implicit: activeIcon()?.[itemIndex] ?? activeIcon() }\" />\n      }\n    </c-rating-item-label>\n  }\n</ng-template>\n\n<ng-template #tooltipContent>\n  <span>{{ hoverValue() }}</span>\n</ng-template>\n\n<ng-template #defaultIconTemplate>\n  <div class=\"rating-item-icon\"></div>\n</ng-template>\n\n<ng-template #customIconTemplate let-icon>\n  <div class=\"rating-item-custom-icon\">\n    <ng-container *ngTemplateOutlet=\"iconTemplates()?.[icon] || defaultIconTemplate\" />\n  </div>\n</ng-template>\n\n<ng-template #customIconActiveTemplate let-icon>\n  <div class=\"rating-item-custom-icon-active\">\n    <ng-container *ngTemplateOutlet=\"iconTemplates()?.[icon] || customIconTemplate\" />\n  </div>\n</ng-template>\n",
      styles: [":host{display:inline-flex}:is(:host.disabled,:host.readonly) .rating-item-label{cursor:default}\n"]
    }]
  }], null, {
    hostClasses: [{
      type: HostBinding,
      args: ['class']
    }],
    ariaValueNow: [{
      type: HostBinding,
      args: ['attr.aria-valuenow']
    }],
    ariaValueMax: [{
      type: HostBinding,
      args: ['attr.aria-valuemax']
    }],
    role: [{
      type: HostBinding,
      args: ['attr.role']
    }],
    onKeydown: [{
      type: HostListener,
      args: ['keydown', ['$event']]
    }]
  });
})();
class RatingModule {
  static {
    this.ɵfac = function RatingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RatingModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: RatingModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RatingModule, [{
    type: NgModule,
    args: [{
      imports: [RatingComponent],
      exports: [RatingComponent]
    }]
  }], null, null);
})();
const calculateClickValue = (event, container, min, max, step, vertical, rtl) => {
  const clickPosition = getClickPosition(event, container, vertical, rtl);
  const value = min + clickPosition * (max - min);
  return roundToStep(value, step);
};
const calculateMoveValue = (event, container, min, max, step, vertical, rtl) => {
  const rect = container.getBoundingClientRect();
  const position = vertical ? calculateVerticalPosition(event.clientY, rect) : calculateHorizontalPosition(event.clientX, rect, rtl);
  if (typeof position === 'string') {
    return position === 'max' ? max : min;
  }
  const value = min + position * (max - min);
  return roundToStep(value, step);
};
const calculateVerticalPosition = (mouseY, rect) => {
  if (mouseY < rect.top) {
    return 'max';
  }
  if (mouseY > rect.bottom) {
    return 'min';
  }
  return Math.min(Math.max((rect.bottom - mouseY) / rect.height, 0), 1);
};
const calculateHorizontalPosition = (mouseX, rect, rtl) => {
  if (mouseX < rect.left) {
    return rtl ? 'max' : 'min';
  }
  if (mouseX > rect.right) {
    return rtl ? 'min' : 'max';
  }
  const relativeX = rtl ? rect.right - mouseX : mouseX - rect.left;
  return Math.min(Math.max(relativeX / rect.width, 0), 1);
};
const calculateLabelPosition = (min, max, labels, label, index) => {
  if (typeof label === 'object' && 'value' in label) {
    return `${(label.value - min) / (max - min) * 100}%`;
  }
  return `${index / (labels.length - 1) * 100}%`;
};
const calculateTooltipPosition = (min, max, value, thumbSize, vertical, rtl) => {
  const percent = (value - min) / (max - min);
  const margin = percent > 0.5 ? `-${(percent - 0.5) * thumbSize.value}${thumbSize.unit}` : `${(0.5 - percent) * thumbSize.value}${thumbSize.unit}`;
  if (vertical) {
    return {
      bottom: `${percent * 100}%`,
      marginBottom: margin
    };
  }
  return rtl ? {
    right: `${percent * 100}%`,
    marginRight: margin
  } : {
    left: `${percent * 100}%`,
    marginLeft: margin
  };
};
const getClickPosition = (event, container, vertical, rtl) => {
  const {
    offsetX,
    offsetY
  } = event;
  const {
    offsetWidth,
    offsetHeight
  } = container;
  if (vertical) {
    return 1 - offsetY / offsetHeight;
  }
  return rtl ? 1 - offsetX / offsetWidth : offsetX / offsetWidth;
};
const getLabelValue = (min, max, labels, label, index) => typeof label === 'object' && 'value' in label ? label.value : min + index / (labels.length - 1) * (max - min);
const getNearestValueIndex = (value, values) => {
  const valuesLength = values.length;
  if (value < values[0]) {
    return 0;
  }
  if (value > values[valuesLength - 1]) {
    return valuesLength - 1;
  }
  const distances = values.map(v => Math.abs(v - value));
  const min = Math.min(...distances);
  const firstIndex = distances.indexOf(min);
  return value < values[firstIndex] ? firstIndex : distances.lastIndexOf(min);
};
const roundToStep = (number, step) => {
  const _step = step === 0 ? 1 : step;
  return Math.round(number / _step) * _step;
};
const updateGradient = (min, max, values, vertical, rtl) => {
  const minVal = Math.min(...values);
  const maxVal = Math.max(...values);
  const from = (minVal - min) / (max - min) * 100;
  const to = (maxVal - min) / (max - min) * 100;
  const direction = vertical ? 'to top' : rtl ? 'to left' : 'to right';
  return {
    backgroundImage: values.length === 1 ? `linear-gradient(
    ${direction},
    var(--cui-range-slider-track-in-range-bg) 0%,
    var(--cui-range-slider-track-in-range-bg) ${to}%,
    transparent ${to}%,
    transparent 100%
  )` : `linear-gradient(
    ${direction},
    transparent 0%,
    transparent ${from}%,
    var(--cui-range-slider-track-in-range-bg) ${from}%,
    var(--cui-range-slider-track-in-range-bg) ${to}%,
    transparent ${to}%,
    transparent 100%
  )`
  };
};
const updateValue = (value, values, distance, index) => {
  const newValue = [...values];
  newValue[index] = validateValue(value, values, distance, index);
  return newValue;
};
const validateValue = (value, values, distance, index) => {
  // If there's only one value, return it as is
  if (values.length === 1) {
    return value;
  }
  // Determine previous and next values if they exist
  const prevValue = index > 0 ? values[index - 1] : undefined;
  const nextValue = index < values.length - 1 ? values[index + 1] : undefined;
  // If it's the first element, ensure it's not too close to the next value
  if (index === 0 && nextValue !== undefined) {
    return Math.min(value, nextValue - distance);
  }
  // If it's the last element, ensure it's not too close to the previous value
  if (index === values.length - 1 && prevValue !== undefined) {
    return Math.max(value, prevValue + distance);
  }
  // For middle elements, ensure the value is within the allowed distance from both neighbors
  if (prevValue !== undefined && nextValue !== undefined) {
    const minVal = prevValue + distance;
    const maxVal = nextValue - distance;
    return Math.min(Math.max(value, minVal), maxVal);
  }
  // Fallback: If for some reason prevValue or nextValue is undefined, return the original value
  return value;
};
const equalArrays = (a, b) => a.length === b.length && a.every((element, index) => element === b[index]);
class RangeSliderTrackPipe {
  transform(value, min, max, vertical, rtl = false) {
    return updateGradient(min, max, value, vertical, rtl);
  }
  static {
    this.ɵfac = function RangeSliderTrackPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RangeSliderTrackPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "rangeSliderTrack",
      type: RangeSliderTrackPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RangeSliderTrackPipe, [{
    type: Pipe,
    args: [{
      name: 'rangeSliderTrack'
    }]
  }], null, null);
})();
class RangeSliderLabelStylePipe {
  transform(label, min, max, vertical, labels, index, isRTL = false) {
    const labelPosition = calculateLabelPosition(min, max, labels, label, index);
    return Object.assign(vertical ? {
      bottom: labelPosition
    } : isRTL ? {
      right: labelPosition
    } : {
      left: labelPosition
    }, typeof label === 'object' && 'style' in label && label.style);
  }
  static {
    this.ɵfac = function RangeSliderLabelStylePipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RangeSliderLabelStylePipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "rangeSliderLabelStyle",
      type: RangeSliderLabelStylePipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RangeSliderLabelStylePipe, [{
    type: Pipe,
    args: [{
      name: 'rangeSliderLabelStyle'
    }]
  }], null, null);
})();
class RangeSliderLabelClassPipe {
  transform(label, clickableLabels) {
    const classes = {
      'range-slider-label': true,
      clickable: clickableLabels
    };
    const labelClasses = typeof label === 'object' && 'class' in label && label.class;
    let classObj = {};
    if (typeof labelClasses === 'string') {
      classObj = {
        [labelClasses]: true
      };
    } else if (Array.isArray(labelClasses)) {
      classObj = labelClasses.reduce((acc, labelClass) => ({
        ...acc,
        [labelClass]: true
      }), {});
    } else if (labelClasses instanceof Set) {
      classObj = Array.from(labelClasses).reduce((acc, labelClass) => ({
        ...acc,
        [labelClass]: true
      }), {});
    } else if (typeof labelClasses === 'object') {
      classObj = labelClasses;
    }
    return {
      ...classes,
      ...classObj
    };
  }
  static {
    this.ɵfac = function RangeSliderLabelClassPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RangeSliderLabelClassPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "rangeSliderLabelClass",
      type: RangeSliderLabelClassPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RangeSliderLabelClassPipe, [{
    type: Pipe,
    args: [{
      name: 'rangeSliderLabelClass'
    }]
  }], null, null);
})();
class RangeSliderTooltipPositionStylePipe {
  transform(value, min, max, vertical, thumbSize, rtl = false) {
    return thumbSize ? calculateTooltipPosition(min, max, value, thumbSize, vertical, rtl) : null;
  }
  static {
    this.ɵfac = function RangeSliderTooltipPositionStylePipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RangeSliderTooltipPositionStylePipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "rangeSliderTooltipPositionStyle",
      type: RangeSliderTooltipPositionStylePipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RangeSliderTooltipPositionStylePipe, [{
    type: Pipe,
    args: [{
      name: 'rangeSliderTooltipPositionStyle'
    }]
  }], null, null);
})();
class RangeSliderComponent {
  #destroyRef;
  #document;
  #elementRef;
  #UIDService;
  #RtlService;
  #value$;
  #getThumbSize;
  constructor() {
    this.#destroyRef = inject(DestroyRef);
    this.#document = inject(DOCUMENT);
    this.#elementRef = inject(ElementRef);
    this.#UIDService = inject(UIDService);
    this.#RtlService = inject(RtlService);
    /**
     * Enable or disable clickable labels in the Angular Range Slider.
     * When set to `true`, users can click on labels to adjust the slider's value directly, enhancing interactivity and user experience.
     * @default true
     */
    this.clickableLabels = input(true, {
      transform: booleanAttribute
    });
    /**
     * Control the interactive state of the Angular Range Slider with the `disabled` prop.
     * Setting it to `true` will disable all slider functionalities, preventing user interaction and visually indicating a non-interactive state.
     * @default false
     */
    this.disabled = input(false, {
      transform: booleanAttribute
    });
    this.disabledState = linkedSignal({
      source: this.disabled,
      computation: isDisabled => {
        this.#elementRef.nativeElement.disabled = isDisabled;
        return isDisabled;
        // return isDisabled ? isDisabled : null;
      }
    });
    /**
     * Define the minimum distance between slider handles using the `distance` prop in the Angular Range Slider.
     * This ensures that the handles maintain a specified separation, preventing overlap and maintaining clear value distinctions.
     * @default 0
     */
    this.distance = input(0, {
      transform: numberAttribute
    });
    /**
     * Add descriptive labels to your Angular Range Slider by providing an array of `labels`.
     * These labels enhance the slider's usability by clearly indicating key values and providing contextual information to users.
     */
    this.labels = input([]);
    /**
     * Specify the maximum value for the Angular Range Slider with the `max` prop.
     * This determines the upper limit of the slider's range, enabling precise control over the highest selectable value.
     * @default 100
     */
    this.max = input(100, {
      transform: numberAttribute
    });
    /**
     * Set the minimum value for the Angular Range Slider using the `min` prop.
     * This defines the lower bound of the slider's range, allowing you to control the starting point of user selection.
     * @default 0
     */
    this.min = input(0, {
      transform: numberAttribute
    });
    /**
     * Default role for c-range-slider.
     * @default 'slider'
     */
    this.role = input('slider');
    /**
     * Control the granularity of the Angular Range Slider by setting the `step` prop.
     * This defines the increment intervals between selectable values, allowing for precise adjustments based on your application's requirements.
     * @default 1
     */
    this.step = input(1, {
      transform: numberAttribute
    });
    /**
     * Toggle the visibility of tooltips in the Angular Range Slider with the `tooltips` prop.
     * When enabled, tooltips display the current value of the slider handles, providing real-time feedback to users.
     * @default true
     */
    this.tooltips = input(true, {
      transform: booleanAttribute
    });
    /**
     * Customize the display format of tooltips in the Angular Range Slider using the `tooltipsFormat` function.
     * This allows you to format the tooltip values according to your specific requirements, enhancing the clarity and presentation of information.
     */
    this.tooltipsFormat = input();
    /**
     * Controls the visual representation of the slider's track. When set to `'fill'`, the track is dynamically filled based on the slider's value(s).
     * Setting it to `false` disables the filled track.
     * @default 'fill'
     */
    this.track = input('fill');
    /**
     * Set the current value(s) of the Angular Range Slider using the `value` prop.
     * Whether you're using a single value or an array for multi-handle sliders, this prop controls the slider's position and ensures it reflects the desired state.
     */
    this.value = model([]);
    this.valueChange = output();
    this.currentValue = computed(() => {
      const value = this.value();
      return Array.isArray(value) ? [...value] : [value];
    }
    // { equal: equalArrays }
    );
    this.valueEffect = effect(() => {
      const currentValue = this.currentValue();
      const inputRefs = this.inputRefs();
      if (inputRefs.length) {
        inputRefs.forEach((inputRef, index) => {
          inputRef.nativeElement.value = currentValue[index].toString();
        });
      }
      this.#value$.next(currentValue);
    });
    this.#value$ = new BehaviorSubject(this.currentValue());
    this.valueNow = computed(() => {
      const value = this.currentValue();
      return value.length === 1 ? value[0] : [...value];
    });
    this.inputIds = signal([]);
    this.inputIdsEffect = effect(() => {
      const sliders = this.currentValue().length;
      const inputIds = untracked(this.inputIds);
      if (sliders > 0) {
        const ids = new Array(sliders).fill(undefined);
        for (let i = 0; i < sliders; i++) {
          ids[i] = inputIds[i] ?? this.#UIDService.getUID(`range-slider-input-${i}`);
        }
        this.inputIds.set([...ids]);
      }
    });
    /**
     * Orient the Angular Range Slider vertically by setting the `vertical` prop to `true`.
     * This changes the slider's layout from horizontal to vertical, providing a different aesthetic and fitting various UI designs.
     */
    this.vertical = input(false, {
      transform: booleanAttribute
    });
    this.hostClasses = computed(() => {
      return {
        'range-slider': true,
        'range-slider-vertical': this.vertical(),
        disabled: this.disabled() || this.disabledState()
      };
    });
    this.inputRefs = viewChildren('inputRef');
    this.trackRef = viewChild('trackRef');
    this.isDragging = signal(false);
    this.dragIndex = signal(0);
    this.thumbSize = signal(null);
    this.isDraggingEffect = effect(onCleanup => {
      const removeEventListeners = () => {
        this.#document.removeEventListener('mousemove', this.handleMouseMove);
        this.#document.removeEventListener('mouseup', this.handleMouseUp);
      };
      onCleanup(removeEventListeners);
      if (this.isDragging()) {
        this.#document.addEventListener('mousemove', this.handleMouseMove);
        this.#document.addEventListener('mouseup', this.handleMouseUp);
      } else {
        removeEventListeners();
      }
    });
    this.#getThumbSize = (element, vertical) => {
      const computedStyles = this.#document.defaultView?.getComputedStyle(element);
      const value = computedStyles?.getPropertyValue(vertical ? '--cui-range-slider-thumb-height' : '--cui-range-slider-thumb-width') ?? '2rem';
      const regex = /^(\d+\.?\d*)([%a-z]*)$/i;
      const match = value?.match(regex);
      if (match) {
        return {
          value: Number.parseFloat(match[1]),
          unit: match[2] || null
        };
      }
      return null;
    };
    this.onChange = value => {
      /* empty */
    };
    this.onTouched = () => {
      /* empty */
    };
    this.updateNearestValue = value => {
      const nearestIndex = getNearestValueIndex(value, this.currentValue());
      const newCurrentValue = [...this.currentValue()];
      newCurrentValue[nearestIndex] = validateValue(value, this.currentValue(), this.distance(), nearestIndex);
      setTimeout(() => {
        this.inputRefs()[nearestIndex].nativeElement.focus();
      });
      this.value.set(newCurrentValue);
    };
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    afterNextRender({
      read: () => {
        setTimeout(() => {
          const thumbSize = this.#getThumbSize(this.#elementRef.nativeElement, this.vertical());
          this.thumbSize.set(thumbSize);
        }, 1000);
      }
    });
  }
  ngOnInit() {
    this.#value$.pipe(debounceTime(300), distinctUntilChanged(equalArrays), takeUntilDestroyed(this.#destroyRef)).subscribe(value => {
      const returnValue = value.length === 1 ? value[0] : [...value];
      this.onChange(returnValue);
      this.onTouched();
      this.valueChange.emit(returnValue);
    });
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled) {
    this.disabledState.set(isDisabled);
    // this.disabledState.set(isDisabled ? isDisabled : null);
  }
  writeValue(value) {
    this.value.set(Array.isArray(value) ? [...value] : [value]);
  }
  get isRtl() {
    return this.#RtlService.isRTL(this.#elementRef.nativeElement);
  }
  handleInputChange(value, index) {
    this.isDragging.set(false);
    const newCurrentValue = updateValue(value, this.currentValue(), this.distance(), index);
    this.value.set([...newCurrentValue]);
  }
  handleInputsContainerMouseDown($event) {
    $event.preventDefault();
    if (!this.trackRef() || $event.button !== 0 || this.disabledState()) {
      return;
    }
    const validTarget = [...this.inputRefs(), this.trackRef()];
    if (!validTarget.find(target => target?.nativeElement === $event.target)) {
      return;
    }
    const clickValue = calculateClickValue($event, this.trackRef()?.nativeElement, this.min(), this.max(), this.step(), this.vertical(), this.isRtl);
    const index = getNearestValueIndex(clickValue, this.currentValue());
    this.isDragging.set(true);
    this.dragIndex.set(index);
    this.updateNearestValue(clickValue);
  }
  handleLabelClick($event, label) {
    if (!this.clickableLabels() || this.disabledState() || $event.button !== 0) {
      return;
    }
    const labelValue = getLabelValue(this.min(), this.max(), this.labels(), label, this.labels().indexOf(label));
    this.updateNearestValue(labelValue);
  }
  getLabel(label) {
    return typeof label === 'object' && 'label' in label ? label.label : label;
  }
  handleMouseMove($event) {
    if (!this.isDragging() || !this.trackRef() || this.disabledState()) {
      return;
    }
    const moveValue = calculateMoveValue($event, this.trackRef()?.nativeElement, this.min(), this.max(), this.step(), this.vertical(), this.isRtl);
    const newCurrentValue = updateValue(moveValue, this.currentValue(), this.distance(), this.dragIndex());
    this.value.set(newCurrentValue);
  }
  handleMouseUp() {
    this.isDragging.set(false);
  }
  static {
    this.ɵfac = function RangeSliderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RangeSliderComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: RangeSliderComponent,
      selectors: [["c-range-slider"]],
      viewQuery: function RangeSliderComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuerySignal(ctx.inputRefs, _c39, 5);
          i0.ɵɵviewQuerySignal(ctx.trackRef, _c40, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance(2);
        }
      },
      hostAttrs: [1, "range-slider"],
      hostVars: 8,
      hostBindings: function RangeSliderComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("disabled", ctx.disabledState() || null)("aria-orientation", ctx.vertical() ? "vertical" : "horizontal")("aria-valuemax", ctx.max())("aria-valuemin", ctx.min())("aria-valuenow", ctx.valueNow())("role", ctx.role());
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        clickableLabels: [1, "clickableLabels"],
        disabled: [1, "disabled"],
        distance: [1, "distance"],
        labels: [1, "labels"],
        max: [1, "max"],
        min: [1, "min"],
        role: [1, "role"],
        step: [1, "step"],
        tooltips: [1, "tooltips"],
        tooltipsFormat: [1, "tooltipsFormat"],
        track: [1, "track"],
        value: [1, "value"],
        vertical: [1, "vertical"]
      },
      outputs: {
        value: "valueChange",
        valueChange: "valueChange"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => RangeSliderComponent),
        multi: true
      }])],
      decls: 6,
      vars: 2,
      consts: [["inputRef", ""], ["trackRef", ""], ["labelsContainerRef", ""], ["labelRef", ""], [1, "range-slider-inputs-container", 3, "mousedown"], [1, "range-slider-track", 3, "ngStyle"], [1, "range-slider-track"], [1, "range-slider-labels-container"], ["type", "range", "role", "slider", 1, "range-slider-input", 3, "ngModelChange", "min", "max", "step", "value", "disabled", "ngModel"], [1, "range-slider-tooltip", 3, "ngStyle"], [1, "range-slider-tooltip-inner"], [3, "for"], [1, "range-slider-tooltip-arrow"], [3, "ngClass", "ngStyle"], [3, "mousedown", "ngClass", "ngStyle"]],
      template: function RangeSliderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 4);
          i0.ɵɵlistener("mousedown", function RangeSliderComponent_Template_div_mousedown_0_listener($event) {
            return ctx.handleInputsContainerMouseDown($event);
          });
          i0.ɵɵrepeaterCreate(1, RangeSliderComponent_For_2_Template, 3, 13, null, null, i0.ɵɵrepeaterTrackByIndex);
          i0.ɵɵtemplate(3, RangeSliderComponent_Conditional_3_Template, 3, 13, "div", 5)(4, RangeSliderComponent_Conditional_4_Template, 2, 0, "div", 6);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(5, RangeSliderComponent_Conditional_5_Template, 4, 0, "div", 7);
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵrepeater(ctx.currentValue());
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.track() ? 3 : 4);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.labels() ? 5 : -1);
        }
      },
      dependencies: [NgStyle, RangeSliderTrackPipe, NgClass, RangeSliderLabelStylePipe, RangeSliderLabelClassPipe, RangeSliderTooltipPositionStylePipe, ReactiveFormsModule, i1$2.DefaultValueAccessor, i1$2.RangeValueAccessor, i1$2.NgControlStatus, FormsModule, i1$2.NgModel],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RangeSliderComponent, [{
    type: Component,
    args: [{
      selector: 'c-range-slider',
      imports: [NgStyle, RangeSliderTrackPipe, NgClass, RangeSliderLabelStylePipe, RangeSliderLabelClassPipe, RangeSliderTooltipPositionStylePipe, ReactiveFormsModule, FormsModule],
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => RangeSliderComponent),
        multi: true
      }],
      host: {
        class: 'range-slider',
        '[class]': 'hostClasses()',
        '[attr.disabled]': 'disabledState() || null',
        '[attr.aria-orientation]': 'vertical() ? "vertical" : "horizontal"',
        '[attr.aria-valuemax]': 'max()',
        '[attr.aria-valuemin]': 'min()',
        '[attr.aria-valuenow]': 'valueNow()',
        '[attr.role]': 'role()'
      },
      template: "<div (mousedown)=\"handleInputsContainerMouseDown($event)\" class=\"range-slider-inputs-container\">\n  @for (value of currentValue(); track index; let index = $index) {\n    <input\n      class=\"range-slider-input\"\n      type=\"range\"\n      [min]=\"min()\"\n      [max]=\"max()\"\n      [step]=\"step()\"\n      [value]=\"value\"\n      [attr.value]=\"value\"\n      [attr.aria-valuemin]=\"min()\"\n      [attr.aria-valuemax]=\"max()\"\n      [attr.aria-valuenow]=\"value\"\n      [attr.aria-orientation]=\"vertical() ? 'vertical' : 'horizontal'\"\n      [disabled]=\"disabledState()\"\n      [ngModel]=\"value\"\n      (ngModelChange)=\"handleInputChange($event, index)\"\n      [attr.id]=\"inputIds()[index]\"\n      role=\"slider\"\n      #inputRef\n    />\n    @if (tooltips()) {\n      <div\n        class=\"range-slider-tooltip\"\n        [ngStyle]=\"value | rangeSliderTooltipPositionStyle: min() : max() : vertical() : thumbSize() : isRtl\"\n      >\n        <div class=\"range-slider-tooltip-inner\">\n          @let tooltipsFn = tooltipsFormat();\n          <label for=\"{{inputIds()[index]}}\">\n            {{ tooltipsFn?.(value) ?? value }}\n          </label>\n        </div>\n        <div class=\"range-slider-tooltip-arrow\"></div>\n      </div>\n    }\n  }\n  @if (track()) {\n    <div\n      class=\"range-slider-track\"\n      [ngStyle]=\"currentValue() | rangeSliderTrack: min() : max() : vertical() : isRtl\"\n      #trackRef\n    ></div>\n  } @else {\n    <div class=\"range-slider-track\" #trackRef></div>\n  }\n</div>\n\n@if (labels()) {\n  <div class=\"range-slider-labels-container\" #labelsContainerRef>\n    @for (label of labels(); track index; let index = $index) {\n      @let labelValue = getLabel(label);\n      <div\n        #labelRef\n        [ngClass]=\"label | rangeSliderLabelClass: clickableLabels()\"\n        [ngStyle]=\"label | rangeSliderLabelStyle: min() : max() : vertical() : labels() : index: isRtl\"\n        (mousedown)=\"handleLabelClick($event, label)\"\n      >\n        {{ labelValue }}\n      </div>\n    }\n  </div>\n}\n"
    }]
  }], () => [], null);
})();
class RangeSliderModule {
  static {
    this.ɵfac = function RangeSliderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RangeSliderModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: RangeSliderModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [RangeSliderComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RangeSliderModule, [{
    type: NgModule,
    args: [{
      imports: [RangeSliderComponent],
      exports: [RangeSliderComponent]
    }]
  }], null, null);
})();
class SidebarService {
  constructor() {
    this.sidebarState = new BehaviorSubject({});
    this.sidebarState$ = this.sidebarState.asObservable();
  }
  toggle(action) {
    this.sidebarState.next(action);
  }
  static {
    this.ɵfac = function SidebarService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SidebarService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SidebarService,
      factory: SidebarService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class SidebarBackdropService {
  #document = inject(DOCUMENT);
  #sidebarService = inject(SidebarService);
  #backdrop;
  #clickListener = () => {
    /* empty */
  };
  setBackdrop(sidebar) {
    const backdrop = this.#document.getElementsByClassName('sidebar-backdrop');
    // console.log(`sidebar-${this.id}`, ' setBackdrop', backdrop);
    if (backdrop.length === 0) {
      this.#backdrop = this.renderer.createElement('div');
      this.renderer.addClass(this.#backdrop, 'sidebar-backdrop');
      this.renderer.appendChild(this.#document.body, this.#backdrop);
      this.#clickListener = this.renderer.listen(this.#backdrop, 'click', e => {
        // console.log(`sidebar-${this.id}`, ' backdrop click', e);
        this.#sidebarService.toggle({
          toggle: 'visible',
          sidebar
        });
      });
    }
    // console.log(this.backdrop, sidebar.sidebarState.mobile, sidebar.sidebarState.show);
    if (this.#backdrop && sidebar.sidebarState.mobile && sidebar.sidebarState.visible) {
      this.renderer.addClass(this.#backdrop, 'fade');
      this.renderer.addClass(this.#backdrop, 'show');
      // this.renderer.removeClass(this.backdrop, 'd-none');
    } else {
      this.renderer.removeClass(this.#backdrop, 'show');
      this.renderer.removeClass(this.#backdrop, 'fade');
      // this.renderer.addClass(this.backdrop, 'd-none');
    }
  }
  clearBackdrop() {
    if (this.#backdrop) {
      // clear backdrop click Listener
      this.#clickListener();
      // this.renderer.listen(this.backdrop, 'click', (e): void => {} );
      this.renderer.removeChild(this.#document.body, this.#backdrop);
      // @ts-ignore
      this.#backdrop = undefined;
    }
  }
  static {
    this.ɵfac = function SidebarBackdropService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SidebarBackdropService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SidebarBackdropService,
      factory: SidebarBackdropService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarBackdropService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class SidebarComponent {
  #document;
  #renderer;
  #breakpointObserver;
  #sidebarService;
  #backdropService;
  #onMobile;
  #layoutChangeSubscription;
  #stateToggleSubscription;
  #stateInitial;
  #narrow;
  set narrow(value) {
    this.#narrow.set(value);
  }
  get narrow() {
    return this.#narrow();
  }
  #visible;
  #visibleEffect;
  set visible(value) {
    this.#visible.set(value);
  }
  get visible() {
    return this.#visible();
  }
  set sidebarState(value) {
    const newState = value;
    if ('toggle' in newState) {
      if (newState.toggle === 'visible') {
        newState.visible = !this.state().visible;
        this.#visible.set(newState.visible);
      } else if (newState.toggle === 'unfoldable') {
        newState.unfoldable = !this.state().unfoldable;
        this.unfoldable.set(newState.unfoldable);
      }
    } else {
      this.#visible.update(visible => (newState.visible ?? visible) && !this.overlaid());
    }
    this.state.update(state => ({
      ...state,
      ...newState
    }));
    this.state().mobile && this.state().visible ? this.#backdropService.setBackdrop(this) : this.#backdropService.clearBackdrop();
  }
  get sidebarState() {
    return {
      ...this.state()
    };
  }
  get getMobileBreakpoint() {
    const element = this.#document.documentElement;
    const mobileBreakpoint = this.#document.defaultView?.getComputedStyle(element)?.getPropertyValue('--cui-mobile-breakpoint') ?? 'md';
    const breakpointValue = this.#document.defaultView?.getComputedStyle(element)?.getPropertyValue(`--cui-breakpoint-${mobileBreakpoint.trim()}`) ?? '768px';
    return `${parseFloat(breakpointValue.trim()) - 0.02}px`;
  }
  constructor() {
    this.#document = inject(DOCUMENT);
    this.#renderer = inject(Renderer2);
    this.#breakpointObserver = inject(BreakpointObserver);
    this.#sidebarService = inject(SidebarService);
    this.#backdropService = inject(SidebarBackdropService);
    this.#onMobile = false;
    this.state = signal({
      sidebar: this
    });
    this.#stateInitial = {
      narrow: false,
      visible: false,
      unfoldable: false
    };
    /**
     * Sets if the color of text should be colored for a light or dark background.
     * @return 'dark' | 'light'
     */
    this.colorScheme = input();
    /**
     * Sets html attribute id.
     * @return string
     */
    this.id = input();
    /**
     * Make sidebar narrow.
     * @return boolean
     * @default false
     */
    this.narrowInput = input(false, {
      transform: booleanAttribute,
      alias: 'narrow'
    });
    this.#narrow = linkedSignal(this.narrowInput);
    /**
     * Set sidebar to overlaid variant.
     * @return boolean
     * @default false
     */
    this.overlaid = input(false, {
      transform: booleanAttribute
    });
    /**
     * Components placement, there’s no default placement.
     * @return 'start' | 'end'
     */
    this.placement = input();
    /**
     * Place sidebar in non-static positions.
     * @return 'fixed' | 'sticky'
     * @default 'fixed'
     */
    this.position = input('fixed');
    /**
     * Size the component small, large, or extra large.
     * @return 'sm' | 'lg' | 'xl'
     */
    this.size = input();
    /**
     * Expand narrowed sidebar on hover.
     * @type boolean
     * @default false
     */
    this.unfoldableInput = input(false, {
      transform: booleanAttribute,
      alias: 'unfoldable'
    });
    this.unfoldable = linkedSignal({
      source: this.unfoldableInput,
      computation: value => value
    });
    /**
     * Toggle the visibility of sidebar component.
     * @type boolean
     * @default false
     */
    this.visibleInput = input(false, {
      transform: booleanAttribute,
      alias: 'visible'
    });
    this.#visible = linkedSignal(this.visibleInput);
    this.#visibleEffect = effect(() => {
      this.visibleChange.emit(this.#visible());
    });
    /**
     * Event emitted on visibility change.
     * @return boolean
     */
    this.visibleChange = output();
    this.hostClasses = computed(() => {
      const {
        mobile,
        visible
      } = {
        ...this.sidebarState
      };
      const unfoldable = this.unfoldable();
      const placement = this.placement();
      const colorScheme = this.colorScheme();
      const size = this.size();
      return {
        sidebar: true,
        'sidebar-fixed': this.position() === 'fixed' && !mobile,
        'sidebar-narrow': this.#narrow() && !unfoldable,
        'sidebar-narrow-unfoldable': unfoldable,
        'sidebar-overlaid': this.overlaid(),
        [`sidebar-${placement}`]: !!placement,
        [`sidebar-${colorScheme}`]: !!colorScheme,
        [`sidebar-${size}`]: !!size,
        show: visible,
        // show: visible && this.#onMobile, //todo: check
        hide: !visible
      };
    });
    this.#backdropService.renderer = this.#renderer;
  }
  ngOnInit() {
    this.setInitialState();
    this.layoutChangeSubscribe();
    this.stateToggleSubscribe();
  }
  ngOnDestroy() {
    this.stateToggleSubscribe(false);
    this.layoutChangeSubscribe(false);
  }
  ngOnChanges(changes) {
    const oldStateMap = new Map(Object.entries(this.state()));
    const newStateMap = new Map();
    newStateMap.set('sidebar', this);
    const propList = ['visible', 'unfoldable', 'narrow'];
    for (const propName in changes) {
      if (propList.includes(propName)) {
        if (changes[propName] && !changes[propName].firstChange) {
          const value = booleanAttribute(changes[propName].currentValue);
          if (oldStateMap.get(propName) !== value) {
            newStateMap.set(propName, value);
          }
        }
      }
    }
    if (newStateMap.size > 1) {
      const state = Object.fromEntries(newStateMap.entries());
      this.#sidebarService.toggle(state);
    }
  }
  setInitialState() {
    this.#stateInitial = {
      narrow: this.#narrow(),
      visible: this.#visible(),
      unfoldable: this.unfoldable()
    };
    this.#sidebarService.toggle({
      ...this.#stateInitial,
      sidebar: this
    });
  }
  stateToggleSubscribe(subscribe = true) {
    if (subscribe) {
      this.#stateToggleSubscription = this.#sidebarService.sidebarState$.subscribe(state => {
        if (this === state.sidebar || this.id() === state.id) {
          this.sidebarState = {
            ...state
          };
        }
      });
    } else {
      this.#stateToggleSubscription?.unsubscribe();
    }
  }
  layoutChangeSubscribe(subscribe = true) {
    const onMobile = `(max-width: ${this.getMobileBreakpoint})`;
    if (subscribe) {
      const layoutChanges = this.#breakpointObserver.observe([onMobile]);
      this.#layoutChangeSubscription = layoutChanges.subscribe(result => {
        const isOnMobile = result.breakpoints[onMobile];
        const isUnfoldable = isOnMobile ? false : this.unfoldable();
        if (this.#onMobile !== isOnMobile) {
          this.#onMobile = isOnMobile;
          this.#sidebarService.toggle({
            mobile: isOnMobile,
            unfoldable: isUnfoldable,
            visible: isOnMobile ? !isOnMobile : this.#stateInitial.visible,
            sidebar: this
          });
        }
      });
    } else {
      this.#layoutChangeSubscription?.unsubscribe();
    }
  }
  static {
    this.ɵfac = function SidebarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SidebarComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SidebarComponent,
      selectors: [["c-sidebar"]],
      hostAttrs: [1, "sidebar"],
      hostVars: 3,
      hostBindings: function SidebarComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("inert", !ctx.sidebarState.visible || null);
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        colorScheme: [1, "colorScheme"],
        id: [1, "id"],
        narrowInput: [1, "narrow", "narrowInput"],
        overlaid: [1, "overlaid"],
        placement: [1, "placement"],
        position: [1, "position"],
        size: [1, "size"],
        unfoldableInput: [1, "unfoldable", "unfoldableInput"],
        visibleInput: [1, "visible", "visibleInput"]
      },
      outputs: {
        visibleChange: "visibleChange"
      },
      exportAs: ["cSidebar"],
      features: [i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SidebarComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarComponent, [{
    type: Component,
    args: [{
      selector: 'c-sidebar',
      exportAs: 'cSidebar',
      template: '<ng-content />',
      host: {
        class: 'sidebar',
        '[class]': 'hostClasses()',
        '[attr.inert]': '!this.sidebarState.visible || null'
      }
    }]
  }], () => [], null);
})();
class SidebarBrandComponent {
  constructor() {
    this.brandFull = input();
    this.brandNarrow = input();
    this.routerLink = input();
    this.brandImg = computed(() => Boolean(this.brandFull() || this.brandNarrow()));
  }
  static {
    this.ɵfac = function SidebarBrandComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SidebarBrandComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SidebarBrandComponent,
      selectors: [["c-sidebar-brand"]],
      hostAttrs: [1, "sidebar-brand"],
      inputs: {
        brandFull: [1, "brandFull"],
        brandNarrow: [1, "brandNarrow"],
        routerLink: [1, "routerLink"]
      },
      ngContentSelectors: _c0,
      decls: 2,
      vars: 1,
      consts: [[3, "routerLink"], [3, "cHtmlAttr", "ngClass"]],
      template: function SidebarBrandComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, SidebarBrandComponent_Conditional_0_Template, 3, 3, "a", 0)(1, SidebarBrandComponent_Conditional_1_Template, 1, 0);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.brandImg() ? 0 : 1);
        }
      },
      dependencies: [RouterLink, HtmlAttributesDirective, NgClass],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarBrandComponent, [{
    type: Component,
    args: [{
      selector: 'c-sidebar-brand',
      imports: [RouterLink, HtmlAttributesDirective, NgClass],
      host: {
        class: 'sidebar-brand'
      },
      template: "@if (brandImg()) {\n  <a [routerLink]=\"routerLink()\">\n    @if (brandFull()) {\n      <img [cHtmlAttr]=\"brandFull()\" [ngClass]=\"'sidebar-brand-full'\">\n    }\n    @if (brandNarrow()) {\n      <img [cHtmlAttr]=\"brandNarrow()\" [ngClass]=\"'sidebar-brand-narrow'\">\n    }\n  </a>\n} @else {\n  <ng-content />\n}\n"
    }]
  }], null, null);
})();

/**
 * Allows the sidebar to be toggled/folded via click on host element.
 */
class SidebarToggleDirective {
  constructor() {
    this.#sidebarService = inject(SidebarService);
    /**
     * Id of sidebar for toggle action.
     * @return string
     */
    this.id = input(undefined, {
      alias: 'cSidebarToggle'
    });
    /**
     * Sidebar property name for toggle action.
     *
     * @return 'visible' | 'unfoldable'
     * @default 'visible'
     */
    this.toggle = input('visible');
  }
  #sidebarService;
  toggleOpen($event) {
    $event.preventDefault();
    this.#sidebarService.toggle({
      toggle: this.toggle(),
      id: this.id()
    });
  }
  static {
    this.ɵfac = function SidebarToggleDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SidebarToggleDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: SidebarToggleDirective,
      selectors: [["", "cSidebarToggle", ""]],
      hostBindings: function SidebarToggleDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function SidebarToggleDirective_click_HostBindingHandler($event) {
            return ctx.toggleOpen($event);
          });
        }
      },
      inputs: {
        id: [1, "cSidebarToggle", "id"],
        toggle: [1, "toggle"]
      },
      exportAs: ["cSidebarToggle"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarToggleDirective, [{
    type: Directive,
    args: [{
      selector: '[cSidebarToggle]',
      exportAs: 'cSidebarToggle',
      host: {
        '(click)': 'toggleOpen($event)'
      }
    }]
  }], null, null);
})();
class SidebarTogglerDirective {
  constructor() {
    this.role = input('button');
  }
  get getStyles() {
    return {
      appearance: 'button',
      'align-items': 'flex-start',
      cursor: 'pointer'
    };
  }
  static {
    this.ɵfac = function SidebarTogglerDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SidebarTogglerDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: SidebarTogglerDirective,
      selectors: [["", "cSidebarToggler", ""]],
      hostAttrs: [1, "sidebar-toggler"],
      hostVars: 3,
      hostBindings: function SidebarTogglerDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role());
          i0.ɵɵstyleMap(ctx.getStyles);
        }
      },
      inputs: {
        role: [1, "role"]
      },
      features: [i0.ɵɵHostDirectivesFeature([{
        directive: SidebarToggleDirective,
        inputs: ["cSidebarToggle", "cSidebarToggler", "toggle", "toggle"]
      }])]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarTogglerDirective, [{
    type: Directive,
    args: [{
      selector: '[cSidebarToggler]',
      hostDirectives: [{
        directive: SidebarToggleDirective,
        inputs: ['cSidebarToggle: cSidebarToggler', 'toggle']
      }],
      host: {
        '[attr.role]': 'role()',
        class: 'sidebar-toggler',
        '[style]': 'getStyles'
      }
    }]
  }], null, null);
})();
class SidebarHeaderComponent {
  static {
    this.ɵfac = function SidebarHeaderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SidebarHeaderComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SidebarHeaderComponent,
      selectors: [["c-sidebar-header"]],
      hostAttrs: [1, "sidebar-header"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SidebarHeaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarHeaderComponent, [{
    type: Component,
    args: [{
      selector: 'c-sidebar-header',
      template: '<ng-content />',
      host: {
        class: 'sidebar-header'
      }
    }]
  }], null, null);
})();
class SidebarFooterComponent {
  static {
    this.ɵfac = function SidebarFooterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SidebarFooterComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SidebarFooterComponent,
      selectors: [["c-sidebar-footer"]],
      hostAttrs: [1, "sidebar-footer"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SidebarFooterComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarFooterComponent, [{
    type: Component,
    args: [{
      selector: 'c-sidebar-footer',
      template: '<ng-content />',
      host: {
        class: 'sidebar-footer'
      }
    }]
  }], null, null);
})();
class SidebarNavService {
  static {
    this.ɵfac = function SidebarNavService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SidebarNavService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SidebarNavService,
      factory: SidebarNavService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavService, [{
    type: Injectable
  }], null, null);
})();
class SidebarNavHelper {
  constructor() {
    this.hasBadge = item => Boolean(item.badge);
    this.hasIcon = item => Boolean(item.icon) || item.icon === '';
    this.hasIconComponent = item => Boolean(item.iconComponent);
  }
  itemType(item) {
    if (item.divider) {
      return 'divider';
    } else if (item.title) {
      return 'title';
    } else if (item.children && item.children.length > 0) {
      return 'group';
    } else if (item.label) {
      return 'label';
    } else if (!Object.keys(item).length) {
      return 'empty';
    } else {
      return 'link';
    }
  }
  isActive(router, item) {
    return router.isActive(item.url, false);
  }
  getIconClass(item) {
    const classes = {
      'nav-icon': true
    };
    const icon = item.icon;
    // @ts-ignore
    classes[icon] = this.hasIcon(item);
    return classes;
  }
  static {
    this.ɵfac = function SidebarNavHelper_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SidebarNavHelper)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SidebarNavHelper,
      factory: SidebarNavHelper.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavHelper, [{
    type: Injectable
  }], null, null);
})();
class SidebarNavGroupService {
  constructor() {
    this.sidebarNavGroupState = new BehaviorSubject({});
    this.sidebarNavGroupState$ = this.sidebarNavGroupState.asObservable();
  }
  toggle(action) {
    this.sidebarNavGroupState.next(action);
  }
  static {
    this.ɵfac = function SidebarNavGroupService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SidebarNavGroupService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SidebarNavGroupService,
      factory: SidebarNavGroupService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavGroupService, [{
    type: Injectable
  }], null, null);
})();
class SidebarNavIconPipe {
  transform(item, args) {
    const icon = item.icon;
    return {
      'nav-icon': true,
      [`${icon}`]: !!icon
    };
  }
  static {
    this.ɵfac = function SidebarNavIconPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SidebarNavIconPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "cSidebarNavIcon",
      type: SidebarNavIconPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavIconPipe, [{
    type: Pipe,
    args: [{
      name: 'cSidebarNavIcon'
    }]
  }], null, null);
})();
class SidebarNavBadgePipe {
  transform(item, args) {
    const badge = item.badge;
    return {
      badge: true,
      'ms-auto': true,
      'badge-sm': !badge.size,
      [`badge-${badge.size}`]: !!badge.size,
      [`bg-${badge.color}`]: !!badge.color,
      [`${badge.class}`]: !!badge.class
    };
  }
  static {
    this.ɵfac = function SidebarNavBadgePipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SidebarNavBadgePipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "cSidebarNavBadge",
      type: SidebarNavBadgePipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavBadgePipe, [{
    type: Pipe,
    args: [{
      name: 'cSidebarNavBadge'
    }]
  }], null, null);
})();
class SidebarNavLinkPipe {
  transform(item) {
    const disabled = item?.attributes?.disabled;
    return {
      'nav-link': true,
      disabled,
      'btn-link': disabled,
      [`nav-link-${item.variant}`]: !!item.variant
    };
  }
  static {
    this.ɵfac = function SidebarNavLinkPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SidebarNavLinkPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "cSidebarNavLink",
      type: SidebarNavLinkPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavLinkPipe, [{
    type: Pipe,
    args: [{
      name: 'cSidebarNavLink'
    }]
  }], null, null);
})();
class SidebarNavLinkContentComponent {
  constructor() {
    this.helper = inject(SidebarNavHelper);
  }
  static {
    this.ɵfac = function SidebarNavLinkContentComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SidebarNavLinkContentComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SidebarNavLinkContentComponent,
      selectors: [["c-sidebar-nav-link-content"]],
      inputs: {
        item: "item"
      },
      features: [i0.ɵɵProvidersFeature([SidebarNavHelper])],
      decls: 1,
      vars: 1,
      template: function SidebarNavLinkContentComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, SidebarNavLinkContentComponent_Conditional_0_Template, 2, 1, "ng-container");
        }
        if (rf & 2) {
          i0.ɵɵconditional(true ? 0 : -1);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavLinkContentComponent, [{
    type: Component,
    args: [{
      selector: 'c-sidebar-nav-link-content',
      template: `
    @if (true) {
      <ng-container>{{ item?.name ?? '' }}</ng-container>
    }
  `,
      providers: [SidebarNavHelper]
    }]
  }], null, {
    item: [{
      type: Input
    }]
  });
})();
class SidebarNavLinkComponent {
  set item(item) {
    this._item = JSON.parse(JSON.stringify(item));
  }
  get item() {
    return this._item;
  }
  constructor() {
    this.router = inject(Router);
    this._item = {};
    this.linkClick = output();
    const router = this.router;
    this.navigationEndObservable = router.events.pipe(filter(event => {
      return event instanceof NavigationEnd;
    }));
  }
  ngOnInit() {
    this.url = typeof this.item.url === 'string' ? this.item.url : this.router.serializeUrl(this.router.createUrlTree(this.item.url ?? ['']));
    this.linkType = this.getLinkType();
    this.href = this.isDisabled() ? '' : this.item.href || this.url;
    this.linkActive = this.router.url.split(/[?#(;]/)[0] === this.href.split(/[?#(;]/)[0];
    this.navSubscription = this.navigationEndObservable.subscribe(event => {
      const itemUrlArray = this.href.split(/[?#(;]/)[0].split('/');
      const urlArray = event.urlAfterRedirects.split(/[?#(;]/)[0].split('/');
      this.linkActive = itemUrlArray.every((value, index) => value === urlArray[index]);
    });
  }
  ngOnDestroy() {
    this.navSubscription?.unsubscribe();
  }
  getLinkType() {
    return this.isDisabled() ? 'disabled' : this.isExternalLink() ? 'external' : 'link';
  }
  isDisabled() {
    return this.item?.attributes?.['disabled'];
  }
  isExternalLink() {
    const linkPath = Array.isArray(this.item.url) ? this.item.url[0] : this.item.url;
    return !!this.item.href || linkPath?.substring(0, 4) === 'http';
  }
  linkClicked() {
    this.linkClick.emit();
  }
  static {
    this.ɵfac = function SidebarNavLinkComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SidebarNavLinkComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SidebarNavLinkComponent,
      selectors: [["c-sidebar-nav-link"]],
      inputs: {
        item: "item"
      },
      outputs: {
        linkClick: "linkClick"
      },
      features: [i0.ɵɵProvidersFeature([SidebarNavHelper])],
      decls: 5,
      vars: 1,
      consts: [["iconTemplate", ""], [3, "cHtmlAttr", "ngClass"], [3, "cHtmlAttr", "href", "ngClass"], ["routerLinkActive", "active", 3, "cHtmlAttr", "fragment", "ngClass", "preserveFragment", "queryParamsHandling", "queryParams", "replaceUrl", "routerLinkActiveOptions", "routerLink", "skipLocationChange", "state", "target"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "item"], [3, "ngClass"], [3, "click", "cHtmlAttr", "href", "ngClass"], ["routerLinkActive", "active", 3, "click", "cHtmlAttr", "fragment", "ngClass", "preserveFragment", "queryParamsHandling", "queryParams", "replaceUrl", "routerLinkActiveOptions", "routerLink", "skipLocationChange", "state", "target"], [1, "nav-icon"], [3, "cIcon", "customClasses", "name"]],
      template: function SidebarNavLinkComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, SidebarNavLinkComponent_Case_0_Template, 5, 11, "a", 1)(1, SidebarNavLinkComponent_Case_1_Template, 5, 12, "a", 2)(2, SidebarNavLinkComponent_Case_2_Template, 5, 23, "a", 3)(3, SidebarNavLinkComponent_ng_template_3_Template, 3, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          let tmp_1_0;
          i0.ɵɵconditional((tmp_1_0 = ctx.linkType) === "disabled" ? 0 : tmp_1_0 === "external" ? 1 : 2);
        }
      },
      dependencies: [RouterModule, i1.RouterLink, i1.RouterLinkActive, HtmlAttributesDirective, IconDirective, SidebarNavLinkContentComponent, SidebarNavLinkPipe, SidebarNavBadgePipe, SidebarNavIconPipe, NgTemplateOutlet, NgClass],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavLinkComponent, [{
    type: Component,
    args: [{
      selector: 'c-sidebar-nav-link',
      providers: [SidebarNavHelper],
      imports: [RouterModule, HtmlAttributesDirective, IconDirective, SidebarNavLinkContentComponent, SidebarNavLinkPipe, SidebarNavBadgePipe, SidebarNavIconPipe, NgTemplateOutlet, NgClass],
      template: "@switch (linkType) {\n  @case ('disabled') {\n    <a [cHtmlAttr]=\"item.attributes ?? {}\" [ngClass]=\"item | cSidebarNavLink\">\n      <ng-container *ngTemplateOutlet=\"iconTemplate; context: {$implicit: item}\" />\n      <c-sidebar-nav-link-content [item]=\"item\" />\n      @if (item.badge) {\n        <span [ngClass]=\"item | cSidebarNavBadge\">{{ item.badge?.text }}</span>\n      }\n    </a>\n  }\n  @case ('external') {\n    <a (click)=\"linkClicked()\" [cHtmlAttr]=\"item.attributes ?? {}\" [href]=\"href\" [ngClass]=\"item | cSidebarNavLink\">\n      <ng-container *ngTemplateOutlet=\"iconTemplate; context: {$implicit: item}\" />\n      <c-sidebar-nav-link-content [item]=\"item\" />\n      @if (item.badge) {\n        <span [ngClass]=\"item | cSidebarNavBadge\">{{ item.badge?.text }}</span>\n      }\n    </a>\n  }\n  @default {\n    <a (click)=\"linkClicked()\"\n       [cHtmlAttr]=\"item.attributes ?? {}\"\n       [fragment]=\"item.linkProps?.fragment\"\n       [ngClass]=\"item | cSidebarNavLink\"\n       [preserveFragment]=\"item.linkProps?.preserveFragment ?? false\"\n       [queryParamsHandling]=\"item.linkProps?.queryParamsHandling\"\n       [queryParams]=\"item.linkProps?.queryParams ?? null\"\n       [replaceUrl]=\"item.linkProps?.replaceUrl ?? false\"\n       [routerLinkActiveOptions]=\"item.linkProps?.routerLinkActiveOptions ?? { exact: false }\"\n       [routerLink]=\"item.url\"\n       [skipLocationChange]=\"item.linkProps?.skipLocationChange ?? false\"\n       [state]=\"item.linkProps?.state ?? {}\"\n       [target]=\"item.attributes?.['target']\"\n       routerLinkActive=\"active\"\n    >\n      <!--    [class.active]=\"linkActive\"-->\n      <ng-container *ngTemplateOutlet=\"iconTemplate ; context: {$implicit: item}\" />\n      <c-sidebar-nav-link-content [item]=\"item\" />\n      @if (item.badge) {\n        <span [ngClass]=\"item | cSidebarNavBadge\">{{ item.badge?.text }}</span>\n      }\n    </a>\n  }\n}\n<ng-template #iconTemplate let-item>\n  <!--  <i *ngIf=\"item?.icon\" [ngClass]=\"item | cSidebarNavIcon\"></i>-->\n  @if (item?.icon) {\n    <span class=\"nav-icon\">\n      <span [ngClass]=\"item.icon ?? ''\"></span>\n    </span>\n  }\n  @if (item?.iconComponent) {\n    <svg\n      [cIcon]=\"item.iconComponent?.content\"\n      [customClasses]=\"item | cSidebarNavIcon\"\n      [name]=\"item.iconComponent?.name\"\n    ></svg>\n  }\n  @if (!item?.icon && !item?.iconComponent) {\n    <span [ngClass]=\"item | cSidebarNavIcon\"></span>\n  }\n</ng-template>\n"
    }]
  }], () => [], {
    item: [{
      type: Input
    }]
  });
})();
class SidebarNavLabelComponent {
  constructor() {
    this.helper = inject(SidebarNavHelper);
    this.classes = {
      'c-nav-label': true,
      'c-active': true
    };
    this.iconClasses = {};
  }
  ngOnInit() {
    this.iconClasses = this.helper.getIconClass(this.item);
  }
  getItemClass() {
    const itemClass = this.item.class;
    // @ts-ignore
    this.classes[itemClass] = !!itemClass;
    return this.classes;
  }
  getLabelIconClass() {
    const variant = `text-${this.item.label.variant}`;
    // @ts-ignore
    this.iconClasses[variant] = !!this.item.label.variant;
    const labelClass = this.item.label.class;
    // @ts-ignore
    this.iconClasses[labelClass] = !!labelClass;
    return this.iconClasses;
  }
  static {
    this.ɵfac = function SidebarNavLabelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SidebarNavLabelComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SidebarNavLabelComponent,
      selectors: [["c-sidebar-nav-label"]],
      inputs: {
        item: "item"
      },
      decls: 5,
      vars: 6,
      consts: [[3, "cHtmlAttr", "ngClass", "href"], [3, "ngClass"]],
      template: function SidebarNavLabelComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "a", 0);
          i0.ɵɵtemplate(1, SidebarNavLabelComponent_Conditional_1_Template, 1, 1, "i", 1);
          i0.ɵɵelementContainerStart(2);
          i0.ɵɵtext(3);
          i0.ɵɵelementContainerEnd();
          i0.ɵɵtemplate(4, SidebarNavLabelComponent_Conditional_4_Template, 3, 4, "span", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵpropertyInterpolate("href", ctx.item.url, i0.ɵɵsanitizeUrl);
          i0.ɵɵproperty("cHtmlAttr", ctx.item.attributes)("ngClass", ctx.getItemClass());
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.helper.hasIcon(ctx.item) ? 1 : -1);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.item.name);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.helper.hasBadge(ctx.item) ? 4 : -1);
        }
      },
      dependencies: [HtmlAttributesDirective, SidebarNavBadgePipe, NgClass],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavLabelComponent, [{
    type: Component,
    args: [{
      selector: 'c-sidebar-nav-label',
      imports: [HtmlAttributesDirective, SidebarNavBadgePipe, NgClass],
      template: "<a [cHtmlAttr]=\"item.attributes\"\n   [ngClass]=\"getItemClass()\"\n   href=\"{{item.url}}\">\n  @if (helper.hasIcon(item)) {\n    <i [ngClass]=\"getLabelIconClass()\"></i>\n  }\n  <ng-container>{{ item.name }}</ng-container>\n  @if (helper.hasBadge(item)) {\n    <span [ngClass]=\"item | cSidebarNavBadge\">{{ item.badge.text }}</span>\n  }\n</a>\n"
    }]
  }], null, {
    item: [{
      type: Input
    }]
  });
})();
class SidebarNavTitleComponent {
  #elementRef = inject(ElementRef);
  #renderer = inject(Renderer2);
  ngOnInit() {
    const nativeElement = this.#elementRef.nativeElement;
    const name = this.#renderer.createText(this.item.name);
    if (this.item.class) {
      const classes = this.item.class;
      this.#renderer.addClass(nativeElement, classes);
    }
    if (this.item.wrapper) {
      const wrapper = this.#renderer.createElement(this.item.wrapper.element);
      this.addAttribs(this.item.wrapper.attributes, wrapper);
      this.#renderer.appendChild(wrapper, name);
      this.#renderer.appendChild(nativeElement, wrapper);
    } else {
      this.#renderer.appendChild(nativeElement, name);
    }
  }
  addAttribs(attribs, element) {
    if (attribs) {
      for (const attr in attribs) {
        if (attr === 'style' && typeof attribs[attr] === 'object') {
          this.setStyle(attribs[attr], element);
        } else if (attr === 'class') {
          this.addClass(attribs[attr], element);
        } else {
          this.setAttrib(attr, attribs[attr], element);
        }
      }
    }
  }
  setStyle(styles, el) {
    for (const style in styles) {
      if (style) {
        this.#renderer.setStyle(el, style, styles[style]);
      }
    }
  }
  addClass(classes, el) {
    const classArray = Array.isArray(classes) ? classes : classes.split(' ');
    classArray.filter(element => element.length > 0).forEach(element => {
      this.#renderer.addClass(el, element);
    });
  }
  setAttrib(key, value, el) {
    this.#renderer.setAttribute(el, key, value);
  }
  static {
    this.ɵfac = function SidebarNavTitleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SidebarNavTitleComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SidebarNavTitleComponent,
      selectors: [["c-sidebar-nav-title"]],
      inputs: {
        item: "item"
      },
      decls: 0,
      vars: 0,
      template: function SidebarNavTitleComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavTitleComponent, [{
    type: Component,
    args: [{
      selector: 'c-sidebar-nav-title',
      template: ''
    }]
  }], null, {
    item: [{
      type: Input
    }]
  });
})();
class SidebarNavDividerComponent {
  static {
    this.ɵfac = function SidebarNavDividerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SidebarNavDividerComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SidebarNavDividerComponent,
      selectors: [["c-sidebar-nav-divider"]],
      inputs: {
        item: "item"
      },
      decls: 0,
      vars: 0,
      template: function SidebarNavDividerComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavDividerComponent, [{
    type: Component,
    args: [{
      selector: 'c-sidebar-nav-divider',
      template: ``
    }]
  }], null, {
    item: [{
      type: Input
    }]
  });
})();
class SidebarNavItemClassPipe {
  constructor() {
    this.helper = inject(SidebarNavHelper);
  }
  // transform(item: any, ...args: any[]): any {
  transform(item, args) {
    const itemType = this.helper.itemType(item);
    let itemClass;
    if (['divider', 'title'].includes(itemType)) {
      itemClass = `nav-${itemType}`;
    } else if (itemType === 'group') {
      // itemClass = 'c-sidebar-nav-group' ;
      itemClass = '';
    } else {
      itemClass = 'nav-item';
    }
    return item.class ? `${itemClass} ${item.class}` : itemClass;
  }
  static {
    this.ɵfac = function SidebarNavItemClassPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SidebarNavItemClassPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "cSidebarNavItemClass",
      type: SidebarNavItemClassPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavItemClassPipe, [{
    type: Pipe,
    args: [{
      name: 'cSidebarNavItemClass'
    }]
  }], null, null);
})();
class SidebarNavGroupComponent {
  #router;
  #renderer;
  #hostElement;
  #sidebarNavGroupService;
  constructor() {
    this.#router = inject(Router);
    this.#renderer = inject(Renderer2);
    this.#hostElement = inject(ElementRef);
    this.#sidebarNavGroupService = inject(SidebarNavGroupService);
    this.helper = inject(SidebarNavHelper);
    this.dropdownMode = 'path';
    this.navItems = [];
    this.display = {
      display: 'block'
    };
    const router = this.#router;
    this.navigationEndObservable = router.events.pipe(filter(event => event instanceof NavigationEnd));
  }
  get hostClasses() {
    return {
      'nav-group': true,
      show: this.open
    };
  }
  ngOnInit() {
    this.navItems = [...this.item.children];
    this.navSubscription = this.navigationEndObservable.subscribe(event => {
      if (this.dropdownMode !== 'none') {
        const samePath = this.samePath(event.url);
        this.openGroup(samePath);
      }
    });
    if (this.samePath(this.#router.routerState.snapshot.url)) {
      this.openGroup(true);
    }
    this.navGroupSubscription = this.#sidebarNavGroupService.sidebarNavGroupState$.subscribe(next => {
      if (this.dropdownMode === 'close' && next.sidebarNavGroup && next.sidebarNavGroup !== this) {
        if (next.sidebarNavGroup.item.url.startsWith(this.item.url)) {
          return;
        }
        if (this.samePath(this.#router.routerState.snapshot.url)) {
          this.openGroup(true);
          return;
        }
        this.openGroup(false);
      }
    });
  }
  samePath(url) {
    // console.log('item:', this.item.name, this.item.url, 'url:', url);
    const itemArray = this.item.url?.split('/');
    const urlArray = url.split('/');
    return itemArray?.every((value, index) => {
      // console.log(value === urlArray[index], 'value:', value, 'index:', index, urlArray[index], url);
      return value === urlArray[index];
    });
  }
  openGroup(open) {
    this.open = open;
  }
  toggleGroup($event) {
    $event.preventDefault();
    this.openGroup(!this.open);
    if (this.open) {
      this.#sidebarNavGroupService.toggle({
        open: this.open,
        sidebarNavGroup: this
      });
    }
  }
  ngOnDestroy() {
    this.navSubscription?.unsubscribe();
  }
  onAnimationStart($event) {
    this.display = {
      display: 'block'
    };
    setTimeout(() => {
      const host = this.sidebarNav?.nativeElement;
      if ($event.toState === 'open' && host) {
        this.#renderer.setStyle(host, 'height', `${host['scrollHeight']}px`);
      }
    });
  }
  onAnimationDone($event) {
    setTimeout(() => {
      const host = this.sidebarNav?.nativeElement;
      if ($event.toState === 'open' && host) {
        this.#renderer.setStyle(host, 'height', 'auto');
      }
      if ($event.toState === 'closed') {
        setTimeout(() => {
          this.display = null;
        });
      }
    });
  }
  static {
    this.ɵfac = function SidebarNavGroupComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SidebarNavGroupComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SidebarNavGroupComponent,
      selectors: [["c-sidebar-nav-group"]],
      viewQuery: function SidebarNavGroupComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(SidebarNavComponent, 5, ElementRef);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sidebarNav = _t.first);
        }
      },
      hostVars: 2,
      hostBindings: function SidebarNavGroupComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses);
        }
      },
      inputs: {
        item: "item",
        dropdownMode: "dropdownMode",
        show: "show",
        compact: [2, "compact", "compact", booleanAttribute]
      },
      features: [i0.ɵɵProvidersFeature([SidebarNavHelper, SidebarNavGroupService])],
      decls: 8,
      vars: 13,
      consts: [["iconTemplate", ""], ["href", "", 1, "nav-link", "nav-group-toggle", 3, "click", "cHtmlAttr"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "ngClass"], [3, "compact", "dropdownMode", "groupItems", "navItems", "ngStyle"], [1, "nav-icon"], [3, "cIcon", "customClasses", "name"]],
      template: function SidebarNavGroupComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "a", 1);
          i0.ɵɵlistener("click", function SidebarNavGroupComponent_Template_a_click_0_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.toggleGroup($event));
          });
          i0.ɵɵtemplate(1, SidebarNavGroupComponent_ng_container_1_Template, 1, 0, "ng-container", 2);
          i0.ɵɵelementContainerStart(2);
          i0.ɵɵtext(3);
          i0.ɵɵelementContainerEnd();
          i0.ɵɵtemplate(4, SidebarNavGroupComponent_Conditional_4_Template, 3, 4, "span", 3);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "c-sidebar-nav", 4);
          i0.ɵɵlistener("@openClose.done", function SidebarNavGroupComponent_Template_c_sidebar_nav_animation_openClose_done_5_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onAnimationDone($event));
          })("@openClose.start", function SidebarNavGroupComponent_Template_c_sidebar_nav_animation_openClose_start_5_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onAnimationStart($event));
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(6, SidebarNavGroupComponent_ng_template_6_Template, 3, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const iconTemplate_r4 = i0.ɵɵreference(7);
          i0.ɵɵproperty("cHtmlAttr", ctx.item.attributes);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngTemplateOutlet", iconTemplate_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction1(11, _c13, ctx.item));
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.item.name);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.helper.hasBadge(ctx.item) ? 4 : -1);
          i0.ɵɵadvance();
          i0.ɵɵproperty("@openClose", ctx.open ? "open" : "closed")("compact", ctx.compact)("dropdownMode", ctx.dropdownMode)("groupItems", true)("navItems", ctx.navItems)("ngStyle", ctx.display);
        }
      },
      dependencies: () => [HtmlAttributesDirective, IconDirective, NgTemplateOutlet, NgClass, SidebarNavIconPipe, SidebarNavBadgePipe, SidebarNavComponent, NgStyle],
      styles: [".nav-group-toggle[_ngcontent-%COMP%]{cursor:pointer}.nav-group-items[_ngcontent-%COMP%]{display:block}"],
      data: {
        animation: [trigger('openClose', [state('open', style({
          height: '*'
        })), state('closed', style({
          height: '0px'
        })), transition('open <=> closed', [animate('.15s ease')])])]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavGroupComponent, [{
    type: Component,
    args: [{
      selector: 'c-sidebar-nav-group',
      providers: [SidebarNavHelper, SidebarNavGroupService],
      imports: [HtmlAttributesDirective, IconDirective, NgTemplateOutlet, NgClass, SidebarNavIconPipe, SidebarNavBadgePipe, forwardRef(() => SidebarNavComponent), NgStyle],
      animations: [trigger('openClose', [state('open', style({
        height: '*'
      })), state('closed', style({
        height: '0px'
      })), transition('open <=> closed', [animate('.15s ease')])])],
      template: "<a (click)=\"toggleGroup($event)\"\n   [cHtmlAttr]=\"item.attributes\"\n   class=\"nav-link nav-group-toggle\"\n   href>\n  <ng-container *ngTemplateOutlet=\"iconTemplate ; context: {$implicit: item}\" />\n  <ng-container>{{ item.name }}</ng-container>\n  @if (helper.hasBadge(item)) {\n    <span [ngClass]=\"item | cSidebarNavBadge\">{{ item.badge.text }}</span>\n  }\n</a>\n<c-sidebar-nav\n  (@openClose.done)=\"onAnimationDone($event)\"\n  (@openClose.start)=\"onAnimationStart($event)\"\n  [@openClose]=\"open ? 'open' : 'closed'\"\n  [compact]=\"compact\"\n  [dropdownMode]=\"dropdownMode\"\n  [groupItems]=\"true\"\n  [navItems]=\"navItems\"\n  [ngStyle]=\"display\"\n/>\n\n<ng-template #iconTemplate let-item>\n  <!--  <i *ngIf=\"item?.icon\" [ngClass]=\"item | cSidebarNavIcon\"></i>-->\n  @if (item?.icon) {\n    <span class=\"nav-icon\">\n    <span [ngClass]=\"item.icon ?? ''\"></span>\n  </span>\n  }\n  @if (item?.iconComponent) {\n    <svg\n      [cIcon]=\"item.iconComponent?.content\"\n      [customClasses]=\"item | cSidebarNavIcon\"\n      [name]=\"item.iconComponent?.name\"\n    />\n  }\n  @if (!item?.icon && !item?.iconComponent) {\n    <span [ngClass]=\"item | cSidebarNavIcon\"></span>\n  }\n</ng-template>\n",
      styles: [".nav-group-toggle{cursor:pointer}.nav-group-items{display:block}\n"]
    }]
  }], () => [], {
    item: [{
      type: Input
    }],
    dropdownMode: [{
      type: Input
    }],
    show: [{
      type: Input
    }],
    compact: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    hostClasses: [{
      type: HostBinding,
      args: ['class']
    }],
    sidebarNav: [{
      type: ViewChild,
      args: [forwardRef(() => SidebarNavComponent), {
        read: ElementRef
      }]
    }]
  });
})();
class SidebarNavComponent {
  constructor() {
    this.sidebar = inject(SidebarComponent, {
      optional: true
    });
    this.helper = inject(SidebarNavHelper);
    this.router = inject(Router);
    this.#renderer = inject(Renderer2);
    this.#hostElement = inject(ElementRef);
    this.#sidebarService = inject(SidebarService);
    this.navItems = [];
    this.dropdownMode = 'path';
    // @HostBinding('class.nav-group-items')
    // get sidebarNavGroupItemsClass(): boolean {
    //   return !!this.groupItems;
    // }
    this.role = 'navigation';
    this.navItemsArray = [];
  }
  #renderer;
  #hostElement;
  #sidebarService;
  get hostClasses() {
    return {
      'sidebar-nav': !this.groupItems,
      'nav-group-items': this.groupItems,
      compact: this.groupItems && this.compact
    };
  }
  ngOnChanges(changes) {
    this.navItemsArray = Array.isArray(this.navItems) ? this.navItems.slice() : [];
  }
  hideMobile() {
    // todo: proper scrollIntoView() after NavigationEnd
    if (this.sidebar && this.sidebar.sidebarState.mobile) {
      this.#sidebarService.toggle({
        toggle: 'visible',
        sidebar: this.sidebar
      });
    }
  }
  static {
    this.ɵfac = function SidebarNavComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SidebarNavComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SidebarNavComponent,
      selectors: [["c-sidebar-nav"]],
      hostVars: 3,
      hostBindings: function SidebarNavComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role);
          i0.ɵɵclassMap(ctx.hostClasses);
        }
      },
      inputs: {
        navItems: "navItems",
        dropdownMode: "dropdownMode",
        groupItems: [2, "groupItems", "groupItems", booleanAttribute],
        compact: [2, "compact", "compact", booleanAttribute],
        role: "role"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c0,
      decls: 3,
      vars: 0,
      consts: [["rla", "routerLinkActive"], ["routerLinkActive", "show", 3, "dropdownMode", "item", "ngClass", "routerLinkActiveOptions", "compact"], [3, "cHtmlAttr", "item", "ngClass"], [3, "item", "ngClass"], [3, "linkClick", "item", "ngClass"]],
      template: function SidebarNavComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵrepeaterCreate(0, SidebarNavComponent_For_1_Template, 6, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
          i0.ɵɵprojection(2);
        }
        if (rf & 2) {
          i0.ɵɵrepeater(ctx.navItemsArray);
        }
      },
      dependencies: () => [NgClass, HtmlAttributesDirective, SidebarNavLinkComponent, SidebarNavLabelComponent, SidebarNavTitleComponent, SidebarNavDividerComponent, SidebarNavGroupComponent, SidebarNavItemClassPipe, RouterModule, i1.RouterLinkActive],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavComponent, [{
    type: Component,
    args: [{
      selector: 'c-sidebar-nav',
      imports: [NgClass, HtmlAttributesDirective, SidebarNavLinkComponent, SidebarNavLabelComponent, SidebarNavTitleComponent, SidebarNavDividerComponent, forwardRef(() => SidebarNavGroupComponent), SidebarNavItemClassPipe, RouterModule],
      template: "@for (item of navItemsArray; track item) {\n  @switch (helper.itemType(item)) {\n    @case ('group') {\n      <c-sidebar-nav-group\n        #rla=\"routerLinkActive\"\n        [dropdownMode]=\"dropdownMode\"\n        [item]=\"item\"\n        [ngClass]=\"item | cSidebarNavItemClass\"\n        [routerLinkActiveOptions]=\"{exact: true}\"\n        routerLinkActive=\"show\"\n        [compact]=\"compact\"\n      />\n    }\n    @case ('divider') {\n      <c-sidebar-nav-divider\n        [cHtmlAttr]=\"item.attributes ?? {}\"\n        [item]=\"item\"\n        [ngClass]=\"item | cSidebarNavItemClass\"\n      />\n    }\n    @case ('title') {\n      <c-sidebar-nav-title\n        [cHtmlAttr]=\"item.attributes ?? {}\"\n        [item]=\"item\"\n        [ngClass]=\"item | cSidebarNavItemClass\"\n      />\n    }\n    @case ('label') {\n      <c-sidebar-nav-label\n        [item]=\"item\"\n        [ngClass]=\"item | cSidebarNavItemClass\"\n      />\n    }\n    @case ('empty') {\n      <ng-container />\n    }\n    @default {\n      <c-sidebar-nav-link\n        (linkClick)=\"hideMobile()\"\n        [item]=\"item\"\n        [ngClass]=\"item | cSidebarNavItemClass\"\n      />\n    }\n  }\n}\n<ng-content />\n"
    }]
  }], null, {
    navItems: [{
      type: Input
    }],
    dropdownMode: [{
      type: Input
    }],
    groupItems: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    compact: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    hostClasses: [{
      type: HostBinding,
      args: ['class']
    }],
    role: [{
      type: HostBinding,
      args: ['attr.role']
    }, {
      type: Input
    }]
  });
})();
class SidebarModule {
  static {
    this.ɵfac = function SidebarModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SidebarModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SidebarModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [SidebarService, SidebarNavHelper, SidebarNavGroupService],
      imports: [SidebarNavComponent, SidebarNavGroupComponent, SidebarNavLinkComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarModule, [{
    type: NgModule,
    args: [{
      imports: [SidebarComponent, SidebarBrandComponent, SidebarFooterComponent, SidebarHeaderComponent, SidebarNavComponent, SidebarNavBadgePipe, SidebarNavDividerComponent, SidebarNavGroupComponent, SidebarNavIconPipe, SidebarNavItemClassPipe, SidebarNavLabelComponent, SidebarNavLinkComponent, SidebarNavLinkContentComponent, SidebarNavLinkPipe, SidebarNavTitleComponent, SidebarToggleDirective, SidebarTogglerDirective],
      exports: [SidebarComponent, SidebarToggleDirective, SidebarTogglerDirective, SidebarBrandComponent, SidebarNavComponent, SidebarHeaderComponent, SidebarFooterComponent],
      providers: [SidebarService, SidebarNavHelper, SidebarNavGroupService]
    }]
  }], null, null);
})();
class SmartPaginationComponent {
  constructor() {
    /**
     * Current page number. [docs]
     * @default 1
     * @type number
     */
    this.activePage = 1;
    /**
     * Event triggered on activePage change.
     * @type EventEmitter<number>
     */
    this.activePageChange = new EventEmitter();
    /**
     * Show/hide arrows
     * @default true
     * @type boolean
     */
    this.arrows = true;
    /**
     * Show double arrows buttons
     * @default true
     * @type boolean
     */
    this.doubleArrows = true;
    /**
     * Show/hide dots. [docs]
     * @default true
     */
    this.dots = true;
    this._limit = 5;
    this._pages = 1;
    /**
     * The content of 'firstButton' button. [docs]
     * @default '&laquo'
     * todo TemplateRef
     */
    this.firstButton = '«';
    // firstButton?: string | TemplateRef<any> = '&laquo;'
    /**
     * The content of 'lastButton' button. [docs]
     * @default '&raquo'
     * todo TemplateRef
     */
    this.lastButton = '»';
    // lastButton?: string | TemplateRef<any> = '&raquo;'
    /**
     * The content of 'nextButton' button. [docs]
     * @default '&lsaquo'
     * todo TemplateRef
     */
    this.nextButton = '›';
    /**
     * The content of 'previousButton' button. [docs]
     * @default '&rsaquo'
     * todo TemplateRef
     */
    this.previousButton = '‹';
    /**
     * Set the alignment of pagination components.
     * @values 'start', 'center', 'end'
     */
    this.align = 'start';
    /**
     * Default role for pagination. [docs]
     * @type string
     * @default 'navigation'
     */
    this.role = 'navigation';
  }
  /**
   * Maximum items number. [docs]
   * @default 5
   * @type number
   */
  set limit(value) {
    this._limit = value;
  }
  get limit() {
    return this._limit;
  }
  /**
   * Number of pages. [docs]
   * @type number
   */
  set pages(value) {
    this._pages = value;
  }
  get pages() {
    return this._pages;
  }
  get paginationClass() {
    return {
      pagination: true,
      [`pagination-${this.size}`]: !!this.size,
      [`justify-content-${this.align}`]: !!this.align
    };
  }
  get maxPrevItems() {
    return Math.floor((this._limit - 1) / 2);
  }
  get maxNextItems() {
    return Math.ceil((this._limit - 1) / 2);
  }
  get range() {
    return this.activePage + this.maxNextItems;
  }
  get lastItem() {
    return this.range >= this._pages ? this._pages : this.range - (this.afterDots ? 1 : 0);
  }
  get computedLimit() {
    return this._limit - (this.afterDots ? 1 : 0) - (this.beforeDots ? 1 : 0);
  }
  get itemsLimit() {
    return this._pages < this.computedLimit ? this._pages : this.computedLimit;
  }
  get showDots() {
    return this.dots && this._limit > 4 && this._limit < this._pages;
  }
  get beforeDots() {
    return this.showDots && this.activePage > this.maxPrevItems + 1;
  }
  get afterDots() {
    return this.showDots && this.activePage < this._pages - this.maxNextItems;
  }
  get items() {
    if (this.activePage - this.maxPrevItems <= 1) {
      return Array.from({
        length: this.itemsLimit
      }, (_item, i) => i + 1);
    } else {
      return Array.from({
        length: this.itemsLimit
      }, (_item, i) => {
        return this.lastItem - i;
      }).reverse();
    }
  }
  setPage(page) {
    if (page !== this.activePage) {
      this.activePage = page;
      this.activePageChange.emit(page);
    }
  }
  static {
    this.ɵfac = function SmartPaginationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SmartPaginationComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SmartPaginationComponent,
      selectors: [["c-smart-pagination"]],
      hostVars: 1,
      hostBindings: function SmartPaginationComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role);
        }
      },
      inputs: {
        activePage: [2, "activePage", "activePage", numberAttribute],
        arrows: "arrows",
        doubleArrows: "doubleArrows",
        dots: "dots",
        limit: [2, "limit", "limit", numberAttribute],
        pages: [2, "pages", "pages", numberAttribute],
        firstButton: "firstButton",
        lastButton: "lastButton",
        nextButton: "nextButton",
        previousButton: "previousButton",
        align: "align",
        size: "size",
        role: "role"
      },
      outputs: {
        activePageChange: "activePageChange"
      },
      exportAs: ["cSmartPagination"],
      decls: 9,
      vars: 7,
      consts: [[3, "ngClass"], ["cPageItem", ""], ["cPageItem", "", 3, "active"], ["aria-label", "First page", "cPageLink", "", 3, "click", "disabled", "ngClass"], ["aria-hidden", "true"], ["aria-label", "Previous page", "cPageLink", "", 3, "click", "disabled", "ngClass"], ["cPageLink", "", "disabled", "", "role", "separator"], ["cPageLink", "", 3, "click", "title"], ["aria-label", "Next page", "cPageLink", "", 3, "click", "disabled", "ngClass"], ["aria-label", "Last page", "cPageLink", "", 3, "click", "disabled", "ngClass"]],
      template: function SmartPaginationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "ul", 0);
          i0.ɵɵtemplate(1, SmartPaginationComponent_Conditional_1_Template, 4, 5, "li", 1)(2, SmartPaginationComponent_Conditional_2_Template, 4, 5, "li", 1)(3, SmartPaginationComponent_Conditional_3_Template, 3, 0, "li", 1);
          i0.ɵɵrepeaterCreate(4, SmartPaginationComponent_For_5_Template, 3, 3, "li", 2, i0.ɵɵrepeaterTrackByIdentity);
          i0.ɵɵtemplate(6, SmartPaginationComponent_Conditional_6_Template, 3, 0, "li", 1)(7, SmartPaginationComponent_Conditional_7_Template, 4, 5, "li", 1)(8, SmartPaginationComponent_Conditional_8_Template, 4, 5, "li", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", ctx.paginationClass);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.doubleArrows ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.arrows ? 2 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.beforeDots ? 3 : -1);
          i0.ɵɵadvance();
          i0.ɵɵrepeater(ctx.items);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.afterDots ? 6 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.arrows ? 7 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.doubleArrows ? 8 : -1);
        }
      },
      dependencies: [PageItemDirective, PageLinkDirective, NgClass],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SmartPaginationComponent, [{
    type: Component,
    args: [{
      selector: 'c-smart-pagination',
      exportAs: 'cSmartPagination',
      imports: [PageItemDirective, PageLinkDirective, NgClass],
      template: "<ul [ngClass]=\"paginationClass\">\n  @if (doubleArrows) {\n    <li cPageItem>\n      <button\n        (click)=\"setPage(1)\"\n        [disabled]=\"activePage === 1\"\n        [ngClass]=\"{ disabled: activePage === 1 }\"\n        aria-label=\"First page\"\n        cPageLink\n      >\n        <span aria-hidden=\"true\">{{ firstButton }}</span>\n      </button>\n    </li>\n  }\n  @if (arrows) {\n    <li cPageItem>\n      <button\n        (click)=\"setPage(activePage - 1)\"\n        [disabled]=\"activePage === 1\"\n        [ngClass]=\"{ disabled: activePage === 1 }\"\n        aria-label=\"Previous page\"\n        cPageLink\n      >\n        <span aria-hidden=\"true\">{{ previousButton }}</span>\n      </button>\n    </li>\n  }\n  @if (beforeDots) {\n    <li cPageItem>\n      <a cPageLink disabled role=\"separator\">\n        ...\n      </a>\n    </li>\n  }\n  @for (item of items; track item; let i = $index) {\n    <li [active]=\"activePage === item\" cPageItem>\n      <button\n        (click)=\"setPage(item)\"\n        [title]=\"(activePage === item ? 'Current page ' : 'Go to page ') + (item).toString()\"\n        cPageLink\n      >\n        {{ item }}\n      </button>\n    </li>\n  }\n  @if (afterDots) {\n    <li cPageItem>\n      <a cPageLink disabled role=\"separator\">\n        ...\n      </a>\n    </li>\n  }\n  @if (arrows) {\n    <li cPageItem>\n      <button\n        (click)=\"setPage(activePage + 1)\"\n        [disabled]=\"activePage === pages\"\n        [ngClass]=\"{ disabled: activePage === pages }\"\n        aria-label=\"Next page\"\n        cPageLink\n      >\n        <span aria-hidden=\"true\">{{ nextButton }}</span>\n      </button>\n    </li>\n  }\n  @if (doubleArrows) {\n    <li cPageItem>\n      <button\n        (click)=\"setPage(pages)\"\n        [disabled]=\"activePage === pages\"\n        [ngClass]=\"{ disabled: activePage === pages }\"\n        aria-label=\"Last page\"\n        cPageLink\n      >\n        <span aria-hidden=\"true\">{{ lastButton }}</span>\n      </button>\n    </li>\n  }\n</ul>\n"
    }]
  }], null, {
    activePage: [{
      type: Input,
      args: [{
        transform: numberAttribute
      }]
    }],
    activePageChange: [{
      type: Output
    }],
    arrows: [{
      type: Input
    }],
    doubleArrows: [{
      type: Input
    }],
    dots: [{
      type: Input
    }],
    limit: [{
      type: Input,
      args: [{
        transform: numberAttribute
      }]
    }],
    pages: [{
      type: Input,
      args: [{
        transform: numberAttribute
      }]
    }],
    firstButton: [{
      type: Input
    }],
    lastButton: [{
      type: Input
    }],
    nextButton: [{
      type: Input
    }],
    previousButton: [{
      type: Input
    }],
    align: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    role: [{
      type: HostBinding,
      args: ['attr.role']
    }, {
      type: Input
    }]
  });
})();
class SmartPaginationModule {
  static {
    this.ɵfac = function SmartPaginationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SmartPaginationModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SmartPaginationModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SmartPaginationModule, [{
    type: NgModule,
    args: [{
      exports: [SmartPaginationComponent],
      imports: [SmartPaginationComponent]
    }]
  }], null, null);
})();
class FilterInputDirective {
  constructor(elementRef, destroyRef) {
    this.elementRef = elementRef;
    this.destroyRef = destroyRef;
    this.#value = '';
    this.value$ = new BehaviorSubject('');
    this.emitObject = {
      value: '',
      type: '',
      column: ''
    };
    this.delay = 300;
    this.onEvent = 'input';
    this.valueChange = new EventEmitter();
  }
  #value;
  set value(value) {
    this.value$.next(value);
  }
  ngAfterViewInit() {
    this.setSubscription();
  }
  setSubscription() {
    this.value$.pipe(distinctUntilChanged$1(), takeUntilDestroyed(this.destroyRef)).subscribe(value => {
      if (this.#value !== value) {
        this.#value = value;
        this.emitObject = {
          ...this.emitObject,
          value: value,
          type: this.onEvent
        };
        this.valueChange.emit({
          ...this.emitObject
        });
      }
    });
    const dueTime = this.onEvent === 'change' ? 0 : this.delay;
    fromEvent(this.elementRef.nativeElement, this.onEvent).pipe(map$1(event => {
      return event.target.value;
    }), debounceTime$1(dueTime), takeUntilDestroyed(this.destroyRef)).subscribe(value => {
      if (value !== this.#value) {
        this.value$.next(value);
      }
    });
  }
  static {
    this.ɵfac = function FilterInputDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FilterInputDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.DestroyRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FilterInputDirective,
      selectors: [["", "cFilterInput", ""]],
      inputs: {
        delay: "delay",
        onEvent: "onEvent",
        value: "value"
      },
      outputs: {
        valueChange: "valueChange"
      },
      exportAs: ["cFilterInput"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FilterInputDirective, [{
    type: Directive,
    args: [{
      selector: '[cFilterInput]',
      exportAs: 'cFilterInput',
      standalone: true
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.DestroyRef
  }], {
    delay: [{
      type: Input
    }],
    onEvent: [{
      type: Input
    }],
    value: [{
      type: Input
    }],
    valueChange: [{
      type: Output
    }]
  });
})();
class SmartTableFilterComponent {
  constructor() {
    this.#filterInputDirective = inject(FilterInputDirective);
    this.value$ = this.#filterInputDirective.value$;
    this.filterLabel = 'Filter:';
    this.filterPlaceholder = 'Filter';
  }
  #filterInputDirective;
  get hostClasses() {
    return {
      row: true,
      'mb-2': true
    };
  }
  get labelClasses() {
    return {
      'col-form-label': true,
      [`col-form-label-${this.sizing}`]: !!this.sizing
    };
  }
  static {
    this.ɵfac = function SmartTableFilterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SmartTableFilterComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SmartTableFilterComponent,
      selectors: [["c-smart-table-filter"]],
      hostVars: 2,
      hostBindings: function SmartTableFilterComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses);
        }
      },
      inputs: {
        filterLabel: "filterLabel",
        filterPlaceholder: "filterPlaceholder",
        sizing: "sizing"
      },
      decls: 4,
      vars: 6,
      consts: [["cLabel", "col", 1, "col-auto", 3, "ngClass"], [1, "col-auto"], ["autocomplete", "off", "cFormControl", "", "size", "10", 3, "placeholder", "sizing", "value"]],
      template: function SmartTableFilterComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, SmartTableFilterComponent_Conditional_0_Template, 2, 2, "label", 0);
          i0.ɵɵelementStart(1, "div", 1);
          i0.ɵɵelement(2, "input", 2);
          i0.ɵɵpipe(3, "async");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵconditional(!!ctx.filterLabel ? 0 : -1);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("placeholder", ctx.filterPlaceholder)("sizing", ctx.sizing)("value", i0.ɵɵpipeBind1(3, 4, ctx.value$));
        }
      },
      dependencies: [FormControlDirective, FormLabelDirective, NgClass, AsyncPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SmartTableFilterComponent, [{
    type: Component,
    args: [{
      selector: 'c-smart-table-filter',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [FormControlDirective, FormLabelDirective, NgClass, AsyncPipe],
      template: "@if (!!filterLabel) {\n  <label [ngClass]=\"labelClasses\" cLabel=\"col\" class=\"col-auto\">\n    {{ filterLabel }}\n  </label>\n}\n<div class=\"col-auto\">\n  <input\n    [placeholder]=\"filterPlaceholder\"\n    [sizing]=\"sizing\"\n    [value]=\"value$ | async\"\n    autocomplete=\"off\"\n    cFormControl\n    size=\"10\"\n  />\n</div>\n"
    }]
  }], null, {
    filterLabel: [{
      type: Input
    }],
    filterPlaceholder: [{
      type: Input
    }],
    sizing: [{
      type: Input
    }],
    hostClasses: [{
      type: HostBinding,
      args: ['class']
    }]
  });
})();
const getClickedColumnName = (target, columnNames, selectable) => {
  const closest = target.closest('tr');
  const children = closest ? Array.from(closest.children) : [];
  const clickedCell = children.filter(child => child.contains(target))[0];
  return columnNames[children.indexOf(clickedCell) - (selectable ? 1 : 0)];
};
const getColumnKey = column => typeof column === 'object' ? column.key ?? column.group : column;
const getColumnLabel = column => typeof column === 'object' && column.label !== undefined ? column.label : prettifyName(getColumnKey(column));
const getColumnName = getColumnKey;
const getColumnNames = (columns, items) => {
  if (columns?.length) {
    const _columns = [];
    for (const column of columns) {
      if (typeof column === 'object' && column.children) {
        _columns.push(...getColumnNames(column.children, []));
        continue;
      }
      typeof column === 'object' ? _columns.push(column.key) : _columns.push(column);
    }
    return _columns;
  }
  return getColumnNamesFromItems(items);
};
const getColumns = _columns => {
  const columns = [];
  for (const column of _columns) {
    if (typeof column === 'object' && column.group && column.children) {
      columns.push(...getColumns(column.children));
      continue;
    }
    if (typeof column === 'object' && column.children) {
      columns.push(...getColumns(column.children));
    }
    columns.push(column);
  }
  return columns;
};
const countColumns = (columns, counter = 0) => {
  let _counter = counter;
  for (const column of columns) {
    if (!column.children) {
      _counter++;
    }
    if (column.children) {
      _counter = countColumns(column.children, _counter);
    }
  }
  return _counter;
};
const getColumnGroups = columns => {
  const groups = [];
  const traverseColumns = (column, deep = 0, colSpan = 0) => {
    const groups = [];
    if (column.children) {
      for (const _column of column.children) {
        if (!_column.group) {
          colSpan++;
        }
        groups.push(...traverseColumns(_column, deep + 1, colSpan));
      }
    }
    if (typeof column === 'object' && column.group) {
      const {
        children,
        group,
        ...rest
      } = column;
      groups.push({
        deep: deep,
        label: group,
        ...(children && {
          colspan: countColumns(children)
        }),
        ...rest
      });
    }
    return groups;
  };
  if (columns) {
    for (const column of columns) {
      if (typeof column === 'object' && column.group) {
        const objects = traverseColumns(column);
        if (objects) {
          for (const object of objects) {
            const {
              deep,
              ...rest
            } = object;
            if (deep === undefined) {
              continue;
            }
            for (let i = 0; i < deep; i++) {
              if (groups[i]) {
                continue;
              }
              groups.push([]);
            }
            if (groups[deep]) {
              groups[deep].push(rest);
            } else {
              groups.push([rest]);
            }
          }
        }
      }
    }
  }
  return groups;
};
const getColumnNamesFromItems = items => Object.keys(items[0] || {}).filter(el => el.charAt(0) !== '_');
const getColumnValues = (items, key) => {
  return items.map(item => item[key]);
};
const convertNgClassToObj = value => {
  const WS_REGEXP = /\s+/;
  const rawClass = typeof value === 'string' ? value.trim().split(WS_REGEXP) : value;
  const objClass = {};
  if (Array.isArray(rawClass) || rawClass instanceof Set) {
    for (const klass of rawClass) {
      objClass[klass] = true;
    }
    return objClass;
  }
  return rawClass ?? {};
};
const getTableDataCellClass = (column, item) => {
  const colClass = convertNgClassToObj(column?._colClass ?? {});
  const rowClass = convertNgClassToObj(item._class ?? {});
  const allClass = convertNgClassToObj(item._cellClass?._all ?? {});
  const cellClass = convertNgClassToObj(item._cellClass?.[column.key ?? column.group] ?? {});
  return {
    ...colClass,
    ...rowClass,
    ...allClass,
    ...cellClass
  };
};
const getTableDataCellProps = (column, item) => {
  const props = {};
  if (typeof column === 'object' && column._colProps) {
    Object.assign(props, column._colProps);
  }
  if (item._cellProps?._all) {
    Object.assign(props, item._cellProps._all);
  }
  if (item._cellProps?.[column.key ?? column.group]) {
    Object.assign(props, item._cellProps[column.key ?? column.group]);
  }
  return props;
};
const getTableDataCellStyles = (column, item) => {
  const styles = {};
  if (typeof column === 'object' && column._colStyle) {
    Object.assign(styles, column._colStyle);
  }
  if (item._cellStyle?._all) {
    Object.assign(styles, item._cellStyle._all);
  }
  // @ts-ignore
  if (item._cellStyle?.[column.key]) {
    // @ts-ignore
    Object.assign(styles, item._cellStyle[column.key]);
  }
  return {
    ...styles
  };
};
const getTableHeaderCellProps = column => {
  if (typeof column === 'object' && column._props) {
    const {
      color,
      ...props
    } = {
      ...column._props
    };
    return props;
  }
  return {};
};
const getTableHeaderCellClass = column => {
  const headerClass = convertNgClassToObj(column?._classes ?? {});
  return {
    ...headerClass
  };
};
const getTableHeaderCellStyles = (column, columnSorter) => {
  const style = {
    verticalAlign: 'middle',
    overflow: 'hidden',
    cursor: columnSorter ? 'pointer' : ''
  };
  if (typeof column === 'object' && column._style) {
    return {
      ...style,
      ...column._style
    };
  }
  return {
    ...style
  };
};
const prettifyName = name => {
  return name.replace(/[-_.]/g, ' ').replace(/ +/g, ' ').replace(/([a-z0-9])([A-Z])/g, '$1 $2').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
};
class TableColorDirective {
  constructor() {
    /**
     * Use contextual color for tables, table rows or individual cells.
     * @return Colors
     */
    this.color = input(undefined, {
      alias: 'cTableColor'
    });
    this.hostClasses = computed(() => {
      const color = this.color();
      return {
        [`table-${color}`]: !!color
      };
    });
  }
  static {
    this.ɵfac = function TableColorDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TableColorDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: TableColorDirective,
      selectors: [["", "cTableColor", ""]],
      hostVars: 2,
      hostBindings: function TableColorDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        color: [1, "cTableColor", "color"]
      },
      exportAs: ["cTableColor"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableColorDirective, [{
    type: Directive,
    args: [{
      selector: '[cTableColor]',
      exportAs: 'cTableColor',
      host: {
        '[class]': 'hostClasses()'
      }
    }]
  }], null, null);
})();
class TableActiveDirective {
  constructor() {
    /**
     * Highlight a table row or cell
     * @return boolean
     */
    this.active = input(false, {
      alias: "cTableActive",
      transform: booleanAttribute
    });
  }
  static {
    this.ɵfac = function TableActiveDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TableActiveDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: TableActiveDirective,
      selectors: [["", "cTableActive", ""]],
      hostVars: 2,
      hostBindings: function TableActiveDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("table-active", ctx.active());
        }
      },
      inputs: {
        active: [1, "cTableActive", "active"]
      },
      exportAs: ["cTableActive"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableActiveDirective, [{
    type: Directive,
    args: [{
      selector: '[cTableActive]',
      exportAs: 'cTableActive',
      host: {
        '[class.table-active]': 'active()'
      }
    }]
  }], null, null);
})();
class TableDirective {
  constructor() {
    this.#renderer = inject(Renderer2);
    this.#hostElement = inject(ElementRef);
    /**
     * Set the vertical alignment.
     * @return string
     * @values 'bottom' | 'middle' | 'top'
     */
    this.align = input();
    /**
     * Sets the border color of the component to one of CoreUI’s themed colors.
     * @return Colors
     */
    this.borderColor = input();
    /**
     * Add borders on all sides of the table and cells.
     * @return boolean
     */
    this.bordered = input(false, {
      transform: booleanAttribute
    });
    /**
     * Remove borders on all sides of the table and cells.
     * @return boolean
     */
    this.borderless = input(false, {
      transform: booleanAttribute
    });
    /**
     * Put the `<caption>` on the top of the table.
     * @return 'top'
     * @values 'top'
     */
    this.caption = input();
    /**
     * Sets the color context of the component to one of CoreUI’s themed colors.
     * @return Colors
     */
    this.color = input();
    /**
     * Enable a hover state on table rows within table body.
     * @return boolean
     */
    this.hover = input(false, {
      transform: booleanAttribute
    });
    /**
     * Make table responsive across all viewports or pick a maximum breakpoint with which to have a responsive table up to.
     * @values: {boolean | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'}
     */
    this.responsive = input();
    /**
     * Make table more compact by cutting all cell `padding` in half.
     * @return boolean
     */
    this.small = input(false, {
      transform: booleanAttribute
    });
    /**
     * Add zebra-striping to any table row within the table body.
     * @return boolean
     */
    this.striped = input(false, {
      transform: booleanAttribute
    });
    /**
     * Add zebra-striping to any table column.
     * @return boolean
     * @since 4.2.4
     */
    this.stripedColumns = input(false, {
      transform: booleanAttribute
    });
    this.hostClasses = computed(() => {
      const align = this.align();
      const caption = this.caption();
      const borderColor = this.borderColor();
      const bordered = this.bordered();
      const borderless = this.borderless();
      const color = this.color();
      const hover = this.hover();
      const small = this.small();
      const striped = this.striped();
      const stripedColumns = this.stripedColumns();
      return {
        table: true,
        [`align-${align}`]: !!align,
        [`caption-${caption}`]: !!caption,
        [`border-${borderColor}`]: !!borderColor,
        'table-bordered': bordered,
        'table-borderless': borderless,
        [`table-${color}`]: !!color,
        'table-hover': hover,
        'table-sm': small,
        'table-striped': striped,
        'table-striped-columns': stripedColumns
      };
    });
    this.#responsiveWrapperEffect = effect(() => {
      const responsive = this.responsive();
      if (!!responsive) {
        const nativeElement = this.#hostElement.nativeElement;
        const wrapper = this.#renderer.createElement('div');
        const className = responsive === true ? 'table-responsive' : `table-responsive-${responsive}`;
        this.#renderer.addClass(wrapper, className);
        const parentNode = this.#renderer.parentNode(nativeElement);
        this.#renderer.appendChild(parentNode, wrapper);
        this.#renderer.insertBefore(parentNode, wrapper, nativeElement);
        this.#renderer.appendChild(wrapper, nativeElement);
      }
    });
  }
  #renderer;
  #hostElement;
  #responsiveWrapperEffect;
  static {
    this.ɵfac = function TableDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TableDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: TableDirective,
      selectors: [["table", "cTable", ""]],
      hostAttrs: [1, "table"],
      hostVars: 2,
      hostBindings: function TableDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        align: [1, "align"],
        borderColor: [1, "borderColor"],
        bordered: [1, "bordered"],
        borderless: [1, "borderless"],
        caption: [1, "caption"],
        color: [1, "color"],
        hover: [1, "hover"],
        responsive: [1, "responsive"],
        small: [1, "small"],
        striped: [1, "striped"],
        stripedColumns: [1, "stripedColumns"]
      },
      exportAs: ["cTable"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableDirective, [{
    type: Directive,
    args: [{
      selector: 'table[cTable]',
      exportAs: 'cTable',
      host: {
        class: 'table',
        '[class]': 'hostClasses()'
      }
    }]
  }], null, null);
})();
class TableModule {
  static {
    this.ɵfac = function TableModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TableModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: TableModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableModule, [{
    type: NgModule,
    args: [{
      exports: [TableDirective, TableColorDirective, TableActiveDirective],
      imports: [TableDirective, TableColorDirective, TableActiveDirective]
    }]
  }], null, null);
})();
class SmartTableColumnFilterComponent {
  constructor() {
    this.#filterInputDirective = inject(FilterInputDirective);
    this.value$ = this.#filterInputDirective.value$;
    this.sizing = 'sm';
  }
  #filterInputDirective;
  set column(value) {
    this.#filterInputDirective.emitObject = {
      ...this.#filterInputDirective.emitObject,
      column: value
    };
  }
  static {
    this.ɵfac = function SmartTableColumnFilterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SmartTableColumnFilterComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SmartTableColumnFilterComponent,
      selectors: [["c-smart-table-column-filter"]],
      inputs: {
        column: "column",
        sizing: "sizing"
      },
      decls: 2,
      vars: 4,
      consts: [["autocomplete", "off", "cFormControl", "", 3, "sizing", "value"]],
      template: function SmartTableColumnFilterComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "input", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("sizing", ctx.sizing)("value", i0.ɵɵpipeBind1(1, 2, ctx.value$));
        }
      },
      dependencies: [FormControlDirective, AsyncPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SmartTableColumnFilterComponent, [{
    type: Component,
    args: [{
      selector: 'c-smart-table-column-filter',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [FormControlDirective, AsyncPipe],
      template: "<input\n  [sizing]=\"sizing\"\n  [value]=\"value$ | async\"\n  autocomplete=\"off\"\n  cFormControl\n/>\n"
    }]
  }], null, {
    column: [{
      type: Input
    }],
    sizing: [{
      type: Input
    }]
  });
})();
class SmartTableColumnLabelPipe {
  transform(column, ...args) {
    return getColumnLabel(column);
  }
  static {
    this.ɵfac = function SmartTableColumnLabelPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SmartTableColumnLabelPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "columnLabel",
      type: SmartTableColumnLabelPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SmartTableColumnLabelPipe, [{
    type: Pipe,
    args: [{
      name: 'columnLabel',
      standalone: true
    }]
  }], null, null);
})();

// todo - add support for column groups
class SmartTableHeadComponent {
  constructor() {
    this.getTableHeaderCellStyles = getTableHeaderCellStyles;
    this.getTableHeaderCellProps = getTableHeaderCellProps;
    this.getTableHeaderCellClass = getTableHeaderCellClass;
    this.columnFilter = input();
    this.columnFilterStateInput = input({}, {
      alias: 'columnFilterState'
    });
    this.columnFilterState = linkedSignal(this.columnFilterStateInput);
    this.columnSorter = input(true);
    this.component = input('thead');
    this.#columns = signal(undefined);
    this.columnGroupsInput = input(undefined, {
      alias: 'columnGroups'
    });
    this.columnGroups = linkedSignal(this.columnGroupsInput);
    this.selectable = input(undefined, {
      transform: booleanAttribute
    });
    this.selectAll = input(true, {
      transform: booleanAttribute
    });
    this.#selectedAll = false;
    this.showGroups = input(false, {
      transform: booleanAttribute
    });
    this.sorterValue = input();
    this.#columnFilterTemplates = {};
    this.#columnLabelTemplates = {};
    this.#summaryRowTemplate = null;
    // todo
    // @Input() sortingIcon?: string | TemplateRef<any>;
    // @Input() sortingIconAscending?: string | TemplateRef<any>;
    // @Input() sortingIconDescending?: string | TemplateRef<any>;
    this.indeterminate$ = new BehaviorSubject(false);
    this.columnFilterStateChange = output();
    this.sorterStateChange = output();
    this.selectAllChange = output();
    this.hostClasses = computed(() => {
      const component = this.component();
      return {
        thead: component === 'thead',
        tfoot: component === 'tfoot'
      };
    });
  }
  set columns(value) {
    const columns = value ? getColumns(value) : [];
    this.#columns.set(columns);
  }
  get columns() {
    return this.#columns();
  }
  #columns;
  #selectedAllPreviousValue;
  set selectedAll(value) {
    this.indeterminate$.next(value === 'indeterminate');
    this.#selectedAll = value === 'indeterminate' ? false : booleanAttribute(value);
    if (value !== 'indeterminate') {
      this.#selectedAllPreviousValue = this.#selectedAll;
    }
  }
  get selectedAll() {
    return this.#selectedAll;
  }
  #selectedAll;
  set columnFilterTemplates(value) {
    this.#columnFilterTemplates = {
      ...value
    };
  }
  get columnFilterTemplates() {
    return this.#columnFilterTemplates;
  }
  #columnFilterTemplates;
  set columnLabelTemplates(value) {
    this.#columnLabelTemplates = {
      ...value
    };
  }
  get columnLabelTemplates() {
    return this.#columnLabelTemplates;
  }
  #columnLabelTemplates;
  set summaryRowTemplate(value) {
    this.#summaryRowTemplate = value;
  }
  get summaryRowTemplate() {
    return this.#summaryRowTemplate;
  }
  #summaryRowTemplate;
  ngOnInit() {
    this.columns?.forEach((column, index) => {
      const columnKey = this.columnKey(column);
      this.columnFilterState()[columnKey] = this.columnFilterState()[columnKey] ?? '';
    });
  }
  tableHeaderCellColor(column) {
    if (typeof column === 'object' && column._props) {
      const {
        color
      } = {
        ...column._props
      };
      return color;
    }
    return '';
  }
  columnKey(column) {
    return typeof column === 'object' ? column.key ?? column.group : column;
  }
  getColumnSorterState(column) {
    const columnKey = this.columnKey(column);
    const sorterValue = this.sorterValue();
    if (sorterValue?.column === columnKey) {
      return sorterValue?.state ?? 0;
    }
    return 0;
  }
  handleSortClick(column, i, order) {
    if (this.columnSorterEnabled(column)) {
      const columnKey = this.columnKey(column);
      this.sorterStateChange.emit({
        columnKey,
        index: i,
        order
      });
    }
  }
  handleSortKeyDown($event, column, i) {
    const eventCode = $event.code;
    if (['Enter', 'Space', 'ArrowUp', 'ArrowDown'].includes(eventCode)) {
      $event.preventDefault();
      const order = eventCode === 'ArrowUp' ? 'asc' : eventCode === 'ArrowDown' ? 'desc' : undefined;
      this.handleSortClick(column, i, order);
    }
  }
  columnFilterEnabled(column) {
    return typeof column !== 'object' ? true : typeof column.filter === 'undefined' ? true : column.filter;
  }
  columnSorterEnabled(column) {
    if (!this.columnSorter()) {
      return false;
    }
    return typeof column !== 'object' ? true : typeof column.sorter === 'undefined' ? true : column.sorter;
  }
  handleColumnFilterValueChange($event) {
    const {
      value,
      type: eventType,
      column
    } = {
      ...$event
    };
    const columnKey = this.columnKey(column);
    const columnFilterValue = value;
    const columnFilter = this.columnFilter();
    const isLazy = typeof columnFilter === 'object' && columnFilter.lazy === true;
    if ((isLazy && eventType === 'input' || !isLazy && eventType === 'change') && columnFilterValue.length !== 0) {
      return;
    }
    this.columnFilterState()[columnKey] = columnFilterValue;
    this.columnFilterStateChange.emit({
      column: columnKey,
      value: columnFilterValue,
      type: eventType
    });
  }
  handleSelectAllChecked($event) {
    $event.preventDefault();
    $event.target.checked = !this.#selectedAllPreviousValue;
    // ($event.target as HTMLInputElement).checked = !this.selectedAll;
    const selectAll = $event.target.checked;
    this.selectAllChange.emit(selectAll);
  }
  getColumnFilter(column) {
    return `columnFilter_${this.columnKey(column) ?? '_undefined'}`;
  }
  getColumnLabel(column) {
    if (typeof column === 'object' && column._labelTemplateId) {
      return `columnLabel_${column._labelTemplateId ?? '_undefined'}`;
    }
    return `columnLabel_${this.columnKey(column) ?? '_undefined'}`;
  }
  get columnFilterEvent() {
    const columnFilter = this.columnFilter();
    return typeof columnFilter === 'object' && columnFilter.lazy ? 'change' : 'input';
  }
  getAriaSort(column) {
    const sort = this.getColumnSorterState(column);
    return sort === 'asc' ? 'ascending' : sort === 'desc' ? 'descending' : null;
  }
  static {
    this.ɵfac = function SmartTableHeadComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SmartTableHeadComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SmartTableHeadComponent,
      selectors: [["c-smart-table-head"]],
      hostVars: 2,
      hostBindings: function SmartTableHeadComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        columnFilter: [1, "columnFilter"],
        columnFilterStateInput: [1, "columnFilterState", "columnFilterStateInput"],
        columnSorter: [1, "columnSorter"],
        component: [1, "component"],
        columns: "columns",
        columnGroupsInput: [1, "columnGroups", "columnGroupsInput"],
        selectable: [1, "selectable"],
        selectAll: [1, "selectAll"],
        selectedAll: "selectedAll",
        showGroups: [1, "showGroups"],
        sorterValue: [1, "sorterValue"],
        columnFilterTemplates: "columnFilterTemplates",
        columnLabelTemplates: "columnLabelTemplates",
        summaryRowTemplate: "summaryRowTemplate"
      },
      outputs: {
        columnFilterStateChange: "columnFilterStateChange",
        sorterStateChange: "sorterStateChange",
        selectAllChange: "selectAllChange"
      },
      decls: 21,
      vars: 6,
      consts: [["defaultColumnLabel", ""], ["defaultColumnFilter", ""], ["columnSorterIconTemplate", ""], ["sortingIconTemplate", ""], ["sortingIconAscendingTemplate", ""], ["sortingIconDescendingTemplate", ""], [3, "cHtmlAttr", "cTableColor", "ngClass", "ngStyle", "tabindex"], [4, "ngTemplateOutlet"], [3, "cHtmlAttr", "cTableColor", "colSpan", "ngStyle"], ["autocomplete", "off", "cFormCheckInput", "", "type", "checkbox", 3, "change", "checked", "disabled", "indeterminate"], [3, "click", "keydown", "cHtmlAttr", "cTableColor", "ngClass", "ngStyle", "tabindex"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "cHtmlAttr", "cTableColor", "ngStyle"], [1, "d-inline"], ["cFilterInput", "", "sizing", "sm", 3, "column", "delay", "onEvent", "value"], ["cFilterInput", "", "sizing", "sm", 3, "valueChange", "column", "delay", "onEvent", "value"], [1, "float-end", "mx-1"], [1, "opacity-25", "float-end", "mx-1"], ["role", "img", "viewBox", "0 0 512 512", "width", "18", "xmlns", "http://www.w3.org/2000/svg", 1, "icon", "icon-custom-size"], ["fill", "var(--ci-primary-color, currentColor)", "points", "384 433.373 384 160 352 160 352 434.51 282.177 364.687 259.55 387.313 367.432 495.196 475.313 387.313 452.687 364.687 384 433.373", 1, "ci-primary"], ["fill", "var(--ci-primary-color, currentColor)", "points", "159.432 17.372 51.55 125.255 74.177 147.882 144 78.059 144 352 176 352 176 79.195 244.687 147.882 267.313 125.255 159.432 17.372", 1, "ci-primary"], ["fill", "var(--ci-primary-color, currentColor)", "points", "390.624 150.625 256 16 121.376 150.625 144.004 173.252 240.001 77.254 240.001 495.236 272.001 495.236 272.001 77.257 367.996 173.252 390.624 150.625", 1, "ci-primary"], ["fill", "var(--ci-primary-color, currentColor)", "points", "367.997 338.75 271.999 434.747 271.999 17.503 239.999 17.503 239.999 434.745 144.003 338.75 121.376 361.377 256 496 390.624 361.377 367.997 338.75", 1, "ci-primary"]],
      template: function SmartTableHeadComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵdeclareLet(0)(1);
          i0.ɵɵtemplate(2, SmartTableHeadComponent_Conditional_2_Template, 1, 1, "ng-container")(3, SmartTableHeadComponent_Conditional_3_Template, 2, 0);
          i0.ɵɵelementStart(4, "tr");
          i0.ɵɵtemplate(5, SmartTableHeadComponent_Conditional_5_Template, 3, 5, "th");
          i0.ɵɵrepeaterCreate(6, SmartTableHeadComponent_For_7_Template, 3, 12, "th", 6, i0.ɵɵrepeaterTrackByIdentity);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(8, SmartTableHeadComponent_Conditional_8_Template, 4, 1, "tr")(9, SmartTableHeadComponent_ng_template_9_Template, 3, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(11, SmartTableHeadComponent_ng_template_11_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(13, SmartTableHeadComponent_ng_template_13_Template, 3, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(15, SmartTableHeadComponent_ng_template_15_Template, 3, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(17, SmartTableHeadComponent_ng_template_17_Template, 2, 0, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(19, SmartTableHeadComponent_ng_template_19_Template, 2, 0, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵstoreLet(ctx.columnSorter());
          i0.ɵɵadvance();
          const selectableRows_r23 = i0.ɵɵstoreLet(ctx.selectable());
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.component() === "tfoot" ? 2 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.showGroups() ? 3 : -1);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(selectableRows_r23 ? 5 : -1);
          i0.ɵɵadvance();
          i0.ɵɵrepeater(ctx.columns);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.columnFilter() ? 8 : -1);
        }
      },
      dependencies: [FilterInputDirective, FormCheckInputDirective, HtmlAttributesDirective, SmartTableColumnFilterComponent, TableColorDirective, AsyncPipe, NgStyle, NgTemplateOutlet, SmartTableColumnLabelPipe, NgClass],
      styles: ["[_nghost-%COMP%]{-webkit-user-select:none;user-select:none}.thead[_nghost-%COMP%]{display:table-header-group;vertical-align:middle;border-color:inherit}.tfoot[_nghost-%COMP%]{display:table-footer-group;vertical-align:middle;border-color:inherit}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SmartTableHeadComponent, [{
    type: Component,
    args: [{
      selector: 'c-smart-table-head',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [FilterInputDirective, FormCheckInputDirective, HtmlAttributesDirective, SmartTableColumnFilterComponent, TableColorDirective, AsyncPipe, NgStyle, NgTemplateOutlet, SmartTableColumnLabelPipe, NgClass],
      host: {
        '[class]': 'hostClasses()'
      },
      template: "@let colSorter = columnSorter();\n@let selectableRows = selectable();\n\n@if (component() === 'tfoot') {\n  <ng-container *ngTemplateOutlet=\"summaryRowTemplate\" />\n}\n@if (showGroups()) {\n  @for (row of columnGroups(); track row; let i = $index) {\n    <tr>\n      @if (selectableRows) {\n        <th></th>\n      }\n      @for (cell of row; track cell; let i = $index) {\n        <th [cHtmlAttr]=\"getTableHeaderCellProps(cell)\"\n            [cTableColor]=\"tableHeaderCellColor(cell)\"\n            [colSpan]=\"cell.colspan ?? 1\"\n            [ngStyle]=\"getTableHeaderCellStyles(cell, colSorter)\"\n        >\n          {{ cell.label }}\n        </th>\n      }\n    </tr>\n  }\n}\n\n<tr>\n  @if (selectableRows) {\n    <th>\n      <input\n        (change)=\"handleSelectAllChecked($event)\"\n        [checked]=\"selectedAll === true\"\n        [disabled]=\"!selectAll()\"\n        [indeterminate]=\"indeterminate$ | async\"\n        autocomplete=\"off\"\n        cFormCheckInput\n        type=\"checkbox\"\n      >\n    </th>\n  }\n  @for (column of columns; track column; let i = $index) {\n    <th\n      (click)=\"handleSortClick(column, i)\"\n      (keydown)=\"handleSortKeyDown($event, column, i)\"\n      [attr.aria-sort]=\"getAriaSort(column)\"\n      [cHtmlAttr]=\"getTableHeaderCellProps(column)\"\n      [cTableColor]=\"tableHeaderCellColor(column)\"\n      [ngClass]=\"getTableHeaderCellClass(column)\"\n      [ngStyle]=\"getTableHeaderCellStyles(column, colSorter)\"\n      [tabindex]=\"colSorter && columnSorterEnabled(column) ? 0 : -1\"\n    >\n      @if (colSorter && columnSorterEnabled(column)) {\n        <ng-container\n          *ngTemplateOutlet=\"columnSorterIconTemplate; context: { $implicit: getColumnSorterState(column) }\"\n        />\n      }\n      <ng-container\n        *ngTemplateOutlet=\"columnLabelTemplates[getColumnLabel(column)] ?? defaultColumnLabel; context: {$implicit: column, header: this}\"\n      />\n    </th>\n  }\n</tr>\n@if (columnFilter()) {\n  <tr>\n    @if (selectableRows) {\n      <th></th>\n    }\n    @for (column of columns; track column; let i = $index) {\n      <th [cHtmlAttr]=\"getTableHeaderCellProps(column)\"\n          [cTableColor]=\"tableHeaderCellColor(column)\"\n          [ngStyle]=\"getTableHeaderCellStyles(column, colSorter)\"\n      >\n        <ng-container\n          *ngTemplateOutlet=\"columnFilterTemplates[getColumnFilter(column)] ?? defaultColumnFilter; context: {$implicit: column, header: this}\"\n        />\n      </th>\n    }\n  </tr>\n}\n\n<ng-template #defaultColumnLabel let-column>\n  <div class=\"d-inline\">{{ column | columnLabel }}</div>\n</ng-template>\n\n<ng-template #defaultColumnFilter let-column>\n  @if (columnFilterEnabled(column)) {\n    <c-smart-table-column-filter\n      (valueChange)=\"handleColumnFilterValueChange($event)\"\n      [column]=\"column\"\n      [delay]=\"300\"\n      [onEvent]=\"columnFilterEvent\"\n      [value]=\"columnFilterState()[columnKey(column)] ?? ''\"\n      cFilterInput\n      sizing=\"sm\"\n    />\n  }\n</ng-template>\n\n<ng-template #columnSorterIconTemplate let-columnSorterState>\n  @switch (columnSorterState) {\n    @case ('asc') {\n      <span class=\"float-end mx-1\">\n        <ng-container *ngTemplateOutlet=\"sortingIconAscendingTemplate\" />\n      </span>\n    }\n    @case ('desc') {\n      <span class=\"float-end mx-1\">\n        <ng-container *ngTemplateOutlet=\"sortingIconDescendingTemplate\" />\n      </span>\n    }\n    @default {\n      <span class=\"opacity-25 float-end mx-1\">\n        <ng-container *ngTemplateOutlet=\"sortingIconTemplate\" />\n      </span>\n    }\n  }\n</ng-template>\n\n<!--todo: sortingIconCustom Templates-->\n<ng-template #sortingIconTemplate>\n  <svg\n    class=\"icon icon-custom-size\"\n    role=\"img\"\n    viewBox=\"0 0 512 512\"\n    width=\"18\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n  >\n    <polygon\n      class=\"ci-primary\"\n      fill=\"var(--ci-primary-color, currentColor)\"\n      points=\"384 433.373 384 160 352 160 352 434.51 282.177 364.687 259.55 387.313 367.432 495.196 475.313 387.313 452.687 364.687 384 433.373\"\n    ></polygon>\n    <polygon\n      class=\"ci-primary\"\n      fill=\"var(--ci-primary-color, currentColor)\"\n      points=\"159.432 17.372 51.55 125.255 74.177 147.882 144 78.059 144 352 176 352 176 79.195 244.687 147.882 267.313 125.255 159.432 17.372\"\n    ></polygon>\n  </svg>\n</ng-template>\n\n<ng-template #sortingIconAscendingTemplate>\n  <svg\n    class=\"icon icon-custom-size\"\n    role=\"img\"\n    viewBox=\"0 0 512 512\"\n    width=\"18\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n  >\n    <polygon\n      class=\"ci-primary\"\n      fill=\"var(--ci-primary-color, currentColor)\"\n      points=\"390.624 150.625 256 16 121.376 150.625 144.004 173.252 240.001 77.254 240.001 495.236 272.001 495.236 272.001 77.257 367.996 173.252 390.624 150.625\"\n    ></polygon>\n  </svg>\n</ng-template>\n\n<ng-template #sortingIconDescendingTemplate>\n  <svg\n    class=\"icon icon-custom-size\"\n    role=\"img\"\n    viewBox=\"0 0 512 512\"\n    width=\"18\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n  >\n    <polygon\n      class=\"ci-primary\"\n      fill=\"var(--ci-primary-color, currentColor)\"\n      points=\"367.997 338.75 271.999 434.747 271.999 17.503 239.999 17.503 239.999 434.745 144.003 338.75 121.376 361.377 256 496 390.624 361.377 367.997 338.75\"\n    ></polygon>\n  </svg>\n</ng-template>\n",
      styles: [":host{-webkit-user-select:none;user-select:none}:host.thead{display:table-header-group;vertical-align:middle;border-color:inherit}:host.tfoot{display:table-footer-group;vertical-align:middle;border-color:inherit}\n"]
    }]
  }], null, {
    columns: [{
      type: Input
    }],
    selectedAll: [{
      type: Input
    }],
    columnFilterTemplates: [{
      type: Input
    }],
    columnLabelTemplates: [{
      type: Input
    }],
    summaryRowTemplate: [{
      type: Input
    }]
  });
})();
class SmartTableItemsPerPageSelectorComponent {
  constructor() {
    this.#itemsPerPage = 5;
    this.itemsPerPageLabel = 'Items per page:';
    this.itemsPerPageOptions = [5, 10, 20, 50];
    this.itemsPerPageChange = new EventEmitter();
  }
  set itemsPerPage(value) {
    if (this.#itemsPerPage != value) {
      this.#itemsPerPage = value;
      this.itemsPerPageChange.emit(value);
    }
  }
  get itemsPerPage() {
    return this.#itemsPerPage;
  }
  #itemsPerPage;
  get hostClasses() {
    return {
      row: true
    };
  }
  static {
    this.ɵfac = function SmartTableItemsPerPageSelectorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SmartTableItemsPerPageSelectorComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SmartTableItemsPerPageSelectorComponent,
      selectors: [["c-smart-table-items-per-page-selector"]],
      hostVars: 2,
      hostBindings: function SmartTableItemsPerPageSelectorComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses);
        }
      },
      inputs: {
        itemsPerPage: "itemsPerPage",
        itemsPerPageLabel: "itemsPerPageLabel",
        itemsPerPageOptions: "itemsPerPageOptions"
      },
      outputs: {
        itemsPerPageChange: "itemsPerPageChange"
      },
      decls: 6,
      vars: 2,
      consts: [["cLabel", "col", 1, "col-sm-auto"], [1, "col-auto"], ["cSelect", "", "name", "itemsPerPageSelector", 3, "ngModelChange", "ngModel"], [3, "ngValue"]],
      template: function SmartTableItemsPerPageSelectorComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "label", 0);
          i0.ɵɵtext(1);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(2, "div", 1)(3, "select", 2);
          i0.ɵɵtwoWayListener("ngModelChange", function SmartTableItemsPerPageSelectorComponent_Template_select_ngModelChange_3_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.itemsPerPage, $event) || (ctx.itemsPerPage = $event);
            return $event;
          });
          i0.ɵɵrepeaterCreate(4, SmartTableItemsPerPageSelectorComponent_For_5_Template, 2, 2, "option", 3, i0.ɵɵrepeaterTrackByIdentity);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate(ctx.itemsPerPageLabel);
          i0.ɵɵadvance(2);
          i0.ɵɵtwoWayProperty("ngModel", ctx.itemsPerPage);
          i0.ɵɵadvance();
          i0.ɵɵrepeater(ctx.itemsPerPageOptions);
        }
      },
      dependencies: [FormSelectDirective, FormLabelDirective, FormsModule, i1$2.NgSelectOption, i1$2.ɵNgSelectMultipleOption, i1$2.SelectControlValueAccessor, i1$2.NgControlStatus, i1$2.NgModel],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SmartTableItemsPerPageSelectorComponent, [{
    type: Component,
    args: [{
      selector: 'c-smart-table-items-per-page-selector',
      imports: [FormSelectDirective, FormLabelDirective, FormsModule],
      template: "<label cLabel=\"col\" class=\"col-sm-auto\">{{ itemsPerPageLabel }}</label>\n<div class=\"col-auto\">\n  <select [(ngModel)]=\"itemsPerPage\" cSelect name=\"itemsPerPageSelector\">\n    @for (option of itemsPerPageOptions; track option; let i = $index) {\n      <option [ngValue]=\"option\">{{ option }}</option>\n    }\n  </select>\n</div>\n"
    }]
  }], null, {
    itemsPerPage: [{
      type: Input
    }],
    itemsPerPageLabel: [{
      type: Input
    }],
    itemsPerPageOptions: [{
      type: Input
    }],
    itemsPerPageChange: [{
      type: Output
    }],
    hostClasses: [{
      type: HostBinding,
      args: ['class']
    }]
  });
})();
class SmartTableComponent {
  constructor(iterableDiffers, keyValueDiffers) {
    this.iterableDiffers = iterableDiffers;
    this.keyValueDiffers = keyValueDiffers;
    this.getColumnKey = getColumnKey;
    this.getTableDataCellClass = getTableDataCellClass;
    this.getTableDataCellProps = getTableDataCellProps;
    this.getTableDataCellStyles = getTableDataCellStyles;
    this.selectedAllSubject = new BehaviorSubject(false);
    this._activePage = 1;
    this.cleaner = false;
    this.clickableRows = false;
    this.columns$ = signal([]);
    this.columnGroups$ = signal([]);
    this.showGroups$ = computed(() => !!this.columnGroups$().length);
    this._columnFilterValue = {};
    this.columnSorter = input(false);
    this.footer = false;
    this.header = false;
    this.items$ = signal([]);
    this._items = [];
    this._itemsPerPage = 10;
    this.itemsPerPageLabel = 'Items per page:';
    this.itemsPerPageOptions = [5, 10, 20, 50];
    this.noItemsLabel = 'No items found';
    this.pagination = false;
    this._selectable = false;
    this.selectAll = true;
    this._sorterValue = {};
    this.tableFilterLabel = 'Filter:';
    this.tableFilterPlaceholder = 'type string...';
    this._tableFilterValue = '';
    this.tableBodyProps = {};
    this.tableFootProps = {};
    this.tableHeadProps = {};
    this.tableProps = {};
    this.selectedItemsChange = new EventEmitter();
    this.sorterValueChange = new EventEmitter();
    this.activePageChange = new EventEmitter();
    this.itemsPerPageChange = new EventEmitter();
    this.rowClick = new EventEmitter();
    this.columnFilterValueChange = new EventEmitter();
    this.filteredItemsChange = new EventEmitter();
    this.tableFilterValueChange = new EventEmitter();
    this.templates = {
      tableDetails: null,
      tableData: null
    };
    this.columnFilterTemplates = {};
    this.columnLabelTemplates = {};
    this.summaryRowTemplate = null;
    this.rawColumnNames$ = computed(() => {
      return getColumnNames(this.columns$(), this.items$());
    });
    this.itemsDataColumns$ = computed(() => this.rawColumnNames$().filter(name => getColumnNamesFromItems(this.items$()).includes(name)));
    this._columnFiltered = [];
    this.itemsDiffer = this.iterableDiffers.find(this.items).create();
    this.itemsFilteredDiffer = this.iterableDiffers.find(this._columnFiltered).create();
    this.columFilterValueDiffer = this.keyValueDiffers.find(this.columnFilterValue).create();
    this.sorterValueDiffer = this.keyValueDiffers.find(this.sorterValue).create();
  }
  set activePage(value) {
    this._activePage = value || 1;
    this.activePageChange.emit(this._activePage);
  }
  get activePage() {
    return this._activePage;
  }
  set columns(value) {
    const colObjects = value.map(column => typeof column === 'string' ? {
      key: column
    } : {
      ...column
    });
    const columns = getColumns(colObjects);
    this.columns$.set(columns);
    // todo: Input columnGroups - separation?
    // console.log(getColumnGroups(colObjects ?? []));
    const groups = getColumnGroups(value ?? []);
    this.columnGroups$.set(groups);
  }
  get columns() {
    return this.columns$();
  }
  set columnFilterValue(value) {
    if (this.columFilterValueDiffer) {
      const changes = this.columFilterValueDiffer.diff(value);
      if (changes) {
        this._columnFilterValue = {
          ...value
        };
        this.columnFilterValueChange.emit({
          ...this._columnFilterValue
        });
        this.tableFiltered; // emits tableFiltered change
      }
    }
  }
  get columnFilterValue() {
    return this._columnFilterValue;
  }
  set items(value) {
    if (this.itemsDiffer) {
      const changes = this.itemsDiffer.diff(value);
      if (changes) {
        this._items = this.setItems(value);
        this.items$.set(this._items);
        if (!this.columns.length) {
          this.columns = getColumnNamesFromItems(this.items$());
        }
      }
    }
  }
  get items() {
    return this._items;
  }
  set itemsPerPage(value) {
    this._itemsPerPage = value;
  }
  get itemsPerPage() {
    return this._itemsPerPage;
  }
  set selectable(value) {
    this._selectable = value;
  }
  get selectable() {
    return this._selectable;
  }
  set sorterValue(value) {
    if (this.sorterValueDiffer) {
      const changes = this.sorterValueDiffer.diff(value);
      if (changes) {
        this._sorterValue = value;
        this.sorterValueChange.emit({
          ...value
        });
      }
    }
  }
  get sorterValue() {
    return this._sorterValue;
  }
  set tableFilter(filter) {
    this._tableFilter = filter;
    if (typeof filter === 'object') {
      this.tableFilterLabel = typeof filter.label === 'string' ? filter.label : this.tableFilterLabel;
      this.tableFilterPlaceholder = typeof filter.placeholder === 'string' ? filter.placeholder : this.tableFilterPlaceholder;
      this.tableFilterValue = typeof filter.value === 'string' ? filter.value : this.tableFilterValue;
    }
  }
  get tableFilter() {
    return this._tableFilter;
  }
  set tableFilterValue(value) {
    if (this._tableFilterValue !== value) {
      this._tableFilterValue = value;
      this.tableFilterValueChange.emit(value);
      this.tableFiltered; // emits tableFiltered change
    }
  }
  get tableFilterValue() {
    return this._tableFilterValue;
  }
  ngAfterContentInit() {
    this.columnTemplates.forEach(child => {
      if (child.id.startsWith('columnFilter_')) {
        this.columnFilterTemplates[child.id] = child.templateRef;
        return;
      }
      if (child.id.startsWith('columnLabel_')) {
        this.columnLabelTemplates[child.id] = child.templateRef;
        return;
      }
      if (child.id === 'tableSummaryRow') {
        this.summaryRowTemplate = child.templateRef;
        return;
      }
      this.templates[child.id] = child.templateRef;
    });
    this.columnFilterTemplates = {
      ...this.columnFilterTemplates
    };
    this.columnLabelTemplates = {
      ...this.columnLabelTemplates
    };
    setTimeout(() => {
      this.selectedAllSubject.next(this.selectedAll);
    }, 0);
  }
  get selectedAll() {
    const selected = this.items.some(item => item._selected === true);
    const unselected = this.items.some(item => item._selected !== true);
    return selected && unselected ? 'indeterminate' : selected;
  }
  get tableFilterState() {
    return this.tableFilterValue ? this.tableFilterValue : '';
  }
  get columnFilterState() {
    return this.columnFilterValue ? this.columnFilterValue : {};
  }
  get numberOfPages() {
    return this._itemsPerPage ? Math.ceil(this.sortedItems.length / this._itemsPerPage) : 1;
  }
  get colspan() {
    return this._selectable ? this.rawColumnNames$().length + 1 : this.rawColumnNames$().length;
  }
  get firstItemOnActivePageIndex() {
    return this._activePage ? (this._activePage - 1) * this._itemsPerPage : 0;
  }
  get itemsOnActivePage() {
    return this.sortedItems.slice(this.firstItemOnActivePageIndex, this.firstItemOnActivePageIndex + this._itemsPerPage);
  }
  get currentItems() {
    return this._activePage ? this.itemsOnActivePage : this.sortedItems ?? [];
  }
  get sortedItems() {
    const columnKey = this.sorterValue.column;
    const currentColumn = this.columns.find(column => column.key === columnKey);
    const columnSorter = this.columnSorter();
    if (!columnKey || !this.itemsDataColumns$().includes(columnKey) && typeof currentColumn?.sorter !== 'function' || typeof columnSorter === 'object' && columnSorter.external) {
      return this.tableFiltered;
    }
    const tableFiltered = [...this.tableFiltered];
    // if values in column are to be sorted by numeric value they all have to be a type of number
    const flip = this.sorterValue.state === 'asc' ? 1 : this.sorterValue.state === 'desc' ? -1 : 0;
    if (flip === 0) {
      return tableFiltered;
    }
    if (typeof currentColumn?.sorter === 'function') {
      const sorted = tableFiltered.slice().sort(currentColumn.sorter);
      return flip < 0 ? sorted.reverse() : sorted;
    }
    const compareFn = (item1, item2) => {
      const value1 = item1[columnKey];
      const value2 = item2[columnKey];
      const a = typeof value1 === 'number' ? value1 : String(value1).toLowerCase();
      const b = typeof value2 === 'number' ? value2 : String(value2).toLowerCase();
      return a > b ? 1 * flip : b > a ? -1 * flip : 0;
    };
    return tableFiltered.slice().sort(compareFn);
  }
  get tableFilterEvent() {
    return typeof this.tableFilter === 'object' && this.tableFilter.lazy ? 'change' : 'input';
  }
  get columnFiltered() {
    let _items = this._items;
    if (this.columnFilter && typeof this.columnFilter === 'object' && this.columnFilter.external) {
      this._columnFiltered = _items;
      return _items;
    }
    Object.entries(this.columnFilterState).forEach(([key, value]) => {
      if (value instanceof Function) {
        _items = _items.filter(item => value(item[key]));
        return;
      }
      const currentColumn = this.columns.find(column => column.key === key);
      if (typeof currentColumn?.filter === 'function') {
        _items = _items.filter(item => (typeof currentColumn.filter === 'function' && currentColumn.filter(item, value)) ?? !value);
        return;
      }
      const columnFilter = String(value).toLowerCase();
      if (columnFilter && this.itemsDataColumns$().includes(key)) {
        _items = _items.filter(item => String(item[key]).toLowerCase().includes(columnFilter));
      }
    });
    this._columnFiltered = _items;
    return _items;
  }
  get tableFiltered() {
    let items = this.columnFiltered;
    if (!this.tableFilterState || this.tableFilter && typeof this.tableFilter === 'object' && this.tableFilter.external) {
      if (this.itemsFilteredDiffer) {
        const changes = this.itemsFilteredDiffer.diff(items);
        if (changes) {
          this.filteredItemsChange.emit(items);
        }
      }
      return items;
    }
    const filter = this.tableFilterState.toLowerCase();
    const valueContainFilter = val => String(val).toLowerCase().includes(filter);
    // @ts-ignore
    items = items.filter(item => {
      return !!this.itemsDataColumns$().find(key => valueContainFilter(item[key]));
    });
    if (this.itemsFilteredDiffer) {
      const changes = this.itemsFilteredDiffer.diff(items);
      if (changes) {
        this.filteredItemsChange.emit(items);
      }
    }
    return items;
  }
  get isFiltered() {
    return this.tableFilterState || this.sorterValue?.column || Object.values(this.columnFilterState).join('');
  }
  setItems(items) {
    if (Array.isArray(items)) {
      return items.map((item, index) => {
        return {
          ...item,
          ___id: item['___id'] ?? index
        };
      });
    }
    return [];
  }
  handleSortChange($event) {
    this.handleSorterChange($event.columnKey, $event.index, $event.order);
  }
  isSortable(i) {
    const columnSorter = this.columnSorter();
    if (!columnSorter) {
      return false;
    }
    const columnKey = this.rawColumnNames$()[i];
    const isDataColumn = this.itemsDataColumns$().includes(columnKey);
    const column = this.columns[i];
    const isColumnSortable = !this.columns.length || typeof column !== 'object' || column.sorter !== false;
    const isExternalSorter = typeof columnSorter === 'object' && columnSorter.external;
    return isColumnSortable && (isDataColumn || typeof column?.sorter === 'function') || isExternalSorter;
  }
  handleSorterChange(column, index, order) {
    if (!this.isSortable(index)) {
      return;
    }
    //if column changed or sort was descending change asc to true
    const sorterState = {
      ...this.sorterValue
    };
    if (sorterState.column === column) {
      const columnSorter = this.columnSorter();
      const resettable = columnSorter === true || typeof columnSorter === 'object' && columnSorter.resetable !== false && columnSorter.resettable !== false;
      const state = sorterState.state;
      if (order === undefined) {
        sorterState.state = state === 0 ? 'asc' : state === 'asc' ? 'desc' : resettable ? 0 : 'asc';
      } else {
        sorterState.state = order === 0 && !resettable ? state : order;
      }
    } else {
      sorterState.column = column;
      sorterState.state = 'asc';
    }
    this.sorterValue = {
      ...sorterState
    };
  }
  setActivePage($event) {
    this.activePage = $event;
  }
  handleColumnFilterChange($event) {
    const {
      column,
      value,
      type
    } = $event;
    this.setActivePage(1);
    this.columnFilterValue = {
      ...this.columnFilterValue,
      [`${column}`]: value
    };
  }
  handleTableFilterChange($event) {
    const {
      value,
      type
    } = $event;
    const isLazy = typeof this.tableFilter === 'object' && this.tableFilter.lazy === true;
    if ((isLazy && type === 'input' || !isLazy && type === 'change') && value.length !== 0) {
      return;
    }
    this.setActivePage(1);
    this.tableFilterValue = value;
  }
  clean($event) {
    this.columnFilterValue = {};
    this.tableFilterValue = '';
    this.sorterValue = {};
    this.tableFiltered; //emits tableFiltered change
  }
  handleItemsPerPageChange(value) {
    if (value !== this._itemsPerPage) {
      this.setActivePage(1);
      this._itemsPerPage = value;
      this.itemsPerPageChange.emit(value);
    }
  }
  handleRowChecked($event, item) {
    item._selected = item._selectable !== false && $event.target.checked;
    this.selectedItemsChange.emit(this.items.filter(item => item._selected === true));
    setTimeout(() => {
      this.selectedAllSubject.next(this.selectedAll);
    }, 0);
  }
  handleSelectAllChange($event) {
    const tableFiltered = [...this.tableFiltered];
    this._items = this.items.map(item => {
      if (!tableFiltered.includes(item)) {
        return {
          ...item
        };
      }
      return {
        ...item,
        _selected: item._selectable !== false ? $event : !!item._selected
      };
    });
    this.selectedAllSubject.next($event);
    setTimeout(() => {
      this.selectedItemsChange.emit(this.items.filter(item => item._selected === true));
      this.selectedAllSubject.next(this.selectedAll);
    }, 0);
  }
  handleRowClick(param) {
    const {
      $event,
      item,
      i
    } = {
      ...param
    };
    const target = $event.target;
    const columnNames = this.rawColumnNames$();
    const selectable = this._selectable;
    const columnName = getClickedColumnName(target, columnNames, selectable);
    this.rowClick.emit({
      item: item,
      index: i + this.firstItemOnActivePageIndex,
      columnName,
      event: $event
    });
  }
  ngOnChanges(changes) {
    if (changes['columnFilterValue']) {
      const columnFilterValueChange = changes['columnFilterValue'];
      const currentValue = columnFilterValueChange.currentValue;
      if (typeof currentValue === 'object' && Object.keys(currentValue ?? {}).length) {
        this.setActivePage(1);
      }
    }
    if (changes['tableFilterValue']) {
      const tableFilterValueChange = changes['tableFilterValue'];
      const currentValue = tableFilterValueChange.currentValue;
      if (currentValue.length) {
        this.setActivePage(1);
      }
    }
  }
  static {
    this.ɵfac = function SmartTableComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SmartTableComponent)(i0.ɵɵdirectiveInject(i0.IterableDiffers), i0.ɵɵdirectiveInject(i0.KeyValueDiffers));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SmartTableComponent,
      selectors: [["c-smart-table"]],
      contentQueries: function SmartTableComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, TemplateIdDirective, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.columnTemplates = _t);
        }
      },
      inputs: {
        activePage: [2, "activePage", "activePage", numberAttribute],
        cleaner: [2, "cleaner", "cleaner", booleanAttribute],
        clickableRows: [2, "clickableRows", "clickableRows", booleanAttribute],
        columns: "columns",
        columnFilter: "columnFilter",
        columnFilterValue: "columnFilterValue",
        columnSorter: [1, "columnSorter"],
        footer: [2, "footer", "footer", booleanAttribute],
        header: [2, "header", "header", booleanAttribute],
        items: "items",
        itemsPerPage: [2, "itemsPerPage", "itemsPerPage", numberAttribute],
        itemsPerPageLabel: "itemsPerPageLabel",
        itemsPerPageOptions: "itemsPerPageOptions",
        itemsPerPageSelect: "itemsPerPageSelect",
        loading: "loading",
        noItemsLabel: "noItemsLabel",
        pagination: [2, "pagination", "pagination", booleanAttribute],
        selectable: [2, "selectable", "selectable", booleanAttribute],
        selectAll: [2, "selectAll", "selectAll", booleanAttribute],
        sorterValue: "sorterValue",
        tableFilter: "tableFilter",
        tableFilterLabel: "tableFilterLabel",
        tableFilterPlaceholder: "tableFilterPlaceholder",
        tableFilterValue: "tableFilterValue",
        tableBodyProps: "tableBodyProps",
        tableFootProps: "tableFootProps",
        tableHeadProps: "tableHeadProps",
        tableProps: "tableProps"
      },
      outputs: {
        selectedItemsChange: "selectedItemsChange",
        sorterValueChange: "sorterValueChange",
        activePageChange: "activePageChange",
        itemsPerPageChange: "itemsPerPageChange",
        rowClick: "rowClick",
        columnFilterValueChange: "columnFilterValueChange",
        filteredItemsChange: "filteredItemsChange",
        tableFilterValueChange: "tableFilterValueChange"
      },
      exportAs: ["cSmartTable"],
      features: [i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c49,
      decls: 17,
      vars: 20,
      consts: [["tbodyDefaultTemplate", ""], ["columnDefaultTemplate", ""], ["noItemsDefaultTemplate", ""], ["filterIconTemplate", ""], ["tableFilterTemplate", ""], ["tableCleanerTemplate", ""], ["tableCustomHeaderTemplate", ""], [1, "row", "my-2", "mx-0"], [1, "position-relative"], ["cTable", "", 3, "align", "borderColor", "bordered", "borderless", "cHtmlAttr", "cTableColor", "caption", "color", "hover", "responsive", "small", "striped"], [3, "cAlign", "cHtmlAttr", "cTableColor", "columnFilterState", "columnFilterTemplates", "columnFilter", "columnGroups", "columnLabelTemplates", "columnSorter", "columns", "selectAll", "selectable", "selectedAll", "showGroups", "sorterValue"], [4, "ngTemplateOutlet"], ["component", "tfoot", 3, "cAlign", "cHtmlAttr", "cTableColor", "columnFilterTemplates", "columnLabelTemplates", "columnSorter", "columns", "selectAll", "selectable", "selectedAll", "sorterValue", "summaryRowTemplate"], [3, "boundaries"], [1, "row"], [1, "col-auto", "p-0"], ["cFilterInput", "", 3, "delay", "filterLabel", "filterPlaceholder", "onEvent", "value"], ["cFilterInput", "", 3, "valueChange", "delay", "filterLabel", "filterPlaceholder", "onEvent", "value"], ["cButton", "", "color", "transparent", "tabindex", "0", 3, "disabled", "ngClass"], ["cButton", "", "color", "transparent", "tabindex", "0", 3, "click", "disabled", "ngClass"], [1, "col-auto", "p-0", "ms-auto"], [3, "columnFilterStateChange", "selectAllChange", "sorterStateChange", "cAlign", "cHtmlAttr", "cTableColor", "columnFilterState", "columnFilterTemplates", "columnFilter", "columnGroups", "columnLabelTemplates", "columnSorter", "columns", "selectAll", "selectable", "selectedAll", "showGroups", "sorterValue"], ["component", "tfoot", 3, "selectAllChange", "sorterStateChange", "cAlign", "cHtmlAttr", "cTableColor", "columnFilterTemplates", "columnLabelTemplates", "columnSorter", "columns", "selectAll", "selectable", "selectedAll", "sorterValue", "summaryRowTemplate"], [1, "col"], [3, "activePage", "pages"], [1, "col-auto", "ms-auto"], [3, "itemsPerPageLabel", "itemsPerPageOptions", "itemsPerPage"], [3, "activePageChange", "activePage", "pages"], [3, "itemsPerPageChange", "itemsPerPageLabel", "itemsPerPageOptions", "itemsPerPage"], [3, "cAlign", "cHtmlAttr", "cTableColor"], [3, "click", "cAlign", "cTableActive", "cTableColor", "ngStyle", "tabindex"], [3, "cAlign", "cTableActive", "cTableColor"], ["autocomplete", "off", "cFormCheckInput", "", 3, "change", "checked", "disabled"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["tabindex", "-1", 1, "p-0", 3, "colSpan", "ngStyle"], [1, "p-0"], [1, "p-0", 3, "colSpan", "ngStyle"], [3, "cAlign", "cHtmlAttr", "cTableActive", "cTableColor", "ngClass", "ngStyle"], [1, "justify-content-center", 3, "colSpan"], ["pointer-events", "none", "role", "img", "viewBox", "0 0 512 512", "width", "18", "xmlns", "http://www.w3.org/2000/svg", 1, "icon", "icon-custom-size"], ["fill", "var(--ci-primary-color, currentColor)", "points", "40 16 40 53.828 109.024 136 150.815 136 76.896 48 459.51 48 304 242.388 304 401.373 241.373 464 240 464 240 368 208 368 208 496 254.627 496 336 414.627 336 253.612 496 53.612 496 16 40 16", 1, "ci-primary"], ["fill", "var(--ci-primary-color, currentColor)", "points", "166.403 248.225 226.864 187.763 204.237 165.135 143.775 225.597 83.313 165.135 60.687 187.763 121.148 248.225 60.687 308.687 83.313 331.314 143.775 270.852 204.237 331.314 226.864 308.687 166.403 248.225", 1, "ci-primary"]],
      template: function SmartTableComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c48);
          i0.ɵɵtemplate(0, SmartTableComponent_Conditional_0_Template, 10, 3, "div", 7);
          i0.ɵɵelementStart(1, "div", 8)(2, "table", 9);
          i0.ɵɵtemplate(3, SmartTableComponent_Conditional_3_Template, 2, 18, "c-smart-table-head", 10)(4, SmartTableComponent_ng_container_4_Template, 1, 0, "ng-container", 11)(5, SmartTableComponent_Conditional_5_Template, 2, 1, "tfoot")(6, SmartTableComponent_Conditional_6_Template, 2, 15, "c-smart-table-head", 12);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(7, SmartTableComponent_Conditional_7_Template, 1, 10, "c-element-cover", 13);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(8, SmartTableComponent_Conditional_8_Template, 5, 2, "div", 14)(9, SmartTableComponent_ng_template_9_Template, 4, 5, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(11, SmartTableComponent_ng_template_11_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(13, SmartTableComponent_ng_template_13_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(15, SmartTableComponent_ng_template_15_Template, 3, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          let tmp_7_0;
          let tmp_8_0;
          let tmp_9_0;
          let tmp_13_0;
          let tmp_15_0;
          let tmp_16_0;
          const tbodyDefaultTemplate_r28 = i0.ɵɵreference(10);
          i0.ɵɵconditional(ctx.itemsPerPageSelect || ctx.tableFilter || ctx.cleaner || ctx.templates["tableCustomHeader"] ? 0 : -1);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("align", ctx.tableProps == null ? null : ctx.tableProps.align)("borderColor", ctx.tableProps == null ? null : ctx.tableProps.borderColor)("bordered", (tmp_7_0 = ctx.tableProps == null ? null : ctx.tableProps.bordered) !== null && tmp_7_0 !== undefined ? tmp_7_0 : undefined)("borderless", (tmp_8_0 = ctx.tableProps == null ? null : ctx.tableProps.borderless) !== null && tmp_8_0 !== undefined ? tmp_8_0 : undefined)("cHtmlAttr", (tmp_9_0 = ctx.tableProps == null ? null : ctx.tableProps.attributes) !== null && tmp_9_0 !== undefined ? tmp_9_0 : i0.ɵɵpureFunction0(19, _c3))("cTableColor", ctx.tableProps == null ? null : ctx.tableProps.color)("caption", ctx.tableProps == null ? null : ctx.tableProps.caption)("color", ctx.tableProps == null ? null : ctx.tableProps.color)("hover", (tmp_13_0 = ctx.tableProps == null ? null : ctx.tableProps.hover) !== null && tmp_13_0 !== undefined ? tmp_13_0 : undefined)("responsive", ctx.tableProps == null ? null : ctx.tableProps.responsive)("small", (tmp_15_0 = ctx.tableProps == null ? null : ctx.tableProps.small) !== null && tmp_15_0 !== undefined ? tmp_15_0 : undefined)("striped", (tmp_16_0 = ctx.tableProps == null ? null : ctx.tableProps.striped) !== null && tmp_16_0 !== undefined ? tmp_16_0 : undefined);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.header ? 3 : -1);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngTemplateOutlet", tbodyDefaultTemplate_r28);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.summaryRowTemplate && !ctx.footer ? 5 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.footer ? 6 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.loading ? 7 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.pagination || ctx.itemsPerPageSelect ? 8 : -1);
        }
      },
      dependencies: [AsyncPipe, NgTemplateOutlet, NgClass, NgStyle, AlignDirective, ButtonDirective, ElementCoverComponent, FilterInputDirective, FormCheckInputDirective, HtmlAttributesDirective, SmartPaginationComponent, SmartTableFilterComponent, SmartTableHeadComponent, SmartTableItemsPerPageSelectorComponent, TableActiveDirective, TableColorDirective, TableDirective],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SmartTableComponent, [{
    type: Component,
    args: [{
      selector: 'c-smart-table',
      exportAs: 'cSmartTable',
      imports: [AsyncPipe, NgTemplateOutlet, NgClass, NgStyle, AlignDirective, ButtonDirective, ElementCoverComponent, FilterInputDirective, FormCheckInputDirective, HtmlAttributesDirective, SmartPaginationComponent, SmartTableFilterComponent, SmartTableHeadComponent, SmartTableItemsPerPageSelectorComponent, TableActiveDirective, TableColorDirective, TableDirective],
      template: "@if (itemsPerPageSelect || tableFilter || cleaner || templates['tableCustomHeader']) {\n  <div class=\"row my-2 mx-0\">\n    @if (tableFilter) {\n      <div class=\"col-auto p-0\">\n        <ng-container *ngTemplateOutlet=\"tableFilterTemplate\" />\n      </div>\n    }\n    @if (cleaner) {\n      <div class=\"col-auto p-0\">\n        <ng-container *ngTemplateOutlet=\"tableCleanerTemplate\" />\n      </div>\n    }\n    <ng-container *ngTemplateOutlet=\"templates['tableCustomHeader'] || tableCustomHeaderTemplate\" />\n\n    <ng-template #tableFilterTemplate>\n      @if (tableFilter) {\n        <c-smart-table-filter\n          (valueChange)=\"handleTableFilterChange($event)\"\n          [delay]=\"300\"\n          [filterLabel]=\"tableFilterLabel\"\n          [filterPlaceholder]=\"tableFilterPlaceholder\"\n          [onEvent]=\"tableFilterEvent\"\n          [value]=\"tableFilterState\"\n          cFilterInput\n        />\n      }\n    </ng-template>\n\n    <ng-template #tableCleanerTemplate>\n      @if (cleaner) {\n        <button\n          (click)=\"clean($event)\"\n          [disabled]=\"!isFiltered\"\n          [ngClass]=\"{'ms-1': tableFilter}\"\n          cButton\n          color=\"transparent\"\n          tabindex=\"0\"\n        >\n          <ng-container *ngTemplateOutlet=\"filterIconTemplate\" />\n        </button>\n      }\n    </ng-template>\n\n    <ng-template #tableCustomHeaderTemplate>\n      <div class=\"col-auto p-0 ms-auto\">\n        <ng-content select=\"[customHeader]\" />\n      </div>\n    </ng-template>\n  </div>\n}\n<div class=\"position-relative\">\n  <table [align]=\"tableProps?.align\"\n         [borderColor]=\"tableProps?.borderColor\"\n         [bordered]=\"tableProps?.bordered ?? undefined\"\n         [borderless]=\"tableProps?.borderless ?? undefined\"\n         [cHtmlAttr]=\"tableProps?.attributes ?? {}\"\n         [cTableColor]=\"tableProps?.color\"\n         [caption]=\"tableProps?.caption\"\n         [color]=\"tableProps?.color\"\n         [hover]=\"tableProps?.hover ?? undefined\"\n         [responsive]=\"tableProps?.responsive\"\n         [small]=\"tableProps?.small ?? undefined\"\n         [striped]=\"tableProps?.striped ?? undefined\"\n         cTable\n  >\n    @if (header) {\n      <c-smart-table-head\n        (columnFilterStateChange)=\"handleColumnFilterChange($event)\"\n        (selectAllChange)=\"handleSelectAllChange($event)\"\n        (sorterStateChange)=\"handleSortChange($event)\"\n        [cAlign]=\"tableHeadProps?.align\"\n        [cHtmlAttr]=\"tableHeadProps?.attributes ?? {}\"\n        [cTableColor]=\"tableHeadProps?.color\"\n        [columnFilterState]=\"columnFilterState\"\n        [columnFilterTemplates]=\"columnFilterTemplates\"\n        [columnFilter]=\"columnFilter\"\n        [columnGroups]=\"columnGroups$()\"\n        [columnLabelTemplates]=\"columnLabelTemplates\"\n        [columnSorter]=\"columnSorter()\"\n        [columns]=\"columns$()\"\n        [selectAll]=\"selectAll\"\n        [selectable]=\"selectable\"\n        [selectedAll]=\"(selectedAllSubject | async) ?? false\"\n        [showGroups]=\"showGroups$()\"\n        [sorterValue]=\"sorterValue\"\n      />\n    }\n\n    <ng-container *ngTemplateOutlet=\"tbodyDefaultTemplate\" />\n\n    @if (summaryRowTemplate && !footer) {\n      <tfoot>\n      <ng-container *ngTemplateOutlet=\"summaryRowTemplate\" />\n      </tfoot>\n    }\n    @if (footer) {\n      <c-smart-table-head\n        (selectAllChange)=\"handleSelectAllChange($event)\"\n        (sorterStateChange)=\"handleSortChange($event)\"\n        [cAlign]=\"tableFootProps?.align\"\n        [cHtmlAttr]=\"tableFootProps?.attributes ?? {}\"\n        [cTableColor]=\"tableFootProps?.color\"\n        [columnFilterTemplates]=\"columnFilterTemplates\"\n        [columnLabelTemplates]=\"columnLabelTemplates\"\n        [columnSorter]=\"columnSorter()\"\n        [columns]=\"columns$()\"\n        [selectAll]=\"selectAll\"\n        [selectable]=\"selectable\"\n        [selectedAll]=\"(selectedAllSubject | async) ?? false\"\n        [sorterValue]=\"sorterValue\"\n        [summaryRowTemplate]=\"summaryRowTemplate\"\n        component=\"tfoot\"\n      />\n    }\n\n  </table>\n  @if (loading) {\n    <c-element-cover\n      [boundaries]=\"[\n        { sides: ['top'], query: 'td' },\n        { sides: ['bottom'], query: 'tbody' }\n      ]\"\n    />\n  }\n</div>\n@if (pagination || itemsPerPageSelect) {\n  <div class=\"row\">\n    <div class=\"col\">\n      @if (pagination && numberOfPages > 1) {\n        <c-smart-pagination\n          (activePageChange)=\"setActivePage($event)\"\n          [activePage]=\"activePage\"\n          [pages]=\"numberOfPages\"\n        />\n      }\n    </div>\n    <div class=\"col-auto ms-auto\">\n      @if (itemsPerPageSelect) {\n        <c-smart-table-items-per-page-selector\n          (itemsPerPageChange)=\"handleItemsPerPageChange($event)\"\n          [itemsPerPageLabel]=\"itemsPerPageLabel\"\n          [itemsPerPageOptions]=\"itemsPerPageOptions\"\n          [itemsPerPage]=\"itemsPerPage\"\n        />\n      }\n    </div>\n  </div>\n}\n<ng-template #tbodyDefaultTemplate>\n  <tbody [cAlign]=\"tableBodyProps?.align\"\n         [cHtmlAttr]=\"tableBodyProps?.attributes ?? {}\"\n         [cTableColor]=\"tableBodyProps?.color\"\n  >\n    @for (item of currentItems; track item; let i = $index, cnt = $count, isEven = $even, isOdd = $odd) {\n      <tr (click)=\"handleRowClick({$event, item, i})\"\n          [cAlign]=\"item._props?.align\"\n          [cTableActive]=\"item._props?.active ?? undefined\"\n          [cTableColor]=\"item._props?.color\"\n          [ngStyle]=\"{cursor: clickableRows ? 'pointer' : 'auto'}\"\n          [tabindex]=\"clickableRows ? 0 : -1\"\n      >\n        @if (selectable) {\n          <td [cAlign]=\"item?.['_cellProps']?._all?.align\"\n              [cTableActive]=\"item?.['_cellProps']?._all?.active ?? undefined\"\n              [cTableColor]=\"item?.['_cellProps']?._all?.color\"\n          >\n            <input (change)=\"handleRowChecked($event, item)\"\n                   [checked]=\"item._selected ?? false\"\n                   [disabled]=\"(item?._selectable === false)\"\n                   autocomplete=\"off\"\n                   cFormCheckInput\n            >\n          </td>\n        }\n        @for (column of columns$(); track column; let i = $index) {\n          @let columnKey = getColumnKey(column);\n          <ng-container\n            *ngTemplateOutlet=\"templates['tableData'] || columnDefaultTemplate; context: {column, item, columnName: getColumnKey(column), tdContent: item[columnKey], cellProps: getTableDataCellProps(column, item) }\"\n          />\n        }\n      </tr>\n      @if (templates['tableDetails']) {\n        <!--      <ng-container *ngTemplateOutlet=\"rowDetailsDefaultTemplate\"></ng-container>-->\n        <tr>\n          <td [colSpan]=\"colspan\" [ngStyle]=\"{borderBottomWidth: 0}\" class=\"p-0\" tabindex=\"-1\"></td>\n        </tr>\n        <tr class=\"p-0\">\n          <td [colSpan]=\"colspan\" [ngStyle]=\"{border: 0}\" class=\"p-0\">\n            <ng-container *ngTemplateOutlet=\"templates['tableDetails']; context: {item, index: i}\" />\n          </td>\n        </tr>\n      }\n    }\n  <ng-container *ngTemplateOutlet=\"noItemsDefaultTemplate\" />\n  </tbody>\n</ng-template>\n\n<ng-template\n  #columnDefaultTemplate\n  let-cellProps=\"cellProps\"\n  let-column=\"column\"\n  let-columnName=\"columnName\"\n  let-item=\"item\"\n  let-tdContent=\"tdContent\"\n>\n  @if (tdContent !== undefined) {\n    <td [cAlign]=\"cellProps?.align\"\n        [cHtmlAttr]=\"cellProps?.['_attributes'] ?? undefined\"\n        [cTableActive]=\"cellProps?.['active']\"\n        [cTableColor]=\"cellProps?.color ?? column[columnName]?._colProps?.color ?? undefined\"\n        [ngClass]=\"getTableDataCellClass(column, item)\"\n        [ngStyle]=\"getTableDataCellStyles(column, item)\"\n    >\n      {{ tdContent }}\n    </td>\n  }\n</ng-template>\n\n<!--<ng-template #rowDetailsDefaultTemplate let-item let-index>-->\n<!--  <tr><td [colSpan]=\"colspan\" class=\"p-0\" tabindex=\"-1\" [ngStyle]=\"{borderBottomWidth: 0}\"></td></tr>-->\n<!--  <tr class=\"p-0\">-->\n<!--    <td [colSpan]=\"colspan\" class=\"p-0\" [ngStyle]=\"{border: 0}\">-->\n<!--      <ng-container *ngTemplateOutlet=\"templates?.tableDetails\"></ng-container>-->\n<!--    </td>-->\n<!--  </tr>-->\n<!--</ng-template>-->\n\n<ng-template #noItemsDefaultTemplate>\n  @if (!currentItems.length) {\n    <tr>\n      <td [colSpan]=\"colspan\" class=\"justify-content-center\">{{ noItemsLabel }}</td>\n    </tr>\n  }\n</ng-template>\n\n<!--todo: filterIconCustomTemplate-->\n<ng-template #filterIconTemplate>\n  <svg class=\"icon icon-custom-size\" pointer-events=\"none\" role=\"img\" viewBox=\"0 0 512 512\"\n       width=\"18\" xmlns=\"http://www.w3.org/2000/svg\">\n    <polygon\n      class=\"ci-primary\"\n      fill=\"var(--ci-primary-color, currentColor)\"\n      points=\"40 16 40 53.828 109.024 136 150.815 136 76.896 48 459.51 48 304 242.388 304 401.373 241.373 464 240 464 240 368 208 368 208 496 254.627 496 336 414.627 336 253.612 496 53.612 496 16 40 16\">\n    </polygon>\n    <polygon\n      class=\"ci-primary\"\n      fill=\"var(--ci-primary-color, currentColor)\"\n      points=\"166.403 248.225 226.864 187.763 204.237 165.135 143.775 225.597 83.313 165.135 60.687 187.763 121.148 248.225 60.687 308.687 83.313 331.314 143.775 270.852 204.237 331.314 226.864 308.687 166.403 248.225\">\n    </polygon>\n  </svg>\n</ng-template>\n",
      styles: [":host{display:block}\n"]
    }]
  }], () => [{
    type: i0.IterableDiffers
  }, {
    type: i0.KeyValueDiffers
  }], {
    activePage: [{
      type: Input,
      args: [{
        transform: numberAttribute
      }]
    }],
    cleaner: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    clickableRows: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    columns: [{
      type: Input
    }],
    columnFilter: [{
      type: Input
    }],
    columnFilterValue: [{
      type: Input
    }],
    footer: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    header: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    items: [{
      type: Input
    }],
    itemsPerPage: [{
      type: Input,
      args: [{
        transform: numberAttribute
      }]
    }],
    itemsPerPageLabel: [{
      type: Input
    }],
    itemsPerPageOptions: [{
      type: Input
    }],
    itemsPerPageSelect: [{
      type: Input
    }],
    loading: [{
      type: Input
    }],
    noItemsLabel: [{
      type: Input
    }],
    pagination: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    selectable: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    selectAll: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    sorterValue: [{
      type: Input
    }],
    tableFilter: [{
      type: Input
    }],
    tableFilterLabel: [{
      type: Input
    }],
    tableFilterPlaceholder: [{
      type: Input
    }],
    tableFilterValue: [{
      type: Input
    }],
    tableBodyProps: [{
      type: Input
    }],
    tableFootProps: [{
      type: Input
    }],
    tableHeadProps: [{
      type: Input
    }],
    tableProps: [{
      type: Input
    }],
    selectedItemsChange: [{
      type: Output
    }],
    sorterValueChange: [{
      type: Output
    }],
    activePageChange: [{
      type: Output
    }],
    itemsPerPageChange: [{
      type: Output
    }],
    rowClick: [{
      type: Output
    }],
    columnFilterValueChange: [{
      type: Output
    }],
    filteredItemsChange: [{
      type: Output
    }],
    tableFilterValueChange: [{
      type: Output
    }],
    columnTemplates: [{
      type: ContentChildren,
      args: [TemplateIdDirective]
    }]
  });
})();
class SmartTableModule {
  static {
    this.ɵfac = function SmartTableModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SmartTableModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SmartTableModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [SmartTableComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SmartTableModule, [{
    type: NgModule,
    args: [{
      exports: [SmartTableComponent, SmartTableFilterComponent],
      imports: [SmartTableComponent, SmartTableFilterComponent]
    }]
  }], null, null);
})();
class TabService {
  constructor() {
    this.activeTabPaneIdx = new Subject();
    this.activeTabPaneIdx$ = this.activeTabPaneIdx.asObservable();
  }
  setActiveTabIdx(tabContentState) {
    this.activeTabPaneIdx.next(tabContentState);
  }
  static {
    this.ɵfac = function TabService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TabService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: TabService,
      factory: TabService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class TabPaneComponent {
  #changeDetectorRef;
  #tabService;
  constructor() {
    this.#changeDetectorRef = inject(ChangeDetectorRef);
    this.#tabService = inject(TabService);
    this.#active = false;
    this.role = 'tabpanel';
    this.subscribeTabService();
  }
  #tabServiceSubscription;
  set active(value) {
    const newValue = booleanAttribute(value);
    if (this.#active !== newValue) {
      this.#active = newValue;
      this.#changeDetectorRef.markForCheck();
    }
  }
  get active() {
    return this.#active;
  }
  #active;
  get hostClasses() {
    return {
      'tab-pane': true,
      fade: true,
      show: this.active,
      active: this.active
    };
  }
  ngOnDestroy() {
    this.subscribeTabService(false);
  }
  subscribeTabService(subscribe = true) {
    if (subscribe) {
      this.#tabServiceSubscription = this.#tabService.activeTabPaneIdx$.subscribe(tabContentState => {
        if (tabContentState.tabContent === this.tabContent) {
          this.active = tabContentState.activeIdx === this.tabPaneIdx;
        }
      });
    } else {
      this.#tabServiceSubscription?.unsubscribe();
    }
  }
  static {
    this.ɵfac = function TabPaneComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TabPaneComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TabPaneComponent,
      selectors: [["c-tab-pane"]],
      hostAttrs: [1, "tab-pane"],
      hostVars: 3,
      hostBindings: function TabPaneComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role);
          i0.ɵɵclassMap(ctx.hostClasses);
        }
      },
      inputs: {
        role: "role"
      },
      exportAs: ["cTabPane"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function TabPaneComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabPaneComponent, [{
    type: Component,
    args: [{
      selector: 'c-tab-pane',
      template: '<ng-content />',
      exportAs: 'cTabPane',
      host: {
        class: 'tab-pane'
      },
      styles: [":host{display:block}\n"]
    }]
  }], () => [], {
    hostClasses: [{
      type: HostBinding,
      args: ['class']
    }],
    role: [{
      type: Input
    }, {
      type: HostBinding,
      args: ['attr.role']
    }]
  });
})();
class TabContentComponent {
  constructor() {
    this.#changeDetectorRef = inject(ChangeDetectorRef);
    this.#tabService = inject(TabService);
    this.#activeTabPaneIdx = -1;
    /**
     * Event emitted on the active tab pane index change.
     */
    this.activeTabPaneIdxChange = new EventEmitter();
  }
  #changeDetectorRef;
  #tabService;
  /**
   * Set active tabPane index
   * @type number
   */
  set activeTabPaneIdx(value) {
    const newValue = value;
    if (this.#activeTabPaneIdx != newValue) {
      this.#activeTabPaneIdx = newValue;
      this.activeTabPaneIdxChange.emit(newValue);
      this.#changeDetectorRef.markForCheck();
      this.#changeDetectorRef.detectChanges();
    }
  }
  get activeTabPaneIdx() {
    return this.#activeTabPaneIdx;
  }
  #activeTabPaneIdx;
  #tabServiceSubscription;
  ngAfterContentInit() {
    this.subscribeTabService();
  }
  ngAfterContentChecked() {
    this.panes?.forEach((tabPane, index) => {
      tabPane.tabContent = this;
      tabPane.tabPaneIdx = index;
    });
    this.refreshTabPaneActive(this.activeTabPaneIdx);
    this.#tabService.setActiveTabIdx({
      tabContent: this,
      activeIdx: this.activeTabPaneIdx
    });
  }
  ngOnChanges(changes) {
    if (changes['activeTabPaneIdx']?.currentValue) {
      this.#tabService.setActiveTabIdx({
        tabContent: this,
        activeIdx: changes['activeTabPaneIdx'].currentValue
      });
    }
  }
  ngOnDestroy() {
    this.subscribeTabService(false);
  }
  subscribeTabService(subscribe = true) {
    if (subscribe) {
      this.#tabServiceSubscription = this.#tabService.activeTabPaneIdx$.subscribe(tabContentState => {
        if (this === tabContentState.tabContent) {
          this.activeTabPaneIdx = tabContentState.activeIdx;
        }
      });
    } else {
      this.#tabServiceSubscription?.unsubscribe();
    }
  }
  refreshTabPaneActive(idx) {
    // hack for active state pane refresh todo?
    this.panes?.forEach((tabPane, index) => {
      tabPane.active = idx === index;
    });
  }
  static {
    this.ɵfac = function TabContentComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TabContentComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TabContentComponent,
      selectors: [["c-tab-content"]],
      contentQueries: function TabContentComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, TabPaneComponent, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.panes = _t);
        }
      },
      hostAttrs: [1, "tab-content"],
      inputs: {
        activeTabPaneIdx: [2, "activeTabPaneIdx", "activeTabPaneIdx", numberAttribute]
      },
      outputs: {
        activeTabPaneIdxChange: "activeTabPaneIdxChange"
      },
      exportAs: ["cTabContent"],
      features: [i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function TabContentComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabContentComponent, [{
    type: Component,
    args: [{
      selector: 'c-tab-content',
      template: '<ng-content />',
      changeDetection: ChangeDetectionStrategy.OnPush,
      exportAs: 'cTabContent',
      host: {
        class: 'tab-content'
      },
      styles: [":host{display:block}\n"]
    }]
  }], null, {
    activeTabPaneIdx: [{
      type: Input,
      args: [{
        transform: numberAttribute
      }]
    }],
    activeTabPaneIdxChange: [{
      type: Output
    }],
    panes: [{
      type: ContentChildren,
      args: [TabPaneComponent]
    }]
  });
})();
class TabContentRefDirective {
  #changeDetectorRef;
  #tabService;
  constructor() {
    this.#changeDetectorRef = inject(ChangeDetectorRef);
    this.#tabService = inject(TabService);
    this.#active = false;
    this.#disabled = false;
    /**
     * c-tab-pane index respectively
     * @type number
     */
    this.tabPaneIdx = -1;
    this.role = 'tab';
    this.subscribeTabService();
  }
  #tabServiceSubscription;
  /**
   * Set active state of tab content
   * @type boolean
   * @default false
   */
  set active(value) {
    const newValue = value;
    if (this.#active !== newValue) {
      this.#active = newValue;
      this.#changeDetectorRef.detectChanges();
    }
  }
  get active() {
    return this.#active;
  }
  #active;
  /**
   * Set disabled state of tab content
   * @type boolean
   */
  set disabled(value) {
    this.#disabled = value;
  }
  get disabled() {
    return this.#disabled || this.tabPaneIdx >= this.tabContentRef?.panes?.length;
  }
  #disabled;
  get hostClasses() {
    return {
      active: this.active,
      disabled: this.disabled
    };
  }
  get isDisabled() {
    return this.disabled || null;
  }
  get attrDisabled() {
    return this.disabled ? '' : null;
  }
  get ariaSelected() {
    return this.active;
  }
  get getTabindex() {
    return this.disabled ? '-1' : null;
  }
  ngOnChanges(changes) {
    if (changes['active']?.currentValue) {
      this.setActiveTabPane();
    }
  }
  toggleOpen($event) {
    $event.preventDefault();
    this.setActiveTabPane();
  }
  setActiveTabPane() {
    setTimeout(() => {
      if (this.tabPaneIdx < this.tabContentRef.panes.length) {
        this.active = true;
        this.#tabService.setActiveTabIdx({
          tabContent: this.tabContentRef,
          activeIdx: this.tabPaneIdx
        });
      } else {
        this.active = false;
      }
    });
  }
  ngOnDestroy() {
    this.subscribeTabService(false);
  }
  subscribeTabService(subscribe = true) {
    if (subscribe) {
      this.#tabServiceSubscription = this.#tabService.activeTabPaneIdx$.subscribe(tabContentState => {
        if (tabContentState.tabContent === this.tabContentRef) {
          this.active = tabContentState.activeIdx === this.tabPaneIdx;
        }
      });
    } else {
      this.#tabServiceSubscription?.unsubscribe();
    }
  }
  static {
    this.ɵfac = function TabContentRefDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TabContentRefDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: TabContentRefDirective,
      selectors: [["", "cTabContent", ""]],
      hostVars: 7,
      hostBindings: function TabContentRefDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function TabContentRefDirective_click_HostBindingHandler($event) {
            return ctx.toggleOpen($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("aria-disabled", ctx.isDisabled)("disabled", ctx.attrDisabled)("aria-selected", ctx.ariaSelected)("role", ctx.role)("tabindex", ctx.getTabindex);
          i0.ɵɵclassMap(ctx.hostClasses);
        }
      },
      inputs: {
        tabContentRef: [0, "cTabContent", "tabContentRef"],
        active: [2, "active", "active", booleanAttribute],
        disabled: [2, "disabled", "disabled", booleanAttribute],
        tabPaneIdx: [2, "tabPaneIdx", "tabPaneIdx", numberAttribute],
        role: "role"
      },
      features: [i0.ɵɵNgOnChangesFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabContentRefDirective, [{
    type: Directive,
    args: [{
      selector: '[cTabContent]'
    }]
  }], () => [], {
    tabContentRef: [{
      type: Input,
      args: ['cTabContent']
    }],
    active: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    disabled: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    tabPaneIdx: [{
      type: Input,
      args: [{
        transform: numberAttribute
      }]
    }],
    hostClasses: [{
      type: HostBinding,
      args: ['class']
    }],
    isDisabled: [{
      type: HostBinding,
      args: ['attr.aria-disabled']
    }],
    attrDisabled: [{
      type: HostBinding,
      args: ['attr.disabled']
    }],
    ariaSelected: [{
      type: HostBinding,
      args: ['attr.aria-selected']
    }],
    role: [{
      type: Input
    }, {
      type: HostBinding,
      args: ['attr.role']
    }],
    getTabindex: [{
      type: HostBinding,
      args: ['attr.tabindex']
    }],
    toggleOpen: [{
      type: HostListener,
      args: ['click', ['$event']]
    }]
  });
})();
class TabsModule {
  static {
    this.ɵfac = function TabsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TabsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: TabsModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [TabService]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabsModule, [{
    type: NgModule,
    args: [{
      imports: [TabContentComponent, TabContentRefDirective, TabPaneComponent],
      exports: [TabContentComponent, TabPaneComponent, TabContentRefDirective],
      providers: [TabService]
    }]
  }], null, null);
})();
class TabsService {
  constructor() {
    this.activeItem = signal(undefined);
    this.activeItemKey = signal(undefined);
    this.id = signal(undefined);
  }
  static {
    this.ɵfac = function TabsService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TabsService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: TabsService,
      factory: TabsService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabsService, [{
    type: Injectable
  }], null, null);
})();
let nextId = 0;
class TabsComponent {
  constructor() {
    this.tabsService = inject(TabsService);
    /**
     * The active item key.
     * @type <string | number | undefined>
     */
    this.activeItemKey = model();
    /**
     * The id attribute
     * @type string
     */
    this.tabsId = `tabs-${nextId++}`;
    this.id = input(this.tabsId);
    this.#activeItemEffect = effect(() => {
      this.tabsService.id.set(this.id());
      this.tabsService.activeItemKey.set(this.activeItemKey());
    });
    this.#tabsServiceEffect = effect(() => {
      this.activeItemKey.set(this.tabsService.activeItemKey());
    });
  }
  #activeItemEffect;
  #tabsServiceEffect;
  static {
    this.ɵfac = function TabsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TabsComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TabsComponent,
      selectors: [["c-tabs"]],
      hostAttrs: [1, "tabs"],
      hostVars: 1,
      hostBindings: function TabsComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵhostProperty("id", ctx.id());
        }
      },
      inputs: {
        activeItemKey: [1, "activeItemKey"],
        id: [1, "id"]
      },
      outputs: {
        activeItemKey: "activeItemKeyChange"
      },
      exportAs: ["cTabs"],
      features: [i0.ɵɵProvidersFeature([TabsService])],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function TabsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabsComponent, [{
    type: Component,
    args: [{
      exportAs: 'cTabs',
      selector: 'c-tabs',
      imports: [],
      template: '<ng-content />',
      providers: [TabsService],
      host: {
        '[id]': 'id()',
        class: 'tabs'
      },
      styles: [":host{display:block}\n"]
    }]
  }], null, null);
})();
class TabDirective {
  constructor() {
    this.#injector = inject(Injector);
    this.#destroyRef = inject(DestroyRef);
    this.#elementRef = inject(ElementRef);
    this.#tabsService = inject(TabsService);
    /**
     * Disabled attribute
     * @return boolean
     * @default false
     */
    this.disabledInput = input(false, {
      transform: booleanAttribute,
      alias: 'disabled'
    });
    this.#disabled = signal(false);
    this.attrDisabled = computed(() => this.#disabled() || null);
    this.#disabledEffect = effect(() => {
      const disabled = this.disabledInput();
      untracked(() => {
        this.disabled = disabled;
      });
    });
    /**
     * Item key.
     * @type string | number
     * @required
     */
    this.itemKey = input.required();
    /**
     * Element id attribute
     * @type string
     * @default undefined
     */
    this.id = input();
    /**
     * aria-controls attribute
     * @type string
     * @default undefined
     */
    this.ariaControls = input(undefined, {
      alias: 'aria-controls'
    });
    this.isActive = signal(false);
    this.hostClasses = computed(() => ({
      'nav-link': true,
      active: this.isActive(),
      disabled: this.#disabled()
    }));
    this.propId = computed(() => this.id() ?? `${this.#tabsService.id()}-tab-${this.itemKey()}`);
    this.attrAriaControls = computed(() => this.ariaControls() ?? `${this.#tabsService.id()}-panel-${this.itemKey()}`);
    this.#disabledSignalEffect = effect(() => {
      const disabled = this.#disabled();
      if (!disabled) {
        const click$ = fromEvent(this.#elementRef.nativeElement, 'click');
        const focusIn$ = fromEvent(this.#elementRef.nativeElement, 'focusin');
        merge(focusIn$, click$).pipe(filter($event => !disabled), tap($event => {
          this.#tabsService.activeItemKey.set(untracked(this.itemKey));
        }), takeWhile(() => !disabled), takeUntilDestroyed(this.#destroyRef)).subscribe();
      }
    });
  }
  #injector;
  #destroyRef;
  #elementRef;
  #tabsService;
  #disabled;
  #disabledEffect;
  set disabled(value) {
    this.#disabled.set(value);
  }
  get disabled() {
    return this.#disabled();
  }
  #disabledSignalEffect;
  focus(origin) {
    this.#elementRef.nativeElement.focus();
  }
  ngOnInit() {
    runInInjectionContext(this.#injector, () => {
      effect(() => {
        const isActive = !this.#disabled() && this.#tabsService.activeItemKey() === this.itemKey();
        this.isActive.set(isActive);
      });
    });
  }
  static {
    this.ɵfac = function TabDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TabDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: TabDirective,
      selectors: [["button", "cTab", ""]],
      hostAttrs: ["type", "button", "role", "tab"],
      hostVars: 7,
      hostBindings: function TabDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵhostProperty("id", ctx.propId())("tabindex", ctx.isActive() ? 0 : -1);
          i0.ɵɵattribute("aria-selected", ctx.isActive())("aria-controls", ctx.attrAriaControls())("disabled", ctx.attrDisabled() || null);
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        disabledInput: [1, "disabled", "disabledInput"],
        itemKey: [1, "itemKey"],
        id: [1, "id"],
        ariaControls: [1, "aria-controls", "ariaControls"]
      },
      exportAs: ["cTab"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabDirective, [{
    type: Directive,
    args: [{
      exportAs: 'cTab',
      selector: 'button[cTab]',
      host: {
        '[class]': 'hostClasses()',
        type: 'button',
        role: 'tab',
        '[attr.aria-selected]': 'isActive()',
        '[attr.aria-controls]': 'attrAriaControls()',
        '[attr.disabled]': 'attrDisabled() || null',
        '[id]': 'propId()',
        '[tabindex]': 'isActive() ? 0 : -1'
      }
    }]
  }], null, null);
})();
class TabsListComponent {
  constructor() {
    this.#destroyRef = inject(DestroyRef);
    this.tabsService = inject(TabsService);
    /**
     * Specify a layout type for component.
     * @type 'fill' | 'justified' | undefined
     * @default undefined
     */
    this.layout = input();
    /**
     * Set the variant to tabs, pills or underline.
     * @type 'pills' | 'tabs' | 'underline' | 'underline-border' | undefined
     * @default undefined
     */
    this.variant = input();
    /**
     * Set the role to tab list.
     * @default 'tablist'
     */
    this.role = input('tablist');
    this.hostClasses = computed(() => ({
      nav: true,
      [`nav-${this.layout()}`]: this.layout(),
      [`nav-${this.variant()}`]: this.variant()
    }));
    this.tabs = contentChildren(TabDirective);
    this.#tabsEffect = effect(() => {
      const tabs = this.tabs();
      if (tabs.length === 0) {
        return;
      }
      this.#focusKeyManager = new FocusKeyManager(tabs).skipPredicate(tab => tab.disabled === true).withHorizontalOrientation('ltr').withHomeAndEnd().withWrap();
      this.#focusKeyManager.change.pipe(tap(value => {
        this.tabsService.activeItemKey.set(this.#focusKeyManager.activeItem?.itemKey());
        this.tabsService.activeItem.set(this.#focusKeyManager.activeItem);
      }), takeUntilDestroyed(this.#destroyRef)).subscribe();
      untracked(() => {
        setTimeout(() => {
          const activeItem = tabs.find(tab => tab.isActive()) ?? tabs.find(tab => !tab.disabled);
          const activeItemIndex = tabs.findIndex(tab => tab === activeItem);
          this.#focusKeyManager?.updateActiveItem(activeItemIndex < 0 ? 0 : activeItemIndex);
          this.tabsService.activeItemKey.set(this.#focusKeyManager.activeItem?.itemKey());
          this.tabsService.activeItem.set(this.#focusKeyManager.activeItem);
        });
      });
    });
    this.#tabsServiceEffect = effect(() => {
      const activeItemIndex = this.tabs().findIndex(tab => untracked(tab.isActive) && untracked(tab.itemKey) === this.tabsService.activeItemKey());
      this.#focusKeyManager?.updateActiveItem(activeItemIndex < 0 ? 0 : activeItemIndex);
    });
  }
  #destroyRef;
  #focusKeyManager;
  #tabsEffect;
  #tabsServiceEffect;
  onKeydown($event) {
    if (['ArrowLeft', 'ArrowRight'].includes($event.key)) {
      this.#focusKeyManager.onKeydown($event);
      return;
    }
    if (['Tab'].includes($event.key)) {
      this.#focusKeyManager?.tabOut.next();
    }
    return;
  }
  static {
    this.ɵfac = function TabsListComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TabsListComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TabsListComponent,
      selectors: [["c-tabs-list"]],
      contentQueries: function TabsListComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.tabs, TabDirective, 4);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      hostVars: 3,
      hostBindings: function TabsListComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown", function TabsListComponent_keydown_HostBindingHandler($event) {
            return ctx.onKeydown($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role());
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        layout: [1, "layout"],
        variant: [1, "variant"],
        role: [1, "role"]
      },
      exportAs: ["cTabsList"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function TabsListComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabsListComponent, [{
    type: Component,
    args: [{
      exportAs: 'cTabsList',
      selector: 'c-tabs-list',
      imports: [],
      template: '<ng-content />',
      host: {
        '[attr.role]': 'role()',
        '[class]': 'hostClasses()'
      }
    }]
  }], null, {
    onKeydown: [{
      type: HostListener,
      args: ['keydown', ['$event']]
    }]
  });
})();
class TabsContentComponent {
  static {
    this.ɵfac = function TabsContentComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TabsContentComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TabsContentComponent,
      selectors: [["c-tabs-content"]],
      hostAttrs: [1, "tab-content"],
      exportAs: ["cTabsContent"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function TabsContentComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabsContentComponent, [{
    type: Component,
    args: [{
      exportAs: 'cTabsContent',
      selector: 'c-tabs-content',
      template: '<ng-content />',
      host: {
        class: 'tab-content'
      }
    }]
  }], null, null);
})();
class TabPanelComponent {
  constructor() {
    this.tabsService = inject(TabsService);
    /**
     * aria-labelledby attribute
     * @type string
     * @default undefined
     */
    this.ariaLabelledBy = input(undefined, {
      alias: 'aria-labelledby'
    });
    /**
     * Element id attribute
     * @type string
     * @default undefined
     */
    this.id = input();
    /**
     * Item key.
     * @type string | number
     * @required
     */
    this.itemKey = input.required();
    /**
     * tabindex attribute.
     * @type number
     * @default 0
     */
    this.tabindex = input(0, {
      transform: numberAttribute
    });
    /**
     * Enable fade in transition.
     * @type boolean
     * @default true
     */
    this.transition = input(true);
    /**
     * visible change output
     * @type OutputEmitterRef<VisibleChangeEvent>
     */
    this.visibleChange = output();
    this.show = signal(false);
    this.visible = computed(() => {
      const visible = this.tabsService.activeItemKey() === this.itemKey() && !this.tabsService.activeItem()?.disabled;
      this.visibleChange.emit({
        itemKey: this.itemKey(),
        visible
      });
      return visible;
    });
    this.propId = computed(() => this.id() ?? `${this.tabsService.id()}-panel-${this.itemKey()}`);
    this.attrAriaLabelledBy = computed(() => this.ariaLabelledBy() ?? `${this.tabsService.id()}-tab-${this.itemKey()}`);
    this.hostClasses = computed(() => ({
      'tab-pane': true,
      active: this.show(),
      fade: this.transition(),
      show: this.show(),
      invisible: this.tabsService.activeItem()?.disabled
    }));
  }
  get animationDisabled() {
    return !this.transition();
  }
  get animateType() {
    return this.visible() ? 'show' : 'hide';
  }
  onAnimationDone($event) {
    this.show.set(this.visible());
  }
  static {
    this.ɵfac = function TabPanelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TabPanelComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TabPanelComponent,
      selectors: [["c-tab-panel"]],
      hostAttrs: ["role", "tabpanel"],
      hostVars: 7,
      hostBindings: function TabPanelComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵsyntheticHostListener("@fadeInOut.done", function TabPanelComponent_animation_fadeInOut_done_HostBindingHandler($event) {
            return ctx.onAnimationDone($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵhostProperty("tabindex", ctx.visible() ? ctx.tabindex() : -1)("id", ctx.propId());
          i0.ɵɵsyntheticHostProperty("@.disabled", ctx.animationDisabled)("@fadeInOut", ctx.animateType);
          i0.ɵɵattribute("aria-labelledby", ctx.attrAriaLabelledBy());
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        ariaLabelledBy: [1, "aria-labelledby", "ariaLabelledBy"],
        id: [1, "id"],
        itemKey: [1, "itemKey"],
        tabindex: [1, "tabindex"],
        transition: [1, "transition"]
      },
      outputs: {
        visibleChange: "visibleChange"
      },
      exportAs: ["cTabPanel"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function TabPanelComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      data: {
        animation: [trigger('fadeInOut', [state('show', style({
          opacity: 1
        })), state('hide', style({
          opacity: 0
        })), state('void', style({
          opacity: 1
        })), transition('* => *', [query('@*', [animateChild()], {
          optional: true
        }), animate('150ms linear')])])]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabPanelComponent, [{
    type: Component,
    args: [{
      exportAs: 'cTabPanel',
      selector: 'c-tab-panel',
      template: '<ng-content />',
      host: {
        '[class]': 'hostClasses()',
        '[tabindex]': 'visible() ? tabindex(): -1',
        '[attr.aria-labelledby]': 'attrAriaLabelledBy()',
        '[id]': 'propId()',
        role: 'tabpanel'
      },
      animations: [trigger('fadeInOut', [state('show', style({
        opacity: 1
      })), state('hide', style({
        opacity: 0
      })), state('void', style({
        opacity: 1
      })), transition('* => *', [query('@*', [animateChild()], {
        optional: true
      }), animate('150ms linear')])])]
    }]
  }], null, {
    animationDisabled: [{
      type: HostBinding,
      args: ['@.disabled']
    }],
    animateType: [{
      type: HostBinding,
      args: ['@fadeInOut']
    }],
    onAnimationDone: [{
      type: HostListener,
      args: ['@fadeInOut.done', ['$event']]
    }]
  });
})();
class Tabs2Module {
  static {
    this.ɵfac = function Tabs2Module_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || Tabs2Module)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: Tabs2Module
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [TabsService]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(Tabs2Module, [{
    type: NgModule,
    args: [{
      imports: [TabsComponent, TabsListComponent, TabDirective, TabsContentComponent, TabPanelComponent],
      exports: [TabsComponent, TabsListComponent, TabDirective, TabsContentComponent, TabPanelComponent],
      providers: [TabsService]
    }]
  }], null, null);
})();
class ToasterService {
  constructor() {
    this.#toasterState = new BehaviorSubject({});
    this.toasterState$ = this.#toasterState.asObservable();
  }
  #toasterState;
  setState(state) {
    this.#toasterState.next({
      ...state
    });
  }
  static {
    this.ɵfac = function ToasterService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ToasterService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ToasterService,
      factory: ToasterService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToasterService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class ToastComponent {
  constructor() {
    this.changeDetectorRef = inject(ChangeDetectorRef);
    this.hostElement = inject(ElementRef);
    this.renderer = inject(Renderer2);
    this.toasterService = inject(ToasterService);
    this.dynamic = input();
    this.placementInput = input(undefined, {
      alias: 'placement'
    });
    /**
     * Auto hide the toast.
     * @return boolean
     */
    this.autohide = input(true);
    /**
     * Sets the color context of the component to one of CoreUI’s themed colors.
     * @return Colors
     */
    this.color = input('');
    /**
     * Delay hiding the toast (ms).
     * @return number
     */
    this.delay = input(5000, {
      transform: numberAttribute
    });
    /**
     * Apply fade transition to the toast.
     * @return boolean
     */
    this.fade = input(true);
    /**
     * Toggle the visibility of component.
     * @return boolean
     */
    this.visibleInput = input(false, {
      transform: booleanAttribute,
      alias: 'visible'
    });
    this.#visibleInputEffect = effect(() => {
      this.visible = this.visibleInput();
    });
    this.#visible = false;
    /**
     * @ignore
     */
    this.index = input(0, {
      transform: numberAttribute
    });
    /**
     * Event emitted on visibility change. [docs]
     * @return <boolean>
     */
    this.visibleChange = output();
    /**
     * Event emitted on timer tick. [docs]
     * @return number
     */
    this.timer = output();
    this.animationDisabled = computed(() => {
      return !this.fade();
    });
    this.hostClasses = computed(() => {
      const color = this.color();
      return {
        toast: true,
        show: true,
        [`bg-${color}`]: !!color,
        'border-0': !!color
      };
    });
  }
  get placement() {
    return this.placementInput();
  }
  #visibleInputEffect;
  set visible(value) {
    const newValue = value;
    if (this.#visible !== newValue) {
      this.#visible = newValue;
      newValue ? this.setTimer() : this.clearTimer();
      this.visibleChange.emit(newValue);
      this.changeDetectorRef.markForCheck();
    }
  }
  get visible() {
    return this.#visible;
  }
  #visible;
  get clock() {
    return this._clock;
  }
  set clock(value) {
    this._clock = value;
    this.timer.emit(this._clock);
    this.changeDetectorRef.markForCheck();
  }
  get animateType() {
    return this.visible ? 'show' : 'hide';
  }
  ngOnInit() {
    if (this.visible) {
      this.toasterService.setState({
        toast: this,
        show: this.visible,
        placement: this.placement
      });
      this.clearTimer();
      this.setTimer();
    }
  }
  ngOnDestroy() {
    this.clearTimer();
  }
  setTimer() {
    this.clearTimer();
    if (this.autohide() && this.visible) {
      this.timerId = this.delay() > 0 ? setTimeout(() => this.onClose(), this.delay()) : undefined;
      this.setClock();
    }
  }
  clearTimer() {
    this.clearClock();
    clearTimeout(this.timerId);
    this.timerId = undefined;
  }
  onClose() {
    this.clearTimer();
    this.toasterService.setState({
      toast: this,
      show: false,
      placement: this.placement
    });
  }
  setClock() {
    this.clearClock();
    this.clock = 0;
    this.clockId = setInterval(() => {
      this.clock += 1;
      this.changeDetectorRef.markForCheck();
    }, 1000);
    this.clockTimerId = setTimeout(() => {
      this.clearClock();
    }, this.delay());
  }
  clearClock() {
    clearTimeout(this.clockTimerId);
    clearInterval(this.clockId);
    this.clockId = undefined;
  }
  static {
    this.ɵfac = function ToastComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ToastComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ToastComponent,
      selectors: [["c-toast"]],
      hostAttrs: [1, "toast", "show"],
      hostVars: 4,
      hostBindings: function ToastComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("mouseover", function ToastComponent_mouseover_HostBindingHandler() {
            return ctx.clearTimer();
          })("mouseout", function ToastComponent_mouseout_HostBindingHandler() {
            return ctx.setTimer();
          });
        }
        if (rf & 2) {
          i0.ɵɵsyntheticHostProperty("@fadeInOut", ctx.animateType)("@.disabled", ctx.animationDisabled());
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        dynamic: [1, "dynamic"],
        placementInput: [1, "placement", "placementInput"],
        autohide: [1, "autohide"],
        color: [1, "color"],
        delay: [1, "delay"],
        fade: [1, "fade"],
        visibleInput: [1, "visible", "visibleInput"],
        index: [1, "index"]
      },
      outputs: {
        visibleChange: "visibleChange",
        timer: "timer"
      },
      exportAs: ["cToast"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function ToastComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block;overflow:hidden}"],
      data: {
        animation: [trigger('fadeInOut', [state('show', style({
          opacity: 1,
          height: '*',
          padding: '*',
          border: '*',
          margin: '*'
        })), state('hide', style({
          opacity: 0,
          height: 0,
          padding: 0,
          border: 0,
          margin: 0
        })), state('void', style({
          opacity: 0,
          height: 0,
          padding: 0,
          border: 0,
          margin: 0
        })), transition('show => hide', [animate('{{ time }} {{ easing }}')], {
          params: {
            time: '300ms',
            easing: 'ease-out'
          }
        }), transition('hide => show', [animate('{{ time }} {{ easing }}')], {
          params: {
            time: '300ms',
            easing: 'ease-in'
          }
        }), transition('show => void', [animate('{{ time }} {{ easing }}')], {
          params: {
            time: '300ms',
            easing: 'ease-out'
          }
        }), transition('void => show', [animate('{{ time }} {{ easing }}')], {
          params: {
            time: '300ms',
            easing: 'ease-in'
          }
        })])]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToastComponent, [{
    type: Component,
    args: [{
      selector: 'c-toast',
      template: '<ng-content />',
      exportAs: 'cToast',
      animations: [trigger('fadeInOut', [state('show', style({
        opacity: 1,
        height: '*',
        padding: '*',
        border: '*',
        margin: '*'
      })), state('hide', style({
        opacity: 0,
        height: 0,
        padding: 0,
        border: 0,
        margin: 0
      })), state('void', style({
        opacity: 0,
        height: 0,
        padding: 0,
        border: 0,
        margin: 0
      })), transition('show => hide', [animate('{{ time }} {{ easing }}')], {
        params: {
          time: '300ms',
          easing: 'ease-out'
        }
      }), transition('hide => show', [animate('{{ time }} {{ easing }}')], {
        params: {
          time: '300ms',
          easing: 'ease-in'
        }
      }), transition('show => void', [animate('{{ time }} {{ easing }}')], {
        params: {
          time: '300ms',
          easing: 'ease-out'
        }
      }), transition('void => show', [animate('{{ time }} {{ easing }}')], {
        params: {
          time: '300ms',
          easing: 'ease-in'
        }
      })])],
      host: {
        class: 'toast show',
        '[class]': 'hostClasses()',
        '(mouseover)': 'clearTimer()',
        '(mouseout)': 'setTimer()',
        '[@fadeInOut]': 'animateType',
        '[@.disabled]': 'animationDisabled()'
      },
      styles: [":host{display:block;overflow:hidden}\n"]
    }]
  }], null, null);
})();
class ToastBodyComponent {
  constructor() {
    this.toast = inject(ToastComponent, {
      optional: true
    });
  }
  static {
    this.ɵfac = function ToastBodyComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ToastBodyComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ToastBodyComponent,
      selectors: [["c-toast-body"]],
      hostAttrs: [1, "toast-body"],
      exportAs: ["cToastBody"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function ToastBodyComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToastBodyComponent, [{
    type: Component,
    args: [{
      selector: 'c-toast-body',
      template: '<ng-content />',
      exportAs: 'cToastBody',
      host: {
        class: 'toast-body'
      },
      styles: [":host{display:block}\n"]
    }]
  }], null, null);
})();
class ToastCloseDirective {
  constructor() {
    this.#toasterService = inject(ToasterService);
    this.cToastClose = input();
  }
  #toasterService;
  toggleOpen($event) {
    $event.preventDefault();
    this.#toasterService.setState({
      show: false,
      toast: this.cToastClose()
    });
  }
  static {
    this.ɵfac = function ToastCloseDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ToastCloseDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ToastCloseDirective,
      selectors: [["", "cToastClose", ""]],
      hostBindings: function ToastCloseDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function ToastCloseDirective_click_HostBindingHandler($event) {
            return ctx.toggleOpen($event);
          });
        }
      },
      inputs: {
        cToastClose: [1, "cToastClose"]
      },
      exportAs: ["cToastClose"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToastCloseDirective, [{
    type: Directive,
    args: [{
      selector: '[cToastClose]',
      exportAs: 'cToastClose',
      host: {
        '(click)': 'toggleOpen($event)'
      }
    }]
  }], null, null);
})();
class ToastHeaderComponent {
  constructor() {
    this.#toast = inject(ToastComponent, {
      optional: true
    });
    this.toast = signal(this.#toast ?? undefined);
    /**
     * Add close button to a toast header
     * @return boolean
     */
    this.closeButton = input(true);
  }
  #toast;
  static {
    this.ɵfac = function ToastHeaderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ToastHeaderComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ToastHeaderComponent,
      selectors: [["c-toast-header"]],
      hostAttrs: [1, "toast-header"],
      inputs: {
        closeButton: [1, "closeButton"]
      },
      exportAs: ["cToastHeader"],
      ngContentSelectors: _c0,
      decls: 3,
      vars: 1,
      consts: [["aria-label", "close", "cButtonClose", "", 1, "ms-auto", 3, "cToastClose", "style"], ["aria-label", "close", "cButtonClose", "", 1, "ms-auto", 3, "cToastClose"]],
      template: function ToastHeaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementContainerStart(0);
          i0.ɵɵprojection(1);
          i0.ɵɵtemplate(2, ToastHeaderComponent_Conditional_2_Template, 1, 4, "button", 0);
          i0.ɵɵelementContainerEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.closeButton() ? 2 : -1);
        }
      },
      dependencies: [ToastCloseDirective, ButtonCloseDirective],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToastHeaderComponent, [{
    type: Component,
    args: [{
      selector: 'c-toast-header',
      exportAs: 'cToastHeader',
      imports: [ToastCloseDirective, ButtonCloseDirective],
      host: {
        class: 'toast-header'
      },
      template: "<ng-container>\n  <ng-content />\n  @if (closeButton()) {\n    <button [cToastClose]=\"toast()\" [style]=\"{outline: 0}\" aria-label=\"close\" cButtonClose class=\"ms-auto\"></button>\n  }\n</ng-container>\n"
    }]
  }], null, null);
})();
class ToasterHostDirective {
  constructor() {
    this.viewContainerRef = inject(ViewContainerRef);
  }
  static {
    this.ɵfac = function ToasterHostDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ToasterHostDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ToasterHostDirective,
      selectors: [["", "cToasterHost", ""]],
      exportAs: ["cToasterHost"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToasterHostDirective, [{
    type: Directive,
    args: [{
      selector: '[cToasterHost]',
      exportAs: 'cToasterHost'
    }]
  }], null, null);
})();
var ToasterPlacement;
(function (ToasterPlacement) {
  ToasterPlacement["Static"] = "static";
  ToasterPlacement["TopStart"] = "top-start";
  ToasterPlacement["TopCenter"] = "top-center";
  ToasterPlacement["TopEnd"] = "top-end";
  ToasterPlacement["MiddleStart"] = "middle-start";
  ToasterPlacement["MiddleCenter"] = "middle-center";
  ToasterPlacement["MiddleEnd"] = "middle-end";
  ToasterPlacement["BottomStart"] = "bottom-start";
  ToasterPlacement["BottomCenter"] = "bottom-center";
  ToasterPlacement["BottomEnd"] = "bottom-end";
})(ToasterPlacement || (ToasterPlacement = {}));
class ToasterComponent {
  constructor() {
    this.#hostElement = inject(ElementRef);
    this.#renderer = inject(Renderer2);
    this.#toasterService = inject(ToasterService);
    this.#destroyRef = inject(DestroyRef);
    this.placements = Object.values(ToasterPlacement);
    this.toastsDynamic = [];
    /**
     * Toaster placement
     * @return TToasterPlacement
     */
    this.placementInput = input(ToasterPlacement.TopEnd, {
      alias: 'placement'
    });
    /**
     * Toaster position
     * @return (string | 'absolute' | 'fixed' | 'static')
     */
    this.position = input('absolute');
    this.toasterHost = viewChild.required(ToasterHostDirective);
    this.contentToasts = contentChildren(ToastComponent, {
      read: ViewContainerRef
    });
    this.hostClasses = computed(() => {
      const placement = this.placement;
      const position = this.position();
      return {
        toaster: true,
        'toast-container': true,
        [`position-${position}`]: !!position,
        'top-0': placement.includes('top'),
        'top-50': placement.includes('middle'),
        'bottom-0': placement.includes('bottom'),
        'start-0': placement.includes('start'),
        'start-50': placement.includes('center'),
        'end-0': placement.includes('end'),
        'translate-middle-x': placement.includes('center') && !placement.includes('middle'),
        'translate-middle-y': placement.includes('middle') && !placement.includes('center'),
        'translate-middle': placement.includes('middle') && placement.includes('center')
      };
    });
  }
  #hostElement;
  #renderer;
  #toasterService;
  #destroyRef;
  get placement() {
    return this.placementInput();
  }
  ngOnInit() {
    this.stateToasterSubscribe();
  }
  addToast(toast, props, options) {
    const componentRef = this.toasterHost().viewContainerRef.createComponent(toast, options);
    this.toastsDynamic.push(componentRef);
    const index = this.toastsDynamic.indexOf(componentRef);
    for (const [key, value] of Object.entries(props)) {
      componentRef.setInput(key, value);
    }
    componentRef.setInput('placement', this.placement);
    componentRef.setInput('dynamic', true);
    componentRef.setInput('index', index);
    componentRef.setInput('visible', true);
    componentRef.instance['visibleChange'].emit(true);
    componentRef.changeDetectorRef?.detectChanges();
    return componentRef;
  }
  removeToast(state) {
    this.toastsDynamic?.forEach(item => {
      if (state.toast?.dynamic() && item.instance === state.toast) {
        item.setInput('visible', false);
        item.instance['visibleChange'].emit(false);
        item.destroy();
      }
    });
    this.contentToasts()?.forEach(item => {
      if (state.toast && item.element.nativeElement === state.toast.hostElement.nativeElement) {
        if (!state.toast.dynamic()) {
          state.toast['visible'] = false;
        }
      }
    });
  }
  stateToasterSubscribe() {
    this.#toasterService.toasterState$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(state => {
      if (state.show === false) {
        this.removeToast(state);
      }
      // if (state.show === true && state.toast?.dynamic() === undefined) {
      //   /* empty */
      // }
    });
  }
  static {
    this.ɵfac = function ToasterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ToasterComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ToasterComponent,
      selectors: [["c-toaster"]],
      contentQueries: function ToasterComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.contentToasts, ToastComponent, 4, ViewContainerRef);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      viewQuery: function ToasterComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuerySignal(ctx.toasterHost, ToasterHostDirective, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      hostAttrs: [1, "toaster", "toast-container"],
      hostVars: 2,
      hostBindings: function ToasterComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        placementInput: [1, "placement", "placementInput"],
        position: [1, "position"]
      },
      exportAs: ["cToaster"],
      ngContentSelectors: _c0,
      decls: 2,
      vars: 0,
      consts: [["cToasterHost", ""]],
      template: function ToasterComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, ToasterComponent_ng_template_0_Template, 0, 0, "ng-template", 0);
          i0.ɵɵprojection(1, 0, ["cToasterHost", ""]);
        }
      },
      dependencies: [ToasterHostDirective],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToasterComponent, [{
    type: Component,
    args: [{
      selector: 'c-toaster',
      exportAs: 'cToaster',
      imports: [ToasterHostDirective],
      host: {
        class: 'toaster toast-container',
        '[class]': 'hostClasses()'
      },
      template: "<ng-template cToasterHost />\n<ng-content cToasterHost />\n"
    }]
  }], null, null);
})();
class ToastModule {
  static {
    this.ɵfac = function ToastModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ToastModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ToastModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [ToasterService]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToastModule, [{
    type: NgModule,
    args: [{
      imports: [ToastBodyComponent, ToastComponent, ToastCloseDirective, ToastHeaderComponent, ToasterComponent, ToasterHostDirective],
      providers: [ToasterService],
      exports: [ToastBodyComponent, ToastComponent, ToastCloseDirective, ToastHeaderComponent, ToasterComponent, ToasterHostDirective]
    }]
  }], null, null);
})();
class WidgetStatAComponent extends CardComponent {
  constructor() {
    super(...arguments);
    /**
     * Sets the color context of the component to one of CoreUI’s themed colors.
     * @type Colors
     */
    // override readonly color = input<Colors>();
    /**
     * Title of the widget to display
     * @type string
     */
    this.title = input();
    /**
     * Value for your widget to display
     * @type string
     */
    this.value = input();
    this.templates = {};
    this.contentTemplates = contentChildren(TemplateIdDirective, {
      descendants: true
    });
    this.#contentTemplatesEffect = effect(() => {
      this.contentTemplates().forEach(child => {
        this.templates[child.id] = child.templateRef;
      });
    });
    this.hostClasses = computed(() => {
      const color = this.color();
      return {
        card: true,
        [`bg-${color}`]: !!color,
        'text-white': !!color
      };
    });
  }
  #contentTemplatesEffect;
  get bodyClasses() {
    return {
      'pb-0': true,
      'd-flex': true,
      'justify-content-between': true,
      'align-items-start': true
    };
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵWidgetStatAComponent_BaseFactory;
      return function WidgetStatAComponent_Factory(__ngFactoryType__) {
        return (ɵWidgetStatAComponent_BaseFactory || (ɵWidgetStatAComponent_BaseFactory = i0.ɵɵgetInheritedFactory(WidgetStatAComponent)))(__ngFactoryType__ || WidgetStatAComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WidgetStatAComponent,
      selectors: [["c-widget-stat-a"]],
      contentQueries: function WidgetStatAComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.contentTemplates, TemplateIdDirective, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      hostAttrs: [1, "card"],
      hostVars: 2,
      hostBindings: function WidgetStatAComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        title: [1, "title"],
        value: [1, "value"]
      },
      exportAs: ["cWidgetStatA"],
      features: [i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c63,
      decls: 15,
      vars: 5,
      consts: [["defaultWidgetTitleTemplate", ""], ["defaultWidgetValueTemplate", ""], ["defaultWidgetChartTemplate", ""], ["defaultWidgetActionTemplate", ""], [3, "ngClass"], [1, "fs-4", "fw-semibold"], [4, "ngTemplateOutlet"]],
      template: function WidgetStatAComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c62);
          i0.ɵɵelementContainerStart(0);
          i0.ɵɵelementStart(1, "c-card-body", 4)(2, "div");
          i0.ɵɵtemplate(3, WidgetStatAComponent_Conditional_3_Template, 2, 1, "div", 5)(4, WidgetStatAComponent_Conditional_4_Template, 2, 1, "div");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(5, WidgetStatAComponent_ng_container_5_Template, 1, 0, "ng-container", 6);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(6, WidgetStatAComponent_ng_container_6_Template, 1, 0, "ng-container", 6);
          i0.ɵɵelementContainerEnd();
          i0.ɵɵtemplate(7, WidgetStatAComponent_ng_template_7_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(9, WidgetStatAComponent_ng_template_9_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(11, WidgetStatAComponent_ng_template_11_Template, 1, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(13, WidgetStatAComponent_ng_template_13_Template, 1, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const defaultWidgetChartTemplate_r4 = i0.ɵɵreference(12);
          const defaultWidgetActionTemplate_r5 = i0.ɵɵreference(14);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", ctx.bodyClasses);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(!!ctx.value() || (ctx.templates == null ? null : ctx.templates["widgetValueTemplate"]) ? 3 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(!!ctx.title() || (ctx.templates == null ? null : ctx.templates["widgetTitleTemplate"]) ? 4 : -1);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngTemplateOutlet", (ctx.templates == null ? null : ctx.templates["widgetActionTemplate"]) || defaultWidgetActionTemplate_r5);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngTemplateOutlet", (ctx.templates == null ? null : ctx.templates["widgetChartTemplate"]) || defaultWidgetChartTemplate_r4);
        }
      },
      dependencies: [CardBodyComponent, NgClass, NgTemplateOutlet],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WidgetStatAComponent, [{
    type: Component,
    args: [{
      selector: 'c-widget-stat-a',
      exportAs: 'cWidgetStatA',
      imports: [CardBodyComponent, NgClass, NgTemplateOutlet],
      host: {
        class: 'card',
        '[class]': 'hostClasses()'
      },
      template: "<ng-container>\n  <c-card-body [ngClass]=\"bodyClasses\">\n    <div>\n      @if (!!value() || templates?.['widgetValueTemplate']) {\n        <div class=\"fs-4 fw-semibold\">\n          <ng-container *ngTemplateOutlet=\"templates?.['widgetValueTemplate'] || defaultWidgetValueTemplate\" />\n        </div>\n      }\n      @if (!!title() || templates?.['widgetTitleTemplate']) {\n        <div>\n          <ng-container *ngTemplateOutlet=\"templates?.['widgetTitleTemplate'] || defaultWidgetTitleTemplate\" />\n        </div>\n      }\n    </div>\n    <ng-container *ngTemplateOutlet=\"templates?.['widgetActionTemplate'] || defaultWidgetActionTemplate\" />\n  </c-card-body>\n  <ng-container *ngTemplateOutlet=\"templates?.['widgetChartTemplate'] || defaultWidgetChartTemplate\" />\n</ng-container>\n\n<ng-template #defaultWidgetTitleTemplate>\n  {{ title() }}\n</ng-template>\n\n<ng-template #defaultWidgetValueTemplate>\n  {{ value() }}\n</ng-template>\n\n<ng-template #defaultWidgetChartTemplate>\n  <ng-content select=\".chart-wrapper\" />\n</ng-template>\n\n<ng-template #defaultWidgetActionTemplate>\n  <ng-content />\n</ng-template>\n"
    }]
  }], null, null);
})();
class WidgetStatBComponent extends CardComponent {
  constructor() {
    super();
    /**
     * Sets the color context of the component to one of CoreUI themed colors.
     * @type Colors
     */
    // override readonly color: InputSignal<Colors | undefined> = input();
    /**
     * Sets the text-color context of the component to one of CoreUI themed colors.
     * via TextColorDirective
     * @type TextColors
     */
    // override readonly textColor: InputSignal<TextColors | undefined> = input();
    /**
     * Title of the widget to display
     * @type string
     */
    this.title = input();
    /**
     * Helper text for your widget.
     * @type string
     */
    this.text = input();
    /**
     * Value for your widget to display
     * @type string
     */
    this.value = input();
    /**
     * Invert colors from their default dark shade.
     * @type boolean
     */
    this.inverse = input(false, {
      transform: booleanAttribute
    });
    this.hostClasses = computed(() => {
      const color = this.color();
      const textColor = this.textColor();
      return {
        card: true,
        [`bg-${color}`]: !!color,
        [`text-${textColor}`]: !!textColor,
        'text-white': this.inverse()
      };
    });
  }
  static {
    this.ɵfac = function WidgetStatBComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WidgetStatBComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WidgetStatBComponent,
      selectors: [["c-widget-stat-b"]],
      hostAttrs: [1, "card"],
      hostVars: 2,
      hostBindings: function WidgetStatBComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        title: [1, "title"],
        text: [1, "text"],
        value: [1, "value"],
        inverse: [1, "inverse"]
      },
      exportAs: ["cWidgetStatB"],
      features: [i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 5,
      vars: 3,
      consts: [[1, "fs-4", "fw-semibold"], [3, "ngClass"]],
      template: function WidgetStatBComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "c-card-body");
          i0.ɵɵtemplate(1, WidgetStatBComponent_Conditional_1_Template, 2, 1, "div", 0)(2, WidgetStatBComponent_Conditional_2_Template, 2, 1, "div");
          i0.ɵɵprojection(3);
          i0.ɵɵtemplate(4, WidgetStatBComponent_Conditional_4_Template, 2, 2, "small", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵconditional(!!ctx.value() ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(!!ctx.title() ? 2 : -1);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.text() ? 4 : -1);
        }
      },
      dependencies: [CardBodyComponent, NgClass],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WidgetStatBComponent, [{
    type: Component,
    args: [{
      selector: 'c-widget-stat-b',
      exportAs: 'cWidgetStatB',
      imports: [CardBodyComponent, NgClass],
      host: {
        class: 'card',
        '[class]': 'hostClasses()'
      },
      template: "<c-card-body>\n  @if (!!value()) {\n    <div class=\"fs-4 fw-semibold\">{{ value() }}</div>\n  }\n  @if (!!title()) {\n    <div>{{ title() }}</div>\n  }\n  <ng-content />\n  @if (text()) {\n    <small [ngClass]=\"inverse() ? 'text-white text-opacity-75' : 'text-body-secondary'\">\n      {{ text() }}\n    </small>\n  }\n</c-card-body>\n"
    }]
  }], () => [], null);
})();
class WidgetStatCComponent extends CardComponent {
  constructor() {
    super();
    /**
     * Icon for your component.
     * @type string
     */
    this.icon = input();
    /**
     * Title of the widget to display
     * @type string
     */
    this.title = input();
    /**
     * Value for your widget to display
     * @type string|number
     */
    this.value = input();
    /**
     * Invert colors from their default dark shade.
     * @type boolean
     */
    this.inverse = input(false, {
      transform: booleanAttribute
    });
    this.templates = {};
    this.contentTemplates = contentChildren(TemplateIdDirective, {
      descendants: true
    });
    this.#contentTemplatesEffect = effect(() => {
      this.contentTemplates().forEach(child => {
        this.templates[child.id] = child.templateRef;
      });
    });
    this.hostExtendedClass = computed(() => {
      return {
        ...this.hostClasses(),
        'text-white': this.inverse()
      };
    });
    this.titleClasses = computed(() => {
      const inverse = this.inverse();
      return {
        'text-body-secondary': !inverse,
        'text-white': inverse,
        'text-opacity-75': inverse,
        [`text-${this.textColor()}`]: !!this.textColor()
      };
    });
    this.valueClasses = computed(() => {
      return {
        'fs-4': !this.textColor(),
        'fw-semibold': true,
        ...this.titleClasses(),
        'text-opacity-75': false
      };
    });
    this.iconClasses = computed(() => {
      return {
        'mb-4': !this.textColor(),
        'text-end': true,
        ...this.titleClasses()
      };
    });
  }
  #contentTemplatesEffect;
  static {
    this.ɵfac = function WidgetStatCComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WidgetStatCComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WidgetStatCComponent,
      selectors: [["c-widget-stat-c"]],
      contentQueries: function WidgetStatCComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.contentTemplates, TemplateIdDirective, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      hostVars: 2,
      hostBindings: function WidgetStatCComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostExtendedClass());
        }
      },
      inputs: {
        icon: [1, "icon"],
        title: [1, "title"],
        value: [1, "value"],
        inverse: [1, "inverse"]
      },
      exportAs: ["cWidgetStatC"],
      features: [i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 9,
      vars: 4,
      consts: [["defaultWidgetIconTemplate", ""], ["defaultWidgetProgressTemplate", ""], [3, "ngClass"], [4, "ngTemplateOutlet"]],
      template: function WidgetStatCComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "c-card-body");
          i0.ɵɵtemplate(1, WidgetStatCComponent_Conditional_1_Template, 2, 2, "div", 2)(2, WidgetStatCComponent_Conditional_2_Template, 2, 2, "div", 2)(3, WidgetStatCComponent_Conditional_3_Template, 2, 2, "div", 2)(4, WidgetStatCComponent_Conditional_4_Template, 1, 1, "ng-container");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(5, WidgetStatCComponent_ng_template_5_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(7, WidgetStatCComponent_ng_template_7_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.icon() || (ctx.templates == null ? null : ctx.templates["widgetIconTemplate"]) ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(!!ctx.value() ? 2 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(!!ctx.title() ? 3 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional((ctx.templates == null ? null : ctx.templates["widgetProgressTemplate"]) ? 4 : -1);
        }
      },
      dependencies: [CardBodyComponent, NgClass, NgTemplateOutlet],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WidgetStatCComponent, [{
    type: Component,
    args: [{
      selector: 'c-widget-stat-c',
      exportAs: 'cWidgetStatC',
      imports: [CardBodyComponent, NgClass, NgTemplateOutlet],
      host: {
        '[class]': 'hostExtendedClass()'
      },
      template: "<c-card-body>\n  @if (icon() || templates?.['widgetIconTemplate']) {\n    <div [ngClass]=\"iconClasses()\">\n      <ng-container *ngTemplateOutlet=\"templates?.['widgetIconTemplate'] || defaultWidgetIconTemplate\" />\n    </div>\n  }\n  @if (!!value()) {\n    <div [ngClass]=\"valueClasses()\">\n      {{ value() }}\n    </div>\n  }\n  @if (!!title()) {\n    <div [ngClass]=\"titleClasses()\">\n      {{ title() }}\n    </div>\n  }\n  @if (templates?.['widgetProgressTemplate']) {\n    <ng-container *ngTemplateOutlet=\"templates?.['widgetProgressTemplate'] || defaultWidgetProgressTemplate\" />\n  }\n</c-card-body>\n\n<ng-template #defaultWidgetIconTemplate>\n  {{ icon() }}\n</ng-template>\n\n<ng-template #defaultWidgetProgressTemplate>\n  <ng-content />\n</ng-template>\n"
    }]
  }], () => [], null);
})();
class WidgetStatDComponent extends CardComponent {
  constructor() {
    super(...arguments);
    /**
     * Sets the color context of the component to one of CoreUI’s themed colors.
     * @type Colors
     */
    // override readonly color = input<Colors>();
    /**
     * Values and subtitles for your component.
     * @type WidgetStatDValue
     */
    this.values = input();
    this.headerClasses = computed(() => {
      return {
        'position-relative': true,
        'd-flex': true,
        'justify-content-center': true,
        'align-items-center': true,
        [`bg-${this.color()}`]: this.color()
      };
    });
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵWidgetStatDComponent_BaseFactory;
      return function WidgetStatDComponent_Factory(__ngFactoryType__) {
        return (ɵWidgetStatDComponent_BaseFactory || (ɵWidgetStatDComponent_BaseFactory = i0.ɵɵgetInheritedFactory(WidgetStatDComponent)))(__ngFactoryType__ || WidgetStatDComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WidgetStatDComponent,
      selectors: [["c-widget-stat-d"]],
      hostAttrs: [1, "card"],
      inputs: {
        values: [1, "values"]
      },
      exportAs: ["cWidgetStatD"],
      features: [i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 5,
      vars: 1,
      consts: [[3, "ngClass"], ["cRow", "", 1, "text-center"], [1, "vr"], [1, "fs-5", "fw-semibold"], [1, "text-uppercase", "text-body-secondary", "small"]],
      template: function WidgetStatDComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "c-card-header", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(2, "c-card-body", 1);
          i0.ɵɵrepeaterCreate(3, WidgetStatDComponent_For_4_Template, 6, 3, null, null, i0.ɵɵrepeaterTrackByIdentity);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", ctx.headerClasses());
          i0.ɵɵadvance(3);
          i0.ɵɵrepeater(ctx.values());
        }
      },
      dependencies: [CardHeaderComponent, CardBodyComponent, ColComponent, RowDirective, NgClass],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WidgetStatDComponent, [{
    type: Component,
    args: [{
      selector: 'c-widget-stat-d',
      exportAs: 'cWidgetStatD',
      imports: [CardHeaderComponent, CardBodyComponent, ColComponent, RowDirective, NgClass],
      host: {
        class: 'card'
      },
      template: "<c-card-header [ngClass]=\"headerClasses()\">\n  <ng-content />\n</c-card-header>\n<c-card-body cRow class=\"text-center\">\n  @for (item of values(); track item; let i = $index) {\n    @if (i % 2 !== 0) {\n      <div class=\"vr\"></div>\n    }\n    <c-col>\n      <div class=\"fs-5 fw-semibold\">{{ item.value }}</div>\n      <div class=\"text-uppercase text-body-secondary small\">{{ item.title }}</div>\n    </c-col>\n  }\n</c-card-body>\n"
    }]
  }], null, null);
})();
class WidgetStatEComponent extends CardComponent {
  constructor() {
    super();
    /**
     * Title of the widget to display
     * @type string
     */
    this.title = input();
    /**
     * Value for your widget to display
     * @type string | number
     */
    this.value = input();
    this.titleClasses = computed(() => {
      const textColor = this.textColor();
      return {
        'text-body-secondary': !textColor,
        small: true,
        'text-uppercase': true,
        'fw-semibold': true,
        [`text-${textColor}`]: !!textColor
      };
    });
  }
  static {
    this.ɵfac = function WidgetStatEComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WidgetStatEComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WidgetStatEComponent,
      selectors: [["c-widget-stat-e"]],
      inputs: {
        title: [1, "title"],
        value: [1, "value"]
      },
      exportAs: ["cWidgetStatE"],
      features: [i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 4,
      vars: 2,
      consts: [[1, "text-center"], [3, "ngClass"], [1, "fs-6", "fw-semibold", "py-3"]],
      template: function WidgetStatEComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "c-card-body", 0);
          i0.ɵɵtemplate(1, WidgetStatEComponent_Conditional_1_Template, 2, 2, "div", 1)(2, WidgetStatEComponent_Conditional_2_Template, 2, 1, "div", 2);
          i0.ɵɵprojection(3);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵconditional(!!ctx.title() ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(!!ctx.value() ? 2 : -1);
        }
      },
      dependencies: [CardBodyComponent, NgClass],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WidgetStatEComponent, [{
    type: Component,
    args: [{
      selector: 'c-widget-stat-e',
      exportAs: 'cWidgetStatE',
      imports: [CardBodyComponent, NgClass],
      template: "<c-card-body class=\"text-center\">\n  @if (!!title()) {\n    <div [ngClass]=\"titleClasses()\">{{ title() }}</div>\n  }\n  @if (!!value()) {\n    <div class=\"fs-6 fw-semibold py-3\">{{ value() }}</div>\n  }\n  <ng-content />\n</c-card-body>\n"
    }]
  }], () => [], null);
})();
class WidgetStatFComponent extends CardComponent {
  constructor() {
    super(...arguments);
    /**
     * Sets the color context of the component to one of CoreUI’s themed colors.
     * @type Colors
     */
    // override readonly color = input<Colors>();
    /**
     * Sets the text-color context of the component to one of CoreUI’s themed colors.
     * @type Colors
     */
    // override readonly textColor = input<TextColors | 'white' | 'muted'>();
    /**
     * Footer for your widget
     * @type string
     */
    this.footer = input();
    /**
     * Icon for your widget
     * @type string
     */
    this.icon = input();
    /**
     * Set padding of your component.
     * @type boolean
     */
    this.padding = input(false, {
      transform: booleanAttribute
    });
    /**
     * Title of the widget to display
     * @type string
     */
    this.title = input();
    /**
     * Value for your widget to display
     * @type string
     */
    this.value = input();
    this.templates = {};
    this.contentTemplates = contentChildren(TemplateIdDirective, {
      descendants: true
    });
    this.#contentTemplatesEffect = effect(() => {
      this.contentTemplates().forEach(child => {
        this.templates[child.id] = child.templateRef;
      });
    });
    this.cardBodyClasses = computed(() => {
      return {
        'd-flex': true,
        'align-items-center': true,
        'p-0': !this.padding()
      };
    });
    this.iconClasses = computed(() => {
      const color = this.color();
      const padding = this.padding();
      return {
        'me-3': !this.textColor(),
        'text-white': true,
        [`bg-${color}`]: !!color,
        'p-3': padding,
        'p-4': !padding,
        'rounded-start-1': !padding
      };
    });
    this.titleClasses = computed(() => {
      const textColor = this.textColor();
      return {
        'text-body-secondary': !textColor,
        small: true,
        'text-uppercase': true,
        'fw-semibold': true,
        [`text-${textColor}`]: !!textColor
      };
    });
    this.valueClasses = computed(() => {
      const textColor = this.textColor();
      return {
        'fs-6': !textColor,
        'fw-semibold': true,
        [`text-${textColor}`]: !!textColor
      };
    });
  }
  #contentTemplatesEffect;
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵWidgetStatFComponent_BaseFactory;
      return function WidgetStatFComponent_Factory(__ngFactoryType__) {
        return (ɵWidgetStatFComponent_BaseFactory || (ɵWidgetStatFComponent_BaseFactory = i0.ɵɵgetInheritedFactory(WidgetStatFComponent)))(__ngFactoryType__ || WidgetStatFComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WidgetStatFComponent,
      selectors: [["c-widget-stat-f"]],
      contentQueries: function WidgetStatFComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.contentTemplates, TemplateIdDirective, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      hostAttrs: [1, "card"],
      hostVars: 2,
      hostBindings: function WidgetStatFComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses());
        }
      },
      inputs: {
        footer: [1, "footer"],
        icon: [1, "icon"],
        padding: [1, "padding"],
        title: [1, "title"],
        value: [1, "value"]
      },
      exportAs: ["cWidgetStatB"],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 14,
      vars: 8,
      consts: [["defaultWidgetIconTemplate", ""], ["defaultFooterIconTemplate", ""], [3, "ngClass"], [4, "ngTemplateOutlet"]],
      template: function WidgetStatFComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementContainerStart(0);
          i0.ɵɵelementStart(1, "c-card-body", 2)(2, "div", 2);
          i0.ɵɵtemplate(3, WidgetStatFComponent_ng_container_3_Template, 1, 0, "ng-container", 3);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "div")(5, "div", 2);
          i0.ɵɵtext(6);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(7, "div", 2);
          i0.ɵɵtext(8);
          i0.ɵɵelementEnd()()();
          i0.ɵɵtemplate(9, WidgetStatFComponent_Conditional_9_Template, 2, 1, "c-card-footer");
          i0.ɵɵelementContainerEnd();
          i0.ɵɵtemplate(10, WidgetStatFComponent_ng_template_10_Template, 2, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(12, WidgetStatFComponent_ng_template_12_Template, 2, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const defaultWidgetIconTemplate_r3 = i0.ɵɵreference(11);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", ctx.cardBodyClasses());
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", ctx.iconClasses());
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngTemplateOutlet", (ctx.templates == null ? null : ctx.templates["widgetIconTemplate"]) || defaultWidgetIconTemplate_r3);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngClass", ctx.valueClasses());
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate(ctx.value());
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", ctx.titleClasses());
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate(ctx.title());
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.footer() || (ctx.templates == null ? null : ctx.templates["widgetFooterTemplate"]) ? 9 : -1);
        }
      },
      dependencies: [CardBodyComponent, CardFooterComponent, NgClass, NgTemplateOutlet],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WidgetStatFComponent, [{
    type: Component,
    args: [{
      selector: 'c-widget-stat-f',
      exportAs: 'cWidgetStatB',
      imports: [CardBodyComponent, CardFooterComponent, NgClass, NgTemplateOutlet],
      host: {
        class: 'card',
        '[class]': 'hostClasses()'
      },
      template: "<ng-container>\n  <c-card-body [ngClass]=\"cardBodyClasses()\">\n    <div [ngClass]=\"iconClasses()\">\n      <ng-container *ngTemplateOutlet=\"templates?.['widgetIconTemplate'] || defaultWidgetIconTemplate\" />\n    </div>\n    <div>\n      <div [ngClass]=\"valueClasses()\">{{ value() }}</div>\n      <div [ngClass]=\"titleClasses()\">{{ title() }}</div>\n    </div>\n  </c-card-body>\n  @if (footer() || templates?.['widgetFooterTemplate']) {\n    <c-card-footer>\n      <ng-container *ngTemplateOutlet=\"templates?.['widgetFooterTemplate'] || defaultFooterIconTemplate\" />\n    </c-card-footer>\n  }\n</ng-container>\n\n<ng-template #defaultWidgetIconTemplate>\n  <span>{{ icon() }}</span>\n</ng-template>\n\n<ng-template #defaultFooterIconTemplate>\n  <span>{{ footer() }}</span>\n</ng-template>\n"
    }]
  }], null, null);
})();
class WidgetModule {
  static {
    this.ɵfac = function WidgetModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WidgetModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WidgetModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WidgetModule, [{
    type: NgModule,
    args: [{
      imports: [WidgetStatAComponent, WidgetStatBComponent, WidgetStatCComponent, WidgetStatDComponent, WidgetStatEComponent, WidgetStatFComponent],
      exports: [WidgetStatAComponent, WidgetStatBComponent, WidgetStatCComponent, WidgetStatDComponent, WidgetStatEComponent, WidgetStatFComponent]
    }]
  }], null, null);
})();

/*
 * Public API Surface of coreui-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccordionButtonDirective, AccordionComponent, AccordionItemComponent, AccordionModule, AlertComponent, AlertHeadingDirective, AlertLinkDirective, AlertModule, AlignDirective, AvatarComponent, AvatarModule, BackdropService, BadgeComponent, BadgeModule, BgColorDirective, BorderDirective, BreadcrumbComponent, BreadcrumbItemComponent, BreadcrumbModule, BreadcrumbRouterComponent, BreadcrumbRouterService, BreakpointInfix, ButtonCloseDirective, ButtonDirective, ButtonGroupComponent, ButtonGroupModule, ButtonModule, ButtonToolbarComponent, CalendarComponent, CalendarModule, CalendarMonthComponent, CalendarNavigationComponent, CalloutComponent, CalloutModule, CardBodyComponent, CardComponent, CardFooterComponent, CardGroupComponent, CardHeaderActionsComponent, CardHeaderComponent, CardImgDirective, CardImgOverlayComponent, CardLinkDirective, CardModule, CardSubtitleDirective, CardTextDirective, CardTitleDirective, CarouselCaptionComponent, CarouselComponent, CarouselConfig, CarouselControlComponent, CarouselIndicatorsComponent, CarouselInnerComponent, CarouselItemComponent, CarouselModule, ClassToggleService, ColComponent, ColDirective, CollapseDirective, CollapseModule, ColorModeService, ContainerComponent, DatePickerComponent, DatePickerModule, DateRangePickerComponent, DateRangePickerModule, DropdownCloseDirective, DropdownComponent, DropdownDividerDirective, DropdownHeaderDirective, DropdownItemDirective, DropdownItemPlainDirective, DropdownMenuDirective, DropdownModule, DropdownService, DropdownToggleDirective, ElementCoverComponent, ElementCoverModule, ElementRefDirective, FooterComponent, FooterModule, FormCheckComponent, FormCheckInputDirective, FormCheckLabelDirective, FormControlDirective, FormDirective, FormFeedbackComponent, FormFloatingDirective, FormLabelDirective, FormModule, FormSelectDirective, FormTextDirective, GridModule, GutterDirective, HeaderBrandComponent, HeaderComponent, HeaderDividerComponent, HeaderModule, HeaderNavComponent, HeaderTextComponent, HeaderTogglerDirective, HtmlAttributesDirective, ImgDirective, ImgModule, InMemoryStorageService, InputGroupComponent, InputGroupTextDirective, IntersectionService, ListGroupDirective, ListGroupItemDirective, ListGroupModule, ListenersService, LoadingButtonComponent, LoadingButtonModule, LocalStorageService, ModalBodyComponent, ModalComponent, ModalContentComponent, ModalDialogComponent, ModalFooterComponent, ModalHeaderComponent, ModalModule, ModalService, ModalTitleDirective, ModalToggleDirective, MultiSelectComponent, MultiSelectModule, MultiSelectOptgroupComponent, MultiSelectOptgroupLabelComponent, MultiSelectOptionComponent, NavComponent, NavItemComponent, NavLinkDirective, NavModule, NavbarBrandDirective, NavbarComponent, NavbarModule, NavbarNavComponent, NavbarTextComponent, NavbarTogglerDirective, OffcanvasBodyComponent, OffcanvasComponent, OffcanvasHeaderComponent, OffcanvasModule, OffcanvasService, OffcanvasTitleDirective, OffcanvasToggleDirective, PageItemComponent, PageItemDirective, PageLinkDirective, PaginationComponent, PaginationModule, PlaceholderAnimationDirective, PlaceholderDirective, PlaceholderModule, PopoverComponent, PopoverDirective, PopoverModule, ProgressBarComponent, ProgressBarDirective, ProgressComponent, ProgressModule, ProgressStackedComponent, RangeSliderComponent, RangeSliderModule, RatingComponent, RatingModule, RoundedDirective, RowComponent, RowDirective, RtlService, ShadowOnScrollDirective, SharedModule, SidebarBrandComponent, SidebarComponent, SidebarFooterComponent, SidebarHeaderComponent, SidebarModule, SidebarNavComponent, SidebarNavHelper, SidebarService, SidebarToggleDirective, SidebarTogglerDirective, SmartPaginationComponent, SmartPaginationModule, SmartTableComponent, SmartTableFilterComponent, SmartTableModule, SpinnerComponent, SpinnerModule, TabContentComponent, TabContentRefDirective, TabDirective, TabPaneComponent, TabPanelComponent, TabService, TableActiveDirective, TableColorDirective, TableDirective, TableModule, Tabs2Module, TabsComponent, TabsContentComponent, TabsListComponent, TabsModule, TabsService, TemplateIdDirective, TextBgColorDirective, TextColorDirective, ThemeDirective, TimePickerComponent, TimePickerModule, ToastBodyComponent, ToastCloseDirective, ToastComponent, ToastHeaderComponent, ToastModule, ToasterComponent, ToasterHostDirective, ToasterPlacement, ToasterService, TooltipComponent, TooltipDirective, TooltipModule, UIDService, UtilitiesModule, WidgetModule, WidgetStatAComponent, WidgetStatBComponent, WidgetStatCComponent, WidgetStatDComponent, WidgetStatEComponent, WidgetStatFComponent };
